
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e1e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e1e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gIfym", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ga9lV"));

});
parcelRegister("ga9lV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $bc44d5c582efa5c9$export$dca3b0875bd9a954; }, function (v) { return $bc44d5c582efa5c9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bc44d5c582efa5c9$export$16fa2f45be04daa8; }, function (v) { return $bc44d5c582efa5c9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bc44d5c582efa5c9$export$ffb0004e005737fa; }, function (v) { return $bc44d5c582efa5c9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc44d5c582efa5c9$export$e2c29f18771995cb; }, function (v) { return $bc44d5c582efa5c9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd; }, function (v) { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc44d5c582efa5c9$export$5f8d39834fd61797; }, function (v) { return $bc44d5c582efa5c9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5; }, function (v) { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bc44d5c582efa5c9$export$ae55be85d98224ed; }, function (v) { return $bc44d5c582efa5c9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bc44d5c582efa5c9$export$e530037191fcd5d7; }, function (v) { return $bc44d5c582efa5c9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109; }, function (v) { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d; }, function (v) { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9; }, function (v) { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43; }, function (v) { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bc44d5c582efa5c9$export$257a8862b851cb5b; }, function (v) { return $bc44d5c582efa5c9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bc44d5c582efa5c9$export$a8257692ac88316c; }, function (v) { return $bc44d5c582efa5c9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bc44d5c582efa5c9$export$488013bae63b21da; }, function (v) { return $bc44d5c582efa5c9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bc44d5c582efa5c9$export$7c73462e0d25e514; }, function (v) { return $bc44d5c582efa5c9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bc44d5c582efa5c9$export$35808ee640e87ca7; }, function (v) { return $bc44d5c582efa5c9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bc44d5c582efa5c9$export$fae74005e78b1a27; }, function (v) { return $bc44d5c582efa5c9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e; }, function (v) { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $bc44d5c582efa5c9$export$6d9c69b0de29b591; }, function (v) { return $bc44d5c582efa5c9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bc44d5c582efa5c9$export$d5a552a76deda3c2; }, function (v) { return $bc44d5c582efa5c9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c; }, function (v) { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bc44d5c582efa5c9$export$1538c33de8887b59; }, function (v) { return $bc44d5c582efa5c9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $bc44d5c582efa5c9$export$13e3392192263954; }, function (v) { return $bc44d5c582efa5c9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca; }, function (v) { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bc44d5c582efa5c9$export$60241385465d0a34; }, function (v) { return $bc44d5c582efa5c9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $bc44d5c582efa5c9$export$83d89fbfd8236492; }, function (v) { return $bc44d5c582efa5c9$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc44d5c582efa5c9$export$dca3b0875bd9a954;
var $bc44d5c582efa5c9$export$16fa2f45be04daa8;
var $bc44d5c582efa5c9$export$ffb0004e005737fa;
var $bc44d5c582efa5c9$export$e2c29f18771995cb;
var $bc44d5c582efa5c9$export$221d75b3f55bb0bd;
var $bc44d5c582efa5c9$export$5f8d39834fd61797;
var $bc44d5c582efa5c9$export$74bf444e3cd11ea5;
var $bc44d5c582efa5c9$export$ae55be85d98224ed;
var $bc44d5c582efa5c9$export$e530037191fcd5d7;
var $bc44d5c582efa5c9$export$fd42f52fd3ae1109;
var $bc44d5c582efa5c9$export$c8a8987d4410bf2d;
var $bc44d5c582efa5c9$export$d38cd72104c1f0e9;
var $bc44d5c582efa5c9$export$7d1e3a5e95ceca43;
var $bc44d5c582efa5c9$export$257a8862b851cb5b;
var $bc44d5c582efa5c9$export$a8257692ac88316c;
var $bc44d5c582efa5c9$export$488013bae63b21da;
var $bc44d5c582efa5c9$export$7c73462e0d25e514;
var $bc44d5c582efa5c9$export$35808ee640e87ca7;
var $bc44d5c582efa5c9$export$fae74005e78b1a27;
var $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e;
var $bc44d5c582efa5c9$export$6d9c69b0de29b591;
var $bc44d5c582efa5c9$export$d5a552a76deda3c2;
var $bc44d5c582efa5c9$export$e5c5a5f917a5871c;
var $bc44d5c582efa5c9$export$1538c33de8887b59;
var $bc44d5c582efa5c9$export$13e3392192263954;
var $bc44d5c582efa5c9$export$b8f5890fc79d6aca;
var $bc44d5c582efa5c9$export$60241385465d0a34;
var $bc44d5c582efa5c9$export$83d89fbfd8236492;
"use strict";

var $2WFPq = parcelRequire("2WFPq");
var $bc44d5c582efa5c9$var$n = "function" === typeof Symbol && Symbol.for, $bc44d5c582efa5c9$var$p = $bc44d5c582efa5c9$var$n ? Symbol.for("react.element") : 60103, $bc44d5c582efa5c9$var$q = $bc44d5c582efa5c9$var$n ? Symbol.for("react.portal") : 60106, $bc44d5c582efa5c9$var$r = $bc44d5c582efa5c9$var$n ? Symbol.for("react.fragment") : 60107, $bc44d5c582efa5c9$var$t = $bc44d5c582efa5c9$var$n ? Symbol.for("react.strict_mode") : 60108, $bc44d5c582efa5c9$var$u = $bc44d5c582efa5c9$var$n ? Symbol.for("react.profiler") : 60114, $bc44d5c582efa5c9$var$v = $bc44d5c582efa5c9$var$n ? Symbol.for("react.provider") : 60109, $bc44d5c582efa5c9$var$w = $bc44d5c582efa5c9$var$n ? Symbol.for("react.context") : 60110, $bc44d5c582efa5c9$var$x = $bc44d5c582efa5c9$var$n ? Symbol.for("react.forward_ref") : 60112, $bc44d5c582efa5c9$var$y = $bc44d5c582efa5c9$var$n ? Symbol.for("react.suspense") : 60113, $bc44d5c582efa5c9$var$z = $bc44d5c582efa5c9$var$n ? Symbol.for("react.memo") : 60115, $bc44d5c582efa5c9$var$A = $bc44d5c582efa5c9$var$n ? Symbol.for("react.lazy") : 60116, $bc44d5c582efa5c9$var$B = "function" === typeof Symbol && Symbol.iterator;
function $bc44d5c582efa5c9$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bc44d5c582efa5c9$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bc44d5c582efa5c9$var$E = {};
function $bc44d5c582efa5c9$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$E;
    this.updater = c || $bc44d5c582efa5c9$var$D;
}
$bc44d5c582efa5c9$var$F.prototype.isReactComponent = {};
$bc44d5c582efa5c9$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($bc44d5c582efa5c9$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bc44d5c582efa5c9$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bc44d5c582efa5c9$var$G() {}
$bc44d5c582efa5c9$var$G.prototype = $bc44d5c582efa5c9$var$F.prototype;
function $bc44d5c582efa5c9$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$E;
    this.updater = c || $bc44d5c582efa5c9$var$D;
}
var $bc44d5c582efa5c9$var$I = $bc44d5c582efa5c9$var$H.prototype = new $bc44d5c582efa5c9$var$G;
$bc44d5c582efa5c9$var$I.constructor = $bc44d5c582efa5c9$var$H;
$2WFPq($bc44d5c582efa5c9$var$I, $bc44d5c582efa5c9$var$F.prototype);
$bc44d5c582efa5c9$var$I.isPureReactComponent = !0;
var $bc44d5c582efa5c9$var$J = {
    current: null
}, $bc44d5c582efa5c9$var$K = Object.prototype.hasOwnProperty, $bc44d5c582efa5c9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bc44d5c582efa5c9$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$bc44d5c582efa5c9$var$K.call(b, e) && !$bc44d5c582efa5c9$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $bc44d5c582efa5c9$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $bc44d5c582efa5c9$var$J.current
    };
}
function $bc44d5c582efa5c9$var$N(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bc44d5c582efa5c9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bc44d5c582efa5c9$var$p;
}
function $bc44d5c582efa5c9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bc44d5c582efa5c9$var$P = /\/+/g, $bc44d5c582efa5c9$var$Q = [];
function $bc44d5c582efa5c9$var$R(a, b, c, e) {
    if ($bc44d5c582efa5c9$var$Q.length) {
        var d = $bc44d5c582efa5c9$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $bc44d5c582efa5c9$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $bc44d5c582efa5c9$var$Q.length && $bc44d5c582efa5c9$var$Q.push(a);
}
function $bc44d5c582efa5c9$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bc44d5c582efa5c9$var$p:
                case $bc44d5c582efa5c9$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $bc44d5c582efa5c9$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $bc44d5c582efa5c9$var$U(d, k);
        g += $bc44d5c582efa5c9$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $bc44d5c582efa5c9$var$B && a[$bc44d5c582efa5c9$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $bc44d5c582efa5c9$var$U(d, k++), g += $bc44d5c582efa5c9$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($bc44d5c582efa5c9$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $bc44d5c582efa5c9$var$V(a, b, c) {
    return null == a ? 0 : $bc44d5c582efa5c9$var$T(a, "", b, c);
}
function $bc44d5c582efa5c9$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bc44d5c582efa5c9$var$escape(a.key) : b.toString(36);
}
function $bc44d5c582efa5c9$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $bc44d5c582efa5c9$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $bc44d5c582efa5c9$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($bc44d5c582efa5c9$var$O(a) && (a = $bc44d5c582efa5c9$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($bc44d5c582efa5c9$var$P, "$&/") + "/") + c)), e.push(a));
}
function $bc44d5c582efa5c9$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($bc44d5c582efa5c9$var$P, "$&/") + "/");
    b = $bc44d5c582efa5c9$var$R(b, g, e, d);
    $bc44d5c582efa5c9$var$V(a, $bc44d5c582efa5c9$var$aa, b);
    $bc44d5c582efa5c9$var$S(b);
}
var $bc44d5c582efa5c9$var$Y = {
    current: null
};
function $bc44d5c582efa5c9$var$Z() {
    var a = $bc44d5c582efa5c9$var$Y.current;
    if (null === a) throw Error($bc44d5c582efa5c9$var$C(321));
    return a;
}
var $bc44d5c582efa5c9$var$ba = {
    ReactCurrentDispatcher: $bc44d5c582efa5c9$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $bc44d5c582efa5c9$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $2WFPq
};
$bc44d5c582efa5c9$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $bc44d5c582efa5c9$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $bc44d5c582efa5c9$var$R(null, null, b, c);
        $bc44d5c582efa5c9$var$V(a, $bc44d5c582efa5c9$var$W, b);
        $bc44d5c582efa5c9$var$S(b);
    },
    count: function(a) {
        return $bc44d5c582efa5c9$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $bc44d5c582efa5c9$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$bc44d5c582efa5c9$var$O(a)) throw Error($bc44d5c582efa5c9$var$C(143));
        return a;
    }
};
$bc44d5c582efa5c9$export$16fa2f45be04daa8 = $bc44d5c582efa5c9$var$F;
$bc44d5c582efa5c9$export$ffb0004e005737fa = $bc44d5c582efa5c9$var$r;
$bc44d5c582efa5c9$export$e2c29f18771995cb = $bc44d5c582efa5c9$var$u;
$bc44d5c582efa5c9$export$221d75b3f55bb0bd = $bc44d5c582efa5c9$var$H;
$bc44d5c582efa5c9$export$5f8d39834fd61797 = $bc44d5c582efa5c9$var$t;
$bc44d5c582efa5c9$export$74bf444e3cd11ea5 = $bc44d5c582efa5c9$var$y;
$bc44d5c582efa5c9$export$ae55be85d98224ed = $bc44d5c582efa5c9$var$ba;
$bc44d5c582efa5c9$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($bc44d5c582efa5c9$var$C(267, a));
    var e = $2WFPq({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $bc44d5c582efa5c9$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$bc44d5c582efa5c9$var$K.call(b, h) && !$bc44d5c582efa5c9$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $bc44d5c582efa5c9$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$bc44d5c582efa5c9$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $bc44d5c582efa5c9$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $bc44d5c582efa5c9$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$bc44d5c582efa5c9$export$c8a8987d4410bf2d = $bc44d5c582efa5c9$var$M;
$bc44d5c582efa5c9$export$d38cd72104c1f0e9 = function(a) {
    var b = $bc44d5c582efa5c9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bc44d5c582efa5c9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$x,
        render: a
    };
};
$bc44d5c582efa5c9$export$a8257692ac88316c = $bc44d5c582efa5c9$var$O;
$bc44d5c582efa5c9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$bc44d5c582efa5c9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bc44d5c582efa5c9$export$35808ee640e87ca7 = function(a, b) {
    return $bc44d5c582efa5c9$var$Z().useCallback(a, b);
};
$bc44d5c582efa5c9$export$fae74005e78b1a27 = function(a, b) {
    return $bc44d5c582efa5c9$var$Z().useContext(a, b);
};
$bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = function() {};
$bc44d5c582efa5c9$export$6d9c69b0de29b591 = function(a, b) {
    return $bc44d5c582efa5c9$var$Z().useEffect(a, b);
};
$bc44d5c582efa5c9$export$d5a552a76deda3c2 = function(a, b, c) {
    return $bc44d5c582efa5c9$var$Z().useImperativeHandle(a, b, c);
};
$bc44d5c582efa5c9$export$e5c5a5f917a5871c = function(a, b) {
    return $bc44d5c582efa5c9$var$Z().useLayoutEffect(a, b);
};
$bc44d5c582efa5c9$export$1538c33de8887b59 = function(a, b) {
    return $bc44d5c582efa5c9$var$Z().useMemo(a, b);
};
$bc44d5c582efa5c9$export$13e3392192263954 = function(a, b, c) {
    return $bc44d5c582efa5c9$var$Z().useReducer(a, b, c);
};
$bc44d5c582efa5c9$export$b8f5890fc79d6aca = function(a) {
    return $bc44d5c582efa5c9$var$Z().useRef(a);
};
$bc44d5c582efa5c9$export$60241385465d0a34 = function(a) {
    return $bc44d5c582efa5c9$var$Z().useState(a);
};
$bc44d5c582efa5c9$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("2WFPq", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $225171d2ce221288$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $225171d2ce221288$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $225171d2ce221288$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $225171d2ce221288$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $225171d2ce221288$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $225171d2ce221288$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $225171d2ce221288$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($225171d2ce221288$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($225171d2ce221288$var$getOwnPropertySymbols) {
            symbols = $225171d2ce221288$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($225171d2ce221288$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("eN6q3", function(module, exports) {
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $gIfym = parcelRequire("gIfym");

var $2WFPq = parcelRequire("2WFPq");

var $Qw0kg = parcelRequire("Qw0kg");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$gIfym) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $2WFPq({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $gIfym.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $2WFPq({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $2WFPq({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $Qw0kg.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $Qw0kg.unstable_scheduleCallback($Qw0kg.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $Qw0kg.unstable_UserBlockingPriority, ed = $Qw0kg.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $2WFPq({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$2WFPq(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $2WFPq(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $2WFPq({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $2WFPq({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $Qw0kg.unstable_runWithPriority, Jf = $Qw0kg.unstable_scheduleCallback, Kf = $Qw0kg.unstable_cancelCallback, Lf = $Qw0kg.unstable_requestPaint, Mf = $Qw0kg.unstable_now, Nf = $Qw0kg.unstable_getCurrentPriorityLevel, Of = $Qw0kg.unstable_ImmediatePriority, Pf = $Qw0kg.unstable_UserBlockingPriority, Qf = $Qw0kg.unstable_NormalPriority, Rf = $Qw0kg.unstable_LowPriority, Sf = $Qw0kg.unstable_IdlePriority, Tf = {}, Uf = $Qw0kg.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $2WFPq({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $2WFPq({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $gIfym.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2WFPq({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $2WFPq({}, f, {
                    value: void 0
                });
                d = $2WFPq({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $2WFPq({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($2WFPq({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.13.1",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.13.1";

});
parcelRegister("Qw0kg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("29Llp"));

});
parcelRegister("29Llp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $192125a6b5623347$export$c4744153514ff05d; }, function (v) { return $192125a6b5623347$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $192125a6b5623347$export$d66a1c1c77bd778b; }, function (v) { return $192125a6b5623347$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $192125a6b5623347$export$3e506c1ccc9cc1a7; }, function (v) { return $192125a6b5623347$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $192125a6b5623347$export$e26fe2ed2fa76875; }, function (v) { return $192125a6b5623347$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $192125a6b5623347$export$502329bbf4b505b1; }, function (v) { return $192125a6b5623347$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $192125a6b5623347$export$6e3807111c4874c4; }, function (v) { return $192125a6b5623347$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $192125a6b5623347$export$c27134553091fb3a; }, function (v) { return $192125a6b5623347$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $192125a6b5623347$export$33ee1acdc04fd2a2; }, function (v) { return $192125a6b5623347$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $192125a6b5623347$export$b00a404bbd5edef2; }, function (v) { return $192125a6b5623347$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $192125a6b5623347$export$8352ce38b91d0c62; }, function (v) { return $192125a6b5623347$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $192125a6b5623347$export$d3dfb8e4810cb555; }, function (v) { return $192125a6b5623347$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $192125a6b5623347$export$839f9183b0465a69; }, function (v) { return $192125a6b5623347$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $192125a6b5623347$export$72fdf0e06517287b; }, function (v) { return $192125a6b5623347$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $192125a6b5623347$export$4b844e58a3e414b4; }, function (v) { return $192125a6b5623347$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $192125a6b5623347$export$816d2913ae6b83b1; }, function (v) { return $192125a6b5623347$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $192125a6b5623347$export$61bcfe829111a1d0; }, function (v) { return $192125a6b5623347$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $192125a6b5623347$export$7ee8c9beb337bc3f; }, function (v) { return $192125a6b5623347$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $192125a6b5623347$export$b5836b71941fa3ed; }, function (v) { return $192125a6b5623347$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $192125a6b5623347$export$cf845f2c119da08a; }, function (v) { return $192125a6b5623347$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $192125a6b5623347$export$c4744153514ff05d;
var $192125a6b5623347$export$d66a1c1c77bd778b;
var $192125a6b5623347$export$3e506c1ccc9cc1a7;
var $192125a6b5623347$export$e26fe2ed2fa76875;
var $192125a6b5623347$export$502329bbf4b505b1;
var $192125a6b5623347$export$6e3807111c4874c4;
var $192125a6b5623347$export$c27134553091fb3a;
var $192125a6b5623347$export$33ee1acdc04fd2a2;
var $192125a6b5623347$export$b00a404bbd5edef2;
var $192125a6b5623347$export$8352ce38b91d0c62;
var $192125a6b5623347$export$d3dfb8e4810cb555;
var $192125a6b5623347$export$839f9183b0465a69;
var $192125a6b5623347$export$72fdf0e06517287b;
var $192125a6b5623347$export$4b844e58a3e414b4;
var $192125a6b5623347$export$816d2913ae6b83b1;
var $192125a6b5623347$export$61bcfe829111a1d0;
var $192125a6b5623347$export$7ee8c9beb337bc3f;
var $192125a6b5623347$export$b5836b71941fa3ed;
var $192125a6b5623347$export$cf845f2c119da08a;
"use strict";
var $192125a6b5623347$var$f, $192125a6b5623347$var$g, $192125a6b5623347$var$h, $192125a6b5623347$var$k, $192125a6b5623347$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $192125a6b5623347$var$p = null, $192125a6b5623347$var$q = null, $192125a6b5623347$var$t = function() {
        if (null !== $192125a6b5623347$var$p) try {
            var a = $192125a6b5623347$export$c4744153514ff05d();
            $192125a6b5623347$var$p(!0, a);
            $192125a6b5623347$var$p = null;
        } catch (b) {
            throw setTimeout($192125a6b5623347$var$t, 0), b;
        }
    }, $192125a6b5623347$var$u = Date.now();
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return Date.now() - $192125a6b5623347$var$u;
    };
    $192125a6b5623347$var$f = function(a) {
        null !== $192125a6b5623347$var$p ? setTimeout($192125a6b5623347$var$f, 0, a) : ($192125a6b5623347$var$p = a, setTimeout($192125a6b5623347$var$t, 0));
    };
    $192125a6b5623347$var$g = function(a, b) {
        $192125a6b5623347$var$q = setTimeout(a, b);
    };
    $192125a6b5623347$var$h = function() {
        clearTimeout($192125a6b5623347$var$q);
    };
    $192125a6b5623347$var$k = function() {
        return !1;
    };
    $192125a6b5623347$var$l = $192125a6b5623347$export$d66a1c1c77bd778b = function() {};
} else {
    var $192125a6b5623347$var$w = window.performance, $192125a6b5623347$var$x = window.Date, $192125a6b5623347$var$y = window.setTimeout, $192125a6b5623347$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $192125a6b5623347$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $192125a6b5623347$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $192125a6b5623347$var$w && "function" === typeof $192125a6b5623347$var$w.now) $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$w.now();
    };
    else {
        var $192125a6b5623347$var$B = $192125a6b5623347$var$x.now();
        $192125a6b5623347$export$c4744153514ff05d = function() {
            return $192125a6b5623347$var$x.now() - $192125a6b5623347$var$B;
        };
    }
    var $192125a6b5623347$var$C = !1, $192125a6b5623347$var$D = null, $192125a6b5623347$var$E = -1, $192125a6b5623347$var$F = 5, $192125a6b5623347$var$G = 0;
    $192125a6b5623347$var$k = function() {
        return $192125a6b5623347$export$c4744153514ff05d() >= $192125a6b5623347$var$G;
    };
    $192125a6b5623347$var$l = function() {};
    $192125a6b5623347$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $192125a6b5623347$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $192125a6b5623347$var$H = new MessageChannel, $192125a6b5623347$var$I = $192125a6b5623347$var$H.port2;
    $192125a6b5623347$var$H.port1.onmessage = function() {
        if (null !== $192125a6b5623347$var$D) {
            var a = $192125a6b5623347$export$c4744153514ff05d();
            $192125a6b5623347$var$G = a + $192125a6b5623347$var$F;
            try {
                $192125a6b5623347$var$D(!0, a) ? $192125a6b5623347$var$I.postMessage(null) : ($192125a6b5623347$var$C = !1, $192125a6b5623347$var$D = null);
            } catch (b) {
                throw $192125a6b5623347$var$I.postMessage(null), b;
            }
        } else $192125a6b5623347$var$C = !1;
    };
    $192125a6b5623347$var$f = function(a) {
        $192125a6b5623347$var$D = a;
        $192125a6b5623347$var$C || ($192125a6b5623347$var$C = !0, $192125a6b5623347$var$I.postMessage(null));
    };
    $192125a6b5623347$var$g = function(a, b) {
        $192125a6b5623347$var$E = $192125a6b5623347$var$y(function() {
            a($192125a6b5623347$export$c4744153514ff05d());
        }, b);
    };
    $192125a6b5623347$var$h = function() {
        $192125a6b5623347$var$z($192125a6b5623347$var$E);
        $192125a6b5623347$var$E = -1;
    };
}
function $192125a6b5623347$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $192125a6b5623347$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $192125a6b5623347$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $192125a6b5623347$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $192125a6b5623347$var$K(n, c)) void 0 !== r && 0 > $192125a6b5623347$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $192125a6b5623347$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $192125a6b5623347$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $192125a6b5623347$var$N = [], $192125a6b5623347$var$O = [], $192125a6b5623347$var$P = 1, $192125a6b5623347$var$Q = null, $192125a6b5623347$var$R = 3, $192125a6b5623347$var$S = !1, $192125a6b5623347$var$T = !1, $192125a6b5623347$var$U = !1;
function $192125a6b5623347$var$V(a) {
    for(var b = $192125a6b5623347$var$L($192125a6b5623347$var$O); null !== b;){
        if (null === b.callback) $192125a6b5623347$var$M($192125a6b5623347$var$O);
        else if (b.startTime <= a) $192125a6b5623347$var$M($192125a6b5623347$var$O), b.sortIndex = b.expirationTime, $192125a6b5623347$var$J($192125a6b5623347$var$N, b);
        else break;
        b = $192125a6b5623347$var$L($192125a6b5623347$var$O);
    }
}
function $192125a6b5623347$var$W(a) {
    $192125a6b5623347$var$U = !1;
    $192125a6b5623347$var$V(a);
    if (!$192125a6b5623347$var$T) {
        if (null !== $192125a6b5623347$var$L($192125a6b5623347$var$N)) $192125a6b5623347$var$T = !0, $192125a6b5623347$var$f($192125a6b5623347$var$X);
        else {
            var b = $192125a6b5623347$var$L($192125a6b5623347$var$O);
            null !== b && $192125a6b5623347$var$g($192125a6b5623347$var$W, b.startTime - a);
        }
    }
}
function $192125a6b5623347$var$X(a, b) {
    $192125a6b5623347$var$T = !1;
    $192125a6b5623347$var$U && ($192125a6b5623347$var$U = !1, $192125a6b5623347$var$h());
    $192125a6b5623347$var$S = !0;
    var c = $192125a6b5623347$var$R;
    try {
        $192125a6b5623347$var$V(b);
        for($192125a6b5623347$var$Q = $192125a6b5623347$var$L($192125a6b5623347$var$N); null !== $192125a6b5623347$var$Q && (!($192125a6b5623347$var$Q.expirationTime > b) || a && !$192125a6b5623347$var$k());){
            var d = $192125a6b5623347$var$Q.callback;
            if (null !== d) {
                $192125a6b5623347$var$Q.callback = null;
                $192125a6b5623347$var$R = $192125a6b5623347$var$Q.priorityLevel;
                var e = d($192125a6b5623347$var$Q.expirationTime <= b);
                b = $192125a6b5623347$export$c4744153514ff05d();
                "function" === typeof e ? $192125a6b5623347$var$Q.callback = e : $192125a6b5623347$var$Q === $192125a6b5623347$var$L($192125a6b5623347$var$N) && $192125a6b5623347$var$M($192125a6b5623347$var$N);
                $192125a6b5623347$var$V(b);
            } else $192125a6b5623347$var$M($192125a6b5623347$var$N);
            $192125a6b5623347$var$Q = $192125a6b5623347$var$L($192125a6b5623347$var$N);
        }
        if (null !== $192125a6b5623347$var$Q) var m = !0;
        else {
            var n = $192125a6b5623347$var$L($192125a6b5623347$var$O);
            null !== n && $192125a6b5623347$var$g($192125a6b5623347$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $192125a6b5623347$var$Q = null, $192125a6b5623347$var$R = c, $192125a6b5623347$var$S = !1;
    }
}
function $192125a6b5623347$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $192125a6b5623347$var$Z = $192125a6b5623347$var$l;
$192125a6b5623347$export$3e506c1ccc9cc1a7 = 5;
$192125a6b5623347$export$e26fe2ed2fa76875 = 1;
$192125a6b5623347$export$502329bbf4b505b1 = 4;
$192125a6b5623347$export$6e3807111c4874c4 = 3;
$192125a6b5623347$export$c27134553091fb3a = null;
$192125a6b5623347$export$33ee1acdc04fd2a2 = 2;
$192125a6b5623347$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$192125a6b5623347$export$8352ce38b91d0c62 = function() {
    $192125a6b5623347$var$T || $192125a6b5623347$var$S || ($192125a6b5623347$var$T = !0, $192125a6b5623347$var$f($192125a6b5623347$var$X));
};
$192125a6b5623347$export$d3dfb8e4810cb555 = function() {
    return $192125a6b5623347$var$R;
};
$192125a6b5623347$export$839f9183b0465a69 = function() {
    return $192125a6b5623347$var$L($192125a6b5623347$var$N);
};
$192125a6b5623347$export$72fdf0e06517287b = function(a) {
    switch($192125a6b5623347$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $192125a6b5623347$var$R;
    }
    var c = $192125a6b5623347$var$R;
    $192125a6b5623347$var$R = b;
    try {
        return a();
    } finally{
        $192125a6b5623347$var$R = c;
    }
};
$192125a6b5623347$export$4b844e58a3e414b4 = function() {};
$192125a6b5623347$export$816d2913ae6b83b1 = $192125a6b5623347$var$Z;
$192125a6b5623347$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $192125a6b5623347$var$R;
    $192125a6b5623347$var$R = a;
    try {
        return b();
    } finally{
        $192125a6b5623347$var$R = c;
    }
};
$192125a6b5623347$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $192125a6b5623347$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $192125a6b5623347$var$Y(a);
    } else c = $192125a6b5623347$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $192125a6b5623347$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $192125a6b5623347$var$J($192125a6b5623347$var$O, a), null === $192125a6b5623347$var$L($192125a6b5623347$var$N) && a === $192125a6b5623347$var$L($192125a6b5623347$var$O) && ($192125a6b5623347$var$U ? $192125a6b5623347$var$h() : $192125a6b5623347$var$U = !0, $192125a6b5623347$var$g($192125a6b5623347$var$W, e - d))) : (a.sortIndex = c, $192125a6b5623347$var$J($192125a6b5623347$var$N, a), $192125a6b5623347$var$T || $192125a6b5623347$var$S || ($192125a6b5623347$var$T = !0, $192125a6b5623347$var$f($192125a6b5623347$var$X)));
    return a;
};
$192125a6b5623347$export$b5836b71941fa3ed = function() {
    var a = $192125a6b5623347$export$c4744153514ff05d();
    $192125a6b5623347$var$V(a);
    var b = $192125a6b5623347$var$L($192125a6b5623347$var$N);
    return b !== $192125a6b5623347$var$Q && null !== $192125a6b5623347$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $192125a6b5623347$var$Q.expirationTime || $192125a6b5623347$var$k();
};
$192125a6b5623347$export$cf845f2c119da08a = function(a) {
    var b = $192125a6b5623347$var$R;
    return function() {
        var c = $192125a6b5623347$var$R;
        $192125a6b5623347$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $192125a6b5623347$var$R = c;
        }
    };
};

});



parcelRegister("jw5As", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $4lXeK = parcelRequire("4lXeK");

var $17tgv = parcelRequire("17tgv");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $4lXeK.isBrowserBundle)() && Object.prototype.toString.call(typeof $17tgv !== "undefined" ? $17tgv : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("4lXeK", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $32b712c6eab5491d$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $32b712c6eab5491d$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $32b712c6eab5491d$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $32b712c6eab5491d$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}

});

parcelRegister("17tgv", function(module, exports) {
// shim for using process in browser
var $0d0d255e14f785b6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0d0d255e14f785b6$var$cachedSetTimeout;
var $0d0d255e14f785b6$var$cachedClearTimeout;
function $0d0d255e14f785b6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $0d0d255e14f785b6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        else $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        else $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    }
})();
function $0d0d255e14f785b6$var$runTimeout(fun) {
    if ($0d0d255e14f785b6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedSetTimeout === $0d0d255e14f785b6$var$defaultSetTimout || !$0d0d255e14f785b6$var$cachedSetTimeout) && setTimeout) {
        $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0d0d255e14f785b6$var$runClearTimeout(marker) {
    if ($0d0d255e14f785b6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedClearTimeout === $0d0d255e14f785b6$var$defaultClearTimeout || !$0d0d255e14f785b6$var$cachedClearTimeout) && clearTimeout) {
        $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0d0d255e14f785b6$var$queue = [];
var $0d0d255e14f785b6$var$draining = false;
var $0d0d255e14f785b6$var$currentQueue;
var $0d0d255e14f785b6$var$queueIndex = -1;
function $0d0d255e14f785b6$var$cleanUpNextTick() {
    if (!$0d0d255e14f785b6$var$draining || !$0d0d255e14f785b6$var$currentQueue) return;
    $0d0d255e14f785b6$var$draining = false;
    if ($0d0d255e14f785b6$var$currentQueue.length) $0d0d255e14f785b6$var$queue = $0d0d255e14f785b6$var$currentQueue.concat($0d0d255e14f785b6$var$queue);
    else $0d0d255e14f785b6$var$queueIndex = -1;
    if ($0d0d255e14f785b6$var$queue.length) $0d0d255e14f785b6$var$drainQueue();
}
function $0d0d255e14f785b6$var$drainQueue() {
    if ($0d0d255e14f785b6$var$draining) return;
    var timeout = $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$cleanUpNextTick);
    $0d0d255e14f785b6$var$draining = true;
    var len = $0d0d255e14f785b6$var$queue.length;
    while(len){
        $0d0d255e14f785b6$var$currentQueue = $0d0d255e14f785b6$var$queue;
        $0d0d255e14f785b6$var$queue = [];
        while(++$0d0d255e14f785b6$var$queueIndex < len)if ($0d0d255e14f785b6$var$currentQueue) $0d0d255e14f785b6$var$currentQueue[$0d0d255e14f785b6$var$queueIndex].run();
        $0d0d255e14f785b6$var$queueIndex = -1;
        len = $0d0d255e14f785b6$var$queue.length;
    }
    $0d0d255e14f785b6$var$currentQueue = null;
    $0d0d255e14f785b6$var$draining = false;
    $0d0d255e14f785b6$var$runClearTimeout(timeout);
}
$0d0d255e14f785b6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0d0d255e14f785b6$var$queue.push(new $0d0d255e14f785b6$var$Item(fun, args));
    if ($0d0d255e14f785b6$var$queue.length === 1 && !$0d0d255e14f785b6$var$draining) $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$drainQueue);
};
// v8 likes predictible objects
function $0d0d255e14f785b6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0d0d255e14f785b6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0d0d255e14f785b6$var$process.title = "browser";
$0d0d255e14f785b6$var$process.browser = true;
$0d0d255e14f785b6$var$process.env = {};
$0d0d255e14f785b6$var$process.argv = [];
$0d0d255e14f785b6$var$process.version = ""; // empty string to avoid regexp issues
$0d0d255e14f785b6$var$process.versions = {};
function $0d0d255e14f785b6$var$noop() {}
$0d0d255e14f785b6$var$process.on = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.addListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.once = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.off = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeAllListeners = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.emit = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependOnceListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.listeners = function(name) {
    return [];
};
$0d0d255e14f785b6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$0d0d255e14f785b6$var$process.cwd = function() {
    return "/";
};
$0d0d255e14f785b6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$0d0d255e14f785b6$var$process.umask = function() {
    return 0;
};

});


parcelRegister("kh2Rv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $4H3Nt = parcelRequire("4H3Nt");
function $ec279d803f66d50f$var$emptyFunction() {}
function $ec279d803f66d50f$var$emptyFunctionWithReset() {}
$ec279d803f66d50f$var$emptyFunctionWithReset.resetWarningCache = $ec279d803f66d50f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $4H3Nt) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ec279d803f66d50f$var$emptyFunctionWithReset,
        resetWarningCache: $ec279d803f66d50f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("4H3Nt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $36ae1f94766f6c68$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $36ae1f94766f6c68$var$ReactPropTypesSecret;

});


parcelRegister("95oGi", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $69d7b9e0f9338877$export$2b8d127b894957b9; }, function (v) { return $69d7b9e0f9338877$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $69d7b9e0f9338877$export$cea3a54a6425200c; }, function (v) { return $69d7b9e0f9338877$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $69d7b9e0f9338877$export$a7c73072b1a182ae; }, function (v) { return $69d7b9e0f9338877$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $69d7b9e0f9338877$export$9f27bc3417b4524d; }, function (v) { return $69d7b9e0f9338877$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $69d7b9e0f9338877$export$db77ccec0bb4ccac; }, function (v) { return $69d7b9e0f9338877$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $69d7b9e0f9338877$export$8392c0c9d3dcbd35; }, function (v) { return $69d7b9e0f9338877$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $69d7b9e0f9338877$export$ffb0004e005737fa; }, function (v) { return $69d7b9e0f9338877$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $69d7b9e0f9338877$export$b624eff549462981; }, function (v) { return $69d7b9e0f9338877$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $69d7b9e0f9338877$export$7897aa7841a5380c; }, function (v) { return $69d7b9e0f9338877$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $69d7b9e0f9338877$export$602eac185826482c; }, function (v) { return $69d7b9e0f9338877$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $69d7b9e0f9338877$export$e2c29f18771995cb; }, function (v) { return $69d7b9e0f9338877$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $69d7b9e0f9338877$export$5f8d39834fd61797; }, function (v) { return $69d7b9e0f9338877$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $69d7b9e0f9338877$export$74bf444e3cd11ea5; }, function (v) { return $69d7b9e0f9338877$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $69d7b9e0f9338877$export$92387174baf9b227; }, function (v) { return $69d7b9e0f9338877$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $69d7b9e0f9338877$export$ec112efeb987d9c6; }, function (v) { return $69d7b9e0f9338877$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $69d7b9e0f9338877$export$b706b080d889d2c9; }, function (v) { return $69d7b9e0f9338877$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $69d7b9e0f9338877$export$5be5a87408f70ddc; }, function (v) { return $69d7b9e0f9338877$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $69d7b9e0f9338877$export$45a5e7f76e0caa8d; }, function (v) { return $69d7b9e0f9338877$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $69d7b9e0f9338877$export$455c2e768291efa6; }, function (v) { return $69d7b9e0f9338877$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $69d7b9e0f9338877$export$9522e17588c12572; }, function (v) { return $69d7b9e0f9338877$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $69d7b9e0f9338877$export$2110ac352bb060b9; }, function (v) { return $69d7b9e0f9338877$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $69d7b9e0f9338877$export$56885ab8b9c456ab; }, function (v) { return $69d7b9e0f9338877$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $69d7b9e0f9338877$export$d927fcb6adf8f9de; }, function (v) { return $69d7b9e0f9338877$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $69d7b9e0f9338877$export$b82d16f27459e05a; }, function (v) { return $69d7b9e0f9338877$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $69d7b9e0f9338877$export$522c17b4f5e123e8; }, function (v) { return $69d7b9e0f9338877$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $69d7b9e0f9338877$export$1aabd8a0274ecfd6; }, function (v) { return $69d7b9e0f9338877$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $69d7b9e0f9338877$export$9b621391a187a31a; }, function (v) { return $69d7b9e0f9338877$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $69d7b9e0f9338877$export$f5bbd400c2f4426f; }, function (v) { return $69d7b9e0f9338877$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $69d7b9e0f9338877$export$2b8d127b894957b9;
var $69d7b9e0f9338877$export$cea3a54a6425200c;
var $69d7b9e0f9338877$export$a7c73072b1a182ae;
var $69d7b9e0f9338877$export$9f27bc3417b4524d;
var $69d7b9e0f9338877$export$db77ccec0bb4ccac;
var $69d7b9e0f9338877$export$8392c0c9d3dcbd35;
var $69d7b9e0f9338877$export$ffb0004e005737fa;
var $69d7b9e0f9338877$export$b624eff549462981;
var $69d7b9e0f9338877$export$7897aa7841a5380c;
var $69d7b9e0f9338877$export$602eac185826482c;
var $69d7b9e0f9338877$export$e2c29f18771995cb;
var $69d7b9e0f9338877$export$5f8d39834fd61797;
var $69d7b9e0f9338877$export$74bf444e3cd11ea5;
var $69d7b9e0f9338877$export$92387174baf9b227;
var $69d7b9e0f9338877$export$ec112efeb987d9c6;
var $69d7b9e0f9338877$export$b706b080d889d2c9;
var $69d7b9e0f9338877$export$5be5a87408f70ddc;
var $69d7b9e0f9338877$export$45a5e7f76e0caa8d;
var $69d7b9e0f9338877$export$455c2e768291efa6;
var $69d7b9e0f9338877$export$9522e17588c12572;
var $69d7b9e0f9338877$export$2110ac352bb060b9;
var $69d7b9e0f9338877$export$56885ab8b9c456ab;
var $69d7b9e0f9338877$export$d927fcb6adf8f9de;
var $69d7b9e0f9338877$export$b82d16f27459e05a;
var $69d7b9e0f9338877$export$522c17b4f5e123e8;
var $69d7b9e0f9338877$export$1aabd8a0274ecfd6;
var $69d7b9e0f9338877$export$9b621391a187a31a;
var $69d7b9e0f9338877$export$f5bbd400c2f4426f;
"use strict";
var $69d7b9e0f9338877$var$b = "function" === typeof Symbol && Symbol.for, $69d7b9e0f9338877$var$c = $69d7b9e0f9338877$var$b ? Symbol.for("react.element") : 60103, $69d7b9e0f9338877$var$d = $69d7b9e0f9338877$var$b ? Symbol.for("react.portal") : 60106, $69d7b9e0f9338877$var$e = $69d7b9e0f9338877$var$b ? Symbol.for("react.fragment") : 60107, $69d7b9e0f9338877$var$f = $69d7b9e0f9338877$var$b ? Symbol.for("react.strict_mode") : 60108, $69d7b9e0f9338877$var$g = $69d7b9e0f9338877$var$b ? Symbol.for("react.profiler") : 60114, $69d7b9e0f9338877$var$h = $69d7b9e0f9338877$var$b ? Symbol.for("react.provider") : 60109, $69d7b9e0f9338877$var$k = $69d7b9e0f9338877$var$b ? Symbol.for("react.context") : 60110, $69d7b9e0f9338877$var$l = $69d7b9e0f9338877$var$b ? Symbol.for("react.async_mode") : 60111, $69d7b9e0f9338877$var$m = $69d7b9e0f9338877$var$b ? Symbol.for("react.concurrent_mode") : 60111, $69d7b9e0f9338877$var$n = $69d7b9e0f9338877$var$b ? Symbol.for("react.forward_ref") : 60112, $69d7b9e0f9338877$var$p = $69d7b9e0f9338877$var$b ? Symbol.for("react.suspense") : 60113, $69d7b9e0f9338877$var$q = $69d7b9e0f9338877$var$b ? Symbol.for("react.suspense_list") : 60120, $69d7b9e0f9338877$var$r = $69d7b9e0f9338877$var$b ? Symbol.for("react.memo") : 60115, $69d7b9e0f9338877$var$t = $69d7b9e0f9338877$var$b ? Symbol.for("react.lazy") : 60116, $69d7b9e0f9338877$var$v = $69d7b9e0f9338877$var$b ? Symbol.for("react.block") : 60121, $69d7b9e0f9338877$var$w = $69d7b9e0f9338877$var$b ? Symbol.for("react.fundamental") : 60117, $69d7b9e0f9338877$var$x = $69d7b9e0f9338877$var$b ? Symbol.for("react.responder") : 60118, $69d7b9e0f9338877$var$y = $69d7b9e0f9338877$var$b ? Symbol.for("react.scope") : 60119;
function $69d7b9e0f9338877$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $69d7b9e0f9338877$var$c:
                switch(a = a.type, a){
                    case $69d7b9e0f9338877$var$l:
                    case $69d7b9e0f9338877$var$m:
                    case $69d7b9e0f9338877$var$e:
                    case $69d7b9e0f9338877$var$g:
                    case $69d7b9e0f9338877$var$f:
                    case $69d7b9e0f9338877$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $69d7b9e0f9338877$var$k:
                            case $69d7b9e0f9338877$var$n:
                            case $69d7b9e0f9338877$var$t:
                            case $69d7b9e0f9338877$var$r:
                            case $69d7b9e0f9338877$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $69d7b9e0f9338877$var$d:
                return u;
        }
    }
}
function $69d7b9e0f9338877$var$A(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$m;
}
$69d7b9e0f9338877$export$2b8d127b894957b9 = $69d7b9e0f9338877$var$l;
$69d7b9e0f9338877$export$cea3a54a6425200c = $69d7b9e0f9338877$var$m;
$69d7b9e0f9338877$export$a7c73072b1a182ae = $69d7b9e0f9338877$var$k;
$69d7b9e0f9338877$export$9f27bc3417b4524d = $69d7b9e0f9338877$var$h;
$69d7b9e0f9338877$export$db77ccec0bb4ccac = $69d7b9e0f9338877$var$c;
$69d7b9e0f9338877$export$8392c0c9d3dcbd35 = $69d7b9e0f9338877$var$n;
$69d7b9e0f9338877$export$ffb0004e005737fa = $69d7b9e0f9338877$var$e;
$69d7b9e0f9338877$export$b624eff549462981 = $69d7b9e0f9338877$var$t;
$69d7b9e0f9338877$export$7897aa7841a5380c = $69d7b9e0f9338877$var$r;
$69d7b9e0f9338877$export$602eac185826482c = $69d7b9e0f9338877$var$d;
$69d7b9e0f9338877$export$e2c29f18771995cb = $69d7b9e0f9338877$var$g;
$69d7b9e0f9338877$export$5f8d39834fd61797 = $69d7b9e0f9338877$var$f;
$69d7b9e0f9338877$export$74bf444e3cd11ea5 = $69d7b9e0f9338877$var$p;
$69d7b9e0f9338877$export$92387174baf9b227 = function(a) {
    return $69d7b9e0f9338877$var$A(a) || $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$l;
};
$69d7b9e0f9338877$export$ec112efeb987d9c6 = $69d7b9e0f9338877$var$A;
$69d7b9e0f9338877$export$b706b080d889d2c9 = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$k;
};
$69d7b9e0f9338877$export$5be5a87408f70ddc = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$h;
};
$69d7b9e0f9338877$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $69d7b9e0f9338877$var$c;
};
$69d7b9e0f9338877$export$455c2e768291efa6 = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$n;
};
$69d7b9e0f9338877$export$9522e17588c12572 = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$e;
};
$69d7b9e0f9338877$export$2110ac352bb060b9 = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$t;
};
$69d7b9e0f9338877$export$56885ab8b9c456ab = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$r;
};
$69d7b9e0f9338877$export$d927fcb6adf8f9de = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$d;
};
$69d7b9e0f9338877$export$b82d16f27459e05a = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$g;
};
$69d7b9e0f9338877$export$522c17b4f5e123e8 = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$f;
};
$69d7b9e0f9338877$export$1aabd8a0274ecfd6 = function(a) {
    return $69d7b9e0f9338877$var$z(a) === $69d7b9e0f9338877$var$p;
};
$69d7b9e0f9338877$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $69d7b9e0f9338877$var$e || a === $69d7b9e0f9338877$var$m || a === $69d7b9e0f9338877$var$g || a === $69d7b9e0f9338877$var$f || a === $69d7b9e0f9338877$var$p || a === $69d7b9e0f9338877$var$q || "object" === typeof a && null !== a && (a.$$typeof === $69d7b9e0f9338877$var$t || a.$$typeof === $69d7b9e0f9338877$var$r || a.$$typeof === $69d7b9e0f9338877$var$h || a.$$typeof === $69d7b9e0f9338877$var$k || a.$$typeof === $69d7b9e0f9338877$var$n || a.$$typeof === $69d7b9e0f9338877$var$w || a.$$typeof === $69d7b9e0f9338877$var$x || a.$$typeof === $69d7b9e0f9338877$var$y || a.$$typeof === $69d7b9e0f9338877$var$v);
};
$69d7b9e0f9338877$export$f5bbd400c2f4426f = $69d7b9e0f9338877$var$z;

});

parcelRegister("dX6E1", function(module, exports) {
"use strict";

var $7CXD2 = parcelRequire("7CXD2");

var $gEldR = parcelRequire("gEldR");

var $3AL9o = parcelRequire("3AL9o");

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var $a285f07e87fa15f7$var$clusterWorkerId = (parcelRequire("3W4pV")) || 0;
/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */ function $a285f07e87fa15f7$var$seed(seedValue) {
    $7CXD2.seed(seedValue);
    return module.exports;
}
/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */ function $a285f07e87fa15f7$var$worker(workerId) {
    $a285f07e87fa15f7$var$clusterWorkerId = workerId;
    return module.exports;
}
/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */ function $a285f07e87fa15f7$var$characters(newCharacters) {
    if (newCharacters !== undefined) $7CXD2.characters(newCharacters);
    return $7CXD2.shuffled();
}
/**
 * Generate unique id
 * Returns string id
 */ function $a285f07e87fa15f7$var$generate() {
    return $gEldR($a285f07e87fa15f7$var$clusterWorkerId);
}
// Export all other functions as properties of the generate function
module.exports = $a285f07e87fa15f7$var$generate;
module.exports.generate = $a285f07e87fa15f7$var$generate;
module.exports.seed = $a285f07e87fa15f7$var$seed;
module.exports.worker = $a285f07e87fa15f7$var$worker;
module.exports.characters = $a285f07e87fa15f7$var$characters;
module.exports.isValid = $3AL9o;

});
parcelRegister("7CXD2", function(module, exports) {
"use strict";

var $4zbao = parcelRequire("4zbao");
var $58da56017eeac1be$var$ORIGINAL = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";
var $58da56017eeac1be$var$alphabet;
var $58da56017eeac1be$var$previousSeed;
var $58da56017eeac1be$var$shuffled;
function $58da56017eeac1be$var$reset() {
    $58da56017eeac1be$var$shuffled = false;
}
function $58da56017eeac1be$var$setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if ($58da56017eeac1be$var$alphabet !== $58da56017eeac1be$var$ORIGINAL) {
            $58da56017eeac1be$var$alphabet = $58da56017eeac1be$var$ORIGINAL;
            $58da56017eeac1be$var$reset();
        }
        return;
    }
    if (_alphabet_ === $58da56017eeac1be$var$alphabet) return;
    if (_alphabet_.length !== $58da56017eeac1be$var$ORIGINAL.length) throw new Error("Custom alphabet for shortid must be " + $58da56017eeac1be$var$ORIGINAL.length + " unique characters. You submitted " + _alphabet_.length + " characters: " + _alphabet_);
    var unique = _alphabet_.split("").filter(function(item, ind, arr) {
        return ind !== arr.lastIndexOf(item);
    });
    if (unique.length) throw new Error("Custom alphabet for shortid must be " + $58da56017eeac1be$var$ORIGINAL.length + " unique characters. These characters were not unique: " + unique.join(", "));
    $58da56017eeac1be$var$alphabet = _alphabet_;
    $58da56017eeac1be$var$reset();
}
function $58da56017eeac1be$var$characters(_alphabet_) {
    $58da56017eeac1be$var$setCharacters(_alphabet_);
    return $58da56017eeac1be$var$alphabet;
}
function $58da56017eeac1be$var$setSeed(seed) {
    $4zbao.seed(seed);
    if ($58da56017eeac1be$var$previousSeed !== seed) {
        $58da56017eeac1be$var$reset();
        $58da56017eeac1be$var$previousSeed = seed;
    }
}
function $58da56017eeac1be$var$shuffle() {
    if (!$58da56017eeac1be$var$alphabet) $58da56017eeac1be$var$setCharacters($58da56017eeac1be$var$ORIGINAL);
    var sourceArray = $58da56017eeac1be$var$alphabet.split("");
    var targetArray = [];
    var r = $4zbao.nextValue();
    var characterIndex;
    while(sourceArray.length > 0){
        r = $4zbao.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join("");
}
function $58da56017eeac1be$var$getShuffled() {
    if ($58da56017eeac1be$var$shuffled) return $58da56017eeac1be$var$shuffled;
    $58da56017eeac1be$var$shuffled = $58da56017eeac1be$var$shuffle();
    return $58da56017eeac1be$var$shuffled;
}
/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */ function $58da56017eeac1be$var$lookup(index) {
    var alphabetShuffled = $58da56017eeac1be$var$getShuffled();
    return alphabetShuffled[index];
}
function $58da56017eeac1be$var$get() {
    return $58da56017eeac1be$var$alphabet || $58da56017eeac1be$var$ORIGINAL;
}
module.exports = {
    get: $58da56017eeac1be$var$get,
    characters: $58da56017eeac1be$var$characters,
    seed: $58da56017eeac1be$var$setSeed,
    lookup: $58da56017eeac1be$var$lookup,
    shuffled: $58da56017eeac1be$var$getShuffled
};

});
parcelRegister("4zbao", function(module, exports) {
"use strict";
// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
var $353317c9e336188b$var$seed = 1;
/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */ function $353317c9e336188b$var$getNextValue() {
    $353317c9e336188b$var$seed = ($353317c9e336188b$var$seed * 9301 + 49297) % 233280;
    return $353317c9e336188b$var$seed / 233280.0;
}
function $353317c9e336188b$var$setSeed(_seed_) {
    $353317c9e336188b$var$seed = _seed_;
}
module.exports = {
    nextValue: $353317c9e336188b$var$getNextValue,
    seed: $353317c9e336188b$var$setSeed
};

});


parcelRegister("gEldR", function(module, exports) {
"use strict";

var $7HOjM = parcelRequire("7HOjM");
parcelRequire("7CXD2");
// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var $c1f0d8263d6634ca$var$REDUCE_TIME = 1567752802062;
// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var $c1f0d8263d6634ca$var$version = 7;
// Counter is used when shortid is called multiple times in one second.
var $c1f0d8263d6634ca$var$counter;
// Remember the last time shortid was called in case counter is needed.
var $c1f0d8263d6634ca$var$previousSeconds;
/**
 * Generate unique id
 * Returns string id
 */ function $c1f0d8263d6634ca$var$build(clusterWorkerId) {
    var str = "";
    var seconds = Math.floor((Date.now() - $c1f0d8263d6634ca$var$REDUCE_TIME) * 0.001);
    if (seconds === $c1f0d8263d6634ca$var$previousSeconds) $c1f0d8263d6634ca$var$counter++;
    else {
        $c1f0d8263d6634ca$var$counter = 0;
        $c1f0d8263d6634ca$var$previousSeconds = seconds;
    }
    str = str + $7HOjM($c1f0d8263d6634ca$var$version);
    str = str + $7HOjM(clusterWorkerId);
    if ($c1f0d8263d6634ca$var$counter > 0) str = str + $7HOjM($c1f0d8263d6634ca$var$counter);
    str = str + $7HOjM(seconds);
    return str;
}
module.exports = $c1f0d8263d6634ca$var$build;

});
parcelRegister("7HOjM", function(module, exports) {
"use strict";

var $7CXD2 = parcelRequire("7CXD2");

var $fGuRc = parcelRequire("fGuRc");

var $cp5Ky = parcelRequire("cp5Ky");
function $59c394acc0ac7e54$var$generate(number) {
    var loopCounter = 0;
    var done;
    var str = "";
    while(!done){
        str = str + $cp5Ky($fGuRc, $7CXD2.get(), 1);
        done = number < Math.pow(16, loopCounter + 1);
        loopCounter++;
    }
    return str;
}
module.exports = $59c394acc0ac7e54$var$generate;

});
parcelRegister("fGuRc", function(module, exports) {
"use strict";
var $b6b2b6d59d3f246f$var$crypto = typeof window === "object" && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
var $b6b2b6d59d3f246f$var$randomByte;
if (!$b6b2b6d59d3f246f$var$crypto || !$b6b2b6d59d3f246f$var$crypto.getRandomValues) $b6b2b6d59d3f246f$var$randomByte = function(size) {
    var bytes = [];
    for(var i = 0; i < size; i++)bytes.push(Math.floor(Math.random() * 256));
    return bytes;
};
else $b6b2b6d59d3f246f$var$randomByte = function(size) {
    return $b6b2b6d59d3f246f$var$crypto.getRandomValues(new Uint8Array(size));
};
module.exports = $b6b2b6d59d3f246f$var$randomByte;

});

parcelRegister("cp5Ky", function(module, exports) {
// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.
module.exports = function(random, alphabet, size) {
    // We can’t use bytes bigger than the alphabet. To make bytes values closer
    // to the alphabet, we apply bitmask on them. We look for the closest
    // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
    // 30 symbols in the alphabet, we will take 31 (00011111).
    // We do not use faster Math.clz32, because it is not available in browsers.
    var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
    // which is bigger than the alphabet). As a result, we will need more bytes,
    // than ID size, because we will refuse bytes bigger than the alphabet.
    // Every hardware random generator call is costly,
    // because we need to wait for entropy collection. This is why often it will
    // be faster to ask for few extra bytes in advance, to avoid additional calls.
    // Here we calculate how many random bytes should we call in advance.
    // It depends on ID length, mask / alphabet size and magic number 1.6
    // (which was selected according benchmarks).
    // -~f => Math.ceil(f) if n is float number
    // -~i => i + 1 if n is integer number
    var step = -~(1.6 * mask * size / alphabet.length);
    var id = "";
    while(true){
        var bytes = random(step);
        // Compact alternative for `for (var i = 0; i < step; i++)`
        var i = step;
        while(i--){
            // If random byte is bigger than alphabet even after bitmask,
            // we refuse it by `|| ''`.
            id += alphabet[bytes[i] & mask] || "";
            // More compact than `id.length + 1 === size`
            if (id.length === +size) return id;
        }
    }
};

});



parcelRegister("3AL9o", function(module, exports) {
"use strict";

var $7CXD2 = parcelRequire("7CXD2");
function $29d94efbcd142488$var$isShortId(id) {
    if (!id || typeof id !== "string" || id.length < 6) return false;
    var nonAlphabetic = new RegExp("[^" + $7CXD2.get().replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&") + "]");
    return !nonAlphabetic.test(id);
}
module.exports = $29d94efbcd142488$var$isShortId;

});

parcelRegister("3W4pV", function(module, exports) {
"use strict";
module.exports = 0;

});


parcelRegister("6IRuR", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});


var $gIfym = parcelRequire("gIfym");
var $c4a08725a78d51bf$exports = {};
"use strict";
function $c4a08725a78d51bf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c4a08725a78d51bf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c4a08725a78d51bf$var$checkDCE();

$c4a08725a78d51bf$exports = (parcelRequire("eN6q3"));


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1d6308828ef11f3e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $f62a014aa4ae8b60$export$31499a9cd224b78c = "8.37.1";


/** Get's the global object for the current JavaScript runtime */ const $33e192bcb8946f8c$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $33e192bcb8946f8c$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $33e192bcb8946f8c$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $f62a014aa4ae8b60$export$31499a9cd224b78c] = __SENTRY__[0, $f62a014aa4ae8b60$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/** Prefix for logging strings */ const $fe5d055940839409$var$PREFIX = "Sentry Logger ";
const $fe5d055940839409$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $fe5d055940839409$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $fe5d055940839409$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($fe5d055940839409$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $fe5d055940839409$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $fe5d055940839409$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $1d6308828ef11f3e$export$16a28057038b10ef) $fe5d055940839409$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $fe5d055940839409$export$cda52e2a8927a2ca(()=>{
                (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).console[name](`${$fe5d055940839409$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $fe5d055940839409$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $fe5d055940839409$export$af88d00dbe7f521 = (0, $33e192bcb8946f8c$export$7e223ec222791509)("logger", $fe5d055940839409$var$makeLogger);


const $213403414f6134bb$var$STACKTRACE_FRAME_LIMIT = 50;
const $213403414f6134bb$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $213403414f6134bb$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $213403414f6134bb$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $213403414f6134bb$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $213403414f6134bb$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($213403414f6134bb$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $213403414f6134bb$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $213403414f6134bb$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $213403414f6134bb$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $213403414f6134bb$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $213403414f6134bb$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($213403414f6134bb$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($213403414f6134bb$var$STRIP_FRAME_REGEXP.test($213403414f6134bb$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($213403414f6134bb$var$STRIP_FRAME_REGEXP.test($213403414f6134bb$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $213403414f6134bb$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $213403414f6134bb$var$getLastStackFrame(localStack).filename,
            function: frame.function || $213403414f6134bb$export$27c7e15d453fc0ac
        }));
}
function $213403414f6134bb$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $213403414f6134bb$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $213403414f6134bb$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $213403414f6134bb$var$defaultFunctionName;
        return fn.name || $213403414f6134bb$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $213403414f6134bb$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $213403414f6134bb$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $0e9b073a7b40ae00$var$handlers = {};
const $0e9b073a7b40ae00$var$instrumented = {};
/** Add a handler function. */ function $0e9b073a7b40ae00$export$a4e09611e30da72e(type, handler) {
    $0e9b073a7b40ae00$var$handlers[type] = $0e9b073a7b40ae00$var$handlers[type] || [];
    $0e9b073a7b40ae00$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $0e9b073a7b40ae00$export$b17eab759a1cb5fe() {
    Object.keys($0e9b073a7b40ae00$var$handlers).forEach((key)=>{
        $0e9b073a7b40ae00$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $0e9b073a7b40ae00$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$0e9b073a7b40ae00$var$instrumented[type]) {
        $0e9b073a7b40ae00$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $1d6308828ef11f3e$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $0e9b073a7b40ae00$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $0e9b073a7b40ae00$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $1d6308828ef11f3e$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $213403414f6134bb$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $a0f8d420fbcfb8ea$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$e6127cc7fe7395c3(wat) {
    switch($a0f8d420fbcfb8ea$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $a0f8d420fbcfb8ea$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$var$isBuiltin(wat, className) {
    return $a0f8d420fbcfb8ea$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$9f9636d330b71954(wat) {
    return $a0f8d420fbcfb8ea$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$ef9e2056653f0c8e(wat) {
    return $a0f8d420fbcfb8ea$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$12e869b2a583f783(wat) {
    return $a0f8d420fbcfb8ea$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$844ec244b1367d54(wat) {
    return $a0f8d420fbcfb8ea$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$c3825b437cbdea5c(wat) {
    return wat === null || $a0f8d420fbcfb8ea$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$53b83ca8eaab0383(wat) {
    return $a0f8d420fbcfb8ea$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $a0f8d420fbcfb8ea$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $a0f8d420fbcfb8ea$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$49841c62b9eff15(wat) {
    return $a0f8d420fbcfb8ea$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $a0f8d420fbcfb8ea$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$bc2894c7158efbac(wat) {
    return $a0f8d420fbcfb8ea$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a0f8d420fbcfb8ea$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



const $83913a7139f39e6c$var$WINDOW = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);
const $83913a7139f39e6c$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $83913a7139f39e6c$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $83913a7139f39e6c$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $83913a7139f39e6c$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $83913a7139f39e6c$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($83913a7139f39e6c$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $83913a7139f39e6c$export$1cfafeee2987818b() {
    try {
        return $83913a7139f39e6c$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $83913a7139f39e6c$export$c660c1f3ab49225c(selector) {
    if ($83913a7139f39e6c$var$WINDOW.document && $83913a7139f39e6c$var$WINDOW.document.querySelector) return $83913a7139f39e6c$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $83913a7139f39e6c$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$83913a7139f39e6c$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $df92c5c0ba822dfa$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $df92c5c0ba822dfa$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df92c5c0ba822dfa$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $a0f8d420fbcfb8ea$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $df92c5c0ba822dfa$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(value)) return false;
    if ((0, $a0f8d420fbcfb8ea$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $df92c5c0ba822dfa$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$df92c5c0ba822dfa$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $212518d61e73b76e$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $212518d61e73b76e$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $212518d61e73b76e$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $1d6308828ef11f3e$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $212518d61e73b76e$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $212518d61e73b76e$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $212518d61e73b76e$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $212518d61e73b76e$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $212518d61e73b76e$export$62ff257738bf57f5(value) {
    if ((0, $a0f8d420fbcfb8ea$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$212518d61e73b76e$var$getOwnProperties(value)
    };
    else if ((0, $a0f8d420fbcfb8ea$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $212518d61e73b76e$var$serializeEventTarget(value.target),
            currentTarget: $212518d61e73b76e$var$serializeEventTarget(value.currentTarget),
            ...$212518d61e73b76e$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $a0f8d420fbcfb8ea$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $212518d61e73b76e$var$serializeEventTarget(target) {
    try {
        return (0, $a0f8d420fbcfb8ea$export$45a5e7f76e0caa8d)(target) ? (0, $83913a7139f39e6c$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $212518d61e73b76e$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $212518d61e73b76e$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($212518d61e73b76e$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $df92c5c0ba822dfa$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $df92c5c0ba822dfa$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $212518d61e73b76e$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $212518d61e73b76e$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $212518d61e73b76e$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($212518d61e73b76e$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $212518d61e73b76e$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($212518d61e73b76e$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $212518d61e73b76e$var$isPojo(input) {
    if (!(0, $a0f8d420fbcfb8ea$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $212518d61e73b76e$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $a0f8d420fbcfb8ea$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $a2c218bffcf7a8ff$var$WINDOW = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a2c218bffcf7a8ff$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $a2c218bffcf7a8ff$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a2c218bffcf7a8ff$var$WINDOW && !!$a2c218bffcf7a8ff$var$WINDOW.history.pushState && !!$a2c218bffcf7a8ff$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $496ff79b0915bd1a$export$56d8a8a25bd48b81 = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);


let $9c43746b6e1807b7$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9c43746b6e1807b7$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $0e9b073a7b40ae00$export$a4e09611e30da72e)(type, handler);
    (0, $0e9b073a7b40ae00$export$e18d6c5462c01368)(type, $9c43746b6e1807b7$var$instrumentHistory);
}
function $9c43746b6e1807b7$var$instrumentHistory() {
    if (!(0, $a2c218bffcf7a8ff$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).onpopstate;
    (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $9c43746b6e1807b7$var$lastHref;
        $9c43746b6e1807b7$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $9c43746b6e1807b7$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $9c43746b6e1807b7$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $212518d61e73b76e$export$9563e054e6f787fb)((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $212518d61e73b76e$export$9563e054e6f787fb)((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}




const $6c99372f7423d531$export$9ca9946bd449ac06 = "baggage";
const $6c99372f7423d531$export$6e69537d67fa20f = "sentry-";
const $6c99372f7423d531$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $6c99372f7423d531$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $6c99372f7423d531$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $6c99372f7423d531$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($6c99372f7423d531$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($6c99372f7423d531$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $6c99372f7423d531$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$6c99372f7423d531$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $6c99372f7423d531$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $6c99372f7423d531$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $6c99372f7423d531$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $6c99372f7423d531$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $6c99372f7423d531$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $6c99372f7423d531$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $6c99372f7423d531$export$bdd844ddb2def819) {
            (0, $1d6308828ef11f3e$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}





/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $21925b133330b925$export$19f53698e68b2496() {
    const gbl = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $21925b133330b925$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $21925b133330b925$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $21925b133330b925$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $21925b133330b925$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $21925b133330b925$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $21925b133330b925$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $21925b133330b925$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $21925b133330b925$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $21925b133330b925$export$d364f2020ab30578(input) {
    const match = input.match($21925b133330b925$var$SEMVER_REGEXP) || [];
    const major = $21925b133330b925$var$_parseInt(match[1]);
    const minor = $21925b133330b925$var$_parseInt(match[2]);
    const patch = $21925b133330b925$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $21925b133330b925$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $df92c5c0ba822dfa$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $df92c5c0ba822dfa$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $df92c5c0ba822dfa$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $21925b133330b925$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $212518d61e73b76e$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $21925b133330b925$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $270472853a09b5e1$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $270472853a09b5e1$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($270472853a09b5e1$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $270472853a09b5e1$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $270472853a09b5e1$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $6c99372f7423d531$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $21925b133330b925$export$19f53698e68b2496)(),
        spanId: (0, $21925b133330b925$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $21925b133330b925$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $21925b133330b925$export$19f53698e68b2496)().substring(16),
        spanId: (0, $21925b133330b925$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $270472853a09b5e1$export$f35d907436da45cf(traceId = (0, $21925b133330b925$export$19f53698e68b2496)(), spanId = (0, $21925b133330b925$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


const $3bdbd9b2c36d1620$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $3bdbd9b2c36d1620$export$7740643b9eeaf0c4() {
    return Date.now() / $3bdbd9b2c36d1620$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $3bdbd9b2c36d1620$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $3bdbd9b2c36d1620$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $3bdbd9b2c36d1620$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $3bdbd9b2c36d1620$export$ee52dced521e3e18 = $3bdbd9b2c36d1620$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $3bdbd9b2c36d1620$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $3bdbd9b2c36d1620$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $3bdbd9b2c36d1620$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $3bdbd9b2c36d1620$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $3bdbd9b2c36d1620$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $3bdbd9b2c36d1620$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db4da0676491ff74$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db4da0676491ff74$export$c8bfa33e4e8ae492((0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1));
    return 0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db4da0676491ff74$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $f62a014aa4ae8b60$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $f62a014aa4ae8b60$export$31499a9cd224b78c] = __SENTRY__[0, $f62a014aa4ae8b60$export$31499a9cd224b78c] || {};
}





/**
 * Returns a new minimal propagation context
 */ function $69deb073f948d319$export$37f0f2f9cf343e5e() {
    return {
        traceId: (0, $21925b133330b925$export$19f53698e68b2496)(),
        spanId: (0, $21925b133330b925$export$19f53698e68b2496)().substring(16)
    };
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ed585064cddca611$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $21925b133330b925$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ed585064cddca611$var$sessionToJSON(session)
    };
    if (context) $ed585064cddca611$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ed585064cddca611$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $21925b133330b925$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ed585064cddca611$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ed585064cddca611$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ed585064cddca611$var$sessionToJSON(session) {
    return (0, $212518d61e73b76e$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}



const $1b048be58b6fe914$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $1b048be58b6fe914$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $212518d61e73b76e$export$e73679ffaf56810e)(scope, $1b048be58b6fe914$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$1b048be58b6fe914$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $1b048be58b6fe914$export$91f063ebb8eff307(scope) {
    return scope[$1b048be58b6fe914$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $b5fe62d7da05e697$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $b5fe62d7da05e697$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = (0, $69deb073f948d319$export$37f0f2f9cf343e5e)();
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $b5fe62d7da05e697$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $1b048be58b6fe914$export$3f25fa50c18e20ca)(newScope, (0, $1b048be58b6fe914$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $ed585064cddca611$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $b5fe62d7da05e697$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $a0f8d420fbcfb8ea$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $1b048be58b6fe914$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this._propagationContext = (0, $69deb073f948d319$export$37f0f2f9cf343e5e)();
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $b5fe62d7da05e697$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $3bdbd9b2c36d1620$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $1b048be58b6fe914$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $21925b133330b925$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fe5d055940839409$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $21925b133330b925$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fe5d055940839409$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $21925b133330b925$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fe5d055940839409$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
// NOTE: By exporting this here as const & type, instead of doing `export class`,
// We can get the correct class when importing from `@sentry/core`, but the original type (from `@sentry/types`)
// This is helpful for interop, e.g. when doing `import type { Scope } from '@sentry/node';` (which re-exports this)
/**
 * Holds additional event information.
 */ const $b5fe62d7da05e697$export$775b6bb06e53a214 = $b5fe62d7da05e697$var$ScopeClass;


/** Get the default current scope. */ function $1a6e628ccaafc8f3$export$6f1b9191db9c4d5() {
    return (0, $33e192bcb8946f8c$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $b5fe62d7da05e697$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $1a6e628ccaafc8f3$export$de9862929b76bf57() {
    return (0, $33e192bcb8946f8c$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $b5fe62d7da05e697$export$775b6bb06e53a214)());
}




/**
 * This is an object that holds a stack of scopes.
 */ class $6e3fe82d39f4ead7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $b5fe62d7da05e697$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $b5fe62d7da05e697$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $a0f8d420fbcfb8ea$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $6e3fe82d39f4ead7$var$getAsyncContextStack() {
    const registry = (0, $db4da0676491ff74$export$19eade501500c6c1)();
    const sentry = (0, $db4da0676491ff74$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $6e3fe82d39f4ead7$export$d36ec451f120cfba((0, $1a6e628ccaafc8f3$export$6f1b9191db9c4d5)(), (0, $1a6e628ccaafc8f3$export$de9862929b76bf57)());
}
function $6e3fe82d39f4ead7$var$withScope(callback) {
    return $6e3fe82d39f4ead7$var$getAsyncContextStack().withScope(callback);
}
function $6e3fe82d39f4ead7$var$withSetScope(scope, callback) {
    const stack = $6e3fe82d39f4ead7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $6e3fe82d39f4ead7$var$withIsolationScope(callback) {
    return $6e3fe82d39f4ead7$var$getAsyncContextStack().withScope(()=>{
        return callback($6e3fe82d39f4ead7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $6e3fe82d39f4ead7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $6e3fe82d39f4ead7$var$withIsolationScope,
        withScope: $6e3fe82d39f4ead7$var$withScope,
        withSetScope: $6e3fe82d39f4ead7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $6e3fe82d39f4ead7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$6e3fe82d39f4ead7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$6e3fe82d39f4ead7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $3da64f08684526ba$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db4da0676491ff74$export$19eade501500c6c1)();
    const sentry = (0, $db4da0676491ff74$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $3da64f08684526ba$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db4da0676491ff74$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $6e3fe82d39f4ead7$export$329d4d4d54e42710)();
}







/**
 * Get the currently active scope.
 */ function $4d085f2ea319a6b5$export$c7be4b0125a10cba() {
    const carrier = (0, $db4da0676491ff74$export$19eade501500c6c1)();
    const acs = (0, $3da64f08684526ba$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $4d085f2ea319a6b5$export$68f3af03034c9e90() {
    const carrier = (0, $db4da0676491ff74$export$19eade501500c6c1)();
    const acs = (0, $3da64f08684526ba$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $4d085f2ea319a6b5$export$aa55d5ab8e05984f() {
    return (0, $33e192bcb8946f8c$export$7e223ec222791509)("globalScope", ()=>new (0, $b5fe62d7da05e697$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $4d085f2ea319a6b5$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db4da0676491ff74$export$19eade501500c6c1)();
    const acs = (0, $3da64f08684526ba$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $4d085f2ea319a6b5$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db4da0676491ff74$export$19eade501500c6c1)();
    const acs = (0, $3da64f08684526ba$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $4d085f2ea319a6b5$export$6bb76d6eba7e258c() {
    return $4d085f2ea319a6b5$export$c7be4b0125a10cba().getClient();
}



/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $aae3ce6bfddb9bb2$var$METRICS_SPAN_FIELD = "_sentryMetrics";
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $aae3ce6bfddb9bb2$export$2e7205e45c58797d(span) {
    const storage = span[$aae3ce6bfddb9bb2$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $212518d61e73b76e$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $aae3ce6bfddb9bb2$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$aae3ce6bfddb9bb2$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$aae3ce6bfddb9bb2$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $48bb799067430277$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $48bb799067430277$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $48bb799067430277$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $48bb799067430277$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $48bb799067430277$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $48bb799067430277$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $48bb799067430277$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * The id of the profile that this span occurred in.
 */ const $48bb799067430277$export$1efec95406bbe327 = "sentry.profile_id";
const $48bb799067430277$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $48bb799067430277$export$b016f89ac1066ec = "cache.hit";
const $48bb799067430277$export$3110e4c3f4386399 = "cache.key";
const $48bb799067430277$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $48bb799067430277$export$be7a251980e7e946 = "http.request.method";
const $48bb799067430277$export$25dfd73e0e32c6e1 = "url.full";


const $11c0f0f43ce3ae5b$export$136e25984ba4a383 = 0;
const $11c0f0f43ce3ae5b$export$58f7963109c806fc = 1;
const $11c0f0f43ce3ae5b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $11c0f0f43ce3ae5b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $11c0f0f43ce3ae5b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $11c0f0f43ce3ae5b$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $11c0f0f43ce3ae5b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $11c0f0f43ce3ae5b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



// These are aligned with OpenTelemetry trace flags
const $5563dd3c937fc83c$export$208d5b368507fb8b = 0x0;
const $5563dd3c937fc83c$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $5563dd3c937fc83c$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $5563dd3c937fc83c$export$92d8c23565496537(span);
    return (0, $212518d61e73b76e$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $5563dd3c937fc83c$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { parent_span_id: parent_span_id } = $5563dd3c937fc83c$export$92d8c23565496537(span);
    return (0, $212518d61e73b76e$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $5563dd3c937fc83c$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $5563dd3c937fc83c$export$5caecac1caaf3a71(span);
    return (0, $270472853a09b5e1$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $5563dd3c937fc83c$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $5563dd3c937fc83c$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $5563dd3c937fc83c$var$ensureTimestampInSeconds(input.getTime());
    return (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $5563dd3c937fc83c$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $5563dd3c937fc83c$export$92d8c23565496537(span) {
    if ($5563dd3c937fc83c$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($5563dd3c937fc83c$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $212518d61e73b76e$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $5563dd3c937fc83c$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $5563dd3c937fc83c$export$3f7581298f56c6d7(endTime) || undefined,
                status: $5563dd3c937fc83c$export$e238a77ea3a8cd66(status),
                op: attributes[0, $48bb799067430277$export$1a413bd9a88fdb09],
                origin: attributes[0, $48bb799067430277$export$cca8dd30f57f805e],
                _metrics_summary: (0, $aae3ce6bfddb9bb2$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $5563dd3c937fc83c$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $5563dd3c937fc83c$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $5563dd3c937fc83c$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $5563dd3c937fc83c$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $5563dd3c937fc83c$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $11c0f0f43ce3ae5b$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $11c0f0f43ce3ae5b$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $5563dd3c937fc83c$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $5563dd3c937fc83c$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $5563dd3c937fc83c$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$5563dd3c937fc83c$var$ROOT_SPAN_FIELD] || span;
    (0, $212518d61e73b76e$export$e73679ffaf56810e)(childSpan, $5563dd3c937fc83c$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$5563dd3c937fc83c$var$CHILD_SPANS_FIELD]) span[$5563dd3c937fc83c$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $212518d61e73b76e$export$e73679ffaf56810e)(span, $5563dd3c937fc83c$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $5563dd3c937fc83c$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$5563dd3c937fc83c$var$CHILD_SPANS_FIELD]) span[$5563dd3c937fc83c$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $5563dd3c937fc83c$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($5563dd3c937fc83c$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$5563dd3c937fc83c$var$CHILD_SPANS_FIELD] ? Array.from(span[$5563dd3c937fc83c$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $5563dd3c937fc83c$export$c4c6a79b1260ca1b(span) {
    return span[$5563dd3c937fc83c$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $5563dd3c937fc83c$export$1be426a8e585c83e() {
    const carrier = (0, $db4da0676491ff74$export$19eade501500c6c1)();
    const acs = (0, $3da64f08684526ba$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $1b048be58b6fe914$export$91f063ebb8eff307)((0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $5563dd3c937fc83c$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $5563dd3c937fc83c$export$1be426a8e585c83e();
    if (span) (0, $aae3ce6bfddb9bb2$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}



/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $94ef37c8285d8bdd$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) rootSpan.addEvent(name, {
        [(0, $48bb799067430277$export$69cd5c610c7bb96a)]: value,
        [(0, $48bb799067430277$export$f5f95cff026507b5)]: unit
    });
}
/**
 * Convert timed events to measurements.
 */ function $94ef37c8285d8bdd$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $48bb799067430277$export$f5f95cff026507b5];
        const value = attributes[0, $48bb799067430277$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}





/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1f061359ff69ce32$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $01258473f6227eb9$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $01258473f6227eb9$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $01258473f6227eb9$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $a0f8d420fbcfb8ea$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e666466af6a00254$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}





const $3357363524dbf465$export$849dbeeeda01ae98 = "production";






/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $896c8118669d0430$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $896c8118669d0430$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $212518d61e73b76e$export$e73679ffaf56810e)(spanWithMaybeDsc, $896c8118669d0430$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $896c8118669d0430$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $212518d61e73b76e$export$d25f2688db1bb433)({
        environment: options.environment || (0, $3357363524dbf465$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $896c8118669d0430$export$a117f995597e25df(span) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const dsc = $896c8118669d0430$export$366bad00d6815eed((0, $5563dd3c937fc83c$export$92d8c23565496537)(span).trace_id || "", client);
    const rootSpan = (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$896c8118669d0430$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $6c99372f7423d531$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const jsonSpan = (0, $5563dd3c937fc83c$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $48bb799067430277$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $48bb799067430277$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $e666466af6a00254$export$5008da00b1b6dee6)()) dsc.sampled = String((0, $5563dd3c937fc83c$export$5caecac1caaf3a71)(rootSpan));
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $896c8118669d0430$export$95cf936fdacaff7b(span) {
    const dsc = $896c8118669d0430$export$a117f995597e25df(span);
    return (0, $6c99372f7423d531$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $249ca399c8246235$export$2f3d84e767c9592b(span) {
    if (!(0, $1f061359ff69ce32$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $5563dd3c937fc83c$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $fe5d055940839409$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $249ca399c8246235$export$b77c830667a4d630(span) {
    if (!(0, $1f061359ff69ce32$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $fe5d055940839409$export$af88d00dbe7f521).log(msg);
}







/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $aa7e579fce63739a$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}


/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $91fb420942f29e03$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $e666466af6a00254$export$5008da00b1b6dee6)(options)) return [
        false
    ];
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") sampleRate = options.tracesSampler(samplingContext);
    else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $aa7e579fce63739a$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $18851cea88d51bf5$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $21925b133330b925$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $21925b133330b925$export$19f53698e68b2496)().substring(16);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $5563dd3c937fc83c$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}







/** Regular expression used to parse a Dsn. */ const $1eb6493fa38ceb83$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $1eb6493fa38ceb83$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $1eb6493fa38ceb83$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $1eb6493fa38ceb83$export$b892860177f70a30(str) {
    const match = $1eb6493fa38ceb83$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $fe5d055940839409$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $1eb6493fa38ceb83$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $1eb6493fa38ceb83$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $1eb6493fa38ceb83$var$validateDsn(dsn) {
    if (!(0, $1d6308828ef11f3e$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $fe5d055940839409$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $fe5d055940839409$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$1eb6493fa38ceb83$var$isValidProtocol(protocol)) {
        (0, $fe5d055940839409$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $fe5d055940839409$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $1eb6493fa38ceb83$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $1eb6493fa38ceb83$export$b892860177f70a30(from) : $1eb6493fa38ceb83$var$dsnFromComponents(from);
    if (!components || !$1eb6493fa38ceb83$var$validateDsn(components)) return undefined;
    return components;
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $a4d3ca4c2d5286ef$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4c0d7eab065d1a33$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $4c0d7eab065d1a33$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $4c0d7eab065d1a33$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $4c0d7eab065d1a33$export$a3295358bff77e(object, depth);
    if ($4c0d7eab065d1a33$var$jsonSize(normalized) > maxSize) return $4c0d7eab065d1a33$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $4c0d7eab065d1a33$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $a4d3ca4c2d5286ef$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $4c0d7eab065d1a33$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $4c0d7eab065d1a33$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $212518d61e73b76e$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $4c0d7eab065d1a33$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $4c0d7eab065d1a33$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $a0f8d420fbcfb8ea$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $a0f8d420fbcfb8ea$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $213403414f6134bb$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $4c0d7eab065d1a33$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $4c0d7eab065d1a33$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $4c0d7eab065d1a33$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4c0d7eab065d1a33$var$jsonSize(value) {
    return $4c0d7eab065d1a33$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $4c0d7eab065d1a33$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ac9400386ed4faec$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ac9400386ed4faec$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $ac9400386ed4faec$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $ac9400386ed4faec$export$604a45d95a155e2b(envelope, types) {
    return $ac9400386ed4faec$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $ac9400386ed4faec$var$encodeUTF8(input) {
    return (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $ac9400386ed4faec$var$decodeUTF8(input) {
    return (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $ac9400386ed4faec$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $ac9400386ed4faec$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $ac9400386ed4faec$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $4c0d7eab065d1a33$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $ac9400386ed4faec$var$concatBuffers(parts);
}
function $ac9400386ed4faec$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $ac9400386ed4faec$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $ac9400386ed4faec$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($ac9400386ed4faec$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $ac9400386ed4faec$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $ac9400386ed4faec$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $ac9400386ed4faec$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $212518d61e73b76e$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $ac9400386ed4faec$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $ac9400386ed4faec$export$b11169581eeaf237(type) {
    return $ac9400386ed4faec$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $ac9400386ed4faec$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $ac9400386ed4faec$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1eb6493fa38ceb83$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $212518d61e73b76e$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $98aedf1efd71f255$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $98aedf1efd71f255$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ac9400386ed4faec$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1eb6493fa38ceb83$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $ac9400386ed4faec$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $98aedf1efd71f255$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ac9400386ed4faec$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $98aedf1efd71f255$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $ac9400386ed4faec$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $ac9400386ed4faec$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $98aedf1efd71f255$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $896c8118669d0430$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1eb6493fa38ceb83$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>beforeSendSpan((0, $5563dd3c937fc83c$export$92d8c23565496537)(span)) : (span)=>(0, $5563dd3c937fc83c$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $ac9400386ed4faec$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $ac9400386ed4faec$export$f93f7f385160c44e)(headers, items);
}









const $3432ec821fe04cd2$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $3432ec821fe04cd2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $3432ec821fe04cd2$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $212518d61e73b76e$export$e73679ffaf56810e)(span, $3432ec821fe04cd2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $212518d61e73b76e$export$e73679ffaf56810e)(span, $3432ec821fe04cd2$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $3432ec821fe04cd2$export$c08fbc656a245d03(span) {
    return {
        scope: span[$3432ec821fe04cd2$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$3432ec821fe04cd2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


const $be8e66ca63ab8323$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $be8e66ca63ab8323$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $21925b133330b925$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $21925b133330b925$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
        this._attributes = {};
        this.setAttributes({
            [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "manual",
            [(0, $48bb799067430277$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $5563dd3c937fc83c$export$eb571cd9b5d98de8) : (0, $5563dd3c937fc83c$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $5563dd3c937fc83c$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $5563dd3c937fc83c$export$3f7581298f56c6d7)(endTimestamp);
        (0, $249ca399c8246235$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $212518d61e73b76e$export$d25f2688db1bb433)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $48bb799067430277$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $5563dd3c937fc83c$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $48bb799067430277$export$cca8dd30f57f805e],
            _metrics_summary: (0, $aae3ce6bfddb9bb2$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $48bb799067430277$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $48bb799067430277$export$fea48ba9f4550879],
            measurements: (0, $94ef37c8285d8bdd$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Tracing] Adding an event to span:", name);
        const time = $be8e66ca63ab8323$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
        const attributes = $be8e66ca63ab8323$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $5563dd3c937fc83c$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $be8e66ca63ab8323$var$sendSpanEnvelope((0, $98aedf1efd71f255$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $3432ec821fe04cd2$export$c08fbc656a245d03)(this).scope || (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$be8e66ca63ab8323$var$isFullFinishedSpan((0, $5563dd3c937fc83c$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $3432ec821fe04cd2$export$c08fbc656a245d03)(this);
        const scope = capturedSpanScope || (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
        const client = scope.getClient() || (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $5563dd3c937fc83c$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$be8e66ca63ab8323$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $5563dd3c937fc83c$export$92d8c23565496537)(span)).filter($be8e66ca63ab8323$var$isFullFinishedSpan);
        const source = this._attributes[0, $48bb799067430277$export$d7a7d984b0791405];
        const transaction = {
            contexts: {
                trace: (0, $5563dd3c937fc83c$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $be8e66ca63ab8323$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $be8e66ca63ab8323$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $212518d61e73b76e$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $896c8118669d0430$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $aae3ce6bfddb9bb2$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $94ef37c8285d8bdd$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $be8e66ca63ab8323$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $be8e66ca63ab8323$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $be8e66ca63ab8323$var$isStandaloneSpan(span) {
    return span instanceof $be8e66ca63ab8323$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $be8e66ca63ab8323$var$sendSpanEnvelope(envelope) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




const $0e8760fc46e607c6$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $0e8760fc46e607c6$export$a1bd95187356f372(options, callback) {
    const acs = $0e8760fc46e607c6$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $0e8760fc46e607c6$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $4d085f2ea319a6b5$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $0e8760fc46e607c6$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
            const parentSpan = $0e8760fc46e607c6$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $18851cea88d51bf5$export$d6636b700b76c516)() : $0e8760fc46e607c6$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $1b048be58b6fe914$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $01258473f6227eb9$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $11c0f0f43ce3ae5b$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>activeSpan.end());
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $0e8760fc46e607c6$export$c10292ad04b92aea(options, callback) {
    const acs = $0e8760fc46e607c6$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $0e8760fc46e607c6$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $4d085f2ea319a6b5$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $0e8760fc46e607c6$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
            const parentSpan = $0e8760fc46e607c6$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $18851cea88d51bf5$export$d6636b700b76c516)() : $0e8760fc46e607c6$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $1b048be58b6fe914$export$3f25fa50c18e20ca)(scope, activeSpan);
            function finishAndSetSpan() {
                activeSpan.end();
            }
            return (0, $01258473f6227eb9$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $11c0f0f43ce3ae5b$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $0e8760fc46e607c6$export$63dbba021a6b4047(options) {
    const acs = $0e8760fc46e607c6$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $0e8760fc46e607c6$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $4d085f2ea319a6b5$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$0e8760fc46e607c6$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
        const parentSpan = $0e8760fc46e607c6$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $18851cea88d51bf5$export$d6636b700b76c516)();
        return $0e8760fc46e607c6$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $0e8760fc46e607c6$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    return (0, $4d085f2ea319a6b5$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $270472853a09b5e1$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $0e8760fc46e607c6$export$e57ac09b143d92a2(span, callback) {
    const acs = $0e8760fc46e607c6$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $4d085f2ea319a6b5$export$ec58d9285c204497)((scope)=>{
        (0, $1b048be58b6fe914$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $0e8760fc46e607c6$export$869298f9835abc68(callback) {
    const acs = $0e8760fc46e607c6$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $4d085f2ea319a6b5$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$0e8760fc46e607c6$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $0e8760fc46e607c6$export$f90b03291402f553(callback) {
    return (0, $4d085f2ea319a6b5$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext((0, $69deb073f948d319$export$37f0f2f9cf343e5e)());
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $0e8760fc46e607c6$export$e57ac09b143d92a2(null, callback);
    });
}
function $0e8760fc46e607c6$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $e666466af6a00254$export$5008da00b1b6dee6)()) return new (0, $18851cea88d51bf5$export$d6636b700b76c516)();
    const isolationScope = (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $0e8760fc46e607c6$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $5563dd3c937fc83c$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $896c8118669d0430$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $5563dd3c937fc83c$export$5caecac1caaf3a71)(parentSpan);
        span = $0e8760fc46e607c6$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $896c8118669d0430$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $0e8760fc46e607c6$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $896c8118669d0430$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $249ca399c8246235$export$2f3d84e767c9592b)(span);
    (0, $3432ec821fe04cd2$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $0e8760fc46e607c6$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $5563dd3c937fc83c$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $0e8760fc46e607c6$var$getAcs() {
    const carrier = (0, $db4da0676491ff74$export$19eade501500c6c1)();
    return (0, $3da64f08684526ba$export$f639b0c2752203be)(carrier);
}
function $0e8760fc46e607c6$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {};
    const { name: name = "", attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$0e8760fc46e607c6$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $91fb420942f29e03$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $be8e66ca63ab8323$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $48bb799067430277$export$d7a7d984b0791405)]: "custom",
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $48bb799067430277$export$ccfe0a40627cc34b), sampleRate);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $0e8760fc46e607c6$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$0e8760fc46e607c6$var$SUPPRESS_TRACING_KEY] ? false : (0, $5563dd3c937fc83c$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $be8e66ca63ab8323$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $18851cea88d51bf5$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $5563dd3c937fc83c$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $0e8760fc46e607c6$var$getParentSpan(scope) {
    const span = (0, $1b048be58b6fe914$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $0e8760fc46e607c6$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $0e8760fc46e607c6$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $60e4420834845c0c$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $60e4420834845c0c$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $60e4420834845c0c$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $60e4420834845c0c$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1a5e20c7490d57a5$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $f50c25d72c839ed9$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}






const $2017e28d0c0734bd$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $2017e28d0c0734bd$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $2017e28d0c0734bd$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $495fb7f565423ea0$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $418b7863084de289$export$6431553786c94949 = ()=>{
    return (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6c4ed4d1fd79f8b3$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $418b7863084de289$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1e237c6abe8a3e15$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $418b7863084de289$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.prerendering || (0, $6c4ed4d1fd79f8b3$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: entries,
        id: (0, $495fb7f565423ea0$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $e158e103f8722bed$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e67043401030991$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.visibilityState === "hidden") cb(event);
    };
    if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $81bb90a8d7895784$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return (arg)=>{
        if (!called) {
            cb(arg);
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $0c00988f7888413d$var$firstHiddenTime = -1;
const $0c00988f7888413d$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    $0c00988f7888413d$var$firstHiddenTime = (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $0c00988f7888413d$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && $0c00988f7888413d$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $0c00988f7888413d$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        removeEventListener("visibilitychange", $0c00988f7888413d$var$onVisibilityUpdate, true);
        removeEventListener("prerenderingchange", $0c00988f7888413d$var$onVisibilityUpdate, true);
    }
};
const $0c00988f7888413d$var$addChangeListeners = ()=>{
    addEventListener("visibilitychange", $0c00988f7888413d$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener("prerenderingchange", $0c00988f7888413d$var$onVisibilityUpdate, true);
};
const $0c00988f7888413d$export$443f86b2c77012c4 = ()=>{
    if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document && $0c00988f7888413d$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $0c00988f7888413d$var$initHiddenTime();
        $0c00988f7888413d$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $0c00988f7888413d$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $00c873b87893cf59$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $332244ae619bbcbd$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $332244ae619bbcbd$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $00c873b87893cf59$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $0c00988f7888413d$export$443f86b2c77012c4)();
        const metric = (0, $1e237c6abe8a3e15$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === "first-contentful-paint") {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $6c4ed4d1fd79f8b3$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $e158e103f8722bed$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $2017e28d0c0734bd$export$17679dccdd551979)(onReport, metric, $332244ae619bbcbd$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $ddd96de4f73c216c$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $ddd96de4f73c216c$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $332244ae619bbcbd$export$fe3c86b74e15d5de)((0, $81bb90a8d7895784$export$b841d51e31c12bab)(()=>{
        const metric = (0, $1e237c6abe8a3e15$export$3c29b44508a0612b)("CLS", 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $e158e103f8722bed$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $2017e28d0c0734bd$export$17679dccdd551979)(onReport, metric, $ddd96de4f73c216c$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $5e67043401030991$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $e9fde39a7ac9a670$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $e9fde39a7ac9a670$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $00c873b87893cf59$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $0c00988f7888413d$export$443f86b2c77012c4)();
        const metric = (0, $1e237c6abe8a3e15$export$3c29b44508a0612b)("FID");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $e158e103f8722bed$export$d1203567a167490e)("first-input", handleEntries);
        report = (0, $2017e28d0c0734bd$export$17679dccdd551979)(onReport, metric, $e9fde39a7ac9a670$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $5e67043401030991$export$91ec2be6fdd8f1b4)((0, $81bb90a8d7895784$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};








let $f41134e1c849320f$var$interactionCountEstimate = 0;
let $f41134e1c849320f$var$minKnownInteractionId = Infinity;
let $f41134e1c849320f$var$maxKnownInteractionId = 0;
const $f41134e1c849320f$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $f41134e1c849320f$var$minKnownInteractionId = Math.min($f41134e1c849320f$var$minKnownInteractionId, e.interactionId);
            $f41134e1c849320f$var$maxKnownInteractionId = Math.max($f41134e1c849320f$var$maxKnownInteractionId, e.interactionId);
            $f41134e1c849320f$var$interactionCountEstimate = $f41134e1c849320f$var$maxKnownInteractionId ? ($f41134e1c849320f$var$maxKnownInteractionId - $f41134e1c849320f$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $f41134e1c849320f$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $f41134e1c849320f$export$8a962f2683a476d1 = ()=>{
    return $f41134e1c849320f$var$po ? $f41134e1c849320f$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $f41134e1c849320f$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $f41134e1c849320f$var$po) return;
    $f41134e1c849320f$var$po = (0, $e158e103f8722bed$export$d1203567a167490e)("event", $f41134e1c849320f$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $183656760a72e114$export$7f4cb060ded9173c = [
    200,
    500
];
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
const $183656760a72e114$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $183656760a72e114$var$getInteractionCountForNavigation = ()=>{
    return (0, $f41134e1c849320f$export$8a962f2683a476d1)() - $183656760a72e114$var$prevInteractionCount;
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $183656760a72e114$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $183656760a72e114$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $183656760a72e114$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $183656760a72e114$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $183656760a72e114$var$longestInteractionList[$183656760a72e114$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $183656760a72e114$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $183656760a72e114$var$longestInteractionList.length < $183656760a72e114$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $183656760a72e114$var$longestInteractionMap[interaction.id] = interaction;
            $183656760a72e114$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $183656760a72e114$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $183656760a72e114$var$longestInteractionList.splice($183656760a72e114$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $183656760a72e114$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $183656760a72e114$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($183656760a72e114$var$longestInteractionList.length - 1, Math.floor($183656760a72e114$var$getInteractionCountForNavigation() / 50));
    return $183656760a72e114$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $183656760a72e114$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    (0, $00c873b87893cf59$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $f41134e1c849320f$export$67d90cda6b78a2eb)();
        const metric = (0, $1e237c6abe8a3e15$export$3c29b44508a0612b)("INP");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.interactionId) $183656760a72e114$var$processEntry(entry);
                // Entries of type `first-input` don't currently have an `interactionId`,
                // so to consider them in INP we have to first check that an existing
                // entry doesn't match the `duration` and `startTime`.
                // Note that this logic assumes that `event` entries are dispatched
                // before `first-input` entries. This is true in Chrome (the only browser
                // that currently supports INP).
                // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
                if (entry.entryType === "first-input") {
                    const noMatchingEntry = !$183656760a72e114$var$longestInteractionList.some((interaction)=>{
                        return interaction.entries.some((prevEntry)=>{
                            return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                        });
                    });
                    if (noMatchingEntry) $183656760a72e114$var$processEntry(entry);
                }
            });
            const inp = $183656760a72e114$var$estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = inp.entries;
                report();
            }
        };
        const po = (0, $e158e103f8722bed$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : 40
        });
        report = (0, $2017e28d0c0734bd$export$17679dccdd551979)(onReport, metric, $183656760a72e114$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // If browser supports interactionId (and so supports INP), also
            // observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            if ("PerformanceEventTiming" in (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81) && "interactionId" in PerformanceEventTiming.prototype) po.observe({
                type: "first-input",
                buffered: true
            });
            (0, $5e67043401030991$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                // If the interaction count shows that there were interactions but
                // none were captured by the PerformanceObserver, report a latency of 0.
                if (metric.value < 0 && $183656760a72e114$var$getInteractionCountForNavigation() > 0) {
                    metric.value = 0;
                    metric.entries = [];
                }
                report(true);
            });
        }
    });
};











/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $dd20bdc4ef59acaa$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $dd20bdc4ef59acaa$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $dd20bdc4ef59acaa$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $00c873b87893cf59$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $0c00988f7888413d$export$443f86b2c77012c4)();
        const metric = (0, $1e237c6abe8a3e15$export$3c29b44508a0612b)("LCP");
        let report;
        const handleEntries = (entries)=>{
            const lastEntry = entries[entries.length - 1];
            if (lastEntry) // Only report if the page wasn't hidden prior to LCP.
            {
                if (lastEntry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(lastEntry.startTime - (0, $6c4ed4d1fd79f8b3$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        lastEntry
                    ];
                    report();
                }
            }
        };
        const po = (0, $e158e103f8722bed$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $2017e28d0c0734bd$export$17679dccdd551979)(onReport, metric, $dd20bdc4ef59acaa$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $81bb90a8d7895784$export$b841d51e31c12bab)(()=>{
                if (!$dd20bdc4ef59acaa$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $dd20bdc4ef59acaa$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                "keydown",
                "click"
            ].forEach((type)=>{
                if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document) // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                addEventListener(type, ()=>setTimeout(stopListening, 0), true);
            });
            (0, $5e67043401030991$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $63a06c9bb8defc2e$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $63a06c9bb8defc2e$var$whenReady = (callback)=>{
    if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.prerendering) (0, $00c873b87893cf59$export$8bdb38a5671b594e)(()=>$63a06c9bb8defc2e$var$whenReady(callback));
    else if ((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$63a06c9bb8defc2e$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $63a06c9bb8defc2e$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $1e237c6abe8a3e15$export$3c29b44508a0612b)("TTFB");
    const report = (0, $2017e28d0c0734bd$export$17679dccdd551979)(onReport, metric, $63a06c9bb8defc2e$export$65c59ea8064668fc, opts.reportAllChanges);
    $63a06c9bb8defc2e$var$whenReady(()=>{
        const navEntry = (0, $418b7863084de289$export$6431553786c94949)();
        if (navEntry) {
            const responseStart = navEntry.responseStart;
            // In some cases no value is reported by the browser (for
            // privacy/security reasons), and in other cases (bugs) the value is
            // negative or is larger than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            // https://github.com/GoogleChrome/web-vitals/issues/275
            if (responseStart <= 0 || responseStart > performance.now()) return;
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(responseStart - (0, $6c4ed4d1fd79f8b3$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $3be3f584f987b31e$var$handlers = {};
const $3be3f584f987b31e$var$instrumented = {};
let $3be3f584f987b31e$var$_previousCls;
let $3be3f584f987b31e$var$_previousFid;
let $3be3f584f987b31e$var$_previousLcp;
let $3be3f584f987b31e$var$_previousTtfb;
let $3be3f584f987b31e$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $3be3f584f987b31e$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $3be3f584f987b31e$var$addMetricObserver("cls", callback, $3be3f584f987b31e$var$instrumentCls, $3be3f584f987b31e$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $3be3f584f987b31e$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $3be3f584f987b31e$var$addMetricObserver("lcp", callback, $3be3f584f987b31e$var$instrumentLcp, $3be3f584f987b31e$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $3be3f584f987b31e$export$2707d7471c0b918f(callback) {
    return $3be3f584f987b31e$var$addMetricObserver("fid", callback, $3be3f584f987b31e$var$instrumentFid, $3be3f584f987b31e$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $3be3f584f987b31e$export$699d9529c099a797(callback) {
    return $3be3f584f987b31e$var$addMetricObserver("ttfb", callback, $3be3f584f987b31e$var$instrumentTtfb, $3be3f584f987b31e$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $3be3f584f987b31e$export$da3b76aa2022cbd7(callback) {
    return $3be3f584f987b31e$var$addMetricObserver("inp", callback, $3be3f584f987b31e$var$instrumentInp, $3be3f584f987b31e$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $3be3f584f987b31e$export$69816c1a049f8db6(type, callback) {
    $3be3f584f987b31e$var$addHandler(type, callback);
    if (!$3be3f584f987b31e$var$instrumented[type]) {
        $3be3f584f987b31e$var$instrumentPerformanceObserver(type);
        $3be3f584f987b31e$var$instrumented[type] = true;
    }
    return $3be3f584f987b31e$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $3be3f584f987b31e$var$triggerHandlers(type, data) {
    const typeHandlers = $3be3f584f987b31e$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $213403414f6134bb$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $3be3f584f987b31e$var$instrumentCls() {
    return (0, $ddd96de4f73c216c$export$a7873055838e5ad8)((metric)=>{
        $3be3f584f987b31e$var$triggerHandlers("cls", {
            metric: metric
        });
        $3be3f584f987b31e$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $3be3f584f987b31e$var$instrumentFid() {
    return (0, $e9fde39a7ac9a670$export$39705a25c49af873)((metric)=>{
        $3be3f584f987b31e$var$triggerHandlers("fid", {
            metric: metric
        });
        $3be3f584f987b31e$var$_previousFid = metric;
    });
}
function $3be3f584f987b31e$var$instrumentLcp() {
    return (0, $dd20bdc4ef59acaa$export$947b1626ab8d5632)((metric)=>{
        $3be3f584f987b31e$var$triggerHandlers("lcp", {
            metric: metric
        });
        $3be3f584f987b31e$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $3be3f584f987b31e$var$instrumentTtfb() {
    return (0, $63a06c9bb8defc2e$export$33a01e6c5f2c7e33)((metric)=>{
        $3be3f584f987b31e$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $3be3f584f987b31e$var$_previousTtfb = metric;
    });
}
function $3be3f584f987b31e$var$instrumentInp() {
    return (0, $183656760a72e114$export$7df4b36ecaed99e1)((metric)=>{
        $3be3f584f987b31e$var$triggerHandlers("inp", {
            metric: metric
        });
        $3be3f584f987b31e$var$_previousInp = metric;
    });
}
function $3be3f584f987b31e$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $3be3f584f987b31e$var$addHandler(type, callback);
    let stopListening;
    if (!$3be3f584f987b31e$var$instrumented[type]) {
        stopListening = instrumentFn();
        $3be3f584f987b31e$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $3be3f584f987b31e$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $3be3f584f987b31e$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $e158e103f8722bed$export$d1203567a167490e)(type, (entries)=>{
        $3be3f584f987b31e$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $3be3f584f987b31e$var$addHandler(type, handler) {
    $3be3f584f987b31e$var$handlers[type] = $3be3f584f987b31e$var$handlers[type] || [];
    $3be3f584f987b31e$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $3be3f584f987b31e$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $3be3f584f987b31e$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $3be3f584f987b31e$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}




/**
 * Checks if a given value is a valid measurement value.
 */ function $f04e265a2ca373e3$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $f04e265a2ca373e3$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $5563dd3c937fc83c$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $0e8760fc46e607c6$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $0e8760fc46e607c6$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $f04e265a2ca373e3$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay && replay.getReplayId();
    const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).navigator && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).navigator.userAgent,
        ...passedAttributes
    };
    return (0, $0e8760fc46e607c6$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $f04e265a2ca373e3$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81) && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).addEventListener && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $f04e265a2ca373e3$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}



/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $66a75a2e904e46e3$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$66a75a2e904e46e3$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $66a75a2e904e46e3$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $3be3f584f987b31e$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $5e67043401030991$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
        const unsubscribeStartNavigation = (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
            client,
            "optionalAccess",
            (_)=>_.on,
            "call",
            (_2)=>_2("startNavigationSpan", ()=>{
                    _collectClsOnce();
                    unsubscribeStartNavigation && unsubscribeStartNavigation();
                })
        ]);
        const activeSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(activeSpan);
        const spanJSON = rootSpan && (0, $5563dd3c937fc83c$export$92d8c23565496537)(rootSpan);
        if (spanJSON && spanJSON.op === "pageload") pageloadSpanId = rootSpan.spanContext().spanId;
    }, 0);
}
function $66a75a2e904e46e3$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) || 0) + ((0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
        entry,
        "optionalAccess",
        (_3)=>_3.startTime
    ]) || 0));
    const routeName = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $83913a7139f39e6c$export$5647df6b7814ac86)((0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
        entry,
        "access",
        (_4)=>_4.sources,
        "access",
        (_5)=>_5[0],
        "optionalAccess",
        (_6)=>_6.node
    ])) : "Layout shift";
    const attributes = (0, $212518d61e73b76e$export$d25f2688db1bb433)({
        [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $48bb799067430277$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $48bb799067430277$export$fea48ba9f4550879)]: (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
            entry,
            "optionalAccess",
            (_7)=>_7.duration
        ]) || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId
    });
    const span = (0, $f04e265a2ca373e3$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
        span,
        "optionalAccess",
        (_8)=>_8.addEvent,
        "call",
        (_9)=>_9("cls", {
                [(0, $48bb799067430277$export$f5f95cff026507b5)]: "",
                [(0, $48bb799067430277$export$69cd5c610c7bb96a)]: clsValue
            })
    ]);
    // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
    // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
    (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
        span,
        "optionalAccess",
        (_10)=>_10.end,
        "call",
        (_11)=>_11(startTime)
    ]);
}
function $66a75a2e904e46e3$var$supportsLayoutShift() {
    try {
        return (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
            PerformanceObserver,
            "access",
            (_12)=>_12.supportedEntryTypes,
            "optionalAccess",
            (_13)=>_13.includes,
            "call",
            (_14)=>_14("layout-shift")
        ]);
    } catch (e) {
        return false;
    }
}







/* eslint-disable max-lines */ const $641c33c072e1eb78$var$MAX_INT_AS_BYTES = 2147483647;
let $641c33c072e1eb78$var$_performanceCursor = 0;
let $641c33c072e1eb78$var$_measurements = {};
let $641c33c072e1eb78$var$_lcpEntry;
let $641c33c072e1eb78$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $641c33c072e1eb78$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $f04e265a2ca373e3$export$f72a13c439a30cab)();
    if (performance && (0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCleanupCallback = $641c33c072e1eb78$var$_trackFID();
        const lcpCleanupCallback = $641c33c072e1eb78$var$_trackLCP();
        const ttfbCleanupCallback = $641c33c072e1eb78$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $66a75a2e904e46e3$export$585bab03c6c18c45)() : $641c33c072e1eb78$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback && clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $641c33c072e1eb78$export$f396d19077034ad2() {
    (0, $3be3f584f987b31e$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $f04e265a2ca373e3$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $641c33c072e1eb78$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        if (!(0, $5563dd3c937fc83c$export$1be426a8e585c83e)()) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            const span = (0, $0e8760fc46e607c6$export$63dbba021a6b4047)({
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                startTime: startTime,
                attributes: attributes
            });
            if (span) span.end(startTime + duration);
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $641c33c072e1eb78$export$e27543e0976315e4() {
    (0, $3be3f584f987b31e$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        if (!(0, $5563dd3c937fc83c$export$1be426a8e585c83e)()) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $83913a7139f39e6c$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $83913a7139f39e6c$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            const span = (0, $0e8760fc46e607c6$export$63dbba021a6b4047)(spanOptions);
            if (span) span.end(startTime + duration);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $641c33c072e1eb78$var$_trackCLS() {
    return (0, $3be3f584f987b31e$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`[Measurements] Adding CLS ${metric.value}`);
        $641c33c072e1eb78$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $641c33c072e1eb78$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $641c33c072e1eb78$var$_trackLCP() {
    return (0, $3be3f584f987b31e$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $641c33c072e1eb78$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $641c33c072e1eb78$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $641c33c072e1eb78$var$_trackFID() {
    return (0, $3be3f584f987b31e$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf));
        const startTime = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(entry.startTime);
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $641c33c072e1eb78$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $641c33c072e1eb78$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $641c33c072e1eb78$var$_trackTtfb() {
    return (0, $3be3f584f987b31e$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $641c33c072e1eb78$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
/** Add performance related spans to a transaction */ function $641c33c072e1eb78$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $f04e265a2ca373e3$export$f72a13c439a30cab)();
    if (!performance || !(0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).performance.getEntries || !(0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(span);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($641c33c072e1eb78$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $641c33c072e1eb78$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $641c33c072e1eb78$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $0c00988f7888413d$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $641c33c072e1eb78$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $641c33c072e1eb78$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $641c33c072e1eb78$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $641c33c072e1eb78$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $641c33c072e1eb78$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $641c33c072e1eb78$var$_addTtfbRequestTimeToMeasurements($641c33c072e1eb78$var$_measurements);
        const fidMark = $641c33c072e1eb78$var$_measurements["mark.fid"];
        if (fidMark && $641c33c072e1eb78$var$_measurements["fid"]) {
            // create span for FID
            (0, $f04e265a2ca373e3$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)($641c33c072e1eb78$var$_measurements["fid"].value), {
                name: "first input delay",
                op: "ui.action",
                attributes: {
                    [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $641c33c072e1eb78$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!("fcp" in $641c33c072e1eb78$var$_measurements) || !options.recordClsOnPageloadSpan) delete $641c33c072e1eb78$var$_measurements.cls;
        Object.entries($641c33c072e1eb78$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $94ef37c8285d8bdd$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute("performance.timeOrigin", timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute("performance.activationStart", (0, $6c4ed4d1fd79f8b3$export$d3e828b3c7b5b845)());
        $641c33c072e1eb78$var$_setWebVitalAttributes(span);
    }
    $641c33c072e1eb78$var$_lcpEntry = undefined;
    $641c33c072e1eb78$var$_clsEntry = undefined;
    $641c33c072e1eb78$var$_measurements = {};
}
/** Create measure related spans */ function $641c33c072e1eb78$export$bc93b84e4d45912d(span, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $418b7863084de289$export$6431553786c94949)();
    const requestTime = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    (0, $f04e265a2ca373e3$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $641c33c072e1eb78$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $641c33c072e1eb78$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $641c33c072e1eb78$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $641c33c072e1eb78$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $641c33c072e1eb78$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $641c33c072e1eb78$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $641c33c072e1eb78$var$_addPerformanceNavigationTiming(span, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, name, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $f04e265a2ca373e3$export$7567a67bdb69a23d)(span, timeOrigin + (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name || event}`,
        name: entry.name,
        attributes: {
            [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
        }
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $641c33c072e1eb78$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $f04e265a2ca373e3$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $f04e265a2ca373e3$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
/** Create resource-related spans */ function $641c33c072e1eb78$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $60e4420834845c0c$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    $641c33c072e1eb78$var$setResourceEntrySizeData(attributes, entry, "transferSize", "http.response_transfer_size");
    $641c33c072e1eb78$var$setResourceEntrySizeData(attributes, entry, "encodedBodySize", "http.response_content_length");
    $641c33c072e1eb78$var$setResourceEntrySizeData(attributes, entry, "decodedBodySize", "http.decoded_response_content_length");
    if (entry.deliveryType != null) attributes["http.response_delivery_type"] = entry.deliveryType;
    if ("renderBlockingStatus" in entry) attributes["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $f04e265a2ca373e3$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).location.origin, ""),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $641c33c072e1eb78$var$_trackNavigator(span) {
    const navigator = (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute("effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute("connectionType", connection.type);
        if ((0, $f04e265a2ca373e3$export$27169ccae1b439e3)(connection.rtt)) $641c33c072e1eb78$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $f04e265a2ca373e3$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $f04e265a2ca373e3$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $641c33c072e1eb78$var$_setWebVitalAttributes(span) {
    if ($641c33c072e1eb78$var$_lcpEntry) {
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($641c33c072e1eb78$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $83913a7139f39e6c$export$5647df6b7814ac86)($641c33c072e1eb78$var$_lcpEntry.element));
        if ($641c33c072e1eb78$var$_lcpEntry.id) span.setAttribute("lcp.id", $641c33c072e1eb78$var$_lcpEntry.id);
        if ($641c33c072e1eb78$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute("lcp.url", $641c33c072e1eb78$var$_lcpEntry.url.trim().slice(0, 200));
        span.setAttribute("lcp.size", $641c33c072e1eb78$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($641c33c072e1eb78$var$_clsEntry && $641c33c072e1eb78$var$_clsEntry.sources) {
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $641c33c072e1eb78$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $83913a7139f39e6c$export$5647df6b7814ac86)(source.node)));
    }
}
function $641c33c072e1eb78$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $641c33c072e1eb78$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $641c33c072e1eb78$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $418b7863084de289$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}





const $affa586d541a8a91$var$LAST_INTERACTIONS = [];
const $affa586d541a8a91$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $affa586d541a8a91$export$f17d06681a4744a3() {
    const performance = (0, $f04e265a2ca373e3$export$f72a13c439a30cab)();
    if (performance && (0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf)) {
        const inpCallback = $affa586d541a8a91$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $affa586d541a8a91$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $affa586d541a8a91$var$_trackINP() {
    return (0, $3be3f584f987b31e$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $affa586d541a8a91$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $affa586d541a8a91$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) + entry.startTime);
        const duration = (0, $f04e265a2ca373e3$export$b4785dbd4a81b33f)(metric.value);
        const activeSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
        const rootSpan = activeSpan ? (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $affa586d541a8a91$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $5563dd3c937fc83c$export$92d8c23565496537)(spanToUse).description : (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().getScopeData().transactionName;
        const name = (0, $83913a7139f39e6c$export$5647df6b7814ac86)(entry.target);
        const attributes = (0, $212518d61e73b76e$export$d25f2688db1bb433)({
            [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
            [(0, $48bb799067430277$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
            [(0, $48bb799067430277$export$fea48ba9f4550879)]: entry.duration
        });
        const span = (0, $f04e265a2ca373e3$export$b71b9c7b60c5a4aa)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
            span,
            "optionalAccess",
            (_)=>_.addEvent,
            "call",
            (_2)=>_2("inp", {
                    [(0, $48bb799067430277$export$f5f95cff026507b5)]: "millisecond",
                    [(0, $48bb799067430277$export$69cd5c610c7bb96a)]: metric.value
                })
        ]);
        (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
            span,
            "optionalAccess",
            (_3)=>_3.end,
            "call",
            (_4)=>_4(startTime + duration)
        ]);
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */ function $affa586d541a8a91$export$e4e04d43e223cce2(_latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $3be3f584f987b31e$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($affa586d541a8a91$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($affa586d541a8a91$var$LAST_INTERACTIONS.length > 10) {
                const last = $affa586d541a8a91$var$LAST_INTERACTIONS.shift();
                $affa586d541a8a91$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $affa586d541a8a91$var$LAST_INTERACTIONS.push(interactionId);
            $affa586d541a8a91$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $3be3f584f987b31e$export$69816c1a049f8db6)("event", handleEntries);
    (0, $3be3f584f987b31e$export$69816c1a049f8db6)("first-input", handleEntries);
}




let $1d51464c407068e8$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1d51464c407068e8$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $0e9b073a7b40ae00$export$a4e09611e30da72e)(type, handler);
    (0, $0e9b073a7b40ae00$export$e18d6c5462c01368)(type, $1d51464c407068e8$var$instrumentError);
}
function $1d51464c407068e8$var$instrumentError() {
    $1d51464c407068e8$var$_oldOnErrorHandler = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).onerror;
    (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("error", handlerData);
        if ($1d51464c407068e8$var$_oldOnErrorHandler && !$1d51464c407068e8$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $1d51464c407068e8$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $70a2af0ebada787d$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $70a2af0ebada787d$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $0e9b073a7b40ae00$export$a4e09611e30da72e)(type, handler);
    (0, $0e9b073a7b40ae00$export$e18d6c5462c01368)(type, $70a2af0ebada787d$var$instrumentUnhandledRejection);
}
function $70a2af0ebada787d$var$instrumentUnhandledRejection() {
    $70a2af0ebada787d$var$_oldOnUnhandledRejectionHandler = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($70a2af0ebada787d$var$_oldOnUnhandledRejectionHandler && !$70a2af0ebada787d$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $70a2af0ebada787d$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $53122ce0d21e141d$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $53122ce0d21e141d$export$b0914730ee1f6c80() {
    if ($53122ce0d21e141d$var$errorsInstrumented) return;
    $53122ce0d21e141d$var$errorsInstrumented = true;
    (0, $1d51464c407068e8$export$55b5c3ba2194f0c6)($53122ce0d21e141d$var$errorCallback);
    (0, $70a2af0ebada787d$export$8bf4fc6858821a4e)($53122ce0d21e141d$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $53122ce0d21e141d$var$errorCallback() {
    const activeSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = "internal_error";
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $11c0f0f43ce3ae5b$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$53122ce0d21e141d$var$errorCallback.tag = "sentry_tracingErrorCallback";











const $9436ddc183c850c4$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $9436ddc183c850c4$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $9436ddc183c850c4$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $9436ddc183c850c4$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $9436ddc183c850c4$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $9436ddc183c850c4$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $9436ddc183c850c4$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $9436ddc183c850c4$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $9436ddc183c850c4$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $9436ddc183c850c4$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (!client || !(0, $e666466af6a00254$export$5008da00b1b6dee6)()) return new (0, $18851cea88d51bf5$export$d6636b700b76c516)();
    const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
    const span = $9436ddc183c850c4$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $5563dd3c937fc83c$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $5563dd3c937fc83c$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $5563dd3c937fc83c$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $5563dd3c937fc83c$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $9436ddc183c850c4$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $9436ddc183c850c4$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $1b048be58b6fe914$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $5563dd3c937fc83c$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $48bb799067430277$export$ba73f34502b7a3b3]) span.setAttribute((0, $48bb799067430277$export$ba73f34502b7a3b3), _finishReason);
        (0, $fe5d055940839409$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $5563dd3c937fc83c$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $11c0f0f43ce3ae5b$export$f966a0446ece71e),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $5563dd3c937fc83c$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $1f061359ff69ce32$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $5563dd3c937fc83c$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $5563dd3c937fc83c$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $5563dd3c937fc83c$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $11c0f0f43ce3ae5b$export$f966a0446ece71e),
                message: "deadline_exceeded"
            });
            _finishReason = $9436ddc183c850c4$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $9436ddc183c850c4$var$_startIdleSpan(options) {
    const span = (0, $0e8760fc46e607c6$export$63dbba021a6b4047)(options);
    (0, $1b048be58b6fe914$export$3f25fa50c18e20ca)((0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)(), span);
    (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("[Tracing] Started span is an idle span");
    return span;
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $20f22cfb73fac39b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;











/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $2ad57a53fafc2702$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($2ad57a53fafc2702$var$States || ($2ad57a53fafc2702$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $2ad57a53fafc2702$export$1fda8aa4d135f8aa(value) {
    return new $2ad57a53fafc2702$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $2ad57a53fafc2702$export$78e43115b553f358(reason) {
    return new $2ad57a53fafc2702$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $2ad57a53fafc2702$export$6f292d4960313241 {
    constructor(executor){
        $2ad57a53fafc2702$export$6f292d4960313241.prototype.__init.call(this);
        $2ad57a53fafc2702$export$6f292d4960313241.prototype.__init2.call(this);
        $2ad57a53fafc2702$export$6f292d4960313241.prototype.__init3.call(this);
        $2ad57a53fafc2702$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $2ad57a53fafc2702$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $2ad57a53fafc2702$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $2ad57a53fafc2702$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($2ad57a53fafc2702$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($2ad57a53fafc2702$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $2ad57a53fafc2702$var$States.PENDING) return;
            if ((0, $a0f8d420fbcfb8ea$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $2ad57a53fafc2702$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $2ad57a53fafc2702$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $2ad57a53fafc2702$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $cb03ca38800b9eec$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $2ad57a53fafc2702$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && processor.id && result === null && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $a0f8d420fbcfb8ea$export$f5b060c2914b97c8)(result)) result.then((final)=>$cb03ca38800b9eec$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $cb03ca38800b9eec$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}






/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $af6b6fe5f5f49c2f$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $af6b6fe5f5f49c2f$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $af6b6fe5f5f49c2f$var$applySpanToEvent(event, span);
    $af6b6fe5f5f49c2f$var$applyFingerprintToEvent(event, fingerprint);
    $af6b6fe5f5f49c2f$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $af6b6fe5f5f49c2f$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $af6b6fe5f5f49c2f$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $af6b6fe5f5f49c2f$export$b1a120a2871faa46(data, "extra", extra);
    $af6b6fe5f5f49c2f$export$b1a120a2871faa46(data, "tags", tags);
    $af6b6fe5f5f49c2f$export$b1a120a2871faa46(data, "user", user);
    $af6b6fe5f5f49c2f$export$b1a120a2871faa46(data, "contexts", contexts);
    $af6b6fe5f5f49c2f$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $af6b6fe5f5f49c2f$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $af6b6fe5f5f49c2f$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $212518d61e73b76e$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $212518d61e73b76e$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $212518d61e73b76e$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $212518d61e73b76e$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $af6b6fe5f5f49c2f$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $af6b6fe5f5f49c2f$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $af6b6fe5f5f49c2f$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $5563dd3c937fc83c$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $896c8118669d0430$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $5563dd3c937fc83c$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $af6b6fe5f5f49c2f$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $21925b133330b925$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $9ca12f9fb5d46a07$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $21925b133330b925$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $3bdbd9b2c36d1620$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $9ca12f9fb5d46a07$var$applyClientOptions(prepared, options);
    $9ca12f9fb5d46a07$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $9ca12f9fb5d46a07$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $9ca12f9fb5d46a07$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $21925b133330b925$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $4d085f2ea319a6b5$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $af6b6fe5f5f49c2f$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $af6b6fe5f5f49c2f$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $af6b6fe5f5f49c2f$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $cb03ca38800b9eec$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $9ca12f9fb5d46a07$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $9ca12f9fb5d46a07$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $9ca12f9fb5d46a07$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $3357363524dbf465$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $df92c5c0ba822dfa$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $df92c5c0ba822dfa$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $df92c5c0ba822dfa$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $9ca12f9fb5d46a07$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $9ca12f9fb5d46a07$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $9ca12f9fb5d46a07$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $9ca12f9fb5d46a07$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.entries(debugIdMap).reduce((acc, [debugIdStackTrace, debugIdValue])=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdValue;
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $9ca12f9fb5d46a07$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $9ca12f9fb5d46a07$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $9ca12f9fb5d46a07$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $4c0d7eab065d1a33$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $4c0d7eab065d1a33$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $4c0d7eab065d1a33$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $4c0d7eab065d1a33$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $4c0d7eab065d1a33$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $4c0d7eab065d1a33$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    return normalized;
}
function $9ca12f9fb5d46a07$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $b5fe62d7da05e697$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $9ca12f9fb5d46a07$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($9ca12f9fb5d46a07$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($9ca12f9fb5d46a07$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $9ca12f9fb5d46a07$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $b5fe62d7da05e697$export$775b6bb06e53a214) || typeof hint === "function";
}
const $9ca12f9fb5d46a07$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $9ca12f9fb5d46a07$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$9ca12f9fb5d46a07$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $a2753be55d715def$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    return (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().captureException(exception, (0, $9ca12f9fb5d46a07$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $a2753be55d715def$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $a2753be55d715def$export$1462b974fdcf6ba2(event, hint) {
    return (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a2753be55d715def$export$2f04de43fe27971a(name, context) {
    (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $a2753be55d715def$export$bb4922da0dd51b92(extras) {
    (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $a2753be55d715def$export$8e8e7789d42ed61d(key, extra) {
    (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $a2753be55d715def$export$74a8fb34822092e6(tags) {
    (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $a2753be55d715def$export$a37d07ee78eb4569(key, value) {
    (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $a2753be55d715def$export$8b6bb3dd62a01be2(user) {
    (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $a2753be55d715def$export$5d4e9fd7fac8e617() {
    return (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $a2753be55d715def$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (!client) (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $21925b133330b925$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $a2753be55d715def$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $a2753be55d715def$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $a2753be55d715def$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $4d085f2ea319a6b5$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $a0f8d420fbcfb8ea$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $a2753be55d715def$export$4909b86c8034bf73(timeout) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $a2753be55d715def$export$8360e631d277ea4d(timeout) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $a2753be55d715def$export$3f95c6f800b78024() {
    return !!(0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $a2753be55d715def$export$3b029eb57ac4d562() {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $a2753be55d715def$export$9aac0b9f77928fbf(callback) {
    (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $a2753be55d715def$export$c0d84948cecf78d8(context) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)();
    const currentScope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $3357363524dbf465$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ed585064cddca611$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $ed585064cddca611$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $a2753be55d715def$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $a2753be55d715def$export$17a5be43989a0bc1() {
    const isolationScope = (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)();
    const currentScope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ed585064cddca611$export$56521d9ba90f62ee)(session);
    $a2753be55d715def$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $a2753be55d715def$var$_sendSessionUpdate() {
    const isolationScope = (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)();
    const currentScope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $a2753be55d715def$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $a2753be55d715def$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $a2753be55d715def$var$_sendSessionUpdate();
}



const $3a146b5d1d4aa58b$export$56d8a8a25bd48b81 = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);
let $3a146b5d1d4aa58b$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $3a146b5d1d4aa58b$export$b79738ab10c590b2() {
    return $3a146b5d1d4aa58b$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $3a146b5d1d4aa58b$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $3a146b5d1d4aa58b$var$ignoreOnError++;
    setTimeout(()=>{
        $3a146b5d1d4aa58b$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $3a146b5d1d4aa58b$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $212518d61e73b76e$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            before && typeof before;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$3a146b5d1d4aa58b$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $3a146b5d1d4aa58b$export$1265a142ff5ba165();
            (0, $4d085f2ea319a6b5$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $21925b133330b925$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $21925b133330b925$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $a2753be55d715def$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $212518d61e73b76e$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $212518d61e73b76e$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}






/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $cd73b0315856daa4$export$6f18f55521af71a1() {
    if ((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81) && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document) (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(rootSpan);
            if (0, $20f22cfb73fac39b$export$16a28057038b10ef) (0, $fe5d055940839409$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $11c0f0f43ce3ae5b$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $211d7e01eb8e4d9d$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $211d7e01eb8e4d9d$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $0e9b073a7b40ae00$export$a4e09611e30da72e)(type, handler);
    (0, $0e9b073a7b40ae00$export$e18d6c5462c01368)(type, $211d7e01eb8e4d9d$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $211d7e01eb8e4d9d$export$c67d533bf77cbf54() {
    if (!(0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const startTimestamp = (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $211d7e01eb8e4d9d$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$211d7e01eb8e4d9d$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$211d7e01eb8e4d9d$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg
                    };
                    (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$211d7e01eb8e4d9d$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(header) && (0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$211d7e01eb8e4d9d$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $211d7e01eb8e4d9d$var$parseUrl(url) {
    if ((0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}













/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $bdc50e01698c977c$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $e666466af6a00254$export$5008da00b1b6dee6)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $bdc50e01698c977c$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $bdc50e01698c977c$var$getFullURL(url);
    const host = fullUrl ? (0, $60e4420834845c0c$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $0e8760fc46e607c6$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $48bb799067430277$export$cca8dd30f57f805e)]: spanOrigin,
            [(0, $48bb799067430277$export$1a413bd9a88fdb09)]: "http.client"
        }
    }) : new (0, $18851cea88d51bf5$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        options.headers = $bdc50e01698c977c$export$6717acf674206871(request, client, scope, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $e666466af6a00254$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $bdc50e01698c977c$export$6717acf674206871(request, client, scope, fetchOptionsObj, span) {
    const isolationScope = (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $5563dd3c937fc83c$export$7e9f8ae9e4a328ab)(span) : (0, $270472853a09b5e1$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $6c99372f7423d531$export$56766feef403f365)(dsc || (span ? (0, $896c8118669d0430$export$a117f995597e25df)(span) : (0, $896c8118669d0430$export$366bad00d6815eed)(traceId, client)));
    const headers = fetchOptionsObj.headers || (typeof Request !== "undefined" && (0, $a0f8d420fbcfb8ea$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $a0f8d420fbcfb8ea$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.set("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) {
            const prevBaggageHeader = newHeaders.get((0, $6c99372f7423d531$export$9ca9946bd449ac06));
            if (prevBaggageHeader) {
                const prevHeaderStrippedFromSentryBaggage = $bdc50e01698c977c$var$stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
                newHeaders.set((0, $6c99372f7423d531$export$9ca9946bd449ac06), // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
                // otherwise just set the sentry baggage header
                prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${sentryBaggageHeader}` : sentryBaggageHeader);
            } else newHeaders.set((0, $6c99372f7423d531$export$9ca9946bd449ac06), sentryBaggageHeader);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers// Remove any existing sentry-trace headers
            .filter((header)=>{
                return !(Array.isArray(header) && header[0] === "sentry-trace");
            })// Get rid of previous sentry baggage values in baggage header
            .map((header)=>{
                if (Array.isArray(header) && header[0] === (0, $6c99372f7423d531$export$9ca9946bd449ac06) && typeof header[1] === "string") {
                    const [headerName, headerValue, ...rest] = header;
                    return [
                        headerName,
                        $bdc50e01698c977c$var$stripBaggageHeaderOfSentryBaggageValues(headerValue),
                        ...rest
                    ];
                } else return header;
            }),
            // Attach the new sentry-trace header
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $6c99372f7423d531$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        let newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders = existingBaggageHeader.map((headerItem)=>typeof headerItem === "string" ? $bdc50e01698c977c$var$stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter((headerItem)=>headerItem === "");
        else if (existingBaggageHeader) newBaggageHeaders.push($bdc50e01698c977c$var$stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $bdc50e01698c977c$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $bdc50e01698c977c$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $11c0f0f43ce3ae5b$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $11c0f0f43ce3ae5b$export$f966a0446ece71e),
        message: "internal_error"
    });
    span.end();
}
function $bdc50e01698c977c$var$stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(",")// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .filter((baggageEntry)=>!baggageEntry.split("=")[0].startsWith((0, $6c99372f7423d531$export$6e69537d67fa20f))).join(",");
}







const $3919554e69c23272$var$WINDOW = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $3919554e69c23272$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $3919554e69c23272$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $3919554e69c23272$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $3919554e69c23272$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $3919554e69c23272$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3919554e69c23272$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $3919554e69c23272$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$3919554e69c23272$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($3919554e69c23272$export$d5f608b368e73f38($3919554e69c23272$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $3919554e69c23272$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $3919554e69c23272$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $1d6308828ef11f3e$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $3919554e69c23272$export$531055a6c684a70a() {
    return "ReportingObserver" in $3919554e69c23272$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $3919554e69c23272$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$3919554e69c23272$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5b3c72fa4b924ba6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $0e9b073a7b40ae00$export$a4e09611e30da72e)(type, handler);
    (0, $0e9b073a7b40ae00$export$e18d6c5462c01368)(type, ()=>$5b3c72fa4b924ba6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $5b3c72fa4b924ba6$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $0e9b073a7b40ae00$export$a4e09611e30da72e)(type, handler);
    (0, $0e9b073a7b40ae00$export$e18d6c5462c01368)(type, ()=>$5b3c72fa4b924ba6$var$instrumentFetch($5b3c72fa4b924ba6$var$streamHandler));
}
function $5b3c72fa4b924ba6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $3919554e69c23272$export$c82d238e23c40b21)()) return;
    (0, $212518d61e73b76e$export$9563e054e6f787fb)((0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $5b3c72fa4b924ba6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)() * 1000
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // We capture the stack right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualStackTrace = new Error().stack;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $a0f8d420fbcfb8ea$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualStackTrace;
                    (0, $212518d61e73b76e$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $5b3c72fa4b924ba6$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $5b3c72fa4b924ba6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $5b3c72fa4b924ba6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $3bdbd9b2c36d1620$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $5b3c72fa4b924ba6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $5b3c72fa4b924ba6$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($5b3c72fa4b924ba6$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $5b3c72fa4b924ba6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $5b3c72fa4b924ba6$var$getUrlFromResource(url),
            method: $5b3c72fa4b924ba6$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $5b3c72fa4b924ba6$var$getUrlFromResource(arg),
        method: $5b3c72fa4b924ba6$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}



/* eslint-disable max-lines */ /** Options for Request Instrumentation */ const $fbbe13993055518b$var$responseToSpanId = new WeakMap();
const $fbbe13993055518b$var$spanIdToEndTimestamp = new Map();
const $fbbe13993055518b$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $fbbe13993055518b$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = {
        traceFetch: $fbbe13993055518b$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $fbbe13993055518b$export$cc17fb3c0bc95cd7.traceXHR,
        trackFetchStreamPerformance: $fbbe13993055518b$export$cc17fb3c0bc95cd7.trackFetchStreamPerformance,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$fbbe13993055518b$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === "transaction" && event.spans) event.spans.forEach((span)=>{
                if (span.op === "http.client") {
                    const updatedTimestamp = $fbbe13993055518b$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $fbbe13993055518b$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $5b3c72fa4b924ba6$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $fbbe13993055518b$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $fbbe13993055518b$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $5b3c72fa4b924ba6$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $bdc50e01698c977c$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $fbbe13993055518b$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $fbbe13993055518b$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $60e4420834845c0c$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
            }
            if (enableHTTPTimings && createdSpan) $fbbe13993055518b$var$addHTTPTimings(createdSpan);
        });
    }
    if (traceXHR) (0, $211d7e01eb8e4d9d$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $fbbe13993055518b$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $fbbe13993055518b$var$addHTTPTimings(createdSpan);
    });
}
function $fbbe13993055518b$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $fbbe13993055518b$var$addHTTPTimings(span) {
    const { url: url } = (0, $5563dd3c937fc83c$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $3be3f584f987b31e$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($fbbe13993055518b$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $fbbe13993055518b$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $fbbe13993055518b$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $fbbe13993055518b$var$getAbsoluteTime(time = 0) {
    return (((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $fbbe13993055518b$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $fbbe13993055518b$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $fbbe13993055518b$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $fbbe13993055518b$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $df92c5c0ba822dfa$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $df92c5c0ba822dfa$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $df92c5c0ba822dfa$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $fbbe13993055518b$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $211d7e01eb8e4d9d$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $e666466af6a00254$export$5008da00b1b6dee6)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $11c0f0f43ce3ae5b$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $fbbe13993055518b$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $60e4420834845c0c$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $0e8760fc46e607c6$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.http.browser",
            [(0, $48bb799067430277$export$1a413bd9a88fdb09)]: "http.client"
        }
    }) : new (0, $18851cea88d51bf5$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) $fbbe13993055518b$var$addTracingHeadersToXhrRequest(xhr, client, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $e666466af6a00254$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    return span;
}
function $fbbe13993055518b$var$addTracingHeadersToXhrRequest(xhr, client, span) {
    const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const isolationScope = (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span && (0, $e666466af6a00254$export$5008da00b1b6dee6)() ? (0, $5563dd3c937fc83c$export$7e9f8ae9e4a328ab)(span) : (0, $270472853a09b5e1$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $6c99372f7423d531$export$56766feef403f365)(dsc || (span ? (0, $896c8118669d0430$export$a117f995597e25df)(span) : (0, $896c8118669d0430$export$366bad00d6815eed)(traceId, client)));
    $fbbe13993055518b$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
}
function $fbbe13993055518b$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $6c99372f7423d531$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $fbbe13993055518b$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}


/* eslint-disable max-lines */ const $02a23b0f4e66f6c2$export$bbd2089f30bd3708 = "BrowserTracing";
const $02a23b0f4e66f6c2$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $9436ddc183c850c4$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    _experiments: {},
    ...(0, $fbbe13993055518b$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $02a23b0f4e66f6c2$export$b4109253475213e9 = (_options = {})=>{
    (0, $53122ce0d21e141d$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = {
        ...$02a23b0f4e66f6c2$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $641c33c072e1eb78$export$7c69f0412d101b88)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $affa586d541a8a91$export$f17d06681a4744a3)();
    if (enableLongAnimationFrame && (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame")) (0, $641c33c072e1eb78$export$5b823ab2ccbc801d)();
    else if (enableLongTask) (0, $641c33c072e1eb78$export$f396d19077034ad2)();
    if (enableInteractions) (0, $641c33c072e1eb78$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === "pageload";
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $48bb799067430277$export$d7a7d984b0791405] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $48bb799067430277$export$d7a7d984b0791405];
        const idleSpan = (0, $9436ddc183c850c4$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $641c33c072e1eb78$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
            }
        });
        function emitFinish() {
            if ([
                "interactive",
                "complete"
            ].includes((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.readyState)) client.emit("idleSpanEnableAutoFinish", idleSpan);
        }
        if (isPageloadTransaction && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document) {
            (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $02a23b0f4e66f6c2$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location.href;
            client.on("startNavigationSpan", (startSpanOptions)=>{
                if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client) return;
                if (activeSpan && !(0, $5563dd3c937fc83c$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`[Tracing] Finishing current root span with op: ${(0, $5563dd3c937fc83c$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeSpan.end();
                }
                activeSpan = _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions
                });
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client) return;
                if (activeSpan && !(0, $5563dd3c937fc83c$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`[Tracing] Finishing current root span with op: ${(0, $5563dd3c937fc83c$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeSpan.end();
                }
                const sentryTrace = traceOptions.sentryTrace || $02a23b0f4e66f6c2$export$f147b32b03c9cf11("sentry-trace");
                const baggage = traceOptions.baggage || $02a23b0f4e66f6c2$export$f147b32b03c9cf11("baggage");
                const propagationContext = (0, $270472853a09b5e1$export$261f383d16a93e39)(sentryTrace, baggage);
                (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on("spanEnd", (span)=>{
                const op = (0, $5563dd3c937fc83c$export$92d8c23565496537)(span).op;
                if (span !== (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(span) || op !== "navigation" && op !== "pageload") return;
                const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $5563dd3c937fc83c$export$5caecac1caaf3a71)(span),
                    dsc: oldPropagationContext.dsc || (0, $896c8118669d0430$export$a117f995597e25df)(span)
                });
            });
            if ((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) $02a23b0f4e66f6c2$export$aa44a07f82af519f(client, {
                    name: (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) ? (0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) / 1000 : undefined,
                    attributes: {
                        [(0, $48bb799067430277$export$d7a7d984b0791405)]: "url",
                        [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.pageload.browser"
                    }
                });
                if (instrumentNavigation) (0, $9c43746b6e1807b7$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $02a23b0f4e66f6c2$export$7d159749bd9969ad(client, {
                            name: (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $48bb799067430277$export$d7a7d984b0791405)]: "url",
                                [(0, $48bb799067430277$export$cca8dd30f57f805e)]: "auto.navigation.browser"
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $cd73b0315856daa4$export$6f18f55521af71a1)();
            if (enableInteractions) $02a23b0f4e66f6c2$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $affa586d541a8a91$export$e4e04d43e223cce2)();
            (0, $fbbe13993055518b$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $02a23b0f4e66f6c2$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
    const op = span && (0, $5563dd3c937fc83c$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $02a23b0f4e66f6c2$export$7d159749bd9969ad(client, spanOptions) {
    (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)().setPropagationContext((0, $69deb073f948d319$export$37f0f2f9cf343e5e)());
    (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().setPropagationContext((0, $69deb073f948d319$export$37f0f2f9cf343e5e)());
    client.emit("startNavigationSpan", spanOptions);
    (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
    const op = span && (0, $5563dd3c937fc83c$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $02a23b0f4e66f6c2$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $83913a7139f39e6c$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $02a23b0f4e66f6c2$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $5563dd3c937fc83c$export$92d8c23565496537)(rootSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $48bb799067430277$export$ba73f34502b7a3b3), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $9436ddc183c850c4$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $48bb799067430277$export$d7a7d984b0791405)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document) addEventListener("click", registerInteractionTransaction, {
        once: false,
        capture: true
    });
}





const $1065ef619eb4d8b2$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $1065ef619eb4d8b2$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $1065ef619eb4d8b2$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $21925b133330b925$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $1065ef619eb4d8b2$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === "Debug");
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $1065ef619eb4d8b2$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $1065ef619eb4d8b2$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $1065ef619eb4d8b2$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $1065ef619eb4d8b2$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($1065ef619eb4d8b2$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $1065ef619eb4d8b2$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $1065ef619eb4d8b2$export$2d8f5188773bcddd(integration) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $1065ef619eb4d8b2$export$2323046b9414659f(fn) {
    return fn;
}



const $35ed3088982fe990$var$INTEGRATION_NAME = "Dedupe";
const $35ed3088982fe990$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $35ed3088982fe990$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($35ed3088982fe990$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $35ed3088982fe990$export$6d39aa44cd0c7567 = (0, $1065ef619eb4d8b2$export$2323046b9414659f)($35ed3088982fe990$var$_dedupeIntegration);
/** only exported for tests. */ function $35ed3088982fe990$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($35ed3088982fe990$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($35ed3088982fe990$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $35ed3088982fe990$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$35ed3088982fe990$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$35ed3088982fe990$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $35ed3088982fe990$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $35ed3088982fe990$var$_getExceptionFromEvent(previousEvent);
    const currentException = $35ed3088982fe990$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$35ed3088982fe990$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$35ed3088982fe990$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $35ed3088982fe990$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $213403414f6134bb$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $213403414f6134bb$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $35ed3088982fe990$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $35ed3088982fe990$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $ad9af4a6a9d5ba43$var$originalFunctionToString;
const $ad9af4a6a9d5ba43$var$INTEGRATION_NAME = "FunctionToString";
const $ad9af4a6a9d5ba43$var$SETUP_CLIENTS = new WeakMap();
const $ad9af4a6a9d5ba43$var$_functionToStringIntegration = ()=>{
    return {
        name: $ad9af4a6a9d5ba43$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $ad9af4a6a9d5ba43$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $212518d61e73b76e$export$e6cc1e135e2092e5)(this);
                    const context = $ad9af4a6a9d5ba43$var$SETUP_CLIENTS.has((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $ad9af4a6a9d5ba43$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $ad9af4a6a9d5ba43$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $ad9af4a6a9d5ba43$export$7918117e9202e4fb = (0, $1065ef619eb4d8b2$export$2323046b9414659f)($ad9af4a6a9d5ba43$var$_functionToStringIntegration);


const $07177d5aa53b2153$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $07177d5aa53b2153$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $07177d5aa53b2153$var$_getIngestEndpoint(dsn) {
    return `${$07177d5aa53b2153$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $07177d5aa53b2153$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $212518d61e73b76e$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $07177d5aa53b2153$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $07177d5aa53b2153$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$07177d5aa53b2153$var$_getIngestEndpoint(dsn)}?${$07177d5aa53b2153$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $07177d5aa53b2153$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $1eb6493fa38ceb83$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$07177d5aa53b2153$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $1eb6493fa38ceb83$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $fd35d1d4f0accf5c$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler"
];
/** Options for the InboundFilters integration */ const $fd35d1d4f0accf5c$var$INTEGRATION_NAME = "InboundFilters";
const $fd35d1d4f0accf5c$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $fd35d1d4f0accf5c$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $fd35d1d4f0accf5c$var$_mergeOptions(options, clientOptions);
            return $fd35d1d4f0accf5c$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $fd35d1d4f0accf5c$export$cb3c5c2ceb9818ba = (0, $1065ef619eb4d8b2$export$2323046b9414659f)($fd35d1d4f0accf5c$var$_inboundFiltersIntegration);
function $fd35d1d4f0accf5c$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $fd35d1d4f0accf5c$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $fd35d1d4f0accf5c$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $fd35d1d4f0accf5c$var$_isSentryError(event)) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $21925b133330b925$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($fd35d1d4f0accf5c$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $21925b133330b925$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($fd35d1d4f0accf5c$var$_isUselessError(event)) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $21925b133330b925$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($fd35d1d4f0accf5c$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $21925b133330b925$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($fd35d1d4f0accf5c$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $21925b133330b925$export$4157119e2b157127)(event)}.\nUrl: ${$fd35d1d4f0accf5c$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$fd35d1d4f0accf5c$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $21925b133330b925$export$4157119e2b157127)(event)}.\nUrl: ${$fd35d1d4f0accf5c$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $fd35d1d4f0accf5c$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $fd35d1d4f0accf5c$var$_getPossibleEventMessages(event).some((message)=>(0, $df92c5c0ba822dfa$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $fd35d1d4f0accf5c$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $df92c5c0ba822dfa$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $fd35d1d4f0accf5c$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $fd35d1d4f0accf5c$var$_getEventFilterUrl(event);
    return !url ? false : (0, $df92c5c0ba822dfa$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $fd35d1d4f0accf5c$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $fd35d1d4f0accf5c$var$_getEventFilterUrl(event);
    return !url ? true : (0, $df92c5c0ba822dfa$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $fd35d1d4f0accf5c$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $fd35d1d4f0accf5c$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $fd35d1d4f0accf5c$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $fd35d1d4f0accf5c$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $fd35d1d4f0accf5c$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $21925b133330b925$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $fd35d1d4f0accf5c$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $819d3ec67d14c696$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $1f061359ff69ce32$export$16a28057038b10ef) (0, $fe5d055940839409$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $fe5d055940839409$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $819d3ec67d14c696$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $819d3ec67d14c696$export$ecb76f41d43c0e43(client) {
    (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().setClient(client);
}





/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $35a843654fd66131$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $f62a014aa4ae8b60$export$31499a9cd224b78c)
            })),
        version: (0, $f62a014aa4ae8b60$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $f6e85e9d5163c1de$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $3bdbd9b2c36d1620$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $ac9400386ed4faec$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/** An error emitted by Sentry SDKs and related utilities. */ class $f3b7634e91d86a76$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}











const $801dc39b3dacd560$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $801dc39b3dacd560$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $1eb6493fa38ceb83$export$128827c3562ec0cb)(options.dsn);
        else (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $07177d5aa53b2153$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    captureException(exception, hint, scope) {
        const eventId = (0, $21925b133330b925$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $21925b133330b925$export$6de4ffac6a2f1098)(exception)) {
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log($801dc39b3dacd560$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $21925b133330b925$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $a0f8d420fbcfb8ea$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $a0f8d420fbcfb8ea$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $21925b133330b925$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $21925b133330b925$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log($801dc39b3dacd560$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $ed585064cddca611$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $1065ef619eb4d8b2$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $1065ef619eb4d8b2$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $98aedf1efd71f255$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $ac9400386ed4faec$export$d650323442802f6f)(env, (0, $ac9400386ed4faec$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $98aedf1efd71f255$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error("Error while sending envelope:", reason);
            return reason;
        });
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error("Transport disabled");
        return (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $1065ef619eb4d8b2$export$51abed9797baa598)(this, integrations);
        (0, $1065ef619eb4d8b2$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ed585064cddca611$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $2ad57a53fafc2702$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope = (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $9ca12f9fb5d46a07$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...currentScope ? currentScope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: (0, $212518d61e73b76e$export$d25f2688db1bb433)({
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    }),
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $896c8118669d0430$export$366bad00d6815eed)(trace_id, this);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $1f061359ff69ce32$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $fe5d055940839409$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $fe5d055940839409$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $801dc39b3dacd560$var$isTransactionEvent(event);
        const isError = $801dc39b3dacd560$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $aa7e579fce63739a$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $2ad57a53fafc2702$export$78e43115b553f358)(new (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $801dc39b3dacd560$var$processBeforeSend(this, options, prepared, hint);
            return $801dc39b3dacd560$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $f6e85e9d5163c1de$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $1eb6493fa38ceb83$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $801dc39b3dacd560$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $a0f8d420fbcfb8ea$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $a0f8d420fbcfb8ea$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $a0f8d420fbcfb8ea$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $801dc39b3dacd560$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($801dc39b3dacd560$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($801dc39b3dacd560$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else client.recordDroppedEvent("before_send", "span");
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $801dc39b3dacd560$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $801dc39b3dacd560$var$isTransactionEvent(event) {
    return event.type === "transaction";
}



var $4lXeK = parcelRequire("4lXeK");



/**
 * This function creates an exception from a JavaScript Error
 */ function $39cacec81320cdc8$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $39cacec81320cdc8$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $39cacec81320cdc8$export$2e9ae379995d99e3(ex),
        value: $39cacec81320cdc8$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $39cacec81320cdc8$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $39cacec81320cdc8$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $4c0d7eab065d1a33$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $39cacec81320cdc8$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $a0f8d420fbcfb8ea$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $39cacec81320cdc8$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $39cacec81320cdc8$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $39cacec81320cdc8$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $39cacec81320cdc8$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $39cacec81320cdc8$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $39cacec81320cdc8$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $39cacec81320cdc8$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $39cacec81320cdc8$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $39cacec81320cdc8$var$getSkipFirstStackStringLines(ex) {
    if (ex && $39cacec81320cdc8$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $39cacec81320cdc8$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $39cacec81320cdc8$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $39cacec81320cdc8$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $39cacec81320cdc8$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $39cacec81320cdc8$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($39cacec81320cdc8$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $39cacec81320cdc8$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $39cacec81320cdc8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $21925b133330b925$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $39cacec81320cdc8$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $39cacec81320cdc8$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $39cacec81320cdc8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $a0f8d420fbcfb8ea$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $39cacec81320cdc8$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $a0f8d420fbcfb8ea$export$ef9e2056653f0c8e)(exception) || (0, $a0f8d420fbcfb8ea$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $39cacec81320cdc8$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $a0f8d420fbcfb8ea$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $39cacec81320cdc8$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $21925b133330b925$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $a0f8d420fbcfb8ea$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $39cacec81320cdc8$var$eventFromError(stackParser, exception);
    if ((0, $a0f8d420fbcfb8ea$export$53b83ca8eaab0383)(exception) || (0, $a0f8d420fbcfb8ea$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $39cacec81320cdc8$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $21925b133330b925$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $39cacec81320cdc8$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $21925b133330b925$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $21925b133330b925$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $39cacec81320cdc8$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $39cacec81320cdc8$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $a0f8d420fbcfb8ea$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $39cacec81320cdc8$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $212518d61e73b76e$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $a0f8d420fbcfb8ea$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $a0f8d420fbcfb8ea$export$9671ea99bd126ace)(exception)) {
        const className = $39cacec81320cdc8$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $39cacec81320cdc8$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $39cacec81320cdc8$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}




/**
 * Creates an envelope from a user feedback.
 */ function $e9d7436d7dccee6b$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $1eb6493fa38ceb83$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $e9d7436d7dccee6b$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $ac9400386ed4faec$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $e9d7436d7dccee6b$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $6da7331a221e1c79$export$1df9218a526d318d extends (0, $801dc39b3dacd560$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $4lXeK.getSDKSource)();
        (0, $35a843654fd66131$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document) (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $39cacec81320cdc8$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $39cacec81320cdc8$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $e9d7436d7dccee6b$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
}






const $da61a269929582d0$var$DEBOUNCE_DURATION = 1000;
let $da61a269929582d0$var$debounceTimerID;
let $da61a269929582d0$var$lastCapturedEventType;
let $da61a269929582d0$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da61a269929582d0$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $0e9b073a7b40ae00$export$a4e09611e30da72e)(type, handler);
    (0, $0e9b073a7b40ae00$export$e18d6c5462c01368)(type, $da61a269929582d0$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $da61a269929582d0$export$3014bbf0af0e1d4a() {
    if (!(0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $0e9b073a7b40ae00$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $da61a269929582d0$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const proto = (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81)[target] && (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81)[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $212518d61e73b76e$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $da61a269929582d0$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $212518d61e73b76e$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $da61a269929582d0$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $da61a269929582d0$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $da61a269929582d0$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $da61a269929582d0$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $da61a269929582d0$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $da61a269929582d0$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($da61a269929582d0$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $212518d61e73b76e$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $212518d61e73b76e$export$e73679ffaf56810e)(target, "_sentryId", (0, $21925b133330b925$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$da61a269929582d0$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $da61a269929582d0$var$lastCapturedEventType = event.type;
            $da61a269929582d0$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($da61a269929582d0$var$debounceTimerID);
        $da61a269929582d0$var$debounceTimerID = (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).setTimeout(()=>{
            $da61a269929582d0$var$lastCapturedEventTargetId = undefined;
            $da61a269929582d0$var$lastCapturedEventType = undefined;
        }, $da61a269929582d0$var$DEBOUNCE_DURATION);
    };
}
function $da61a269929582d0$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}




/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $f322f13cecbd05ef$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $f322f13cecbd05ef$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $f322f13cecbd05ef$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $3bdbd9b2c36d1620$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $fe5d055940839409$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}






/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c1025b223db87b98$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $0e9b073a7b40ae00$export$a4e09611e30da72e)(type, handler);
    (0, $0e9b073a7b40ae00$export$e18d6c5462c01368)(type, $c1025b223db87b98$var$instrumentConsole);
}
function $c1025b223db87b98$var$instrumentConsole() {
    if (!("console" in (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1))) return;
    (0, $fe5d055940839409$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).console)) return;
        (0, $212518d61e73b76e$export$9563e054e6f787fb)((0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $fe5d055940839409$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $0e9b073a7b40ae00$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $fe5d055940839409$export$77c4ce905194557b)[level];
                log && log.apply((0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $29e2ac77ef241fe3$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $9cabd38b2efbc941$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $9cabd38b2efbc941$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $9cabd38b2efbc941$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $c3bd537fcd6961fc$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $c3bd537fcd6961fc$var$INTEGRATION_NAME = "Breadcrumbs";
const $c3bd537fcd6961fc$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $c3bd537fcd6961fc$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $c1025b223db87b98$export$1d6e0d073f9e6723)($c3bd537fcd6961fc$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $da61a269929582d0$export$5aeffd3db2cf9df7)($c3bd537fcd6961fc$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $211d7e01eb8e4d9d$export$26ace48dd54c9aea)($c3bd537fcd6961fc$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $5b3c72fa4b924ba6$export$f75d3c772c923df0)($c3bd537fcd6961fc$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $9c43746b6e1807b7$export$3f18c56c58114e75)($c3bd537fcd6961fc$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $c3bd537fcd6961fc$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $c3bd537fcd6961fc$export$c079d904b326663a = (0, $1065ef619eb4d8b2$export$2323046b9414659f)($c3bd537fcd6961fc$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $c3bd537fcd6961fc$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client) return;
        (0, $f322f13cecbd05ef$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $21925b133330b925$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $c3bd537fcd6961fc$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $c3bd537fcd6961fc$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$c3bd537fcd6961fc$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$c3bd537fcd6961fc$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $c3bd537fcd6961fc$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $c3bd537fcd6961fc$var$_isEvent(event) ? event.target : event;
            target = (0, $83913a7139f39e6c$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $83913a7139f39e6c$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $f322f13cecbd05ef$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $c3bd537fcd6961fc$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $9cabd38b2efbc941$export$d771ef054122c30a)(handlerData.level),
            message: (0, $df92c5c0ba822dfa$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $df92c5c0ba822dfa$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $f322f13cecbd05ef$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $c3bd537fcd6961fc$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $211d7e01eb8e4d9d$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $29e2ac77ef241fe3$export$b8cfcc4175694bcc)(status_code);
        (0, $f322f13cecbd05ef$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http",
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $c3bd537fcd6961fc$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $f322f13cecbd05ef$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $29e2ac77ef241fe3$export$b8cfcc4175694bcc)(data.status_code);
            (0, $f322f13cecbd05ef$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http",
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $c3bd537fcd6961fc$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $60e4420834845c0c$export$7a5253c0f62e0150)((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $60e4420834845c0c$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $60e4420834845c0c$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $f322f13cecbd05ef$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $c3bd537fcd6961fc$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $8d5316fa2896b747$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $8d5316fa2896b747$var$INTEGRATION_NAME = "BrowserApiErrors";
const $8d5316fa2896b747$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $8d5316fa2896b747$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $212518d61e73b76e$export$9563e054e6f787fb)((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81), "setTimeout", $8d5316fa2896b747$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $212518d61e73b76e$export$9563e054e6f787fb)((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81), "setInterval", $8d5316fa2896b747$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $212518d61e73b76e$export$9563e054e6f787fb)((0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81), "requestAnimationFrame", $8d5316fa2896b747$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81)) (0, $212518d61e73b76e$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $8d5316fa2896b747$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $8d5316fa2896b747$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($8d5316fa2896b747$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $8d5316fa2896b747$export$59bfe9f1c76150e = (0, $1065ef619eb4d8b2$export$2323046b9414659f)($8d5316fa2896b747$var$_browserApiErrorsIntegration);
function $8d5316fa2896b747$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $3a146b5d1d4aa58b$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $213403414f6134bb$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8d5316fa2896b747$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $3a146b5d1d4aa58b$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $213403414f6134bb$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $8d5316fa2896b747$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $212518d61e73b76e$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $213403414f6134bb$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $212518d61e73b76e$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $213403414f6134bb$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $3a146b5d1d4aa58b$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $8d5316fa2896b747$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $212518d61e73b76e$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $3a146b5d1d4aa58b$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $213403414f6134bb$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $3a146b5d1d4aa58b$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $213403414f6134bb$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $212518d61e73b76e$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}







const $f96bbe9fb5ba72fb$var$INTEGRATION_NAME = "GlobalHandlers";
const $f96bbe9fb5ba72fb$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $f96bbe9fb5ba72fb$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $f96bbe9fb5ba72fb$var$_installGlobalOnErrorHandler(client);
                $f96bbe9fb5ba72fb$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $f96bbe9fb5ba72fb$var$_installGlobalOnUnhandledRejectionHandler(client);
                $f96bbe9fb5ba72fb$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $f96bbe9fb5ba72fb$export$66acc70e8cf2b71a = (0, $1065ef619eb4d8b2$export$2323046b9414659f)($f96bbe9fb5ba72fb$var$_globalHandlersIntegration);
function $f96bbe9fb5ba72fb$var$_installGlobalOnErrorHandler(client) {
    (0, $1d51464c407068e8$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $f96bbe9fb5ba72fb$var$getOptions();
        if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client || (0, $3a146b5d1d4aa58b$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $f96bbe9fb5ba72fb$var$_enhanceEventWithInitialFrame((0, $39cacec81320cdc8$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $a2753be55d715def$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $f96bbe9fb5ba72fb$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $70a2af0ebada787d$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $f96bbe9fb5ba72fb$var$getOptions();
        if ((0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)() !== client || (0, $3a146b5d1d4aa58b$export$b79738ab10c590b2)()) return;
        const error = $f96bbe9fb5ba72fb$var$_getUnhandledRejectionError(e);
        const event = (0, $a0f8d420fbcfb8ea$export$c3825b437cbdea5c)(error) ? $f96bbe9fb5ba72fb$var$_eventFromRejectionWithPrimitive(error) : (0, $39cacec81320cdc8$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $a2753be55d715def$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $f96bbe9fb5ba72fb$var$_getUnhandledRejectionError(error) {
    if ((0, $a0f8d420fbcfb8ea$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $f96bbe9fb5ba72fb$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f96bbe9fb5ba72fb$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $a0f8d420fbcfb8ea$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $83913a7139f39e6c$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $213403414f6134bb$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $f96bbe9fb5ba72fb$var$globalHandlerLog(type) {
    (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $f96bbe9fb5ba72fb$var$getOptions() {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $db287acf42e5ea17$export$1378794447170364 = (0, $1065ef619eb4d8b2$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).navigator && !(0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location && !(0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $ca930ba32a341e1e$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $a0f8d420fbcfb8ea$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $ca930ba32a341e1e$var$truncateAggregateExceptions($ca930ba32a341e1e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $ca930ba32a341e1e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $a0f8d420fbcfb8ea$export$49034edbe6b62415)(error[key], Error)) {
        $ca930ba32a341e1e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $ca930ba32a341e1e$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $ca930ba32a341e1e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $a0f8d420fbcfb8ea$export$49034edbe6b62415)(childError, Error)) {
            $ca930ba32a341e1e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $ca930ba32a341e1e$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $ca930ba32a341e1e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $ca930ba32a341e1e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $ca930ba32a341e1e$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $ca930ba32a341e1e$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $df92c5c0ba822dfa$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $11db80bf6686b1f5$var$DEFAULT_KEY = "cause";
const $11db80bf6686b1f5$var$DEFAULT_LIMIT = 5;
const $11db80bf6686b1f5$var$INTEGRATION_NAME = "LinkedErrors";
const $11db80bf6686b1f5$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $11db80bf6686b1f5$var$DEFAULT_LIMIT;
    const key = options.key || $11db80bf6686b1f5$var$DEFAULT_KEY;
    return {
        name: $11db80bf6686b1f5$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $ca930ba32a341e1e$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $39cacec81320cdc8$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $11db80bf6686b1f5$export$ebabb00eb7f3a395 = (0, $1065ef619eb4d8b2$export$2323046b9414659f)($11db80bf6686b1f5$var$_linkedErrorsIntegration);



const $9b2880001067af1f$var$OPERA10_PRIORITY = 10;
const $9b2880001067af1f$var$OPERA11_PRIORITY = 20;
const $9b2880001067af1f$var$CHROME_PRIORITY = 30;
const $9b2880001067af1f$var$WINJS_PRIORITY = 40;
const $9b2880001067af1f$var$GECKO_PRIORITY = 50;
function $9b2880001067af1f$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $213403414f6134bb$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $9b2880001067af1f$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $9b2880001067af1f$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $9b2880001067af1f$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $9b2880001067af1f$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $9b2880001067af1f$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $9b2880001067af1f$var$createFrame(filename, (0, $213403414f6134bb$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $9b2880001067af1f$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $9b2880001067af1f$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $9b2880001067af1f$var$extractSafariExtensionDetails(parts[1] || (0, $213403414f6134bb$export$27c7e15d453fc0ac), parts[2]);
        return $9b2880001067af1f$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $9b2880001067af1f$export$263a749fff749872 = [
    $9b2880001067af1f$var$CHROME_PRIORITY,
    $9b2880001067af1f$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $9b2880001067af1f$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $9b2880001067af1f$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $9b2880001067af1f$var$gecko = (line)=>{
    const parts = $9b2880001067af1f$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $9b2880001067af1f$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $213403414f6134bb$export$27c7e15d453fc0ac);
        [func, filename] = $9b2880001067af1f$var$extractSafariExtensionDetails(func, filename);
        return $9b2880001067af1f$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $9b2880001067af1f$export$cdba47a5dd2804d = [
    $9b2880001067af1f$var$GECKO_PRIORITY,
    $9b2880001067af1f$var$gecko
];
const $9b2880001067af1f$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $9b2880001067af1f$var$winjs = (line)=>{
    const parts = $9b2880001067af1f$var$winjsRegex.exec(line);
    return parts ? $9b2880001067af1f$var$createFrame(parts[2], parts[1] || (0, $213403414f6134bb$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $9b2880001067af1f$export$179460296da408e8 = [
    $9b2880001067af1f$var$WINJS_PRIORITY,
    $9b2880001067af1f$var$winjs
];
const $9b2880001067af1f$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $9b2880001067af1f$var$opera10 = (line)=>{
    const parts = $9b2880001067af1f$var$opera10Regex.exec(line);
    return parts ? $9b2880001067af1f$var$createFrame(parts[2], parts[3] || (0, $213403414f6134bb$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $9b2880001067af1f$export$f892b52c880ffc7a = [
    $9b2880001067af1f$var$OPERA10_PRIORITY,
    $9b2880001067af1f$var$opera10
];
const $9b2880001067af1f$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $9b2880001067af1f$var$opera11 = (line)=>{
    const parts = $9b2880001067af1f$var$opera11Regex.exec(line);
    return parts ? $9b2880001067af1f$var$createFrame(parts[5], parts[3] || parts[4] || (0, $213403414f6134bb$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $9b2880001067af1f$export$af11af13f09fb0dc = [
    $9b2880001067af1f$var$OPERA11_PRIORITY,
    $9b2880001067af1f$var$opera11
];
const $9b2880001067af1f$export$7197c0fe6554c079 = [
    $9b2880001067af1f$export$263a749fff749872,
    $9b2880001067af1f$export$cdba47a5dd2804d
];
const $9b2880001067af1f$export$2b2b997d81bf3907 = (0, $213403414f6134bb$export$a5739666fb2d03d4)(...$9b2880001067af1f$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $9b2880001067af1f$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $213403414f6134bb$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};





/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $b8b7ee5b6a60bf78$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $b8b7ee5b6a60bf78$export$e464f4a514ac28a8(name) {
    const cached = $b8b7ee5b6a60bf78$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $3919554e69c23272$export$d5f608b368e73f38)(impl)) return $b8b7ee5b6a60bf78$var$cachedImplementations[name] = impl.bind((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81));
    const document = (0, $496ff79b0915bd1a$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $1a5e20c7490d57a5$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $b8b7ee5b6a60bf78$var$cachedImplementations[name] = impl.bind((0, $496ff79b0915bd1a$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $b8b7ee5b6a60bf78$export$8aa36702e8c8978(name) {
    $b8b7ee5b6a60bf78$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $b8b7ee5b6a60bf78$export$e7aa7bc5c1b3cfb3(...rest) {
    return $b8b7ee5b6a60bf78$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $b8b7ee5b6a60bf78$export$831dc9f2ab0a617b(...rest) {
    return $b8b7ee5b6a60bf78$export$e464f4a514ac28a8("setTimeout")(...rest);
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $883882786b17df09$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $883882786b17df09$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $883882786b17df09$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $883882786b17df09$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $883882786b17df09$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $883882786b17df09$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $883882786b17df09$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $883882786b17df09$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $dc1035c8c78ef14e$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $2ad57a53fafc2702$export$78e43115b553f358)(new (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $2ad57a53fafc2702$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $8d7864803a4013a5$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $8d7864803a4013a5$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $dc1035c8c78ef14e$export$85a4f67f852183e6)(options.bufferSize || $8d7864803a4013a5$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $ac9400386ed4faec$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $ac9400386ed4faec$export$b11169581eeaf237)(type);
            if ((0, $883882786b17df09$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $8d7864803a4013a5$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $ac9400386ed4faec$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $ac9400386ed4faec$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $8d7864803a4013a5$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $ac9400386ed4faec$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $ac9400386ed4faec$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $883882786b17df09$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $f3b7634e91d86a76$export$5949942ba2a7c0e2)) {
                (0, $1f061359ff69ce32$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $8d7864803a4013a5$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $891085fb2b0e15e8$export$b2311068c46d7cc8(options, nativeFetch = (0, $b8b7ee5b6a60bf78$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $b8b7ee5b6a60bf78$export$8aa36702e8c8978)("fetch");
            return (0, $2ad57a53fafc2702$export$78e43115b553f358)("No fetch implementation available");
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $b8b7ee5b6a60bf78$export$8aa36702e8c8978)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $2ad57a53fafc2702$export$78e43115b553f358)(e);
        }
    }
    return (0, $8d7864803a4013a5$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $aa420d34cc44a112$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        (0, $fd35d1d4f0accf5c$export$cb3c5c2ceb9818ba)(),
        (0, $ad9af4a6a9d5ba43$export$7918117e9202e4fb)(),
        (0, $8d5316fa2896b747$export$59bfe9f1c76150e)(),
        (0, $c3bd537fcd6961fc$export$c079d904b326663a)(),
        (0, $f96bbe9fb5ba72fb$export$66acc70e8cf2b71a)(),
        (0, $11db80bf6686b1f5$export$ebabb00eb7f3a395)(),
        (0, $35ed3088982fe990$export$6d39aa44cd0c7567)(),
        (0, $db287acf42e5ea17$export$1378794447170364)()
    ];
}
function $aa420d34cc44a112$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $aa420d34cc44a112$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $aa420d34cc44a112$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).window !== "undefined" && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).location.href || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:",
        "safari-web-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81) === (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== "undefined";
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $aa420d34cc44a112$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $aa420d34cc44a112$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $aa420d34cc44a112$var$shouldShowBrowserExtensionError()) {
        (0, $fe5d055940839409$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if (0, $20f22cfb73fac39b$export$16a28057038b10ef) {
        if (!(0, $3919554e69c23272$export$edf3cb81fd7d2a3e)()) (0, $fe5d055940839409$export$af88d00dbe7f521).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $213403414f6134bb$export$1d5cf88b347146d4)(options.stackParser || (0, $9b2880001067af1f$export$2b2b997d81bf3907)),
        integrations: (0, $1065ef619eb4d8b2$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $891085fb2b0e15e8$export$b2311068c46d7cc8)
    };
    const client = (0, $819d3ec67d14c696$export$5333c3f1c58d9bc1)((0, $6da7331a221e1c79$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $aa420d34cc44a112$var$startSessionTracking();
    return client;
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $aa420d34cc44a112$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document) {
        (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $a2753be55d715def$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $07177d5aa53b2153$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.head || (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $aa420d34cc44a112$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $aa420d34cc44a112$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $aa420d34cc44a112$var$startSessionTracking() {
    if (typeof (0, $3a146b5d1d4aa58b$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $20f22cfb73fac39b$export$16a28057038b10ef) && (0, $fe5d055940839409$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $a2753be55d715def$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $a2753be55d715def$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $9c43746b6e1807b7$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $a2753be55d715def$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $a2753be55d715def$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $aa420d34cc44a112$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}




var $gIfym = parcelRequire("gIfym");
/**
 * Inits the React SDK
 */ function $ca8c28182539f605$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $35a843654fd66131$export$b9f95b027256052c)(opts, "react");
    (0, $a2753be55d715def$export$2f04de43fe27971a)("react", {
        version: $gIfym.version
    });
    return (0, $aa420d34cc44a112$export$2cd8252107eb640b)(opts);
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $a58e43e3c56d69ad$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}


var $jw5As = parcelRequire("jw5As");

/**
 * Returns true if we are in the browser.
 */ function $2eff0ce3a5f6e8d5$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $jw5As.isNodeEnv)() || $2eff0ce3a5f6e8d5$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $2eff0ce3a5f6e8d5$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).process !== undefined && (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1).process.type === "renderer");
}


/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $6ccaa31f5abf35f3$export$d92e61f5600202af(url, client) {
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $6ccaa31f5abf35f3$var$checkDsn(url, dsn) || $6ccaa31f5abf35f3$var$checkTunnel(url, tunnel);
}
function $6ccaa31f5abf35f3$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $6ccaa31f5abf35f3$var$removeTrailingSlash(url) === $6ccaa31f5abf35f3$var$removeTrailingSlash(tunnel);
}
function $6ccaa31f5abf35f3$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $6ccaa31f5abf35f3$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $d2e2031c7edc550c$var$WINDOW = (0, $33e192bcb8946f8c$export$f1a6cdb1459e81d1);
const $d2e2031c7edc550c$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $d2e2031c7edc550c$var$REPLAY_EVENT_NAME = "replay_event";
const $d2e2031c7edc550c$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $d2e2031c7edc550c$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $d2e2031c7edc550c$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $d2e2031c7edc550c$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $d2e2031c7edc550c$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $d2e2031c7edc550c$var$BUFFER_CHECKOUT_TIME = 60000;
const $d2e2031c7edc550c$var$RETRY_BASE_INTERVAL = 5000;
const $d2e2031c7edc550c$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $d2e2031c7edc550c$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $d2e2031c7edc550c$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $d2e2031c7edc550c$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $d2e2031c7edc550c$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $d2e2031c7edc550c$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $d2e2031c7edc550c$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $d2e2031c7edc550c$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $d2e2031c7edc550c$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $d2e2031c7edc550c$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $d2e2031c7edc550c$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $d2e2031c7edc550c$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($d2e2031c7edc550c$var$NodeType$1 || ($d2e2031c7edc550c$var$NodeType$1 = {}));
function $d2e2031c7edc550c$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $d2e2031c7edc550c$var$isShadowRoot(n) {
    const host = $d2e2031c7edc550c$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($d2e2031c7edc550c$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $d2e2031c7edc550c$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $d2e2031c7edc550c$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $d2e2031c7edc550c$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $d2e2031c7edc550c$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $d2e2031c7edc550c$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $d2e2031c7edc550c$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $d2e2031c7edc550c$var$stringifyRule(rule) {
    let importStringified;
    if ($d2e2031c7edc550c$var$isCSSImportRule(rule)) try {
        importStringified = $d2e2031c7edc550c$var$stringifyStylesheet(rule.styleSheet) || $d2e2031c7edc550c$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($d2e2031c7edc550c$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $d2e2031c7edc550c$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $d2e2031c7edc550c$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $d2e2031c7edc550c$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $d2e2031c7edc550c$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $d2e2031c7edc550c$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $d2e2031c7edc550c$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $d2e2031c7edc550c$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $d2e2031c7edc550c$var$createMirror() {
    return new $d2e2031c7edc550c$var$Mirror();
}
function $d2e2031c7edc550c$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $d2e2031c7edc550c$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $d2e2031c7edc550c$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $d2e2031c7edc550c$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $d2e2031c7edc550c$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $d2e2031c7edc550c$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $d2e2031c7edc550c$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$d2e2031c7edc550c$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $d2e2031c7edc550c$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $d2e2031c7edc550c$var$toLowerCase(type) : null;
}
function $d2e2031c7edc550c$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $d2e2031c7edc550c$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, $d2e2031c7edc550c$var$_nullishCoalesce$1(baseURL, ()=>window.location.href));
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return $d2e2031c7edc550c$var$_nullishCoalesce$1($d2e2031c7edc550c$var$_optionalChain$5([
        match,
        "optionalAccess",
        (_6)=>_6[1]
    ]), ()=>null);
}
const $d2e2031c7edc550c$var$cachedImplementations$1 = {};
function $d2e2031c7edc550c$var$getImplementation$1(name) {
    const cached = $d2e2031c7edc550c$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $d2e2031c7edc550c$var$cachedImplementations$1[name] = impl.bind(window);
}
function $d2e2031c7edc550c$var$setTimeout$2(...rest) {
    return $d2e2031c7edc550c$var$getImplementation$1("setTimeout")(...rest);
}
function $d2e2031c7edc550c$var$clearTimeout$2(...rest) {
    return $d2e2031c7edc550c$var$getImplementation$1("clearTimeout")(...rest);
}
let $d2e2031c7edc550c$var$_id = 1;
const $d2e2031c7edc550c$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $d2e2031c7edc550c$var$IGNORED_NODE = -2;
function $d2e2031c7edc550c$var$genId() {
    return $d2e2031c7edc550c$var$_id++;
}
function $d2e2031c7edc550c$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $d2e2031c7edc550c$var$toLowerCase(element.tagName);
    if ($d2e2031c7edc550c$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $d2e2031c7edc550c$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $d2e2031c7edc550c$var$canvasService;
let $d2e2031c7edc550c$var$canvasCtx;
const $d2e2031c7edc550c$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $d2e2031c7edc550c$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $d2e2031c7edc550c$var$URL_WWW_MATCH = /^www\..*/i;
const $d2e2031c7edc550c$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $d2e2031c7edc550c$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($d2e2031c7edc550c$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($d2e2031c7edc550c$var$URL_PROTOCOL_MATCH.test(filePath) || $d2e2031c7edc550c$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($d2e2031c7edc550c$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$d2e2031c7edc550c$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $d2e2031c7edc550c$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $d2e2031c7edc550c$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $d2e2031c7edc550c$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($d2e2031c7edc550c$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($d2e2031c7edc550c$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $d2e2031c7edc550c$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $d2e2031c7edc550c$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $d2e2031c7edc550c$var$cachedDocument = new WeakMap();
function $d2e2031c7edc550c$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $d2e2031c7edc550c$var$getHref(doc, attributeValue);
}
function $d2e2031c7edc550c$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $d2e2031c7edc550c$var$getHref(doc, customHref) {
    let a = $d2e2031c7edc550c$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement("a");
        $d2e2031c7edc550c$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a.setAttribute("href", customHref);
    return a.href;
}
function $d2e2031c7edc550c$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $d2e2031c7edc550c$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $d2e2031c7edc550c$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $d2e2031c7edc550c$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $d2e2031c7edc550c$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $d2e2031c7edc550c$var$absoluteToStylesheet(value, $d2e2031c7edc550c$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $d2e2031c7edc550c$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $d2e2031c7edc550c$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $d2e2031c7edc550c$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $d2e2031c7edc550c$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $d2e2031c7edc550c$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $d2e2031c7edc550c$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $d2e2031c7edc550c$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($d2e2031c7edc550c$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $d2e2031c7edc550c$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $d2e2031c7edc550c$var$distanceToMatch(el, $d2e2031c7edc550c$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $d2e2031c7edc550c$var$distanceToMatch(el, $d2e2031c7edc550c$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $d2e2031c7edc550c$var$distanceToMatch(el, $d2e2031c7edc550c$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $d2e2031c7edc550c$var$distanceToMatch(el, $d2e2031c7edc550c$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $d2e2031c7edc550c$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $d2e2031c7edc550c$var$setTimeout$2(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $d2e2031c7edc550c$var$clearTimeout$2(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $d2e2031c7edc550c$var$setTimeout$2(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $d2e2031c7edc550c$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = $d2e2031c7edc550c$var$setTimeout$2(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $d2e2031c7edc550c$var$clearTimeout$2(timer);
        fired = true;
        listener();
    });
}
function $d2e2031c7edc550c$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $d2e2031c7edc550c$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $d2e2031c7edc550c$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $d2e2031c7edc550c$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $d2e2031c7edc550c$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $d2e2031c7edc550c$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $d2e2031c7edc550c$var$serializeTextNode(n, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $d2e2031c7edc550c$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $d2e2031c7edc550c$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $d2e2031c7edc550c$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $d2e2031c7edc550c$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($d2e2031c7edc550c$var$_optionalChain$5([
                n,
                "access",
                (_7)=>_7.parentNode,
                "access",
                (_8)=>_8.sheet,
                "optionalAccess",
                (_9)=>_9.cssRules
            ])) textContent = $d2e2031c7edc550c$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $d2e2031c7edc550c$var$absoluteToStylesheet(textContent, $d2e2031c7edc550c$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $d2e2031c7edc550c$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $d2e2031c7edc550c$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $d2e2031c7edc550c$var$maskInputValue({
            isMasked: $d2e2031c7edc550c$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $d2e2031c7edc550c$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $d2e2031c7edc550c$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $d2e2031c7edc550c$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $d2e2031c7edc550c$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$d2e2031c7edc550c$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $d2e2031c7edc550c$var$transformAttribute(doc, tagName, $d2e2031c7edc550c$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $d2e2031c7edc550c$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $d2e2031c7edc550c$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $d2e2031c7edc550c$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $d2e2031c7edc550c$var$absoluteToStylesheet(cssText, $d2e2031c7edc550c$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $d2e2031c7edc550c$var$getInputType(el);
        const value = $d2e2031c7edc550c$var$getInputValue(el, $d2e2031c7edc550c$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $d2e2031c7edc550c$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $d2e2031c7edc550c$var$shouldMaskInput({
                type: type,
                tagName: $d2e2031c7edc550c$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $d2e2031c7edc550c$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$d2e2031c7edc550c$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$d2e2031c7edc550c$var$canvasService) {
            $d2e2031c7edc550c$var$canvasService = doc.createElement("canvas");
            $d2e2031c7edc550c$var$canvasCtx = $d2e2031c7edc550c$var$canvasService.getContext("2d");
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $d2e2031c7edc550c$var$canvasService.width = image.naturalWidth;
                $d2e2031c7edc550c$var$canvasService.height = image.naturalHeight;
                $d2e2031c7edc550c$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $d2e2031c7edc550c$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!needBlock && !n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $d2e2031c7edc550c$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $d2e2031c7edc550c$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $d2e2031c7edc550c$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $d2e2031c7edc550c$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $d2e2031c7edc550c$var$NodeType$1.Comment) return true;
    else if (sn.type === $d2e2031c7edc550c$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $d2e2031c7edc550c$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "application-name" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.rel) === "icon" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($d2e2031c7edc550c$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "robots" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "googlebot" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "author" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "generator" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "framework" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "publisher" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "progid" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "verification" || $d2e2031c7edc550c$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $d2e2031c7edc550c$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $d2e2031c7edc550c$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($d2e2031c7edc550c$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $d2e2031c7edc550c$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $d2e2031c7edc550c$var$IGNORED_NODE;
    else id = $d2e2031c7edc550c$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $d2e2031c7edc550c$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $d2e2031c7edc550c$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $d2e2031c7edc550c$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $d2e2031c7edc550c$var$NodeType$1.Document || serializedNode.type === $d2e2031c7edc550c$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $d2e2031c7edc550c$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $d2e2031c7edc550c$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($d2e2031c7edc550c$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $d2e2031c7edc550c$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $d2e2031c7edc550c$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $d2e2031c7edc550c$var$isShadowRoot(n.parentNode) && $d2e2031c7edc550c$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $d2e2031c7edc550c$var$NodeType$1.Element && serializedNode.tagName === "iframe") $d2e2031c7edc550c$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $d2e2031c7edc550c$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $d2e2031c7edc550c$var$NodeType$1.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $d2e2031c7edc550c$var$extractFileExtension(serializedNode.attributes.href) === "css")) $d2e2031c7edc550c$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $d2e2031c7edc550c$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $d2e2031c7edc550c$var$snapshot(n, options) {
    const { mirror: mirror = new $d2e2031c7edc550c$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $d2e2031c7edc550c$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $d2e2031c7edc550c$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $d2e2031c7edc550c$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $d2e2031c7edc550c$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $d2e2031c7edc550c$var$_mirror = {
    map: {},
    getId () {
        console.error($d2e2031c7edc550c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($d2e2031c7edc550c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($d2e2031c7edc550c$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($d2e2031c7edc550c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($d2e2031c7edc550c$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $d2e2031c7edc550c$var$_mirror = new Proxy($d2e2031c7edc550c$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($d2e2031c7edc550c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $d2e2031c7edc550c$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $d2e2031c7edc550c$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $d2e2031c7edc550c$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $d2e2031c7edc550c$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $d2e2031c7edc550c$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$d2e2031c7edc550c$var$hookSetter(target, key, original || {}, true);
}
function $d2e2031c7edc550c$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $d2e2031c7edc550c$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $d2e2031c7edc550c$var$nowTimestamp = ()=>new Date().getTime();
function $d2e2031c7edc550c$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $d2e2031c7edc550c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $d2e2031c7edc550c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $d2e2031c7edc550c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $d2e2031c7edc550c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $d2e2031c7edc550c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $d2e2031c7edc550c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $d2e2031c7edc550c$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $d2e2031c7edc550c$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $d2e2031c7edc550c$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $d2e2031c7edc550c$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $d2e2031c7edc550c$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $d2e2031c7edc550c$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $d2e2031c7edc550c$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $d2e2031c7edc550c$var$distanceToMatch(el, $d2e2031c7edc550c$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $d2e2031c7edc550c$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $d2e2031c7edc550c$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $d2e2031c7edc550c$var$IGNORED_NODE;
}
function $d2e2031c7edc550c$var$isAncestorRemoved(target, mirror) {
    if ($d2e2031c7edc550c$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $d2e2031c7edc550c$var$isAncestorRemoved(target.parentNode, mirror);
}
function $d2e2031c7edc550c$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $d2e2031c7edc550c$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $d2e2031c7edc550c$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $d2e2031c7edc550c$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $d2e2031c7edc550c$var$hasShadowRoot(n) {
    return Boolean($d2e2031c7edc550c$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $d2e2031c7edc550c$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $a58e43e3c56d69ad$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $d2e2031c7edc550c$var$getShadowHost(n) {
    let shadowHost = null;
    if ($d2e2031c7edc550c$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $d2e2031c7edc550c$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $d2e2031c7edc550c$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $d2e2031c7edc550c$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $d2e2031c7edc550c$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $d2e2031c7edc550c$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $d2e2031c7edc550c$var$shadowHostInDom(n);
}
const $d2e2031c7edc550c$var$cachedImplementations = {};
function $d2e2031c7edc550c$var$getImplementation(name) {
    const cached = $d2e2031c7edc550c$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $d2e2031c7edc550c$var$cachedImplementations[name] = impl.bind(window);
}
function $d2e2031c7edc550c$var$onRequestAnimationFrame(...rest) {
    return $d2e2031c7edc550c$var$getImplementation("requestAnimationFrame")(...rest);
}
function $d2e2031c7edc550c$var$setTimeout$1(...rest) {
    return $d2e2031c7edc550c$var$getImplementation("setTimeout")(...rest);
}
function $d2e2031c7edc550c$var$clearTimeout$1(...rest) {
    return $d2e2031c7edc550c$var$getImplementation("clearTimeout")(...rest);
}
var $d2e2031c7edc550c$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($d2e2031c7edc550c$var$EventType || {});
var $d2e2031c7edc550c$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($d2e2031c7edc550c$var$IncrementalSource || {});
var $d2e2031c7edc550c$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($d2e2031c7edc550c$var$MouseInteractions || {});
var $d2e2031c7edc550c$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($d2e2031c7edc550c$var$PointerTypes || {});
function $d2e2031c7edc550c$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $d2e2031c7edc550c$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $d2e2031c7edc550c$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $d2e2031c7edc550c$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $d2e2031c7edc550c$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $d2e2031c7edc550c$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $d2e2031c7edc550c$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $d2e2031c7edc550c$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $d2e2031c7edc550c$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $d2e2031c7edc550c$var$IGNORED_NODE;
                while(nextId === $d2e2031c7edc550c$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$d2e2031c7edc550c$var$inDom(n)) return;
                const parentId = $d2e2031c7edc550c$var$isShadowRoot(n.parentNode) ? this.mirror.getId($d2e2031c7edc550c$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $d2e2031c7edc550c$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($d2e2031c7edc550c$var$isSerializedIframe(currentN, this.mirror) && !$d2e2031c7edc550c$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($d2e2031c7edc550c$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($d2e2031c7edc550c$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($d2e2031c7edc550c$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        if (iframe.contentWindow) this.canvasManager.addWindow(iframe.contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($d2e2031c7edc550c$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$d2e2031c7edc550c$var$isAncestorInSet(this.droppedSet, n) && !$d2e2031c7edc550c$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($d2e2031c7edc550c$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($d2e2031c7edc550c$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$d2e2031c7edc550c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $d2e2031c7edc550c$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $d2e2031c7edc550c$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $d2e2031c7edc550c$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $d2e2031c7edc550c$var$getInputValue(target, tagName, type);
                            const isInputMasked = $d2e2031c7edc550c$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $d2e2031c7edc550c$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $d2e2031c7edc550c$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($d2e2031c7edc550c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$d2e2031c7edc550c$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $d2e2031c7edc550c$var$transformAttribute(this.doc, $d2e2031c7edc550c$var$toLowerCase(target.tagName), $d2e2031c7edc550c$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($d2e2031c7edc550c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $d2e2031c7edc550c$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($d2e2031c7edc550c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $d2e2031c7edc550c$var$isIgnored(n, this.mirror) || !$d2e2031c7edc550c$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $d2e2031c7edc550c$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($d2e2031c7edc550c$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$d2e2031c7edc550c$var$moveKey(nodeId, parentId)]) $d2e2031c7edc550c$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $d2e2031c7edc550c$var$isShadowRoot(m.target) && $d2e2031c7edc550c$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($d2e2031c7edc550c$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$d2e2031c7edc550c$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$d2e2031c7edc550c$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($d2e2031c7edc550c$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $d2e2031c7edc550c$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$d2e2031c7edc550c$var$deepDelete(addsSet, childN));
}
function $d2e2031c7edc550c$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $d2e2031c7edc550c$var$_isParentRemoved(removes, n, mirror);
}
function $d2e2031c7edc550c$var$_isParentRemoved(removes, n, mirror) {
    let node = n.parentNode;
    while(node){
        const parentId = mirror.getId(node);
        if (removes.some((r)=>r.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $d2e2031c7edc550c$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $d2e2031c7edc550c$var$_isAncestorInSet(set, n);
}
function $d2e2031c7edc550c$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $d2e2031c7edc550c$var$_isAncestorInSet(set, parentNode);
}
let $d2e2031c7edc550c$var$errorHandler;
function $d2e2031c7edc550c$var$registerErrorHandler(handler) {
    $d2e2031c7edc550c$var$errorHandler = handler;
}
function $d2e2031c7edc550c$var$unregisterErrorHandler() {
    $d2e2031c7edc550c$var$errorHandler = undefined;
}
const $d2e2031c7edc550c$var$callbackWrapper = (cb)=>{
    if (!$d2e2031c7edc550c$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($d2e2031c7edc550c$var$errorHandler && $d2e2031c7edc550c$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $d2e2031c7edc550c$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $d2e2031c7edc550c$var$mutationBuffers = [];
function $d2e2031c7edc550c$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $d2e2031c7edc550c$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $d2e2031c7edc550c$var$MutationBuffer();
    $d2e2031c7edc550c$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $d2e2031c7edc550c$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($d2e2031c7edc550c$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $d2e2031c7edc550c$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $d2e2031c7edc550c$var$throttle$1($d2e2031c7edc550c$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $d2e2031c7edc550c$var$callbackWrapper($d2e2031c7edc550c$var$throttle$1($d2e2031c7edc550c$var$callbackWrapper((evt)=>{
        const target = $d2e2031c7edc550c$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $d2e2031c7edc550c$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $d2e2031c7edc550c$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $d2e2031c7edc550c$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $d2e2031c7edc550c$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $d2e2031c7edc550c$var$IncrementalSource.MouseMove : $d2e2031c7edc550c$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $d2e2031c7edc550c$var$on("mousemove", updatePosition, doc),
        $d2e2031c7edc550c$var$on("touchmove", updatePosition, doc),
        $d2e2031c7edc550c$var$on("drag", updatePosition, doc)
    ];
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $d2e2031c7edc550c$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $d2e2031c7edc550c$var$getEventTarget(event);
            if ($d2e2031c7edc550c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $d2e2031c7edc550c$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $d2e2031c7edc550c$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $d2e2031c7edc550c$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $d2e2031c7edc550c$var$PointerTypes.Touch) {
                    if ($d2e2031c7edc550c$var$MouseInteractions[eventKey] === $d2e2031c7edc550c$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($d2e2031c7edc550c$var$MouseInteractions[eventKey] === $d2e2031c7edc550c$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $d2e2031c7edc550c$var$PointerTypes.Pen;
            } else if ($d2e2031c7edc550c$var$legacy_isTouchEvent(event)) pointerType = $d2e2031c7edc550c$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $d2e2031c7edc550c$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $d2e2031c7edc550c$var$PointerTypes.Mouse) pointerType = null;
            } else if ($d2e2031c7edc550c$var$MouseInteractions[eventKey] === $d2e2031c7edc550c$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $d2e2031c7edc550c$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $d2e2031c7edc550c$var$callbackWrapper(mouseInteractionCb)({
                type: $d2e2031c7edc550c$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($d2e2031c7edc550c$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $d2e2031c7edc550c$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($d2e2031c7edc550c$var$MouseInteractions[eventKey]){
            case $d2e2031c7edc550c$var$MouseInteractions.MouseDown:
            case $d2e2031c7edc550c$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $d2e2031c7edc550c$var$MouseInteractions.TouchStart:
            case $d2e2031c7edc550c$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($d2e2031c7edc550c$var$on(eventName, handler, doc));
    });
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $d2e2031c7edc550c$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $d2e2031c7edc550c$var$callbackWrapper($d2e2031c7edc550c$var$throttle$1($d2e2031c7edc550c$var$callbackWrapper((evt)=>{
        const target = $d2e2031c7edc550c$var$getEventTarget(evt);
        if (!target || $d2e2031c7edc550c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $d2e2031c7edc550c$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $d2e2031c7edc550c$var$on("scroll", updatePosition, doc);
}
function $d2e2031c7edc550c$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $d2e2031c7edc550c$var$callbackWrapper($d2e2031c7edc550c$var$throttle$1($d2e2031c7edc550c$var$callbackWrapper(()=>{
        const height = $d2e2031c7edc550c$var$getWindowHeight();
        const width = $d2e2031c7edc550c$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $d2e2031c7edc550c$var$on("resize", updateDimension, win);
}
const $d2e2031c7edc550c$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $d2e2031c7edc550c$var$lastInputValueMap = new WeakMap();
function $d2e2031c7edc550c$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $d2e2031c7edc550c$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $d2e2031c7edc550c$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $d2e2031c7edc550c$var$INPUT_TAGS.indexOf(tagName) < 0 || $d2e2031c7edc550c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $d2e2031c7edc550c$var$getInputType(target);
        let text = $d2e2031c7edc550c$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $d2e2031c7edc550c$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $d2e2031c7edc550c$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $d2e2031c7edc550c$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $d2e2031c7edc550c$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $d2e2031c7edc550c$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $d2e2031c7edc550c$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $d2e2031c7edc550c$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $d2e2031c7edc550c$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$d2e2031c7edc550c$var$on(eventName, $d2e2031c7edc550c$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$d2e2031c7edc550c$var$hookSetter(p[0], p[1], {
            set () {
                $d2e2031c7edc550c$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $d2e2031c7edc550c$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($d2e2031c7edc550c$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $d2e2031c7edc550c$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $d2e2031c7edc550c$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $d2e2031c7edc550c$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $d2e2031c7edc550c$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $d2e2031c7edc550c$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $d2e2031c7edc550c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $d2e2031c7edc550c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $d2e2031c7edc550c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $d2e2031c7edc550c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $d2e2031c7edc550c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $d2e2031c7edc550c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $d2e2031c7edc550c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $d2e2031c7edc550c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($d2e2031c7edc550c$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($d2e2031c7edc550c$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($d2e2031c7edc550c$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($d2e2031c7edc550c$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $d2e2031c7edc550c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $d2e2031c7edc550c$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$d2e2031c7edc550c$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $d2e2031c7edc550c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $d2e2031c7edc550c$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$d2e2031c7edc550c$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $d2e2031c7edc550c$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $d2e2031c7edc550c$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $d2e2031c7edc550c$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $d2e2031c7edc550c$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($d2e2031c7edc550c$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $d2e2031c7edc550c$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $d2e2031c7edc550c$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $d2e2031c7edc550c$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $d2e2031c7edc550c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $d2e2031c7edc550c$var$getIdAndStyleId($d2e2031c7edc550c$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $d2e2031c7edc550c$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $d2e2031c7edc550c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $d2e2031c7edc550c$var$getIdAndStyleId($d2e2031c7edc550c$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $d2e2031c7edc550c$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $d2e2031c7edc550c$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $d2e2031c7edc550c$var$callbackWrapper((type)=>$d2e2031c7edc550c$var$throttle$1($d2e2031c7edc550c$var$callbackWrapper((event)=>{
            const target = $d2e2031c7edc550c$var$getEventTarget(event);
            if (!target || $d2e2031c7edc550c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $d2e2031c7edc550c$var$on("play", handler(0), doc),
        $d2e2031c7edc550c$var$on("pause", handler(1), doc),
        $d2e2031c7edc550c$var$on("seeked", handler(2), doc),
        $d2e2031c7edc550c$var$on("volumechange", handler(3), doc),
        $d2e2031c7edc550c$var$on("ratechange", handler(4), doc)
    ];
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $d2e2031c7edc550c$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $d2e2031c7edc550c$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $d2e2031c7edc550c$var$setTimeout$1($d2e2031c7edc550c$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $d2e2031c7edc550c$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $d2e2031c7edc550c$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $d2e2031c7edc550c$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $d2e2031c7edc550c$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $d2e2031c7edc550c$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $d2e2031c7edc550c$var$on("selectionchange", updateSelection);
}
function $d2e2031c7edc550c$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $d2e2031c7edc550c$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $d2e2031c7edc550c$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o.recordDOM) mutationObserver = $d2e2031c7edc550c$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $d2e2031c7edc550c$var$initMoveObserver(o);
    const mouseInteractionHandler = $d2e2031c7edc550c$var$initMouseInteractionObserver(o);
    const scrollHandler = $d2e2031c7edc550c$var$initScrollObserver(o);
    const viewportResizeHandler = $d2e2031c7edc550c$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $d2e2031c7edc550c$var$initInputObserver(o);
    const mediaInteractionHandler = $d2e2031c7edc550c$var$initMediaInteractionObserver(o);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o.recordDOM) {
        styleSheetObserver = $d2e2031c7edc550c$var$initStyleSheetObserver(o, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $d2e2031c7edc550c$var$initAdoptedStyleSheetObserver(o, o.doc);
        styleDeclarationObserver = $d2e2031c7edc550c$var$initStyleDeclarationObserver(o, {
            win: currentWindow
        });
        if (o.collectFonts) fontObserver = $d2e2031c7edc550c$var$initFontObserver(o);
    }
    const selectionObserver = $d2e2031c7edc550c$var$initSelectionObserver(o);
    const customElementObserver = $d2e2031c7edc550c$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $d2e2031c7edc550c$var$callbackWrapper(()=>{
        $d2e2031c7edc550c$var$mutationBuffers.forEach((b)=>b.reset());
        $d2e2031c7edc550c$var$_optionalChain$2([
            mutationObserver,
            "optionalAccess",
            (_22)=>_22.disconnect,
            "call",
            (_23)=>_23()
        ]);
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $d2e2031c7edc550c$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $d2e2031c7edc550c$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $d2e2031c7edc550c$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $d2e2031c7edc550c$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $d2e2031c7edc550c$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $d2e2031c7edc550c$var$CrossOriginIframeMirror($d2e2031c7edc550c$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $d2e2031c7edc550c$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $d2e2031c7edc550c$var$CrossOriginIframeMirror($d2e2031c7edc550c$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $d2e2031c7edc550c$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $d2e2031c7edc550c$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $d2e2031c7edc550c$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $d2e2031c7edc550c$var$EventType.Meta:
            case $d2e2031c7edc550c$var$EventType.Load:
            case $d2e2031c7edc550c$var$EventType.DomContentLoaded:
                return false;
            case $d2e2031c7edc550c$var$EventType.Plugin:
                return e;
            case $d2e2031c7edc550c$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $d2e2031c7edc550c$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $d2e2031c7edc550c$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $d2e2031c7edc550c$var$IncrementalSource.Drag:
                    case $d2e2031c7edc550c$var$IncrementalSource.TouchMove:
                    case $d2e2031c7edc550c$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $d2e2031c7edc550c$var$IncrementalSource.ViewportResize:
                        return false;
                    case $d2e2031c7edc550c$var$IncrementalSource.MediaInteraction:
                    case $d2e2031c7edc550c$var$IncrementalSource.MouseInteraction:
                    case $d2e2031c7edc550c$var$IncrementalSource.Scroll:
                    case $d2e2031c7edc550c$var$IncrementalSource.CanvasMutation:
                    case $d2e2031c7edc550c$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $d2e2031c7edc550c$var$IncrementalSource.StyleSheetRule:
                    case $d2e2031c7edc550c$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $d2e2031c7edc550c$var$IncrementalSource.Font:
                        return e;
                    case $d2e2031c7edc550c$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $d2e2031c7edc550c$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $d2e2031c7edc550c$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $d2e2031c7edc550c$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $d2e2031c7edc550c$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $d2e2031c7edc550c$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$d2e2031c7edc550c$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $d2e2031c7edc550c$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($d2e2031c7edc550c$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $d2e2031c7edc550c$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($d2e2031c7edc550c$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($d2e2031c7edc550c$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $d2e2031c7edc550c$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
class $d2e2031c7edc550c$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
class $d2e2031c7edc550c$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $d2e2031c7edc550c$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $d2e2031c7edc550c$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $d2e2031c7edc550c$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $d2e2031c7edc550c$var$onRequestAnimationFrame(()=>{
                this.nodeMap = new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    destroy() {}
}
let $d2e2031c7edc550c$var$wrappedEmit;
let $d2e2031c7edc550c$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
            cleanFrame,
            "access",
            (_)=>_.contentWindow,
            "optionalAccess",
            (_2)=>_2.Array,
            "access",
            (_3)=>_3.from
        ]) || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $d2e2031c7edc550c$var$mirror = $d2e2031c7edc550c$var$createMirror();
function $d2e2031c7edc550c$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $d2e2031c7edc550c$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $d2e2031c7edc550c$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $d2e2031c7edc550c$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $d2e2031c7edc550c$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $d2e2031c7edc550c$var$nowTimestamp();
        if ((0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
            $d2e2031c7edc550c$var$mutationBuffers,
            "access",
            (_4)=>_4[0],
            "optionalAccess",
            (_5)=>_5.isFrozen,
            "call",
            (_6)=>_6()
        ]) && e.type !== $d2e2031c7edc550c$var$EventType.FullSnapshot && !(e.type === $d2e2031c7edc550c$var$EventType.IncrementalSnapshot && e.data.source === $d2e2031c7edc550c$var$IncrementalSource.Mutation)) $d2e2031c7edc550c$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_7)=>_7(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $d2e2031c7edc550c$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $d2e2031c7edc550c$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $d2e2031c7edc550c$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $d2e2031c7edc550c$var$wrappedEmit({
            type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
            data: {
                source: $d2e2031c7edc550c$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$d2e2031c7edc550c$var$wrappedEmit({
            type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
            data: {
                source: $d2e2031c7edc550c$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$d2e2031c7edc550c$var$wrappedEmit({
            type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
            data: {
                source: $d2e2031c7edc550c$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$d2e2031c7edc550c$var$wrappedEmit({
            type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
            data: {
                source: $d2e2031c7edc550c$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $d2e2031c7edc550c$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $d2e2031c7edc550c$var$IframeManagerNoop() : new $d2e2031c7edc550c$var$IframeManager({
        mirror: $d2e2031c7edc550c$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $d2e2031c7edc550c$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $d2e2031c7edc550c$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $d2e2031c7edc550c$var$ProcessedNodeManager();
    const canvasManager = $d2e2031c7edc550c$var$_getCanvasManager(getCanvasManager, {
        mirror: $d2e2031c7edc550c$var$mirror,
        win: window,
        mutationCb: (p)=>$d2e2031c7edc550c$var$wrappedEmit({
                type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                data: {
                    source: $d2e2031c7edc550c$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $d2e2031c7edc550c$var$ShadowDomManagerNoop() : new $d2e2031c7edc550c$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $d2e2031c7edc550c$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        if (!recordDOM) return;
        $d2e2031c7edc550c$var$wrappedEmit({
            type: $d2e2031c7edc550c$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $d2e2031c7edc550c$var$getWindowWidth(),
                height: $d2e2031c7edc550c$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $d2e2031c7edc550c$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $d2e2031c7edc550c$var$snapshot(document, {
            mirror: $d2e2031c7edc550c$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($d2e2031c7edc550c$var$isSerializedIframe(n, $d2e2031c7edc550c$var$mirror)) iframeManager.addIframe(n);
                if ($d2e2031c7edc550c$var$isSerializedStylesheet(n, $d2e2031c7edc550c$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($d2e2031c7edc550c$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                if (iframe.contentWindow) canvasManager.addWindow(iframe.contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $d2e2031c7edc550c$var$wrappedEmit({
            type: $d2e2031c7edc550c$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $d2e2031c7edc550c$var$getWindowScroll(window)
            }
        });
        $d2e2031c7edc550c$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $d2e2031c7edc550c$var$mirror.getId(document));
    };
    $d2e2031c7edc550c$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $d2e2031c7edc550c$var$callbackWrapper($d2e2031c7edc550c$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $d2e2031c7edc550c$var$wrappedEmit({
                        type: $d2e2031c7edc550c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $d2e2031c7edc550c$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $d2e2031c7edc550c$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $f50c25d72c839ed9$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_8)=>_8.filter,
                    "call",
                    (_9)=>_9((p)=>p.observer),
                    "optionalAccess",
                    (_10)=>_10.map,
                    "call",
                    (_11)=>_11((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$d2e2031c7edc550c$var$wrappedEmit({
                                        type: $d2e2031c7edc550c$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($d2e2031c7edc550c$var$on("DOMContentLoaded", ()=>{
                $d2e2031c7edc550c$var$wrappedEmit({
                    type: $d2e2031c7edc550c$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($d2e2031c7edc550c$var$on("load", ()=>{
                $d2e2031c7edc550c$var$wrappedEmit({
                    type: $d2e2031c7edc550c$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $d2e2031c7edc550c$var$_takeFullSnapshot = undefined;
            $d2e2031c7edc550c$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $d2e2031c7edc550c$var$takeFullSnapshot(isCheckout) {
    if (!$d2e2031c7edc550c$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $d2e2031c7edc550c$var$_takeFullSnapshot(isCheckout);
}
$d2e2031c7edc550c$var$record.mirror = $d2e2031c7edc550c$var$mirror;
$d2e2031c7edc550c$var$record.takeFullSnapshot = $d2e2031c7edc550c$var$takeFullSnapshot;
function $d2e2031c7edc550c$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $d2e2031c7edc550c$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $d2e2031c7edc550c$var$CanvasManagerNoop();
    }
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $d2e2031c7edc550c$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $d2e2031c7edc550c$var$CONSOLE_LEVELS = [
    "info",
    "warn",
    "error",
    "log"
];
const $d2e2031c7edc550c$var$PREFIX = "[Replay] ";
function $d2e2031c7edc550c$var$_addBreadcrumb(message, level = "info") {
    (0, $f322f13cecbd05ef$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: level,
        message: `${$d2e2031c7edc550c$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $d2e2031c7edc550c$var$makeReplayLogger() {
    let _capture = false;
    let _trace = false;
    const _logger = {
        exception: ()=>undefined,
        infoTick: ()=>undefined,
        setConfig: (opts)=>{
            _capture = opts.captureExceptions;
            _trace = opts.traceInternals;
        }
    };
    if ($d2e2031c7edc550c$var$DEBUG_BUILD) {
        $d2e2031c7edc550c$var$CONSOLE_LEVELS.forEach((name)=>{
            _logger[name] = (...args)=>{
                (0, $fe5d055940839409$export$af88d00dbe7f521)[name]($d2e2031c7edc550c$var$PREFIX, ...args);
                if (_trace) $d2e2031c7edc550c$var$_addBreadcrumb(args.join(""), (0, $9cabd38b2efbc941$export$d771ef054122c30a)(name));
            };
        });
        _logger.exception = (error, ...message)=>{
            if (message.length && _logger.error) _logger.error(...message);
            (0, $fe5d055940839409$export$af88d00dbe7f521).error($d2e2031c7edc550c$var$PREFIX, error);
            if (_capture) (0, $a2753be55d715def$export$f5282963edea4a68)(error);
            else if (_trace) // No need for a breadcrumb if `_capture` is enabled since it should be
            // captured as an exception
            $d2e2031c7edc550c$var$_addBreadcrumb(error, "error");
        };
        _logger.infoTick = (...args)=>{
            (0, $fe5d055940839409$export$af88d00dbe7f521).info($d2e2031c7edc550c$var$PREFIX, ...args);
            if (_trace) // Wait a tick here to avoid race conditions for some initial logs
            // which may be added before replay is initialized
            setTimeout(()=>$d2e2031c7edc550c$var$_addBreadcrumb(args[0]), 0);
        };
    } else $d2e2031c7edc550c$var$CONSOLE_LEVELS.forEach((name)=>{
        _logger[name] = ()=>undefined;
    });
    return _logger;
}
const $d2e2031c7edc550c$var$logger = $d2e2031c7edc550c$var$makeReplayLogger();
const $d2e2031c7edc550c$var$ReplayEventTypeIncrementalSnapshot = 3;
const $d2e2031c7edc550c$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $d2e2031c7edc550c$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $d2e2031c7edc550c$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $d2e2031c7edc550c$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $d2e2031c7edc550c$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $4c0d7eab065d1a33$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $d2e2031c7edc550c$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $d2e2031c7edc550c$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($d2e2031c7edc550c$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $d2e2031c7edc550c$var$getClickTargetNode(event) {
    const target = $d2e2031c7edc550c$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $d2e2031c7edc550c$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $d2e2031c7edc550c$var$getTargetNode(event) {
    if ($d2e2031c7edc550c$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $d2e2031c7edc550c$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $d2e2031c7edc550c$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $d2e2031c7edc550c$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$d2e2031c7edc550c$var$handlers) {
        $d2e2031c7edc550c$var$handlers = [];
        $d2e2031c7edc550c$var$monkeyPatchWindowOpen();
    }
    $d2e2031c7edc550c$var$handlers.push(cb);
    return ()=>{
        const pos = $d2e2031c7edc550c$var$handlers ? $d2e2031c7edc550c$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $d2e2031c7edc550c$var$handlers.splice(pos, 1);
    };
}
function $d2e2031c7edc550c$var$monkeyPatchWindowOpen() {
    (0, $212518d61e73b76e$export$9563e054e6f787fb)($d2e2031c7edc550c$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($d2e2031c7edc550c$var$handlers) try {
                $d2e2031c7edc550c$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($d2e2031c7edc550c$var$WINDOW, args);
        };
    });
}
/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */ const $d2e2031c7edc550c$var$IncrementalMutationSources = new Set([
    $d2e2031c7edc550c$var$IncrementalSource.Mutation,
    $d2e2031c7edc550c$var$IncrementalSource.StyleSheetRule,
    $d2e2031c7edc550c$var$IncrementalSource.StyleDeclaration,
    $d2e2031c7edc550c$var$IncrementalSource.AdoptedStyleSheet,
    $d2e2031c7edc550c$var$IncrementalSource.CanvasMutation,
    $d2e2031c7edc550c$var$IncrementalSource.Selection,
    $d2e2031c7edc550c$var$IncrementalSource.MediaInteraction
]);
/** Handle a click. */ function $d2e2031c7edc550c$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $d2e2031c7edc550c$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $d2e2031c7edc550c$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $d2e2031c7edc550c$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $d2e2031c7edc550c$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($d2e2031c7edc550c$var$ignoreElement(node, this._ignoreSelector) || !$d2e2031c7edc550c$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $d2e2031c7edc550c$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $d2e2031c7edc550c$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $d2e2031c7edc550c$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $d2e2031c7edc550c$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $d2e2031c7edc550c$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $d2e2031c7edc550c$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $d2e2031c7edc550c$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $b8b7ee5b6a60bf78$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1000);
    }
}
const $d2e2031c7edc550c$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $d2e2031c7edc550c$var$ignoreElement(node, ignoreSelector) {
    if (!$d2e2031c7edc550c$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $d2e2031c7edc550c$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $d2e2031c7edc550c$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $d2e2031c7edc550c$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$d2e2031c7edc550c$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($d2e2031c7edc550c$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $d2e2031c7edc550c$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($d2e2031c7edc550c$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $d2e2031c7edc550c$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $d2e2031c7edc550c$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $d2e2031c7edc550c$var$isIncrementalEvent(event) {
    return event.type === $d2e2031c7edc550c$var$ReplayEventTypeIncrementalSnapshot;
}
function $d2e2031c7edc550c$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $d2e2031c7edc550c$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $d2e2031c7edc550c$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $d2e2031c7edc550c$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($d2e2031c7edc550c$var$NodeType || ($d2e2031c7edc550c$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $d2e2031c7edc550c$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $d2e2031c7edc550c$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) attributes["data-sentry-component"] = attributes["data-sentry-element"];
    for(const key in attributes)if ($d2e2031c7edc550c$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $d2e2031c7edc550c$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $d2e2031c7edc550c$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $d2e2031c7edc550c$var$handleClick(replay.clickDetector, result, $d2e2031c7edc550c$var$getClickTargetNode(handlerData.event));
        $d2e2031c7edc550c$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $d2e2031c7edc550c$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $d2e2031c7edc550c$var$record.mirror.getId(target);
    const node = nodeId && $d2e2031c7edc550c$var$record.mirror.getNode(nodeId);
    const meta = node && $d2e2031c7edc550c$var$record.mirror.getMeta(node);
    const element = meta && $d2e2031c7edc550c$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $d2e2031c7edc550c$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $d2e2031c7edc550c$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $d2e2031c7edc550c$var$handleDom(handlerData) {
    const { target: target, message: message } = $d2e2031c7edc550c$var$getDomTarget(handlerData);
    return $d2e2031c7edc550c$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$d2e2031c7edc550c$var$getBaseDomBreadcrumb(target, message)
    });
}
function $d2e2031c7edc550c$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $d2e2031c7edc550c$var$getClickTargetNode(handlerData.event) : $d2e2031c7edc550c$var$getTargetNode(handlerData.event);
        message = (0, $83913a7139f39e6c$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $d2e2031c7edc550c$var$isElement(node) {
    return node.type === $d2e2031c7edc550c$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $d2e2031c7edc550c$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $d2e2031c7edc550c$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $d2e2031c7edc550c$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $d2e2031c7edc550c$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $d2e2031c7edc550c$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $83913a7139f39e6c$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $d2e2031c7edc550c$var$getBaseDomBreadcrumb(target, message);
    return $d2e2031c7edc550c$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $d2e2031c7edc550c$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $d2e2031c7edc550c$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $d2e2031c7edc550c$var$createResourceEntry,
    paint: $d2e2031c7edc550c$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $d2e2031c7edc550c$var$createNavigationEntry
};
/**
 * Handler creater for web vitals
 */ function $d2e2031c7edc550c$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
/**
 * Create replay performance entries from the browser performance entries.
 */ function $d2e2031c7edc550c$var$createPerformanceEntries(entries) {
    return entries.map($d2e2031c7edc550c$var$createPerformanceEntry).filter(Boolean);
}
function $d2e2031c7edc550c$var$createPerformanceEntry(entry) {
    const entryType = $d2e2031c7edc550c$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $d2e2031c7edc550c$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $3bdbd9b2c36d1620$export$baf075a948ffc0bf) || $d2e2031c7edc550c$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $d2e2031c7edc550c$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $d2e2031c7edc550c$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $d2e2031c7edc550c$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $d2e2031c7edc550c$var$getAbsoluteTime(startTime),
        end: $d2e2031c7edc550c$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $d2e2031c7edc550c$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $d2e2031c7edc550c$var$getAbsoluteTime(startTime),
        end: $d2e2031c7edc550c$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on a LCP metric.
 */ function $d2e2031c7edc550c$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.element ? [
        lastEntry.element
    ] : undefined;
    return $d2e2031c7edc550c$var$getWebVital(metric, "largest-contentful-paint", node);
}
function $d2e2031c7edc550c$var$isLayoutShift(entry) {
    return entry.sources !== undefined;
}
/**
 * Add a CLS event to the replay based on a CLS metric.
 */ function $d2e2031c7edc550c$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($d2e2031c7edc550c$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $d2e2031c7edc550c$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : undefined
        });
    }
    return $d2e2031c7edc550c$var$getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
/**
 * Add a FID event to the replay based on a FID metric.
 */ function $d2e2031c7edc550c$var$getFirstInputDelay(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.target ? [
        lastEntry.target
    ] : undefined;
    return $d2e2031c7edc550c$var$getWebVital(metric, "first-input-delay", node);
}
/**
 * Add an INP event to the replay based on an INP metric.
 */ function $d2e2031c7edc550c$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.target ? [
        lastEntry.target
    ] : undefined;
    return $d2e2031c7edc550c$var$getWebVital(metric, "interaction-to-next-paint", node);
}
/**
 * Add an web vital event to the replay based on the web vital metric.
 */ function $d2e2031c7edc550c$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $d2e2031c7edc550c$var$getAbsoluteTime(value);
    return {
        type: "web-vital",
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$d2e2031c7edc550c$var$record.mirror.getId(node)) : undefined,
            attributions: attributions
        }
    };
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $d2e2031c7edc550c$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $3be3f584f987b31e$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $3be3f584f987b31e$export$3fd4b53331200102)($d2e2031c7edc550c$var$webVitalHandler($d2e2031c7edc550c$var$getLargestContentfulPaint, replay)), (0, $3be3f584f987b31e$export$861b82818b37ba5b)($d2e2031c7edc550c$var$webVitalHandler($d2e2031c7edc550c$var$getCumulativeLayoutShift, replay)), (0, $3be3f584f987b31e$export$2707d7471c0b918f)($d2e2031c7edc550c$var$webVitalHandler($d2e2031c7edc550c$var$getFirstInputDelay, replay)), (0, $3be3f584f987b31e$export$da3b76aa2022cbd7)($d2e2031c7edc550c$var$webVitalHandler($d2e2031c7edc550c$var$getInteractionToNextPaint, replay)));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
const $d2e2031c7edc550c$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=A(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},U=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=x(f,15),M=b.t,E=b.l,A=x(h,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=C[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(a[t]^a[t+1]<<A^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=U(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=U(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),a=0,s=function(t){i[a++]=t},o=0;o<e;++o){if(a+5>i.length){var f=new t(a+8+(e-o<<1));f.set(i),i=f}var h=n.charCodeAt(o);h<128||r?s(h):h<2048?(s(192|h>>6),s(128|63&h)):h>55295&&h<57344?(s(240|(h=65536+(1047552&h)|1023&n.charCodeAt(++o))>>18),s(128|h>>12&63),s(128|h>>6&63),s(128|63&h)):(s(224|h>>12),s(128|h>>6&63),s(128|63&h))}return b(i,0,a)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $d2e2031c7edc550c$var$e() {
    const e = new Blob([
        $d2e2031c7edc550c$var$r
    ]);
    return URL.createObjectURL(e);
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $d2e2031c7edc550c$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$d2e2031c7edc550c$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $d2e2031c7edc550c$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $d2e2031c7edc550c$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $d2e2031c7edc550c$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $d2e2031c7edc550c$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $d2e2031c7edc550c$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.error("Error in compression worker: ", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $d2e2031c7edc550c$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $d2e2031c7edc550c$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $d2e2031c7edc550c$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $d2e2031c7edc550c$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $d2e2031c7edc550c$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $d2e2031c7edc550c$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $d2e2031c7edc550c$var$EventBufferArray();
        this._compression = new $d2e2031c7edc550c$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
            // Can now clear fallback buffer as it's no longer necessary
            this._fallback.clear();
        } catch (error) {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to add events when switching buffers.");
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $d2e2031c7edc550c$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $d2e2031c7edc550c$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Using simple buffer");
    return new $d2e2031c7edc550c$var$EventBufferArray();
}
function $d2e2031c7edc550c$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $d2e2031c7edc550c$var$_getWorkerUrl();
        if (!workerUrl) return;
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $d2e2031c7edc550c$var$EventBufferProxy(worker);
    } catch (error) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $d2e2031c7edc550c$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $d2e2031c7edc550c$var$e();
    return "";
}
/** If sessionStorage is available. */ function $d2e2031c7edc550c$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $d2e2031c7edc550c$var$WINDOW && !!$d2e2031c7edc550c$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $d2e2031c7edc550c$var$clearSession(replay) {
    $d2e2031c7edc550c$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $d2e2031c7edc550c$var$deleteSession() {
    if (!$d2e2031c7edc550c$var$hasSessionStorage()) return;
    try {
        $d2e2031c7edc550c$var$WINDOW.sessionStorage.removeItem($d2e2031c7edc550c$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $d2e2031c7edc550c$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $d2e2031c7edc550c$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $21925b133330b925$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $d2e2031c7edc550c$var$saveSession(session) {
    if (!$d2e2031c7edc550c$var$hasSessionStorage()) return;
    try {
        $d2e2031c7edc550c$var$WINDOW.sessionStorage.setItem($d2e2031c7edc550c$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $d2e2031c7edc550c$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $d2e2031c7edc550c$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $d2e2031c7edc550c$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $d2e2031c7edc550c$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $d2e2031c7edc550c$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $d2e2031c7edc550c$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $d2e2031c7edc550c$var$fetchSession() {
    if (!$d2e2031c7edc550c$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $d2e2031c7edc550c$var$WINDOW.sessionStorage.getItem($d2e2031c7edc550c$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.infoTick("Loading existing session");
        return $d2e2031c7edc550c$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $d2e2031c7edc550c$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $d2e2031c7edc550c$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $d2e2031c7edc550c$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $d2e2031c7edc550c$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $d2e2031c7edc550c$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$d2e2031c7edc550c$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $d2e2031c7edc550c$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $d2e2031c7edc550c$var$fetchSession();
    // No session exists yet, just create a new one
    if (!existingSession) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.infoTick("Creating new session");
        return $d2e2031c7edc550c$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$d2e2031c7edc550c$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.infoTick("Session in sessionStorage is expired, creating new one...");
    return $d2e2031c7edc550c$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $d2e2031c7edc550c$var$isCustomEvent(event) {
    return event.type === $d2e2031c7edc550c$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $d2e2031c7edc550c$var$addEventSync(replay, event, isCheckout) {
    if (!$d2e2031c7edc550c$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $d2e2031c7edc550c$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $d2e2031c7edc550c$var$addEvent(replay, event, isCheckout) {
    if (!$d2e2031c7edc550c$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $d2e2031c7edc550c$var$_addEvent(replay, event, isCheckout);
}
async function $d2e2031c7edc550c$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $d2e2031c7edc550c$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $d2e2031c7edc550c$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $d2e2031c7edc550c$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $d2e2031c7edc550c$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $d2e2031c7edc550c$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $d2e2031c7edc550c$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
        return null;
    }
    return event;
}
/** If the event is an error event */ function $d2e2031c7edc550c$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $d2e2031c7edc550c$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $d2e2031c7edc550c$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $d2e2031c7edc550c$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $d2e2031c7edc550c$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$d2e2031c7edc550c$var$isErrorEvent(event) && !$d2e2031c7edc550c$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($d2e2031c7edc550c$var$isTransactionEvent(event)) {
            $d2e2031c7edc550c$var$handleTransactionEvent(replay, event);
            return;
        }
        $d2e2031c7edc550c$var$handleErrorEvent(replay, event);
    };
}
function $d2e2031c7edc550c$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $d2e2031c7edc550c$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    (0, $b8b7ee5b6a60bf78$export$831dc9f2ab0a617b)(async ()=>{
        try {
            // Capture current event buffer as new replay
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $d2e2031c7edc550c$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$d2e2031c7edc550c$var$isErrorEvent(event)) return;
        $d2e2031c7edc550c$var$handleHydrationError(replay, event);
    };
}
function $d2e2031c7edc550c$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $d2e2031c7edc550c$var$createBreadcrumb({
            category: "replay.hydrate-error",
            data: {
                url: (0, $83913a7139f39e6c$export$1cfafeee2987818b)()
            }
        });
        $d2e2031c7edc550c$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $d2e2031c7edc550c$var$handleBreadcrumbs(replay) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", (breadcrumb)=>$d2e2031c7edc550c$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $d2e2031c7edc550c$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$d2e2031c7edc550c$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $d2e2031c7edc550c$var$normalizeBreadcrumb(breadcrumb);
    if (result) $d2e2031c7edc550c$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $d2e2031c7edc550c$var$normalizeBreadcrumb(breadcrumb) {
    if (!$d2e2031c7edc550c$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $d2e2031c7edc550c$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $d2e2031c7edc550c$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $d2e2031c7edc550c$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $d2e2031c7edc550c$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $d2e2031c7edc550c$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $d2e2031c7edc550c$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $4c0d7eab065d1a33$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $d2e2031c7edc550c$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $d2e2031c7edc550c$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $d2e2031c7edc550c$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
function $d2e2031c7edc550c$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $d2e2031c7edc550c$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $d2e2031c7edc550c$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $d2e2031c7edc550c$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $d2e2031c7edc550c$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $d2e2031c7edc550c$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $d2e2031c7edc550c$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $d2e2031c7edc550c$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled or paused
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($d2e2031c7edc550c$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$d2e2031c7edc550c$var$isErrorEvent(event) && !$d2e2031c7edc550c$var$isTransactionEvent(event) && !$d2e2031c7edc550c$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($d2e2031c7edc550c$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $d2e2031c7edc550c$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($d2e2031c7edc550c$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.log("Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $d2e2031c7edc550c$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $d2e2031c7edc550c$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $d2e2031c7edc550c$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $d2e2031c7edc550c$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $d2e2031c7edc550c$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $d2e2031c7edc550c$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $d2e2031c7edc550c$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $d2e2031c7edc550c$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($d2e2031c7edc550c$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $6ccaa31f5abf35f3$export$d92e61f5600202af)(url, (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $d2e2031c7edc550c$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($d2e2031c7edc550c$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $d2e2031c7edc550c$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $d2e2031c7edc550c$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $d2e2031c7edc550c$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $d2e2031c7edc550c$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $d2e2031c7edc550c$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $d2e2031c7edc550c$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $d2e2031c7edc550c$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $d2e2031c7edc550c$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $212518d61e73b76e$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $d2e2031c7edc550c$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $d2e2031c7edc550c$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $d2e2031c7edc550c$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $d2e2031c7edc550c$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $d2e2031c7edc550c$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $d2e2031c7edc550c$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $d2e2031c7edc550c$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $d2e2031c7edc550c$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e2) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $d2e2031c7edc550c$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $d2e2031c7edc550c$var$urlMatches(url, urls) {
    const fullUrl = $d2e2031c7edc550c$var$getFullUrl(url);
    return (0, $df92c5c0ba822dfa$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $d2e2031c7edc550c$var$getFullUrl(url, baseURI = $d2e2031c7edc550c$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($d2e2031c7edc550c$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $d2e2031c7edc550c$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $d2e2031c7edc550c$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $d2e2031c7edc550c$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $d2e2031c7edc550c$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to capture fetch breadcrumb");
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $d2e2031c7edc550c$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? $d2e2031c7edc550c$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $d2e2031c7edc550c$var$getBodySize(body);
    const resSize = response ? $d2e2031c7edc550c$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $d2e2031c7edc550c$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $d2e2031c7edc550c$var$urlMatches(url, options.networkDetailAllowUrls) && !$d2e2031c7edc550c$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $d2e2031c7edc550c$var$_getRequestInfo(options, hint.input, requestBodySize) : $d2e2031c7edc550c$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $d2e2031c7edc550c$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $d2e2031c7edc550c$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $d2e2031c7edc550c$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $d2e2031c7edc550c$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $d2e2031c7edc550c$var$getBodyString(requestBody);
    const data = $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $d2e2031c7edc550c$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $d2e2031c7edc550c$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $d2e2031c7edc550c$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $d2e2031c7edc550c$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $d2e2031c7edc550c$var$_parseFetchResponseBody(response);
    const result = $d2e2031c7edc550c$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $d2e2031c7edc550c$var$mergeWarning(result, warning);
    return result;
}
function $d2e2031c7edc550c$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $d2e2031c7edc550c$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $d2e2031c7edc550c$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to serialize response body");
        // fallback
        return $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $d2e2031c7edc550c$var$_parseFetchResponseBody(response) {
    const res = $d2e2031c7edc550c$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $d2e2031c7edc550c$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.warn("Parsing text body from response timed out");
            return [
                undefined,
                "BODY_PARSE_TIMEOUT"
            ];
        }
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to get text body from response");
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $d2e2031c7edc550c$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $d2e2031c7edc550c$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $d2e2031c7edc550c$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $d2e2031c7edc550c$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $d2e2031c7edc550c$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $d2e2031c7edc550c$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $d2e2031c7edc550c$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $d2e2031c7edc550c$var$getAllowedHeaders(headers, allowedHeaders);
}
function $d2e2031c7edc550c$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to clone response body");
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $d2e2031c7edc550c$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $b8b7ee5b6a60bf78$export$831dc9f2ab0a617b)(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $d2e2031c7edc550c$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $d2e2031c7edc550c$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $d2e2031c7edc550c$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $d2e2031c7edc550c$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $d2e2031c7edc550c$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $d2e2031c7edc550c$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to capture xhr breadcrumb");
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $d2e2031c7edc550c$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $d2e2031c7edc550c$var$getBodySize(input);
    const resSize = xhr.getResponseHeader("content-length") ? $d2e2031c7edc550c$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $d2e2031c7edc550c$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $d2e2031c7edc550c$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$d2e2031c7edc550c$var$urlMatches(url, options.networkDetailAllowUrls) || $d2e2031c7edc550c$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $d2e2031c7edc550c$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $d2e2031c7edc550c$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $211d7e01eb8e4d9d$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $d2e2031c7edc550c$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $d2e2031c7edc550c$var$getAllowedHeaders($d2e2031c7edc550c$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $d2e2031c7edc550c$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $d2e2031c7edc550c$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $d2e2031c7edc550c$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $d2e2031c7edc550c$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $d2e2031c7edc550c$var$mergeWarning(response, responseWarning) : response
    };
}
function $d2e2031c7edc550c$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $d2e2031c7edc550c$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $d2e2031c7edc550c$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.warn("Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $d2e2031c7edc550c$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error, "Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $d2e2031c7edc550c$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $d2e2031c7edc550c$var$getBodySize(bodyStr);
    } catch (e2) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $d2e2031c7edc550c$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$d2e2031c7edc550c$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $d2e2031c7edc550c$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($d2e2031c7edc550c$var$_isXhrBreadcrumb(breadcrumb) && $d2e2031c7edc550c$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $d2e2031c7edc550c$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $d2e2031c7edc550c$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($d2e2031c7edc550c$var$_isFetchBreadcrumb(breadcrumb) && $d2e2031c7edc550c$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $d2e2031c7edc550c$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $d2e2031c7edc550c$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(e, "Error when enriching network breadcrumb");
    }
}
function $d2e2031c7edc550c$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $d2e2031c7edc550c$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $d2e2031c7edc550c$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $d2e2031c7edc550c$var$_isFetchHint(hint) {
    return hint && hint.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $d2e2031c7edc550c$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    (0, $da61a269929582d0$export$5aeffd3db2cf9df7)($d2e2031c7edc550c$var$handleDomListener(replay));
    (0, $9c43746b6e1807b7$export$3f18c56c58114e75)($d2e2031c7edc550c$var$handleHistorySpanListener(replay));
    $d2e2031c7edc550c$var$handleBreadcrumbs(replay);
    $d2e2031c7edc550c$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $d2e2031c7edc550c$var$handleGlobalEventListener(replay);
    (0, $a2753be55d715def$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on("beforeSendEvent", $d2e2031c7edc550c$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $d2e2031c7edc550c$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("spanStart", (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on("spanEnd", (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $d2e2031c7edc550c$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($d2e2031c7edc550c$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $d2e2031c7edc550c$var$createMemoryEntry($d2e2031c7edc550c$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $d2e2031c7edc550c$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $d2e2031c7edc550c$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = (0, $b8b7ee5b6a60bf78$export$831dc9f2ab0a617b)(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = (0, $b8b7ee5b6a60bf78$export$831dc9f2ab0a617b)(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $d2e2031c7edc550c$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.warn("Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $d2e2031c7edc550c$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$d2e2031c7edc550c$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            const session = replay.session;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time. We have an experimental mode
            // to perform multiple checkouts a session (the idea is to improve
            // seeking during playback), so also only include if segmentId is 0
            // (handled in `addSettingsEvent`).
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $d2e2031c7edc550c$var$addSettingsEvent(replay, isCheckout);
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $d2e2031c7edc550c$var$saveSession(session);
                }
            }
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (session && session.previousSessionId) return true;
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $d2e2031c7edc550c$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $d2e2031c7edc550c$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $d2e2031c7edc550c$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $d2e2031c7edc550c$var$addEventSync(replay, $d2e2031c7edc550c$var$createOptionsEvent(replay), false);
}
/**
 * Reset the `replay_id` field on the DSC.
 */ function $d2e2031c7edc550c$var$resetReplayIdOnDynamicSamplingContext() {
    // Reset DSC on the current scope, if there is one
    const dsc = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    // Clear it from frozen DSC on the active span
    const activeSpan = (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc = (0, $896c8118669d0430$export$a117f995597e25df)(activeSpan);
        delete dsc.replay_id;
    }
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $d2e2031c7edc550c$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $ac9400386ed4faec$export$f93f7f385160c44e)((0, $ac9400386ed4faec$export$92b6093782fe661b)(replayEvent, (0, $ac9400386ed4faec$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $d2e2031c7edc550c$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $d2e2031c7edc550c$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $9ca12f9fb5d46a07$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $4d085f2ea319a6b5$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $d2e2031c7edc550c$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $d2e2031c7edc550c$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    const scope = (0, $4d085f2ea319a6b5$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)({});
    const baseEvent = {
        type: $d2e2031c7edc550c$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $d2e2031c7edc550c$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("An event processor returned `null`, will not send event.");
        return (0, $2ad57a53fafc2702$export$1fda8aa4d135f8aa)({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $d2e2031c7edc550c$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($d2e2031c7edc550c$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $d2e2031c7edc550c$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $883882786b17df09$export$699aff705e0d49d4)({}, response);
    if ((0, $883882786b17df09$export$6c91fec22056810a)(rateLimits, "replay")) throw new $d2e2031c7edc550c$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $d2e2031c7edc550c$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $d2e2031c7edc550c$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $d2e2031c7edc550c$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $d2e2031c7edc550c$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $d2e2031c7edc550c$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $d2e2031c7edc550c$var$TransportStatusCodeError || err instanceof $d2e2031c7edc550c$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $a2753be55d715def$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $d2e2031c7edc550c$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$d2e2031c7edc550c$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $b8b7ee5b6a60bf78$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $d2e2031c7edc550c$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $d2e2031c7edc550c$var$THROTTLED = "__THROTTLED";
const $d2e2031c7edc550c$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d2e2031c7edc550c$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $d2e2031c7edc550c$var$SKIPPED : $d2e2031c7edc550c$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $d2e2031c7edc550c$var$ReplayContainer {
    /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $d2e2031c7edc550c$var$ReplayContainer.prototype.__init.call(this);
        $d2e2031c7edc550c$var$ReplayContainer.prototype.__init2.call(this);
        $d2e2031c7edc550c$var$ReplayContainer.prototype.__init3.call(this);
        $d2e2031c7edc550c$var$ReplayContainer.prototype.__init4.call(this);
        $d2e2031c7edc550c$var$ReplayContainer.prototype.__init5.call(this);
        $d2e2031c7edc550c$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $d2e2031c7edc550c$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $d2e2031c7edc550c$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $d2e2031c7edc550c$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $d2e2031c7edc550c$var$throttle((event, isCheckout)=>$d2e2031c7edc550c$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($d2e2031c7edc550c$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $d2e2031c7edc550c$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $d2e2031c7edc550c$var$ClickDetector(this, slowClickConfig);
        // Configure replay logger w/ experimental options
        if ($d2e2031c7edc550c$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $d2e2031c7edc550c$var$logger.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.exception(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Recording is already in progress");
            return;
        }
        if (this._isEnabled && this.recordingMode === "buffer") {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.infoTick("Starting replay in session mode");
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $d2e2031c7edc550c$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.infoTick("Starting replay in buffer mode");
        const session = $d2e2031c7edc550c$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $d2e2031c7edc550c$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" ? {
                    checkoutEveryNms: $d2e2031c7edc550c$var$BUFFER_CHECKOUT_TIME
                } : // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
                },
                emit: $d2e2031c7edc550c$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info(`Stopping Replay${reason ? ` triggered by ${reason}` : ""}`);
            $d2e2031c7edc550c$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $d2e2031c7edc550c$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Pausing replay");
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Resuming replay");
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Converting buffer to session");
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $d2e2031c7edc550c$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$d2e2031c7edc550c$var$WINDOW.location.pathname}${$d2e2031c7edc550c$var$WINDOW.location.hash}${$d2e2031c7edc550c$var$WINDOW.location.search}`;
        const url = `${$d2e2031c7edc550c$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $d2e2031c7edc550c$var$THROTTLED) {
            const breadcrumb = $d2e2031c7edc550c$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$d2e2031c7edc550c$var$addEventSync(this, {
                    type: $d2e2031c7edc550c$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $5563dd3c937fc83c$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $5563dd3c937fc83c$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $5563dd3c937fc83c$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $48bb799067430277$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $5563dd3c937fc83c$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $d2e2031c7edc550c$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $d2e2031c7edc550c$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($d2e2031c7edc550c$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $d2e2031c7edc550c$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $d2e2031c7edc550c$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $d2e2031c7edc550c$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $d2e2031c7edc550c$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $d2e2031c7edc550c$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $d2e2031c7edc550c$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $d2e2031c7edc550c$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $d2e2031c7edc550c$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $d2e2031c7edc550c$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $d2e2031c7edc550c$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($d2e2031c7edc550c$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $d2e2031c7edc550c$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $d2e2031c7edc550c$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $d2e2031c7edc550c$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $d2e2031c7edc550c$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $d2e2031c7edc550c$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $d2e2031c7edc550c$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // If we are manually starting, we want to ensure we only include performance entries
        // that are after the initial timestamp
        // The reason for this is that we may have performance entries from the page load, but may decide to start
        // the replay later on, in which case we do not want to include these entries.
        // without this, manually started replays can have events long before the actual replay recording starts,
        // which messes with the timeline etc.
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1000;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($d2e2031c7edc550c$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        // If replay was started manually (=no sample rate was given),
        // We do not want to back-port the initial timestamp
        if (!session || !eventBuffer || this._requiresManualStart) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.error("No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $d2e2031c7edc550c$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accommodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $d2e2031c7edc550c$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
            if (client) {
                const dropReason = err instanceof $d2e2031c7edc550c$var$RateLimitError ? "ratelimit_backoff" : "send_error";
                client.recordDroppedEvent(dropReason, "replay");
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.error("Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info(`Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $d2e2031c7edc550c$var$DEBUG_BUILD && $d2e2031c7edc550c$var$logger.info("Flushing initial segment without checkout.");
            const _flushInProgress = !!this._flushLock;
            // this._flushLock acts as a lock so that future calls to `_flush()` will
            // be blocked until current flush is finished (i.e. this promise resolves)
            if (!this._flushLock) this._flushLock = this._runFlush();
            try {
                await this._flushLock;
            } catch (err) {
                this.handleException(err);
            } finally{
                this._flushLock = undefined;
                if (_flushInProgress) // Wait for previous flush to finish, then call the debounced
                // `_flush()`. It's possible there are other flush requests queued and
                // waiting for it to resolve. We want to reduce all outstanding
                // requests (as well as any new flush requests that occur within a
                // second of the locked flush completing) into a single flush.
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $d2e2031c7edc550c$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $d2e2031c7edc550c$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $d2e2031c7edc550c$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $d2e2031c7edc550c$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $d2e2031c7edc550c$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    const unmaskSelector = $d2e2031c7edc550c$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $d2e2031c7edc550c$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ]),
        unblockSelector: $d2e2031c7edc550c$var$getOption(unblock, []),
        ignoreSelector: $d2e2031c7edc550c$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $d2e2031c7edc550c$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precedence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $d2e2031c7edc550c$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $d2e2031c7edc550c$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $d2e2031c7edc550c$var$_initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $d2e2031c7edc550c$export$d7706faf7ab354bf = (options)=>{
    return new $d2e2031c7edc550c$var$Replay(options);
};
/**
 * Replay integration
 *
 * TODO: Rewrite this to be functional integration
 * Exported for tests.
 */ class $d2e2031c7edc550c$var$Replay {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $d2e2031c7edc550c$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $d2e2031c7edc550c$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $d2e2031c7edc550c$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $d2e2031c7edc550c$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError } = {}){
        this.name = $d2e2031c7edc550c$var$Replay.id;
        const privacyOptions = $d2e2031c7edc550c$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$d2e2031c7edc550c$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $d2e2031c7edc550c$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $d2e2031c7edc550c$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $d2e2031c7edc550c$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $d2e2031c7edc550c$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $d2e2031c7edc550c$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$d2e2031c7edc550c$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $2eff0ce3a5f6e8d5$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $d2e2031c7edc550c$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $d2e2031c7edc550c$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $2eff0ce3a5f6e8d5$export$4e09c449d6c407f7)() || this._replay) return;
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        // assuming a session should be recorded in this case
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.recordingMode;
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $d2e2031c7edc550c$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $d2e2031c7edc550c$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$d2e2031c7edc550c$var$Replay.__initStatic();
/** Parse Replay-related options from SDK options */ function $d2e2031c7edc550c$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $212518d61e73b76e$export$d25f2688db1bb433)(initialOptions)
    };
    const replaysSessionSampleRate = (0, $aa7e579fce63739a$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $aa7e579fce63739a$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $fe5d055940839409$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $d2e2031c7edc550c$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$d2e2031c7edc550c$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $d2e2031c7edc550c$export$b28310b2f161456b() {
    const client = (0, $4d085f2ea319a6b5$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName("Replay");
}


const $1813fa57023b067c$var$uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function $1813fa57023b067c$export$4143f540b2febe77(uuid) {
    return $1813fa57023b067c$var$uuidPattern.test(uuid);
}
// Based on https://abhishekdutta.org/blog/standalone_uuid_generator_in_javascript.html
// IE11 and Modern Browsers Only
function $1813fa57023b067c$export$19f53698e68b2496() {
    var temp_url = URL.createObjectURL(new Blob());
    var uuid = temp_url.toString();
    URL.revokeObjectURL(temp_url);
    return uuid.split(/[:\/]/g).pop().toLowerCase(); // remove prefixes
}
$1813fa57023b067c$export$19f53698e68b2496.valid = $1813fa57023b067c$export$4143f540b2febe77;
var $1813fa57023b067c$export$2e2bcd8739ae039 = $1813fa57023b067c$export$19f53698e68b2496;



var $gIfym = parcelRequire("gIfym");
var $1644e4e8cc85fb30$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $1644e4e8cc85fb30$var$__DEV__ = false;
var $1644e4e8cc85fb30$var$warning = function() {};
if ($1644e4e8cc85fb30$var$__DEV__) {
    var $1644e4e8cc85fb30$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $1644e4e8cc85fb30$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $1644e4e8cc85fb30$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$1644e4e8cc85fb30$exports = $1644e4e8cc85fb30$var$warning;



var $gIfym = parcelRequire("gIfym");
var $c65bfe520546a474$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c65bfe520546a474$var$ReactIs, $c65bfe520546a474$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c65bfe520546a474$exports = (parcelRequire("kh2Rv"))();


function $e97d362134fa57b8$export$2e2bcd8739ae039() {
    return $e97d362134fa57b8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e97d362134fa57b8$export$2e2bcd8739ae039.apply(null, arguments);
}


function $311de12acff63357$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $311de12acff63357$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $311de12acff63357$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $311de12acff63357$var$isAbsolute(to);
    var isFromAbs = from && $311de12acff63357$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $311de12acff63357$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $311de12acff63357$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $311de12acff63357$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $311de12acff63357$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$311de12acff63357$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $311de12acff63357$export$2e2bcd8739ae039 = $311de12acff63357$var$resolvePathname;


function $d55b595ca7b534d5$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $d55b595ca7b534d5$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $d55b595ca7b534d5$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $d55b595ca7b534d5$var$valueOf(a);
        var bValue = $d55b595ca7b534d5$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $d55b595ca7b534d5$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $d55b595ca7b534d5$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $d55b595ca7b534d5$export$2e2bcd8739ae039 = $d55b595ca7b534d5$var$valueEqual;



var $51137fdf63eaf269$var$isProduction = true;
var $51137fdf63eaf269$var$prefix = "Invariant failed";
function $51137fdf63eaf269$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($51137fdf63eaf269$var$isProduction) throw new Error($51137fdf63eaf269$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($51137fdf63eaf269$var$prefix, ": ").concat(provided) : $51137fdf63eaf269$var$prefix;
    throw new Error(value);
}


function $c0e5765fb75ef8ef$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $c0e5765fb75ef8ef$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $c0e5765fb75ef8ef$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $c0e5765fb75ef8ef$var$stripBasename(path, prefix) {
    return $c0e5765fb75ef8ef$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $c0e5765fb75ef8ef$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $c0e5765fb75ef8ef$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $c0e5765fb75ef8ef$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $c0e5765fb75ef8ef$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $311de12acff63357$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $c0e5765fb75ef8ef$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $d55b595ca7b534d5$export$2e2bcd8739ae039)(a.state, b.state);
}
function $c0e5765fb75ef8ef$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $c0e5765fb75ef8ef$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $c0e5765fb75ef8ef$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $c0e5765fb75ef8ef$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $c0e5765fb75ef8ef$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $c0e5765fb75ef8ef$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $c0e5765fb75ef8ef$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $c0e5765fb75ef8ef$var$PopStateEvent = "popstate";
var $c0e5765fb75ef8ef$var$HashChangeEvent = "hashchange";
function $c0e5765fb75ef8ef$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $c0e5765fb75ef8ef$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$c0e5765fb75ef8ef$var$canUseDOM && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $c0e5765fb75ef8ef$var$supportsHistory();
    var needsHashChangeListener = !$c0e5765fb75ef8ef$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $c0e5765fb75ef8ef$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $c0e5765fb75ef8ef$var$stripTrailingSlash($c0e5765fb75ef8ef$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $c0e5765fb75ef8ef$var$stripBasename(path, basename);
        return $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $c0e5765fb75ef8ef$var$createTransitionManager();
    function setState(nextState) {
        (0, $e97d362134fa57b8$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($c0e5765fb75ef8ef$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($c0e5765fb75ef8ef$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($c0e5765fb75ef8ef$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $c0e5765fb75ef8ef$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($c0e5765fb75ef8ef$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($c0e5765fb75ef8ef$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($c0e5765fb75ef8ef$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($c0e5765fb75ef8ef$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $c0e5765fb75ef8ef$var$HashChangeEvent$1 = "hashchange";
var $c0e5765fb75ef8ef$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $c0e5765fb75ef8ef$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $c0e5765fb75ef8ef$var$stripLeadingSlash,
        decodePath: $c0e5765fb75ef8ef$var$addLeadingSlash
    },
    slash: {
        encodePath: $c0e5765fb75ef8ef$var$addLeadingSlash,
        decodePath: $c0e5765fb75ef8ef$var$addLeadingSlash
    }
};
function $c0e5765fb75ef8ef$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $c0e5765fb75ef8ef$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $c0e5765fb75ef8ef$var$pushHashPath(path) {
    window.location.hash = path;
}
function $c0e5765fb75ef8ef$var$replaceHashPath(path) {
    window.location.replace($c0e5765fb75ef8ef$var$stripHash(window.location.href) + "#" + path);
}
function $c0e5765fb75ef8ef$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$c0e5765fb75ef8ef$var$canUseDOM && (0, $51137fdf63eaf269$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $c0e5765fb75ef8ef$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $c0e5765fb75ef8ef$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $c0e5765fb75ef8ef$var$stripTrailingSlash($c0e5765fb75ef8ef$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $c0e5765fb75ef8ef$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($c0e5765fb75ef8ef$var$getHashPath());
        if (basename) path = $c0e5765fb75ef8ef$var$stripBasename(path, basename);
        return $c0e5765fb75ef8ef$export$90c043f1c57770b8(path);
    }
    var transitionManager = $c0e5765fb75ef8ef$var$createTransitionManager();
    function setState(nextState) {
        (0, $e97d362134fa57b8$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $c0e5765fb75ef8ef$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $c0e5765fb75ef8ef$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $c0e5765fb75ef8ef$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($c0e5765fb75ef8ef$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($c0e5765fb75ef8ef$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $c0e5765fb75ef8ef$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $c0e5765fb75ef8ef$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $c0e5765fb75ef8ef$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $c0e5765fb75ef8ef$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $c0e5765fb75ef8ef$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $c0e5765fb75ef8ef$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $c0e5765fb75ef8ef$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $c0e5765fb75ef8ef$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($c0e5765fb75ef8ef$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $c0e5765fb75ef8ef$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $c0e5765fb75ef8ef$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $c0e5765fb75ef8ef$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($c0e5765fb75ef8ef$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($c0e5765fb75ef8ef$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($c0e5765fb75ef8ef$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $c0e5765fb75ef8ef$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $c0e5765fb75ef8ef$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $c0e5765fb75ef8ef$var$createTransitionManager();
    function setState(nextState) {
        (0, $e97d362134fa57b8$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $c0e5765fb75ef8ef$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $c0e5765fb75ef8ef$export$90c043f1c57770b8(entry, undefined, createKey()) : $c0e5765fb75ef8ef$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $c0e5765fb75ef8ef$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $c0e5765fb75ef8ef$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $c0e5765fb75ef8ef$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}


// Written in this round about way for babel-transform-imports

var $8f76fb1a5ab0d9df$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $8f76fb1a5ab0d9df$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$8f76fb1a5ab0d9df$exports = $8f76fb1a5ab0d9df$var$invariant;



var $gIfym = parcelRequire("gIfym");

var $fcbfef01c179dfb6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $fcbfef01c179dfb6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fcbfef01c179dfb6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fcbfef01c179dfb6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $fcbfef01c179dfb6$var$Router = function(_React$Component) {
    $fcbfef01c179dfb6$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $fcbfef01c179dfb6$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $fcbfef01c179dfb6$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $fcbfef01c179dfb6$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $fcbfef01c179dfb6$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($8f76fb1a5ab0d9df$exports)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$fcbfef01c179dfb6$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node
};
$fcbfef01c179dfb6$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
};
$fcbfef01c179dfb6$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired
};
var $fcbfef01c179dfb6$export$2e2bcd8739ae039 = $fcbfef01c179dfb6$var$Router;


var $cef74eeabd975cb8$export$2e2bcd8739ae039 = (0, $fcbfef01c179dfb6$export$2e2bcd8739ae039);


function $5a45d2e41d002d73$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a45d2e41d002d73$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5a45d2e41d002d73$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $5a45d2e41d002d73$var$BrowserRouter = function(_React$Component) {
    $5a45d2e41d002d73$var$_inherits(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _temp, _this, _ret;
        $5a45d2e41d002d73$var$_classCallCheck(this, BrowserRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $5a45d2e41d002d73$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.history = (0, $c0e5765fb75ef8ef$export$719fc203c4e16dee)(_this.props), _temp), $5a45d2e41d002d73$var$_possibleConstructorReturn(_this, _ret);
    }
    BrowserRouter.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
    };
    BrowserRouter.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $cef74eeabd975cb8$export$2e2bcd8739ae039), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$5a45d2e41d002d73$var$BrowserRouter.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    forceRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    keyLength: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node
};
var $5a45d2e41d002d73$export$2e2bcd8739ae039 = $5a45d2e41d002d73$var$BrowserRouter;

// Written in this round about way for babel-transform-imports



var $gIfym = parcelRequire("gIfym");

var $e6cfae72bb80dad0$exports = {};
var $209070c8b0ec7001$exports = {};
$209070c8b0ec7001$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $e6cfae72bb80dad0$exports = $e6cfae72bb80dad0$var$pathToRegexp;
$e6cfae72bb80dad0$exports.parse = $e6cfae72bb80dad0$var$parse;
$e6cfae72bb80dad0$exports.compile = $e6cfae72bb80dad0$var$compile;
$e6cfae72bb80dad0$exports.tokensToFunction = $e6cfae72bb80dad0$var$tokensToFunction;
$e6cfae72bb80dad0$exports.tokensToRegExp = $e6cfae72bb80dad0$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $e6cfae72bb80dad0$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $e6cfae72bb80dad0$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $e6cfae72bb80dad0$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === "string" ? tokens[tokens.length - 1] : "");
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $e6cfae72bb80dad0$var$escapeGroup(pattern) : asterisk ? ".*" : $e6cfae72bb80dad0$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $e6cfae72bb80dad0$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return "[^" + $e6cfae72bb80dad0$var$escapeString(delimiter) + "]+?";
    return $e6cfae72bb80dad0$var$escapeString(prevText) + "|(?:(?!" + $e6cfae72bb80dad0$var$escapeString(prevText) + ")[^" + $e6cfae72bb80dad0$var$escapeString(delimiter) + "])+?";
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $e6cfae72bb80dad0$var$compile(str, options) {
    return $e6cfae72bb80dad0$var$tokensToFunction($e6cfae72bb80dad0$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $e6cfae72bb80dad0$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $e6cfae72bb80dad0$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $e6cfae72bb80dad0$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $e6cfae72bb80dad0$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $e6cfae72bb80dad0$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($209070c8b0ec7001$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $e6cfae72bb80dad0$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $e6cfae72bb80dad0$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $e6cfae72bb80dad0$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $e6cfae72bb80dad0$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $e6cfae72bb80dad0$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($e6cfae72bb80dad0$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $e6cfae72bb80dad0$var$flags(options));
    return $e6cfae72bb80dad0$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$stringToRegexp(path, keys, options) {
    return $e6cfae72bb80dad0$var$tokensToRegExp($e6cfae72bb80dad0$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$tokensToRegExp(tokens, keys, options) {
    if (!$209070c8b0ec7001$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $e6cfae72bb80dad0$var$escapeString(token);
        else {
            var prefix = $e6cfae72bb80dad0$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $e6cfae72bb80dad0$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $e6cfae72bb80dad0$var$attachKeys(new RegExp("^" + route, $e6cfae72bb80dad0$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $e6cfae72bb80dad0$var$pathToRegexp(path, keys, options) {
    if (!$209070c8b0ec7001$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $e6cfae72bb80dad0$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($209070c8b0ec7001$exports(path)) return $e6cfae72bb80dad0$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $e6cfae72bb80dad0$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $1566ed21ac543560$var$patternCache = {};
var $1566ed21ac543560$var$cacheLimit = 10000;
var $1566ed21ac543560$var$cacheCount = 0;
var $1566ed21ac543560$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $1566ed21ac543560$var$patternCache[cacheKey] || ($1566ed21ac543560$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($e6cfae72bb80dad0$exports)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($1566ed21ac543560$var$cacheCount < $1566ed21ac543560$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $1566ed21ac543560$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $1566ed21ac543560$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $1566ed21ac543560$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $1566ed21ac543560$export$2e2bcd8739ae039 = $1566ed21ac543560$var$matchPath;


var $e950b88d94f1601a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e950b88d94f1601a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e950b88d94f1601a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e950b88d94f1601a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e950b88d94f1601a$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $e950b88d94f1601a$var$Route = function(_React$Component) {
    $e950b88d94f1601a$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $e950b88d94f1601a$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $e950b88d94f1601a$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $e950b88d94f1601a$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $e950b88d94f1601a$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($8f76fb1a5ab0d9df$exports)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $1566ed21ac543560$export$2e2bcd8739ae039)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(!(this.props.component && this.props.children && !$e950b88d94f1601a$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(!(this.props.render && this.props.children && !$e950b88d94f1601a$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$e950b88d94f1601a$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$e950b88d94f1601a$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
};
$e950b88d94f1601a$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
    })
};
$e950b88d94f1601a$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired
};
var $e950b88d94f1601a$export$2e2bcd8739ae039 = $e950b88d94f1601a$var$Route;


var $4d8a4f59b4c9f185$export$2e2bcd8739ae039 = (0, $e950b88d94f1601a$export$2e2bcd8739ae039);

// Written in this round about way for babel-transform-imports

var $gIfym = parcelRequire("gIfym");




function $093c3be768d545a1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $093c3be768d545a1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $093c3be768d545a1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $093c3be768d545a1$var$Switch = function(_React$Component) {
    $093c3be768d545a1$var$_inherits(Switch, _React$Component);
    function Switch() {
        $093c3be768d545a1$var$_classCallCheck(this, Switch);
        return $093c3be768d545a1$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($8f76fb1a5ab0d9df$exports)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $1566ed21ac543560$export$2e2bcd8739ae039)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$093c3be768d545a1$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object.isRequired
    }).isRequired
};
$093c3be768d545a1$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
};
var $093c3be768d545a1$export$2e2bcd8739ae039 = $093c3be768d545a1$var$Switch;


var $2cd531af13324c98$export$2e2bcd8739ae039 = (0, $093c3be768d545a1$export$2e2bcd8739ae039);



var $gIfym = parcelRequire("gIfym");
var $2d222ef6f692482f$exports = {};
"use strict";

$2d222ef6f692482f$exports = (parcelRequire("95oGi"));



var $gIfym = parcelRequire("gIfym");
var $b26ea600167d1d07$exports = {};
//
$b26ea600167d1d07$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $f83085fa594fc566$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $f83085fa594fc566$export$2e2bcd8739ae039 = $f83085fa594fc566$var$stylis_min;


var $f65a01e764c0ea5c$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $f65a01e764c0ea5c$export$2e2bcd8739ae039 = $f65a01e764c0ea5c$var$unitlessKeys;


function $e5f07e826c95f725$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $e5f07e826c95f725$export$2e2bcd8739ae039 = $e5f07e826c95f725$var$memoize;


var $ab1c14456d23888f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $ab1c14456d23888f$var$index = (0, $e5f07e826c95f725$export$2e2bcd8739ae039)(function(prop) {
    return $ab1c14456d23888f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $ab1c14456d23888f$export$2e2bcd8739ae039 = $ab1c14456d23888f$var$index;


var $8370cfca71108aac$exports = {};
"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $8370cfca71108aac$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $8370cfca71108aac$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $8370cfca71108aac$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $8370cfca71108aac$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $8370cfca71108aac$var$TYPE_STATICS = {};
$8370cfca71108aac$var$TYPE_STATICS[$2d222ef6f692482f$exports.ForwardRef] = $8370cfca71108aac$var$FORWARD_REF_STATICS;
$8370cfca71108aac$var$TYPE_STATICS[$2d222ef6f692482f$exports.Memo] = $8370cfca71108aac$var$MEMO_STATICS;
function $8370cfca71108aac$var$getStatics(component) {
    // React v16.11 and below
    if ($2d222ef6f692482f$exports.isMemo(component)) return $8370cfca71108aac$var$MEMO_STATICS;
     // React v16.12 and above
    return $8370cfca71108aac$var$TYPE_STATICS[component["$$typeof"]] || $8370cfca71108aac$var$REACT_STATICS;
}
var $8370cfca71108aac$var$defineProperty = Object.defineProperty;
var $8370cfca71108aac$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $8370cfca71108aac$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8370cfca71108aac$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8370cfca71108aac$var$getPrototypeOf = Object.getPrototypeOf;
var $8370cfca71108aac$var$objectPrototype = Object.prototype;
function $8370cfca71108aac$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($8370cfca71108aac$var$objectPrototype) {
            var inheritedComponent = $8370cfca71108aac$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $8370cfca71108aac$var$objectPrototype) $8370cfca71108aac$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $8370cfca71108aac$var$getOwnPropertyNames(sourceComponent);
        if ($8370cfca71108aac$var$getOwnPropertySymbols) keys = keys.concat($8370cfca71108aac$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $8370cfca71108aac$var$getStatics(targetComponent);
        var sourceStatics = $8370cfca71108aac$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$8370cfca71108aac$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $8370cfca71108aac$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $8370cfca71108aac$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$8370cfca71108aac$exports = $8370cfca71108aac$var$hoistNonReactStatics;



var $17tgv = parcelRequire("17tgv");
function $cc85e8b8e7405a89$var$_extends() {
    $cc85e8b8e7405a89$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cc85e8b8e7405a89$var$_extends.apply(this, arguments);
}
function $cc85e8b8e7405a89$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// 
var $cc85e8b8e7405a89$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $cc85e8b8e7405a89$var$isPlainObject = function(x) {
    return x !== null && typeof x === "object" && (x.toString ? x.toString() : Object.prototype.toString.call(x)) === "[object Object]" && !(0, $2d222ef6f692482f$exports.typeOf)(x);
};
// 
var $cc85e8b8e7405a89$var$EMPTY_ARRAY = Object.freeze([]);
var $cc85e8b8e7405a89$var$EMPTY_OBJECT = Object.freeze({});
// 
function $cc85e8b8e7405a89$var$isFunction(test) {
    return typeof test === "function";
}
// 
function $cc85e8b8e7405a89$var$getComponentName(target) {
    return(// $FlowFixMe
    (0, target.displayName) || // $FlowFixMe
    target.name || "Component");
}
// 
function $cc85e8b8e7405a89$var$isStatelessFunction(test) {
    return typeof test === "function" && !(test.prototype && test.prototype.isReactComponent);
}
// 
function $cc85e8b8e7405a89$export$7ba318d8d2f06c76(target) {
    return target && typeof target.styledComponentId === "string";
}
// 
var $cc85e8b8e7405a89$var$SC_ATTR = (typeof $17tgv !== "undefined" && undefined, "data-styled");
var $cc85e8b8e7405a89$var$SC_ATTR_ACTIVE = "active";
var $cc85e8b8e7405a89$var$SC_ATTR_VERSION = "data-styled-version";
var $cc85e8b8e7405a89$var$SC_VERSION = "5.1.1";
var $cc85e8b8e7405a89$var$SPLITTER = "/*!sc*/\n";
var $cc85e8b8e7405a89$var$IS_BROWSER = typeof window !== "undefined" && "HTMLElement" in window;
var $cc85e8b8e7405a89$var$DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === "boolean" && SC_DISABLE_SPEEDY || typeof $17tgv !== "undefined" && undefined || false; // Shared empty execution context when generating static styles
var $cc85e8b8e7405a89$var$STATIC_EXECUTION_CONTEXT = {};
// 
/* eslint-disable camelcase, no-undef */ var $cc85e8b8e7405a89$var$getNonce = function getNonce() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;
};
var $cc85e8b8e7405a89$var$errorMap = {
    "1": "Cannot create styled-component for component: %s.\n\n",
    "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    "7": 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    "8": 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    "9": "Missing document `<head>`\n\n",
    "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    "14": 'ThemeProvider: "theme" prop is required.\n\n',
    "15": "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    "16": "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    "17": "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
};
// 
var $cc85e8b8e7405a89$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $cc85e8b8e7405a89$var$format() {
    var a = arguments.length <= 0 ? undefined : arguments[0];
    var b = [];
    for(var c = 1, len = arguments.length; c < len; c += 1)b.push(c < 0 || arguments.length <= c ? undefined : arguments[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ function $cc85e8b8e7405a89$var$throwStyledComponentsError(code) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    throw new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + code + " for more information." + (interpolations.length > 0 ? " Additional arguments: " + interpolations.join(", ") : ""));
}
// 
var $cc85e8b8e7405a89$var$ELEMENT_TYPE = 1;
/* Node.ELEMENT_TYPE */ /** Find last style element if any inside target */ var $cc85e8b8e7405a89$var$findLastStyleTag = function findLastStyleTag(target) {
    var childNodes = target.childNodes;
    for(var i = childNodes.length; i >= 0; i--){
        var child = childNodes[i];
        if (child && child.nodeType === $cc85e8b8e7405a89$var$ELEMENT_TYPE && child.hasAttribute($cc85e8b8e7405a89$var$SC_ATTR)) return child;
    }
    return undefined;
};
/** Create a style element inside `target` or <head> after the last */ var $cc85e8b8e7405a89$var$makeStyleTag = function makeStyleTag(target) {
    var head = document.head;
    var parent = target || head;
    var style = document.createElement("style");
    var prevStyle = $cc85e8b8e7405a89$var$findLastStyleTag(parent);
    var nextSibling = prevStyle !== undefined ? prevStyle.nextSibling : null;
    style.setAttribute($cc85e8b8e7405a89$var$SC_ATTR, $cc85e8b8e7405a89$var$SC_ATTR_ACTIVE);
    style.setAttribute($cc85e8b8e7405a89$var$SC_ATTR_VERSION, $cc85e8b8e7405a89$var$SC_VERSION);
    var nonce = $cc85e8b8e7405a89$var$getNonce();
    if (nonce) style.setAttribute("nonce", nonce);
    parent.insertBefore(style, nextSibling);
    return style;
};
/** Get the CSSStyleSheet instance for a given style element */ var $cc85e8b8e7405a89$var$getSheet = function getSheet(tag) {
    if (tag.sheet) return tag.sheet;
     // Avoid Firefox quirk where the style element might not have a sheet property
    var _document = document, styleSheets = _document.styleSheets;
    for(var i = 0, l = styleSheets.length; i < l; i++){
        var sheet = styleSheets[i];
        if (sheet.ownerNode === tag) return sheet;
    }
    $cc85e8b8e7405a89$var$throwStyledComponentsError(17);
    return undefined;
};
// 
/** Create a CSSStyleSheet-like tag depending on the environment */ var $cc85e8b8e7405a89$var$makeTag = function makeTag(_ref) {
    var isServer = _ref.isServer, useCSSOMInjection = _ref.useCSSOMInjection, target = _ref.target;
    if (isServer) return new $cc85e8b8e7405a89$var$VirtualTag(target);
    else if (useCSSOMInjection) return new $cc85e8b8e7405a89$var$CSSOMTag(target);
    else return new $cc85e8b8e7405a89$var$TextTag(target);
};
var $cc85e8b8e7405a89$var$CSSOMTag = /*#__PURE__*/ function() {
    function CSSOMTag(target) {
        var element = this.element = $cc85e8b8e7405a89$var$makeStyleTag(target); // Avoid Edge bug where empty style elements don't create sheets
        element.appendChild(document.createTextNode(""));
        this.sheet = $cc85e8b8e7405a89$var$getSheet(element);
        this.length = 0;
    }
    var _proto = CSSOMTag.prototype;
    _proto.insertRule = function insertRule(index, rule) {
        try {
            this.sheet.insertRule(rule, index);
            this.length++;
            return true;
        } catch (_error) {
            return false;
        }
    };
    _proto.deleteRule = function deleteRule(index) {
        this.sheet.deleteRule(index);
        this.length--;
    };
    _proto.getRule = function getRule(index) {
        var rule = this.sheet.cssRules[index]; // Avoid IE11 quirk where cssText is inaccessible on some invalid rules
        if (rule !== undefined && typeof rule.cssText === "string") return rule.cssText;
        else return "";
    };
    return CSSOMTag;
}();
/** A Tag that emulates the CSSStyleSheet API but uses text nodes */ var $cc85e8b8e7405a89$var$TextTag = /*#__PURE__*/ function() {
    function TextTag(target) {
        var element = this.element = $cc85e8b8e7405a89$var$makeStyleTag(target);
        this.nodes = element.childNodes;
        this.length = 0;
    }
    var _proto2 = TextTag.prototype;
    _proto2.insertRule = function insertRule(index, rule) {
        if (index <= this.length && index >= 0) {
            var node = document.createTextNode(rule);
            var refNode = this.nodes[index];
            this.element.insertBefore(node, refNode || null);
            this.length++;
            return true;
        } else return false;
    };
    _proto2.deleteRule = function deleteRule(index) {
        this.element.removeChild(this.nodes[index]);
        this.length--;
    };
    _proto2.getRule = function getRule(index) {
        if (index < this.length) return this.nodes[index].textContent;
        else return "";
    };
    return TextTag;
}();
/** A completely virtual (server-side) Tag that doesn't manipulate the DOM */ var $cc85e8b8e7405a89$var$VirtualTag = /*#__PURE__*/ function() {
    function VirtualTag(_target) {
        this.rules = [];
        this.length = 0;
    }
    var _proto3 = VirtualTag.prototype;
    _proto3.insertRule = function insertRule(index, rule) {
        if (index <= this.length) {
            this.rules.splice(index, 0, rule);
            this.length++;
            return true;
        } else return false;
    };
    _proto3.deleteRule = function deleteRule(index) {
        this.rules.splice(index, 1);
        this.length--;
    };
    _proto3.getRule = function getRule(index) {
        if (index < this.length) return this.rules[index];
        else return "";
    };
    return VirtualTag;
}();
// 
/** Create a GroupedTag with an underlying Tag implementation */ var $cc85e8b8e7405a89$var$makeGroupedTag = function makeGroupedTag(tag) {
    return new $cc85e8b8e7405a89$var$DefaultGroupedTag(tag);
};
var $cc85e8b8e7405a89$var$BASE_SIZE = 512;
var $cc85e8b8e7405a89$var$DefaultGroupedTag = /*#__PURE__*/ function() {
    function DefaultGroupedTag(tag) {
        this.groupSizes = new Uint32Array($cc85e8b8e7405a89$var$BASE_SIZE);
        this.length = $cc85e8b8e7405a89$var$BASE_SIZE;
        this.tag = tag;
    }
    var _proto = DefaultGroupedTag.prototype;
    _proto.indexOfGroup = function indexOfGroup(group) {
        var index = 0;
        for(var i = 0; i < group; i++)index += this.groupSizes[i];
        return index;
    };
    _proto.insertRules = function insertRules(group, rules) {
        if (group >= this.groupSizes.length) {
            var oldBuffer = this.groupSizes;
            var oldSize = oldBuffer.length;
            var newSize = oldSize;
            while(group >= newSize){
                newSize <<= 1;
                if (newSize < 0) $cc85e8b8e7405a89$var$throwStyledComponentsError(16, "" + group);
            }
            this.groupSizes = new Uint32Array(newSize);
            this.groupSizes.set(oldBuffer);
            this.length = newSize;
            for(var i = oldSize; i < newSize; i++)this.groupSizes[i] = 0;
        }
        var ruleIndex = this.indexOfGroup(group + 1);
        for(var _i = 0, l = rules.length; _i < l; _i++)if (this.tag.insertRule(ruleIndex, rules[_i])) {
            this.groupSizes[group]++;
            ruleIndex++;
        }
    };
    _proto.clearGroup = function clearGroup(group) {
        if (group < this.length) {
            var length = this.groupSizes[group];
            var startIndex = this.indexOfGroup(group);
            var endIndex = startIndex + length;
            this.groupSizes[group] = 0;
            for(var i = startIndex; i < endIndex; i++)this.tag.deleteRule(startIndex);
        }
    };
    _proto.getGroup = function getGroup(group) {
        var css = "";
        if (group >= this.length || this.groupSizes[group] === 0) return css;
        var length = this.groupSizes[group];
        var startIndex = this.indexOfGroup(group);
        var endIndex = startIndex + length;
        for(var i = startIndex; i < endIndex; i++)css += "" + this.tag.getRule(i) + $cc85e8b8e7405a89$var$SPLITTER;
        return css;
    };
    return DefaultGroupedTag;
}();
// 
var $cc85e8b8e7405a89$var$MAX_SMI = 1073741824;
var $cc85e8b8e7405a89$var$groupIDRegister = new Map();
var $cc85e8b8e7405a89$var$reverseRegister = new Map();
var $cc85e8b8e7405a89$var$nextFreeGroup = 1;
var $cc85e8b8e7405a89$var$getGroupForId = function getGroupForId(id) {
    if ($cc85e8b8e7405a89$var$groupIDRegister.has(id)) return $cc85e8b8e7405a89$var$groupIDRegister.get(id);
    var group = $cc85e8b8e7405a89$var$nextFreeGroup++;
    $cc85e8b8e7405a89$var$groupIDRegister.set(id, group);
    $cc85e8b8e7405a89$var$reverseRegister.set(group, id);
    return group;
};
var $cc85e8b8e7405a89$var$getIdForGroup = function getIdForGroup(group) {
    return $cc85e8b8e7405a89$var$reverseRegister.get(group);
};
var $cc85e8b8e7405a89$var$setGroupForId = function setGroupForId(id, group) {
    if (group >= $cc85e8b8e7405a89$var$nextFreeGroup) $cc85e8b8e7405a89$var$nextFreeGroup = group + 1;
    $cc85e8b8e7405a89$var$groupIDRegister.set(id, group);
    $cc85e8b8e7405a89$var$reverseRegister.set(group, id);
};
// 
var $cc85e8b8e7405a89$var$SELECTOR = "style[" + $cc85e8b8e7405a89$var$SC_ATTR + "][" + $cc85e8b8e7405a89$var$SC_ATTR_VERSION + '="' + $cc85e8b8e7405a89$var$SC_VERSION + '"]';
var $cc85e8b8e7405a89$var$MARKER_RE = new RegExp("^" + $cc85e8b8e7405a89$var$SC_ATTR + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)');
var $cc85e8b8e7405a89$var$outputSheet = function outputSheet(sheet) {
    var tag = sheet.getTag();
    var length = tag.length;
    var css = "";
    for(var group = 0; group < length; group++){
        var id = $cc85e8b8e7405a89$var$getIdForGroup(group);
        if (id === undefined) continue;
        var names = sheet.names.get(id);
        var rules = tag.getGroup(group);
        if (names === undefined || rules.length === 0) continue;
        var selector = $cc85e8b8e7405a89$var$SC_ATTR + ".g" + group + '[id="' + id + '"]';
        var content = "";
        if (names !== undefined) names.forEach(function(name) {
            if (name.length > 0) content += name + ",";
        });
         // NOTE: It's easier to collect rules and have the marker
        // after the actual rules to simplify the rehydration
        css += "" + rules + selector + '{content:"' + content + '"}' + $cc85e8b8e7405a89$var$SPLITTER;
    }
    return css;
};
var $cc85e8b8e7405a89$var$rehydrateNamesFromContent = function rehydrateNamesFromContent(sheet, id, content) {
    var names = content.split(",");
    var name;
    for(var i = 0, l = names.length; i < l; i++)// eslint-disable-next-line
    if (name = names[i]) sheet.registerName(id, name);
};
var $cc85e8b8e7405a89$var$rehydrateSheetFromTag = function rehydrateSheetFromTag(sheet, style) {
    var parts = style.innerHTML.split($cc85e8b8e7405a89$var$SPLITTER);
    var rules = [];
    for(var i = 0, l = parts.length; i < l; i++){
        var part = parts[i].trim();
        if (!part) continue;
        var marker = part.match($cc85e8b8e7405a89$var$MARKER_RE);
        if (marker) {
            var group = parseInt(marker[1], 10) | 0;
            var id = marker[2];
            if (group !== 0) {
                // Rehydrate componentId to group index mapping
                $cc85e8b8e7405a89$var$setGroupForId(id, group); // Rehydrate names and rules
                // looks like: data-styled.g11[id="idA"]{content:"nameA,"}
                $cc85e8b8e7405a89$var$rehydrateNamesFromContent(sheet, id, marker[3]);
                sheet.getTag().insertRules(group, rules);
            }
            rules.length = 0;
        } else rules.push(part);
    }
};
var $cc85e8b8e7405a89$var$rehydrateSheet = function rehydrateSheet(sheet) {
    var nodes = document.querySelectorAll($cc85e8b8e7405a89$var$SELECTOR);
    for(var i = 0, l = nodes.length; i < l; i++){
        var node = nodes[i];
        if (node && node.getAttribute($cc85e8b8e7405a89$var$SC_ATTR) !== $cc85e8b8e7405a89$var$SC_ATTR_ACTIVE) {
            $cc85e8b8e7405a89$var$rehydrateSheetFromTag(sheet, node);
            if (node.parentNode) node.parentNode.removeChild(node);
        }
    }
};
var $cc85e8b8e7405a89$var$SHOULD_REHYDRATE = $cc85e8b8e7405a89$var$IS_BROWSER;
var $cc85e8b8e7405a89$var$defaultOptions = {
    isServer: !$cc85e8b8e7405a89$var$IS_BROWSER,
    useCSSOMInjection: !$cc85e8b8e7405a89$var$DISABLE_SPEEDY
};
/** Contains the main stylesheet logic for stringification and caching */ var $cc85e8b8e7405a89$var$StyleSheet = /*#__PURE__*/ function() {
    /** Register a group ID to give it an index */ StyleSheet.registerId = function registerId(id) {
        return $cc85e8b8e7405a89$var$getGroupForId(id);
    };
    function StyleSheet(options, globalStyles, names) {
        if (options === void 0) options = $cc85e8b8e7405a89$var$defaultOptions;
        if (globalStyles === void 0) globalStyles = {};
        this.options = $cc85e8b8e7405a89$var$_extends({}, $cc85e8b8e7405a89$var$defaultOptions, {}, options);
        this.gs = globalStyles;
        this.names = new Map(names); // We rehydrate only once and use the sheet that is created first
        if (!this.options.isServer && $cc85e8b8e7405a89$var$IS_BROWSER && $cc85e8b8e7405a89$var$SHOULD_REHYDRATE) {
            $cc85e8b8e7405a89$var$SHOULD_REHYDRATE = false;
            $cc85e8b8e7405a89$var$rehydrateSheet(this);
        }
    }
    var _proto = StyleSheet.prototype;
    _proto.reconstructWithOptions = function reconstructWithOptions(options) {
        return new StyleSheet($cc85e8b8e7405a89$var$_extends({}, this.options, {}, options), this.gs, this.names);
    };
    _proto.allocateGSInstance = function allocateGSInstance(id) {
        return this.gs[id] = (this.gs[id] || 0) + 1;
    } /** Lazily initialises a GroupedTag for when it's actually needed */ ;
    _proto.getTag = function getTag() {
        return this.tag || (this.tag = $cc85e8b8e7405a89$var$makeGroupedTag($cc85e8b8e7405a89$var$makeTag(this.options)));
    } /** Check whether a name is known for caching */ ;
    _proto.hasNameForId = function hasNameForId(id, name) {
        return this.names.has(id) && this.names.get(id).has(name);
    } /** Mark a group's name as known for caching */ ;
    _proto.registerName = function registerName(id, name) {
        $cc85e8b8e7405a89$var$getGroupForId(id);
        if (!this.names.has(id)) {
            var groupNames = new Set();
            groupNames.add(name);
            this.names.set(id, groupNames);
        } else this.names.get(id).add(name);
    } /** Insert new rules which also marks the name as known */ ;
    _proto.insertRules = function insertRules(id, name, rules) {
        this.registerName(id, name);
        this.getTag().insertRules($cc85e8b8e7405a89$var$getGroupForId(id), rules);
    } /** Clears all cached names for a given group ID */ ;
    _proto.clearNames = function clearNames(id) {
        if (this.names.has(id)) this.names.get(id).clear();
    } /** Clears all rules for a given group ID */ ;
    _proto.clearRules = function clearRules(id) {
        this.getTag().clearGroup($cc85e8b8e7405a89$var$getGroupForId(id));
        this.clearNames(id);
    } /** Clears the entire tag which deletes all rules but not its names */ ;
    _proto.clearTag = function clearTag() {
        // NOTE: This does not clear the names, since it's only used during SSR
        // so that we can continuously output only new rules
        this.tag = undefined;
    } /** Outputs the current sheet as a CSS string with markers for SSR */ ;
    _proto.toString = function toString() {
        return $cc85e8b8e7405a89$var$outputSheet(this);
    };
    return StyleSheet;
}();
// 
/* eslint-disable */ var $cc85e8b8e7405a89$var$SEED = 5381; // When we have separate strings it's useful to run a progressive
// version of djb2 where we pretend that we're still looping over
// the same string
var $cc85e8b8e7405a89$var$phash = function phash(h, x) {
    var i = x.length;
    while(i)h = h * 33 ^ x.charCodeAt(--i);
    return h;
}; // This is a djb2 hashing function
var $cc85e8b8e7405a89$var$hash = function hash(x) {
    return $cc85e8b8e7405a89$var$phash($cc85e8b8e7405a89$var$SEED, x);
};
/**
 * MIT License
 *
 * Copyright (c) 2016 Sultan Tarimo
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
 * IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /* eslint-disable */ function $cc85e8b8e7405a89$var$insertRulePlugin(insertRule) {
    var delimiter = "/*|*/";
    var needle = delimiter + "}";
    function toSheet(block) {
        if (block) try {
            insertRule(block + "}");
        } catch (e) {}
    }
    return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
        switch(context){
            // property
            case 1:
                // @import
                if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ";"), "";
                break;
            // selector
            case 2:
                if (ns === 0) return content + delimiter;
                break;
            // at-rule
            case 3:
                switch(ns){
                    // @font-face, @page
                    case 102:
                    case 112:
                        return insertRule(selectors[0] + content), "";
                    default:
                        return content + (at === 0 ? delimiter : "");
                }
            case -2:
                content.split(needle).forEach(toSheet);
        }
    };
}
var $cc85e8b8e7405a89$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
function $cc85e8b8e7405a89$var$createStylisInstance(_temp) {
    var _ref = _temp === void 0 ? $cc85e8b8e7405a89$var$EMPTY_OBJECT : _temp, _ref$options = _ref.options, options = _ref$options === void 0 ? $cc85e8b8e7405a89$var$EMPTY_OBJECT : _ref$options, _ref$plugins = _ref.plugins, plugins = _ref$plugins === void 0 ? $cc85e8b8e7405a89$var$EMPTY_ARRAY : _ref$plugins;
    var stylis = new (0, $f83085fa594fc566$export$2e2bcd8739ae039)(options); // Wrap `insertRulePlugin to build a list of rules,
    // and then make our own plugin to return the rules. This
    // makes it easier to hook into the existing SSR architecture
    var parsingRules = []; // eslint-disable-next-line consistent-return
    var returnRulesPlugin = function returnRulesPlugin(context) {
        if (context === -2) {
            var parsedRules = parsingRules;
            parsingRules = [];
            return parsedRules;
        }
    };
    var parseRulesPlugin = $cc85e8b8e7405a89$var$insertRulePlugin(function(rule) {
        parsingRules.push(rule);
    });
    var _componentId;
    var _selector;
    var _selectorRegexp;
    var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
        if (offset > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
        string.slice(0, offset).indexOf(_selector) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
        string.slice(offset - _selector.length, offset) !== _selector) return "." + _componentId;
        return match;
    };
    /**
   * When writing a style like
   *
   * & + & {
   *   color: red;
   * }
   *
   * The second ampersand should be a reference to the static component class. stylis
   * has no knowledge of static class so we have to intelligently replace the base selector.
   *
   * https://github.com/thysultan/stylis.js#plugins <- more info about the context phase values
   * "2" means this plugin is taking effect at the very end after all other processing is complete
   */ var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
        if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) // eslint-disable-next-line no-param-reassign
        selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
    };
    stylis.use([].concat(plugins, [
        selfReferenceReplacementPlugin,
        parseRulesPlugin,
        returnRulesPlugin
    ]));
    function stringifyRules(css, selector, prefix, componentId) {
        if (componentId === void 0) componentId = "&";
        var flatCSS = css.replace($cc85e8b8e7405a89$var$COMMENT_REGEX, "");
        var cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS; // stylis has no concept of state to be passed to plugins
        // but since JS is single=threaded, we can rely on that to ensure
        // these properties stay in sync with the current stylis run
        _componentId = componentId;
        _selector = selector;
        _selectorRegexp = new RegExp("\\" + _selector + "\\b", "g");
        return stylis(prefix || !selector ? "" : selector, cssStr);
    }
    stringifyRules.hash = plugins.length ? plugins.reduce(function(acc, plugin) {
        if (!plugin.name) $cc85e8b8e7405a89$var$throwStyledComponentsError(15);
        return $cc85e8b8e7405a89$var$phash(acc, plugin.name);
    }, $cc85e8b8e7405a89$var$SEED).toString() : "";
    return stringifyRules;
}
// 
var $cc85e8b8e7405a89$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext();
var $cc85e8b8e7405a89$export$91317688fc694efa = $cc85e8b8e7405a89$export$8c190ef828af4c86.Consumer;
var $cc85e8b8e7405a89$var$StylisContext = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext();
var $cc85e8b8e7405a89$var$StylisConsumer = $cc85e8b8e7405a89$var$StylisContext.Consumer;
var $cc85e8b8e7405a89$var$masterSheet = new $cc85e8b8e7405a89$var$StyleSheet();
var $cc85e8b8e7405a89$var$masterStylis = $cc85e8b8e7405a89$var$createStylisInstance();
function $cc85e8b8e7405a89$var$useStyleSheet() {
    return (0, $gIfym.useContext)($cc85e8b8e7405a89$export$8c190ef828af4c86) || $cc85e8b8e7405a89$var$masterSheet;
}
function $cc85e8b8e7405a89$var$useStylis() {
    return (0, $gIfym.useContext)($cc85e8b8e7405a89$var$StylisContext) || $cc85e8b8e7405a89$var$masterStylis;
}
function $cc85e8b8e7405a89$export$a473771da2f0ff7c(props) {
    var _useState = (0, $gIfym.useState)(props.stylisPlugins), plugins = _useState[0], setPlugins = _useState[1];
    var contextStyleSheet = $cc85e8b8e7405a89$var$useStyleSheet();
    var styleSheet = (0, $gIfym.useMemo)(function() {
        var sheet = contextStyleSheet;
        if (props.sheet) // eslint-disable-next-line prefer-destructuring
        sheet = props.sheet;
        else if (props.target) sheet = sheet.reconstructWithOptions({
            target: props.target
        });
        if (props.disableCSSOMInjection) sheet = sheet.reconstructWithOptions({
            useCSSOMInjection: false
        });
        return sheet;
    }, [
        props.disableCSSOMInjection,
        props.sheet,
        props.target
    ]);
    var stylis = (0, $gIfym.useMemo)(function() {
        return $cc85e8b8e7405a89$var$createStylisInstance({
            options: {
                prefix: !props.disableVendorPrefixes
            },
            plugins: plugins
        });
    }, [
        props.disableVendorPrefixes,
        plugins
    ]);
    (0, $gIfym.useEffect)(function() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b26ea600167d1d07$exports)))(plugins, props.stylisPlugins)) setPlugins(props.stylisPlugins);
    }, [
        props.stylisPlugins
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($cc85e8b8e7405a89$export$8c190ef828af4c86.Provider, {
        value: styleSheet
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($cc85e8b8e7405a89$var$StylisContext.Provider, {
        value: stylis
    }, (0, props.children)));
}
// 
var $cc85e8b8e7405a89$var$Keyframes = /*#__PURE__*/ function() {
    function Keyframes(name, stringifyArgs) {
        var _this = this;
        this.inject = function(styleSheet) {
            if (!styleSheet.hasNameForId(_this.id, _this.name)) styleSheet.insertRules(_this.id, _this.name, $cc85e8b8e7405a89$var$masterStylis.apply(void 0, _this.stringifyArgs));
        };
        this.toString = function() {
            return $cc85e8b8e7405a89$var$throwStyledComponentsError(12, String(_this.name));
        };
        this.name = name;
        this.id = "sc-keyframes-" + name;
        this.stringifyArgs = stringifyArgs;
    }
    var _proto = Keyframes.prototype;
    _proto.getName = function getName() {
        return this.name;
    };
    return Keyframes;
}();
// 
/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */ var $cc85e8b8e7405a89$var$uppercasePattern = /([A-Z])/g;
var $cc85e8b8e7405a89$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $cc85e8b8e7405a89$var$hyphenateStyleName(string) {
    return string.replace($cc85e8b8e7405a89$var$uppercasePattern, "-$1").toLowerCase().replace($cc85e8b8e7405a89$var$msPattern, "-ms-");
}
// 
function $cc85e8b8e7405a89$var$addUnitIfNeeded(name, value) {
    // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
    // $FlowFixMe
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !(name in (0, $f65a01e764c0ea5c$export$2e2bcd8739ae039))) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
    return String(value).trim();
}
// 
/**
 * It's falsish not falsy because 0 is allowed.
 */ var $cc85e8b8e7405a89$var$isFalsish = function isFalsish(chunk) {
    return chunk === undefined || chunk === null || chunk === false || chunk === "";
};
var $cc85e8b8e7405a89$var$objToCssArray = function objToCssArray(obj, prevKey) {
    var rules = [];
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
        if (!$cc85e8b8e7405a89$var$isFalsish(obj[key])) {
            if ($cc85e8b8e7405a89$var$isPlainObject(obj[key])) {
                rules.push.apply(rules, objToCssArray(obj[key], key));
                return rules;
            } else if ($cc85e8b8e7405a89$var$isFunction(obj[key])) {
                rules.push($cc85e8b8e7405a89$var$hyphenateStyleName(key) + ":", obj[key], ";");
                return rules;
            }
            rules.push($cc85e8b8e7405a89$var$hyphenateStyleName(key) + ": " + $cc85e8b8e7405a89$var$addUnitIfNeeded(key, obj[key]) + ";");
        }
        return rules;
    });
    return prevKey ? [
        prevKey + " {"
    ].concat(rules, [
        "}"
    ]) : rules;
};
function $cc85e8b8e7405a89$var$flatten(chunk, executionContext, styleSheet) {
    if (Array.isArray(chunk)) {
        var ruleSet = [];
        for(var i = 0, len = chunk.length, result; i < len; i += 1){
            result = $cc85e8b8e7405a89$var$flatten(chunk[i], executionContext, styleSheet);
            if (result === "") continue;
            else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);
            else ruleSet.push(result);
        }
        return ruleSet;
    }
    if ($cc85e8b8e7405a89$var$isFalsish(chunk)) return "";
    /* Handle other components */ if ($cc85e8b8e7405a89$export$7ba318d8d2f06c76(chunk)) return "." + chunk.styledComponentId;
    /* Either execute or defer the function */ if ($cc85e8b8e7405a89$var$isFunction(chunk)) {
        if ($cc85e8b8e7405a89$var$isStatelessFunction(chunk) && executionContext) {
            var _result = chunk(executionContext);
            return $cc85e8b8e7405a89$var$flatten(_result, executionContext, styleSheet);
        } else return chunk;
    }
    if (chunk instanceof $cc85e8b8e7405a89$var$Keyframes) {
        if (styleSheet) {
            chunk.inject(styleSheet);
            return chunk.getName();
        } else return chunk;
    }
    /* Handle objects */ return $cc85e8b8e7405a89$var$isPlainObject(chunk) ? $cc85e8b8e7405a89$var$objToCssArray(chunk) : chunk.toString();
}
// 
function $cc85e8b8e7405a89$export$dbf350e5966cf602(styles) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if ($cc85e8b8e7405a89$var$isFunction(styles) || $cc85e8b8e7405a89$var$isPlainObject(styles)) // $FlowFixMe
    return $cc85e8b8e7405a89$var$flatten($cc85e8b8e7405a89$var$interleave($cc85e8b8e7405a89$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    if (interpolations.length === 0 && styles.length === 1 && typeof styles[0] === "string") // $FlowFixMe
    return styles;
     // $FlowFixMe
    return $cc85e8b8e7405a89$var$flatten($cc85e8b8e7405a89$var$interleave(styles, interpolations));
}
function $cc85e8b8e7405a89$var$constructWithOptions(componentConstructor, tag, options) {
    if (options === void 0) options = $cc85e8b8e7405a89$var$EMPTY_OBJECT;
    if (!(0, $2d222ef6f692482f$exports.isValidElementType)(tag)) return $cc85e8b8e7405a89$var$throwStyledComponentsError(1, String(tag));
    /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
        return componentConstructor(tag, options, $cc85e8b8e7405a89$export$dbf350e5966cf602.apply(void 0, arguments));
    };
    /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
        return $cc85e8b8e7405a89$var$constructWithOptions(componentConstructor, tag, $cc85e8b8e7405a89$var$_extends({}, options, {}, config));
    };
    /* Modify/inject new props at runtime */ templateFunction.attrs = function(attrs) {
        return $cc85e8b8e7405a89$var$constructWithOptions(componentConstructor, tag, $cc85e8b8e7405a89$var$_extends({}, options, {
            attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
        }));
    };
    return templateFunction;
}
/* eslint-disable */ /**
  mixin-deep; https://github.com/jonschlinkert/mixin-deep
  Inlined such that it will be consistently transpiled to an IE-compatible syntax.

  The MIT License (MIT)

  Copyright (c) 2014-present, Jon Schlinkert.

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/ var $cc85e8b8e7405a89$var$isObject = function isObject(val) {
    return typeof val === "function" || typeof val === "object" && val !== null && !Array.isArray(val);
};
var $cc85e8b8e7405a89$var$isValidKey = function isValidKey(key) {
    return key !== "__proto__" && key !== "constructor" && key !== "prototype";
};
function $cc85e8b8e7405a89$var$mixin(target, val, key) {
    var obj = target[key];
    if ($cc85e8b8e7405a89$var$isObject(val) && $cc85e8b8e7405a89$var$isObject(obj)) $cc85e8b8e7405a89$var$mixinDeep(obj, val);
    else target[key] = val;
}
function $cc85e8b8e7405a89$var$mixinDeep(target) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
    for(var _i = 0, _rest = rest; _i < _rest.length; _i++){
        var obj = _rest[_i];
        if ($cc85e8b8e7405a89$var$isObject(obj)) {
            for(var key in obj)if ($cc85e8b8e7405a89$var$isValidKey(key)) $cc85e8b8e7405a89$var$mixin(target, obj[key], key);
        }
    }
    return target;
}
// 
/* eslint-disable no-bitwise */ var $cc85e8b8e7405a89$var$AD_REPLACER_R = /(a)(d)/gi;
/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $cc85e8b8e7405a89$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $cc85e8b8e7405a89$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ function $cc85e8b8e7405a89$var$generateAlphabeticName(code) {
    var name = "";
    var x;
    /* get a char and divide by alphabet-length */ for(x = Math.abs(code); x > $cc85e8b8e7405a89$var$charsLength; x = x / $cc85e8b8e7405a89$var$charsLength | 0)name = $cc85e8b8e7405a89$var$getAlphabeticChar(x % $cc85e8b8e7405a89$var$charsLength) + name;
    return ($cc85e8b8e7405a89$var$getAlphabeticChar(x % $cc85e8b8e7405a89$var$charsLength) + name).replace($cc85e8b8e7405a89$var$AD_REPLACER_R, "$1-$2");
}
// 
function $cc85e8b8e7405a89$var$isStaticRules(rules) {
    for(var i = 0; i < rules.length; i += 1){
        var rule = rules[i];
        if ($cc85e8b8e7405a89$var$isFunction(rule) && !$cc85e8b8e7405a89$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    return true;
}
// 
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $cc85e8b8e7405a89$var$ComponentStyle = /*#__PURE__*/ function() {
    function ComponentStyle(rules, componentId) {
        this.rules = rules;
        this.staticRulesId = "";
        this.isStatic = $cc85e8b8e7405a89$var$isStaticRules(rules);
        this.componentId = componentId;
        this.baseHash = $cc85e8b8e7405a89$var$hash(componentId); // NOTE: This registers the componentId, which ensures a consistent order
        // for this component's styles compared to others
        $cc85e8b8e7405a89$var$StyleSheet.registerId(componentId);
    }
    /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */ var _proto = ComponentStyle.prototype;
    _proto.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet, stylis) {
        var componentId = this.componentId; // force dynamic classnames if user-supplied stylis plugins are in use
        if (this.isStatic && !stylis.hash) {
            if (this.staticRulesId && styleSheet.hasNameForId(componentId, this.staticRulesId)) return this.staticRulesId;
            var cssStatic = $cc85e8b8e7405a89$var$flatten(this.rules, executionContext, styleSheet).join("");
            var name = $cc85e8b8e7405a89$var$generateAlphabeticName($cc85e8b8e7405a89$var$phash(this.baseHash, cssStatic.length) >>> 0);
            if (!styleSheet.hasNameForId(componentId, name)) {
                var cssStaticFormatted = stylis(cssStatic, "." + name, undefined, componentId);
                styleSheet.insertRules(componentId, name, cssStaticFormatted);
            }
            this.staticRulesId = name;
            return name;
        } else {
            var length = this.rules.length;
            var dynamicHash = $cc85e8b8e7405a89$var$phash(this.baseHash, stylis.hash);
            var css = "";
            for(var i = 0; i < length; i++){
                var partRule = this.rules[i];
                if (typeof partRule === "string") css += partRule;
                else {
                    var partChunk = $cc85e8b8e7405a89$var$flatten(partRule, executionContext, styleSheet);
                    var partString = Array.isArray(partChunk) ? partChunk.join("") : partChunk;
                    dynamicHash = $cc85e8b8e7405a89$var$phash(dynamicHash, partString + i);
                    css += partString;
                }
            }
            var _name = $cc85e8b8e7405a89$var$generateAlphabeticName(dynamicHash >>> 0);
            if (!styleSheet.hasNameForId(componentId, _name)) {
                var cssFormatted = stylis(css, "." + _name, undefined, componentId);
                styleSheet.insertRules(componentId, _name, cssFormatted);
            }
            return _name;
        }
    };
    return ComponentStyle;
}();
// 
var $cc85e8b8e7405a89$var$LIMIT = 200;
var $cc85e8b8e7405a89$var$createWarnTooManyClasses = function(displayName, componentId) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $cc85e8b8e7405a89$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ var parsedIdString = componentId ? ' with the id of "' + componentId + '"' : "";
                console.warn("Over " + $cc85e8b8e7405a89$var$LIMIT + " classes were generated for component " + displayName + parsedIdString + ".\n" + "Consider using the attrs method, together with a style object for frequently changed styles.\n" + "Example:\n" + "  const Component = styled.div.attrs(props => ({\n" + "    style: {\n" + "      background: props.background,\n" + "    },\n" + "  }))`width: 100%;`\n\n" + "  <Component />");
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $cc85e8b8e7405a89$var$invalidHookCallRe = /invalid hook call/i;
var $cc85e8b8e7405a89$var$seen = new Set();
var $cc85e8b8e7405a89$var$checkDynamicCreation = function checkDynamicCreation(displayName, componentId) {
    var parsedIdString, message, error;
};
// 
var $cc85e8b8e7405a89$var$determineTheme = function(props, providedTheme, defaultProps) {
    if (defaultProps === void 0) defaultProps = $cc85e8b8e7405a89$var$EMPTY_OBJECT;
    return props.theme !== defaultProps.theme && props.theme || providedTheme || defaultProps.theme;
};
// 
// Source: https://www.w3.org/TR/cssom-1/#serialize-an-identifier
// Control characters and non-letter first symbols are not supported
var $cc85e8b8e7405a89$var$escapeRegex = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g;
var $cc85e8b8e7405a89$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $cc85e8b8e7405a89$var$escape(str) {
    return str // Replace all possible CSS selectors
    .replace($cc85e8b8e7405a89$var$escapeRegex, "-") // Remove extraneous hyphens at the start and end
    .replace($cc85e8b8e7405a89$var$dashesAtEnds, "");
}
// 
function $cc85e8b8e7405a89$var$isTag(target) {
    return typeof target === "string" && true;
}
// 
function $cc85e8b8e7405a89$var$generateDisplayName(target) {
    // $FlowFixMe
    return $cc85e8b8e7405a89$var$isTag(target) ? "styled." + target : "Styled(" + $cc85e8b8e7405a89$var$getComponentName(target) + ")";
}
// 
var $cc85e8b8e7405a89$var$generateComponentId = function(str) {
    return $cc85e8b8e7405a89$var$generateAlphabeticName($cc85e8b8e7405a89$var$hash(str) >>> 0);
};
/**
 * Convenience function for joining strings to form className chains
 */ function $cc85e8b8e7405a89$var$joinStrings(a, b) {
    return a && b ? a + " " + b : a || b;
}
var $cc85e8b8e7405a89$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext();
var $cc85e8b8e7405a89$export$b631efc24e9d5e2f = $cc85e8b8e7405a89$export$2c657da244d00bd6.Consumer;
function $cc85e8b8e7405a89$var$mergeTheme(theme, outerTheme) {
    if (!theme) return $cc85e8b8e7405a89$var$throwStyledComponentsError(14);
    if ($cc85e8b8e7405a89$var$isFunction(theme)) {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    if (Array.isArray(theme) || typeof theme !== "object") return $cc85e8b8e7405a89$var$throwStyledComponentsError(8);
    return outerTheme ? $cc85e8b8e7405a89$var$_extends({}, outerTheme, {}, theme) : theme;
}
/**
 * Provide a theme to an entire react component tree via context
 */ function $cc85e8b8e7405a89$export$d8964aec282183a3(props) {
    var outerTheme = (0, $gIfym.useContext)($cc85e8b8e7405a89$export$2c657da244d00bd6);
    var themeContext = (0, $gIfym.useMemo)(function() {
        return $cc85e8b8e7405a89$var$mergeTheme(props.theme, outerTheme);
    }, [
        props.theme,
        outerTheme
    ]);
    if (!props.children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($cc85e8b8e7405a89$export$2c657da244d00bd6.Provider, {
        value: themeContext
    }, props.children);
}
/* global $Call */ var $cc85e8b8e7405a89$var$identifiers = {};
/* We depend on components having unique IDs */ function $cc85e8b8e7405a89$var$generateId(displayName, parentComponentId) {
    var name = typeof displayName !== "string" ? "sc" : $cc85e8b8e7405a89$var$escape(displayName); // Ensure that no displayName can lead to duplicate componentIds
    $cc85e8b8e7405a89$var$identifiers[name] = ($cc85e8b8e7405a89$var$identifiers[name] || 0) + 1;
    var componentId = name + "-" + $cc85e8b8e7405a89$var$generateComponentId(name + $cc85e8b8e7405a89$var$identifiers[name]);
    return parentComponentId ? parentComponentId + "-" + componentId : componentId;
}
function $cc85e8b8e7405a89$var$useResolvedAttrs(theme, props, attrs) {
    if (theme === void 0) theme = $cc85e8b8e7405a89$var$EMPTY_OBJECT;
    // NOTE: can't memoize this
    // returns [context, resolvedAttrs]
    // where resolvedAttrs is only the things injected by the attrs themselves
    var context = $cc85e8b8e7405a89$var$_extends({}, props, {
        theme: theme
    });
    var resolvedAttrs = {};
    attrs.forEach(function(attrDef) {
        var resolvedAttrDef = attrDef;
        var key;
        if ($cc85e8b8e7405a89$var$isFunction(resolvedAttrDef)) resolvedAttrDef = resolvedAttrDef(context);
        /* eslint-disable guard-for-in */ for(key in resolvedAttrDef)context[key] = resolvedAttrs[key] = key === "className" ? $cc85e8b8e7405a89$var$joinStrings(resolvedAttrs[key], resolvedAttrDef[key]) : resolvedAttrDef[key];
    /* eslint-enable guard-for-in */ });
    return [
        context,
        resolvedAttrs
    ];
}
function $cc85e8b8e7405a89$var$useInjectedStyle(componentStyle, hasAttrs, resolvedAttrs, warnTooManyClasses) {
    var styleSheet = $cc85e8b8e7405a89$var$useStyleSheet();
    var stylis = $cc85e8b8e7405a89$var$useStylis(); // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    var isStatic = componentStyle.isStatic && !hasAttrs;
    var className = isStatic ? componentStyle.generateAndInjectStyles($cc85e8b8e7405a89$var$EMPTY_OBJECT, styleSheet, stylis) : componentStyle.generateAndInjectStyles(resolvedAttrs, styleSheet, stylis);
    (0, $gIfym.useDebugValue)(className);
    return className;
}
function $cc85e8b8e7405a89$var$useStyledComponentImpl(forwardedComponent, props, forwardedRef) {
    var componentAttrs = forwardedComponent.attrs, componentStyle = forwardedComponent.componentStyle, defaultProps = forwardedComponent.defaultProps, foldedComponentIds = forwardedComponent.foldedComponentIds, shouldForwardProp = forwardedComponent.shouldForwardProp, styledComponentId = forwardedComponent.styledComponentId, target = forwardedComponent.target;
    (0, $gIfym.useDebugValue)(styledComponentId); // NOTE: the non-hooks version only subscribes to this when !componentStyle.isStatic,
    // but that'd be against the rules-of-hooks. We could be naughty and do it anyway as it
    // should be an immutable value, but behave for now.
    var theme = $cc85e8b8e7405a89$var$determineTheme(props, (0, $gIfym.useContext)($cc85e8b8e7405a89$export$2c657da244d00bd6), defaultProps);
    var _useResolvedAttrs = $cc85e8b8e7405a89$var$useResolvedAttrs(theme || $cc85e8b8e7405a89$var$EMPTY_OBJECT, props, componentAttrs), context = _useResolvedAttrs[0], attrs = _useResolvedAttrs[1];
    var generatedClassName = $cc85e8b8e7405a89$var$useInjectedStyle(componentStyle, componentAttrs.length > 0, context, undefined);
    var refToForward = forwardedRef;
    var elementToBeCreated = attrs.$as || props.$as || attrs.as || props.as || target;
    var isTargetTag = $cc85e8b8e7405a89$var$isTag(elementToBeCreated);
    var computedProps = attrs !== props ? $cc85e8b8e7405a89$var$_extends({}, props, {}, attrs) : props;
    var propFilterFn = shouldForwardProp || isTargetTag && (0, $ab1c14456d23888f$export$2e2bcd8739ae039);
    var propsForElement = {}; // eslint-disable-next-line guard-for-in
    for(var key in computedProps){
        if (key[0] === "$" || key === "as") continue;
        else if (key === "forwardedAs") propsForElement.as = computedProps[key];
        else if (!propFilterFn || propFilterFn(key, (0, $ab1c14456d23888f$export$2e2bcd8739ae039))) // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
    }
    if (props.style && attrs.style !== props.style) propsForElement.style = $cc85e8b8e7405a89$var$_extends({}, props.style, {}, attrs.style);
    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, props.className, attrs.className).filter(Boolean).join(" ");
    propsForElement.ref = refToForward;
    return (0, $gIfym.createElement)(elementToBeCreated, propsForElement);
}
function $cc85e8b8e7405a89$var$createStyledComponent(target, options, rules) {
    var isTargetStyledComp = $cc85e8b8e7405a89$export$7ba318d8d2f06c76(target);
    var isCompositeComponent = !$cc85e8b8e7405a89$var$isTag(target);
    var _options$displayName = options.displayName, displayName = _options$displayName === void 0 ? $cc85e8b8e7405a89$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === void 0 ? $cc85e8b8e7405a89$var$generateId(options.displayName, options.parentComponentId) : _options$componentId, _options$attrs = options.attrs, attrs = _options$attrs === void 0 ? $cc85e8b8e7405a89$var$EMPTY_ARRAY : _options$attrs;
    var styledComponentId = options.displayName && options.componentId ? $cc85e8b8e7405a89$var$escape(options.displayName) + "-" + options.componentId : options.componentId || componentId; // fold the underlying StyledComponent attrs up (implicit extend)
    var finalAttrs = isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs; // eslint-disable-next-line prefer-destructuring
    var shouldForwardProp = options.shouldForwardProp; // $FlowFixMe
    if (isTargetStyledComp && target.shouldForwardProp) {
        if (shouldForwardProp) // compose nested shouldForwardProp calls
        shouldForwardProp = function shouldForwardProp(prop, filterFn) {
            return target.shouldForwardProp(prop, filterFn) && options.shouldForwardProp(prop, filterFn);
        };
        else // eslint-disable-next-line prefer-destructuring
        shouldForwardProp = target.shouldForwardProp;
    }
    var componentStyle = new $cc85e8b8e7405a89$var$ComponentStyle(isTargetStyledComp ? // $FlowFixMe
    target.componentStyle.rules.concat(rules) : rules, styledComponentId);
    /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */ var WrappedStyledComponent; // eslint-disable-next-line react-hooks/rules-of-hooks
    var forwardRef = function forwardRef(props, ref) {
        return $cc85e8b8e7405a89$var$useStyledComponentImpl(WrappedStyledComponent, props, ref);
    };
    forwardRef.displayName = displayName; // $FlowFixMe this is a forced cast to merge it StyledComponentWrapperProperties
    WrappedStyledComponent = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(forwardRef);
    WrappedStyledComponent.attrs = finalAttrs;
    WrappedStyledComponent.componentStyle = componentStyle;
    WrappedStyledComponent.displayName = displayName;
    WrappedStyledComponent.shouldForwardProp = shouldForwardProp; // this static is used to preserve the cascade of static classes for component selector
    // purposes; this is especially important with usage of the css prop
    WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : $cc85e8b8e7405a89$var$EMPTY_ARRAY;
    WrappedStyledComponent.styledComponentId = styledComponentId; // fold the underlying StyledComponent target up since we folded the styles
    WrappedStyledComponent.target = isTargetStyledComp ? target.target : target; // $FlowFixMe
    WrappedStyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId, optionsToCopy = $cc85e8b8e7405a89$var$_objectWithoutPropertiesLoose(options, [
            "componentId"
        ]);
        var newComponentId = previousComponentId && previousComponentId + "-" + ($cc85e8b8e7405a89$var$isTag(tag) ? tag : $cc85e8b8e7405a89$var$escape($cc85e8b8e7405a89$var$getComponentName(tag)));
        var newOptions = $cc85e8b8e7405a89$var$_extends({}, optionsToCopy, {
            attrs: finalAttrs,
            componentId: newComponentId
        });
        return $cc85e8b8e7405a89$var$createStyledComponent(tag, newOptions, rules);
    }; // $FlowFixMe
    Object.defineProperty(WrappedStyledComponent, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(obj) {
            // $FlowFixMe
            this._foldedDefaultProps = isTargetStyledComp ? $cc85e8b8e7405a89$var$mixinDeep({}, target.defaultProps, obj) : obj;
        }
    });
    WrappedStyledComponent.toString = function() {
        return "." + WrappedStyledComponent.styledComponentId;
    };
    if (isCompositeComponent) (0, (/*@__PURE__*/$parcel$interopDefault($8370cfca71108aac$exports)))(WrappedStyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        foldedComponentIds: true,
        shouldForwardProp: true,
        self: true,
        styledComponentId: true,
        target: true,
        withComponent: true
    });
    return WrappedStyledComponent;
}
// 
// Thanks to ReactDOMFactories for this handy list!
var $cc85e8b8e7405a89$var$domElements = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
// 
var $cc85e8b8e7405a89$var$styled = function styled(tag) {
    return $cc85e8b8e7405a89$var$constructWithOptions($cc85e8b8e7405a89$var$createStyledComponent, tag);
}; // Shorthands for all valid HTML Elements
$cc85e8b8e7405a89$var$domElements.forEach(function(domElement) {
    $cc85e8b8e7405a89$var$styled[domElement] = $cc85e8b8e7405a89$var$styled(domElement);
});
// 
var $cc85e8b8e7405a89$var$GlobalStyle = /*#__PURE__*/ function() {
    function GlobalStyle(rules, componentId) {
        this.rules = rules;
        this.componentId = componentId;
        this.isStatic = $cc85e8b8e7405a89$var$isStaticRules(rules);
    }
    var _proto = GlobalStyle.prototype;
    _proto.createStyles = function createStyles(instance, executionContext, styleSheet, stylis) {
        var flatCSS = $cc85e8b8e7405a89$var$flatten(this.rules, executionContext, styleSheet);
        var css = stylis(flatCSS.join(""), "");
        var id = this.componentId + instance; // NOTE: We use the id as a name as well, since these rules never change
        styleSheet.insertRules(id, id, css);
    };
    _proto.removeStyles = function removeStyles(instance, styleSheet) {
        styleSheet.clearRules(this.componentId + instance);
    };
    _proto.renderStyles = function renderStyles(instance, executionContext, styleSheet, stylis) {
        $cc85e8b8e7405a89$var$StyleSheet.registerId(this.componentId + instance); // NOTE: Remove old styles, then inject the new ones
        this.removeStyles(instance, styleSheet);
        this.createStyles(instance, executionContext, styleSheet, stylis);
    };
    return GlobalStyle;
}();
function $cc85e8b8e7405a89$export$f0f03736edb61697(strings) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = $cc85e8b8e7405a89$export$dbf350e5966cf602.apply(void 0, [
        strings
    ].concat(interpolations));
    var styledComponentId = "sc-global-" + $cc85e8b8e7405a89$var$generateComponentId(JSON.stringify(rules));
    var globalStyle = new $cc85e8b8e7405a89$var$GlobalStyle(rules, styledComponentId);
    function GlobalStyleComponent(props) {
        var styleSheet = $cc85e8b8e7405a89$var$useStyleSheet();
        var stylis = $cc85e8b8e7405a89$var$useStylis();
        var theme = (0, $gIfym.useContext)($cc85e8b8e7405a89$export$2c657da244d00bd6);
        var instanceRef = (0, $gIfym.useRef)(null);
        if (instanceRef.current === null) instanceRef.current = styleSheet.allocateGSInstance(styledComponentId);
        var instance = instanceRef.current;
        if (globalStyle.isStatic) globalStyle.renderStyles(instance, $cc85e8b8e7405a89$var$STATIC_EXECUTION_CONTEXT, styleSheet, stylis);
        else {
            var context = $cc85e8b8e7405a89$var$_extends({}, props, {
                theme: $cc85e8b8e7405a89$var$determineTheme(props, theme, GlobalStyleComponent.defaultProps)
            });
            globalStyle.renderStyles(instance, context, styleSheet, stylis);
        }
        (0, $gIfym.useEffect)(function() {
            return function() {
                return globalStyle.removeStyles(instance, styleSheet);
            };
        }, $cc85e8b8e7405a89$var$EMPTY_ARRAY);
        return null;
    } // $FlowFixMe
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).memo(GlobalStyleComponent);
}
// 
function $cc85e8b8e7405a89$export$d25ddfdf17c3ad3e(strings) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = $cc85e8b8e7405a89$export$dbf350e5966cf602.apply(void 0, [
        strings
    ].concat(interpolations)).join("");
    var name = $cc85e8b8e7405a89$var$generateComponentId(rules);
    return new $cc85e8b8e7405a89$var$Keyframes(name, [
        rules,
        name,
        "@keyframes"
    ]);
}
var $cc85e8b8e7405a89$export$ae8c7d15c8b89a20 = /*#__PURE__*/ function() {
    function ServerStyleSheet() {
        var _this = this;
        this._emitSheetCSS = function() {
            var css = _this.instance.toString();
            var nonce = $cc85e8b8e7405a89$var$getNonce();
            var attrs = [
                nonce && 'nonce="' + nonce + '"',
                $cc85e8b8e7405a89$var$SC_ATTR + '="true"',
                $cc85e8b8e7405a89$var$SC_ATTR_VERSION + '="' + $cc85e8b8e7405a89$var$SC_VERSION + '"'
            ];
            var htmlAttr = attrs.filter(Boolean).join(" ");
            return "<style " + htmlAttr + ">" + css + "</style>";
        };
        this.getStyleTags = function() {
            if (_this.sealed) return $cc85e8b8e7405a89$var$throwStyledComponentsError(2);
            return _this._emitSheetCSS();
        };
        this.getStyleElement = function() {
            var _props;
            if (_this.sealed) return $cc85e8b8e7405a89$var$throwStyledComponentsError(2);
            var props = (_props = {}, _props[$cc85e8b8e7405a89$var$SC_ATTR] = "", _props[$cc85e8b8e7405a89$var$SC_ATTR_VERSION] = $cc85e8b8e7405a89$var$SC_VERSION, _props.dangerouslySetInnerHTML = {
                __html: _this.instance.toString()
            }, _props);
            var nonce = $cc85e8b8e7405a89$var$getNonce();
            if (nonce) props.nonce = nonce;
             // v4 returned an array for this fn, so we'll do the same for v5 for backward compat
            return [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("style", $cc85e8b8e7405a89$var$_extends({}, props, {
                    key: "sc-0-0"
                }))
            ];
        };
        this.seal = function() {
            _this.sealed = true;
        };
        this.instance = new $cc85e8b8e7405a89$var$StyleSheet({
            isServer: true
        });
        this.sealed = false;
    }
    var _proto = ServerStyleSheet.prototype;
    _proto.collectStyles = function collectStyles(children) {
        if (this.sealed) return $cc85e8b8e7405a89$var$throwStyledComponentsError(2);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($cc85e8b8e7405a89$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    // eslint-disable-next-line consistent-return
    _proto.interleaveWithNodeStream = function interleaveWithNodeStream(input) {
        return $cc85e8b8e7405a89$var$throwStyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// export default <Config: { theme?: any }, Instance>(
//  Component: AbstractComponent<Config, Instance>
// ): AbstractComponent<$Diff<Config, { theme?: any }> & { theme?: any }, Instance>
//
// but the old build system tooling doesn't support the syntax
var $cc85e8b8e7405a89$export$e8748c6a27b910dc = function(Component) {
    // $FlowFixMe This should be React.forwardRef<Config, Instance>
    var WithTheme = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(function(props, ref) {
        var theme = (0, $gIfym.useContext)($cc85e8b8e7405a89$export$2c657da244d00bd6); // $FlowFixMe defaultProps isn't declared so it can be inferrable
        var defaultProps = Component.defaultProps;
        var themeProp = $cc85e8b8e7405a89$var$determineTheme(props, theme, defaultProps);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(Component, $cc85e8b8e7405a89$var$_extends({}, props, {
            theme: themeProp,
            ref: ref
        }));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8370cfca71108aac$exports)))(WithTheme, Component);
    WithTheme.displayName = "WithTheme(" + $cc85e8b8e7405a89$var$getComponentName(Component) + ")";
    return WithTheme;
};
// 
var $cc85e8b8e7405a89$export$93d4e7f90805808f = function useTheme() {
    return (0, $gIfym.useContext)($cc85e8b8e7405a89$export$2c657da244d00bd6);
};
// 
var $cc85e8b8e7405a89$export$5c87cfe6c475f500 = {
    StyleSheet: $cc85e8b8e7405a89$var$StyleSheet,
    masterSheet: $cc85e8b8e7405a89$var$masterSheet
};
// 
/* Define bundle version for export */ var $cc85e8b8e7405a89$export$83d89fbfd8236492 = "5.1.1";
var $cc85e8b8e7405a89$export$2e2bcd8739ae039 = $cc85e8b8e7405a89$var$styled;



var $gIfym = parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");



var $9cbc292f226e199b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $9cbc292f226e199b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $9cbc292f226e199b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9cbc292f226e199b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9cbc292f226e199b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9cbc292f226e199b$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * The public API for rendering a history-aware <a>.
 */ var $9cbc292f226e199b$var$Link = function(_React$Component) {
    $9cbc292f226e199b$var$_inherits(Link, _React$Component);
    function Link() {
        var _temp, _this, _ret;
        $9cbc292f226e199b$var$_classCallCheck(this, Link);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $9cbc292f226e199b$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !_this.props.target && // let browser handle "target=_blank" etc.
            !$9cbc292f226e199b$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                var history = _this.context.router.history;
                var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                if (replace) history.replace(to);
                else history.push(to);
            }
        }, _temp), $9cbc292f226e199b$var$_possibleConstructorReturn(_this, _ret);
    }
    Link.prototype.render = function render() {
        var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $9cbc292f226e199b$var$_objectWithoutProperties(_props, [
            "replace",
            "to",
            "innerRef"
        ]); // eslint-disable-line no-unused-vars
        (0, (/*@__PURE__*/$parcel$interopDefault($8f76fb1a5ab0d9df$exports)))(this.context.router, "You should not use <Link> outside a <Router>");
        (0, (/*@__PURE__*/$parcel$interopDefault($8f76fb1a5ab0d9df$exports)))(to !== undefined, 'You must specify the "to" property');
        var history = this.context.router.history;
        var location = typeof to === "string" ? (0, $c0e5765fb75ef8ef$export$90c043f1c57770b8)(to, null, null, history.location) : to;
        var href = history.createHref(location);
        return (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("a", $9cbc292f226e199b$var$_extends({}, props, {
            onClick: this.handleClick,
            href: href,
            ref: innerRef
        }));
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$9cbc292f226e199b$var$Link.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
    ]).isRequired,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func
    ])
};
$9cbc292f226e199b$var$Link.defaultProps = {
    replace: false
};
$9cbc292f226e199b$var$Link.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
            createHref: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired
        }).isRequired
    }).isRequired
};
var $9cbc292f226e199b$export$2e2bcd8739ae039 = $9cbc292f226e199b$var$Link;




const $ee6e5d464bbae375$var$StyledLink = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)((0, $9cbc292f226e199b$export$2e2bcd8739ae039))`
  width: 200px;
  padding: 10px;
  font-size: 1.2rem;
  background-color: #90d1a8;
  // color: white;
  color: #333;
  border-color: #333;
  // border: 1px solid #333;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #78b08f;
`;
const $ee6e5d464bbae375$var$StyledDiv = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).button`
  width: 200px;
  padding: 10px;
  font-size: 1.2rem;
  background-color: #90d1a8;
  // color: white;
  color: #333;
  border-color: #333;
  // border: 1px solid #333;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #78b08f;
  border: none;
  outline: none;
  width: 220px;
`;
class $ee6e5d464bbae375$export$353f5b6fc5456de1 extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).PureComponent {
    render() {
        const { text: text, to: to, onClick: onClick, className: className, ...props } = this.props;
        const Element = to ? $ee6e5d464bbae375$var$StyledLink : $ee6e5d464bbae375$var$StyledDiv;
        const classes = `Button ${className || ""}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement(Element, {
            className: classes,
            to: to,
            onClick: onClick,
            ...props
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", null, text));
    }
}
var $ee6e5d464bbae375$export$2e2bcd8739ae039 = $ee6e5d464bbae375$export$353f5b6fc5456de1;


var $d4d2b3d3c18e454d$exports = {};
$d4d2b3d3c18e454d$exports = new URL("icon512-gray.be383917.png", import.meta.url).toString();


const $8b005af3786a1e74$var$API_BASE = (0, window.location.origin);
const $8b005af3786a1e74$export$3988ae62b71be9a3 = (path)=>fetch(`${$8b005af3786a1e74$var$API_BASE}/${path}`).then(async (r)=>{
        let payload = null;
        try {
            payload = await r.json();
        } catch (err) {
            payload = null;
        }
        if (!r.ok) {
            const error = new Error(`HTTP ${r.status}`);
            error.status = r.status;
            error.payload = payload;
            throw error;
        }
        return payload;
    });
// .catch(console.warn)
// NOTE: needsto be disabled for offline handling
// TODO: improve offline handling with service worker (eg. cache response instead of custom)
const $8b005af3786a1e74$export$299ba2dee77727e9 = (path, data)=>{
    return fetch(`${$8b005af3786a1e74$var$API_BASE}/${path}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-type": "application/json"
        }
    }).then((r)=>r.json()).catch(console.error);
};
const $8b005af3786a1e74$export$327f7b26ebf455db = (path, data)=>fetch(`${$8b005af3786a1e74$var$API_BASE}/${path}`, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
            "Content-type": "application/json"
        }
    }).then(async (r)=>{
        let payload = null;
        try {
            payload = await r.json();
        } catch (err) {
            payload = null;
        }
        if (!r.ok) {
            const error = new Error(`HTTP ${r.status}`);
            error.status = r.status;
            error.payload = payload;
            throw error;
        }
        return payload;
    });


const $ddadb956d940b4b7$var$getProfile = (userToken)=>(0, $8b005af3786a1e74$export$3988ae62b71be9a3)(`users/profile?userToken=${encodeURIComponent(userToken)}`);
const $ddadb956d940b4b7$var$updateProfile = (userToken, nickname)=>(0, $8b005af3786a1e74$export$327f7b26ebf455db)("users/profile", {
        userToken: userToken,
        nickname: nickname
    });
var $ddadb956d940b4b7$export$2e2bcd8739ae039 = {
    getProfile: $ddadb956d940b4b7$var$getProfile,
    updateProfile: $ddadb956d940b4b7$var$updateProfile
};


const $e8b70f167a9a3bef$var$HomeContainer = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  background-color: #90d1a8;
  // background-color: #333;
  text-align: center;
`;
const $e8b70f167a9a3bef$var$Title = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).h1`
  font-size: 3rem;
  margin-bottom: 12px;
  color: #333;
  font-weight: bold;
  margin-block-start: 32.16px;
  margin-block-end: 12px;
  // color: #90d1a8;
`;
const $e8b70f167a9a3bef$var$StatsStrip = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  width: 100%;
  max-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: 8px;
`;
const $e8b70f167a9a3bef$var$StatLine = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  border: 1px solid #7da78f;
  padding: 5px 8px;
  color: #2f4c3d;
  font-size: 11px;
  font-weight: 600;
`;
const $e8b70f167a9a3bef$var$StatValue = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).span`
  font-size: 13px;
  font-weight: 700;
  color: #1f3228;
`;
const $e8b70f167a9a3bef$var$StatHint = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).span`
  color: #3f5f4f;
  font-size: 11px;
  font-weight: 500;
`;
const $e8b70f167a9a3bef$var$ProgressCopy = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  margin-bottom: 18px;
  font-size: 12px;
  color: #395547;
`;
const $e8b70f167a9a3bef$var$ButtonBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;
// const StyledButton = styled(Button)`
//   width: 200px;
//   padding: 10px;
//   font-size: 1.2rem;
//   background-color: #90d1a8;
//   // color: white;
//   color: #333;
//   border-color: #333;
//   // border: 1px solid #333;
//   text-decoration: none;
//   display: inline-flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 5px;
//   cursor: pointer;
//   transition: background-color 0.3s;
//   // &:hover {
//   //   background-color: #78b08f;
//   // }
// `
const $e8b70f167a9a3bef$var$HOME_PROFILE_CACHE_KEY = "wordgrid.home.profile";
const $e8b70f167a9a3bef$var$getTodayUtcDate = ()=>new Date().toISOString().slice(0, 10);
const $e8b70f167a9a3bef$var$getUtcCutoffLocalLabel = ()=>{
    const now = new Date();
    const nextUtcMidnight = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 0, 0, 0, 0));
    const parts = new Intl.DateTimeFormat(undefined, {
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    }).formatToParts(nextUtcMidnight);
    const hour = parts.find((part)=>part.type === "hour")?.value || "";
    const minute = parts.find((part)=>part.type === "minute")?.value || "00";
    const dayPeriod = (parts.find((part)=>part.type === "dayPeriod")?.value || "").toLowerCase();
    const minuteSuffix = minute === "00" ? "" : `:${minute}`;
    return `${hour}${minuteSuffix}${dayPeriod}`;
};
const $e8b70f167a9a3bef$var$Home = ()=>{
    const title = "WordGrid.io";
    const [profile, setProfile] = (0, $gIfym.useState)(null);
    const [isLoadingProfile, setIsLoadingProfile] = (0, $gIfym.useState)(true);
    (0, $gIfym.useEffect)(()=>{
        let isMounted = true;
        const loadProfile = async ()=>{
            setIsLoadingProfile(true);
            try {
                const userToken = localStorage.getItem("userToken");
                if (!userToken) return;
                const userProfile = await (0, $ddadb956d940b4b7$export$2e2bcd8739ae039).getProfile(userToken);
                if (!isMounted) return;
                setProfile(userProfile);
                localStorage.setItem($e8b70f167a9a3bef$var$HOME_PROFILE_CACHE_KEY, JSON.stringify(userProfile));
            } catch (error) {
                console.warn("Failed to load profile for home screen", error);
                try {
                    const cachedRaw = localStorage.getItem($e8b70f167a9a3bef$var$HOME_PROFILE_CACHE_KEY);
                    if (cachedRaw && isMounted) setProfile(JSON.parse(cachedRaw));
                } catch (cacheError) {
                    console.warn("Failed to load cached home profile", cacheError);
                }
            } finally{
                if (isMounted) setIsLoadingProfile(false);
            }
        };
        loadProfile();
        return ()=>{
            isMounted = false;
        };
    }, []);
    const streakCopy = (0, $gIfym.useMemo)(()=>{
        if (isLoadingProfile) return "Loading your progress...";
        const todayUtcDate = $e8b70f167a9a3bef$var$getTodayUtcDate();
        const lastCompletedOn = typeof profile?.streakLastCompletedOn === "string" ? profile.streakLastCompletedOn.slice(0, 10) : null;
        return lastCompletedOn === todayUtcDate ? `Streak secured for today. Next reset at ${$e8b70f167a9a3bef$var$getUtcCutoffLocalLabel()}.` : `Complete 1 puzzle before ${$e8b70f167a9a3bef$var$getUtcCutoffLocalLabel()} to keep your streak alive.`;
    }, [
        isLoadingProfile,
        profile?.streakLastCompletedOn
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$HomeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("img", {
        width: 64,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d4d2b3d3c18e454d$exports)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$Title, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$StatsStrip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$StatLine, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        role: "img",
        "aria-label": "streak"
    }, "\uD83D\uDD25"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", null, "Streak"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$StatValue, null, isLoadingProfile ? "..." : String(profile?.dailyStreak || 0)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$StatHint, null, "days")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$StatLine, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        role: "img",
        "aria-label": "completed"
    }, "\u2705"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", null, "Completed"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$StatValue, null, isLoadingProfile ? "..." : String(profile?.completedGames || 0)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$StatHint, null, "total"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$ProgressCopy, null, streakCopy), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($e8b70f167a9a3bef$var$ButtonBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ee6e5d464bbae375$export$2e2bcd8739ae039), {
        text: "New Game",
        to: "/game/new"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ee6e5d464bbae375$export$2e2bcd8739ae039), {
        text: "Continue",
        to: "/game/continue"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ee6e5d464bbae375$export$2e2bcd8739ae039), {
        text: "Settings",
        to: "/settings"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ee6e5d464bbae375$export$2e2bcd8739ae039), {
        text: "Feedback",
        to: "/feedback"
    })));
};
var $e8b70f167a9a3bef$export$2e2bcd8739ae039 = $e8b70f167a9a3bef$var$Home;



var $gIfym = parcelRequire("gIfym");

// Written in this round about way for babel-transform-imports

var $gIfym = parcelRequire("gIfym");





var $8350ad5d1d43946b$var$patternCache = {};
var $8350ad5d1d43946b$var$cacheLimit = 10000;
var $8350ad5d1d43946b$var$cacheCount = 0;
var $8350ad5d1d43946b$var$compileGenerator = function compileGenerator(pattern) {
    var cacheKey = pattern;
    var cache = $8350ad5d1d43946b$var$patternCache[cacheKey] || ($8350ad5d1d43946b$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var compiledGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($e6cfae72bb80dad0$exports))).compile(pattern);
    if ($8350ad5d1d43946b$var$cacheCount < $8350ad5d1d43946b$var$cacheLimit) {
        cache[pattern] = compiledGenerator;
        $8350ad5d1d43946b$var$cacheCount++;
    }
    return compiledGenerator;
};
/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */ var $8350ad5d1d43946b$var$generatePath = function generatePath() {
    var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (pattern === "/") return pattern;
    var generator = $8350ad5d1d43946b$var$compileGenerator(pattern);
    return generator(params, {
        pretty: true
    });
};
var $8350ad5d1d43946b$export$2e2bcd8739ae039 = $8350ad5d1d43946b$var$generatePath;


var $663b26b86f1774ba$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $663b26b86f1774ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $663b26b86f1774ba$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $663b26b86f1774ba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for updating the location programmatically
 * with a component.
 */ var $663b26b86f1774ba$var$Redirect = function(_React$Component) {
    $663b26b86f1774ba$var$_inherits(Redirect, _React$Component);
    function Redirect() {
        $663b26b86f1774ba$var$_classCallCheck(this, Redirect);
        return $663b26b86f1774ba$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Redirect.prototype.isStatic = function isStatic() {
        return this.context.router && this.context.router.staticContext;
    };
    Redirect.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($8f76fb1a5ab0d9df$exports)))(this.context.router, "You should not use <Redirect> outside a <Router>");
        if (this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidMount = function componentDidMount() {
        if (!this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var prevTo = (0, $c0e5765fb75ef8ef$export$90c043f1c57770b8)(prevProps.to);
        var nextTo = (0, $c0e5765fb75ef8ef$export$90c043f1c57770b8)(this.props.to);
        if ((0, $c0e5765fb75ef8ef$export$c3e8bb440bd55b18)(prevTo, nextTo)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1644e4e8cc85fb30$exports)))(false, "You tried to redirect to the same route you're currently on: " + ('"' + nextTo.pathname + nextTo.search + '"'));
            return;
        }
        this.perform();
    };
    Redirect.prototype.computeTo = function computeTo(_ref) {
        var computedMatch = _ref.computedMatch, to = _ref.to;
        if (computedMatch) {
            if (typeof to === "string") return (0, $8350ad5d1d43946b$export$2e2bcd8739ae039)(to, computedMatch.params);
            else return $663b26b86f1774ba$var$_extends({}, to, {
                pathname: (0, $8350ad5d1d43946b$export$2e2bcd8739ae039)(to.pathname, computedMatch.params)
            });
        }
        return to;
    };
    Redirect.prototype.perform = function perform() {
        var history = this.context.router.history;
        var push = this.props.push;
        var to = this.computeTo(this.props);
        if (push) history.push(to);
        else history.replace(to);
    };
    Redirect.prototype.render = function render() {
        return null;
    };
    return Redirect;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$663b26b86f1774ba$var$Redirect.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
    ]).isRequired
};
$663b26b86f1774ba$var$Redirect.defaultProps = {
    push: false
};
$663b26b86f1774ba$var$Redirect.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func.isRequired
        }).isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
    }).isRequired
};
var $663b26b86f1774ba$export$2e2bcd8739ae039 = $663b26b86f1774ba$var$Redirect;


var $19737ff6f49f85c7$export$2e2bcd8739ae039 = (0, $663b26b86f1774ba$export$2e2bcd8739ae039);


var $ab009d3ca5ea0c28$exports = {};
"use strict";

$ab009d3ca5ea0c28$exports = (parcelRequire("dX6E1"));


const $3be2d95b79eebae2$var$_LOCAL_STORAGE_KEY = "recentGames";
const $3be2d95b79eebae2$var$_MAX_GAMES = 15;
const $3be2d95b79eebae2$export$d2e1544dc8131c8a = ()=>{
    const recentGames = localStorage.getItem($3be2d95b79eebae2$var$_LOCAL_STORAGE_KEY);
    if (!recentGames) return [];
    const recentParsed = JSON.parse(recentGames);
    // TODO: remove eventually
    const fixedGames = $3be2d95b79eebae2$var$fixFormatting(recentParsed);
    if (JSON.stringify(fixedGames) !== recentGames) {
        const trimmedGames = fixedGames.slice(0, $3be2d95b79eebae2$var$_MAX_GAMES);
        localStorage.setItem($3be2d95b79eebae2$var$_LOCAL_STORAGE_KEY, JSON.stringify(trimmedGames));
        return trimmedGames;
    }
    return recentParsed.slice(0, $3be2d95b79eebae2$var$_MAX_GAMES);
};
// upper + 32 == lower
// converts from camelCase to snake_case
const $3be2d95b79eebae2$var$fixFormatting = (recentGames)=>{
    const updated = recentGames.map((rg)=>{
        const newObj = {};
        Object.keys(rg).forEach((key)=>{
            const val = rg[key];
            let newKey = "";
            key.split("").forEach((char, idx)=>{
                if (char.match(/[A-Z]/)) {
                    const charCode = char.charCodeAt() + 32;
                    newKey += `_${String.fromCharCode(charCode)}`;
                } else newKey += char;
            });
            newObj[newKey] = val;
        });
        return newObj;
    });
    return updated;
};
const $3be2d95b79eebae2$export$b164046a52434f6a = (game)=>{
    const recentGames = $3be2d95b79eebae2$export$d2e1544dc8131c8a();
    const existingGame = recentGames.find((g)=>g.short_id === game.short_id);
    const formattedGame = {
        ...game,
        last_played_at: new Date().toISOString(),
        completed_at: existingGame?.completed_at || null
    };
    const existingGameIndex = recentGames.findIndex((g)=>g.short_id === formattedGame.short_id);
    if (existingGameIndex > -1) recentGames.splice(existingGameIndex, 1);
    if (recentGames.length >= $3be2d95b79eebae2$var$_MAX_GAMES) recentGames.pop();
    const newRecentGames = [
        formattedGame,
        ...recentGames
    ];
    localStorage.setItem($3be2d95b79eebae2$var$_LOCAL_STORAGE_KEY, JSON.stringify(newRecentGames));
};
const $3be2d95b79eebae2$export$95a1a7db56f99e1b = (shortId)=>{
    if (!shortId) return;
    const recentGames = $3be2d95b79eebae2$export$d2e1544dc8131c8a();
    const existingGameIndex = recentGames.findIndex((g)=>g.short_id === shortId);
    if (existingGameIndex === -1) return;
    const existing = recentGames[existingGameIndex];
    recentGames[existingGameIndex] = {
        ...existing,
        completed_at: existing.completed_at || new Date().toISOString()
    };
    localStorage.setItem($3be2d95b79eebae2$var$_LOCAL_STORAGE_KEY, JSON.stringify(recentGames));
};
const $3be2d95b79eebae2$export$1adf613f7458986 = (shortId)=>{
    const recentGames = $3be2d95b79eebae2$export$d2e1544dc8131c8a();
    return recentGames.find((g)=>g.short_id === shortId);
};



const $1fb8695a0c221e27$var$createGame = (filename)=>(0, $8b005af3786a1e74$export$299ba2dee77727e9)("games", {
        filename: filename
    });
const $1fb8695a0c221e27$var$getGameInfo = (gameId)=>(0, $8b005af3786a1e74$export$3988ae62b71be9a3)(`games/${gameId}`);
const $1fb8695a0c221e27$var$getPuzzles = (page, userToken)=>(0, $8b005af3786a1e74$export$3988ae62b71be9a3)(`games/puzzles?page=${page}&userToken=${userToken}`);
const $1fb8695a0c221e27$var$getPuzzlePreview = (filename)=>(0, $8b005af3786a1e74$export$3988ae62b71be9a3)(`games/puzzles/preview?filename=${encodeURIComponent(filename)}`);
var $1fb8695a0c221e27$export$2e2bcd8739ae039 = {
    createGame: $1fb8695a0c221e27$var$createGame,
    getGameInfo: $1fb8695a0c221e27$var$getGameInfo,
    getPuzzles: $1fb8695a0c221e27$var$getPuzzles,
    getPuzzlePreview: $1fb8695a0c221e27$var$getPuzzlePreview
};



var $gIfym = parcelRequire("gIfym");

parcelRequire("6IRuR");
var $adfd51cc57da14ef$exports = {};

!function(root, factory) {
    $adfd51cc57da14ef$exports = factory((parcelRequire("gIfym")));
}("undefined" != typeof self ? self : $adfd51cc57da14ef$exports, function(__WEBPACK_EXTERNAL_MODULE_5__) {
    return function(modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module1 = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__), module1.l = !0, module1.exports;
        }
        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        }, __webpack_require__.n = function(module1) {
            var getter = module1 && module1.__esModule ? function() {
                return module1.default;
            } : function() {
                return module1;
            };
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 4);
    }([
        function(module1, exports, __webpack_require__) {
            var REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, isValidElement = function(object) {
                return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
            };
            module1.exports = __webpack_require__(6)(isValidElement, !0);
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function hyphenateStyleName(string) {
                return string in cache ? cache[string] : cache[string] = string.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
            }
            var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
            module1.exports = hyphenateStyleName;
        },
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = null != arguments[i] ? arguments[i] : {}, ownKeys = Object.keys(source);
                    "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                    }))), ownKeys.forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    });
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                return key in obj ? Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : obj[key] = value, obj;
            }
            var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__), stringOrNumber = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([
                __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
            ]), matchers = {
                orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([
                    "portrait",
                    "landscape"
                ]),
                scan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([
                    "progressive",
                    "interlace"
                ]),
                aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                deviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                height: stringOrNumber,
                deviceHeight: stringOrNumber,
                width: stringOrNumber,
                deviceWidth: stringOrNumber,
                color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                colorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                monochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                resolution: stringOrNumber
            }, features = _objectSpread({
                minAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                maxAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                minDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                maxDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                minHeight: stringOrNumber,
                maxHeight: stringOrNumber,
                minDeviceHeight: stringOrNumber,
                maxDeviceHeight: stringOrNumber,
                minWidth: stringOrNumber,
                maxWidth: stringOrNumber,
                minDeviceWidth: stringOrNumber,
                maxDeviceWidth: stringOrNumber,
                minColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                maxColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                minColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                maxColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                minMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                maxMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                minResolution: stringOrNumber,
                maxResolution: stringOrNumber
            }, matchers), types = {
                all: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                grid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                aural: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                braille: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                handheld: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                print: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                projection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                screen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                tty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                tv: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
                embossed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
            }, all = _objectSpread({}, types, features);
            matchers.type = Object.keys(types), __webpack_exports__.a = {
                all: all,
                types: types,
                matchers: matchers,
                features: features
            };
        },
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _typeof(obj) {
                return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                })(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
            }
            function _possibleConstructorReturn(self1, call) {
                return !call || "object" !== _typeof(call) && "function" != typeof call ? _assertThisInitialized(self1) : call;
            }
            function _getPrototypeOf(o) {
                return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                })(o);
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: !0,
                        configurable: !0
                    }
                }), superClass && _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                return (_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                    return o.__proto__ = p, o;
                })(o, p);
            }
            function _assertThisInitialized(self1) {
                if (void 0 === self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self1;
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = null != arguments[i] ? arguments[i] : {}, ownKeys = Object.keys(source);
                    "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                    }))), ownKeys.forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    });
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                return key in obj ? Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : obj[key] = value, obj;
            }
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            }), __webpack_require__.d(__webpack_exports__, "default", function() {
                return MediaQuery;
            });
            var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(5), __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__), __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery__ = __webpack_require__(9), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_matchmediaquery__), __WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__ = __webpack_require__(2), __WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__), __WEBPACK_IMPORTED_MODULE_4__mediaQuery__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_5__toQuery__ = __webpack_require__(11);
            __webpack_require__.d(__webpack_exports__, "toQuery", function() {
                return __WEBPACK_IMPORTED_MODULE_5__toQuery__.a;
            });
            var defaultTypes = {
                component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
                query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
                values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__mediaQuery__.a.matchers),
                children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
                    __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
                    __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
                ]),
                onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
            }, excludedQueryKeys = Object.keys(defaultTypes), omit = function(object, keys) {
                var newObject = _objectSpread({}, object);
                return keys.forEach(function(key) {
                    return delete newObject[key];
                }), newObject;
            }, getValues = function(_ref) {
                var _ref$values = _ref.values, values = void 0 === _ref$values ? {} : _ref$values;
                return Object.keys(values).reduce(function(result, key) {
                    return result[__WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name___default()(key)] = values[key], result;
                }, {});
            }, getQuery = function(props) {
                return props.query || Object(__WEBPACK_IMPORTED_MODULE_5__toQuery__.a)(omit(props, excludedQueryKeys));
            }, createMatchMedia = function(props, query) {
                var values = getValues(props), forceStatic = 0 === values.length;
                return __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default()(query, values, forceStatic);
            }, MediaQuery = function(_React$Component) {
                function MediaQuery() {
                    var _getPrototypeOf2, _this;
                    _classCallCheck(this, MediaQuery);
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MediaQuery)).call.apply(_getPrototypeOf2, [
                        this
                    ].concat(args))), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
                        matches: !1,
                        mq: null,
                        query: ""
                    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cleanupMediaQuery", function(mq) {
                        mq && (mq.removeListener(_this.updateMatches), mq.dispose());
                    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateMatches", function() {
                        _this._unmounted || _this.state.mq.matches !== _this.state.matches && _this.setState({
                            matches: _this.state.mq.matches
                        });
                    }), _this;
                }
                return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.state.mq.addListener(this.updateMatches), this.updateMatches();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(prevProps, prevState) {
                            this.state.mq !== prevState.mq && (this.cleanupMediaQuery(prevState.mq), this.state.mq.addListener(this.updateMatches)), this.props.onChange && prevState.matches !== this.state.matches && this.props.onChange(this.state.matches);
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this._unmounted = !0, this.cleanupMediaQuery(this.state.mq);
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            return "function" == typeof this.props.children ? this.props.children(this.state.matches) : this.state.matches ? this.props.children : null;
                        }
                    }
                ], [
                    {
                        key: "getDerivedStateFromProps",
                        value: function(props, state) {
                            var query = getQuery(props);
                            if (!query) throw new Error("Invalid or missing MediaQuery!");
                            if (query === state.query) return null;
                            var mq = createMatchMedia(props, query);
                            return {
                                matches: mq.matches,
                                mq: mq,
                                query: query
                            };
                        }
                    }
                ]), MediaQuery;
            }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
            _defineProperty(MediaQuery, "displayName", "MediaQuery"), _defineProperty(MediaQuery, "defaultProps", {
                values: {}
            });
        },
        function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_5__;
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function emptyFunctionThatReturnsNull() {
                return null;
            }
            var assign = __webpack_require__(7), ReactPropTypesSecret = __webpack_require__(1), checkPropTypes = __webpack_require__(8), printWarning = function() {};
            printWarning = function(text) {
                var message = "Warning: " + text;
                "undefined" != typeof console && console.error(message);
                try {
                    throw new Error(message);
                } catch (x) {}
            }, module1.exports = function(isValidElement, throwOnDirectAccess) {
                function getIteratorFn(maybeIterable) {
                    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if ("function" == typeof iteratorFn) return iteratorFn;
                }
                function is(x, y) {
                    return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
                }
                function PropTypeError(message) {
                    this.message = message, this.stack = "";
                }
                function createChainableTypeChecker(validate) {
                    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                        if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, secret !== ReactPropTypesSecret) {
                            if (throwOnDirectAccess) {
                                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                                throw err.name = "Invariant Violation", err;
                            }
                            if ("undefined" != typeof console) {
                                var cacheKey = componentName + ":" + propName;
                                !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
                            }
                        }
                        return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
                    }
                    var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
                    return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
                }
                function createPrimitiveTypeChecker(expectedType) {
                    function validate(props, propName, componentName, location, propFullName, secret) {
                        var propValue = props[propName];
                        if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createArrayOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                        var propValue = props[propName];
                        if (!Array.isArray(propValue)) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
                        for(var i = 0; i < propValue.length; i++){
                            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createInstanceTypeChecker(expectedClass) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!(props[propName] instanceof expectedClass)) {
                            var expectedClassName = expectedClass.name || ANONYMOUS;
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createEnumTypeChecker(expectedValues) {
                    function validate(props, propName, componentName, location, propFullName) {
                        for(var propValue = props[propName], i = 0; i < expectedValues.length; i++)if (is(propValue, expectedValues[i])) return null;
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` supplied to `" + componentName + "`, expected one of " + JSON.stringify(expectedValues) + ".");
                    }
                    return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning("Invalid argument supplied to oneOf, expected an instance of array."), emptyFunctionThatReturnsNull);
                }
                function createObjectOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                        var propValue = props[propName], propType = getPropType(propValue);
                        if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
                        for(var key in propValue)if (propValue.hasOwnProperty(key)) {
                            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createUnionTypeChecker(arrayOfTypeCheckers) {
                    function validate(props, propName, componentName, location, propFullName) {
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
                        }
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
                    }
                    if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;
                    for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                        var checker = arrayOfTypeCheckers[i];
                        if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), emptyFunctionThatReturnsNull;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName], propType = getPropType(propValue);
                        if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                        for(var key in shapeTypes){
                            var checker = shapeTypes[key];
                            if (checker) {
                                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createStrictShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName], propType = getPropType(propValue);
                        if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                        var allKeys = assign({}, props[propName], shapeTypes);
                        for(var key in allKeys){
                            var checker = shapeTypes[key];
                            if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function isNode(propValue) {
                    switch(typeof propValue){
                        case "number":
                        case "string":
                        case "undefined":
                            return !0;
                        case "boolean":
                            return !propValue;
                        case "object":
                            if (Array.isArray(propValue)) return propValue.every(isNode);
                            if (null === propValue || isValidElement(propValue)) return !0;
                            var iteratorFn = getIteratorFn(propValue);
                            if (!iteratorFn) return !1;
                            var step, iterator = iteratorFn.call(propValue);
                            if (iteratorFn !== propValue.entries) {
                                for(; !(step = iterator.next()).done;)if (!isNode(step.value)) return !1;
                            } else for(; !(step = iterator.next()).done;){
                                var entry = step.value;
                                if (entry && !isNode(entry[1])) return !1;
                            }
                            return !0;
                        default:
                            return !1;
                    }
                }
                function isSymbol(propType, propValue) {
                    return "symbol" === propType || "Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol;
                }
                function getPropType(propValue) {
                    var propType = typeof propValue;
                    return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
                }
                function getPreciseType(propValue) {
                    if (void 0 === propValue || null === propValue) return "" + propValue;
                    var propType = getPropType(propValue);
                    if ("object" === propType) {
                        if (propValue instanceof Date) return "date";
                        if (propValue instanceof RegExp) return "regexp";
                    }
                    return propType;
                }
                function getPostfixForTypeWarning(value) {
                    var type = getPreciseType(value);
                    switch(type){
                        case "array":
                        case "object":
                            return "an " + type;
                        case "boolean":
                        case "date":
                        case "regexp":
                            return "a " + type;
                        default:
                            return type;
                    }
                }
                function getClassName(propValue) {
                    return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
                }
                var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
                    array: createPrimitiveTypeChecker("array"),
                    bool: createPrimitiveTypeChecker("boolean"),
                    func: createPrimitiveTypeChecker("function"),
                    number: createPrimitiveTypeChecker("number"),
                    object: createPrimitiveTypeChecker("object"),
                    string: createPrimitiveTypeChecker("string"),
                    symbol: createPrimitiveTypeChecker("symbol"),
                    any: function() {
                        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                    }(),
                    arrayOf: createArrayOfTypeChecker,
                    element: function() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!isValidElement(propValue)) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }(),
                    instanceOf: createInstanceTypeChecker,
                    node: function() {
                        function validate(props, propName, componentName, location, propFullName) {
                            return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
                        }
                        return createChainableTypeChecker(validate);
                    }(),
                    objectOf: createObjectOfTypeChecker,
                    oneOf: createEnumTypeChecker,
                    oneOfType: createUnionTypeChecker,
                    shape: createShapeTypeChecker,
                    exact: createStrictShapeTypeChecker
                };
                return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
            };
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function toObject(val) {
                if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(val);
            }
            /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
            module1.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var test1 = new String("abc");
                    if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
                    for(var test2 = {}, i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                    if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
                        return test2[n];
                    }).join("")) return !1;
                    var test3 = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                        test3[letter] = letter;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
                } catch (err) {
                    return !1;
                }
            }() ? Object.assign : function(target, source) {
                for(var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++){
                    from = Object(arguments[s]);
                    for(var key in from)hasOwnProperty.call(from, key) && (to[key] = from[key]);
                    if (getOwnPropertySymbols) {
                        symbols = getOwnPropertySymbols(from);
                        for(var i = 0; i < symbols.length; i++)propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
                    }
                }
                return to;
            };
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                for(var typeSpecName in typeSpecs)if (typeSpecs.hasOwnProperty(typeSpecName)) {
                    var error;
                    try {
                        if ("function" != typeof typeSpecs[typeSpecName]) {
                            var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                            throw err.name = "Invariant Violation", err;
                        }
                        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                    } catch (ex) {
                        error = ex;
                    }
                    if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), error instanceof Error && !(error.message in loggedTypeFailures)) {
                        loggedTypeFailures[error.message] = !0;
                        var stack = getStack ? getStack() : "";
                        printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
                    }
                }
            }
            var printWarning = function() {}, ReactPropTypesSecret = __webpack_require__(1), loggedTypeFailures = {};
            printWarning = function(text) {
                var message = "Warning: " + text;
                "undefined" != typeof console && console.error(message);
                try {
                    throw new Error(message);
                } catch (x) {}
            }, module1.exports = checkPropTypes;
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function Mql(query, values, forceStatic) {
                function addListener(listener) {
                    mql && mql.addListener(listener);
                }
                function removeListener(listener) {
                    mql && mql.removeListener(listener);
                }
                function update(evt) {
                    self1.matches = evt.matches, self1.media = evt.media;
                }
                function dispose() {
                    mql && mql.removeListener(update);
                }
                var self1 = this;
                if (dynamicMatch && !forceStatic) {
                    var mql = dynamicMatch.call(window, query);
                    this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
                } else this.matches = staticMatch(query, values), this.media = query;
                this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
            }
            function matchMedia(query, values, forceStatic) {
                return new Mql(query, values, forceStatic);
            }
            var staticMatch = __webpack_require__(10).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
            module1.exports = matchMedia;
        },
        function(module1, exports, __webpack_require__) {
            "use strict";
            function matchQuery(mediaQuery, values) {
                return parseQuery(mediaQuery).some(function(query) {
                    var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
                    if (typeMatch && inverse || !typeMatch && !inverse) return !1;
                    var expressionsMatch = query.expressions.every(function(expression) {
                        var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                        if (!value) return !1;
                        switch(feature){
                            case "orientation":
                            case "scan":
                                return value.toLowerCase() === expValue.toLowerCase();
                            case "width":
                            case "height":
                            case "device-width":
                            case "device-height":
                                expValue = toPx(expValue), value = toPx(value);
                                break;
                            case "resolution":
                                expValue = toDpi(expValue), value = toDpi(value);
                                break;
                            case "aspect-ratio":
                            case "device-aspect-ratio":
                            case "device-pixel-ratio":
                                expValue = toDecimal(expValue), value = toDecimal(value);
                                break;
                            case "grid":
                            case "color":
                            case "color-index":
                            case "monochrome":
                                expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
                        }
                        switch(modifier){
                            case "min":
                                return value >= expValue;
                            case "max":
                                return value <= expValue;
                            default:
                                return value === expValue;
                        }
                    });
                    return expressionsMatch && !inverse || !expressionsMatch && inverse;
                });
            }
            function parseQuery(mediaQuery) {
                return mediaQuery.split(",").map(function(query) {
                    query = query.trim();
                    var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                    return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
                        var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                        return {
                            modifier: feature[1],
                            feature: feature[2],
                            value: captures[2]
                        };
                    }), parsed;
                });
            }
            function toDecimal(ratio) {
                var numbers, decimal = Number(ratio);
                return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), decimal;
            }
            function toDpi(resolution) {
                var value = parseFloat(resolution);
                switch(String(resolution).match(RE_RESOLUTION_UNIT)[1]){
                    case "dpcm":
                        return value / 2.54;
                    case "dppx":
                        return 96 * value;
                    default:
                        return value;
                }
            }
            function toPx(length) {
                var value = parseFloat(length);
                switch(String(length).match(RE_LENGTH_UNIT)[1]){
                    case "em":
                    case "rem":
                        return 16 * value;
                    case "cm":
                        return 96 * value / 2.54;
                    case "mm":
                        return 96 * value / 2.54 / 10;
                    case "in":
                        return 96 * value;
                    case "pt":
                        return 72 * value;
                    case "pc":
                        return 72 * value / 12;
                    default:
                        return value;
                }
            }
            exports.match = matchQuery, exports.parse = parseQuery;
            var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
        },
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            function keyVal(k, v) {
                var realKey = __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name___default()(k);
                return "number" == typeof v && (v = "".concat(v, "px")), !0 === v ? k : !1 === v ? negate(k) : "(".concat(realKey, ": ").concat(v, ")");
            }
            function join(conds) {
                return conds.join(" and ");
            }
            var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(2), __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__), __WEBPACK_IMPORTED_MODULE_1__mediaQuery__ = __webpack_require__(3), negate = function(cond) {
                return "not ".concat(cond);
            };
            __webpack_exports__.a = function(obj) {
                var rules = [];
                return Object.keys(__WEBPACK_IMPORTED_MODULE_1__mediaQuery__.a.all).forEach(function(k) {
                    var v = obj[k];
                    null != v && rules.push(keyVal(k, v));
                }), join(rules);
            };
        }
    ]);
});





var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");

function $6080bdebdcd55ee7$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $9d0d0c37df867b82$export$2e2bcd8739ae039(t, e) {
    return $9d0d0c37df867b82$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9d0d0c37df867b82$export$2e2bcd8739ae039(t, e);
}


function $08bbac2f6708d378$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $9d0d0c37df867b82$export$2e2bcd8739ae039)(t, o);
}



function $dca0dd7d0fc909d9$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $5eb3f9a936237142$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $dca0dd7d0fc909d9$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $883a28a3079d74fd$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $883a28a3079d74fd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $883a28a3079d74fd$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $883a28a3079d74fd$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $gIfym = parcelRequire("gIfym");




var $gIfym = parcelRequire("gIfym");

var $7600586e28688e32$export$2e2bcd8739ae039 = {
    disabled: false
};




var $gIfym = parcelRequire("gIfym");
var $62aabe3b0546d049$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createContext(null);


var $19bb90b7fff15f94$export$bb38bb9a1161268 = "unmounted";
var $19bb90b7fff15f94$export$84cbff306f539230 = "exited";
var $19bb90b7fff15f94$export$df38205c966be359 = "entering";
var $19bb90b7fff15f94$export$78e9e6e3e014d60a = "entered";
var $19bb90b7fff15f94$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $19bb90b7fff15f94$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $08bbac2f6708d378$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $19bb90b7fff15f94$export$84cbff306f539230;
                _this.appearStatus = $19bb90b7fff15f94$export$df38205c966be359;
            } else initialStatus = $19bb90b7fff15f94$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $19bb90b7fff15f94$export$bb38bb9a1161268;
        else initialStatus = $19bb90b7fff15f94$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $19bb90b7fff15f94$export$bb38bb9a1161268) return {
            status: $19bb90b7fff15f94$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $19bb90b7fff15f94$export$df38205c966be359 && status !== $19bb90b7fff15f94$export$78e9e6e3e014d60a) nextStatus = $19bb90b7fff15f94$export$df38205c966be359;
            } else if (status === $19bb90b7fff15f94$export$df38205c966be359 || status === $19bb90b7fff15f94$export$78e9e6e3e014d60a) nextStatus = $19bb90b7fff15f94$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $19bb90b7fff15f94$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $19bb90b7fff15f94$export$84cbff306f539230) this.setState({
            status: $19bb90b7fff15f94$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $7600586e28688e32$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $19bb90b7fff15f94$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $19bb90b7fff15f94$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $19bb90b7fff15f94$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $7600586e28688e32$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $19bb90b7fff15f94$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $19bb90b7fff15f94$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $19bb90b7fff15f94$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $19bb90b7fff15f94$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $6080bdebdcd55ee7$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $62aabe3b0546d049$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$19bb90b7fff15f94$var$Transition.contextType = (0, $62aabe3b0546d049$export$2e2bcd8739ae039);
$19bb90b7fff15f94$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $19bb90b7fff15f94$var$noop() {}
$19bb90b7fff15f94$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $19bb90b7fff15f94$var$noop,
    onEntering: $19bb90b7fff15f94$var$noop,
    onEntered: $19bb90b7fff15f94$var$noop,
    onExit: $19bb90b7fff15f94$var$noop,
    onExiting: $19bb90b7fff15f94$var$noop,
    onExited: $19bb90b7fff15f94$var$noop
};
$19bb90b7fff15f94$var$Transition.UNMOUNTED = $19bb90b7fff15f94$export$bb38bb9a1161268;
$19bb90b7fff15f94$var$Transition.EXITED = $19bb90b7fff15f94$export$84cbff306f539230;
$19bb90b7fff15f94$var$Transition.ENTERING = $19bb90b7fff15f94$export$df38205c966be359;
$19bb90b7fff15f94$var$Transition.ENTERED = $19bb90b7fff15f94$export$78e9e6e3e014d60a;
$19bb90b7fff15f94$var$Transition.EXITING = $19bb90b7fff15f94$export$4aacc83d4d59139f;
var $19bb90b7fff15f94$export$2e2bcd8739ae039 = $19bb90b7fff15f94$var$Transition;



var $8a71f0ffeeb4040b$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $5eb3f9a936237142$export$2e2bcd8739ae039)(node, c);
    });
};
var $8a71f0ffeeb4040b$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $883a28a3079d74fd$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $8a71f0ffeeb4040b$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $08bbac2f6708d378$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") /* eslint-disable no-unused-expressions */ node && node.scrollTop;
        if (className) {
            this.appliedClasses[type][phase] = className;
            $8a71f0ffeeb4040b$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $8a71f0ffeeb4040b$var$removeClass(node, baseClassName);
        if (activeClassName) $8a71f0ffeeb4040b$var$removeClass(node, activeClassName);
        if (doneClassName) $8a71f0ffeeb4040b$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $6080bdebdcd55ee7$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $19bb90b7fff15f94$export$2e2bcd8739ae039), (0, $e97d362134fa57b8$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component);
$8a71f0ffeeb4040b$var$CSSTransition.defaultProps = {
    classNames: ""
};
$8a71f0ffeeb4040b$var$CSSTransition.propTypes = {};
var $8a71f0ffeeb4040b$export$2e2bcd8739ae039 = $8a71f0ffeeb4040b$var$CSSTransition;





var $gIfym = parcelRequire("gIfym");

const $387da96e89a8f98f$var$SCALE = 8;
const $387da96e89a8f98f$var$DURATION = 1.6;
const $387da96e89a8f98f$var$SHARED_PING_COLOR = "#0ea5e9";
const $387da96e89a8f98f$var$Circle = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
    pointer-events: none;
    position: relative;
    z-index: 3;
    opacity: 0;
    position: absolute;
    width: 10px;
    height: 10px;
    border: 2px solid ${$387da96e89a8f98f$var$SHARED_PING_COLOR};
    border-radius: 150%;
    transition-property: opacity, transform;
    transition-duration: ${$387da96e89a8f98f$var$DURATION}s;
    transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
    will-change: transform, opacity;

    &.fade-grow-enter, &.fade-grow-appear {
        opacity: 1;
    }

    &.fade-grow-enter-active, &.fade-grow-appear-active {
        opacity: 0;
        transform: scale(${$387da96e89a8f98f$var$SCALE});
    }

    &.fade-grow-enter-done, &.fade-grow-appear-done {
        transform: scale(${$387da96e89a8f98f$var$SCALE});
        opacity: 0;
    }
`;
const $387da96e89a8f98f$var$Ping = ({ onDestroy: onDestroy })=>{
    (0, $gIfym.useEffect)(()=>{
        const timeoutId = window.setTimeout(()=>{
            onDestroy();
        }, $387da96e89a8f98f$var$DURATION * 1000 - 200);
        return ()=>{
            window.clearTimeout(timeoutId);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($387da96e89a8f98f$var$Circle, null);
};
var $387da96e89a8f98f$export$2e2bcd8739ae039 = $387da96e89a8f98f$var$Ping;


const $21bcdce59356c616$var$PING_DELAY = 1500;
const $21bcdce59356c616$var$Box = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const $21bcdce59356c616$var$Pinger = ({ pingKey: pingKey, onPing: onPing })=>{
    const ref = (0, $gIfym.useRef)(null);
    const [lastPingKey, setLastPingKey] = (0, $gIfym.useState)(pingKey);
    const [pingerKey] = (0, $gIfym.useState)((0, (/*@__PURE__*/$parcel$interopDefault($ab009d3ca5ea0c28$exports))).generate());
    const [pings, setPings] = (0, $gIfym.useState)([]);
    const removePing = (pingId)=>{
        setPings((pings)=>pings.filter((p)=>p.id !== pingId));
    };
    const createPing = (local = false)=>{
        const ping = {
            id: (0, (/*@__PURE__*/$parcel$interopDefault($ab009d3ca5ea0c28$exports))).generate()
        };
        if (local) onPing();
        setPings((pings)=>pings.concat(ping));
    };
    (0, $gIfym.useEffect)(()=>{
        if (!ref.current) return;
        ref.current.oncontextmenu = (e)=>{
            e.preventDefault();
            createPing(true);
        };
    }, [
        ref.current
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (pingKey === lastPingKey || !pingKey) return;
        if (!lastPingKey) {
            setLastPingKey(pingKey);
            return;
        }
        createPing(pingKey.startsWith("local-"));
        setLastPingKey(pingKey);
    }, [
        pingKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($21bcdce59356c616$var$Box, {
        ref: ref
    }, pings.map((p, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $8a71f0ffeeb4040b$export$2e2bcd8739ae039), {
            key: `pinger-${pingerKey}-${p.id}`,
            classNames: "fade-grow",
            appear: true,
            in: true,
            unmountOnExit: true,
            timeout: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $387da96e89a8f98f$export$2e2bcd8739ae039), {
            key: `ping-${pingerKey}-${p.id}`,
            onDestroy: ()=>removePing(p.id)
        }))));
};
var $21bcdce59356c616$export$2e2bcd8739ae039 = $21bcdce59356c616$var$Pinger;


const $774c0cd5a971910f$var$PRESENCE_COLOR_MAP = {
    red: "rgba(219, 94, 72, 0.92)",
    green: "rgba(138, 219, 72, 0.92)",
    blue: "rgba(72, 155, 219, 0.92)",
    purple: "rgba(153, 72, 219, 0.92)",
    orange: "rgba(219, 170, 72, 0.92)"
};
const $774c0cd5a971910f$var$ClueNumberSpan = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).span`
    position: absolute;
    top: 1px;
    left: 2px;
    font-size: 0.4em;
    color: #4a6054;

    @media only screen and (min-width: 1000px) {
        font-size: 0.4em !important;
    }
`;
const $774c0cd5a971910f$var$Square = (props)=>{
    const inputRef = (0, $gIfym.useRef)(null);
    const { text: text, filled: filled, selected: selected, correct: correct, mistake: mistake, user: user, highlighted: highlighted, onClick: onClick, onKeyDown: onKeyDown, style: style, pingKey: pingKey, onPing: onPing, clueNumber: clueNumber } = props;
    const presenceColor = user && $774c0cd5a971910f$var$PRESENCE_COLOR_MAP[user.color];
    const presenceStyle = {};
    if (!filled && presenceColor && !selected) {
        presenceStyle.borderColor = presenceColor;
        presenceStyle.borderWidth = "1.5px";
        if (!correct && !mistake) presenceStyle.backgroundColor = presenceColor;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        onClick: onClick,
        className: [
            "Square",
            filled && "filled",
            highlighted && "highlighted",
            selected && "selected",
            correct && !filled && "correct",
            mistake && !filled && "mistake"
        ].join(" "),
        style: {
            ...style,
            ...presenceStyle
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        ref: inputRef,
        className: "InputText",
        onChange: (e)=>{
            let { value: key } = e.target;
            if (key.length > 1) key = key[key.length - 1];
            onKeyDown({
                key: key,
                preventDefault: ()=>null
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($774c0cd5a971910f$var$ClueNumberSpan, null, clueNumber), text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $21bcdce59356c616$export$2e2bcd8739ae039), {
        pingKey: pingKey,
        onPing: onPing
    }));
};
var $774c0cd5a971910f$export$2e2bcd8739ae039 = $774c0cd5a971910f$var$Square;



var $gIfym = parcelRequire("gIfym");

var $2aa232ed3f791922$exports = {};
/*!
 * 
 *   react-simple-keyboard v2.3.66
 *   https://github.com/hodgef/react-simple-keyboard
 * 
 *   Copyright (c) Francisco Hodge (https://github.com/hodgef)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *   
 */ 
!function(e, t) {
    $2aa232ed3f791922$exports = t((parcelRequire("gIfym")));
}(window, function(e) {
    return function(e) {
        var t = {};
        function __webpack_require__(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
        }
        return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function(e, t, n) {
            __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, __webpack_require__.r = function(e) {
            "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, __webpack_require__.t = function(e, t) {
            if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
            if (4 & t && "object" === typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)__webpack_require__.d(n, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return n;
        }, __webpack_require__.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return __webpack_require__.d(t, "a", t), t;
        }, __webpack_require__.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 2);
    }([
        function(t, n) {
            t.exports = e;
        },
        function(e, t, n) {
            (function(e) {
                var o, i, r, s, a = n(4);
                window, s = function() {
                    return function(e) {
                        var t = {};
                        function __webpack_require__(n) {
                            if (t[n]) return t[n].exports;
                            var o = t[n] = {
                                i: n,
                                l: !1,
                                exports: {}
                            };
                            return e[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
                        }
                        return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function(e, t, n) {
                            __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
                                enumerable: !0,
                                get: n
                            });
                        }, __webpack_require__.r = function(e) {
                            "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(e, "__esModule", {
                                value: !0
                            });
                        }, __webpack_require__.t = function(e, t) {
                            if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
                            if (4 & t && "object" === a(e) && e && e.__esModule) return e;
                            var n = Object.create(null);
                            if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
                                enumerable: !0,
                                value: e
                            }), 2 & t && "string" != typeof e) for(var o in e)__webpack_require__.d(n, o, (function(t) {
                                return e[t];
                            }).bind(null, o));
                            return n;
                        }, __webpack_require__.n = function(e) {
                            var t = e && e.__esModule ? function() {
                                return e.default;
                            } : function() {
                                return e;
                            };
                            return __webpack_require__.d(t, "a", t), t;
                        }, __webpack_require__.o = function(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 0);
                    }([
                        function(e, t, n) {
                            e.exports = n(2);
                        },
                        function(e, t, n) {},
                        function(e, t, n) {
                            "use strict";
                            function _arrayLikeToArray(e, t) {
                                (null == t || t > e.length) && (t = e.length);
                                for(var n = 0, o = new Array(t); n < t; n++)o[n] = e[n];
                                return o;
                            }
                            function _typeof(e) {
                                return (_typeof = "function" === typeof Symbol && "symbol" === a(Symbol.iterator) ? function(e) {
                                    return a(e);
                                } : function(e) {
                                    return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : a(e);
                                })(e);
                            }
                            function _defineProperties(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var o = t[n];
                                    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                                }
                            }
                            n.r(t), n(1);
                            var o = function() {
                                function Utilities(e) {
                                    var t = e.getOptions, n = e.getCaretPosition, o = e.dispatch;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, Utilities), this.getOptions = t, this.getCaretPosition = n, this.dispatch = o, Utilities.bindMethods(Utilities, this);
                                }
                                var e, t, n;
                                return e = Utilities, n = [
                                    {
                                        key: "bindMethods",
                                        value: function(e, t) {
                                            var n, o = function(e, t) {
                                                var n;
                                                if ("undefined" === typeof Symbol || null == e[Symbol.iterator]) {
                                                    if (Array.isArray(e) || (n = function(e, t) {
                                                        if (e) {
                                                            if ("string" === typeof e) return _arrayLikeToArray(e, t);
                                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0;
                                                        }
                                                    }(e)) || t && e && "number" === typeof e.length) {
                                                        n && (e = n);
                                                        var o = 0, F = function() {};
                                                        return {
                                                            s: F,
                                                            n: function() {
                                                                return o >= e.length ? {
                                                                    done: !0
                                                                } : {
                                                                    done: !1,
                                                                    value: e[o++]
                                                                };
                                                            },
                                                            e: function(e) {
                                                                throw e;
                                                            },
                                                            f: F
                                                        };
                                                    }
                                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                                }
                                                var i, r = !0, s = !1;
                                                return {
                                                    s: function() {
                                                        n = e[Symbol.iterator]();
                                                    },
                                                    n: function() {
                                                        var e = n.next();
                                                        return r = e.done, e;
                                                    },
                                                    e: function(e) {
                                                        s = !0, i = e;
                                                    },
                                                    f: function() {
                                                        try {
                                                            r || null == n.return || n.return();
                                                        } finally{
                                                            if (s) throw i;
                                                        }
                                                    }
                                                };
                                            }(Object.getOwnPropertyNames(e.prototype));
                                            try {
                                                for(o.s(); !(n = o.n()).done;){
                                                    var i = n.value;
                                                    "constructor" === i || "bindMethods" === i || (t[i] = t[i].bind(t));
                                                }
                                            } catch (r) {
                                                o.e(r);
                                            } finally{
                                                o.f();
                                            }
                                        }
                                    }
                                ], t = [
                                    {
                                        key: "getButtonClass",
                                        value: function(e) {
                                            var t = e.includes("{") && e.includes("}") && "{//}" !== e ? "functionBtn" : "standardBtn", n = e.replace("{", "").replace("}", ""), o = "";
                                            return "standardBtn" !== t && (o = " hg-button-".concat(n)), "hg-".concat(t).concat(o);
                                        }
                                    },
                                    {
                                        key: "getDefaultDiplay",
                                        value: function() {
                                            return {
                                                "{bksp}": "backspace",
                                                "{backspace}": "backspace",
                                                "{enter}": "< enter",
                                                "{shift}": "shift",
                                                "{shiftleft}": "shift",
                                                "{shiftright}": "shift",
                                                "{alt}": "alt",
                                                "{s}": "shift",
                                                "{tab}": "tab",
                                                "{lock}": "caps",
                                                "{capslock}": "caps",
                                                "{accept}": "Submit",
                                                "{space}": " ",
                                                "{//}": " ",
                                                "{esc}": "esc",
                                                "{escape}": "esc",
                                                "{f1}": "f1",
                                                "{f2}": "f2",
                                                "{f3}": "f3",
                                                "{f4}": "f4",
                                                "{f5}": "f5",
                                                "{f6}": "f6",
                                                "{f7}": "f7",
                                                "{f8}": "f8",
                                                "{f9}": "f9",
                                                "{f10}": "f10",
                                                "{f11}": "f11",
                                                "{f12}": "f12",
                                                "{numpaddivide}": "/",
                                                "{numlock}": "lock",
                                                "{arrowup}": "\u2191",
                                                "{arrowleft}": "\u2190",
                                                "{arrowdown}": "\u2193",
                                                "{arrowright}": "\u2192",
                                                "{prtscr}": "print",
                                                "{scrolllock}": "scroll",
                                                "{pause}": "pause",
                                                "{insert}": "ins",
                                                "{home}": "home",
                                                "{pageup}": "up",
                                                "{delete}": "del",
                                                "{end}": "end",
                                                "{pagedown}": "down",
                                                "{numpadmultiply}": "*",
                                                "{numpadsubtract}": "-",
                                                "{numpadadd}": "+",
                                                "{numpadenter}": "enter",
                                                "{period}": ".",
                                                "{numpaddecimal}": ".",
                                                "{numpad0}": "0",
                                                "{numpad1}": "1",
                                                "{numpad2}": "2",
                                                "{numpad3}": "3",
                                                "{numpad4}": "4",
                                                "{numpad5}": "5",
                                                "{numpad6}": "6",
                                                "{numpad7}": "7",
                                                "{numpad8}": "8",
                                                "{numpad9}": "9"
                                            };
                                        }
                                    },
                                    {
                                        key: "getButtonDisplayName",
                                        value: function(e, t, n) {
                                            return (t = n ? Object.assign({}, this.getDefaultDiplay(), t) : t || this.getDefaultDiplay())[e] || e;
                                        }
                                    },
                                    {
                                        key: "getUpdatedInput",
                                        value: function(e, t, n, o) {
                                            var i = this.getOptions(), r = t;
                                            return ("{bksp}" === e || "{backspace}" === e) && r.length > 0 ? r = this.removeAt(r, n, o) : "{space}" === e ? r = this.addStringAt(r, " ", n, o) : "{tab}" !== e || "boolean" === typeof i.tabCharOnTab && !1 === i.tabCharOnTab ? "{enter}" !== e && "{numpadenter}" !== e || !i.newLineOnEnter ? e.includes("numpad") && Number.isInteger(Number(e[e.length - 2])) ? r = this.addStringAt(r, e[e.length - 2], n, o) : "{numpaddivide}" === e ? r = this.addStringAt(r, "/", n, o) : "{numpadmultiply}" === e ? r = this.addStringAt(r, "*", n, o) : "{numpadsubtract}" === e ? r = this.addStringAt(r, "-", n, o) : "{numpadadd}" === e ? r = this.addStringAt(r, "+", n, o) : "{numpaddecimal}" === e ? r = this.addStringAt(r, ".", n, o) : "{" === e || "}" === e ? r = this.addStringAt(r, e, n, o) : e.includes("{") || e.includes("}") || (r = this.addStringAt(r, e, n, o)) : r = this.addStringAt(r, "\n", n, o) : r = this.addStringAt(r, "	", n, o), r;
                                        }
                                    },
                                    {
                                        key: "updateCaretPos",
                                        value: function(e, t) {
                                            var n = this.updateCaretPosAction(e, t);
                                            this.dispatch(function(e) {
                                                e.caretPosition = n;
                                            });
                                        }
                                    },
                                    {
                                        key: "updateCaretPosAction",
                                        value: function(e, t) {
                                            var n = this.getOptions(), o = this.getCaretPosition();
                                            return t ? o > 0 && (o -= e) : o += e, n.debug && console.log("Caret at:", o, "(".concat(this.keyboardDOMClass, ")")), o;
                                        }
                                    },
                                    {
                                        key: "addStringAt",
                                        value: function(e, t, n, o) {
                                            var i;
                                            return n || 0 === n ? (i = [
                                                e.slice(0, n),
                                                t,
                                                e.slice(n)
                                            ].join(""), this.isMaxLengthReached() || o && this.updateCaretPos(t.length)) : i = e + t, i;
                                        }
                                    },
                                    {
                                        key: "removeAt",
                                        value: function(e, t, n) {
                                            var o;
                                            if (0 === this.getCaretPosition()) return e;
                                            var i = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
                                            return t && t >= 0 ? e.substring(t - 2, t).match(i) ? (o = e.substr(0, t - 2) + e.substr(t), n && this.updateCaretPos(2, !0)) : (o = e.substr(0, t - 1) + e.substr(t), n && this.updateCaretPos(1, !0)) : e.slice(-2).match(i) ? (o = e.slice(0, -2), n && this.updateCaretPos(2, !0)) : (o = e.slice(0, -1), n && this.updateCaretPos(1, !0)), o;
                                        }
                                    },
                                    {
                                        key: "handleMaxLength",
                                        value: function(e, t) {
                                            var n = this.getOptions(), o = n.maxLength, i = e[n.inputName], r = t.length - 1 >= o;
                                            if (t.length <= i.length) return !1;
                                            if (Number.isInteger(o)) return n.debug && console.log("maxLength (num) reached:", r), r ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                                            if ("object" === _typeof(o)) {
                                                var s = i.length === o[n.inputName];
                                                return n.debug && console.log("maxLength (obj) reached:", s), s ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                                            }
                                        }
                                    },
                                    {
                                        key: "isMaxLengthReached",
                                        value: function() {
                                            return Boolean(this.maxLengthReached);
                                        }
                                    },
                                    {
                                        key: "isTouchDevice",
                                        value: function() {
                                            return "ontouchstart" in window || navigator.maxTouchPoints;
                                        }
                                    },
                                    {
                                        key: "pointerEventsSupported",
                                        value: function() {
                                            return window.PointerEvent;
                                        }
                                    },
                                    {
                                        key: "camelCase",
                                        value: function(e) {
                                            return !!e && e.toLowerCase().trim().split(/[.\-_\s]/g).reduce(function(e, t) {
                                                return t.length ? e + t[0].toUpperCase() + t.slice(1) : e;
                                            });
                                        }
                                    }
                                ], _defineProperties(e.prototype, t), n && _defineProperties(e, n), Utilities;
                            }();
                            function PhysicalKeyboard_defineProperties(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var o = t[n];
                                    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                                }
                            }
                            var i = function() {
                                function PhysicalKeyboard(e) {
                                    var t = e.dispatch, n = e.getOptions;
                                    !function(e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    }(this, PhysicalKeyboard), this.dispatch = t, this.getOptions = n, o.bindMethods(PhysicalKeyboard, this);
                                }
                                var e, t;
                                return e = PhysicalKeyboard, t = [
                                    {
                                        key: "handleHighlightKeyDown",
                                        value: function(e) {
                                            var t = this.getOptions(), n = this.getSimpleKeyboardLayoutKey(e);
                                            this.dispatch(function(e) {
                                                var o = e.getButtonElement(n) || e.getButtonElement("{".concat(n, "}"));
                                                o && (o.style.backgroundColor = t.physicalKeyboardHighlightBgColor || "#9ab4d0", o.style.color = t.physicalKeyboardHighlightTextColor || "white");
                                            });
                                        }
                                    },
                                    {
                                        key: "handleHighlightKeyUp",
                                        value: function(e) {
                                            var t = this.getSimpleKeyboardLayoutKey(e);
                                            this.dispatch(function(e) {
                                                var n = e.getButtonElement(t) || e.getButtonElement("{".concat(t, "}"));
                                                n && n.removeAttribute && n.removeAttribute("style");
                                            });
                                        }
                                    },
                                    {
                                        key: "getSimpleKeyboardLayoutKey",
                                        value: function(e) {
                                            var t;
                                            return ((t = e.code.includes("Numpad") || e.code.includes("Shift") || e.code.includes("Space") || e.code.includes("Backspace") || e.code.includes("Control") || e.code.includes("Alt") || e.code.includes("Meta") ? e.code : e.key) !== t.toUpperCase() || "F" === e.code[0] && Number.isInteger(Number(e.code[1])) && e.code.length <= 3) && (t = t.toLowerCase()), t;
                                        }
                                    }
                                ], PhysicalKeyboard_defineProperties(e.prototype, t), PhysicalKeyboard;
                            }();
                            function _toConsumableArray(e) {
                                return function(e) {
                                    if (Array.isArray(e)) return Keyboard_arrayLikeToArray(e);
                                }(e) || function(e) {
                                    if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
                                }(e) || function(e, t) {
                                    if (e) {
                                        if ("string" === typeof e) return Keyboard_arrayLikeToArray(e, t);
                                        var n = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Keyboard_arrayLikeToArray(e, t) : void 0;
                                    }
                                }(e) || function() {
                                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }();
                            }
                            function Keyboard_arrayLikeToArray(e, t) {
                                (null == t || t > e.length) && (t = e.length);
                                for(var n = 0, o = new Array(t); n < t; n++)o[n] = e[n];
                                return o;
                            }
                            function Keyboard_classCallCheck(e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }
                            function Keyboard_defineProperties(e, t) {
                                for(var n = 0; n < t.length; n++){
                                    var o = t[n];
                                    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                                }
                            }
                            function _defineProperty(e, t, n) {
                                return t in e ? Object.defineProperty(e, t, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e[t] = n, e;
                            }
                            var r = function() {
                                function SimpleKeyboard() {
                                    var e = this;
                                    Keyboard_classCallCheck(this, SimpleKeyboard), _defineProperty(this, "handleParams", function(e) {
                                        var t, n, o;
                                        if ("string" === typeof e[0]) t = e[0].split(".").join(""), n = document.querySelector(".".concat(t)), o = e[1];
                                        else if (e[0] instanceof HTMLDivElement) {
                                            if (!e[0].className) throw console.warn("Any DOM element passed as parameter must have a class."), new Error("KEYBOARD_DOM_CLASS_ERROR");
                                            t = e[0].className.split(" ")[0], n = e[0], o = e[1];
                                        } else t = "simple-keyboard", n = document.querySelector(".".concat(t)), o = e[0];
                                        return {
                                            keyboardDOMClass: t,
                                            keyboardDOM: n,
                                            options: o
                                        };
                                    }), _defineProperty(this, "getOptions", function() {
                                        return e.options;
                                    }), _defineProperty(this, "getCaretPosition", function() {
                                        return e.caretPosition;
                                    }), _defineProperty(this, "registerModule", function(t, n) {
                                        e.modules[t] || (e.modules[t] = {}), n(e.modules[t]);
                                    }), _defineProperty(this, "getKeyboardClassString", function() {
                                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                                        var i = [
                                            e.keyboardDOMClass
                                        ].concat(n).filter(function(e) {
                                            return !!e;
                                        });
                                        return i.join(" ");
                                    });
                                    for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                                    var s = this.handleParams(n), a = s.keyboardDOMClass, u = s.keyboardDOM, c = s.options, l = void 0 === c ? {} : c;
                                    if (this.utilities = new o({
                                        getOptions: this.getOptions,
                                        getCaretPosition: this.getCaretPosition,
                                        dispatch: this.dispatch
                                    }), this.caretPosition = null, this.keyboardDOM = u, this.options = l, this.options.layoutName = this.options.layoutName || "default", this.options.theme = this.options.theme || "hg-theme-default", this.options.inputName = this.options.inputName || "default", this.options.preventMouseDownDefault = this.options.preventMouseDownDefault || !1, this.keyboardPluginClasses = "", o.bindMethods(SimpleKeyboard, this), this.input = {}, this.input[this.options.inputName] = "", this.keyboardDOMClass = a, this.buttonElements = {}, window.SimpleKeyboardInstances || (window.SimpleKeyboardInstances = {}), this.currentInstanceName = this.utilities.camelCase(this.keyboardDOMClass), window.SimpleKeyboardInstances[this.currentInstanceName] = this, this.allKeyboardInstances = window.SimpleKeyboardInstances, this.keyboardInstanceNames = Object.keys(window.SimpleKeyboardInstances), this.isFirstKeyboardInstance = this.keyboardInstanceNames[0] === this.currentInstanceName, this.physicalKeyboard = new i({
                                        dispatch: this.dispatch,
                                        getOptions: this.getOptions
                                    }), !this.keyboardDOM) throw console.warn('".'.concat(a, '" was not found in the DOM.')), new Error("KEYBOARD_DOM_ERROR");
                                    this.render(), this.modules = {}, this.loadModules();
                                }
                                var e, t;
                                return e = SimpleKeyboard, t = [
                                    {
                                        key: "handleButtonClicked",
                                        value: function(e) {
                                            var t = this.options.debug;
                                            if ("{//}" === e) return !1;
                                            "function" === typeof this.options.onKeyPress && this.options.onKeyPress(e), this.input[this.options.inputName] || (this.input[this.options.inputName] = "");
                                            var n = this.utilities.getUpdatedInput(e, this.input[this.options.inputName], this.caretPosition);
                                            if (this.input[this.options.inputName] !== n && (!this.options.inputPattern || this.options.inputPattern && this.inputPatternIsValid(n))) {
                                                if (this.options.maxLength && this.utilities.handleMaxLength(this.input, n)) return !1;
                                                this.input[this.options.inputName] = this.utilities.getUpdatedInput(e, this.input[this.options.inputName], this.caretPosition, !0), t && console.log("Input changed:", this.input), this.options.syncInstanceInputs && this.syncInstanceInputs(), "function" === typeof this.options.onChange && this.options.onChange(this.input[this.options.inputName]), "function" === typeof this.options.onChangeAll && this.options.onChangeAll(this.input);
                                            }
                                            t && console.log("Key pressed:", e);
                                        }
                                    },
                                    {
                                        key: "handleButtonMouseDown",
                                        value: function(e, t) {
                                            var n = this;
                                            this.options.preventMouseDownDefault && t.preventDefault(), this.options.stopMouseDownPropagation && t.stopPropagation(), t && t.target.classList.add(this.activeButtonClass), this.isMouseHold = !0, this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdTimeout && clearTimeout(this.holdTimeout), this.options.disableButtonHold || (this.holdTimeout = setTimeout(function() {
                                                (n.isMouseHold && (!e.includes("{") && !e.includes("}") || "{delete}" === e || "{backspace}" === e || "{bksp}" === e || "{space}" === e || "{tab}" === e) || "{arrowright}" === e || "{arrowleft}" === e || "{arrowup}" === e || "{arrowdown}" === e) && (n.options.debug && console.log("Button held:", e), n.handleButtonHold(e, t)), clearTimeout(n.holdTimeout);
                                            }, 500));
                                        }
                                    },
                                    {
                                        key: "handleButtonMouseUp",
                                        value: function(e) {
                                            var t = this;
                                            this.recurseButtons(function(e) {
                                                e.classList.remove(t.activeButtonClass);
                                            }), this.isMouseHold = !1, this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), e && "function" === typeof this.options.onKeyReleased && this.options.onKeyReleased(e);
                                        }
                                    },
                                    {
                                        key: "handleKeyboardContainerMouseDown",
                                        value: function(e) {
                                            this.options.preventMouseDownDefault && e.preventDefault();
                                        }
                                    },
                                    {
                                        key: "handleButtonHold",
                                        value: function(e) {
                                            var t = this;
                                            this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdInteractionTimeout = setTimeout(function() {
                                                t.isMouseHold ? (t.handleButtonClicked(e), t.handleButtonHold(e)) : clearTimeout(t.holdInteractionTimeout);
                                            }, 100);
                                        }
                                    },
                                    {
                                        key: "syncInstanceInputs",
                                        value: function() {
                                            var e = this;
                                            this.dispatch(function(t) {
                                                t.replaceInput(e.input), t.caretPosition = e.caretPosition;
                                            });
                                        }
                                    },
                                    {
                                        key: "clearInput",
                                        value: function(e) {
                                            e = e || this.options.inputName, this.input[e] = "", this.caretPosition = 0, this.options.syncInstanceInputs && this.syncInstanceInputs();
                                        }
                                    },
                                    {
                                        key: "getInput",
                                        value: function(e) {
                                            return e = e || this.options.inputName, this.options.syncInstanceInputs && this.syncInstanceInputs(), this.input[e];
                                        }
                                    },
                                    {
                                        key: "setInput",
                                        value: function(e, t) {
                                            t = t || this.options.inputName, this.input[t] = e, this.options.syncInstanceInputs && this.syncInstanceInputs();
                                        }
                                    },
                                    {
                                        key: "replaceInput",
                                        value: function(e) {
                                            this.input = e;
                                        }
                                    },
                                    {
                                        key: "setOptions",
                                        value: function() {
                                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.changedOptions(e);
                                            this.options = Object.assign(this.options, e), t.length && (this.options.debug && console.log("changedOptions", t), this.onSetOptions(e), this.render());
                                        }
                                    },
                                    {
                                        key: "changedOptions",
                                        value: function(e) {
                                            var t = this;
                                            return Object.keys(e).filter(function(n) {
                                                return JSON.stringify(e[n]) !== JSON.stringify(t.options[n]);
                                            });
                                        }
                                    },
                                    {
                                        key: "onSetOptions",
                                        value: function(e) {
                                            e.inputName && (this.options.debug && console.log("inputName changed. caretPosition reset."), this.caretPosition = null);
                                        }
                                    },
                                    {
                                        key: "clear",
                                        value: function() {
                                            this.keyboardDOM.innerHTML = "", this.keyboardDOM.className = this.keyboardDOMClass, this.buttonElements = {};
                                        }
                                    },
                                    {
                                        key: "dispatch",
                                        value: function(e) {
                                            if (!window.SimpleKeyboardInstances) throw console.warn("SimpleKeyboardInstances is not defined. Dispatch cannot be called."), new Error("INSTANCES_VAR_ERROR");
                                            return Object.keys(window.SimpleKeyboardInstances).forEach(function(t) {
                                                e(window.SimpleKeyboardInstances[t], t);
                                            });
                                        }
                                    },
                                    {
                                        key: "addButtonTheme",
                                        value: function(e, t) {
                                            var n = this;
                                            if (!t || !e) return !1;
                                            e.split(" ").forEach(function(o) {
                                                t.split(" ").forEach(function(t) {
                                                    n.options.buttonTheme || (n.options.buttonTheme = []);
                                                    var i = !1;
                                                    n.options.buttonTheme.map(function(e) {
                                                        if (e.class.split(" ").includes(t)) {
                                                            i = !0;
                                                            var n = e.buttons.split(" ");
                                                            n.includes(o) || (i = !0, n.push(o), e.buttons = n.join(" "));
                                                        }
                                                        return e;
                                                    }), i || n.options.buttonTheme.push({
                                                        class: t,
                                                        buttons: e
                                                    });
                                                });
                                            }), this.render();
                                        }
                                    },
                                    {
                                        key: "removeButtonTheme",
                                        value: function(e, t) {
                                            var n = this;
                                            if (!e && !t) return this.options.buttonTheme = [], this.render(), !1;
                                            e && Array.isArray(this.options.buttonTheme) && this.options.buttonTheme.length && (e.split(" ").forEach(function(e) {
                                                n.options.buttonTheme.map(function(o, i) {
                                                    if (t && t.includes(o.class) || !t) {
                                                        var r = o.buttons.split(" ").filter(function(t) {
                                                            return t !== e;
                                                        });
                                                        r.length ? o.buttons = r.join(" ") : (n.options.buttonTheme.splice(i, 1), o = null);
                                                    }
                                                    return o;
                                                });
                                            }), this.render());
                                        }
                                    },
                                    {
                                        key: "getButtonElement",
                                        value: function(e) {
                                            var t, n = this.buttonElements[e];
                                            return n && (t = n.length > 1 ? n : n[0]), t;
                                        }
                                    },
                                    {
                                        key: "inputPatternIsValid",
                                        value: function(e) {
                                            var t, n = this.options.inputPattern;
                                            if ((t = n instanceof RegExp ? n : n[this.options.inputName]) && e) {
                                                var o = t.test(e);
                                                return this.options.debug && console.log('inputPattern ("'.concat(t, '"): ').concat(o ? "passed" : "did not pass!")), o;
                                            }
                                            return !0;
                                        }
                                    },
                                    {
                                        key: "setEventListeners",
                                        value: function() {
                                            !this.isFirstKeyboardInstance && this.allKeyboardInstances || (this.options.debug && console.log("Caret handling started (".concat(this.keyboardDOMClass, ")")), document.addEventListener("keyup", this.handleKeyUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("touchend", this.handleTouchEnd));
                                        }
                                    },
                                    {
                                        key: "handleKeyUp",
                                        value: function(e) {
                                            this.caretEventHandler(e), this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyUp(e);
                                        }
                                    },
                                    {
                                        key: "handleKeyDown",
                                        value: function(e) {
                                            this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyDown(e);
                                        }
                                    },
                                    {
                                        key: "handleMouseUp",
                                        value: function(e) {
                                            this.caretEventHandler(e);
                                        }
                                    },
                                    {
                                        key: "handleTouchEnd",
                                        value: function(e) {
                                            this.caretEventHandler(e);
                                        }
                                    },
                                    {
                                        key: "caretEventHandler",
                                        value: function(e) {
                                            var t;
                                            e.target.tagName && (t = e.target.tagName.toLowerCase()), this.dispatch(function(n) {
                                                n.isMouseHold && (n.isMouseHold = !1), "textarea" !== t && "input" !== t || n.options.disableCaretPositioning ? n.options.disableCaretPositioning && (n.caretPosition = null) : (n.caretPosition = e.target.selectionStart, n.options.debug && console.log("Caret at: ", e.target.selectionStart, e.target.tagName.toLowerCase(), "(".concat(n.keyboardDOMClass, ")")));
                                            });
                                        }
                                    },
                                    {
                                        key: "recurseButtons",
                                        value: function(e) {
                                            var t = this;
                                            if (!e) return !1;
                                            Object.keys(this.buttonElements).forEach(function(n) {
                                                return t.buttonElements[n].forEach(e);
                                            });
                                        }
                                    },
                                    {
                                        key: "destroy",
                                        value: function() {
                                            this.options.debug && console.log("Destroying simple-keyboard instance: ".concat(this.currentInstanceName)), document.removeEventListener("keyup", this.handleKeyUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("touchend", this.handleTouchEnd), document.onpointerup = null, document.ontouchend = null, document.ontouchcancel = null, document.onmouseup = null;
                                            var deleteButton = function(e) {
                                                e.onpointerdown = null, e.onpointerup = null, e.onpointercancel = null, e.ontouchstart = null, e.ontouchend = null, e.ontouchcancel = null, e.onclick = null, e.onmousedown = null, e.onmouseup = null, e.remove(), e = null;
                                            };
                                            this.recurseButtons(deleteButton), this.recurseButtons = null, deleteButton = null, this.keyboardDOM.onpointerdown = null, this.keyboardDOM.ontouchstart = null, this.keyboardDOM.onmousedown = null, this.clear(), window.SimpleKeyboardInstances[this.currentInstanceName] = null, delete window.SimpleKeyboardInstances[this.currentInstanceName], this.initialized = !1;
                                        }
                                    },
                                    {
                                        key: "getButtonThemeClasses",
                                        value: function(e) {
                                            var t = this.options.buttonTheme, n = [];
                                            return Array.isArray(t) && t.forEach(function(t) {
                                                if (t.class && "string" === typeof t.class && t.buttons && "string" === typeof t.buttons) {
                                                    var o = t.class.split(" ");
                                                    t.buttons.split(" ").includes(e) && (n = [].concat(_toConsumableArray(n), _toConsumableArray(o)));
                                                } else console.warn('Incorrect "buttonTheme". Please check the documentation.', t);
                                            }), n;
                                        }
                                    },
                                    {
                                        key: "setDOMButtonAttributes",
                                        value: function(e, t) {
                                            var n = this.options.buttonAttributes;
                                            Array.isArray(n) && n.forEach(function(n) {
                                                n.attribute && "string" === typeof n.attribute && n.value && "string" === typeof n.value && n.buttons && "string" === typeof n.buttons ? n.buttons.split(" ").includes(e) && t(n.attribute, n.value) : console.warn('Incorrect "buttonAttributes". Please check the documentation.', n);
                                            });
                                        }
                                    },
                                    {
                                        key: "onTouchDeviceDetected",
                                        value: function() {
                                            this.processAutoTouchEvents(), this.disableContextualWindow();
                                        }
                                    },
                                    {
                                        key: "disableContextualWindow",
                                        value: function() {
                                            window.oncontextmenu = function(e) {
                                                if (e.target.classList.contains("hg-button")) return e.preventDefault(), e.stopPropagation(), !1;
                                            };
                                        }
                                    },
                                    {
                                        key: "processAutoTouchEvents",
                                        value: function() {
                                            this.options.autoUseTouchEvents && (this.options.useTouchEvents = !0, this.options.debug && console.log("autoUseTouchEvents: Touch device detected, useTouchEvents enabled."));
                                        }
                                    },
                                    {
                                        key: "onInit",
                                        value: function() {
                                            this.options.debug && console.log("".concat(this.keyboardDOMClass, " Initialized")), this.setEventListeners(), "function" === typeof this.options.onInit && this.options.onInit();
                                        }
                                    },
                                    {
                                        key: "beforeFirstRender",
                                        value: function() {
                                            this.utilities.isTouchDevice() && this.onTouchDeviceDetected(), "function" === typeof this.options.beforeFirstRender && this.options.beforeFirstRender(), this.isFirstKeyboardInstance && this.utilities.pointerEventsSupported() && !this.options.useTouchEvents && !this.options.useMouseEvents && this.options.debug && console.log("Using PointerEvents as it is supported by this browser"), this.options.useTouchEvents && this.options.debug && console.log("useTouchEvents has been enabled. Only touch events will be used.");
                                        }
                                    },
                                    {
                                        key: "beforeRender",
                                        value: function() {
                                            "function" === typeof this.options.beforeRender && this.options.beforeRender();
                                        }
                                    },
                                    {
                                        key: "onRender",
                                        value: function() {
                                            "function" === typeof this.options.onRender && this.options.onRender();
                                        }
                                    },
                                    {
                                        key: "onModulesLoaded",
                                        value: function() {
                                            "function" === typeof this.options.onModulesLoaded && this.options.onModulesLoaded();
                                        }
                                    },
                                    {
                                        key: "loadModules",
                                        value: function() {
                                            var e = this;
                                            Array.isArray(this.options.modules) && (this.options.modules.forEach(function(t) {
                                                var n = new t;
                                                if (n.constructor.name && "Function" !== n.constructor.name) {
                                                    var o = "module-".concat(e.utilities.camelCase(n.constructor.name));
                                                    e.keyboardPluginClasses = e.keyboardPluginClasses + " ".concat(o);
                                                }
                                                n.init(e);
                                            }), this.keyboardPluginClasses = this.keyboardPluginClasses + " modules-loaded", this.render(), this.onModulesLoaded());
                                        }
                                    },
                                    {
                                        key: "getModuleProp",
                                        value: function(e, t) {
                                            return !!this.modules[e] && this.modules[e][t];
                                        }
                                    },
                                    {
                                        key: "getModulesList",
                                        value: function() {
                                            return Object.keys(this.modules);
                                        }
                                    },
                                    {
                                        key: "parseRowDOMContainers",
                                        value: function(e, t, n, o) {
                                            var i = this, r = Array.from(e.children), s = 0;
                                            return r.length && n.forEach(function(n, a) {
                                                var u = o[a];
                                                if (!u || !(u > n)) return !1;
                                                var c = n - s, l = u - s, d = document.createElement("div");
                                                d.className += "hg-button-container";
                                                var p = "".concat(i.options.layoutName, "-r").concat(t, "c").concat(a);
                                                d.setAttribute("data-skUID", p);
                                                var h = r.splice(c, l - c + 1);
                                                s = l - c, h.forEach(function(e) {
                                                    return d.appendChild(e);
                                                }), r.splice(c, 0, d), e.innerHTML = "", r.forEach(function(t) {
                                                    return e.appendChild(t);
                                                }), i.options.debug && console.log("rowDOMContainer", h, c, l, s + 1);
                                            }), e;
                                        }
                                    },
                                    {
                                        key: "render",
                                        value: function() {
                                            var e = this;
                                            this.clear(), this.initialized || this.beforeFirstRender(), this.beforeRender();
                                            var t = "hg-layout-".concat(this.options.layoutName), n = this.options.layout || {
                                                default: [
                                                    "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                                                    "{tab} q w e r t y u i o p [ ] \\",
                                                    "{lock} a s d f g h j k l ; ' {enter}",
                                                    "{shift} z x c v b n m , . / {shift}",
                                                    ".com @ {space}"
                                                ],
                                                shift: [
                                                    "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
                                                    "{tab} Q W E R T Y U I O P { } |",
                                                    '{lock} A S D F G H J K L : " {enter}',
                                                    "{shift} Z X C V B N M < > ? {shift}",
                                                    ".com @ {space}"
                                                ]
                                            }, o = this.options.useTouchEvents || !1, i = o ? "hg-touch-events" : "", r = this.options.useMouseEvents || !1, s = this.options.disableRowButtonContainers;
                                            this.keyboardDOM.className = this.getKeyboardClassString(this.options.theme, t, this.keyboardPluginClasses, i), n[this.options.layoutName].forEach(function(t, n) {
                                                var i = t.split(" "), a = document.createElement("div");
                                                a.className += "hg-row";
                                                var u = [], c = [];
                                                i.forEach(function(t, i) {
                                                    var l, d = !s && "string" === typeof t && t.length > 1 && 0 === t.indexOf("["), p = !s && "string" === typeof t && t.length > 1 && t.indexOf("]") === t.length - 1;
                                                    d && (u.push(i), t = t.replace(/\[/g, "")), p && (c.push(i), t = t.replace(/\]/g, ""));
                                                    var h = e.utilities.getButtonClass(t), f = e.utilities.getButtonDisplayName(t, e.options.display, e.options.mergeDisplay), y = e.options.useButtonTag ? "button" : "div", b = document.createElement(y);
                                                    b.className += "hg-button ".concat(h), (l = b.classList).add.apply(l, _toConsumableArray(e.getButtonThemeClasses(t))), e.setDOMButtonAttributes(t, function(e, t) {
                                                        b.setAttribute(e, t);
                                                    }), e.activeButtonClass = "hg-activeButton", !e.utilities.pointerEventsSupported() || o || r ? o ? (b.ontouchstart = function(n) {
                                                        e.handleButtonClicked(t), e.handleButtonMouseDown(t, n);
                                                    }, b.ontouchend = function() {
                                                        e.handleButtonMouseUp(t);
                                                    }, b.ontouchcancel = function() {
                                                        e.handleButtonMouseUp(t);
                                                    }) : (b.onclick = function() {
                                                        e.isMouseHold = !1, e.handleButtonClicked(t);
                                                    }, b.onmousedown = function(n) {
                                                        e.handleButtonMouseDown(t, n);
                                                    }, b.onmouseup = function() {
                                                        e.handleButtonMouseUp(t);
                                                    }) : (b.onpointerdown = function(n) {
                                                        e.handleButtonClicked(t), e.handleButtonMouseDown(t, n);
                                                    }, b.onpointerup = function() {
                                                        e.handleButtonMouseUp(t);
                                                    }, b.onpointercancel = function() {
                                                        e.handleButtonMouseUp(t);
                                                    }), b.setAttribute("data-skBtn", t);
                                                    var m = "".concat(e.options.layoutName, "-r").concat(n, "b").concat(i);
                                                    b.setAttribute("data-skBtnUID", m);
                                                    var g = document.createElement("span");
                                                    g.innerHTML = f, b.appendChild(g), e.buttonElements[t] || (e.buttonElements[t] = []), e.buttonElements[t].push(b), a.appendChild(b);
                                                }), a = e.parseRowDOMContainers(a, n, u, c), e.keyboardDOM.appendChild(a);
                                            }), this.onRender(), this.initialized || (this.initialized = !0, !this.utilities.pointerEventsSupported() || o || r ? o ? (document.ontouchend = function() {
                                                return e.handleButtonMouseUp();
                                            }, document.ontouchcancel = function() {
                                                return e.handleButtonMouseUp();
                                            }, this.keyboardDOM.ontouchstart = function(t) {
                                                return e.handleKeyboardContainerMouseDown(t);
                                            }) : o || (document.onmouseup = function() {
                                                return e.handleButtonMouseUp();
                                            }, this.keyboardDOM.onmousedown = function(t) {
                                                return e.handleKeyboardContainerMouseDown(t);
                                            }) : (document.onpointerup = function() {
                                                return e.handleButtonMouseUp();
                                            }, this.keyboardDOM.onpointerdown = function(t) {
                                                return e.handleKeyboardContainerMouseDown(t);
                                            }), this.onInit());
                                        }
                                    }
                                ], Keyboard_defineProperties(e.prototype, t), SimpleKeyboard;
                            }();
                            t.default = r;
                        }
                    ]);
                }, "object" === a(t) && "object" === a(e) ? e.exports = s() : (i = [], void 0 === (r = "function" === typeof (o = s) ? o.apply(t, i) : o) || (e.exports = r));
            }).call(this, n(3)(e));
        },
        function(e, t, n) {
            e.exports = n(6);
        },
        function(e, t) {
            e.exports = function(e) {
                return e.webpackPolyfill || (e.deprecate = function() {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
                    enumerable: !0,
                    get: function() {
                        return e.l;
                    }
                }), Object.defineProperty(e, "id", {
                    enumerable: !0,
                    get: function() {
                        return e.i;
                    }
                }), e.webpackPolyfill = 1), e;
            };
        },
        function(e, t) {
            function _typeof(t) {
                return "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? e.exports = _typeof = function(e) {
                    return typeof e;
                } : e.exports = _typeof = function(e) {
                    return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, _typeof(t);
            }
            e.exports = _typeof;
        },
        function(e, t, n) {},
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o = n(0), i = n.n(o), r = n(1), s = n.n(r);
            function ownKeys(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t && (o = o.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), n.push.apply(n, o);
                }
                return n;
            }
            function _objectSpread(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? ownKeys(Object(n), !0).forEach(function(t) {
                        _defineProperty(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                }
                return e;
            }
            function _defineProperty(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            var cleanProps = function(e) {
                return _objectSpread(_objectSpread({}, e), {}, {
                    keyboardRef: null,
                    stateToIgnore: null
                });
            }, a = (n(5), function(e) {
                var t = e.baseClass || "react-simple-keyboard", n = Object(o.useRef)(), r = Object(o.useRef)(), a = Object(o.useRef)(e);
                return Object(o.useEffect)(function() {
                    var o = function(e) {
                        return _objectSpread(_objectSpread({}, e), {}, {
                            theme: "simple-keyboard ".concat(e.theme || "hg-theme-default")
                        });
                    }(e);
                    n.current || (n.current = !0, o.debug && console.log("ReactSimpleKeyboard: Init"), r.current = new s.a(".".concat(t), o), o.keyboardRef && o.keyboardRef(r.current));
                    var i = function(e, t) {
                        var n = cleanProps(t), o = cleanProps(e);
                        return Object.keys(n).filter(function(e) {
                            return n[e] !== o[e];
                        });
                    }(a.current, o);
                    if (i.length) {
                        var u = r.current;
                        a.current = o, u.setOptions(o), o.debug && console.log("ReactSimpleKeyboard - setOptions called due to updated props:", i);
                    }
                }, [
                    n,
                    t,
                    a,
                    e
                ]), i.a.createElement("div", {
                    className: t
                });
            });
            t.default = a;
        }
    ]);
});




const $4371095fe1dd0c2e$var$VirtualKeyboard = ({ onKeyPress: onKeyPress })=>{
    const keyboardRef = (0, $gIfym.useRef)(null);
    const [layout, setLayout] = (0, $gIfym.useState)("default");
    const handleKeyPress = (key)=>{
        if (key === "{numbers}") setLayout("numbers");
        else if (key === "{abc}") setLayout("default");
        else onKeyPress(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "VirtualKeyboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2aa232ed3f791922$exports))), {
        layoutName: layout,
        layout: {
            default: [
                "Q W E R T Y U I O P",
                "A S D F G H J K L",
                "Z X C V B N M {backspace}",
                "{numbers} {space} {ent}"
            ],
            numbers: [
                "1 2 3",
                "4 5 6",
                "7 8 9",
                "{abc} 0 {backspace}"
            ]
        },
        display: {
            "{numbers}": "123",
            "{ent}": "return",
            "{escape}": "esc \u238B",
            "{tab}": "tab \u21E5",
            "{backspace}": "\u232B",
            "{capslock}": "caps lock \u21EA",
            "{shift}": "\u21E7",
            "{controlleft}": "ctrl \u2303",
            "{controlright}": "ctrl \u2303",
            "{altleft}": "alt \u2325",
            "{altright}": "alt \u2325",
            "{metaleft}": "cmd \u2318",
            "{metaright}": "cmd \u2318",
            "{abc}": "ABC",
            "{space}": " "
        },
        onKeyPress: handleKeyPress,
        keyboardRef: (r)=>keyboardRef.current = r
    }));
};
$4371095fe1dd0c2e$var$VirtualKeyboard.propTypes = {
    onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func
};
var $4371095fe1dd0c2e$export$2e2bcd8739ae039 = $4371095fe1dd0c2e$var$VirtualKeyboard;



var $gIfym = parcelRequire("gIfym");

const $a5510e1e28f34fe9$var$Box = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
    position: absolute;
    right: 0;
    bottom: 0;
    height: 90%;
    margin-bottom: 2px;
    width: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const $a5510e1e28f34fe9$var$Circle = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
    background-color: ${(props)=>props.color || "red"};
    border-radius: 100%;
    width: 30px;
    height: 30px;
    cursor: pointer;
`;
const $a5510e1e28f34fe9$var$MobilePingButton = ({ onClick: onClick, color: color })=>{
    const handleClick = (e)=>{
        e.stopPropagation();
        onClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($a5510e1e28f34fe9$var$Box, {
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($a5510e1e28f34fe9$var$Circle, {
        color: color
    }));
};
var $a5510e1e28f34fe9$export$2e2bcd8739ae039 = $a5510e1e28f34fe9$var$MobilePingButton;



const $ab94c19ccb4acf4d$var$VALID_KEYS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const $ab94c19ccb4acf4d$var$LONGPRESS_DELAY = 600;
class $ab94c19ccb4acf4d$export$c9960d29085ddc76 extends (0, $gIfym.Component) {
    static propTypes = {
        across: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        down: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
        board: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        solution: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
        showClues: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        showCheck: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool,
        onViewStats: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        updateLetter: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).func,
        users: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string,
            row: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number,
            col: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).number
        }),
        me: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).string
        }),
        settings: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
        clues: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).shape({
            down: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object,
            across: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).object
        }),
        isComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c65bfe520546a474$exports))).bool
    };
    static defaultProps = {
        showClues: true,
        showCheck: true,
        settings: {}
    };
    constructor(props){
        super(props);
        const board = Array.from(Array(props.width), ()=>Array(props.height).fill(""));
        this.state = {
            selectedSquare: {},
            board: board,
            checking: props.settings.check,
            direction: "across",
            highlights: [
                ...board
            ],
            clueSquare: {},
            pingKeys: [
                ...board
            ],
            finishedClues: new Set()
        };
        this._isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        this._squares = {};
        this._startTouchTime = 0;
        document.addEventListener("keydown", this.onKeyDown);
    // document.addEventListener('dblclick', this.toggleDirection)
    // document.addEventListener('touchstart', this.touchStart)
    // document.addEventListener('touchend', this.touchEnd)
    }
    componentWillUnmount = ()=>{
        document.removeEventListener("keydown", this.onKeyDown);
        // document.removeEventListener('dblclick', this.toggleDirection)
        // document.removeEventListener('touchstart', this.touchStart)
        // document.removeEventListener('touchend', this.touchEnd)
        if (this._touchInterval) clearInterval(this._touchInterval);
    };
    setInitialPosition = ()=>{
        const filled = this.isFilled(0, 0);
        this.updateSelectedSquare({
            row: 0,
            col: 0
        }, filled);
        if (filled) {
            const nextSquare = this.getNextSquare(true);
            this.updateSelectedSquare(nextSquare);
        }
    };
    touchStart = ()=>{
        this._startTouchTime = Date.now();
        this._touchInterval = setInterval(()=>{
            if (Date.now() - this._startTouchTime >= $ab94c19ccb4acf4d$var$LONGPRESS_DELAY) {
                this.toggleDirection();
                this._startTouchTime = Date.now();
            }
        }, 100);
    };
    touchEnd = ()=>{
        if (this._touchInterval) clearInterval(this._touchInterval);
    };
    onClickClue = ()=>{
        this.toggleDirection();
    };
    toggleDirection = ()=>{
        const { direction: direction } = this.state;
        this.setState({
            direction: direction === "across" ? "down" : "across"
        }, ()=>{
            this.updateHighlights();
        });
    };
    componentDidUpdate = (prevProps, prevState)=>{
        const cluesToCheck = [];
        const { board: board, width: width, height: height } = this.props;
        if (board !== prevProps.board) {
            // const newBoard = Array.from(Array(width), () => Array(height).fill(''))
            const newBoard = [];
            const newPingKeys = [];
            for(let i = 0; i < height; ++i){
                const row = [];
                const pingRow = [];
                for(let j = 0; j < width; ++j){
                    const item = board[i * width + j];
                    if (item === "." || item === "-") row.push("");
                    else {
                        row.push(item);
                        cluesToCheck.push({
                            x: i,
                            y: j
                        });
                    }
                    pingRow.push((0, (/*@__PURE__*/$parcel$interopDefault($ab009d3ca5ea0c28$exports))).generate());
                }
                newBoard.push(row);
                newPingKeys.push(pingRow);
            }
            this.setState({
                board: newBoard,
                pingKeys: newPingKeys
            });
        }
    };
    onVirtualKeyDown = (key)=>{
        const { isComplete: isComplete } = this.props;
        const { updateLetter: updateLetter } = this.props;
        const { selectedSquare: selectedSquare, board: board, clueSquare: clueSquare, direction: direction } = this.state;
        if (isComplete) return;
        if (isNaN(parseInt(selectedSquare.row)) || isNaN(parseInt(selectedSquare.col))) return;
        if (this.isFilled(selectedSquare.row, selectedSquare.col)) return;
        key = key.toUpperCase();
        if (key === "{BACKSPACE}" || key === " " || key === "" || !key) ;
        else if (!$ab94c19ccb4acf4d$var$VALID_KEYS.split("").includes(key)) return;
        const newBoard = {
            ...board
        };
        let text = key;
        if (key === "{BACKSPACE}" || key === " " || !key) text = "";
        newBoard[selectedSquare.row][selectedSquare.col] = text;
        this.setState({
            board: newBoard
        });
        this.updateFinishedClues(clueSquare, direction);
        updateLetter(selectedSquare.row, selectedSquare.col, text);
        const newSquare = key === "{BACKSPACE}" ? this.getPrevSquare() : this.getNextSquare();
        this.updateSelectedSquare(newSquare);
    };
    onKeyDown = (e)=>{
        const { isComplete: isComplete } = this.props;
        const { updateLetter: updateLetter } = this.props;
        const { selectedSquare: selectedSquare, board: board, direction: direction, clueSquare: clueSquare } = this.state;
        if (isComplete) return;
        let key = e.key.toUpperCase();
        if (e.keyCode === 229) return;
        if (isNaN(parseInt(selectedSquare.row)) || isNaN(parseInt(selectedSquare.col))) return;
        if (key === "ARROWUP") {
            e.preventDefault();
            this.moveUp();
            return;
        } else if (key === "ARROWDOWN" || key === "ENTER") {
            e.preventDefault();
            this.moveDown();
            return;
        } else if (key === "ARROWLEFT") {
            e.preventDefault();
            this.moveLeft();
            return;
        } else if (key === "ARROWRIGHT") {
            e.preventDefault();
            this.moveRight();
            return;
        } else if (key === "TAB") {
            e.preventDefault();
            // this.toggleDirection()
            this.moveNext(e.shiftKey);
            return;
        } else if (key === " ") {
            e.preventDefault();
            this.toggleDirection();
            return;
        } else if (key === "BACKSPACE" || key === "") ;
        else if (!$ab94c19ccb4acf4d$var$VALID_KEYS.split("").includes(key)) return;
        e.preventDefault();
        const newBoard = {
            ...board
        };
        let text = key;
        if (key === "BACKSPACE") text = "";
        if (this.isFilled(selectedSquare.row, selectedSquare.col)) return;
        newBoard[selectedSquare.row][selectedSquare.col] = text;
        this.setState({
            board: newBoard
        });
        this.updateFinishedClues(clueSquare, direction);
        updateLetter(selectedSquare.row, selectedSquare.col, text);
        const newSquare = key === "BACKSPACE" ? this.getPrevSquare() : this.getNextSquare();
        this.updateSelectedSquare(newSquare);
    };
    updateFinishedClues = ({ row: row, col: col }, direction)=>{
        var clueKey;
        // todo
        return null;
    };
    onSquareClick(e, rowIdx, colIdx) {
        const { row: row, col: col } = this.state.selectedSquare;
        if (this.isFilled(rowIdx, colIdx)) return;
        // if (this._input) {
        //     this._input.style.top = `${25 * rowIdx}px`
        //     this._input.focus()
        // }
        if (row === rowIdx && col === colIdx) {
            this.toggleDirection();
            return;
        }
        this.updateSelectedSquare({
            row: rowIdx,
            col: colIdx
        });
    }
    isFilled = (x, y)=>{
        const { board: board, width: width } = this.props;
        return board[x * width + y] === ".";
    };
    isSquareComplete = (x, y)=>{
        const { board: board, width: width } = this.props;
        return board[x * width + y] !== " ";
    };
    isLineComplete = (x, y, direction = "across")=>{
        const { height: height, width: width } = this.props;
        if (x < 0 || x >= width) return false;
        if (y < 0 || y >= height) return false;
        let x0 = x;
        let y0 = y;
        let done = this.isFilled(x0, y0);
        if (done) return false;
        if (!this.isSquareComplete(x0, y0)) return false;
        if (direction === "across") {
            // left
            done = false;
            while(!done){
                x0 -= 1;
                if (!this.isSquareComplete(x0, y0)) return false;
                done = x === 0 || this.isFilled(x0, y0);
            }
            x0 = x;
            done = false;
            // right
            while(!done){
                x0 += 1;
                if (!this.isSquareComplete(x0, y0)) return false;
                done = x === width - 1 || this.isFilled(x0, y0);
            }
        } else {
            // up
            x0 = x;
            y0 = y;
            done = false;
            while(!done){
                y0 -= 1;
                if (!this.isSquareComplete(x0, y0)) return false;
                done = y === 0 || this.isFilled(x0, y0);
            }
            done = false;
            y0 = y;
            // down
            while(!done){
                y0 += 1;
                if (!this.isSquareComplete(x0, y0)) return false;
                done = y === height - 1 || this.isFilled(x0, y0);
            }
        }
        return true;
    };
    moveNext = (reverse = false)=>{
        const { clueSquare: clueSquare, direction: direction } = this.state;
        const { down: down, across: across } = this.props;
        const clues = direction === "across" ? across : down;
        let nextClue;
        let curClueKey;
        if (!reverse) Object.keys(clues).forEach((key)=>{
            const clue = clues[key];
            if (curClueKey) {
                nextClue = clue;
                curClueKey = null;
                return;
            }
            if (clue.row === clueSquare.row && clue.col === clueSquare.col) curClueKey = key;
        });
        else {
            const keys = Object.keys(clues);
            for(let i = keys.length - 1; i >= 0; --i){
                const key = keys[i];
                const clue = clues[key];
                if (curClueKey) {
                    nextClue = clue;
                    curClueKey = null;
                    break;
                }
                if (clue.row === clueSquare.row && clue.col === clueSquare.col) curClueKey = key;
            }
        }
        console.log("[moveNext] nextClue", curClueKey, nextClue);
        if (!nextClue) {
            const nextDirection = direction === "across" ? "down" : "across";
            let nextClue;
            if (!reverse) nextClue = Object.values(this.props[nextDirection])[0];
            else {
                const keys = Object.keys(this.props[nextDirection]);
                nextClue = this.props[nextDirection][keys[keys.length - 1]];
            }
            this.updateSelectedSquare({
                row: nextClue.row,
                col: nextClue.col
            });
            this.setState({
                direction: nextDirection
            });
            return;
        }
        this.updateSelectedSquare({
            row: nextClue.row,
            col: nextClue.col
        });
    };
    moveUp = ()=>{
        const { height: height } = this.props;
        const { selectedSquare: selectedSquare, direction: direction } = this.state;
        const newSquare = {
            ...selectedSquare
        };
        if (direction === "across") {
            this.toggleDirection();
            return;
        }
        const goUp = ()=>{
            newSquare.row--;
            if (newSquare.row < 0) newSquare.row = height - 1;
        };
        goUp();
        while(this.isFilled(newSquare.row, newSquare.col))goUp();
        this.updateSelectedSquare(newSquare);
    };
    moveDown = ()=>{
        const { height: height } = this.props;
        const { selectedSquare: selectedSquare, direction: direction } = this.state;
        if (direction === "across") {
            this.toggleDirection();
            return;
        }
        const newSquare = {
            ...selectedSquare
        };
        const goDown = ()=>{
            newSquare.row++;
            if (newSquare.row >= height) newSquare.row = 0;
        };
        goDown();
        while(this.isFilled(newSquare.row, newSquare.col))goDown();
        this.updateSelectedSquare(newSquare);
    };
    moveRight = ()=>{
        const { width: width } = this.props;
        const { selectedSquare: selectedSquare, direction: direction } = this.state;
        if (direction === "down") {
            this.toggleDirection();
            return;
        }
        const newSquare = {
            ...selectedSquare
        };
        const goUp = ()=>{
            newSquare.col++;
            if (newSquare.col >= width) newSquare.col = 0;
        };
        goUp();
        while(this.isFilled(newSquare.row, newSquare.col))goUp();
        this.updateSelectedSquare(newSquare);
    };
    moveLeft = ()=>{
        const { width: width } = this.props;
        const { selectedSquare: selectedSquare, direction: direction } = this.state;
        if (direction === "down") {
            this.toggleDirection();
            return;
        }
        const newSquare = {
            ...selectedSquare
        };
        const goDown = ()=>{
            newSquare.col--;
            if (newSquare.col <= 0) newSquare.col = width - 1;
        };
        goDown();
        while(this.isFilled(newSquare.row, newSquare.col))goDown();
        this.updateSelectedSquare(newSquare);
    };
    getNextSquare = (force = false)=>{
        const { width: width, height: height } = this.props;
        const { selectedSquare: selectedSquare, direction: direction } = this.state;
        const newSquare = {
            ...selectedSquare
        };
        const nextSquare = ()=>{
            if (direction === "across") {
                newSquare.col++;
                if (newSquare.col >= width) {
                    newSquare.col--;
                    if (force) {
                        newSquare.col = 0;
                        newSquare.row++;
                    }
                }
                if (newSquare.row >= height && force) newSquare.row = 0;
            } else {
                newSquare.row++;
                if (newSquare.row >= height) {
                    newSquare.row--;
                    if (force) {
                        newSquare.row = 0;
                        newSquare.col++;
                    }
                }
                if (newSquare.col >= width && force) newSquare.col = 0;
            }
        };
        nextSquare();
        if (force) while(this.isFilled(newSquare.row, newSquare.col))nextSquare();
        else {
            if (this.isFilled(newSquare.row, newSquare.col)) return selectedSquare;
        }
        return newSquare;
    };
    getPrevSquare = ()=>{
        const { width: width, height: height } = this.props;
        const { selectedSquare: selectedSquare, direction: direction } = this.state;
        const newSquare = {
            ...selectedSquare
        };
        const previousSquare = ()=>{
            if (direction === "across") {
                newSquare.col--;
                if (newSquare.col < 0) {
                    newSquare.col = width - 1;
                    newSquare.row--;
                }
                if (newSquare.row < 0) newSquare.row = height - 1;
            } else if (direction === "down") {
                newSquare.row--;
                if (newSquare.row < 0) {
                    newSquare.row = height - 1;
                    newSquare.col--;
                }
                if (newSquare.col < 0) newSquare.col = width - 1;
            }
        };
        previousSquare();
        while(this.isFilled(newSquare.row, newSquare.col))previousSquare();
        return newSquare;
    };
    updateHighlights() {
        const { width: width, height: height } = this.props;
        const { selectedSquare: selectedSquare, direction: direction } = this.state;
        const highlights = {};
        const clueSquare = {
            ...selectedSquare
        };
        if (direction === "across") {
            highlights[selectedSquare.row] = {};
            clueSquare.row = selectedSquare.row;
            let i = selectedSquare.col;
            let done = false;
            while(i >= 0 && !done)if (!this.isFilled(selectedSquare.row, i)) {
                highlights[selectedSquare.row][i] = true;
                clueSquare.col = i;
                i--;
            } else done = true;
            done = false;
            i = selectedSquare.col;
            while(i <= width && !done)if (!this.isFilled(selectedSquare.row, i)) {
                highlights[selectedSquare.row][i] = true;
                i++;
            } else done = true;
        } else if (direction === "down") {
            let i = selectedSquare.row;
            clueSquare.col = selectedSquare.col;
            let done = false;
            while(i >= 0 && !done)if (!this.isFilled(i, selectedSquare.col)) {
                if (!highlights[i]) highlights[i] = {};
                highlights[i][selectedSquare.col] = true;
                clueSquare.row = i;
                i--;
            } else done = true;
            done = false;
            i = selectedSquare.row;
            while(i <= height && !done)if (!this.isFilled(i, selectedSquare.col)) {
                if (!highlights[i]) highlights[i] = {};
                highlights[i][selectedSquare.col] = true;
                i++;
            } else done = true;
        }
        this.setState({
            highlights: highlights,
            clueSquare: clueSquare
        });
    }
    updateSelectedSquare = (newSquare, update = true)=>{
        const { updatePos: updatePos } = this.props;
        const { users: users = {} } = this.state;
        if (update) updatePos(newSquare.row, newSquare.col);
        this.setState({
            users: {
                ...users,
                [-1]: {
                    ...users[-1] || {},
                    ...newSquare
                }
            }
        });
        this.setState({
            selectedSquare: newSquare
        }, ()=>{
            this.updateHighlights();
        // focus
        // const squareRef = this._squares[newSquare.row] && this._squares[newSquare.row][newSquare.col]
        // if (squareRef) {
        //     squareRef.focus()
        // }
        });
    };
    renderRow(row, rowIdx) {
        const { solution: solution, width: width, users: users, emitPing: emitPing, clues: clues } = this.props;
        const { down: down, across: across } = clues;
        const { selectedSquare: selectedSquare, board: board, checking: checking, highlights: highlights, pingKeys: pingKeys } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "Row",
            key: `row=${rowIdx}`
        }, row.map((filled, colIdx)=>{
            const idx = rowIdx * width + colIdx;
            const text = board[rowIdx] && board[rowIdx][colIdx];
            const pingKey = pingKeys[rowIdx] && pingKeys[rowIdx][colIdx];
            const hasText = !filled && Boolean(text);
            const normalizedText = hasText ? text.toUpperCase() : "";
            const normalizedSolution = solution[idx].toUpperCase();
            const correct = checking && hasText && normalizedSolution === normalizedText;
            const mistake = checking && hasText && normalizedSolution !== normalizedText;
            const selected = selectedSquare.row === rowIdx && selectedSquare.col === colIdx;
            const user = Object.values(users).find((user)=>user.row === rowIdx && user.col === colIdx);
            const onClick = (e)=>this.onSquareClick(e, rowIdx, colIdx);
            const downClue = down[rowIdx]?.[colIdx];
            const acrossClue = across[rowIdx]?.[colIdx];
            const clue = (downClue || acrossClue || "").toString();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($adfd51cc57da14ef$exports))), {
                maxWidth: 1000,
                key: `cell-${rowIdx}-${colIdx}`
            }, (mobile)=>{
                const squareProps = {
                    key: `square-${idx}`,
                    correct: correct,
                    mistake: mistake,
                    text: text,
                    user: user,
                    highlighted: highlights[rowIdx] && highlights[rowIdx][colIdx],
                    selected: selected,
                    onClick: onClick,
                    filled: filled,
                    pingKey: pingKey
                };
                if (mobile) {
                    const squareWidth = `calc(100% / ${width})`;
                    const squareHeight = "25px";
                    squareProps.style = {
                        width: squareWidth,
                        height: squareHeight
                    };
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $774c0cd5a971910f$export$2e2bcd8739ae039), {
                    ...squareProps,
                    // ref={ref => {
                    //     if (!this._squares[rowIdx]) {
                    //         this._squares[rowIdx] = {}
                    //     }
                    //     this._squares[rowIdx][colIdx] = ref
                    // }}
                    clueNumber: clue,
                    onPing: ()=>emitPing(rowIdx, colIdx),
                    onKeyDown: this.onKeyDown
                });
            });
        }));
    }
    renderBoard = ()=>{
        const { checking: checking } = this.state;
        const { width: width, height: height, board: board, showCheck: showCheck, isComplete: isComplete, onViewStats: onViewStats } = this.props;
        const rows = [];
        for(let i = 0; i < height; ++i){
            const row = [];
            for(let j = 0; j < width; ++j)row.push(board[i * width + j] === ".");
            rows.push(row);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "BoardBox"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "Board"
        }, rows.map((row, idx)=>this.renderRow(row, idx))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($adfd51cc57da14ef$exports))), {
            maxWidth: 1000
        }, this.renderCurrentClue()), this._isMobile && !this.props.isComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4371095fe1dd0c2e$export$2e2bcd8739ae039), {
            onKeyPress: this.onVirtualKeyDown
        })), !isComplete && showCheck && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ee6e5d464bbae375$export$2e2bcd8739ae039), {
            className: "BoardActionButton",
            text: checking ? "Uncheck" : "Check",
            onClick: ()=>this.setState({
                    checking: !this.state.checking
                })
        }), isComplete && typeof onViewStats === "function" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ee6e5d464bbae375$export$2e2bcd8739ae039), {
            className: "BoardActionButton ViewStatsInlineButton",
            text: "View Stats",
            onClick: onViewStats
        }));
    };
    renderCurrentClue = ()=>{
        const { direction: direction, clueSquare: clueSquare, selectedSquare: selectedSquare, pingKeys: pingKeys } = this.state;
        const { across: across, down: down, settings: settings } = this.props;
        const clues = {
            across: across,
            down: down
        };
        const { color: color } = settings;
        const { row: row, col: col } = clueSquare;
        let clue = "";
        if (!direction || !across || !down) return null;
        Object.keys(clues[direction]).forEach((key)=>{
            const item = clues[direction][key];
            if (item.row === row && item.col === col) clue = `${key}. ${item.clue}`;
        });
        const updatePingKey = ()=>{
            if (!selectedSquare || isNaN(selectedSquare.row) || isNaN(selectedSquare.col)) return;
            const newPingKeys = [
                ...pingKeys
            ];
            newPingKeys[selectedSquare.row][selectedSquare.col] = `local-${(0, (/*@__PURE__*/$parcel$interopDefault($ab009d3ca5ea0c28$exports))).generate()}`;
            this.setState({
                pingKeys: newPingKeys
            });
        };
        const classNames = [
            "CurrentClue"
        ];
        if (!this._isMobile) classNames.push("desktop");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            onClick: this.onClickClue,
            className: classNames.join(" ")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", null, clue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $a5510e1e28f34fe9$export$2e2bcd8739ae039), {
            onClick: updatePingKey,
            color: color
        }));
    };
    renderClues = (name, data)=>{
        const { clueSquare: clueSquare, direction: direction, finishedClues: finishedClues } = this.state;
        if (!data) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($adfd51cc57da14ef$exports))), {
            minWidth: 1000
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "Clues"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("ul", null, Object.keys(data).map((key)=>{
            const val = data[key];
            const onClick = ()=>{
                const newSelectedSquare = {
                    row: val.row,
                    col: val.col
                };
                this.updateSelectedSquare(newSelectedSquare);
                this.setState({
                    direction: name
                });
            };
            const classNames = [];
            if (clueSquare.row === val.row && clueSquare.col === val.col && direction === name) classNames.push("selected");
            if (finishedClues.has(key)) classNames.push("complete");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("li", {
                key: `${name}-${key}`,
                className: classNames.join(" "),
                onClick: onClick
            }, key, ". ", val.clue);
        }))));
    };
    render() {
        const { showClues: showClues, across: across, down: down } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "Box"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "Crossword"
        }, showClues && this.renderClues("across", across), this.renderBoard(), showClues && this.renderClues("down", down)));
    }
}
var $ab94c19ccb4acf4d$export$2e2bcd8739ae039 = $ab94c19ccb4acf4d$export$c9960d29085ddc76;


const $8edb5194a04d38bf$var$WIN_CELEBRATIONS = 29;
const $8edb5194a04d38bf$var$WIN_DELAY_MS = [
    200,
    800
];
const $8edb5194a04d38bf$var$explodeConfig = {
    id: "tsparticles",
    options: {
        fullScreen: {
            zIndex: 1
        },
        emitters: {
            position: {
                x: 50,
                y: 100
            },
            rate: {
                quantity: 5,
                delay: 0.15
            }
        },
        particles: {
            color: {
                value: [
                    "#1E00FF",
                    "#FF0061",
                    "#E1FF00",
                    "#00FF9E"
                ]
            },
            move: {
                decay: 0.05,
                direction: "top",
                enable: true,
                gravity: {
                    enable: true
                },
                outModes: {
                    top: "none",
                    default: "destroy"
                },
                speed: {
                    min: 50,
                    max: 100
                }
            },
            number: {
                value: 0
            },
            opacity: {
                value: 1
            },
            rotate: {
                value: {
                    min: 0,
                    max: 360
                },
                direction: "random",
                animation: {
                    enable: true,
                    speed: 30
                }
            },
            tilt: {
                direction: "random",
                enable: true,
                value: {
                    min: 0,
                    max: 360
                },
                animation: {
                    enable: true,
                    speed: 30
                }
            },
            size: {
                value: 3,
                animation: {
                    enable: true,
                    startValue: "min",
                    count: 1,
                    speed: 16,
                    sync: true
                }
            },
            roll: {
                darken: {
                    enable: true,
                    value: 25
                },
                enlighten: {
                    enable: true,
                    value: 25
                },
                enable: true,
                speed: {
                    min: 5,
                    max: 15
                }
            },
            wobble: {
                distance: 30,
                enable: true,
                speed: {
                    min: -7,
                    max: 7
                }
            },
            shape: {
                type: [
                    "circle",
                    "square"
                ],
                options: {}
            }
        },
        responsive: [
            {
                maxWidth: 1024,
                options: {
                    particles: {
                        move: {
                            speed: {
                                min: 33,
                                max: 66
                            }
                        }
                    }
                }
            }
        ]
    }
};
const $8edb5194a04d38bf$export$1e8af1187d9cff25 = (x, y, heart = false)=>{
    if (!window.confetti) {
        console.warn("no confetti");
        return;
    }
    const count = 200;
    if (x === undefined || y === undefined) {
        x = Math.random();
        y = Math.random();
    }
    const defaults = {
        origin: {
            x: x,
            y: y
        }
    };
    if (heart) {
        defaults.shapes = [
            "heart"
        ];
        defaults.colors = [
            "FFC0CB",
            "FF69B4",
            "FF1493",
            "C71585"
        ];
        defaults.gravity = 0;
    }
    function fire(particleRatio, opts) {
        window.confetti(Object.assign({}, defaults, opts, {
            particleCount: Math.floor(count * particleRatio),
            scalar: heart ? (opts.scalar || 1) * 2 : opts.scalar
        }));
    }
    fire(0.25, {
        spread: 26,
        startVelocity: 55
    });
    fire(0.2, {
        spread: 60
    });
    fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 45
    });
};
const $8edb5194a04d38bf$export$7b82f38e9ee2ae8 = ()=>{
    if (!window.confetti) {
        console.warn("no confetti");
        return;
    }
    window.confetti($8edb5194a04d38bf$var$explodeConfig);
};
const $8edb5194a04d38bf$export$ffbd567786ca98ee = (n = $8edb5194a04d38bf$var$WIN_CELEBRATIONS, heart = false)=>{
    if (!window.confetti) {
        console.warn("no confetti");
        return;
    }
    for(let i = 0; i < n; i++){
        const winDelay = $8edb5194a04d38bf$var$WIN_DELAY_MS[0] + Math.random() * ($8edb5194a04d38bf$var$WIN_DELAY_MS[1] - $8edb5194a04d38bf$var$WIN_DELAY_MS[0]);
        setTimeout(()=>$8edb5194a04d38bf$export$1e8af1187d9cff25(undefined, undefined, heart), i * winDelay);
    }
};


const $5cbcba0f1da6c5df$export$56d196d2844d1ca1 = [
    "red",
    "green",
    "blue",
    // 'yellow',
    "purple",
    "orange"
];



var $gIfym = parcelRequire("gIfym");
const $99fbd476f3947bc1$var$UPDATE_DEBOUNCE = 1000;
function $99fbd476f3947bc1$var$useLocalStorage(key = "settings", initialValue = {}, debounce = $99fbd476f3947bc1$var$UPDATE_DEBOUNCE) {
    const timeoutId = (0, $gIfym.useRef)(null);
    const getValue = ()=>{
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error(error);
            return initialValue;
        }
    };
    const [storedValue, setStoredValue] = (0, $gIfym.useState)(getValue());
    (0, $gIfym.useEffect)(()=>{
        setValue(getValue());
    }, [
        key
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (timeoutId.current) window.clearTimeout(timeoutId.current);
        if (!storedValue) return;
        if (!debounce) return;
        timeoutId.current = window.setTimeout(()=>{
            window.localStorage.setItem(key, JSON.stringify(storedValue));
        }, debounce);
        return ()=>{
            if (timeoutId.current) window.clearTimeout(timeoutId.current);
        };
    }, [
        storedValue,
        debounce
    ]);
    const setValue = (value)=>{
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (!debounce) window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error(error);
        }
    };
    return [
        storedValue,
        setValue
    ];
}
var $99fbd476f3947bc1$export$2e2bcd8739ae039 = $99fbd476f3947bc1$var$useLocalStorage;



var $gIfym = parcelRequire("gIfym");

var $51f8827d164123c4$exports = {};
$51f8827d164123c4$exports = new URL("share.f4d2de34.svg", import.meta.url).toString();


const $fad8677fba5f5b13$var$e = "undefined" != typeof window ? window : void 0, $fad8677fba5f5b13$var$t = "undefined" != typeof globalThis ? globalThis : $fad8677fba5f5b13$var$e, $fad8677fba5f5b13$var$i = Array.prototype, $fad8677fba5f5b13$var$n = $fad8677fba5f5b13$var$i.forEach, $fad8677fba5f5b13$var$s = $fad8677fba5f5b13$var$i.indexOf, $fad8677fba5f5b13$var$r = null == $fad8677fba5f5b13$var$t ? void 0 : $fad8677fba5f5b13$var$t.navigator, $fad8677fba5f5b13$var$o = null == $fad8677fba5f5b13$var$t ? void 0 : $fad8677fba5f5b13$var$t.document, $fad8677fba5f5b13$var$a = null == $fad8677fba5f5b13$var$t ? void 0 : $fad8677fba5f5b13$var$t.location, $fad8677fba5f5b13$var$l = null == $fad8677fba5f5b13$var$t ? void 0 : $fad8677fba5f5b13$var$t.fetch, $fad8677fba5f5b13$var$c = null != $fad8677fba5f5b13$var$t && $fad8677fba5f5b13$var$t.XMLHttpRequest && "withCredentials" in new $fad8677fba5f5b13$var$t.XMLHttpRequest ? $fad8677fba5f5b13$var$t.XMLHttpRequest : void 0, $fad8677fba5f5b13$var$u = null == $fad8677fba5f5b13$var$t ? void 0 : $fad8677fba5f5b13$var$t.AbortController, $fad8677fba5f5b13$var$d = null == $fad8677fba5f5b13$var$r ? void 0 : $fad8677fba5f5b13$var$r.userAgent, $fad8677fba5f5b13$var$h = null != $fad8677fba5f5b13$var$e ? $fad8677fba5f5b13$var$e : {};
const $fad8677fba5f5b13$var$_ = {
    DEBUG: !1,
    LIB_VERSION: "1.177.0"
}, $fad8677fba5f5b13$var$p = Array.isArray, $fad8677fba5f5b13$var$g = Object.prototype, $fad8677fba5f5b13$var$f = $fad8677fba5f5b13$var$g.hasOwnProperty, $fad8677fba5f5b13$var$v = $fad8677fba5f5b13$var$g.toString, $fad8677fba5f5b13$var$m = $fad8677fba5f5b13$var$p || function(e) {
    return "[object Array]" === $fad8677fba5f5b13$var$v.call(e);
}, $fad8677fba5f5b13$var$y = function(e) {
    return "function" == typeof e;
}, $fad8677fba5f5b13$var$b = function(e) {
    return e === Object(e) && !$fad8677fba5f5b13$var$m(e);
}, $fad8677fba5f5b13$var$w = function(e) {
    if ($fad8677fba5f5b13$var$b(e)) {
        for(const t in e)if ($fad8677fba5f5b13$var$f.call(e, t)) return !1;
        return !0;
    }
    return !1;
}, $fad8677fba5f5b13$var$S = function(e) {
    return void 0 === e;
}, $fad8677fba5f5b13$var$E = function(e) {
    return "[object String]" == $fad8677fba5f5b13$var$v.call(e);
}, $fad8677fba5f5b13$var$k = function(e) {
    return $fad8677fba5f5b13$var$E(e) && 0 === e.trim().length;
}, $fad8677fba5f5b13$var$x = function(e) {
    return null === e;
}, $fad8677fba5f5b13$var$I = function(e) {
    return $fad8677fba5f5b13$var$S(e) || $fad8677fba5f5b13$var$x(e);
}, $fad8677fba5f5b13$var$P = function(e) {
    return "[object Number]" == $fad8677fba5f5b13$var$v.call(e);
}, $fad8677fba5f5b13$var$F = function(e) {
    return "[object Boolean]" === $fad8677fba5f5b13$var$v.call(e);
}, $fad8677fba5f5b13$var$R = (e)=>e instanceof FormData, $fad8677fba5f5b13$var$T = "[PostHog.js]", $fad8677fba5f5b13$var$$ = {
    _log: function(t) {
        if ($fad8677fba5f5b13$var$e && ($fad8677fba5f5b13$var$_.DEBUG || $fad8677fba5f5b13$var$h.POSTHOG_DEBUG) && !$fad8677fba5f5b13$var$S($fad8677fba5f5b13$var$e.console) && $fad8677fba5f5b13$var$e.console) {
            const r = "__rrweb_original__" in $fad8677fba5f5b13$var$e.console[t] ? $fad8677fba5f5b13$var$e.console[t].__rrweb_original__ : $fad8677fba5f5b13$var$e.console[t];
            for(var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)n[s - 1] = arguments[s];
            r($fad8677fba5f5b13$var$T, ...n);
        }
    },
    info: function() {
        for(var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i];
        $fad8677fba5f5b13$var$$._log("log", ...t);
    },
    warn: function() {
        for(var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i];
        $fad8677fba5f5b13$var$$._log("warn", ...t);
    },
    error: function() {
        for(var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i];
        $fad8677fba5f5b13$var$$._log("error", ...t);
    },
    critical: function() {
        for(var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i];
        console.error($fad8677fba5f5b13$var$T, ...t);
    },
    uninitializedWarning: (e)=>{
        $fad8677fba5f5b13$var$$.error(`You must initialize PostHog before calling ${e}`);
    }
}, $fad8677fba5f5b13$var$C = (e, t, i)=>{
    if (e.config.disable_external_dependency_loading) return $fad8677fba5f5b13$var$$.warn(`${t} was requested but loading of external scripts is disabled.`), i("Loading of external scripts is disabled");
    const n = ()=>{
        if (!$fad8677fba5f5b13$var$o) return i("document not found");
        const e = $fad8677fba5f5b13$var$o.createElement("script");
        e.type = "text/javascript", e.crossOrigin = "anonymous", e.src = t, e.onload = (e)=>i(void 0, e), e.onerror = (e)=>i(e);
        const n = $fad8677fba5f5b13$var$o.querySelectorAll("body > script");
        var s;
        n.length > 0 ? null === (s = n[0].parentNode) || void 0 === s || s.insertBefore(e, n[0]) : $fad8677fba5f5b13$var$o.body.appendChild(e);
    };
    null != $fad8677fba5f5b13$var$o && $fad8677fba5f5b13$var$o.body ? n() : null == $fad8677fba5f5b13$var$o || $fad8677fba5f5b13$var$o.addEventListener("DOMContentLoaded", n);
};
$fad8677fba5f5b13$var$h.__PosthogExtensions__ = $fad8677fba5f5b13$var$h.__PosthogExtensions__ || {}, $fad8677fba5f5b13$var$h.__PosthogExtensions__.loadExternalDependency = (e, t, i)=>{
    let n = `/static/${t}.js?v=${e.version}`;
    if ("toolbar" === t) {
        const e = 3e5;
        n = `${n}&t=${Math.floor(Date.now() / e) * e}`;
    }
    const s = e.requestRouter.endpointFor("assets", n);
    $fad8677fba5f5b13$var$C(e, s, i);
}, $fad8677fba5f5b13$var$h.__PosthogExtensions__.loadSiteApp = (e, t, i)=>{
    const n = e.requestRouter.endpointFor("api", t);
    $fad8677fba5f5b13$var$C(e, n, i);
};
const $fad8677fba5f5b13$var$M = {}, $fad8677fba5f5b13$var$A = function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
function $fad8677fba5f5b13$var$L(e, t, i) {
    if ($fad8677fba5f5b13$var$m(e)) {
        if ($fad8677fba5f5b13$var$n && e.forEach === $fad8677fba5f5b13$var$n) e.forEach(t, i);
        else if ("length" in e && e.length === +e.length) {
            for(let n = 0, s = e.length; n < s; n++)if (n in e && t.call(i, e[n], n) === $fad8677fba5f5b13$var$M) return;
        }
    }
}
function $fad8677fba5f5b13$var$O(e, t, i) {
    if (!$fad8677fba5f5b13$var$I(e)) {
        if ($fad8677fba5f5b13$var$m(e)) return $fad8677fba5f5b13$var$L(e, t, i);
        if ($fad8677fba5f5b13$var$R(e)) {
            for (const n of e.entries())if (t.call(i, n[1], n[0]) === $fad8677fba5f5b13$var$M) return;
        } else for(const n in e)if ($fad8677fba5f5b13$var$f.call(e, n) && t.call(i, e[n], n) === $fad8677fba5f5b13$var$M) return;
    }
}
const $fad8677fba5f5b13$var$D = function(e) {
    for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)i[n - 1] = arguments[n];
    return $fad8677fba5f5b13$var$L(i, function(t) {
        for(const i in t)void 0 !== t[i] && (e[i] = t[i]);
    }), e;
};
function $fad8677fba5f5b13$var$N(e, t) {
    return -1 !== e.indexOf(t);
}
function $fad8677fba5f5b13$var$q(e) {
    const t = Object.keys(e);
    let i = t.length;
    const n = new Array(i);
    for(; i--;)n[i] = [
        t[i],
        e[t[i]]
    ];
    return n;
}
const $fad8677fba5f5b13$var$B = function(e) {
    try {
        return e();
    } catch  {
        return;
    }
}, $fad8677fba5f5b13$var$H = function(e) {
    return function() {
        try {
            for(var t = arguments.length, i = new Array(t), n = 0; n < t; n++)i[n] = arguments[n];
            return e.apply(this, i);
        } catch (e) {
            $fad8677fba5f5b13$var$$.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $fad8677fba5f5b13$var$$.critical(e);
        }
    };
}, $fad8677fba5f5b13$var$U = function(e) {
    const t = {};
    return $fad8677fba5f5b13$var$O(e, function(e, i) {
        $fad8677fba5f5b13$var$E(e) && e.length > 0 && (t[i] = e);
    }), t;
}, $fad8677fba5f5b13$var$W = function(e) {
    return e.replace(/^\$/, "");
};
function $fad8677fba5f5b13$var$z(e, t) {
    return function(e, t) {
        const i = new Set;
        return function e(n, s) {
            if (n !== Object(n)) return t ? t(n, s) : n;
            if (i.has(n)) return;
            let r;
            return i.add(n), $fad8677fba5f5b13$var$m(n) ? (r = [], $fad8677fba5f5b13$var$L(n, (t)=>{
                r.push(e(t));
            })) : (r = {}, $fad8677fba5f5b13$var$O(n, (t, n)=>{
                i.has(t) || (r[n] = e(t, n));
            })), r;
        }(e);
    }(e, (e)=>$fad8677fba5f5b13$var$E(e) && !$fad8677fba5f5b13$var$x(t) ? e.slice(0, t) : e);
}
const $fad8677fba5f5b13$var$V = function(e) {
    let t, i, n, s = "", r = 0;
    for(t = i = 0, r = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, n = 0; n < r; n++){
        const r = e.charCodeAt(n);
        let o = null;
        r < 128 ? i++ : o = r > 127 && r < 2048 ? String.fromCharCode(r >> 6 | 192, 63 & r | 128) : String.fromCharCode(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128), $fad8677fba5f5b13$var$x(o) || (i > t && (s += e.substring(t, i)), s += o, t = i = n + 1);
    }
    return i > t && (s += e.substring(t, e.length)), s;
}, $fad8677fba5f5b13$var$G = function() {
    function t(e) {
        return e && (e.preventDefault = t.preventDefault, e.stopPropagation = t.stopPropagation), e;
    }
    return t.preventDefault = function() {
        this.returnValue = !1;
    }, t.stopPropagation = function() {
        this.cancelBubble = !0;
    }, function(i, n, s, r, o) {
        if (i) {
            if (i.addEventListener && !r) i.addEventListener(n, s, !!o);
            else {
                const r = "on" + n, o = i[r];
                i[r] = function(i, n, s) {
                    return function(r) {
                        if (!(r = r || t(null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.event))) return;
                        let o, a = !0;
                        $fad8677fba5f5b13$var$y(s) && (o = s(r));
                        const l = n.call(i, r);
                        return !1 !== o && !1 !== l || (a = !1), a;
                    };
                }(i, s, o);
            }
        } else $fad8677fba5f5b13$var$$.error("No valid element provided to register_event");
    };
}();
function $fad8677fba5f5b13$var$j(e) {
    const t = null == e ? void 0 : e.hostname;
    return !!$fad8677fba5f5b13$var$E(t) && "herokuapp.com" !== t.split(".").slice(-2).join(".");
}
function $fad8677fba5f5b13$var$Q(e, t) {
    for(let i = 0; i < e.length; i++)if (t(e[i])) return e[i];
}
let $fad8677fba5f5b13$export$6a00d17b5aff0af;
!function(e) {
    e.GZipJS = "gzip-js", e.Base64 = "base64";
}($fad8677fba5f5b13$export$6a00d17b5aff0af || ($fad8677fba5f5b13$export$6a00d17b5aff0af = {}));
const $fad8677fba5f5b13$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $fad8677fba5f5b13$var$X = "$people_distinct_id", $fad8677fba5f5b13$var$K = "__alias", $fad8677fba5f5b13$var$Z = "__timers", $fad8677fba5f5b13$var$ee = "$autocapture_disabled_server_side", $fad8677fba5f5b13$var$te = "$heatmaps_enabled_server_side", $fad8677fba5f5b13$var$ie = "$exception_capture_enabled_server_side", $fad8677fba5f5b13$var$ne = "$exception_capture_endpoint_suffix", $fad8677fba5f5b13$var$se = "$web_vitals_enabled_server_side", $fad8677fba5f5b13$var$re = "$web_vitals_allowed_metrics", $fad8677fba5f5b13$var$oe = "$session_recording_enabled_server_side", $fad8677fba5f5b13$var$ae = "$console_log_recording_enabled_server_side", $fad8677fba5f5b13$var$le = "$session_recording_network_payload_capture", $fad8677fba5f5b13$var$ce = "$session_recording_canvas_recording", $fad8677fba5f5b13$var$ue = "$replay_sample_rate", $fad8677fba5f5b13$var$de = "$replay_minimum_duration", $fad8677fba5f5b13$var$he = "$sesid", $fad8677fba5f5b13$var$_e = "$session_is_sampled", $fad8677fba5f5b13$var$pe = "$session_recording_url_trigger_activated_session", $fad8677fba5f5b13$var$ge = "$session_recording_url_trigger_status", $fad8677fba5f5b13$var$fe = "$enabled_feature_flags", $fad8677fba5f5b13$var$ve = "$early_access_features", $fad8677fba5f5b13$var$me = "$stored_person_properties", $fad8677fba5f5b13$var$ye = "$stored_group_properties", $fad8677fba5f5b13$var$be = "$surveys", $fad8677fba5f5b13$var$we = "$surveys_activated", $fad8677fba5f5b13$var$Se = "$flag_call_reported", $fad8677fba5f5b13$var$Ee = "$user_state", $fad8677fba5f5b13$var$ke = "$client_session_props", $fad8677fba5f5b13$var$xe = "$capture_rate_limit", $fad8677fba5f5b13$var$Ie = "$initial_campaign_params", $fad8677fba5f5b13$var$Pe = "$initial_referrer_info", $fad8677fba5f5b13$var$Fe = "$initial_person_info", $fad8677fba5f5b13$var$Re = "$epp", $fad8677fba5f5b13$var$Te = "__POSTHOG_TOOLBAR__", $fad8677fba5f5b13$var$$e = [
    $fad8677fba5f5b13$var$X,
    $fad8677fba5f5b13$var$K,
    "__cmpns",
    $fad8677fba5f5b13$var$Z,
    $fad8677fba5f5b13$var$oe,
    $fad8677fba5f5b13$var$te,
    $fad8677fba5f5b13$var$he,
    $fad8677fba5f5b13$var$fe,
    $fad8677fba5f5b13$var$Ee,
    $fad8677fba5f5b13$var$ve,
    $fad8677fba5f5b13$var$ye,
    $fad8677fba5f5b13$var$me,
    $fad8677fba5f5b13$var$be,
    $fad8677fba5f5b13$var$Se,
    $fad8677fba5f5b13$var$ke,
    $fad8677fba5f5b13$var$xe,
    $fad8677fba5f5b13$var$Ie,
    $fad8677fba5f5b13$var$Pe,
    $fad8677fba5f5b13$var$Re
], $fad8677fba5f5b13$var$Ce = "$active_feature_flags", $fad8677fba5f5b13$var$Me = "$override_feature_flags", $fad8677fba5f5b13$var$Ae = "$feature_flag_payloads", $fad8677fba5f5b13$var$Le = (e)=>{
    const t = {};
    for (const [i, n] of $fad8677fba5f5b13$var$q(e || {}))n && (t[i] = n);
    return t;
};
class $fad8677fba5f5b13$var$Oe {
    constructor(e){
        this.instance = e, this._override_warning = !1, this.featureFlagEventHandlers = [], this.reloadFeatureFlagsQueued = !1, this.reloadFeatureFlagsInAction = !1;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagVariants() {
        const e = this.instance.get_property($fad8677fba5f5b13$var$fe), t = this.instance.get_property($fad8677fba5f5b13$var$Me);
        if (!t) return e || {};
        const i = $fad8677fba5f5b13$var$D({}, e), n = Object.keys(t);
        for(let e = 0; e < n.length; e++)i[n[e]] = t[n[e]];
        return this._override_warning || ($fad8677fba5f5b13$var$$.warn(" Overriding feature flags!", {
            enabledFlags: e,
            overriddenFlags: t,
            finalFlags: i
        }), this._override_warning = !0), i;
    }
    getFlagPayloads() {
        return this.instance.get_property($fad8677fba5f5b13$var$Ae) || {};
    }
    reloadFeatureFlags() {
        this.reloadFeatureFlagsQueued || (this.reloadFeatureFlagsQueued = !0, this._startReloadTimer());
    }
    setAnonymousDistinctId(e) {
        this.$anon_distinct_id = e;
    }
    setReloadingPaused(e) {
        this.reloadFeatureFlagsInAction = e;
    }
    resetRequestQueue() {
        this.reloadFeatureFlagsQueued = !1;
    }
    _startReloadTimer() {
        this.reloadFeatureFlagsQueued && !this.reloadFeatureFlagsInAction && setTimeout(()=>{
            !this.reloadFeatureFlagsInAction && this.reloadFeatureFlagsQueued && (this.reloadFeatureFlagsQueued = !1, this._reloadFeatureFlagsRequest());
        }, 5);
    }
    _reloadFeatureFlagsRequest() {
        if (this.instance.config.advanced_disable_feature_flags) return;
        this.setReloadingPaused(!0);
        const e = this.instance.config.token, t = this.instance.get_property($fad8677fba5f5b13$var$me), i = this.instance.get_property($fad8677fba5f5b13$var$ye), n = {
            token: e,
            distinct_id: this.instance.get_distinct_id(),
            groups: this.instance.getGroups(),
            $anon_distinct_id: this.$anon_distinct_id,
            person_properties: t,
            group_properties: i,
            disable_flags: this.instance.config.advanced_disable_feature_flags || void 0
        };
        this.instance._send_request({
            method: "POST",
            url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"),
            data: n,
            compression: this.instance.config.disable_compression ? void 0 : $fad8677fba5f5b13$export$6a00d17b5aff0af.Base64,
            timeout: this.instance.config.feature_flag_request_timeout_ms,
            callback: (e)=>{
                var t;
                this.setReloadingPaused(!1);
                let i = !0;
                200 === e.statusCode && (this.$anon_distinct_id = void 0, i = !1), this.receivedFeatureFlags(null !== (t = e.json) && void 0 !== t ? t : {}, i), this._startReloadTimer();
            }
        });
    }
    getFeatureFlag(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!(this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0)) return void $fad8677fba5f5b13$var$$.warn('getFeatureFlag for key "' + e + "\" failed. Feature flags didn't load in time.");
        const i = this.getFlagVariants()[e], n = `${i}`, s = this.instance.get_property($fad8677fba5f5b13$var$Se) || {};
        var r;
        !t.send_event && "send_event" in t || e in s && s[e].includes(n) || ($fad8677fba5f5b13$var$m(s[e]) ? s[e].push(n) : s[e] = [
            n
        ], null === (r = this.instance.persistence) || void 0 === r || r.register({
            [$fad8677fba5f5b13$var$Se]: s
        }), this.instance.capture("$feature_flag_called", {
            $feature_flag: e,
            $feature_flag_response: i
        }));
        return i;
    }
    getFeatureFlagPayload(e) {
        return this.getFlagPayloads()[e];
    }
    isFeatureEnabled(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(e, t);
        $fad8677fba5f5b13$var$$.warn('isFeatureEnabled for key "' + e + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(e) {
        this.featureFlagEventHandlers.push(e);
    }
    removeFeatureFlagsHandler(e) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((t)=>t !== e);
    }
    receivedFeatureFlags(e, t) {
        if (!this.instance.persistence) return;
        this.instance.decideEndpointWasHit = !0;
        const i = this.getFlagVariants(), n = this.getFlagPayloads();
        !function(e, t) {
            let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            const s = e.featureFlags, r = e.featureFlagPayloads;
            if (!s) return;
            if ($fad8677fba5f5b13$var$m(s)) {
                const e = {};
                if (s) for(let t = 0; t < s.length; t++)e[s[t]] = !0;
                return void (t && t.register({
                    [$fad8677fba5f5b13$var$Ce]: s,
                    [$fad8677fba5f5b13$var$fe]: e
                }));
            }
            let o = s, a = r;
            e.errorsWhileComputingFlags && (o = {
                ...i,
                ...o
            }, a = {
                ...n,
                ...a
            }), t && t.register({
                [$fad8677fba5f5b13$var$Ce]: Object.keys($fad8677fba5f5b13$var$Le(o)),
                [$fad8677fba5f5b13$var$fe]: o || {},
                [$fad8677fba5f5b13$var$Ae]: a || {}
            });
        }(e, this.instance.persistence, i, n), this._fireFeatureFlagsCallbacks(t);
    }
    override(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (!this.instance.__loaded || !this.instance.persistence) return $fad8677fba5f5b13$var$$.uninitializedWarning("posthog.feature_flags.override");
        if (this._override_warning = t, !1 === e) this.instance.persistence.unregister($fad8677fba5f5b13$var$Me);
        else if ($fad8677fba5f5b13$var$m(e)) {
            const t = {};
            for(let i = 0; i < e.length; i++)t[e[i]] = !0;
            this.instance.persistence.register({
                [$fad8677fba5f5b13$var$Me]: t
            });
        } else this.instance.persistence.register({
            [$fad8677fba5f5b13$var$Me]: e
        });
    }
    onFeatureFlags(e) {
        if (this.addFeatureFlagsHandler(e), this.instance.decideEndpointWasHit) {
            const { flags: t, flagVariants: i } = this._prepareFeatureFlagsForCallbacks();
            e(t, i);
        }
        return ()=>this.removeFeatureFlagsHandler(e);
    }
    updateEarlyAccessFeatureEnrollment(e, t) {
        var i;
        const n = {
            [`$feature_enrollment/${e}`]: t
        };
        this.instance.capture("$feature_enrollment_update", {
            $feature_flag: e,
            $feature_enrollment: t,
            $set: n
        }), this.setPersonPropertiesForFlags(n, !1);
        const s = {
            ...this.getFlagVariants(),
            [e]: t
        };
        null === (i = this.instance.persistence) || void 0 === i || i.register({
            [$fad8677fba5f5b13$var$Ce]: Object.keys($fad8677fba5f5b13$var$Le(s)),
            [$fad8677fba5f5b13$var$fe]: s
        }), this._fireFeatureFlagsCallbacks();
    }
    getEarlyAccessFeatures(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        const i = this.instance.get_property($fad8677fba5f5b13$var$ve);
        if (i && !t) return e(i);
        this.instance._send_request({
            transport: "XHR",
            url: this.instance.requestRouter.endpointFor("api", `/api/early_access_features/?token=${this.instance.config.token}`),
            method: "GET",
            callback: (t)=>{
                var i;
                if (!t.json) return;
                const n = t.json.earlyAccessFeatures;
                return null === (i = this.instance.persistence) || void 0 === i || i.register({
                    [$fad8677fba5f5b13$var$ve]: n
                }), e(n);
            }
        });
    }
    _prepareFeatureFlagsForCallbacks() {
        const e = this.getFlags(), t = this.getFlagVariants();
        return {
            flags: e.filter((e)=>t[e]),
            flagVariants: Object.keys(t).filter((e)=>t[e]).reduce((e, i)=>(e[i] = t[i], e), {})
        };
    }
    _fireFeatureFlagsCallbacks(e) {
        const { flags: t, flagVariants: i } = this._prepareFeatureFlagsForCallbacks();
        this.featureFlagEventHandlers.forEach((n)=>n(t, i, {
                errorsLoading: e
            }));
    }
    setPersonPropertiesForFlags(e) {
        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        const i = this.instance.get_property($fad8677fba5f5b13$var$me) || {};
        this.instance.register({
            [$fad8677fba5f5b13$var$me]: {
                ...i,
                ...e
            }
        }), t && this.instance.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this.instance.unregister($fad8677fba5f5b13$var$me);
    }
    setGroupPropertiesForFlags(e) {
        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        const i = this.instance.get_property($fad8677fba5f5b13$var$ye) || {};
        0 !== Object.keys(i).length && Object.keys(i).forEach((t)=>{
            i[t] = {
                ...i[t],
                ...e[t]
            }, delete e[t];
        }), this.instance.register({
            [$fad8677fba5f5b13$var$ye]: {
                ...i,
                ...e
            }
        }), t && this.instance.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(e) {
        if (e) {
            const t = this.instance.get_property($fad8677fba5f5b13$var$ye) || {};
            this.instance.register({
                [$fad8677fba5f5b13$var$ye]: {
                    ...t,
                    [e]: {}
                }
            });
        } else this.instance.unregister($fad8677fba5f5b13$var$ye);
    }
}
/**
 * uuidv7: An experimental implementation of the proposed UUID Version 7
 *
 * @license Apache-2.0
 * @copyright 2021-2023 LiosK
 * @packageDocumentation
 *
 * from https://github.com/LiosK/uuidv7/blob/e501462ea3d23241de13192ceae726956f9b3b7d/src/index.ts
 */ Math.trunc || (Math.trunc = function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
    return $fad8677fba5f5b13$var$P(e) && isFinite(e) && Math.floor(e) === e;
});
const $fad8677fba5f5b13$var$De = "0123456789abcdef";
class $fad8677fba5f5b13$var$Ne {
    constructor(e){
        if (this.bytes = e, 16 !== e.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(e, t, i, n) {
        if (!Number.isInteger(e) || !Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(n) || e < 0 || t < 0 || i < 0 || n < 0 || e > 0xffffffffffff || t > 4095 || i > 1073741823 || n > 4294967295) throw new RangeError("invalid field value");
        const s = new Uint8Array(16);
        return s[0] = e / 2 ** 40, s[1] = e / 2 ** 32, s[2] = e / 2 ** 24, s[3] = e / 65536, s[4] = e / 256, s[5] = e, s[6] = 112 | t >>> 8, s[7] = t, s[8] = 128 | i >>> 24, s[9] = i >>> 16, s[10] = i >>> 8, s[11] = i, s[12] = n >>> 24, s[13] = n >>> 16, s[14] = n >>> 8, s[15] = n, new $fad8677fba5f5b13$var$Ne(s);
    }
    toString() {
        let e = "";
        for(let t = 0; t < this.bytes.length; t++)e = e + $fad8677fba5f5b13$var$De.charAt(this.bytes[t] >>> 4) + $fad8677fba5f5b13$var$De.charAt(15 & this.bytes[t]), 3 !== t && 5 !== t && 7 !== t && 9 !== t || (e += "-");
        if (36 !== e.length) throw new Error("Invalid UUIDv7 was generated");
        return e;
    }
    clone() {
        return new $fad8677fba5f5b13$var$Ne(this.bytes.slice(0));
    }
    equals(e) {
        return 0 === this.compareTo(e);
    }
    compareTo(e) {
        for(let t = 0; t < 16; t++){
            const i = this.bytes[t] - e.bytes[t];
            if (0 !== i) return Math.sign(i);
        }
        return 0;
    }
}
class $fad8677fba5f5b13$var$qe {
    timestamp = 0;
    counter = 0;
    random = new $fad8677fba5f5b13$var$Ue;
    generate() {
        const e = this.generateOrAbort();
        if ($fad8677fba5f5b13$var$S(e)) {
            this.timestamp = 0;
            const e = this.generateOrAbort();
            if ($fad8677fba5f5b13$var$S(e)) throw new Error("Could not generate UUID after timestamp reset");
            return e;
        }
        return e;
    }
    generateOrAbort() {
        const e = Date.now();
        if (e > this.timestamp) this.timestamp = e, this.resetCounter();
        else {
            if (!(e + 1e4 > this.timestamp)) return;
            this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
        }
        return $fad8677fba5f5b13$var$Ne.fromFieldsV7(this.timestamp, Math.trunc(this.counter / 2 ** 30), this.counter & 2 ** 30 - 1, this.random.nextUint32());
    }
    resetCounter() {
        this.counter = 1024 * this.random.nextUint32() + (1023 & this.random.nextUint32());
    }
}
let $fad8677fba5f5b13$var$Be, $fad8677fba5f5b13$var$He = (e)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(let t = 0; t < e.length; t++)e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return e;
};
$fad8677fba5f5b13$var$e && !$fad8677fba5f5b13$var$S($fad8677fba5f5b13$var$e.crypto) && crypto.getRandomValues && ($fad8677fba5f5b13$var$He = (e)=>crypto.getRandomValues(e));
class $fad8677fba5f5b13$var$Ue {
    buffer = new Uint32Array(8);
    cursor = 1 / 0;
    nextUint32() {
        return this.cursor >= this.buffer.length && ($fad8677fba5f5b13$var$He(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
    }
}
const $fad8677fba5f5b13$var$We = ()=>$fad8677fba5f5b13$var$ze().toString(), $fad8677fba5f5b13$var$ze = ()=>($fad8677fba5f5b13$var$Be || ($fad8677fba5f5b13$var$Be = new $fad8677fba5f5b13$var$qe)).generate(), $fad8677fba5f5b13$var$Ve = "Thu, 01 Jan 1970 00:00:00 GMT";
let $fad8677fba5f5b13$var$Ge = "";
const $fad8677fba5f5b13$var$je = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $fad8677fba5f5b13$var$Qe(e, t) {
    if (t) {
        let t = function(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $fad8677fba5f5b13$var$o;
            if ($fad8677fba5f5b13$var$Ge) return $fad8677fba5f5b13$var$Ge;
            if (!t) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(e)) return "";
            const i = e.split(".");
            let n = Math.min(i.length, 8);
            const s = "dmn_chk_" + $fad8677fba5f5b13$var$We(), r = new RegExp("(^|;)\\s*" + s + "=1");
            for(; !$fad8677fba5f5b13$var$Ge && n--;){
                const e = i.slice(n).join("."), o = s + "=1;domain=." + e;
                t.cookie = o, r.test(t.cookie) && (t.cookie = o + ";expires=" + $fad8677fba5f5b13$var$Ve, $fad8677fba5f5b13$var$Ge = e);
            }
            return $fad8677fba5f5b13$var$Ge;
        }(e);
        if (!t) {
            const i = ((e)=>{
                const t = e.match($fad8677fba5f5b13$var$je);
                return t ? t[0] : "";
            })(e);
            i !== t && $fad8677fba5f5b13$var$$.info("Warning: cookie subdomain discovery mismatch", i, t), t = i;
        }
        return t ? "; domain=." + t : "";
    }
    return "";
}
const $fad8677fba5f5b13$var$Je = {
    is_supported: ()=>!!$fad8677fba5f5b13$var$o,
    error: function(e) {
        $fad8677fba5f5b13$var$$.error("cookieStore error: " + e);
    },
    get: function(e) {
        if ($fad8677fba5f5b13$var$o) {
            try {
                const t = e + "=", i = $fad8677fba5f5b13$var$o.cookie.split(";").filter((e)=>e.length);
                for(let e = 0; e < i.length; e++){
                    let n = i[e];
                    for(; " " == n.charAt(0);)n = n.substring(1, n.length);
                    if (0 === n.indexOf(t)) return decodeURIComponent(n.substring(t.length, n.length));
                }
            } catch  {}
            return null;
        }
    },
    parse: function(e) {
        let t;
        try {
            t = JSON.parse($fad8677fba5f5b13$var$Je.get(e)) || {};
        } catch  {}
        return t;
    },
    set: function(e, t, i, n, s) {
        if ($fad8677fba5f5b13$var$o) try {
            let r = "", a = "";
            const l = $fad8677fba5f5b13$var$Qe($fad8677fba5f5b13$var$o.location.hostname, n);
            if (i) {
                const e = new Date;
                e.setTime(e.getTime() + 24 * i * 3600000), r = "; expires=" + e.toUTCString();
            }
            s && (a = "; secure");
            const c = e + "=" + encodeURIComponent(JSON.stringify(t)) + r + "; SameSite=Lax; path=/" + l + a;
            return c.length > 3686.4 && $fad8677fba5f5b13$var$$.warn("cookieStore warning: large cookie, len=" + c.length), $fad8677fba5f5b13$var$o.cookie = c, c;
        } catch  {
            return;
        }
    },
    remove: function(e, t) {
        try {
            $fad8677fba5f5b13$var$Je.set(e, "", -1, t);
        } catch  {
            return;
        }
    }
};
let $fad8677fba5f5b13$var$Ye = null;
const $fad8677fba5f5b13$var$Xe = {
    is_supported: function() {
        if (!$fad8677fba5f5b13$var$x($fad8677fba5f5b13$var$Ye)) return $fad8677fba5f5b13$var$Ye;
        let t = !0;
        if ($fad8677fba5f5b13$var$S($fad8677fba5f5b13$var$e)) t = !1;
        else try {
            const e = "__mplssupport__", i = "xyz";
            $fad8677fba5f5b13$var$Xe.set(e, i), '"xyz"' !== $fad8677fba5f5b13$var$Xe.get(e) && (t = !1), $fad8677fba5f5b13$var$Xe.remove(e);
        } catch  {
            t = !1;
        }
        return t || $fad8677fba5f5b13$var$$.error("localStorage unsupported; falling back to cookie store"), $fad8677fba5f5b13$var$Ye = t, t;
    },
    error: function(e) {
        $fad8677fba5f5b13$var$$.error("localStorage error: " + e);
    },
    get: function(t) {
        try {
            return null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.localStorage.getItem(t);
        } catch (e) {
            $fad8677fba5f5b13$var$Xe.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($fad8677fba5f5b13$var$Xe.get(e)) || {};
        } catch  {}
        return null;
    },
    set: function(t, i) {
        try {
            null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.localStorage.setItem(t, JSON.stringify(i));
        } catch (e) {
            $fad8677fba5f5b13$var$Xe.error(e);
        }
    },
    remove: function(t) {
        try {
            null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.localStorage.removeItem(t);
        } catch (e) {
            $fad8677fba5f5b13$var$Xe.error(e);
        }
    }
}, $fad8677fba5f5b13$var$Ke = [
    "distinct_id",
    $fad8677fba5f5b13$var$he,
    $fad8677fba5f5b13$var$_e,
    $fad8677fba5f5b13$var$Re
], $fad8677fba5f5b13$var$Ze = {
    ...$fad8677fba5f5b13$var$Xe,
    parse: function(e) {
        try {
            let t = {};
            try {
                t = $fad8677fba5f5b13$var$Je.parse(e) || {};
            } catch  {}
            const i = $fad8677fba5f5b13$var$D(t, JSON.parse($fad8677fba5f5b13$var$Xe.get(e) || "{}"));
            return $fad8677fba5f5b13$var$Xe.set(e, i), i;
        } catch  {}
        return null;
    },
    set: function(e, t, i, n, s, r) {
        try {
            $fad8677fba5f5b13$var$Xe.set(e, t, void 0, void 0, r);
            const o = {};
            $fad8677fba5f5b13$var$Ke.forEach((e)=>{
                t[e] && (o[e] = t[e]);
            }), Object.keys(o).length && $fad8677fba5f5b13$var$Je.set(e, o, i, n, s, r);
        } catch (e) {
            $fad8677fba5f5b13$var$Xe.error(e);
        }
    },
    remove: function(t, i) {
        try {
            null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.localStorage.removeItem(t), $fad8677fba5f5b13$var$Je.remove(t, i);
        } catch (e) {
            $fad8677fba5f5b13$var$Xe.error(e);
        }
    }
}, $fad8677fba5f5b13$var$et = {}, $fad8677fba5f5b13$var$tt = {
    is_supported: function() {
        return !0;
    },
    error: function(e) {
        $fad8677fba5f5b13$var$$.error("memoryStorage error: " + e);
    },
    get: function(e) {
        return $fad8677fba5f5b13$var$et[e] || null;
    },
    parse: function(e) {
        return $fad8677fba5f5b13$var$et[e] || null;
    },
    set: function(e, t) {
        $fad8677fba5f5b13$var$et[e] = t;
    },
    remove: function(e) {
        delete $fad8677fba5f5b13$var$et[e];
    }
};
let $fad8677fba5f5b13$var$it = null;
const $fad8677fba5f5b13$var$nt = {
    is_supported: function() {
        if (!$fad8677fba5f5b13$var$x($fad8677fba5f5b13$var$it)) return $fad8677fba5f5b13$var$it;
        if ($fad8677fba5f5b13$var$it = !0, $fad8677fba5f5b13$var$S($fad8677fba5f5b13$var$e)) $fad8677fba5f5b13$var$it = !1;
        else try {
            const e = "__support__", t = "xyz";
            $fad8677fba5f5b13$var$nt.set(e, t), '"xyz"' !== $fad8677fba5f5b13$var$nt.get(e) && ($fad8677fba5f5b13$var$it = !1), $fad8677fba5f5b13$var$nt.remove(e);
        } catch  {
            $fad8677fba5f5b13$var$it = !1;
        }
        return $fad8677fba5f5b13$var$it;
    },
    error: function(e) {
        $fad8677fba5f5b13$var$$.error("sessionStorage error: ", e);
    },
    get: function(t) {
        try {
            return null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.sessionStorage.getItem(t);
        } catch (e) {
            $fad8677fba5f5b13$var$nt.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($fad8677fba5f5b13$var$nt.get(e)) || null;
        } catch  {}
        return null;
    },
    set: function(t, i) {
        try {
            null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.sessionStorage.setItem(t, JSON.stringify(i));
        } catch (e) {
            $fad8677fba5f5b13$var$nt.error(e);
        }
    },
    remove: function(t) {
        try {
            null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.sessionStorage.removeItem(t);
        } catch (e) {
            $fad8677fba5f5b13$var$nt.error(e);
        }
    }
}, $fad8677fba5f5b13$var$st = [
    "localhost",
    "127.0.0.1"
], $fad8677fba5f5b13$var$rt = (e)=>{
    const t = null == $fad8677fba5f5b13$var$o ? void 0 : $fad8677fba5f5b13$var$o.createElement("a");
    return $fad8677fba5f5b13$var$S(t) ? null : (t.href = e, t);
}, $fad8677fba5f5b13$var$ot = function(e, t) {
    return !!function(e) {
        try {
            new RegExp(e);
        } catch  {
            return !1;
        }
        return !0;
    }(t) && new RegExp(t).test(e);
}, $fad8677fba5f5b13$var$at = function(e) {
    let t, i, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "&";
    const s = [];
    return $fad8677fba5f5b13$var$O(e, function(e, n) {
        $fad8677fba5f5b13$var$S(e) || $fad8677fba5f5b13$var$S(n) || "undefined" === n || (t = encodeURIComponent(((e)=>e instanceof File)(e) ? e.name : e.toString()), i = encodeURIComponent(n), s[s.length] = i + "=" + t);
    }), s.join(n);
}, $fad8677fba5f5b13$var$lt = function(e, t) {
    const i = ((e.split("#")[0] || "").split("?")[1] || "").split("&");
    let n;
    for(let e = 0; e < i.length; e++){
        const s = i[e].split("=");
        if (s[0] === t) {
            n = s;
            break;
        }
    }
    if (!$fad8677fba5f5b13$var$m(n) || n.length < 2) return "";
    {
        let e = n[1];
        try {
            e = decodeURIComponent(e);
        } catch  {
            $fad8677fba5f5b13$var$$.error("Skipping decoding for malformed query param: " + e);
        }
        return e.replace(/\+/g, " ");
    }
}, $fad8677fba5f5b13$var$ct = function(e, t) {
    const i = e.match(new RegExp(t + "=([^&]*)"));
    return i ? i[1] : null;
}, $fad8677fba5f5b13$var$ut = "Mobile", $fad8677fba5f5b13$var$dt = "iOS", $fad8677fba5f5b13$var$ht = "Android", $fad8677fba5f5b13$var$_t = "Tablet", $fad8677fba5f5b13$var$pt = $fad8677fba5f5b13$var$ht + " " + $fad8677fba5f5b13$var$_t, $fad8677fba5f5b13$var$gt = "iPad", $fad8677fba5f5b13$var$ft = "Apple", $fad8677fba5f5b13$var$vt = $fad8677fba5f5b13$var$ft + " Watch", $fad8677fba5f5b13$var$mt = "Safari", $fad8677fba5f5b13$var$yt = "BlackBerry", $fad8677fba5f5b13$var$bt = "Samsung", $fad8677fba5f5b13$var$wt = $fad8677fba5f5b13$var$bt + "Browser", $fad8677fba5f5b13$var$St = $fad8677fba5f5b13$var$bt + " Internet", $fad8677fba5f5b13$var$Et = "Chrome", $fad8677fba5f5b13$var$kt = $fad8677fba5f5b13$var$Et + " OS", $fad8677fba5f5b13$var$xt = $fad8677fba5f5b13$var$Et + " " + $fad8677fba5f5b13$var$dt, $fad8677fba5f5b13$var$It = "Internet Explorer", $fad8677fba5f5b13$var$Pt = $fad8677fba5f5b13$var$It + " " + $fad8677fba5f5b13$var$ut, $fad8677fba5f5b13$var$Ft = "Opera", $fad8677fba5f5b13$var$Rt = $fad8677fba5f5b13$var$Ft + " Mini", $fad8677fba5f5b13$var$Tt = "Edge", $fad8677fba5f5b13$var$$t = "Microsoft " + $fad8677fba5f5b13$var$Tt, $fad8677fba5f5b13$var$Ct = "Firefox", $fad8677fba5f5b13$var$Mt = $fad8677fba5f5b13$var$Ct + " " + $fad8677fba5f5b13$var$dt, $fad8677fba5f5b13$var$At = "Nintendo", $fad8677fba5f5b13$var$Lt = "PlayStation", $fad8677fba5f5b13$var$Ot = "Xbox", $fad8677fba5f5b13$var$Dt = $fad8677fba5f5b13$var$ht + " " + $fad8677fba5f5b13$var$ut, $fad8677fba5f5b13$var$Nt = $fad8677fba5f5b13$var$ut + " " + $fad8677fba5f5b13$var$mt, $fad8677fba5f5b13$var$qt = "Windows", $fad8677fba5f5b13$var$Bt = $fad8677fba5f5b13$var$qt + " Phone", $fad8677fba5f5b13$var$Ht = "Nokia", $fad8677fba5f5b13$var$Ut = "Ouya", $fad8677fba5f5b13$var$Wt = "Generic", $fad8677fba5f5b13$var$zt = $fad8677fba5f5b13$var$Wt + " " + $fad8677fba5f5b13$var$ut.toLowerCase(), $fad8677fba5f5b13$var$Vt = $fad8677fba5f5b13$var$Wt + " " + $fad8677fba5f5b13$var$_t.toLowerCase(), $fad8677fba5f5b13$var$Gt = "Konqueror", $fad8677fba5f5b13$var$jt = "(\\d+(\\.\\d+)?)", $fad8677fba5f5b13$var$Qt = new RegExp("Version/" + $fad8677fba5f5b13$var$jt), $fad8677fba5f5b13$var$Jt = new RegExp($fad8677fba5f5b13$var$Ot, "i"), $fad8677fba5f5b13$var$Yt = new RegExp($fad8677fba5f5b13$var$Lt + " \\w+", "i"), $fad8677fba5f5b13$var$Xt = new RegExp($fad8677fba5f5b13$var$At + " \\w+", "i"), $fad8677fba5f5b13$var$Kt = new RegExp($fad8677fba5f5b13$var$yt + "|PlayBook|BB10", "i"), $fad8677fba5f5b13$var$Zt = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
const $fad8677fba5f5b13$var$ei = (e, t)=>t && $fad8677fba5f5b13$var$N(t, $fad8677fba5f5b13$var$ft) || function(e) {
        return $fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$mt) && !$fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$Et) && !$fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$ht);
    }(e), $fad8677fba5f5b13$var$ti = function(e, t) {
    return t = t || "", $fad8677fba5f5b13$var$N(e, " OPR/") && $fad8677fba5f5b13$var$N(e, "Mini") ? $fad8677fba5f5b13$var$Rt : $fad8677fba5f5b13$var$N(e, " OPR/") ? $fad8677fba5f5b13$var$Ft : $fad8677fba5f5b13$var$Kt.test(e) ? $fad8677fba5f5b13$var$yt : $fad8677fba5f5b13$var$N(e, "IE" + $fad8677fba5f5b13$var$ut) || $fad8677fba5f5b13$var$N(e, "WPDesktop") ? $fad8677fba5f5b13$var$Pt : $fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$wt) ? $fad8677fba5f5b13$var$St : $fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$Tt) || $fad8677fba5f5b13$var$N(e, "Edg/") ? $fad8677fba5f5b13$var$$t : $fad8677fba5f5b13$var$N(e, "FBIOS") ? "Facebook " + $fad8677fba5f5b13$var$ut : $fad8677fba5f5b13$var$N(e, "UCWEB") || $fad8677fba5f5b13$var$N(e, "UCBrowser") ? "UC Browser" : $fad8677fba5f5b13$var$N(e, "CriOS") ? $fad8677fba5f5b13$var$xt : $fad8677fba5f5b13$var$N(e, "CrMo") ? $fad8677fba5f5b13$var$Et : $fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$ht) && $fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$mt) ? $fad8677fba5f5b13$var$Dt : $fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$Et) ? $fad8677fba5f5b13$var$Et : $fad8677fba5f5b13$var$N(e, "FxiOS") ? $fad8677fba5f5b13$var$Mt : $fad8677fba5f5b13$var$N(e.toLowerCase(), $fad8677fba5f5b13$var$Gt.toLowerCase()) ? $fad8677fba5f5b13$var$Gt : $fad8677fba5f5b13$var$ei(e, t) ? $fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$ut) ? $fad8677fba5f5b13$var$Nt : $fad8677fba5f5b13$var$mt : $fad8677fba5f5b13$var$N(e, $fad8677fba5f5b13$var$Ct) ? $fad8677fba5f5b13$var$Ct : $fad8677fba5f5b13$var$N(e, "MSIE") || $fad8677fba5f5b13$var$N(e, "Trident/") ? $fad8677fba5f5b13$var$It : $fad8677fba5f5b13$var$N(e, "Gecko") ? $fad8677fba5f5b13$var$Ct : "";
}, $fad8677fba5f5b13$var$ii = {
    [$fad8677fba5f5b13$var$Pt]: [
        new RegExp("rv:" + $fad8677fba5f5b13$var$jt)
    ],
    [$fad8677fba5f5b13$var$$t]: [
        new RegExp($fad8677fba5f5b13$var$Tt + "?\\/" + $fad8677fba5f5b13$var$jt)
    ],
    [$fad8677fba5f5b13$var$Et]: [
        new RegExp("(" + $fad8677fba5f5b13$var$Et + "|CrMo)\\/" + $fad8677fba5f5b13$var$jt)
    ],
    [$fad8677fba5f5b13$var$xt]: [
        new RegExp("CriOS\\/" + $fad8677fba5f5b13$var$jt)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $fad8677fba5f5b13$var$jt)
    ],
    [$fad8677fba5f5b13$var$mt]: [
        $fad8677fba5f5b13$var$Qt
    ],
    [$fad8677fba5f5b13$var$Nt]: [
        $fad8677fba5f5b13$var$Qt
    ],
    [$fad8677fba5f5b13$var$Ft]: [
        new RegExp("(Opera|OPR)\\/" + $fad8677fba5f5b13$var$jt)
    ],
    [$fad8677fba5f5b13$var$Ct]: [
        new RegExp($fad8677fba5f5b13$var$Ct + "\\/" + $fad8677fba5f5b13$var$jt)
    ],
    [$fad8677fba5f5b13$var$Mt]: [
        new RegExp("FxiOS\\/" + $fad8677fba5f5b13$var$jt)
    ],
    [$fad8677fba5f5b13$var$Gt]: [
        new RegExp("Konqueror[:/]?" + $fad8677fba5f5b13$var$jt, "i")
    ],
    [$fad8677fba5f5b13$var$yt]: [
        new RegExp($fad8677fba5f5b13$var$yt + " " + $fad8677fba5f5b13$var$jt),
        $fad8677fba5f5b13$var$Qt
    ],
    [$fad8677fba5f5b13$var$Dt]: [
        new RegExp("android\\s" + $fad8677fba5f5b13$var$jt, "i")
    ],
    [$fad8677fba5f5b13$var$St]: [
        new RegExp($fad8677fba5f5b13$var$wt + "\\/" + $fad8677fba5f5b13$var$jt)
    ],
    [$fad8677fba5f5b13$var$It]: [
        new RegExp("(rv:|MSIE )" + $fad8677fba5f5b13$var$jt)
    ],
    Mozilla: [
        new RegExp("rv:" + $fad8677fba5f5b13$var$jt)
    ]
}, $fad8677fba5f5b13$var$ni = [
    [
        new RegExp($fad8677fba5f5b13$var$Ot + "; " + $fad8677fba5f5b13$var$Ot + " (.*?)[);]", "i"),
        (e)=>[
                $fad8677fba5f5b13$var$Ot,
                e && e[1] || ""
            ]
    ],
    [
        new RegExp($fad8677fba5f5b13$var$At, "i"),
        [
            $fad8677fba5f5b13$var$At,
            ""
        ]
    ],
    [
        new RegExp($fad8677fba5f5b13$var$Lt, "i"),
        [
            $fad8677fba5f5b13$var$Lt,
            ""
        ]
    ],
    [
        $fad8677fba5f5b13$var$Kt,
        [
            $fad8677fba5f5b13$var$yt,
            ""
        ]
    ],
    [
        new RegExp($fad8677fba5f5b13$var$qt, "i"),
        (e, t)=>{
            if (/Phone/.test(t) || /WPDesktop/.test(t)) return [
                $fad8677fba5f5b13$var$Bt,
                ""
            ];
            if (new RegExp($fad8677fba5f5b13$var$ut).test(t) && !/IEMobile\b/.test(t)) return [
                $fad8677fba5f5b13$var$qt + " " + $fad8677fba5f5b13$var$ut,
                ""
            ];
            const i = /Windows NT ([0-9.]+)/i.exec(t);
            if (i && i[1]) {
                const e = i[1];
                let n = $fad8677fba5f5b13$var$Zt[e] || "";
                return /arm/i.test(t) && (n = "RT"), [
                    $fad8677fba5f5b13$var$qt,
                    n
                ];
            }
            return [
                $fad8677fba5f5b13$var$qt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (e)=>{
            if (e && e[3]) {
                const t = [
                    e[3],
                    e[4],
                    e[5] || "0"
                ];
                return [
                    $fad8677fba5f5b13$var$dt,
                    t.join(".")
                ];
            }
            return [
                $fad8677fba5f5b13$var$dt,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (e)=>{
            let t = "";
            return e && e.length >= 3 && (t = $fad8677fba5f5b13$var$S(e[2]) ? e[3] : e[2]), [
                "watchOS",
                t
            ];
        }
    ],
    [
        new RegExp("(" + $fad8677fba5f5b13$var$ht + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $fad8677fba5f5b13$var$ht + ")", "i"),
        (e)=>{
            if (e && e[2]) {
                const t = [
                    e[2],
                    e[3],
                    e[4] || "0"
                ];
                return [
                    $fad8677fba5f5b13$var$ht,
                    t.join(".")
                ];
            }
            return [
                $fad8677fba5f5b13$var$ht,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (e)=>{
            const t = [
                "Mac OS X",
                ""
            ];
            if (e && e[1]) {
                const i = [
                    e[1],
                    e[2],
                    e[3] || "0"
                ];
                t[1] = i.join(".");
            }
            return t;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $fad8677fba5f5b13$var$kt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $fad8677fba5f5b13$var$si = function(e) {
    return $fad8677fba5f5b13$var$Xt.test(e) ? $fad8677fba5f5b13$var$At : $fad8677fba5f5b13$var$Yt.test(e) ? $fad8677fba5f5b13$var$Lt : $fad8677fba5f5b13$var$Jt.test(e) ? $fad8677fba5f5b13$var$Ot : new RegExp($fad8677fba5f5b13$var$Ut, "i").test(e) ? $fad8677fba5f5b13$var$Ut : new RegExp("(" + $fad8677fba5f5b13$var$Bt + "|WPDesktop)", "i").test(e) ? $fad8677fba5f5b13$var$Bt : /iPad/.test(e) ? $fad8677fba5f5b13$var$gt : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? $fad8677fba5f5b13$var$vt : $fad8677fba5f5b13$var$Kt.test(e) ? $fad8677fba5f5b13$var$yt : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp($fad8677fba5f5b13$var$Ht, "i").test(e) ? $fad8677fba5f5b13$var$Ht : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? !new RegExp($fad8677fba5f5b13$var$ut).test(e) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) ? /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? $fad8677fba5f5b13$var$ht : $fad8677fba5f5b13$var$pt : $fad8677fba5f5b13$var$ht : new RegExp("(pda|" + $fad8677fba5f5b13$var$ut + ")", "i").test(e) ? $fad8677fba5f5b13$var$zt : new RegExp($fad8677fba5f5b13$var$_t, "i").test(e) && !new RegExp($fad8677fba5f5b13$var$_t + " pc", "i").test(e) ? $fad8677fba5f5b13$var$Vt : "";
}, $fad8677fba5f5b13$var$ri = "https?://(.*)", $fad8677fba5f5b13$var$oi = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gad_source",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "mc_cid",
    "igshid",
    "ttclid",
    "rdt_cid"
], $fad8677fba5f5b13$var$ai = {
    campaignParams: function(e) {
        return $fad8677fba5f5b13$var$o ? this._campaignParamsFromUrl($fad8677fba5f5b13$var$o.URL, e) : {};
    },
    _campaignParamsFromUrl: function(e, t) {
        const i = $fad8677fba5f5b13$var$oi.concat(t || []), n = {};
        return $fad8677fba5f5b13$var$O(i, function(t) {
            const i = $fad8677fba5f5b13$var$lt(e, t);
            n[t] = i || null;
        }), n;
    },
    _searchEngine: function(e) {
        return e ? 0 === e.search($fad8677fba5f5b13$var$ri + "google.([^/?]*)") ? "google" : 0 === e.search($fad8677fba5f5b13$var$ri + "bing.com") ? "bing" : 0 === e.search($fad8677fba5f5b13$var$ri + "yahoo.com") ? "yahoo" : 0 === e.search($fad8677fba5f5b13$var$ri + "duckduckgo.com") ? "duckduckgo" : null : null;
    },
    _searchInfoFromReferrer: function(e) {
        const t = $fad8677fba5f5b13$var$ai._searchEngine(e), i = "yahoo" != t ? "q" : "p", n = {};
        if (!$fad8677fba5f5b13$var$x(t)) {
            n.$search_engine = t;
            const e = $fad8677fba5f5b13$var$o ? $fad8677fba5f5b13$var$lt($fad8677fba5f5b13$var$o.referrer, i) : "";
            e.length && (n.ph_keyword = e);
        }
        return n;
    },
    searchInfo: function() {
        const e = null == $fad8677fba5f5b13$var$o ? void 0 : $fad8677fba5f5b13$var$o.referrer;
        return e ? this._searchInfoFromReferrer(e) : {};
    },
    browser: $fad8677fba5f5b13$var$ti,
    browserVersion: function(e, t) {
        const i = $fad8677fba5f5b13$var$ti(e, t), n = $fad8677fba5f5b13$var$ii[i];
        if ($fad8677fba5f5b13$var$S(n)) return null;
        for(let t = 0; t < n.length; t++){
            const i = n[t], s = e.match(i);
            if (s) return parseFloat(s[s.length - 2]);
        }
        return null;
    },
    browserLanguage: function() {
        return navigator.language || navigator.userLanguage;
    },
    os: function(e) {
        for(let t = 0; t < $fad8677fba5f5b13$var$ni.length; t++){
            const [i, n] = $fad8677fba5f5b13$var$ni[t], s = i.exec(e), r = s && ($fad8677fba5f5b13$var$y(n) ? n(s, e) : n);
            if (r) return r;
        }
        return [
            "",
            ""
        ];
    },
    device: $fad8677fba5f5b13$var$si,
    deviceType: function(e) {
        const t = $fad8677fba5f5b13$var$si(e);
        return t === $fad8677fba5f5b13$var$gt || t === $fad8677fba5f5b13$var$pt || "Kobo" === t || "Kindle Fire" === t || t === $fad8677fba5f5b13$var$Vt ? $fad8677fba5f5b13$var$_t : t === $fad8677fba5f5b13$var$At || t === $fad8677fba5f5b13$var$Ot || t === $fad8677fba5f5b13$var$Lt || t === $fad8677fba5f5b13$var$Ut ? "Console" : t === $fad8677fba5f5b13$var$vt ? "Wearable" : t ? $fad8677fba5f5b13$var$ut : "Desktop";
    },
    referrer: function() {
        return (null == $fad8677fba5f5b13$var$o ? void 0 : $fad8677fba5f5b13$var$o.referrer) || "$direct";
    },
    referringDomain: function() {
        var e;
        return null != $fad8677fba5f5b13$var$o && $fad8677fba5f5b13$var$o.referrer && (null === (e = $fad8677fba5f5b13$var$rt($fad8677fba5f5b13$var$o.referrer)) || void 0 === e ? void 0 : e.host) || "$direct";
    },
    referrerInfo: function() {
        return {
            $referrer: this.referrer(),
            $referring_domain: this.referringDomain()
        };
    },
    initialPersonInfo: function() {
        return {
            r: this.referrer(),
            u: null == $fad8677fba5f5b13$var$a ? void 0 : $fad8677fba5f5b13$var$a.href
        };
    },
    initialPersonPropsFromInfo: function(e) {
        var t;
        const { r: i, u: n } = e, s = {
            $initial_referrer: i,
            $initial_referring_domain: null == i ? void 0 : "$direct" == i ? "$direct" : null === (t = $fad8677fba5f5b13$var$rt(i)) || void 0 === t ? void 0 : t.host
        };
        if (n) {
            s.$initial_current_url = n;
            const e = $fad8677fba5f5b13$var$rt(n);
            s.$initial_host = null == e ? void 0 : e.host, s.$initial_pathname = null == e ? void 0 : e.pathname;
            $fad8677fba5f5b13$var$O(this._campaignParamsFromUrl(n), function(e, t) {
                s["$initial_" + $fad8677fba5f5b13$var$W(t)] = e;
            });
        }
        if (i) $fad8677fba5f5b13$var$O(this._searchInfoFromReferrer(i), function(e, t) {
            s["$initial_" + $fad8677fba5f5b13$var$W(t)] = e;
        });
        return s;
    },
    properties: function() {
        if (!$fad8677fba5f5b13$var$d) return {};
        const [t, i] = $fad8677fba5f5b13$var$ai.os($fad8677fba5f5b13$var$d);
        return $fad8677fba5f5b13$var$D($fad8677fba5f5b13$var$U({
            $os: t,
            $os_version: i,
            $browser: $fad8677fba5f5b13$var$ai.browser($fad8677fba5f5b13$var$d, navigator.vendor),
            $device: $fad8677fba5f5b13$var$ai.device($fad8677fba5f5b13$var$d),
            $device_type: $fad8677fba5f5b13$var$ai.deviceType($fad8677fba5f5b13$var$d)
        }), {
            $current_url: null == $fad8677fba5f5b13$var$a ? void 0 : $fad8677fba5f5b13$var$a.href,
            $host: null == $fad8677fba5f5b13$var$a ? void 0 : $fad8677fba5f5b13$var$a.host,
            $pathname: null == $fad8677fba5f5b13$var$a ? void 0 : $fad8677fba5f5b13$var$a.pathname,
            $raw_user_agent: $fad8677fba5f5b13$var$d.length > 1e3 ? $fad8677fba5f5b13$var$d.substring(0, 997) + "..." : $fad8677fba5f5b13$var$d,
            $browser_version: $fad8677fba5f5b13$var$ai.browserVersion($fad8677fba5f5b13$var$d, navigator.vendor),
            $browser_language: $fad8677fba5f5b13$var$ai.browserLanguage(),
            $screen_height: null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.screen.height,
            $screen_width: null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.screen.width,
            $viewport_height: null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.innerHeight,
            $viewport_width: null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.innerWidth,
            $lib: "web",
            $lib_version: $fad8677fba5f5b13$var$_.LIB_VERSION,
            $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
            $time: Date.now() / 1e3
        });
    },
    people_properties: function() {
        if (!$fad8677fba5f5b13$var$d) return {};
        const [e, t] = $fad8677fba5f5b13$var$ai.os($fad8677fba5f5b13$var$d);
        return $fad8677fba5f5b13$var$D($fad8677fba5f5b13$var$U({
            $os: e,
            $os_version: t,
            $browser: $fad8677fba5f5b13$var$ai.browser($fad8677fba5f5b13$var$d, navigator.vendor)
        }), {
            $browser_version: $fad8677fba5f5b13$var$ai.browserVersion($fad8677fba5f5b13$var$d, navigator.vendor)
        });
    }
}, $fad8677fba5f5b13$var$li = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $fad8677fba5f5b13$var$ci {
    constructor(e){
        this.config = e, this.props = {}, this.campaign_params_saved = !1, this.name = ((e)=>{
            let t = "";
            return e.token && (t = e.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), e.persistence_name ? "ph_" + e.persistence_name : "ph_" + t + "_posthog";
        })(e), this.storage = this.buildStorage(e), this.load(), e.debug && $fad8677fba5f5b13$var$$.info("Persistence loaded", e.persistence, {
            ...this.props
        }), this.update_config(e, e), this.save();
    }
    buildStorage(e) {
        let t;
        -1 === $fad8677fba5f5b13$var$li.indexOf(e.persistence.toLowerCase()) && ($fad8677fba5f5b13$var$$.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
        const i = e.persistence.toLowerCase();
        return t = "localstorage" === i && $fad8677fba5f5b13$var$Xe.is_supported() ? $fad8677fba5f5b13$var$Xe : "localstorage+cookie" === i && $fad8677fba5f5b13$var$Ze.is_supported() ? $fad8677fba5f5b13$var$Ze : "sessionstorage" === i && $fad8677fba5f5b13$var$nt.is_supported() ? $fad8677fba5f5b13$var$nt : "memory" === i ? $fad8677fba5f5b13$var$tt : "cookie" === i ? $fad8677fba5f5b13$var$Je : $fad8677fba5f5b13$var$Ze.is_supported() ? $fad8677fba5f5b13$var$Ze : $fad8677fba5f5b13$var$Je, t;
    }
    properties() {
        const e = {};
        return $fad8677fba5f5b13$var$O(this.props, function(t, i) {
            if (i === $fad8677fba5f5b13$var$fe && $fad8677fba5f5b13$var$b(t)) {
                const i = Object.keys(t);
                for(let n = 0; n < i.length; n++)e[`$feature/${i[n]}`] = t[i[n]];
            } else (function(e, t) {
                let i = !1;
                return $fad8677fba5f5b13$var$x(e) ? i : $fad8677fba5f5b13$var$s && e.indexOf === $fad8677fba5f5b13$var$s ? -1 != e.indexOf(t) : ($fad8677fba5f5b13$var$O(e, function(e) {
                    if (i || (i = e === t)) return $fad8677fba5f5b13$var$M;
                }), i);
            })($fad8677fba5f5b13$var$$e, i) || (e[i] = t);
        }), e;
    }
    load() {
        if (this.disabled) return;
        const e = this.storage.parse(this.name);
        e && (this.props = $fad8677fba5f5b13$var$D({}, e));
    }
    save() {
        this.disabled || this.storage.set(this.name, this.props, this.expire_days, this.cross_subdomain, this.secure, this.config.debug);
    }
    remove() {
        this.storage.remove(this.name, !1), this.storage.remove(this.name, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(e, t, i) {
        if ($fad8677fba5f5b13$var$b(e)) {
            $fad8677fba5f5b13$var$S(t) && (t = "None"), this.expire_days = $fad8677fba5f5b13$var$S(i) ? this.default_expiry : i;
            let n = !1;
            if ($fad8677fba5f5b13$var$O(e, (e, i)=>{
                this.props.hasOwnProperty(i) && this.props[i] !== t || (this.props[i] = e, n = !0);
            }), n) return this.save(), !0;
        }
        return !1;
    }
    register(e, t) {
        if ($fad8677fba5f5b13$var$b(e)) {
            this.expire_days = $fad8677fba5f5b13$var$S(t) ? this.default_expiry : t;
            let i = !1;
            if ($fad8677fba5f5b13$var$O(e, (t, n)=>{
                e.hasOwnProperty(n) && this.props[n] !== t && (this.props[n] = t, i = !0);
            }), i) return this.save(), !0;
        }
        return !1;
    }
    unregister(e) {
        e in this.props && (delete this.props[e], this.save());
    }
    update_campaign_params() {
        if (!this.campaign_params_saved) {
            const e = $fad8677fba5f5b13$var$ai.campaignParams(this.config.custom_campaign_params);
            $fad8677fba5f5b13$var$w($fad8677fba5f5b13$var$U(e)) || this.register($fad8677fba5f5b13$var$ai.campaignParams(this.config.custom_campaign_params)), this.campaign_params_saved = !0;
        }
    }
    update_search_keyword() {
        this.register($fad8677fba5f5b13$var$ai.searchInfo());
    }
    update_referrer_info() {
        this.register_once($fad8677fba5f5b13$var$ai.referrerInfo(), void 0);
    }
    set_initial_person_info() {
        this.props[$fad8677fba5f5b13$var$Ie] || this.props[$fad8677fba5f5b13$var$Pe] || this.register_once({
            [$fad8677fba5f5b13$var$Fe]: $fad8677fba5f5b13$var$ai.initialPersonInfo()
        }, void 0);
    }
    get_referrer_info() {
        return $fad8677fba5f5b13$var$U({
            $referrer: this.props.$referrer,
            $referring_domain: this.props.$referring_domain
        });
    }
    get_initial_props() {
        const e = {};
        $fad8677fba5f5b13$var$O([
            $fad8677fba5f5b13$var$Pe,
            $fad8677fba5f5b13$var$Ie
        ], (t)=>{
            const i = this.props[t];
            i && $fad8677fba5f5b13$var$O(i, function(t, i) {
                e["$initial_" + $fad8677fba5f5b13$var$W(i)] = t;
            });
        });
        const t = this.props[$fad8677fba5f5b13$var$Fe];
        if (t) {
            const i = $fad8677fba5f5b13$var$ai.initialPersonPropsFromInfo(t);
            $fad8677fba5f5b13$var$D(e, i);
        }
        return e;
    }
    safe_merge(e) {
        return $fad8677fba5f5b13$var$O(this.props, function(t, i) {
            i in e || (e[i] = t);
        }), e;
    }
    update_config(e, t) {
        if (this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie), e.persistence !== t.persistence) {
            const t = this.buildStorage(e), i = this.props;
            this.clear(), this.storage = t, this.props = i, this.save();
        }
    }
    set_disabled(e) {
        this.disabled = e, this.disabled ? this.remove() : this.save();
    }
    set_cross_subdomain(e) {
        e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
    }
    get_cross_subdomain() {
        return !!this.cross_subdomain;
    }
    set_secure(e) {
        e !== this.secure && (this.secure = e, this.remove(), this.save());
    }
    set_event_timer(e, t) {
        const i = this.props[$fad8677fba5f5b13$var$Z] || {};
        i[e] = t, this.props[$fad8677fba5f5b13$var$Z] = i, this.save();
    }
    remove_event_timer(e) {
        const t = (this.props[$fad8677fba5f5b13$var$Z] || {})[e];
        return $fad8677fba5f5b13$var$S(t) || (delete this.props[$fad8677fba5f5b13$var$Z][e], this.save()), t;
    }
    get_property(e) {
        return this.props[e];
    }
    set_property(e, t) {
        this.props[e] = t, this.save();
    }
}
function $fad8677fba5f5b13$var$ui(e) {
    var t;
    return (null === (t = JSON.stringify(e, function() {
        const e = [];
        return function(t, i) {
            if ($fad8677fba5f5b13$var$b(i)) {
                for(; e.length > 0 && e.at(-1) !== this;)e.pop();
                return e.includes(i) ? "[Circular]" : (e.push(i), i);
            }
            return i;
        };
    }())) || void 0 === t ? void 0 : t.length) || 0;
}
function $fad8677fba5f5b13$var$di(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6606028.8;
    if (e.size >= t && e.data.length > 1) {
        const t = Math.floor(e.data.length / 2), i = e.data.slice(0, t), n = e.data.slice(t);
        return [
            $fad8677fba5f5b13$var$di({
                size: $fad8677fba5f5b13$var$ui(i),
                data: i,
                sessionId: e.sessionId,
                windowId: e.windowId
            }),
            $fad8677fba5f5b13$var$di({
                size: $fad8677fba5f5b13$var$ui(n),
                data: n,
                sessionId: e.sessionId,
                windowId: e.windowId
            })
        ].flatMap((e)=>e);
    }
    return [
        e
    ];
}
var $fad8677fba5f5b13$var$hi = ((e)=>(e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))($fad8677fba5f5b13$var$hi || {}), $fad8677fba5f5b13$var$_i = ((e)=>(e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))($fad8677fba5f5b13$var$_i || {});
function $fad8677fba5f5b13$var$pi(e) {
    return e ? $fad8677fba5f5b13$var$A(e).split(/\s+/) : [];
}
function $fad8677fba5f5b13$var$gi(t) {
    const i = null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.location.href;
    return !!(i && t && t.some((e)=>i.match(e)));
}
function $fad8677fba5f5b13$var$fi(e) {
    let t = "";
    switch(typeof e.className){
        case "string":
            t = e.className;
            break;
        case "object":
            t = (e.className && "baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
            break;
        default:
            t = "";
    }
    return $fad8677fba5f5b13$var$pi(t);
}
function $fad8677fba5f5b13$var$vi(e) {
    return $fad8677fba5f5b13$var$I(e) ? null : $fad8677fba5f5b13$var$A(e).split(/(\s+)/).filter((e)=>$fad8677fba5f5b13$var$Li(e)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $fad8677fba5f5b13$var$mi(e) {
    let t = "";
    return $fad8677fba5f5b13$var$Pi(e) && !$fad8677fba5f5b13$var$Fi(e) && e.childNodes && e.childNodes.length && $fad8677fba5f5b13$var$O(e.childNodes, function(e) {
        var i;
        $fad8677fba5f5b13$var$Si(e) && e.textContent && (t += null !== (i = $fad8677fba5f5b13$var$vi(e.textContent)) && void 0 !== i ? i : "");
    }), $fad8677fba5f5b13$var$A(t);
}
function $fad8677fba5f5b13$var$yi(e) {
    var t;
    return $fad8677fba5f5b13$var$S(e.target) ? e.srcElement || null : null !== (t = e.target) && void 0 !== t && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
}
function $fad8677fba5f5b13$var$bi(e) {
    return !!e && 1 === e.nodeType;
}
function $fad8677fba5f5b13$var$wi(e, t) {
    return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function $fad8677fba5f5b13$var$Si(e) {
    return !!e && 3 === e.nodeType;
}
function $fad8677fba5f5b13$var$Ei(e) {
    return !!e && 11 === e.nodeType;
}
const $fad8677fba5f5b13$var$ki = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $fad8677fba5f5b13$var$xi(e) {
    const t = e.parentNode;
    return !(!t || !$fad8677fba5f5b13$var$bi(t)) && t;
}
function $fad8677fba5f5b13$var$Ii(t, i) {
    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, s = arguments.length > 3 ? arguments[3] : void 0, r = arguments.length > 4 ? arguments[4] : void 0;
    if (!$fad8677fba5f5b13$var$e || !t || $fad8677fba5f5b13$var$wi(t, "html") || !$fad8677fba5f5b13$var$bi(t)) return !1;
    if (null != n && n.url_allowlist && !$fad8677fba5f5b13$var$gi(n.url_allowlist)) return !1;
    if (null != n && n.url_ignorelist && $fad8677fba5f5b13$var$gi(n.url_ignorelist)) return !1;
    if (null != n && n.dom_event_allowlist) {
        const e = n.dom_event_allowlist;
        if (e && !e.some((e)=>i.type === e)) return !1;
    }
    let o = !1;
    const a = [
        t
    ];
    let l = !0, c = t;
    for(; c.parentNode && !$fad8677fba5f5b13$var$wi(c, "body");)if ($fad8677fba5f5b13$var$Ei(c.parentNode)) a.push(c.parentNode.host), c = c.parentNode.host;
    else {
        if (l = $fad8677fba5f5b13$var$xi(c), !l) break;
        if (s || $fad8677fba5f5b13$var$ki.indexOf(l.tagName.toLowerCase()) > -1) o = !0;
        else {
            const t = $fad8677fba5f5b13$var$e.getComputedStyle(l);
            t && "pointer" === t.getPropertyValue("cursor") && (o = !0);
        }
        a.push(l), c = l;
    }
    if (!function(e, t) {
        const i = null == t ? void 0 : t.element_allowlist;
        if ($fad8677fba5f5b13$var$S(i)) return !0;
        for (const t of e)if (i.some((e)=>t.tagName.toLowerCase() === e)) return !0;
        return !1;
    }(a, n)) return !1;
    if (!function(e, t) {
        const i = null == t ? void 0 : t.css_selector_allowlist;
        if ($fad8677fba5f5b13$var$S(i)) return !0;
        for (const t of e)if (i.some((e)=>t.matches(e))) return !0;
        return !1;
    }(a, n)) return !1;
    const u = $fad8677fba5f5b13$var$e.getComputedStyle(t);
    if (u && "pointer" === u.getPropertyValue("cursor") && "click" === i.type) return !0;
    const d = t.tagName.toLowerCase();
    switch(d){
        case "html":
            return !1;
        case "form":
            return (r || [
                "submit"
            ]).indexOf(i.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (r || [
                "change",
                "click"
            ]).indexOf(i.type) >= 0;
        default:
            return o ? (r || [
                "click"
            ]).indexOf(i.type) >= 0 : (r || [
                "click"
            ]).indexOf(i.type) >= 0 && ($fad8677fba5f5b13$var$ki.indexOf(d) > -1 || "true" === t.getAttribute("contenteditable"));
    }
}
function $fad8677fba5f5b13$var$Pi(e) {
    for(let t = e; t.parentNode && !$fad8677fba5f5b13$var$wi(t, "body"); t = t.parentNode){
        const e = $fad8677fba5f5b13$var$fi(t);
        if ($fad8677fba5f5b13$var$N(e, "ph-sensitive") || $fad8677fba5f5b13$var$N(e, "ph-no-capture")) return !1;
    }
    if ($fad8677fba5f5b13$var$N($fad8677fba5f5b13$var$fi(e), "ph-include")) return !0;
    const t = e.type || "";
    if ($fad8677fba5f5b13$var$E(t)) switch(t.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    const i = e.name || e.id || "";
    if ($fad8677fba5f5b13$var$E(i)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(i.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $fad8677fba5f5b13$var$Fi(e) {
    return !!($fad8677fba5f5b13$var$wi(e, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(e.type) || $fad8677fba5f5b13$var$wi(e, "select") || $fad8677fba5f5b13$var$wi(e, "textarea") || "true" === e.getAttribute("contenteditable"));
}
const $fad8677fba5f5b13$var$Ri = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $fad8677fba5f5b13$var$Ti = new RegExp(`^(?:${$fad8677fba5f5b13$var$Ri})$`), $fad8677fba5f5b13$var$$i = new RegExp($fad8677fba5f5b13$var$Ri), $fad8677fba5f5b13$var$Ci = "\\d{3}-?\\d{2}-?\\d{4}", $fad8677fba5f5b13$var$Mi = new RegExp(`^(${$fad8677fba5f5b13$var$Ci})$`), $fad8677fba5f5b13$var$Ai = new RegExp(`(${$fad8677fba5f5b13$var$Ci})`);
function $fad8677fba5f5b13$var$Li(e) {
    let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    if ($fad8677fba5f5b13$var$I(e)) return !1;
    if ($fad8677fba5f5b13$var$E(e)) {
        e = $fad8677fba5f5b13$var$A(e);
        if ((t ? $fad8677fba5f5b13$var$Ti : $fad8677fba5f5b13$var$$i).test((e || "").replace(/[- ]/g, ""))) return !1;
        if ((t ? $fad8677fba5f5b13$var$Mi : $fad8677fba5f5b13$var$Ai).test(e)) return !1;
    }
    return !0;
}
function $fad8677fba5f5b13$var$Oi(e) {
    let t = $fad8677fba5f5b13$var$mi(e);
    return t = `${t} ${$fad8677fba5f5b13$var$Di(e)}`.trim(), $fad8677fba5f5b13$var$Li(t) ? t : "";
}
function $fad8677fba5f5b13$var$Di(e) {
    let t = "";
    return e && e.childNodes && e.childNodes.length && $fad8677fba5f5b13$var$O(e.childNodes, function(e) {
        var i;
        if (e && "span" === (null === (i = e.tagName) || void 0 === i ? void 0 : i.toLowerCase())) try {
            const i = $fad8677fba5f5b13$var$mi(e);
            t = `${t} ${i}`.trim(), e.childNodes && e.childNodes.length && (t = `${t} ${$fad8677fba5f5b13$var$Di(e)}`.trim());
        } catch (e) {
            $fad8677fba5f5b13$var$$.error(e);
        }
    }), t;
}
function $fad8677fba5f5b13$var$Ni(e) {
    return function(e) {
        const t = e.map((e)=>{
            var t, i;
            let n = "";
            if (e.tag_name && (n += e.tag_name), e.attr_class) {
                e.attr_class.sort();
                for (const t of e.attr_class)n += `.${t.replace(/"/g, "")}`;
            }
            const s = {
                ...e.text ? {
                    text: e.text
                } : {},
                "nth-child": null !== (t = e.nth_child) && void 0 !== t ? t : 0,
                "nth-of-type": null !== (i = e.nth_of_type) && void 0 !== i ? i : 0,
                ...e.href ? {
                    href: e.href
                } : {},
                ...e.attr_id ? {
                    attr_id: e.attr_id
                } : {},
                ...e.attributes
            }, r = {};
            return $fad8677fba5f5b13$var$q(s).sort((e, t)=>{
                let [i] = e, [n] = t;
                return i.localeCompare(n);
            }).forEach((e)=>{
                let [t, i] = e;
                return r[$fad8677fba5f5b13$var$qi(t.toString())] = $fad8677fba5f5b13$var$qi(i.toString());
            }), n += ":", n += $fad8677fba5f5b13$var$q(s).map((e)=>{
                let [t, i] = e;
                return `${t}="${i}"`;
            }).join(""), n;
        });
        return t.join(";");
    }(function(e) {
        return e.map((e)=>{
            var t, i;
            const n = {
                text: null === (t = e.$el_text) || void 0 === t ? void 0 : t.slice(0, 400),
                tag_name: e.tag_name,
                href: null === (i = e.attr__href) || void 0 === i ? void 0 : i.slice(0, 2048),
                attr_class: $fad8677fba5f5b13$var$Bi(e),
                attr_id: e.attr__id,
                nth_child: e.nth_child,
                nth_of_type: e.nth_of_type,
                attributes: {}
            };
            return $fad8677fba5f5b13$var$q(e).filter((e)=>{
                let [t] = e;
                return 0 === t.indexOf("attr__");
            }).forEach((e)=>{
                let [t, i] = e;
                return n.attributes[t] = i;
            }), n;
        });
    }(e));
}
function $fad8677fba5f5b13$var$qi(e) {
    return e.replace(/"|\\"/g, '\\"');
}
function $fad8677fba5f5b13$var$Bi(e) {
    const t = e.attr__class;
    return t ? $fad8677fba5f5b13$var$m(t) ? t : $fad8677fba5f5b13$var$pi(t) : void 0;
}
const $fad8677fba5f5b13$var$Hi = "[SessionRecording]", $fad8677fba5f5b13$var$Ui = "redacted", $fad8677fba5f5b13$var$Wi = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: (e)=>e,
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6,
    payloadHostDenyList: [
        ".lr-ingest.io",
        ".ingest.sentry.io"
    ]
}, $fad8677fba5f5b13$var$zi = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $fad8677fba5f5b13$var$Vi = [
    "password",
    "secret",
    "passwd",
    "api_key",
    "apikey",
    "auth",
    "credentials",
    "mysql_pwd",
    "privatekey",
    "private_key",
    "token"
], $fad8677fba5f5b13$var$Gi = [
    "/s/",
    "/e/",
    "/i/"
];
function $fad8677fba5f5b13$var$ji(e, t, i, n) {
    if ($fad8677fba5f5b13$var$I(e)) return e;
    let s = (null == t ? void 0 : t["content-length"]) || function(e) {
        return new Blob([
            e
        ]).size;
    }(e);
    return $fad8677fba5f5b13$var$E(s) && (s = parseInt(s)), s > i ? $fad8677fba5f5b13$var$Hi + ` ${n} body too large to record (${s} bytes)` : e;
}
function $fad8677fba5f5b13$var$Qi(e, t) {
    if ($fad8677fba5f5b13$var$I(e)) return e;
    let i = e;
    return $fad8677fba5f5b13$var$Li(i, !1) || (i = $fad8677fba5f5b13$var$Hi + " " + t + " body " + $fad8677fba5f5b13$var$Ui), $fad8677fba5f5b13$var$O($fad8677fba5f5b13$var$Vi, (e)=>{
        var n, s;
        null !== (n = i) && void 0 !== n && n.length && -1 !== (null === (s = i) || void 0 === s ? void 0 : s.indexOf(e)) && (i = $fad8677fba5f5b13$var$Hi + " " + t + " body " + $fad8677fba5f5b13$var$Ui + " as might contain: " + e);
    }), i;
}
const $fad8677fba5f5b13$var$Ji = (e, t)=>{
    const i = {
        payloadSizeLimitBytes: $fad8677fba5f5b13$var$Wi.payloadSizeLimitBytes,
        performanceEntryTypeToObserve: [
            ...$fad8677fba5f5b13$var$Wi.performanceEntryTypeToObserve
        ],
        payloadHostDenyList: [
            ...t.payloadHostDenyList || [],
            ...$fad8677fba5f5b13$var$Wi.payloadHostDenyList
        ]
    }, n = !1 !== e.session_recording.recordHeaders && t.recordHeaders, s = !1 !== e.session_recording.recordBody && t.recordBody, r = !1 !== e.capture_performance && t.recordPerformance, o = ((e)=>{
        var t;
        const i = Math.min(1e6, null !== (t = e.payloadSizeLimitBytes) && void 0 !== t ? t : 1e6);
        return (e)=>(null != e && e.requestBody && (e.requestBody = $fad8677fba5f5b13$var$ji(e.requestBody, e.requestHeaders, i, "Request")), null != e && e.responseBody && (e.responseBody = $fad8677fba5f5b13$var$ji(e.responseBody, e.responseHeaders, i, "Response")), e);
    })(i), a = (e)=>o(((e)=>{
            const t = $fad8677fba5f5b13$var$rt(e.name);
            if (!(t && t.pathname && $fad8677fba5f5b13$var$Gi.some((e)=>0 === t.pathname.indexOf(e)))) return e;
        })(((e)=>{
            const t = e.requestHeaders;
            return $fad8677fba5f5b13$var$I(t) || $fad8677fba5f5b13$var$O(Object.keys(null != t ? t : {}), (e)=>{
                $fad8677fba5f5b13$var$zi.includes(e.toLowerCase()) && (t[e] = $fad8677fba5f5b13$var$Ui);
            }), e;
        })(e))), l = $fad8677fba5f5b13$var$y(e.session_recording.maskNetworkRequestFn);
    return l && $fad8677fba5f5b13$var$y(e.session_recording.maskCapturedNetworkRequestFn) && $fad8677fba5f5b13$var$$.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), l && (e.session_recording.maskCapturedNetworkRequestFn = (t)=>{
        const i = e.session_recording.maskNetworkRequestFn({
            url: t.name
        });
        return {
            ...t,
            name: null == i ? void 0 : i.url
        };
    }), i.maskRequestFn = $fad8677fba5f5b13$var$y(e.session_recording.maskCapturedNetworkRequestFn) ? (t)=>{
        var i, n, s;
        const r = a(t);
        return r && null !== (i = null === (n = (s = e.session_recording).maskCapturedNetworkRequestFn) || void 0 === n ? void 0 : n.call(s, r)) && void 0 !== i ? i : void 0;
    } : (e)=>(function(e) {
            if (!$fad8677fba5f5b13$var$S(e)) return e.requestBody = $fad8677fba5f5b13$var$Qi(e.requestBody, "Request"), e.responseBody = $fad8677fba5f5b13$var$Qi(e.responseBody, "Response"), e;
        })(a(e)), {
        ...$fad8677fba5f5b13$var$Wi,
        ...i,
        recordHeaders: n,
        recordBody: s,
        recordPerformance: r,
        recordInitialRequests: r
    };
};
class $fad8677fba5f5b13$var$Yi {
    bucketSize = 100;
    refillRate = 10;
    mutationBuckets = {};
    loggedTracker = {};
    constructor(e){
        var t, i;
        let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        this.rrweb = e, this.options = n, this.refillRate = null !== (t = this.options.refillRate) && void 0 !== t ? t : this.refillRate, this.bucketSize = null !== (i = this.options.bucketSize) && void 0 !== i ? i : this.bucketSize, setInterval(()=>{
            this.refillBuckets();
        }, 1e3);
    }
    refillBuckets = ()=>{
        Object.keys(this.mutationBuckets).forEach((e)=>{
            this.mutationBuckets[e] = this.mutationBuckets[e] + this.refillRate, this.mutationBuckets[e] >= this.bucketSize && delete this.mutationBuckets[e];
        });
    };
    getNodeOrRelevantParent = (e)=>{
        const t = this.rrweb.mirror.getNode(e);
        if ("svg" !== (null == t ? void 0 : t.nodeName) && t instanceof Element) {
            const e = t.closest("svg");
            if (e) return [
                this.rrweb.mirror.getId(e),
                e
            ];
        }
        return [
            e,
            t
        ];
    };
    numberOfChanges = (e)=>{
        var t, i, n, s, r, o, a, l;
        return (null !== (t = null === (i = e.removes) || void 0 === i ? void 0 : i.length) && void 0 !== t ? t : 0) + (null !== (n = null === (s = e.attributes) || void 0 === s ? void 0 : s.length) && void 0 !== n ? n : 0) + (null !== (r = null === (o = e.texts) || void 0 === o ? void 0 : o.length) && void 0 !== r ? r : 0) + (null !== (a = null === (l = e.adds) || void 0 === l ? void 0 : l.length) && void 0 !== a ? a : 0);
    };
    throttleMutations = (e)=>{
        if (3 !== e.type || 0 !== e.data.source) return e;
        const t = e.data, i = this.numberOfChanges(t);
        t.attributes && (t.attributes = t.attributes.filter((e)=>{
            var t;
            const [i, n] = this.getNodeOrRelevantParent(e.id);
            if (0 === this.mutationBuckets[i]) return !1;
            var s, r;
            (this.mutationBuckets[i] = null !== (t = this.mutationBuckets[i]) && void 0 !== t ? t : this.bucketSize, this.mutationBuckets[i] = Math.max(this.mutationBuckets[i] - 1, 0), 0 === this.mutationBuckets[i]) && (this.loggedTracker[i] || (this.loggedTracker[i] = !0, null === (s = (r = this.options).onBlockedNode) || void 0 === s || s.call(r, i, n)));
            return e;
        }));
        const n = this.numberOfChanges(t);
        return 0 !== n || i === n ? e : void 0;
    };
}
var $fad8677fba5f5b13$var$Xi = Uint8Array, $fad8677fba5f5b13$var$Ki = Uint16Array, $fad8677fba5f5b13$var$Zi = Uint32Array, $fad8677fba5f5b13$var$en = new $fad8677fba5f5b13$var$Xi([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $fad8677fba5f5b13$var$tn = new $fad8677fba5f5b13$var$Xi([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $fad8677fba5f5b13$var$nn = new $fad8677fba5f5b13$var$Xi([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $fad8677fba5f5b13$var$sn = function(e, t) {
    for(var i = new $fad8677fba5f5b13$var$Ki(31), n = 0; n < 31; ++n)i[n] = t += 1 << e[n - 1];
    var s = new $fad8677fba5f5b13$var$Zi(i[30]);
    for(n = 1; n < 30; ++n)for(var r = i[n]; r < i[n + 1]; ++r)s[r] = r - i[n] << 5 | n;
    return [
        i,
        s
    ];
}, $fad8677fba5f5b13$var$rn = $fad8677fba5f5b13$var$sn($fad8677fba5f5b13$var$en, 2), $fad8677fba5f5b13$var$on = $fad8677fba5f5b13$var$rn[0], $fad8677fba5f5b13$var$an = $fad8677fba5f5b13$var$rn[1];
$fad8677fba5f5b13$var$on[28] = 258, $fad8677fba5f5b13$var$an[258] = 28;
for(var $fad8677fba5f5b13$var$ln = $fad8677fba5f5b13$var$sn($fad8677fba5f5b13$var$tn, 0)[1], $fad8677fba5f5b13$var$cn = new $fad8677fba5f5b13$var$Ki(32768), $fad8677fba5f5b13$var$un = 0; $fad8677fba5f5b13$var$un < 32768; ++$fad8677fba5f5b13$var$un){
    var $fad8677fba5f5b13$var$dn = (43690 & $fad8677fba5f5b13$var$un) >>> 1 | (21845 & $fad8677fba5f5b13$var$un) << 1;
    $fad8677fba5f5b13$var$dn = (61680 & ($fad8677fba5f5b13$var$dn = (52428 & $fad8677fba5f5b13$var$dn) >>> 2 | (13107 & $fad8677fba5f5b13$var$dn) << 2)) >>> 4 | (3855 & $fad8677fba5f5b13$var$dn) << 4, $fad8677fba5f5b13$var$cn[$fad8677fba5f5b13$var$un] = ((65280 & $fad8677fba5f5b13$var$dn) >>> 8 | (255 & $fad8677fba5f5b13$var$dn) << 8) >>> 1;
}
var $fad8677fba5f5b13$var$hn = function(e, t, i) {
    for(var n = e.length, s = 0, r = new $fad8677fba5f5b13$var$Ki(t); s < n; ++s)++r[e[s] - 1];
    var o, a = new $fad8677fba5f5b13$var$Ki(t);
    for(s = 0; s < t; ++s)a[s] = a[s - 1] + r[s - 1] << 1;
    if (i) {
        o = new $fad8677fba5f5b13$var$Ki(1 << t);
        var l = 15 - t;
        for(s = 0; s < n; ++s)if (e[s]) for(var c = s << 4 | e[s], u = t - e[s], d = a[e[s] - 1]++ << u, h = d | (1 << u) - 1; d <= h; ++d)o[$fad8677fba5f5b13$var$cn[d] >>> l] = c;
    } else for(o = new $fad8677fba5f5b13$var$Ki(n), s = 0; s < n; ++s)o[s] = $fad8677fba5f5b13$var$cn[a[e[s] - 1]++] >>> 15 - e[s];
    return o;
}, $fad8677fba5f5b13$var$_n = new $fad8677fba5f5b13$var$Xi(288);
for($fad8677fba5f5b13$var$un = 0; $fad8677fba5f5b13$var$un < 144; ++$fad8677fba5f5b13$var$un)$fad8677fba5f5b13$var$_n[$fad8677fba5f5b13$var$un] = 8;
for($fad8677fba5f5b13$var$un = 144; $fad8677fba5f5b13$var$un < 256; ++$fad8677fba5f5b13$var$un)$fad8677fba5f5b13$var$_n[$fad8677fba5f5b13$var$un] = 9;
for($fad8677fba5f5b13$var$un = 256; $fad8677fba5f5b13$var$un < 280; ++$fad8677fba5f5b13$var$un)$fad8677fba5f5b13$var$_n[$fad8677fba5f5b13$var$un] = 7;
for($fad8677fba5f5b13$var$un = 280; $fad8677fba5f5b13$var$un < 288; ++$fad8677fba5f5b13$var$un)$fad8677fba5f5b13$var$_n[$fad8677fba5f5b13$var$un] = 8;
var $fad8677fba5f5b13$var$pn = new $fad8677fba5f5b13$var$Xi(32);
for($fad8677fba5f5b13$var$un = 0; $fad8677fba5f5b13$var$un < 32; ++$fad8677fba5f5b13$var$un)$fad8677fba5f5b13$var$pn[$fad8677fba5f5b13$var$un] = 5;
var $fad8677fba5f5b13$var$gn = $fad8677fba5f5b13$var$hn($fad8677fba5f5b13$var$_n, 9, 0), $fad8677fba5f5b13$var$fn = $fad8677fba5f5b13$var$hn($fad8677fba5f5b13$var$pn, 5, 0), $fad8677fba5f5b13$var$vn = function(e) {
    return (e / 8 >> 0) + (7 & e && 1);
}, $fad8677fba5f5b13$var$mn = function(e, t, i) {
    (null == i || i > e.length) && (i = e.length);
    var n = new (e instanceof $fad8677fba5f5b13$var$Ki ? $fad8677fba5f5b13$var$Ki : e instanceof $fad8677fba5f5b13$var$Zi ? $fad8677fba5f5b13$var$Zi : $fad8677fba5f5b13$var$Xi)(i - t);
    return n.set(e.subarray(t, i)), n;
}, $fad8677fba5f5b13$var$yn = function(e, t, i) {
    i <<= 7 & t;
    var n = t / 8 >> 0;
    e[n] |= i, e[n + 1] |= i >>> 8;
}, $fad8677fba5f5b13$var$bn = function(e, t, i) {
    i <<= 7 & t;
    var n = t / 8 >> 0;
    e[n] |= i, e[n + 1] |= i >>> 8, e[n + 2] |= i >>> 16;
}, $fad8677fba5f5b13$var$wn = function(e, t) {
    for(var i = [], n = 0; n < e.length; ++n)e[n] && i.push({
        s: n,
        f: e[n]
    });
    var s = i.length, r = i.slice();
    if (!s) return [
        new $fad8677fba5f5b13$var$Xi(0),
        0
    ];
    if (1 == s) {
        var o = new $fad8677fba5f5b13$var$Xi(i[0].s + 1);
        return o[i[0].s] = 1, [
            o,
            1
        ];
    }
    i.sort(function(e, t) {
        return e.f - t.f;
    }), i.push({
        s: -1,
        f: 25001
    });
    var a = i[0], l = i[1], c = 0, u = 1, d = 2;
    for(i[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; u != s - 1;)a = i[i[c].f < i[d].f ? c++ : d++], l = i[c != u && i[c].f < i[d].f ? c++ : d++], i[u++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var h = r[0].s;
    for(n = 1; n < s; ++n)r[n].s > h && (h = r[n].s);
    var _ = new $fad8677fba5f5b13$var$Ki(h + 1), p = $fad8677fba5f5b13$var$Sn(i[u - 1], _, 0);
    if (p > t) {
        n = 0;
        var g = 0, f = p - t, v = 1 << f;
        for(r.sort(function(e, t) {
            return _[t.s] - _[e.s] || e.f - t.f;
        }); n < s; ++n){
            var m = r[n].s;
            if (!(_[m] > t)) break;
            g += v - (1 << p - _[m]), _[m] = t;
        }
        for(g >>>= f; g > 0;){
            var y = r[n].s;
            _[y] < t ? g -= 1 << t - _[y]++ - 1 : ++n;
        }
        for(; n >= 0 && g; --n){
            var b = r[n].s;
            _[b] == t && (--_[b], ++g);
        }
        p = t;
    }
    return [
        new $fad8677fba5f5b13$var$Xi(_),
        p
    ];
}, $fad8677fba5f5b13$var$Sn = function(e, t, i) {
    return -1 == e.s ? Math.max($fad8677fba5f5b13$var$Sn(e.l, t, i + 1), $fad8677fba5f5b13$var$Sn(e.r, t, i + 1)) : t[e.s] = i;
}, $fad8677fba5f5b13$var$En = function(e) {
    for(var t = e.length; t && !e[--t];);
    for(var i = new $fad8677fba5f5b13$var$Ki(++t), n = 0, s = e[0], r = 1, o = function(e) {
        i[n++] = e;
    }, a = 1; a <= t; ++a)if (e[a] == s && a != t) ++r;
    else {
        if (!s && r > 2) {
            for(; r > 138; r -= 138)o(32754);
            r > 2 && (o(r > 10 ? r - 11 << 5 | 28690 : r - 3 << 5 | 12305), r = 0);
        } else if (r > 3) {
            for(o(s), --r; r > 6; r -= 6)o(8304);
            r > 2 && (o(r - 3 << 5 | 8208), r = 0);
        }
        for(; r--;)o(s);
        r = 1, s = e[a];
    }
    return [
        i.subarray(0, n),
        t
    ];
}, $fad8677fba5f5b13$var$kn = function(e, t) {
    for(var i = 0, n = 0; n < t.length; ++n)i += e[n] * t[n];
    return i;
}, $fad8677fba5f5b13$var$xn = function(e, t, i) {
    var n = i.length, s = $fad8677fba5f5b13$var$vn(t + 2);
    e[s] = 255 & n, e[s + 1] = n >>> 8, e[s + 2] = 255 ^ e[s], e[s + 3] = 255 ^ e[s + 1];
    for(var r = 0; r < n; ++r)e[s + r + 4] = i[r];
    return 8 * (s + 4 + n);
}, $fad8677fba5f5b13$var$In = function(e, t, i, n, s, r, o, a, l, c, u) {
    $fad8677fba5f5b13$var$yn(t, u++, i), ++s[256];
    for(var d = $fad8677fba5f5b13$var$wn(s, 15), h = d[0], _ = d[1], p = $fad8677fba5f5b13$var$wn(r, 15), g = p[0], f = p[1], v = $fad8677fba5f5b13$var$En(h), m = v[0], y = v[1], b = $fad8677fba5f5b13$var$En(g), w = b[0], S = b[1], E = new $fad8677fba5f5b13$var$Ki(19), k = 0; k < m.length; ++k)E[31 & m[k]]++;
    for(k = 0; k < w.length; ++k)E[31 & w[k]]++;
    for(var x = $fad8677fba5f5b13$var$wn(E, 7), I = x[0], P = x[1], F = 19; F > 4 && !I[$fad8677fba5f5b13$var$nn[F - 1]]; --F);
    var R, T, $, C, M = c + 5 << 3, A = $fad8677fba5f5b13$var$kn(s, $fad8677fba5f5b13$var$_n) + $fad8677fba5f5b13$var$kn(r, $fad8677fba5f5b13$var$pn) + o, L = $fad8677fba5f5b13$var$kn(s, h) + $fad8677fba5f5b13$var$kn(r, g) + o + 14 + 3 * F + $fad8677fba5f5b13$var$kn(E, I) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
    if (M <= A && M <= L) return $fad8677fba5f5b13$var$xn(t, u, e.subarray(l, l + c));
    if ($fad8677fba5f5b13$var$yn(t, u, 1 + (L < A)), u += 2, L < A) {
        R = $fad8677fba5f5b13$var$hn(h, _, 0), T = h, $ = $fad8677fba5f5b13$var$hn(g, f, 0), C = g;
        var O = $fad8677fba5f5b13$var$hn(I, P, 0);
        $fad8677fba5f5b13$var$yn(t, u, y - 257), $fad8677fba5f5b13$var$yn(t, u + 5, S - 1), $fad8677fba5f5b13$var$yn(t, u + 10, F - 4), u += 14;
        for(k = 0; k < F; ++k)$fad8677fba5f5b13$var$yn(t, u + 3 * k, I[$fad8677fba5f5b13$var$nn[k]]);
        u += 3 * F;
        for(var D = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var q = D[N];
            for(k = 0; k < q.length; ++k){
                var B = 31 & q[k];
                $fad8677fba5f5b13$var$yn(t, u, O[B]), u += I[B], B > 15 && ($fad8677fba5f5b13$var$yn(t, u, q[k] >>> 5 & 127), u += q[k] >>> 12);
            }
        }
    } else R = $fad8677fba5f5b13$var$gn, T = $fad8677fba5f5b13$var$_n, $ = $fad8677fba5f5b13$var$fn, C = $fad8677fba5f5b13$var$pn;
    for(k = 0; k < a; ++k)if (n[k] > 255) {
        B = n[k] >>> 18 & 31;
        $fad8677fba5f5b13$var$bn(t, u, R[B + 257]), u += T[B + 257], B > 7 && ($fad8677fba5f5b13$var$yn(t, u, n[k] >>> 23 & 31), u += $fad8677fba5f5b13$var$en[B]);
        var H = 31 & n[k];
        $fad8677fba5f5b13$var$bn(t, u, $[H]), u += C[H], H > 3 && ($fad8677fba5f5b13$var$bn(t, u, n[k] >>> 5 & 8191), u += $fad8677fba5f5b13$var$tn[H]);
    } else $fad8677fba5f5b13$var$bn(t, u, R[n[k]]), u += T[n[k]];
    return $fad8677fba5f5b13$var$bn(t, u, R[256]), u + T[256];
}, $fad8677fba5f5b13$var$Pn = new $fad8677fba5f5b13$var$Zi([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $fad8677fba5f5b13$var$Fn = function() {
    for(var e = new $fad8677fba5f5b13$var$Zi(256), t = 0; t < 256; ++t){
        for(var i = t, n = 9; --n;)i = (1 & i && 3988292384) ^ i >>> 1;
        e[t] = i;
    }
    return e;
}(), $fad8677fba5f5b13$var$Rn = function() {
    var e = 4294967295;
    return {
        p: function(t) {
            for(var i = e, n = 0; n < t.length; ++n)i = $fad8677fba5f5b13$var$Fn[255 & i ^ t[n]] ^ i >>> 8;
            e = i;
        },
        d: function() {
            return 4294967295 ^ e;
        }
    };
}, $fad8677fba5f5b13$var$Tn = function(e, t, i, n, s) {
    return function(e, t, i, n, s, r) {
        var o = e.length, a = new $fad8677fba5f5b13$var$Xi(n + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(n, a.length - s), c = 0;
        if (!t || o < 8) for(var u = 0; u <= o; u += 65535){
            var d = u + 65535;
            d < o ? c = $fad8677fba5f5b13$var$xn(l, c, e.subarray(u, d)) : (l[u] = r, c = $fad8677fba5f5b13$var$xn(l, c, e.subarray(u, o)));
        }
        else {
            for(var h = $fad8677fba5f5b13$var$Pn[t - 1], _ = h >>> 13, p = 8191 & h, g = (1 << i) - 1, f = new $fad8677fba5f5b13$var$Ki(32768), v = new $fad8677fba5f5b13$var$Ki(g + 1), m = Math.ceil(i / 3), y = 2 * m, b = function(t) {
                return (e[t] ^ e[t + 1] << m ^ e[t + 2] << y) & g;
            }, w = new $fad8677fba5f5b13$var$Zi(25e3), S = new $fad8677fba5f5b13$var$Ki(288), E = new $fad8677fba5f5b13$var$Ki(32), k = 0, x = 0, I = (u = 0, 0), P = 0, F = 0; u < o; ++u){
                var R = b(u), T = 32767 & u, $ = v[R];
                if (f[T] = $, v[R] = T, P <= u) {
                    var C = o - u;
                    if ((k > 7e3 || I > 24576) && C > 423) {
                        c = $fad8677fba5f5b13$var$In(e, l, 0, w, S, E, x, I, F, u - F, c), I = k = x = 0, F = u;
                        for(var M = 0; M < 286; ++M)S[M] = 0;
                        for(M = 0; M < 30; ++M)E[M] = 0;
                    }
                    var A = 2, L = 0, O = p, D = T - $ & 32767;
                    if (C > 2 && R == b(u - D)) for(var N = Math.min(_, C) - 1, q = Math.min(32767, u), B = Math.min(258, C); D <= q && --O && T != $;){
                        if (e[u + A] == e[u + A - D]) {
                            for(var H = 0; H < B && e[u + H] == e[u + H - D]; ++H);
                            if (H > A) {
                                if (A = H, L = D, H > N) break;
                                var U = Math.min(D, H - 2), W = 0;
                                for(M = 0; M < U; ++M){
                                    var z = u - D + M + 32768 & 32767, V = z - f[z] + 32768 & 32767;
                                    V > W && (W = V, $ = z);
                                }
                            }
                        }
                        D += (T = $) - ($ = f[T]) + 32768 & 32767;
                    }
                    if (L) {
                        w[I++] = 268435456 | $fad8677fba5f5b13$var$an[A] << 18 | $fad8677fba5f5b13$var$ln[L];
                        var G = 31 & $fad8677fba5f5b13$var$an[A], j = 31 & $fad8677fba5f5b13$var$ln[L];
                        x += $fad8677fba5f5b13$var$en[G] + $fad8677fba5f5b13$var$tn[j], ++S[257 + G], ++E[j], P = u + A, ++k;
                    } else w[I++] = e[u], ++S[e[u]];
                }
            }
            c = $fad8677fba5f5b13$var$In(e, l, r, w, S, E, x, I, F, u - F, c);
        }
        return $fad8677fba5f5b13$var$mn(a, 0, n + $fad8677fba5f5b13$var$vn(c) + s);
    }(e, null == t.level ? 6 : t.level, null == t.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, i, n, !s);
}, $fad8677fba5f5b13$var$$n = function(e, t, i) {
    for(; i; ++t)e[t] = i, i >>>= 8;
}, $fad8677fba5f5b13$var$Cn = function(e, t) {
    var i = t.filename;
    if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : 9 == t.level ? 2 : 0, e[9] = 3, 0 != t.mtime && $fad8677fba5f5b13$var$$n(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), i) {
        e[3] = 8;
        for(var n = 0; n <= i.length; ++n)e[n + 10] = i.charCodeAt(n);
    }
}, $fad8677fba5f5b13$var$Mn = function(e) {
    return 10 + (e.filename && e.filename.length + 1 || 0);
};
function $fad8677fba5f5b13$var$An(e, t) {
    void 0 === t && (t = {});
    var i = $fad8677fba5f5b13$var$Rn(), n = e.length;
    i.p(e);
    var s = $fad8677fba5f5b13$var$Tn(e, t, $fad8677fba5f5b13$var$Mn(t), 8), r = s.length;
    return $fad8677fba5f5b13$var$Cn(s, t), $fad8677fba5f5b13$var$$n(s, r - 8, i.d()), $fad8677fba5f5b13$var$$n(s, r - 4, n), s;
}
function $fad8677fba5f5b13$var$Ln(e, t) {
    var i = e.length;
    if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(e);
    for(var n = new $fad8677fba5f5b13$var$Xi(e.length + (e.length >>> 1)), s = 0, r = function(e) {
        n[s++] = e;
    }, o = 0; o < i; ++o){
        if (s + 5 > n.length) {
            var a = new $fad8677fba5f5b13$var$Xi(s + 8 + (i - o << 1));
            a.set(n), n = a;
        }
        var l = e.charCodeAt(o);
        l < 128 || t ? r(l) : l < 2048 ? (r(192 | l >>> 6), r(128 | 63 & l)) : l > 55295 && l < 57344 ? (r(240 | (l = 65536 + (1047552 & l) | 1023 & e.charCodeAt(++o)) >>> 18), r(128 | l >>> 12 & 63), r(128 | l >>> 6 & 63), r(128 | 63 & l)) : (r(224 | l >>> 12), r(128 | l >>> 6 & 63), r(128 | 63 & l));
    }
    return $fad8677fba5f5b13$var$mn(n, 0, s);
}
function $fad8677fba5f5b13$var$On(e, t, i, n) {
    return t > i && ($fad8677fba5f5b13$var$$.warn("min cannot be greater than max."), t = i), $fad8677fba5f5b13$var$P(e) ? e > i ? (n && $fad8677fba5f5b13$var$$.warn(n + " cannot be  greater than max: " + i + ". Using max value instead."), i) : e < t ? (n && $fad8677fba5f5b13$var$$.warn(n + " cannot be less than min: " + t + ". Using min value instead."), t) : e : (n && $fad8677fba5f5b13$var$$.warn(n + " must be a number. Defaulting to max value:" + i), i);
}
const $fad8677fba5f5b13$var$Dn = 3e5, $fad8677fba5f5b13$var$Nn = [
    $fad8677fba5f5b13$var$_i.MouseMove,
    $fad8677fba5f5b13$var$_i.MouseInteraction,
    $fad8677fba5f5b13$var$_i.Scroll,
    $fad8677fba5f5b13$var$_i.ViewportResize,
    $fad8677fba5f5b13$var$_i.Input,
    $fad8677fba5f5b13$var$_i.TouchMove,
    $fad8677fba5f5b13$var$_i.MediaInteraction,
    $fad8677fba5f5b13$var$_i.Drag
], $fad8677fba5f5b13$var$qn = [
    "trigger_activated",
    "trigger_pending",
    "trigger_disabled"
], $fad8677fba5f5b13$var$Bn = (e)=>({
        rrwebMethod: e,
        enqueuedAt: Date.now(),
        attempt: 1
    }), $fad8677fba5f5b13$var$Hn = "[SessionRecording]";
function $fad8677fba5f5b13$var$Un(e) {
    return function(e, t) {
        for(var i = "", n = 0; n < e.length;){
            var s = e[n++];
            s < 128 || t ? i += String.fromCharCode(s) : s < 224 ? i += String.fromCharCode((31 & s) << 6 | 63 & e[n++]) : s < 240 ? i += String.fromCharCode((15 & s) << 12 | (63 & e[n++]) << 6 | 63 & e[n++]) : (s = ((15 & s) << 18 | (63 & e[n++]) << 12 | (63 & e[n++]) << 6 | 63 & e[n++]) - 65536, i += String.fromCharCode(55296 | s >> 10, 56320 | 1023 & s));
        }
        return i;
    }($fad8677fba5f5b13$var$An($fad8677fba5f5b13$var$Ln(JSON.stringify(e))), !0);
}
function $fad8677fba5f5b13$var$Wn(e) {
    return e.type === $fad8677fba5f5b13$var$hi.Custom && "sessionIdle" === e.data.tag;
}
class $fad8677fba5f5b13$var$zn {
    queuedRRWebEvents = [];
    isIdle = !1;
    _linkedFlagSeen = !1;
    _lastActivityTimestamp = Date.now();
    _linkedFlag = null;
    _removePageViewCaptureHook = void 0;
    _onSessionIdListener = void 0;
    _persistDecideOnSessionListener = void 0;
    _samplingSessionListener = void 0;
    _urlTriggers = [];
    _forceAllowLocalhostNetworkCapture = !1;
    get sessionIdleThresholdMilliseconds() {
        return this.instance.config.session_recording.session_idle_threshold_ms || 3e5;
    }
    get rrwebRecord() {
        var e, t;
        return null == $fad8677fba5f5b13$var$h || null === (e = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === e || null === (t = e.rrweb) || void 0 === t ? void 0 : t.record;
    }
    get started() {
        return this._captureStarted;
    }
    get sessionManager() {
        if (!this.instance.sessionManager) throw new Error($fad8677fba5f5b13$var$Hn + " must be started with a valid sessionManager.");
        return this.instance.sessionManager;
    }
    get fullSnapshotIntervalMillis() {
        var e, t;
        return "trigger_pending" === this.urlTriggerStatus ? 6e4 : null !== (e = null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.full_snapshot_interval_millis) && void 0 !== e ? e : $fad8677fba5f5b13$var$Dn;
    }
    get isSampled() {
        const e = this.instance.get_property($fad8677fba5f5b13$var$_e);
        return $fad8677fba5f5b13$var$F(e) ? e : null;
    }
    get sessionDuration() {
        var e, t;
        const i = null === (e = this.buffer) || void 0 === e ? void 0 : e.data[(null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) - 1], { sessionStartTimestamp: n } = this.sessionManager.checkAndGetSessionAndWindowId(!0);
        return i ? i.timestamp - n : null;
    }
    get isRecordingEnabled() {
        const t = !!this.instance.get_property($fad8677fba5f5b13$var$oe), i = !this.instance.config.disable_session_recording;
        return $fad8677fba5f5b13$var$e && t && i;
    }
    get isConsoleLogCaptureEnabled() {
        const e = !!this.instance.get_property($fad8677fba5f5b13$var$ae), t = this.instance.config.enable_recording_console_log;
        return null != t ? t : e;
    }
    get canvasRecording() {
        var e, t, i, n, s, r;
        const o = this.instance.config.session_recording.captureCanvas, a = this.instance.get_property($fad8677fba5f5b13$var$ce), l = null !== (e = null !== (t = null == o ? void 0 : o.recordCanvas) && void 0 !== t ? t : null == a ? void 0 : a.enabled) && void 0 !== e && e, c = null !== (i = null !== (n = null == o ? void 0 : o.canvasFps) && void 0 !== n ? n : null == a ? void 0 : a.fps) && void 0 !== i ? i : 0, u = null !== (s = null !== (r = null == o ? void 0 : o.canvasQuality) && void 0 !== r ? r : null == a ? void 0 : a.quality) && void 0 !== s ? s : 0;
        return {
            enabled: l,
            fps: $fad8677fba5f5b13$var$On(c, 0, 12, "canvas recording fps"),
            quality: $fad8677fba5f5b13$var$On(u, 0, 1, "canvas recording quality")
        };
    }
    get networkPayloadCapture() {
        var e, t;
        const i = this.instance.get_property($fad8677fba5f5b13$var$le), n = {
            recordHeaders: null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recordHeaders,
            recordBody: null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.recordBody
        }, s = (null == n ? void 0 : n.recordHeaders) || (null == i ? void 0 : i.recordHeaders), r = (null == n ? void 0 : n.recordBody) || (null == i ? void 0 : i.recordBody), o = $fad8677fba5f5b13$var$b(this.instance.config.capture_performance) ? this.instance.config.capture_performance.network_timing : this.instance.config.capture_performance, a = !!($fad8677fba5f5b13$var$F(o) ? o : null == i ? void 0 : i.capturePerformance);
        return s || r || a ? {
            recordHeaders: s,
            recordBody: r,
            recordPerformance: a
        } : void 0;
    }
    get sampleRate() {
        const e = this.instance.get_property($fad8677fba5f5b13$var$ue);
        return $fad8677fba5f5b13$var$P(e) ? e : null;
    }
    get minimumDuration() {
        const e = this.instance.get_property($fad8677fba5f5b13$var$de);
        return $fad8677fba5f5b13$var$P(e) ? e : null;
    }
    get status() {
        return this.receivedDecide ? this.isRecordingEnabled ? $fad8677fba5f5b13$var$I(this._linkedFlag) || this._linkedFlagSeen ? "trigger_pending" === this.urlTriggerStatus ? "buffering" : $fad8677fba5f5b13$var$F(this.isSampled) ? this.isSampled ? "sampled" : "disabled" : "active" : "buffering" : "disabled" : "buffering";
    }
    get urlTriggerStatus() {
        var e, t;
        if (this.receivedDecide && 0 === this._urlTriggers.length) return "trigger_disabled";
        const i = null === (e = this.instance) || void 0 === e ? void 0 : e.get_property($fad8677fba5f5b13$var$ge);
        var n, s, r, o;
        return (null === (t = this.instance) || void 0 === t ? void 0 : t.get_property($fad8677fba5f5b13$var$pe)) !== this.sessionId ? (null === (n = this.instance) || void 0 === n || null === (s = n.persistence) || void 0 === s || s.unregister($fad8677fba5f5b13$var$pe), null === (r = this.instance) || void 0 === r || null === (o = r.persistence) || void 0 === o || o.unregister($fad8677fba5f5b13$var$ge), "trigger_pending") : $fad8677fba5f5b13$var$qn.includes(i) ? i : "trigger_pending";
    }
    set urlTriggerStatus(e) {
        var t, i;
        null === (t = this.instance) || void 0 === t || null === (i = t.persistence) || void 0 === i || i.register({
            [$fad8677fba5f5b13$var$pe]: this.sessionId,
            [$fad8677fba5f5b13$var$ge]: e
        });
    }
    constructor(e){
        if (this.instance = e, this._captureStarted = !1, this._endpoint = "/s/", this.stopRrweb = void 0, this.receivedDecide = !1, !this.instance.sessionManager) throw $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$Hn + " started without valid sessionManager"), new Error($fad8677fba5f5b13$var$Hn + " started without valid sessionManager. This is a bug.");
        const { sessionId: t, windowId: i } = this.sessionManager.checkAndGetSessionAndWindowId();
        this.sessionId = t, this.windowId = i, this.buffer = this.clearBuffer(), this.sessionIdleThresholdMilliseconds >= this.sessionManager.sessionTimeoutMs && $fad8677fba5f5b13$var$$.warn($fad8677fba5f5b13$var$Hn + ` session_idle_threshold_ms (${this.sessionIdleThresholdMilliseconds}) is greater than the session timeout (${this.sessionManager.sessionTimeoutMs}). Session will never be detected as idle`);
    }
    _onBeforeUnload = ()=>{
        this._flushBuffer();
    };
    _onOffline = ()=>{
        this._tryAddCustomEvent("browser offline", {});
    };
    _onOnline = ()=>{
        this._tryAddCustomEvent("browser online", {});
    };
    _onVisibilityChange = ()=>{
        if (null != $fad8677fba5f5b13$var$o && $fad8677fba5f5b13$var$o.visibilityState) {
            const e = "window " + $fad8677fba5f5b13$var$o.visibilityState;
            this._tryAddCustomEvent(e, {});
        }
    };
    startIfEnabledOrStop(t) {
        this.isRecordingEnabled ? (this._startCapture(t), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("beforeunload", this._onBeforeUnload), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("offline", this._onOffline), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("online", this._onOnline), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("visibilitychange", this._onVisibilityChange), this._setupSampling(), $fad8677fba5f5b13$var$I(this._removePageViewCaptureHook) && (this._removePageViewCaptureHook = this.instance._addCaptureHook((t)=>{
            try {
                if ("$pageview" === t) {
                    const t = $fad8677fba5f5b13$var$e ? this._maskUrl($fad8677fba5f5b13$var$e.location.href) : "";
                    if (!t) return;
                    this._tryAddCustomEvent("$pageview", {
                        href: t
                    });
                }
            } catch (e) {
                $fad8677fba5f5b13$var$$.error("Could not add $pageview to rrweb session", e);
            }
        })), this._onSessionIdListener || (this._onSessionIdListener = this.sessionManager.onSessionId((e, t, i)=>{
            var n, s, r, o;
            i && (this._tryAddCustomEvent("$session_id_change", {
                sessionId: e,
                windowId: t,
                changeReason: i
            }), null === (n = this.instance) || void 0 === n || null === (s = n.persistence) || void 0 === s || s.unregister($fad8677fba5f5b13$var$pe), null === (r = this.instance) || void 0 === r || null === (o = r.persistence) || void 0 === o || o.unregister($fad8677fba5f5b13$var$ge));
        }))) : this.stopRecording();
    }
    stopRecording() {
        var t, i, n;
        this._captureStarted && this.stopRrweb && (this.stopRrweb(), this.stopRrweb = void 0, this._captureStarted = !1, null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.removeEventListener("beforeunload", this._onBeforeUnload), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.removeEventListener("offline", this._onOffline), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.removeEventListener("online", this._onOnline), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.removeEventListener("visibilitychange", this._onVisibilityChange), this.clearBuffer(), clearInterval(this._fullSnapshotTimer), null === (t = this._removePageViewCaptureHook) || void 0 === t || t.call(this), this._removePageViewCaptureHook = void 0, null === (i = this._onSessionIdListener) || void 0 === i || i.call(this), this._onSessionIdListener = void 0, null === (n = this._samplingSessionListener) || void 0 === n || n.call(this), this._samplingSessionListener = void 0, $fad8677fba5f5b13$var$$.info($fad8677fba5f5b13$var$Hn + " stopped"));
    }
    makeSamplingDecision(e) {
        var t;
        const i = this.sessionId !== e, n = this.sampleRate;
        var s;
        if (!$fad8677fba5f5b13$var$P(n)) return void (null === (s = this.instance.persistence) || void 0 === s || s.register({
            [$fad8677fba5f5b13$var$_e]: null
        }));
        const r = this.isSampled;
        let o;
        const a = i || !$fad8677fba5f5b13$var$F(r);
        if (a) o = Math.random() < n;
        else o = r;
        a && (o ? this._reportStarted("sampling") : $fad8677fba5f5b13$var$$.warn($fad8677fba5f5b13$var$Hn + ` Sample rate (${n}) has determined that this sessionId (${e}) will not be sent to the server.`), this._tryAddCustomEvent("samplingDecisionMade", {
            sampleRate: n,
            isSampled: o
        })), null === (t = this.instance.persistence) || void 0 === t || t.register({
            [$fad8677fba5f5b13$var$_e]: o
        });
    }
    afterDecideResponse(e) {
        var t, i, n, s;
        (this._persistDecideResponse(e), this._linkedFlag = (null === (t = e.sessionRecording) || void 0 === t ? void 0 : t.linkedFlag) || null, null !== (i = e.sessionRecording) && void 0 !== i && i.endpoint) && (this._endpoint = null === (s = e.sessionRecording) || void 0 === s ? void 0 : s.endpoint);
        if (this._setupSampling(), !$fad8677fba5f5b13$var$I(this._linkedFlag) && !this._linkedFlagSeen) {
            const e = $fad8677fba5f5b13$var$E(this._linkedFlag) ? this._linkedFlag : this._linkedFlag.flag, t = $fad8677fba5f5b13$var$E(this._linkedFlag) ? null : this._linkedFlag.variant;
            this.instance.onFeatureFlags((i, n)=>{
                const s = $fad8677fba5f5b13$var$b(n) && e in n, r = t ? n[e] === t : s;
                if (r) {
                    const i = {
                        linkedFlag: e,
                        linkedVariant: t
                    }, n = "linked flag matched";
                    $fad8677fba5f5b13$var$$.info($fad8677fba5f5b13$var$Hn + " " + n, i), this._tryAddCustomEvent(n, i), this._reportStarted("linked_flag_match");
                }
                this._linkedFlagSeen = r;
            });
        }
        null !== (n = e.sessionRecording) && void 0 !== n && n.urlTriggers && (this._urlTriggers = e.sessionRecording.urlTriggers), this.receivedDecide = !0, this.startIfEnabledOrStop();
    }
    _setupSampling() {
        $fad8677fba5f5b13$var$P(this.sampleRate) && $fad8677fba5f5b13$var$I(this._samplingSessionListener) && (this._samplingSessionListener = this.sessionManager.onSessionId((e)=>{
            this.makeSamplingDecision(e);
        }));
    }
    _persistDecideResponse(e) {
        if (this.instance.persistence) {
            var t;
            const i = this.instance.persistence, n = ()=>{
                var t, n, s, r, o, a, l;
                const c = null === (t = e.sessionRecording) || void 0 === t ? void 0 : t.sampleRate, u = $fad8677fba5f5b13$var$I(c) ? null : parseFloat(c), d = null === (n = e.sessionRecording) || void 0 === n ? void 0 : n.minimumDurationMilliseconds;
                i.register({
                    [$fad8677fba5f5b13$var$oe]: !!e.sessionRecording,
                    [$fad8677fba5f5b13$var$ae]: null === (s = e.sessionRecording) || void 0 === s ? void 0 : s.consoleLogRecordingEnabled,
                    [$fad8677fba5f5b13$var$le]: {
                        capturePerformance: e.capturePerformance,
                        ...null === (r = e.sessionRecording) || void 0 === r ? void 0 : r.networkPayloadCapture
                    },
                    [$fad8677fba5f5b13$var$ce]: {
                        enabled: null === (o = e.sessionRecording) || void 0 === o ? void 0 : o.recordCanvas,
                        fps: null === (a = e.sessionRecording) || void 0 === a ? void 0 : a.canvasFps,
                        quality: null === (l = e.sessionRecording) || void 0 === l ? void 0 : l.canvasQuality
                    },
                    [$fad8677fba5f5b13$var$ue]: u,
                    [$fad8677fba5f5b13$var$de]: $fad8677fba5f5b13$var$S(d) ? null : d
                });
            };
            n(), null === (t = this._persistDecideOnSessionListener) || void 0 === t || t.call(this), this._persistDecideOnSessionListener = this.sessionManager.onSessionId(n);
        }
    }
    log(e) {
        var t;
        let i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "log";
        null === (t = this.instance.sessionRecording) || void 0 === t || t.onRRwebEmit({
            type: 6,
            data: {
                plugin: "rrweb/console@1",
                payload: {
                    level: i,
                    trace: [],
                    payload: [
                        JSON.stringify(e)
                    ]
                }
            },
            timestamp: Date.now()
        });
    }
    _startCapture(e) {
        if (!$fad8677fba5f5b13$var$S(Object.assign) && !$fad8677fba5f5b13$var$S(Array.from) && !(this._captureStarted || this.instance.config.disable_session_recording || this.instance.consent.isOptedOut())) {
            var t, i;
            if (this._captureStarted = !0, this.sessionManager.checkAndGetSessionAndWindowId(), this.rrwebRecord) this._onScriptLoaded();
            else null === (t = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === t || null === (i = t.loadExternalDependency) || void 0 === i || i.call(t, this.instance, "recorder", (e)=>{
                if (e) return $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$Hn + " could not load recorder", e);
                this._onScriptLoaded();
            });
            $fad8677fba5f5b13$var$$.info($fad8677fba5f5b13$var$Hn + " starting"), "active" === this.status && this._reportStarted(e || "recording_initialized");
        }
    }
    isInteractiveEvent(e) {
        var t;
        return 3 === e.type && -1 !== $fad8677fba5f5b13$var$Nn.indexOf(null === (t = e.data) || void 0 === t ? void 0 : t.source);
    }
    _updateWindowAndSessionIds(e) {
        const t = this.isInteractiveEvent(e);
        if (!t && !this.isIdle) e.timestamp - this._lastActivityTimestamp > this.sessionIdleThresholdMilliseconds && (this.isIdle = !0, clearInterval(this._fullSnapshotTimer), this._tryAddCustomEvent("sessionIdle", {
            eventTimestamp: e.timestamp,
            lastActivityTimestamp: this._lastActivityTimestamp,
            threshold: this.sessionIdleThresholdMilliseconds,
            bufferLength: this.buffer.data.length,
            bufferSize: this.buffer.size
        }), this._flushBuffer());
        let i = !1;
        if (t && (this._lastActivityTimestamp = e.timestamp, this.isIdle && (this.isIdle = !1, this._tryAddCustomEvent("sessionNoLongerIdle", {
            reason: "user activity",
            type: e.type
        }), i = !0)), this.isIdle) return;
        const { windowId: n, sessionId: s } = this.sessionManager.checkAndGetSessionAndWindowId(!t, e.timestamp), r = this.sessionId !== s, o = this.windowId !== n;
        this.windowId = n, this.sessionId = s, r || o ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : i && this._scheduleFullSnapshot();
    }
    _tryRRWebMethod(e) {
        try {
            return e.rrwebMethod(), !0;
        } catch (t) {
            return this.queuedRRWebEvents.length < 10 ? this.queuedRRWebEvents.push({
                enqueuedAt: e.enqueuedAt || Date.now(),
                attempt: e.attempt++,
                rrwebMethod: e.rrwebMethod
            }) : $fad8677fba5f5b13$var$$.warn($fad8677fba5f5b13$var$Hn + " could not emit queued rrweb event.", t, e), !1;
        }
    }
    _tryAddCustomEvent(e, t) {
        return this._tryRRWebMethod($fad8677fba5f5b13$var$Bn(()=>this.rrwebRecord.addCustomEvent(e, t)));
    }
    _tryTakeFullSnapshot() {
        return this._tryRRWebMethod($fad8677fba5f5b13$var$Bn(()=>this.rrwebRecord.takeFullSnapshot()));
    }
    _onScriptLoaded() {
        var e;
        const t = {
            blockClass: "ph-no-capture",
            blockSelector: void 0,
            ignoreClass: "ph-ignore-input",
            maskTextClass: "ph-mask",
            maskTextSelector: void 0,
            maskTextFn: void 0,
            maskAllInputs: !0,
            maskInputOptions: {
                password: !0
            },
            maskInputFn: void 0,
            slimDOMOptions: {},
            collectFonts: !1,
            inlineStylesheet: !0,
            recordCrossOriginIframes: !1
        }, i = this.instance.config.session_recording;
        for (const [e, n] of Object.entries(i || {}))e in t && ("maskInputOptions" === e ? t.maskInputOptions = {
            password: !0,
            ...n
        } : t[e] = n);
        if (this.canvasRecording && this.canvasRecording.enabled && (t.recordCanvas = !0, t.sampling = {
            canvas: this.canvasRecording.fps
        }, t.dataURLOptions = {
            type: "image/webp",
            quality: this.canvasRecording.quality
        }), !this.rrwebRecord) return void $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$Hn + "onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
        this.mutationRateLimiter = null !== (e = this.mutationRateLimiter) && void 0 !== e ? e : new $fad8677fba5f5b13$var$Yi(this.rrwebRecord, {
            onBlockedNode: (e, t)=>{
                const i = `Too many mutations on node '${e}'. Rate limiting. This could be due to SVG animations or something similar`;
                $fad8677fba5f5b13$var$$.info(i, {
                    node: t
                }), this.log($fad8677fba5f5b13$var$Hn + " " + i, "warn");
            }
        });
        const n = this._gatherRRWebPlugins();
        this.stopRrweb = this.rrwebRecord({
            emit: (e)=>{
                this.onRRwebEmit(e);
            },
            plugins: n,
            ...t
        }), this._lastActivityTimestamp = Date.now(), this.isIdle = !1, this._tryAddCustomEvent("$session_options", {
            sessionRecordingOptions: t,
            activePlugins: n.map((e)=>null == e ? void 0 : e.name)
        }), this._tryAddCustomEvent("$posthog_config", {
            config: this.instance.config
        });
    }
    _scheduleFullSnapshot() {
        if (this._fullSnapshotTimer && clearInterval(this._fullSnapshotTimer), this.isIdle) return;
        const e = this.fullSnapshotIntervalMillis;
        e && (this._fullSnapshotTimer = setInterval(()=>{
            this._tryTakeFullSnapshot();
        }, e));
    }
    _gatherRRWebPlugins() {
        var e, t, i, n;
        const s = [], r = null === (e = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === e || null === (t = e.rrwebPlugins) || void 0 === t ? void 0 : t.getRecordConsolePlugin;
        r && this.isConsoleLogCaptureEnabled && s.push(r());
        const o = null === (i = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === i || null === (n = i.rrwebPlugins) || void 0 === n ? void 0 : n.getRecordNetworkPlugin;
        if (this.networkPayloadCapture && $fad8677fba5f5b13$var$y(o)) !$fad8677fba5f5b13$var$st.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? s.push(o($fad8677fba5f5b13$var$Ji(this.instance.config, this.networkPayloadCapture))) : $fad8677fba5f5b13$var$$.info($fad8677fba5f5b13$var$Hn + " NetworkCapture not started because we are on localhost.");
        return s;
    }
    onRRwebEmit(e) {
        var t;
        if (this._processQueuedEvents(), !e || !$fad8677fba5f5b13$var$b(e)) return;
        if (e.type === $fad8677fba5f5b13$var$hi.Meta) {
            const t = this._maskUrl(e.data.href);
            if (this._lastHref = t, !t) return;
            e.data.href = t;
        } else this._pageViewFallBack();
        this._checkUrlTrigger(), e.type === $fad8677fba5f5b13$var$hi.FullSnapshot && this._scheduleFullSnapshot(), e.type === $fad8677fba5f5b13$var$hi.FullSnapshot && "trigger_pending" === this.urlTriggerStatus && this.clearBuffer();
        const i = this.mutationRateLimiter ? this.mutationRateLimiter.throttleMutations(e) : e;
        if (!i) return;
        const n = function(e) {
            const t = e;
            if (t && $fad8677fba5f5b13$var$b(t) && 6 === t.type && $fad8677fba5f5b13$var$b(t.data) && "rrweb/console@1" === t.data.plugin) {
                t.data.payload.payload.length > 10 && (t.data.payload.payload = t.data.payload.payload.slice(0, 10), t.data.payload.payload.push("...[truncated]"));
                const i = [];
                for(let e = 0; e < t.data.payload.payload.length; e++)t.data.payload.payload[e] && t.data.payload.payload[e].length > 2e3 ? i.push(t.data.payload.payload[e].slice(0, 2e3) + "...[truncated]") : i.push(t.data.payload.payload[e]);
                return t.data.payload.payload = i, e;
            }
            return e;
        }(i);
        if (this._updateWindowAndSessionIds(n), this.isIdle && !$fad8677fba5f5b13$var$Wn(n)) return;
        if ($fad8677fba5f5b13$var$Wn(n)) {
            const e = n.data.payload;
            if (e) {
                const t = e.lastActivityTimestamp, i = e.threshold;
                n.timestamp = t + i;
            }
        }
        const s = null === (t = this.instance.config.session_recording.compress_events) || void 0 === t || t ? function(e) {
            if ($fad8677fba5f5b13$var$ui(e) < 1024) return e;
            try {
                if (e.type === $fad8677fba5f5b13$var$hi.FullSnapshot) return {
                    ...e,
                    data: $fad8677fba5f5b13$var$Un(e.data),
                    cv: "2024-10"
                };
                if (e.type === $fad8677fba5f5b13$var$hi.IncrementalSnapshot && e.data.source === $fad8677fba5f5b13$var$_i.Mutation) return {
                    ...e,
                    cv: "2024-10",
                    data: {
                        ...e.data,
                        texts: $fad8677fba5f5b13$var$Un(e.data.texts),
                        attributes: $fad8677fba5f5b13$var$Un(e.data.attributes),
                        removes: $fad8677fba5f5b13$var$Un(e.data.removes),
                        adds: $fad8677fba5f5b13$var$Un(e.data.adds)
                    }
                };
                if (e.type === $fad8677fba5f5b13$var$hi.IncrementalSnapshot && e.data.source === $fad8677fba5f5b13$var$_i.StyleSheetRule) return {
                    ...e,
                    cv: "2024-10",
                    data: {
                        ...e.data,
                        adds: $fad8677fba5f5b13$var$Un(e.data.adds),
                        removes: $fad8677fba5f5b13$var$Un(e.data.removes)
                    }
                };
            } catch (e) {
                $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$Hn + " could not compress event - will use uncompressed event", e);
            }
            return e;
        }(n) : n, r = {
            $snapshot_bytes: $fad8677fba5f5b13$var$ui(s),
            $snapshot_data: s,
            $session_id: this.sessionId,
            $window_id: this.windowId
        };
        "disabled" !== this.status ? this._captureSnapshotBuffered(r) : this.clearBuffer();
    }
    _pageViewFallBack() {
        if (this.instance.config.capture_pageview || !$fad8677fba5f5b13$var$e) return;
        const t = this._maskUrl($fad8677fba5f5b13$var$e.location.href);
        this._lastHref !== t && (this._tryAddCustomEvent("$url_changed", {
            href: t
        }), this._lastHref = t);
    }
    _processQueuedEvents() {
        if (this.queuedRRWebEvents.length) {
            const e = [
                ...this.queuedRRWebEvents
            ];
            this.queuedRRWebEvents = [], e.forEach((e)=>{
                Date.now() - e.enqueuedAt <= 2e3 && this._tryRRWebMethod(e);
            });
        }
    }
    _maskUrl(e) {
        const t = this.instance.config.session_recording;
        if (t.maskNetworkRequestFn) {
            var i;
            let n = {
                url: e
            };
            return n = t.maskNetworkRequestFn(n), null === (i = n) || void 0 === i ? void 0 : i.url;
        }
        return e;
    }
    clearBuffer() {
        return this.buffer = {
            size: 0,
            data: [],
            sessionId: this.sessionId,
            windowId: this.windowId
        }, this.buffer;
    }
    _flushBuffer() {
        this.flushBufferTimer && (clearTimeout(this.flushBufferTimer), this.flushBufferTimer = void 0);
        const e = this.minimumDuration, t = this.sessionDuration, i = $fad8677fba5f5b13$var$P(t) && t >= 0, n = $fad8677fba5f5b13$var$P(e) && i && t < e;
        if ("buffering" === this.status || n) return this.flushBufferTimer = setTimeout(()=>{
            this._flushBuffer();
        }, 2e3), this.buffer;
        if (this.buffer.data.length > 0) $fad8677fba5f5b13$var$di(this.buffer).forEach((e)=>{
            this._captureSnapshot({
                $snapshot_bytes: e.size,
                $snapshot_data: e.data,
                $session_id: e.sessionId,
                $window_id: e.windowId
            });
        });
        return this.clearBuffer();
    }
    _captureSnapshotBuffered(e) {
        var t;
        const i = 2 + ((null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) || 0);
        !this.isIdle && (this.buffer.size + e.$snapshot_bytes + i > 943718.4 || this.buffer.sessionId !== this.sessionId) && (this.buffer = this._flushBuffer()), this.buffer.size += e.$snapshot_bytes, this.buffer.data.push(e.$snapshot_data), this.flushBufferTimer || this.isIdle || (this.flushBufferTimer = setTimeout(()=>{
            this._flushBuffer();
        }, 2e3));
    }
    _captureSnapshot(e) {
        this.instance.capture("$snapshot", e, {
            _url: this.instance.requestRouter.endpointFor("api", this._endpoint),
            _noTruncate: !0,
            _batchKey: "recordings",
            skip_client_rate_limiting: !0
        });
    }
    _checkUrlTrigger() {
        if (void 0 === $fad8677fba5f5b13$var$e || !$fad8677fba5f5b13$var$e.location.href) return;
        const t = $fad8677fba5f5b13$var$e.location.href;
        this._urlTriggers.some((e)=>"regex" === e.matching && new RegExp(e.url).test(t)) && this._activateUrlTrigger();
    }
    _activateUrlTrigger() {
        "trigger_pending" === this.urlTriggerStatus && (this.urlTriggerStatus = "trigger_activated", this._tryAddCustomEvent("url trigger activated", {}), this._flushBuffer(), $fad8677fba5f5b13$var$$.info($fad8677fba5f5b13$var$Hn + " recording triggered by URL pattern match"));
    }
    overrideLinkedFlag() {
        this._linkedFlagSeen = !0, this._reportStarted("linked_flag_override");
    }
    overrideSampling() {
        var e;
        null === (e = this.instance.persistence) || void 0 === e || e.register({
            [$fad8677fba5f5b13$var$_e]: !0
        }), this._reportStarted("sampling_override");
    }
    _reportStarted(e) {
        (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ()=>!0)() && this.instance.register_for_session({
            $session_recording_start_reason: e
        });
    }
}
class $fad8677fba5f5b13$var$Vn {
    constructor(e){
        this.instance = e, this.instance.decideEndpointWasHit = this.instance._hasBootstrappedFeatureFlags();
    }
    call() {
        const e = {
            token: this.instance.config.token,
            distinct_id: this.instance.get_distinct_id(),
            groups: this.instance.getGroups(),
            person_properties: this.instance.get_property($fad8677fba5f5b13$var$me),
            group_properties: this.instance.get_property($fad8677fba5f5b13$var$ye),
            disable_flags: this.instance.config.advanced_disable_feature_flags || this.instance.config.advanced_disable_feature_flags_on_first_load || void 0
        };
        this.instance._send_request({
            method: "POST",
            url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"),
            data: e,
            compression: this.instance.config.disable_compression ? void 0 : $fad8677fba5f5b13$export$6a00d17b5aff0af.Base64,
            timeout: this.instance.config.feature_flag_request_timeout_ms,
            callback: (e)=>this.parseDecideResponse(e.json)
        });
    }
    parseDecideResponse(e) {
        this.instance.featureFlags.setReloadingPaused(!1), this.instance.featureFlags._startReloadTimer();
        const t = !e;
        if (this.instance.config.advanced_disable_feature_flags_on_first_load || this.instance.config.advanced_disable_feature_flags || this.instance.featureFlags.receivedFeatureFlags(null != e ? e : {}, t), t) $fad8677fba5f5b13$var$$.error("Failed to fetch feature flags from PostHog.");
        else {
            if (!$fad8677fba5f5b13$var$o || !$fad8677fba5f5b13$var$o.body) return $fad8677fba5f5b13$var$$.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
                this.parseDecideResponse(e);
            }, 500);
            if (this.instance._afterDecideResponse(e), e.siteApps) {
                if (this.instance.config.opt_in_site_apps) for (const { id: t, url: r } of e.siteApps){
                    var i, n, s;
                    $fad8677fba5f5b13$var$h[`__$$ph_site_app_${t}`] = this.instance, null === (i = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === i || null === (n = (s = i).loadSiteApp) || void 0 === n || n.call(s, this.instance, r, (e)=>{
                        if (e) return $fad8677fba5f5b13$var$$.error(`Error while initializing PostHog app with config id ${t}`, e);
                    });
                }
                else e.siteApps.length > 0 && $fad8677fba5f5b13$var$$.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            }
        }
    }
}
const $fad8677fba5f5b13$var$Gn = null != $fad8677fba5f5b13$var$e && $fad8677fba5f5b13$var$e.location ? $fad8677fba5f5b13$var$ct($fad8677fba5f5b13$var$e.location.hash, "__posthog") || $fad8677fba5f5b13$var$ct(location.hash, "state") : null, $fad8677fba5f5b13$var$jn = "_postHogToolbarParams";
var $fad8677fba5f5b13$var$Qn;
!function(e) {
    e[e.UNINITIALIZED = 0] = "UNINITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.LOADED = 2] = "LOADED";
}($fad8677fba5f5b13$var$Qn || ($fad8677fba5f5b13$var$Qn = {}));
class $fad8677fba5f5b13$var$Jn {
    constructor(e){
        this.instance = e;
    }
    setToolbarState(e) {
        $fad8677fba5f5b13$var$h.ph_toolbar_state = e;
    }
    getToolbarState() {
        var e;
        return null !== (e = $fad8677fba5f5b13$var$h.ph_toolbar_state) && void 0 !== e ? e : $fad8677fba5f5b13$var$Qn.UNINITIALIZED;
    }
    maybeLoadToolbar() {
        var t, i;
        let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
        if (!$fad8677fba5f5b13$var$e || !$fad8677fba5f5b13$var$o) return !1;
        n = null !== (t = n) && void 0 !== t ? t : $fad8677fba5f5b13$var$e.location, r = null !== (i = r) && void 0 !== i ? i : $fad8677fba5f5b13$var$e.history;
        try {
            if (!s) {
                try {
                    $fad8677fba5f5b13$var$e.localStorage.setItem("test", "test"), $fad8677fba5f5b13$var$e.localStorage.removeItem("test");
                } catch  {
                    return !1;
                }
                s = null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.localStorage;
            }
            const t = $fad8677fba5f5b13$var$Gn || $fad8677fba5f5b13$var$ct(n.hash, "__posthog") || $fad8677fba5f5b13$var$ct(n.hash, "state");
            let i;
            const o = t ? $fad8677fba5f5b13$var$B(()=>JSON.parse(atob(decodeURIComponent(t)))) || $fad8677fba5f5b13$var$B(()=>JSON.parse(decodeURIComponent(t))) : null;
            return o && "ph_authorize" === o.action ? (i = o, i.source = "url", i && Object.keys(i).length > 0 && (o.desiredHash ? n.hash = o.desiredHash : r ? r.replaceState(r.state, "", n.pathname + n.search) : n.hash = "")) : (i = JSON.parse(s.getItem($fad8677fba5f5b13$var$jn) || "{}"), i.source = "localstorage", delete i.userIntent), !(!i.token || this.instance.config.token !== i.token) && (this.loadToolbar(i), !0);
        } catch  {
            return !1;
        }
    }
    _callLoadToolbar(e) {
        ($fad8677fba5f5b13$var$h.ph_load_toolbar || $fad8677fba5f5b13$var$h.ph_load_editor)(e, this.instance);
    }
    loadToolbar(t) {
        const i = !(null == $fad8677fba5f5b13$var$o || !$fad8677fba5f5b13$var$o.getElementById($fad8677fba5f5b13$var$Te));
        if (!$fad8677fba5f5b13$var$e || i) return !1;
        const n = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = {
            token: this.instance.config.token,
            ...t,
            apiURL: this.instance.requestRouter.endpointFor("ui"),
            ...n ? {
                instrument: !1
            } : {}
        };
        if ($fad8677fba5f5b13$var$e.localStorage.setItem($fad8677fba5f5b13$var$jn, JSON.stringify({
            ...s,
            source: void 0
        })), this.getToolbarState() === $fad8677fba5f5b13$var$Qn.LOADED) this._callLoadToolbar(s);
        else if (this.getToolbarState() === $fad8677fba5f5b13$var$Qn.UNINITIALIZED) {
            var r, a;
            this.setToolbarState($fad8677fba5f5b13$var$Qn.LOADING), null === (r = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === r || null === (a = r.loadExternalDependency) || void 0 === a || a.call(r, this.instance, "toolbar", (e)=>{
                if (e) return $fad8677fba5f5b13$var$$.error("Failed to load toolbar", e), void this.setToolbarState($fad8677fba5f5b13$var$Qn.UNINITIALIZED);
                this.setToolbarState($fad8677fba5f5b13$var$Qn.LOADED), this._callLoadToolbar(s);
            }), $fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$e, "turbolinks:load", ()=>{
                this.setToolbarState($fad8677fba5f5b13$var$Qn.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    _loadEditor(e) {
        return this.loadToolbar(e);
    }
    maybeLoadEditor() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
        return this.maybeLoadToolbar(e, t, i);
    }
}
class $fad8677fba5f5b13$var$Yn {
    isPaused = !0;
    queue = [];
    flushTimeoutMs = 3e3;
    constructor(e){
        this.sendRequest = e;
    }
    enqueue(e) {
        this.queue.push(e), this.flushTimeout || this.setFlushTimeout();
    }
    unload() {
        this.clearFlushTimeout();
        const e = this.queue.length > 0 ? this.formatQueue() : {}, t = Object.values(e), i = [
            ...t.filter((e)=>0 === e.url.indexOf("/e")),
            ...t.filter((e)=>0 !== e.url.indexOf("/e"))
        ];
        i.map((e)=>{
            this.sendRequest({
                ...e,
                transport: "sendBeacon"
            });
        });
    }
    enable() {
        this.isPaused = !1, this.setFlushTimeout();
    }
    setFlushTimeout() {
        this.isPaused || (this.flushTimeout = setTimeout(()=>{
            if (this.clearFlushTimeout(), this.queue.length > 0) {
                const e = this.formatQueue();
                for(const t in e){
                    const i = e[t], n = (new Date).getTime();
                    i.data && $fad8677fba5f5b13$var$m(i.data) && $fad8677fba5f5b13$var$O(i.data, (e)=>{
                        e.offset = Math.abs(e.timestamp - n), delete e.timestamp;
                    }), this.sendRequest(i);
                }
            }
        }, this.flushTimeoutMs));
    }
    clearFlushTimeout() {
        clearTimeout(this.flushTimeout), this.flushTimeout = void 0;
    }
    formatQueue() {
        const e = {};
        return $fad8677fba5f5b13$var$O(this.queue, (t)=>{
            var i;
            const n = t, s = (n ? n.batchKey : null) || n.url;
            $fad8677fba5f5b13$var$S(e[s]) && (e[s] = {
                ...n,
                data: []
            }), null === (i = e[s].data) || void 0 === i || i.push(n.data);
        }), this.queue = [], e;
    }
}
const $fad8677fba5f5b13$var$Xn = !!$fad8677fba5f5b13$var$c || !!$fad8677fba5f5b13$var$l, $fad8677fba5f5b13$var$Kn = "text/plain", $fad8677fba5f5b13$var$Zn = (e, t)=>{
    const [i, n] = e.split("?"), s = {
        ...t
    };
    null == n || n.split("&").forEach((e)=>{
        const [t] = e.split("=");
        delete s[t];
    });
    let r = $fad8677fba5f5b13$var$at(s);
    return r = r ? (n ? n + "&" : "") + r : n, `${i}?${r}`;
}, $fad8677fba5f5b13$var$es = (e)=>{
    let { data: t, compression: i } = e;
    if (!t) return;
    if (i === $fad8677fba5f5b13$export$6a00d17b5aff0af.GZipJS) {
        const e = $fad8677fba5f5b13$var$An($fad8677fba5f5b13$var$Ln(JSON.stringify(t)), {
            mtime: 0
        }), i = new Blob([
            e
        ], {
            type: $fad8677fba5f5b13$var$Kn
        });
        return {
            contentType: $fad8677fba5f5b13$var$Kn,
            body: i,
            estimatedSize: i.size
        };
    }
    if (i === $fad8677fba5f5b13$export$6a00d17b5aff0af.Base64) {
        const e = function(e) {
            const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            let i, n, s, r, o, a, l, c, u = 0, d = 0, h = "";
            const _ = [];
            if (!e) return e;
            e = $fad8677fba5f5b13$var$V(e);
            do i = e.charCodeAt(u++), n = e.charCodeAt(u++), s = e.charCodeAt(u++), c = i << 16 | n << 8 | s, r = c >> 18 & 63, o = c >> 12 & 63, a = c >> 6 & 63, l = 63 & c, _[d++] = t.charAt(r) + t.charAt(o) + t.charAt(a) + t.charAt(l);
            while (u < e.length);
            switch(h = _.join(""), e.length % 3){
                case 1:
                    h = h.slice(0, -2) + "==";
                    break;
                case 2:
                    h = h.slice(0, -1) + "=";
            }
            return h;
        }(JSON.stringify(t)), i = ((e)=>"data=" + encodeURIComponent("string" == typeof e ? e : JSON.stringify(e)))(e);
        return {
            contentType: "application/x-www-form-urlencoded",
            body: i,
            estimatedSize: new Blob([
                i
            ]).size
        };
    }
    const n = JSON.stringify(t);
    return {
        contentType: "application/json",
        body: n,
        estimatedSize: new Blob([
            n
        ]).size
    };
}, $fad8677fba5f5b13$var$ts = (e)=>{
    var t;
    const i = new $fad8677fba5f5b13$var$c;
    i.open(e.method || "GET", e.url, !0);
    const { contentType: n, body: s } = null !== (t = $fad8677fba5f5b13$var$es(e)) && void 0 !== t ? t : {};
    $fad8677fba5f5b13$var$O(e.headers, function(e, t) {
        i.setRequestHeader(t, e);
    }), n && i.setRequestHeader("Content-Type", n), e.timeout && (i.timeout = e.timeout), i.withCredentials = !0, i.onreadystatechange = ()=>{
        if (4 === i.readyState) {
            var t;
            const n = {
                statusCode: i.status,
                text: i.responseText
            };
            if (200 === i.status) try {
                n.json = JSON.parse(i.responseText);
            } catch  {}
            null === (t = e.callback) || void 0 === t || t.call(e, n);
        }
    }, i.send(s);
}, $fad8677fba5f5b13$var$is = (e)=>{
    var t, i;
    const { contentType: n, body: s, estimatedSize: r } = null !== (t = $fad8677fba5f5b13$var$es(e)) && void 0 !== t ? t : {}, o = new Headers;
    $fad8677fba5f5b13$var$O(e.headers, function(e, t) {
        o.append(t, e);
    }), n && o.append("Content-Type", n);
    const a = e.url;
    let c = null;
    if ($fad8677fba5f5b13$var$u) {
        const t = new $fad8677fba5f5b13$var$u;
        c = {
            signal: t.signal,
            timeout: setTimeout(()=>t.abort(), e.timeout)
        };
    }
    $fad8677fba5f5b13$var$l(a, {
        method: (null == e ? void 0 : e.method) || "GET",
        headers: o,
        keepalive: "POST" === e.method && (r || 0) < 52428.8,
        body: s,
        signal: null === (i = c) || void 0 === i ? void 0 : i.signal
    }).then((t)=>t.text().then((i)=>{
            var n;
            const s = {
                statusCode: t.status,
                text: i
            };
            if (200 === t.status) try {
                s.json = JSON.parse(i);
            } catch (e) {
                $fad8677fba5f5b13$var$$.error(e);
            }
            null === (n = e.callback) || void 0 === n || n.call(e, s);
        })).catch((t)=>{
        var i;
        $fad8677fba5f5b13$var$$.error(t), null === (i = e.callback) || void 0 === i || i.call(e, {
            statusCode: 0,
            text: t
        });
    }).finally(()=>c ? clearTimeout(c.timeout) : null);
}, $fad8677fba5f5b13$var$ns = (e)=>{
    const t = $fad8677fba5f5b13$var$Zn(e.url, {
        beacon: "1"
    });
    try {
        var i;
        const { contentType: n, body: s } = null !== (i = $fad8677fba5f5b13$var$es(e)) && void 0 !== i ? i : {}, o = "string" == typeof s ? new Blob([
            s
        ], {
            type: n
        }) : s;
        $fad8677fba5f5b13$var$r.sendBeacon(t, o);
    } catch  {}
}, $fad8677fba5f5b13$var$ss = [];
$fad8677fba5f5b13$var$c && $fad8677fba5f5b13$var$ss.push({
    transport: "XHR",
    method: $fad8677fba5f5b13$var$ts
}), $fad8677fba5f5b13$var$l && $fad8677fba5f5b13$var$ss.push({
    transport: "fetch",
    method: $fad8677fba5f5b13$var$is
}), null != $fad8677fba5f5b13$var$r && $fad8677fba5f5b13$var$r.sendBeacon && $fad8677fba5f5b13$var$ss.push({
    transport: "sendBeacon",
    method: $fad8677fba5f5b13$var$ns
});
class $fad8677fba5f5b13$var$rs {
    isPolling = !1;
    pollIntervalMs = 3e3;
    queue = [];
    constructor(t){
        this.instance = t, this.queue = [], this.areWeOnline = !0, !$fad8677fba5f5b13$var$S($fad8677fba5f5b13$var$e) && "onLine" in $fad8677fba5f5b13$var$e.navigator && (this.areWeOnline = $fad8677fba5f5b13$var$e.navigator.onLine, $fad8677fba5f5b13$var$e.addEventListener("online", ()=>{
            this.areWeOnline = !0, this.flush();
        }), $fad8677fba5f5b13$var$e.addEventListener("offline", ()=>{
            this.areWeOnline = !1;
        }));
    }
    retriableRequest(e) {
        let { retriesPerformedSoFar: t, ...i } = e;
        $fad8677fba5f5b13$var$P(t) && t > 0 && (i.url = $fad8677fba5f5b13$var$Zn(i.url, {
            retry_count: t
        })), this.instance._send_request({
            ...i,
            callback: (e)=>{
                var n;
                200 !== e.statusCode && (e.statusCode < 400 || e.statusCode >= 500) && (null != t ? t : 0) < 10 ? this.enqueue({
                    retriesPerformedSoFar: t,
                    ...i
                }) : null === (n = i.callback) || void 0 === n || n.call(i, e);
            }
        });
    }
    enqueue(e) {
        const t = e.retriesPerformedSoFar || 0;
        e.retriesPerformedSoFar = t + 1;
        const i = function(e) {
            const t = 3e3 * 2 ** e, i = t / 2, n = Math.min(18e5, t), s = (Math.random() - .5) * (n - i);
            return Math.ceil(n + s);
        }(t), n = Date.now() + i;
        this.queue.push({
            retryAt: n,
            requestOptions: e
        });
        let s = `Enqueued failed request for retry in ${i}`;
        navigator.onLine || (s += " (Browser is offline)"), $fad8677fba5f5b13$var$$.warn(s), this.isPolling || (this.isPolling = !0, this.poll());
    }
    poll() {
        this.poller && clearTimeout(this.poller), this.poller = setTimeout(()=>{
            this.areWeOnline && this.queue.length > 0 && this.flush(), this.poll();
        }, this.pollIntervalMs);
    }
    flush() {
        const e = Date.now(), t = [], i = this.queue.filter((i)=>i.retryAt < e || (t.push(i), !1));
        if (this.queue = t, i.length > 0) for (const { requestOptions: e } of i)this.retriableRequest(e);
    }
    unload() {
        this.poller && (clearTimeout(this.poller), this.poller = void 0);
        for (const { requestOptions: e } of this.queue)try {
            this.instance._send_request({
                ...e,
                transport: "sendBeacon"
            });
        } catch (e) {
            $fad8677fba5f5b13$var$$.error(e);
        }
        this.queue = [];
    }
}
class $fad8677fba5f5b13$var$os {
    _sessionIdChangedHandlers = [];
    constructor(e, t, i, n){
        var s;
        this.config = e, this.persistence = t, this._windowId = void 0, this._sessionId = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this._sessionIdGenerator = i || $fad8677fba5f5b13$var$We, this._windowIdGenerator = n || $fad8677fba5f5b13$var$We;
        const r = e.persistence_name || e.token, o = e.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $fad8677fba5f5b13$var$On(o, 60, 1800, "session_idle_timeout_seconds"), this._window_id_storage_key = "ph_" + r + "_window_id", this._primary_window_exists_storage_key = "ph_" + r + "_primary_window_exists", this._canUseSessionStorage()) {
            const e = $fad8677fba5f5b13$var$nt.parse(this._window_id_storage_key), t = $fad8677fba5f5b13$var$nt.parse(this._primary_window_exists_storage_key);
            e && !t ? this._windowId = e : $fad8677fba5f5b13$var$nt.remove(this._window_id_storage_key), $fad8677fba5f5b13$var$nt.set(this._primary_window_exists_storage_key, !0);
        }
        if (null !== (s = this.config.bootstrap) && void 0 !== s && s.sessionID) try {
            const e = ((e)=>{
                const t = e.replace(/-/g, "");
                if (32 !== t.length) throw new Error("Not a valid UUID");
                if ("7" !== t[12]) throw new Error("Not a UUIDv7");
                return parseInt(t.substring(0, 12), 16);
            })(this.config.bootstrap.sessionID);
            this._setSessionId(this.config.bootstrap.sessionID, (new Date).getTime(), e);
        } catch (e) {
            $fad8677fba5f5b13$var$$.error("Invalid sessionID in bootstrap", e);
        }
        this._listenToReloadWindow();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(e) {
        return $fad8677fba5f5b13$var$S(this._sessionIdChangedHandlers) && (this._sessionIdChangedHandlers = []), this._sessionIdChangedHandlers.push(e), this._sessionId && e(this._sessionId, this._windowId), ()=>{
            this._sessionIdChangedHandlers = this._sessionIdChangedHandlers.filter((t)=>t !== e);
        };
    }
    _canUseSessionStorage() {
        return "memory" !== this.config.persistence && !this.persistence.disabled && $fad8677fba5f5b13$var$nt.is_supported();
    }
    _setWindowId(e) {
        e !== this._windowId && (this._windowId = e, this._canUseSessionStorage() && $fad8677fba5f5b13$var$nt.set(this._window_id_storage_key, e));
    }
    _getWindowId() {
        return this._windowId ? this._windowId : this._canUseSessionStorage() ? $fad8677fba5f5b13$var$nt.parse(this._window_id_storage_key) : null;
    }
    _setSessionId(e, t, i) {
        e === this._sessionId && t === this._sessionActivityTimestamp && i === this._sessionStartTimestamp || (this._sessionStartTimestamp = i, this._sessionActivityTimestamp = t, this._sessionId = e, this.persistence.register({
            [$fad8677fba5f5b13$var$he]: [
                t,
                e,
                i
            ]
        }));
    }
    _getSessionId() {
        if (this._sessionId && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
            this._sessionActivityTimestamp,
            this._sessionId,
            this._sessionStartTimestamp
        ];
        const e = this.persistence.props[$fad8677fba5f5b13$var$he];
        return $fad8677fba5f5b13$var$m(e) && 2 === e.length && e.push(e[0]), e || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this._setSessionId(null, null, null);
    }
    _listenToReloadWindow() {
        null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("beforeunload", ()=>{
            this._canUseSessionStorage() && $fad8677fba5f5b13$var$nt.remove(this._primary_window_exists_storage_key);
        });
    }
    checkAndGetSessionAndWindowId() {
        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        const t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || (new Date).getTime();
        let [i, n, s] = this._getSessionId(), r = this._getWindowId();
        const o = $fad8677fba5f5b13$var$P(s) && s > 0 && Math.abs(t - s) > 864e5;
        let a = !1;
        const l = !n, c = !e && Math.abs(t - i) > this.sessionTimeoutMs;
        l || c || o ? (n = this._sessionIdGenerator(), r = this._windowIdGenerator(), $fad8677fba5f5b13$var$$.info("[SessionId] new session ID generated", {
            sessionId: n,
            windowId: r,
            changeReason: {
                noSessionId: l,
                activityTimeout: c,
                sessionPastMaximumLength: o
            }
        }), s = t, a = !0) : r || (r = this._windowIdGenerator(), a = !0);
        const u = 0 === i || !e || o ? t : i, d = 0 === s ? (new Date).getTime() : s;
        return this._setWindowId(r), this._setSessionId(n, u, d), a && this._sessionIdChangedHandlers.forEach((e)=>e(n, r, a ? {
                noSessionId: l,
                activityTimeout: c,
                sessionPastMaximumLength: o
            } : void 0)), {
            sessionId: n,
            windowId: r,
            sessionStartTimestamp: d,
            changeReason: a ? {
                noSessionId: l,
                activityTimeout: c,
                sessionPastMaximumLength: o
            } : void 0,
            lastActivityTimestamp: i
        };
    }
}
let $fad8677fba5f5b13$var$as;
!function(e) {
    e.US = "us", e.EU = "eu", e.CUSTOM = "custom";
}($fad8677fba5f5b13$var$as || ($fad8677fba5f5b13$var$as = {}));
const $fad8677fba5f5b13$var$ls = "i.posthog.com";
class $fad8677fba5f5b13$var$cs {
    _regionCache = {};
    constructor(e){
        this.instance = e;
    }
    get apiHost() {
        const e = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === e ? "https://us.i.posthog.com" : e;
    }
    get uiHost() {
        var e;
        let t = null === (e = this.instance.config.ui_host) || void 0 === e ? void 0 : e.replace(/\/$/, "");
        return t || (t = this.apiHost.replace(`.${$fad8677fba5f5b13$var$ls}`, ".posthog.com")), "https://app.posthog.com" === t ? "https://us.posthog.com" : t;
    }
    get region() {
        return this._regionCache[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = $fad8677fba5f5b13$var$as.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = $fad8677fba5f5b13$var$as.EU : this._regionCache[this.apiHost] = $fad8677fba5f5b13$var$as.CUSTOM), this._regionCache[this.apiHost];
    }
    endpointFor(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if (t && (t = "/" === t[0] ? t : `/${t}`), "ui" === e) return this.uiHost + t;
        if (this.region === $fad8677fba5f5b13$var$as.CUSTOM) return this.apiHost + t;
        const i = $fad8677fba5f5b13$var$ls + t;
        switch(e){
            case "assets":
                return `https://${this.region}-assets.${i}`;
            case "api":
                return `https://${this.region}.${i}`;
        }
    }
}
const $fad8677fba5f5b13$var$us = "posthog-js";
function $fad8677fba5f5b13$var$ds(e) {
    let { organization: t, projectId: i, prefix: n, severityAllowList: s = [
        "error"
    ] } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return (r)=>{
        var o, a, l, c, u;
        if (!("*" === s || s.includes(r.level)) || !e.__loaded) return r;
        r.tags || (r.tags = {});
        const d = e.requestRouter.endpointFor("ui", `/project/${e.config.token}/person/${e.get_distinct_id()}`);
        r.tags["PostHog Person URL"] = d, e.sessionRecordingStarted() && (r.tags["PostHog Recording URL"] = e.get_session_replay_url({
            withTimestamp: !0
        }));
        const h = (null === (o = r.exception) || void 0 === o ? void 0 : o.values) || [], _ = {
            $exception_message: (null === (a = h[0]) || void 0 === a ? void 0 : a.value) || r.message,
            $exception_type: null === (l = h[0]) || void 0 === l ? void 0 : l.type,
            $exception_personURL: d,
            $exception_level: r.level,
            $exception_list: h,
            $sentry_event_id: r.event_id,
            $sentry_exception: r.exception,
            $sentry_exception_message: (null === (c = h[0]) || void 0 === c ? void 0 : c.value) || r.message,
            $sentry_exception_type: null === (u = h[0]) || void 0 === u ? void 0 : u.type,
            $sentry_tags: r.tags,
            $level: r.level
        };
        return t && i && (_.$sentry_url = (n || "https://sentry.io/organizations/") + t + "/issues/?project=" + i + "&query=" + r.event_id), e.exceptions.sendExceptionEvent(_), r;
    };
}
class $fad8677fba5f5b13$var$hs {
    constructor(e, t, i, n, s){
        this.name = $fad8677fba5f5b13$var$us, this.setupOnce = function(r) {
            r($fad8677fba5f5b13$var$ds(e, {
                organization: t,
                projectId: i,
                prefix: n,
                severityAllowList: s
            }));
        };
    }
}
function $fad8677fba5f5b13$var$_s(e, t) {
    const i = e.config.segment;
    if (!i) return t();
    !function(e, t) {
        const i = e.config.segment;
        if (!i) return t();
        const n = (i)=>{
            const n = ()=>i.anonymousId() || $fad8677fba5f5b13$var$We();
            e.config.get_device_id = n, i.id() && (e.register({
                distinct_id: i.id(),
                $device_id: n()
            }), e.persistence.set_property($fad8677fba5f5b13$var$Ee, "identified")), t();
        }, s = i.user();
        "then" in s && $fad8677fba5f5b13$var$y(s.then) ? s.then((e)=>n(e)) : n(s);
    }(e, ()=>{
        i.register(((e)=>{
            Promise && Promise.resolve || $fad8677fba5f5b13$var$$.warn("This browser does not have Promise support, and can not use the segment integration");
            const t = (t, i)=>{
                var n;
                if (!i) return t;
                t.event.userId || t.event.anonymousId === e.get_distinct_id() || ($fad8677fba5f5b13$var$$.info("Segment integration does not have a userId set, resetting PostHog"), e.reset()), t.event.userId && t.event.userId !== e.get_distinct_id() && ($fad8677fba5f5b13$var$$.info("Segment integration has a userId set, identifying with PostHog"), e.identify(t.event.userId));
                const s = e._calculate_event_properties(i, null !== (n = t.event.properties) && void 0 !== n ? n : {}, new Date);
                return t.event.properties = Object.assign({}, s, t.event.properties), t;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (e)=>t(e, e.event.event),
                page: (e)=>t(e, "$pageview"),
                identify: (e)=>t(e, "$identify"),
                screen: (e)=>t(e, "$screen")
            };
        })(e)).then(()=>{
            t();
        });
    });
}
class $fad8677fba5f5b13$var$ps {
    constructor(e){
        this._instance = e;
    }
    doPageView(t) {
        var i;
        const n = this._previousPageViewProperties(t);
        return this._currentPath = null !== (i = null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.location.pathname) && void 0 !== i ? i : "", this._instance.scrollManager.resetContext(), this._prevPageviewTimestamp = t, n;
    }
    doPageLeave(e) {
        return this._previousPageViewProperties(e);
    }
    _previousPageViewProperties(e) {
        const t = this._currentPath, i = this._prevPageviewTimestamp, n = this._instance.scrollManager.getContext();
        if (!i) return {};
        let s = {};
        if (n) {
            let { maxScrollHeight: e, lastScrollY: t, maxScrollY: i, maxContentHeight: r, lastContentY: o, maxContentY: a } = n;
            if (!($fad8677fba5f5b13$var$S(e) || $fad8677fba5f5b13$var$S(t) || $fad8677fba5f5b13$var$S(i) || $fad8677fba5f5b13$var$S(r) || $fad8677fba5f5b13$var$S(o) || $fad8677fba5f5b13$var$S(a))) {
                e = Math.ceil(e), t = Math.ceil(t), i = Math.ceil(i), r = Math.ceil(r), o = Math.ceil(o), a = Math.ceil(a);
                s = {
                    $prev_pageview_last_scroll: t,
                    $prev_pageview_last_scroll_percentage: e <= 1 ? 1 : $fad8677fba5f5b13$var$On(t / e, 0, 1),
                    $prev_pageview_max_scroll: i,
                    $prev_pageview_max_scroll_percentage: e <= 1 ? 1 : $fad8677fba5f5b13$var$On(i / e, 0, 1),
                    $prev_pageview_last_content: o,
                    $prev_pageview_last_content_percentage: r <= 1 ? 1 : $fad8677fba5f5b13$var$On(o / r, 0, 1),
                    $prev_pageview_max_content: a,
                    $prev_pageview_max_content_percentage: r <= 1 ? 1 : $fad8677fba5f5b13$var$On(a / r, 0, 1)
                };
            }
        }
        return t && (s.$prev_pageview_pathname = t), i && (s.$prev_pageview_duration = (e.getTime() - i.getTime()) / 1e3), s;
    }
}
let $fad8677fba5f5b13$export$22779822dd24228f, $fad8677fba5f5b13$export$9c2ac61661d417f8, $fad8677fba5f5b13$export$bbed2da3bd3bb001;
!function(e) {
    e.Popover = "popover", e.API = "api", e.Widget = "widget";
}($fad8677fba5f5b13$export$22779822dd24228f || ($fad8677fba5f5b13$export$22779822dd24228f = {})), function(e) {
    e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link";
}($fad8677fba5f5b13$export$9c2ac61661d417f8 || ($fad8677fba5f5b13$export$9c2ac61661d417f8 = {})), function(e) {
    e.NextQuestion = "next_question", e.End = "end", e.ResponseBased = "response_based", e.SpecificQuestion = "specific_question";
}($fad8677fba5f5b13$export$bbed2da3bd3bb001 || ($fad8677fba5f5b13$export$bbed2da3bd3bb001 = {}));
class $fad8677fba5f5b13$var$ms {
    events = {};
    constructor(){
        this.events = {};
    }
    on(e, t) {
        return this.events[e] || (this.events[e] = []), this.events[e].push(t), ()=>{
            this.events[e] = this.events[e].filter((e)=>e !== t);
        };
    }
    emit(e, t) {
        for (const i of this.events[e] || [])i(t);
        for (const i of this.events["*"] || [])i(e, t);
    }
}
class $fad8677fba5f5b13$var$ys {
    _debugEventEmitter = new $fad8677fba5f5b13$var$ms;
    constructor(e){
        this.instance = e, this.actionEvents = new Set, this.actionRegistry = new Set;
    }
    init() {
        var e;
        if (!$fad8677fba5f5b13$var$S(null === (e = this.instance) || void 0 === e ? void 0 : e._addCaptureHook)) {
            var t;
            const e = (e, t)=>{
                this.on(e, t);
            };
            null === (t = this.instance) || void 0 === t || t._addCaptureHook(e);
        }
    }
    register(e) {
        var t, i;
        if (!$fad8677fba5f5b13$var$S(null === (t = this.instance) || void 0 === t ? void 0 : t._addCaptureHook) && (e.forEach((e)=>{
            var t, i;
            null === (t = this.actionRegistry) || void 0 === t || t.add(e), null === (i = e.steps) || void 0 === i || i.forEach((e)=>{
                var t;
                null === (t = this.actionEvents) || void 0 === t || t.add((null == e ? void 0 : e.event) || "");
            });
        }), null !== (i = this.instance) && void 0 !== i && i.autocapture)) {
            var n;
            const t = new Set;
            e.forEach((e)=>{
                var i;
                null === (i = e.steps) || void 0 === i || i.forEach((e)=>{
                    null != e && e.selector && t.add(null == e ? void 0 : e.selector);
                });
            }), null === (n = this.instance) || void 0 === n || n.autocapture.setElementSelectors(t);
        }
    }
    on(e, t) {
        var i;
        null != t && 0 != e.length && (this.actionEvents.has(e) || this.actionEvents.has(null == t ? void 0 : t.event)) && this.actionRegistry && (null === (i = this.actionRegistry) || void 0 === i ? void 0 : i.size) > 0 && this.actionRegistry.forEach((e)=>{
            this.checkAction(t, e) && this._debugEventEmitter.emit("actionCaptured", e.name);
        });
    }
    _addActionHook(e) {
        this.onAction("actionCaptured", (t)=>e(t));
    }
    checkAction(e, t) {
        if (null == (null == t ? void 0 : t.steps)) return !1;
        for (const i of t.steps)if (this.checkStep(e, i)) return !0;
        return !1;
    }
    onAction(e, t) {
        return this._debugEventEmitter.on(e, t);
    }
    checkStep = (e, t)=>this.checkStepEvent(e, t) && this.checkStepUrl(e, t) && this.checkStepElement(e, t);
    checkStepEvent = (e, t)=>null == t || !t.event || (null == e ? void 0 : e.event) === (null == t ? void 0 : t.event);
    checkStepUrl(e, t) {
        if (null != t && t.url) {
            var i;
            const n = null == e || null === (i = e.properties) || void 0 === i ? void 0 : i.$current_url;
            if (!n || "string" != typeof n) return !1;
            if (!$fad8677fba5f5b13$var$ys.matchString(n, null == t ? void 0 : t.url, (null == t ? void 0 : t.url_matching) || "contains")) return !1;
        }
        return !0;
    }
    static matchString(t, i, n) {
        switch(n){
            case "regex":
                return !!$fad8677fba5f5b13$var$e && $fad8677fba5f5b13$var$ot(t, i);
            case "exact":
                return i === t;
            case "contains":
                const n1 = $fad8677fba5f5b13$var$ys.escapeStringRegexp(i).replace(/_/g, ".").replace(/%/g, ".*");
                return $fad8677fba5f5b13$var$ot(t, n1);
            default:
                return !1;
        }
    }
    static escapeStringRegexp(e) {
        return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    checkStepElement(e, t) {
        if (null != t && t.href || null != t && t.tag_name || null != t && t.text) {
            if (!this.getElementsList(e).some((e)=>!(null != t && t.href && !$fad8677fba5f5b13$var$ys.matchString(e.href || "", null == t ? void 0 : t.href, (null == t ? void 0 : t.href_matching) || "exact")) && (null == t || !t.tag_name || e.tag_name === (null == t ? void 0 : t.tag_name)) && !(null != t && t.text && !$fad8677fba5f5b13$var$ys.matchString(e.text || "", null == t ? void 0 : t.text, (null == t ? void 0 : t.text_matching) || "exact") && !$fad8677fba5f5b13$var$ys.matchString(e.$el_text || "", null == t ? void 0 : t.text, (null == t ? void 0 : t.text_matching) || "exact")))) return !1;
        }
        if (null != t && t.selector) {
            var i;
            const n = null == e || null === (i = e.properties) || void 0 === i ? void 0 : i.$element_selectors;
            if (!n) return !1;
            if (!n.includes(null == t ? void 0 : t.selector)) return !1;
        }
        return !0;
    }
    getElementsList(e) {
        return null == (null == e ? void 0 : e.properties.$elements) ? [] : null == e ? void 0 : e.properties.$elements;
    }
}
class $fad8677fba5f5b13$var$bs {
    static SURVEY_SHOWN_EVENT_NAME = "survey shown";
    constructor(e){
        this.instance = e, this.eventToSurveys = new Map, this.actionToSurveys = new Map;
    }
    register(e) {
        var t;
        $fad8677fba5f5b13$var$S(null === (t = this.instance) || void 0 === t ? void 0 : t._addCaptureHook) || (this.setupEventBasedSurveys(e), this.setupActionBasedSurveys(e));
    }
    setupActionBasedSurveys(e) {
        const t = e.filter((e)=>{
            var t, i, n, s;
            return (null === (t = e.conditions) || void 0 === t ? void 0 : t.actions) && (null === (i = e.conditions) || void 0 === i || null === (n = i.actions) || void 0 === n || null === (s = n.values) || void 0 === s ? void 0 : s.length) > 0;
        });
        if (0 !== t.length) {
            if (null == this.actionMatcher) {
                this.actionMatcher = new $fad8677fba5f5b13$var$ys(this.instance), this.actionMatcher.init();
                const e = (e)=>{
                    this.onAction(e);
                };
                this.actionMatcher._addActionHook(e);
            }
            t.forEach((e)=>{
                var t, i, n, s, r, o, a, l, c, u;
                e.conditions && null !== (t = e.conditions) && void 0 !== t && t.actions && null !== (i = e.conditions) && void 0 !== i && null !== (n = i.actions) && void 0 !== n && n.values && (null === (s = e.conditions) || void 0 === s || null === (r = s.actions) || void 0 === r || null === (o = r.values) || void 0 === o ? void 0 : o.length) > 0 && (null === (a = this.actionMatcher) || void 0 === a || a.register(e.conditions.actions.values), null === (l = e.conditions) || void 0 === l || null === (c = l.actions) || void 0 === c || null === (u = c.values) || void 0 === u || u.forEach((t)=>{
                    if (t && t.name) {
                        const i = this.actionToSurveys.get(t.name);
                        i && i.push(e.id), this.actionToSurveys.set(t.name, i || [
                            e.id
                        ]);
                    }
                }));
            });
        }
    }
    setupEventBasedSurveys(e) {
        var t;
        if (0 === e.filter((e)=>{
            var t, i, n, s;
            return (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (i = e.conditions) || void 0 === i || null === (n = i.events) || void 0 === n || null === (s = n.values) || void 0 === s ? void 0 : s.length) > 0;
        }).length) return;
        null === (t = this.instance) || void 0 === t || t._addCaptureHook((e, t)=>{
            this.onEvent(e, t);
        }), e.forEach((e)=>{
            var t, i, n;
            null === (t = e.conditions) || void 0 === t || null === (i = t.events) || void 0 === i || null === (n = i.values) || void 0 === n || n.forEach((t)=>{
                if (t && t.name) {
                    const i = this.eventToSurveys.get(t.name);
                    i && i.push(e.id), this.eventToSurveys.set(t.name, i || [
                        e.id
                    ]);
                }
            });
        });
    }
    onEvent(e, t) {
        var i, n;
        const s = (null === (i = this.instance) || void 0 === i || null === (n = i.persistence) || void 0 === n ? void 0 : n.props[$fad8677fba5f5b13$var$we]) || [];
        if ($fad8677fba5f5b13$var$bs.SURVEY_SHOWN_EVENT_NAME == e && t && s.length > 0) {
            var r;
            const e = null == t || null === (r = t.properties) || void 0 === r ? void 0 : r.$survey_id;
            if (e) {
                const t = s.indexOf(e);
                t >= 0 && (s.splice(t, 1), this._updateActivatedSurveys(s));
            }
        } else this.eventToSurveys.has(e) && this._updateActivatedSurveys(s.concat(this.eventToSurveys.get(e) || []));
    }
    onAction(e) {
        var t, i;
        const n = (null === (t = this.instance) || void 0 === t || null === (i = t.persistence) || void 0 === i ? void 0 : i.props[$fad8677fba5f5b13$var$we]) || [];
        this.actionToSurveys.has(e) && this._updateActivatedSurveys(n.concat(this.actionToSurveys.get(e) || []));
    }
    _updateActivatedSurveys(e) {
        var t, i;
        null === (t = this.instance) || void 0 === t || null === (i = t.persistence) || void 0 === i || i.register({
            [$fad8677fba5f5b13$var$we]: [
                ...new Set(e)
            ]
        });
    }
    getSurveys() {
        var e, t;
        const i = null === (e = this.instance) || void 0 === e || null === (t = e.persistence) || void 0 === t ? void 0 : t.props[$fad8677fba5f5b13$var$we];
        return i || [];
    }
    getEventToSurveys() {
        return this.eventToSurveys;
    }
    _getActionMatcher() {
        return this.actionMatcher;
    }
}
var $fad8677fba5f5b13$var$ws, $fad8677fba5f5b13$var$Ss, $fad8677fba5f5b13$var$Es, $fad8677fba5f5b13$var$ks, $fad8677fba5f5b13$var$xs, $fad8677fba5f5b13$var$Is, $fad8677fba5f5b13$var$Ps, $fad8677fba5f5b13$var$Fs, $fad8677fba5f5b13$var$Rs = {}, $fad8677fba5f5b13$var$Ts = [], $fad8677fba5f5b13$var$$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $fad8677fba5f5b13$var$Cs = Array.isArray;
function $fad8677fba5f5b13$var$Ms(e, t) {
    for(var i in t)e[i] = t[i];
    return e;
}
function $fad8677fba5f5b13$var$As(e) {
    var t = e.parentNode;
    t && t.removeChild(e);
}
function $fad8677fba5f5b13$var$Ls(e, t, i, n, s) {
    var r = {
        type: e,
        props: t,
        key: i,
        ref: n,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == s ? ++$fad8677fba5f5b13$var$Es : s,
        __i: -1,
        __u: 0
    };
    return null == s && null != $fad8677fba5f5b13$var$Ss.vnode && $fad8677fba5f5b13$var$Ss.vnode(r), r;
}
function $fad8677fba5f5b13$var$Os(e) {
    return e.children;
}
function $fad8677fba5f5b13$var$Ds(e, t) {
    this.props = e, this.context = t;
}
function $fad8677fba5f5b13$var$Ns(e, t) {
    if (null == t) return e.__ ? $fad8677fba5f5b13$var$Ns(e.__, e.__i + 1) : null;
    for(var i; t < e.__k.length; t++)if (null != (i = e.__k[t]) && null != i.__e) return i.__e;
    return "function" == typeof e.type ? $fad8677fba5f5b13$var$Ns(e) : null;
}
function $fad8677fba5f5b13$var$qs(e) {
    var t, i;
    if (null != (e = e.__) && null != e.__c) {
        for(e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)if (null != (i = e.__k[t]) && null != i.__e) {
            e.__e = e.__c.base = i.__e;
            break;
        }
        return $fad8677fba5f5b13$var$qs(e);
    }
}
function $fad8677fba5f5b13$var$Bs(e) {
    (!e.__d && (e.__d = !0) && $fad8677fba5f5b13$var$ks.push(e) && !$fad8677fba5f5b13$var$Hs.__r++ || $fad8677fba5f5b13$var$xs !== $fad8677fba5f5b13$var$Ss.debounceRendering) && (($fad8677fba5f5b13$var$xs = $fad8677fba5f5b13$var$Ss.debounceRendering) || $fad8677fba5f5b13$var$Is)($fad8677fba5f5b13$var$Hs);
}
function $fad8677fba5f5b13$var$Hs() {
    var e, t, i, n, s, r, o, a, l;
    for($fad8677fba5f5b13$var$ks.sort($fad8677fba5f5b13$var$Ps); e = $fad8677fba5f5b13$var$ks.shift();)e.__d && (t = $fad8677fba5f5b13$var$ks.length, n = void 0, r = (s = (i = e).__v).__e, a = [], l = [], (o = i.__P) && ((n = $fad8677fba5f5b13$var$Ms({}, s)).__v = s.__v + 1, $fad8677fba5f5b13$var$Ss.vnode && $fad8677fba5f5b13$var$Ss.vnode(n), $fad8677fba5f5b13$var$Ys(o, n, s, i.__n, void 0 !== o.ownerSVGElement, 32 & s.__u ? [
        r
    ] : null, a, null == r ? $fad8677fba5f5b13$var$Ns(s) : r, !!(32 & s.__u), l), n.__.__k[n.__i] = n, $fad8677fba5f5b13$var$Xs(a, n, l), n.__e != r && $fad8677fba5f5b13$var$qs(n)), $fad8677fba5f5b13$var$ks.length > t && $fad8677fba5f5b13$var$ks.sort($fad8677fba5f5b13$var$Ps));
    $fad8677fba5f5b13$var$Hs.__r = 0;
}
function $fad8677fba5f5b13$var$Us(e, t, i, n, s, r, o, a, l, c, u) {
    var d, h, _, p, g, f = n && n.__k || $fad8677fba5f5b13$var$Ts, v = t.length;
    for(i.__d = l, $fad8677fba5f5b13$var$Ws(i, t, f), l = i.__d, d = 0; d < v; d++)null != (_ = i.__k[d]) && "boolean" != typeof _ && "function" != typeof _ && (h = -1 === _.__i ? $fad8677fba5f5b13$var$Rs : f[_.__i] || $fad8677fba5f5b13$var$Rs, _.__i = d, $fad8677fba5f5b13$var$Ys(e, _, h, s, r, o, a, l, c, u), p = _.__e, _.ref && h.ref != _.ref && (h.ref && $fad8677fba5f5b13$var$Zs(h.ref, null, _), u.push(_.ref, _.__c || p, _)), null == g && null != p && (g = p), 65536 & _.__u || h.__k === _.__k ? l = $fad8677fba5f5b13$var$zs(_, l, e) : "function" == typeof _.type && void 0 !== _.__d ? l = _.__d : p && (l = p.nextSibling), _.__d = void 0, _.__u &= -196609);
    i.__d = l, i.__e = g;
}
function $fad8677fba5f5b13$var$Ws(e, t, i) {
    var n, s, r, o, a, l = t.length, c = i.length, u = c, d = 0;
    for(e.__k = [], n = 0; n < l; n++)null != (s = e.__k[n] = null == (s = t[n]) || "boolean" == typeof s || "function" == typeof s ? null : "string" == typeof s || "number" == typeof s || "bigint" == typeof s || s.constructor == String ? $fad8677fba5f5b13$var$Ls(null, s, null, null, s) : $fad8677fba5f5b13$var$Cs(s) ? $fad8677fba5f5b13$var$Ls($fad8677fba5f5b13$var$Os, {
        children: s
    }, null, null, null) : void 0 === s.constructor && s.__b > 0 ? $fad8677fba5f5b13$var$Ls(s.type, s.props, s.key, s.ref ? s.ref : null, s.__v) : s) ? (s.__ = e, s.__b = e.__b + 1, a = $fad8677fba5f5b13$var$Vs(s, i, o = n + d, u), s.__i = a, r = null, -1 !== a && (u--, (r = i[a]) && (r.__u |= 131072)), null == r || null === r.__v ? (-1 == a && d--, "function" != typeof s.type && (s.__u |= 65536)) : a !== o && (a === o + 1 ? d++ : a > o ? u > l - o ? d += a - o : d-- : d = a < o && a == o - 1 ? a - o : 0, a !== n + d && (s.__u |= 65536))) : (r = i[n]) && null == r.key && r.__e && (r.__e == e.__d && (e.__d = $fad8677fba5f5b13$var$Ns(r)), $fad8677fba5f5b13$var$er(r, r, !1), i[n] = null, u--);
    if (u) for(n = 0; n < c; n++)null != (r = i[n]) && 0 == (131072 & r.__u) && (r.__e == e.__d && (e.__d = $fad8677fba5f5b13$var$Ns(r)), $fad8677fba5f5b13$var$er(r, r));
}
function $fad8677fba5f5b13$var$zs(e, t, i) {
    var n, s;
    if ("function" == typeof e.type) {
        for(n = e.__k, s = 0; n && s < n.length; s++)n[s] && (n[s].__ = e, t = $fad8677fba5f5b13$var$zs(n[s], t, i));
        return t;
    }
    return e.__e != t && (i.insertBefore(e.__e, t || null), t = e.__e), t && t.nextSibling;
}
function $fad8677fba5f5b13$var$Vs(e, t, i, n) {
    var s = e.key, r = e.type, o = i - 1, a = i + 1, l = t[i];
    if (null === l || l && s == l.key && r === l.type) return i;
    if (n > (null != l && 0 == (131072 & l.__u) ? 1 : 0)) for(; o >= 0 || a < t.length;){
        if (o >= 0) {
            if ((l = t[o]) && 0 == (131072 & l.__u) && s == l.key && r === l.type) return o;
            o--;
        }
        if (a < t.length) {
            if ((l = t[a]) && 0 == (131072 & l.__u) && s == l.key && r === l.type) return a;
            a++;
        }
    }
    return -1;
}
function $fad8677fba5f5b13$var$Gs(e, t, i) {
    "-" === t[0] ? e.setProperty(t, null == i ? "" : i) : e[t] = null == i ? "" : "number" != typeof i || $fad8677fba5f5b13$var$$s.test(t) ? i : i + "px";
}
function $fad8677fba5f5b13$var$js(e, t, i, n, s) {
    var r;
    e: if ("style" === t) {
        if ("string" == typeof i) e.style.cssText = i;
        else {
            if ("string" == typeof n && (e.style.cssText = n = ""), n) for(t in n)i && t in i || $fad8677fba5f5b13$var$Gs(e.style, t, "");
            if (i) for(t in i)n && i[t] === n[t] || $fad8677fba5f5b13$var$Gs(e.style, t, i[t]);
        }
    } else if ("o" === t[0] && "n" === t[1]) r = t !== (t = t.replace(/(PointerCapture)$|Capture$/, "$1")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + r] = i, i ? n ? i.u = n.u : (i.u = Date.now(), e.addEventListener(t, r ? $fad8677fba5f5b13$var$Js : $fad8677fba5f5b13$var$Qs, r)) : e.removeEventListener(t, r ? $fad8677fba5f5b13$var$Js : $fad8677fba5f5b13$var$Qs, r);
    else {
        if (s) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && "role" !== t && t in e) try {
            e[t] = null == i ? "" : i;
            break e;
        } catch (e) {}
        "function" == typeof i || (null == i || !1 === i && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, i));
    }
}
function $fad8677fba5f5b13$var$Qs(e) {
    var t = this.l[e.type + !1];
    if (e.t) {
        if (e.t <= t.u) return;
    } else e.t = Date.now();
    return t($fad8677fba5f5b13$var$Ss.event ? $fad8677fba5f5b13$var$Ss.event(e) : e);
}
function $fad8677fba5f5b13$var$Js(e) {
    return this.l[e.type + !0]($fad8677fba5f5b13$var$Ss.event ? $fad8677fba5f5b13$var$Ss.event(e) : e);
}
function $fad8677fba5f5b13$var$Ys(e, t, i, n, s, r, o, a, l, c) {
    var u, d, h, _, p, g, f, v, m, y, b, w, S, E, k, x = t.type;
    if (void 0 !== t.constructor) return null;
    128 & i.__u && (l = !!(32 & i.__u), r = [
        a = t.__e = i.__e
    ]), (u = $fad8677fba5f5b13$var$Ss.__b) && u(t);
    e: if ("function" == typeof x) try {
        if (v = t.props, m = (u = x.contextType) && n[u.__c], y = u ? m ? m.props.value : u.__ : n, i.__c ? f = (d = t.__c = i.__c).__ = d.__E : ("prototype" in x && x.prototype.render ? t.__c = d = new x(v, y) : (t.__c = d = new $fad8677fba5f5b13$var$Ds(v, y), d.constructor = x, d.render = $fad8677fba5f5b13$var$tr), m && m.sub(d), d.props = v, d.state || (d.state = {}), d.context = y, d.__n = n, h = d.__d = !0, d.__h = [], d._sb = []), null == d.__s && (d.__s = d.state), null != x.getDerivedStateFromProps && (d.__s == d.state && (d.__s = $fad8677fba5f5b13$var$Ms({}, d.__s)), $fad8677fba5f5b13$var$Ms(d.__s, x.getDerivedStateFromProps(v, d.__s))), _ = d.props, p = d.state, d.__v = t, h) null == x.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);
        else {
            if (null == x.getDerivedStateFromProps && v !== _ && null != d.componentWillReceiveProps && d.componentWillReceiveProps(v, y), !d.__e && (null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(v, d.__s, y) || t.__v === i.__v)) {
                for(t.__v !== i.__v && (d.props = v, d.state = d.__s, d.__d = !1), t.__e = i.__e, t.__k = i.__k, t.__k.forEach(function(e) {
                    e && (e.__ = t);
                }), b = 0; b < d._sb.length; b++)d.__h.push(d._sb[b]);
                d._sb = [], d.__h.length && o.push(d);
                break e;
            }
            null != d.componentWillUpdate && d.componentWillUpdate(v, d.__s, y), null != d.componentDidUpdate && d.__h.push(function() {
                d.componentDidUpdate(_, p, g);
            });
        }
        if (d.context = y, d.props = v, d.__P = e, d.__e = !1, w = $fad8677fba5f5b13$var$Ss.__r, S = 0, "prototype" in x && x.prototype.render) {
            for(d.state = d.__s, d.__d = !1, w && w(t), u = d.render(d.props, d.state, d.context), E = 0; E < d._sb.length; E++)d.__h.push(d._sb[E]);
            d._sb = [];
        } else do d.__d = !1, w && w(t), u = d.render(d.props, d.state, d.context), d.state = d.__s;
        while (d.__d && ++S < 25);
        d.state = d.__s, null != d.getChildContext && (n = $fad8677fba5f5b13$var$Ms($fad8677fba5f5b13$var$Ms({}, n), d.getChildContext())), h || null == d.getSnapshotBeforeUpdate || (g = d.getSnapshotBeforeUpdate(_, p)), $fad8677fba5f5b13$var$Us(e, $fad8677fba5f5b13$var$Cs(k = null != u && u.type === $fad8677fba5f5b13$var$Os && null == u.key ? u.props.children : u) ? k : [
            k
        ], t, i, n, s, r, o, a, l, c), d.base = t.__e, t.__u &= -161, d.__h.length && o.push(d), f && (d.__E = d.__ = null);
    } catch (e) {
        t.__v = null, l || null != r ? (t.__e = a, t.__u |= l ? 160 : 32, r[r.indexOf(a)] = null) : (t.__e = i.__e, t.__k = i.__k), $fad8677fba5f5b13$var$Ss.__e(e, t, i);
    }
    else null == r && t.__v === i.__v ? (t.__k = i.__k, t.__e = i.__e) : t.__e = $fad8677fba5f5b13$var$Ks(i.__e, t, i, n, s, r, o, l, c);
    (u = $fad8677fba5f5b13$var$Ss.diffed) && u(t);
}
function $fad8677fba5f5b13$var$Xs(e, t, i) {
    t.__d = void 0;
    for(var n = 0; n < i.length; n++)$fad8677fba5f5b13$var$Zs(i[n], i[++n], i[++n]);
    $fad8677fba5f5b13$var$Ss.__c && $fad8677fba5f5b13$var$Ss.__c(t, e), e.some(function(t) {
        try {
            e = t.__h, t.__h = [], e.some(function(e) {
                e.call(t);
            });
        } catch (e) {
            $fad8677fba5f5b13$var$Ss.__e(e, t.__v);
        }
    });
}
function $fad8677fba5f5b13$var$Ks(e, t, i, n, s, r, o, a, l) {
    var c, u, d, h, _, p, g, f = i.props, v = t.props, m = t.type;
    if ("svg" === m && (s = !0), null != r) {
        for(c = 0; c < r.length; c++)if ((_ = r[c]) && "setAttribute" in _ == !!m && (m ? _.localName === m : 3 === _.nodeType)) {
            e = _, r[c] = null;
            break;
        }
    }
    if (null == e) {
        if (null === m) return document.createTextNode(v);
        e = s ? document.createElementNS("http://www.w3.org/2000/svg", m) : document.createElement(m, v.is && v), r = null, a = !1;
    }
    if (null === m) f === v || a && e.data === v || (e.data = v);
    else {
        if (r = r && $fad8677fba5f5b13$var$ws.call(e.childNodes), f = i.props || $fad8677fba5f5b13$var$Rs, !a && null != r) for(f = {}, c = 0; c < e.attributes.length; c++)f[(_ = e.attributes[c]).name] = _.value;
        for(c in f)_ = f[c], "children" == c || ("dangerouslySetInnerHTML" == c ? d = _ : "key" === c || c in v || $fad8677fba5f5b13$var$js(e, c, null, _, s));
        for(c in v)_ = v[c], "children" == c ? h = _ : "dangerouslySetInnerHTML" == c ? u = _ : "value" == c ? p = _ : "checked" == c ? g = _ : "key" === c || a && "function" != typeof _ || f[c] === _ || $fad8677fba5f5b13$var$js(e, c, _, f[c], s);
        if (u) a || d && (u.__html === d.__html || u.__html === e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];
        else if (d && (e.innerHTML = ""), $fad8677fba5f5b13$var$Us(e, $fad8677fba5f5b13$var$Cs(h) ? h : [
            h
        ], t, i, n, s && "foreignObject" !== m, r, o, r ? r[0] : i.__k && $fad8677fba5f5b13$var$Ns(i, 0), a, l), null != r) for(c = r.length; c--;)null != r[c] && $fad8677fba5f5b13$var$As(r[c]);
        a || (c = "value", void 0 !== p && (p !== e[c] || "progress" === m && !p || "option" === m && p !== f[c]) && $fad8677fba5f5b13$var$js(e, c, p, f[c], !1), c = "checked", void 0 !== g && g !== e[c] && $fad8677fba5f5b13$var$js(e, c, g, f[c], !1));
    }
    return e;
}
function $fad8677fba5f5b13$var$Zs(e, t, i) {
    try {
        "function" == typeof e ? e(t) : e.current = t;
    } catch (e) {
        $fad8677fba5f5b13$var$Ss.__e(e, i);
    }
}
function $fad8677fba5f5b13$var$er(e, t, i) {
    var n, s;
    if ($fad8677fba5f5b13$var$Ss.unmount && $fad8677fba5f5b13$var$Ss.unmount(e), (n = e.ref) && (n.current && n.current !== e.__e || $fad8677fba5f5b13$var$Zs(n, null, t)), null != (n = e.__c)) {
        if (n.componentWillUnmount) try {
            n.componentWillUnmount();
        } catch (e) {
            $fad8677fba5f5b13$var$Ss.__e(e, t);
        }
        n.base = n.__P = null, e.__c = void 0;
    }
    if (n = e.__k) for(s = 0; s < n.length; s++)n[s] && $fad8677fba5f5b13$var$er(n[s], t, i || "function" != typeof e.type);
    i || null == e.__e || $fad8677fba5f5b13$var$As(e.__e), e.__ = e.__e = e.__d = void 0;
}
function $fad8677fba5f5b13$var$tr(e, t, i) {
    return this.constructor(e, i);
}
$fad8677fba5f5b13$var$ws = $fad8677fba5f5b13$var$Ts.slice, $fad8677fba5f5b13$var$Ss = {
    __e: function(e, t, i, n) {
        for(var s, r, o; t = t.__;)if ((s = t.__c) && !s.__) try {
            if ((r = s.constructor) && null != r.getDerivedStateFromError && (s.setState(r.getDerivedStateFromError(e)), o = s.__d), null != s.componentDidCatch && (s.componentDidCatch(e, n || {}), o = s.__d), o) return s.__E = s;
        } catch (t) {
            e = t;
        }
        throw e;
    }
}, $fad8677fba5f5b13$var$Es = 0, $fad8677fba5f5b13$var$Ds.prototype.setState = function(e, t) {
    var i;
    i = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $fad8677fba5f5b13$var$Ms({}, this.state), "function" == typeof e && (e = e($fad8677fba5f5b13$var$Ms({}, i), this.props)), e && $fad8677fba5f5b13$var$Ms(i, e), null != e && this.__v && (t && this._sb.push(t), $fad8677fba5f5b13$var$Bs(this));
}, $fad8677fba5f5b13$var$Ds.prototype.forceUpdate = function(e) {
    this.__v && (this.__e = !0, e && this.__h.push(e), $fad8677fba5f5b13$var$Bs(this));
}, $fad8677fba5f5b13$var$Ds.prototype.render = $fad8677fba5f5b13$var$Os, $fad8677fba5f5b13$var$ks = [], $fad8677fba5f5b13$var$Is = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $fad8677fba5f5b13$var$Ps = function(e, t) {
    return e.__v.__b - t.__v.__b;
}, $fad8677fba5f5b13$var$Hs.__r = 0, $fad8677fba5f5b13$var$Fs = 0;
!function(e, t) {
    var i = {
        __c: t = "__cC" + $fad8677fba5f5b13$var$Fs++,
        __: e,
        Consumer: function(e, t) {
            return e.children(t);
        },
        Provider: function(e) {
            var i, n;
            return this.getChildContext || (i = [], (n = {})[t] = this, this.getChildContext = function() {
                return n;
            }, this.shouldComponentUpdate = function(e) {
                this.props.value !== e.value && i.some(function(e) {
                    e.__e = !0, $fad8677fba5f5b13$var$Bs(e);
                });
            }, this.sub = function(e) {
                i.push(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function() {
                    i.splice(i.indexOf(e), 1), t && t.call(e);
                };
            }), e.children;
        }
    };
    i.Provider.__ = i.Consumer.contextType = i;
}({
    isPreviewMode: !1,
    previewPageIndex: 0,
    handleCloseSurveyPopup: ()=>{},
    isPopup: !0
});
const $fad8677fba5f5b13$var$ir = "[Surveys]", $fad8677fba5f5b13$var$nr = {
    icontains: (t)=>!!$fad8677fba5f5b13$var$e && $fad8677fba5f5b13$var$e.location.href.toLowerCase().indexOf(t.toLowerCase()) > -1,
    not_icontains: (t)=>!!$fad8677fba5f5b13$var$e && -1 === $fad8677fba5f5b13$var$e.location.href.toLowerCase().indexOf(t.toLowerCase()),
    regex: (t)=>!!$fad8677fba5f5b13$var$e && $fad8677fba5f5b13$var$ot($fad8677fba5f5b13$var$e.location.href, t),
    not_regex: (t)=>!!$fad8677fba5f5b13$var$e && !$fad8677fba5f5b13$var$ot($fad8677fba5f5b13$var$e.location.href, t),
    exact: (t)=>(null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.location.href) === t,
    is_not: (t)=>(null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.location.href) !== t
};
class $fad8677fba5f5b13$var$sr {
    constructor(e){
        this.instance = e, this._surveyEventReceiver = null;
    }
    afterDecideResponse(e) {
        this._decideServerResponse = !!e.surveys, this.loadIfEnabled();
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        const e = (()=>{
            const e = [];
            for(let t = 0; t < localStorage.length; t++){
                const i = localStorage.key(t);
                null != i && i.startsWith("seenSurvey_") && e.push(i);
            }
            return e;
        })();
        e.forEach((e)=>localStorage.removeItem(e));
    }
    loadIfEnabled() {
        var e;
        const t = null == $fad8677fba5f5b13$var$h || null === (e = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === e ? void 0 : e.generateSurveys;
        var i, n;
        this.instance.config.disable_surveys || !this._decideServerResponse || t || (null == this._surveyEventReceiver && (this._surveyEventReceiver = new $fad8677fba5f5b13$var$bs(this.instance)), null === (i = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === i || null === (n = i.loadExternalDependency) || void 0 === n || n.call(i, this.instance, "surveys", (e)=>{
            var t, i;
            if (e) return $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$ir, "Could not load surveys script", e);
            this._surveyManager = null === (t = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === t || null === (i = t.generateSurveys) || void 0 === i ? void 0 : i.call(t, this.instance);
        }));
    }
    getSurveys(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (this.instance.config.disable_surveys) return e([]);
        null == this._surveyEventReceiver && (this._surveyEventReceiver = new $fad8677fba5f5b13$var$bs(this.instance));
        const i = this.instance.get_property($fad8677fba5f5b13$var$be);
        if (i && !t) return e(i);
        this.instance._send_request({
            url: this.instance.requestRouter.endpointFor("api", `/api/surveys/?token=${this.instance.config.token}`),
            method: "GET",
            transport: "XHR",
            callback: (t)=>{
                var i;
                if (200 !== t.statusCode || !t.json) return e([]);
                const n = t.json.surveys || [], s = n.filter((e)=>{
                    var t, i, n, s, r, o, a, l, c, u, d, h;
                    return (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (i = e.conditions) || void 0 === i || null === (n = i.events) || void 0 === n ? void 0 : n.values) && (null === (s = e.conditions) || void 0 === s || null === (r = s.events) || void 0 === r || null === (o = r.values) || void 0 === o ? void 0 : o.length) > 0 || (null === (a = e.conditions) || void 0 === a ? void 0 : a.actions) && (null === (l = e.conditions) || void 0 === l || null === (c = l.actions) || void 0 === c ? void 0 : c.values) && (null === (u = e.conditions) || void 0 === u || null === (d = u.actions) || void 0 === d || null === (h = d.values) || void 0 === h ? void 0 : h.length) > 0;
                });
                var r;
                s.length > 0 && (null === (r = this._surveyEventReceiver) || void 0 === r || r.register(s));
                return null === (i = this.instance.persistence) || void 0 === i || i.register({
                    [$fad8677fba5f5b13$var$be]: n
                }), e(n);
            }
        });
    }
    getActiveMatchingSurveys(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        this.getSurveys((t)=>{
            var i;
            const n = t.filter((e)=>!(!e.start_date || e.end_date)).filter((e)=>{
                var t, i, n, s;
                if (!e.conditions) return !0;
                const r = null === (t = e.conditions) || void 0 === t || !t.url || $fad8677fba5f5b13$var$nr[null !== (i = null === (n = e.conditions) || void 0 === n ? void 0 : n.urlMatchType) && void 0 !== i ? i : "icontains"](e.conditions.url), a = null === (s = e.conditions) || void 0 === s || !s.selector || (null == $fad8677fba5f5b13$var$o ? void 0 : $fad8677fba5f5b13$var$o.querySelector(e.conditions.selector));
                return r && a;
            }), s = null === (i = this._surveyEventReceiver) || void 0 === i ? void 0 : i.getSurveys(), r = n.filter((e)=>{
                var t, i, n, r, o, a, l, c, u, d;
                if (!e.linked_flag_key && !e.targeting_flag_key && !e.internal_targeting_flag_key) return !0;
                const h = !e.linked_flag_key || this.instance.featureFlags.isFeatureEnabled(e.linked_flag_key), _ = !e.targeting_flag_key || this.instance.featureFlags.isFeatureEnabled(e.targeting_flag_key), p = (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (i = e.conditions) || void 0 === i || null === (n = i.events) || void 0 === n ? void 0 : n.values) && (null === (r = e.conditions) || void 0 === r || null === (o = r.events) || void 0 === o ? void 0 : o.values.length) > 0, g = (null === (a = e.conditions) || void 0 === a ? void 0 : a.actions) && (null === (l = e.conditions) || void 0 === l || null === (c = l.actions) || void 0 === c ? void 0 : c.values) && (null === (u = e.conditions) || void 0 === u || null === (d = u.actions) || void 0 === d ? void 0 : d.values.length) > 0, f = !p && !g || (null == s ? void 0 : s.includes(e.id)), v = this._canActivateRepeatedly(e), m = !(e.internal_targeting_flag_key && !v) || this.instance.featureFlags.isFeatureEnabled(e.internal_targeting_flag_key);
                return h && _ && m && f;
            });
            return e(r);
        }, t);
    }
    getNextSurveyStep(e, t, i) {
        var n;
        const s = e.questions[t], r = t + 1;
        if (null === (n = s.branching) || void 0 === n || !n.type) return t === e.questions.length - 1 ? $fad8677fba5f5b13$export$bbed2da3bd3bb001.End : r;
        if (s.branching.type === $fad8677fba5f5b13$export$bbed2da3bd3bb001.End) return $fad8677fba5f5b13$export$bbed2da3bd3bb001.End;
        if (s.branching.type === $fad8677fba5f5b13$export$bbed2da3bd3bb001.SpecificQuestion) {
            if (Number.isInteger(s.branching.index)) return s.branching.index;
        } else if (s.branching.type === $fad8677fba5f5b13$export$bbed2da3bd3bb001.ResponseBased) {
            if (s.type === $fad8677fba5f5b13$export$9c2ac61661d417f8.SingleChoice) {
                var o, a;
                const e = s.choices.indexOf(`${i}`);
                if (null !== (o = s.branching) && void 0 !== o && null !== (a = o.responseValues) && void 0 !== a && a.hasOwnProperty(e)) {
                    const t = s.branching.responseValues[e];
                    return Number.isInteger(t) ? t : t === $fad8677fba5f5b13$export$bbed2da3bd3bb001.End ? $fad8677fba5f5b13$export$bbed2da3bd3bb001.End : r;
                }
            } else if (s.type === $fad8677fba5f5b13$export$9c2ac61661d417f8.Rating) {
                var l, c;
                if ("number" != typeof i || !Number.isInteger(i)) throw new Error("The response type must be an integer");
                const e = function(e, t) {
                    if (3 === t) {
                        if (e < 1 || e > 3) throw new Error("The response must be in range 1-3");
                        return 1 === e ? "negative" : 2 === e ? "neutral" : "positive";
                    }
                    if (5 === t) {
                        if (e < 1 || e > 5) throw new Error("The response must be in range 1-5");
                        return e <= 2 ? "negative" : 3 === e ? "neutral" : "positive";
                    }
                    if (7 === t) {
                        if (e < 1 || e > 7) throw new Error("The response must be in range 1-7");
                        return e <= 3 ? "negative" : 4 === e ? "neutral" : "positive";
                    }
                    if (10 === t) {
                        if (e < 0 || e > 10) throw new Error("The response must be in range 0-10");
                        return e <= 6 ? "detractors" : e <= 8 ? "passives" : "promoters";
                    }
                    throw new Error("The scale must be one of: 3, 5, 7, 10");
                }(i, s.scale);
                if (null !== (l = s.branching) && void 0 !== l && null !== (c = l.responseValues) && void 0 !== c && c.hasOwnProperty(e)) {
                    const t = s.branching.responseValues[e];
                    return Number.isInteger(t) ? t : t === $fad8677fba5f5b13$export$bbed2da3bd3bb001.End ? $fad8677fba5f5b13$export$bbed2da3bd3bb001.End : r;
                }
            }
            return r;
        }
        return $fad8677fba5f5b13$var$$.warn($fad8677fba5f5b13$var$ir, "Falling back to next question index due to unexpected branching type"), r;
    }
    _canActivateRepeatedly(e) {
        var t;
        return $fad8677fba5f5b13$var$I(null === (t = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === t ? void 0 : t.canActivateRepeatedly) ? ($fad8677fba5f5b13$var$$.warn($fad8677fba5f5b13$var$ir, "canActivateRepeatedly is not defined, must init before calling"), !1) : $fad8677fba5f5b13$var$h.__PosthogExtensions__.canActivateRepeatedly(e);
    }
    canRenderSurvey(e) {
        $fad8677fba5f5b13$var$I(this._surveyManager) ? $fad8677fba5f5b13$var$$.warn($fad8677fba5f5b13$var$ir, "canActivateRepeatedly is not defined, must init before calling") : this.getSurveys((t)=>{
            const i = t.filter((t)=>t.id === e)[0];
            this._surveyManager.canRenderSurvey(i);
        });
    }
    renderSurvey(e, t) {
        $fad8677fba5f5b13$var$I(this._surveyManager) ? $fad8677fba5f5b13$var$$.warn($fad8677fba5f5b13$var$ir, "canActivateRepeatedly is not defined, must init before calling") : this.getSurveys((i)=>{
            const n = i.filter((t)=>t.id === e)[0];
            this._surveyManager.renderSurvey(n, null == $fad8677fba5f5b13$var$o ? void 0 : $fad8677fba5f5b13$var$o.querySelector(t));
        });
    }
}
class $fad8677fba5f5b13$var$rr {
    serverLimits = {};
    lastEventRateLimited = !1;
    constructor(e){
        var t, i;
        this.instance = e, this.captureEventsPerSecond = (null === (t = e.config.rate_limiting) || void 0 === t ? void 0 : t.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null === (i = e.config.rate_limiting) || void 0 === i ? void 0 : i.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    clientRateLimitContext() {
        var e, t, i;
        let n = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        const s = (new Date).getTime(), r = null !== (e = null === (t = this.instance.persistence) || void 0 === t ? void 0 : t.get_property($fad8677fba5f5b13$var$xe)) && void 0 !== e ? e : {
            tokens: this.captureEventsBurstLimit,
            last: s
        };
        r.tokens += (s - r.last) / 1e3 * this.captureEventsPerSecond, r.last = s, r.tokens > this.captureEventsBurstLimit && (r.tokens = this.captureEventsBurstLimit);
        const o = r.tokens < 1;
        return o || n || (r.tokens = Math.max(0, r.tokens - 1)), !o || this.lastEventRateLimited || n || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: `posthog-js client rate limited. Config is set to ${this.captureEventsPerSecond} events per second and ${this.captureEventsBurstLimit} events burst limit.`
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = o, null === (i = this.instance.persistence) || void 0 === i || i.set_property($fad8677fba5f5b13$var$xe, r), {
            isRateLimited: o,
            remainingTokens: r.tokens
        };
    }
    isServerRateLimited(e) {
        const t = this.serverLimits[e || "events"] || !1;
        return !1 !== t && (new Date).getTime() < t;
    }
    checkForLimiting = (e)=>{
        const t = e.text;
        if (t && t.length) try {
            const e = JSON.parse(t);
            (e.quota_limited || []).forEach((e)=>{
                $fad8677fba5f5b13$var$$.info(`[RateLimiter] ${e || "events"} is quota limited.`), this.serverLimits[e] = (new Date).getTime() + 6e4;
            });
        } catch (e) {
            return void $fad8677fba5f5b13$var$$.warn(`[RateLimiter] could not rate limit - continuing. Error: "${null == e ? void 0 : e.message}"`, {
                text: t
            });
        }
    };
}
const $fad8677fba5f5b13$var$or = ()=>({
        initialPathName: (null == $fad8677fba5f5b13$var$a ? void 0 : $fad8677fba5f5b13$var$a.pathname) || "",
        referringDomain: $fad8677fba5f5b13$var$ai.referringDomain(),
        ...$fad8677fba5f5b13$var$ai.campaignParams()
    });
class $fad8677fba5f5b13$var$ar {
    constructor(e, t, i){
        this._sessionIdManager = e, this._persistence = t, this._sessionSourceParamGenerator = i || $fad8677fba5f5b13$var$or, this._sessionIdManager.onSessionId(this._onSessionIdCallback);
    }
    _getStoredProps() {
        return this._persistence.props[$fad8677fba5f5b13$var$ke];
    }
    _onSessionIdCallback = (e)=>{
        const t = this._getStoredProps();
        if (t && t.sessionId === e) return;
        const i = {
            sessionId: e,
            props: this._sessionSourceParamGenerator()
        };
        this._persistence.register({
            [$fad8677fba5f5b13$var$ke]: i
        });
    };
    getSessionProps() {
        var e;
        const t = null === (e = this._getStoredProps()) || void 0 === e ? void 0 : e.props;
        return t ? {
            $client_session_initial_referring_host: t.referringDomain,
            $client_session_initial_pathname: t.initialPathName,
            $client_session_initial_utm_source: t.utm_source,
            $client_session_initial_utm_campaign: t.utm_campaign,
            $client_session_initial_utm_medium: t.utm_medium,
            $client_session_initial_utm_content: t.utm_content,
            $client_session_initial_utm_term: t.utm_term
        } : {};
    }
}
const $fad8677fba5f5b13$var$lr = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "applebot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "bot.htm",
    "bot.php",
    "crawler",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "gptbot",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "semrushbot",
    "sitebulb",
    "slurp",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "headlesschrome",
    "cypress",
    "Google-HotelAdsVerifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "Bytespider;"
], $fad8677fba5f5b13$var$cr = function(e, t) {
    if (!e) return !1;
    const i = e.toLowerCase();
    return $fad8677fba5f5b13$var$lr.concat(t || []).some((e)=>{
        const t = e.toLowerCase();
        return -1 !== i.indexOf(t);
    });
}, $fad8677fba5f5b13$var$ur = function(e, t) {
    if (!e) return !1;
    const i = e.userAgent;
    if (i && $fad8677fba5f5b13$var$cr(i, t)) return !0;
    try {
        const i = null == e ? void 0 : e.userAgentData;
        if (null != i && i.brands && i.brands.some((e)=>$fad8677fba5f5b13$var$cr(null == e ? void 0 : e.brand, t))) return !0;
    } catch  {}
    return !!e.webdriver;
};
class $fad8677fba5f5b13$var$dr {
    constructor(){
        this.clicks = [];
    }
    isRageClick(e, t, i) {
        const n = this.clicks[this.clicks.length - 1];
        if (n && Math.abs(e - n.x) + Math.abs(t - n.y) < 30 && i - n.timestamp < 1e3) {
            if (this.clicks.push({
                x: e,
                y: t,
                timestamp: i
            }), 3 === this.clicks.length) return !0;
        } else this.clicks = [
            {
                x: e,
                y: t,
                timestamp: i
            }
        ];
        return !1;
    }
}
function $fad8677fba5f5b13$var$hr(e) {
    var t;
    return e.id === $fad8677fba5f5b13$var$Te || !(null === (t = e.closest) || void 0 === t || !t.call(e, "#" + $fad8677fba5f5b13$var$Te));
}
class $fad8677fba5f5b13$var$_r {
    rageclicks = new $fad8677fba5f5b13$var$dr;
    _enabledServerSide = !1;
    _initialized = !1;
    _flushInterval = null;
    constructor(t){
        var i;
        this.instance = t, this._enabledServerSide = !(null === (i = this.instance.persistence) || void 0 === i || !i.props[$fad8677fba5f5b13$var$te]), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("beforeunload", ()=>{
            this.flush();
        });
    }
    get flushIntervalMilliseconds() {
        let e = 5e3;
        return $fad8677fba5f5b13$var$b(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (e = this.instance.config.capture_heatmaps.flush_interval_milliseconds), e;
    }
    get isEnabled() {
        return $fad8677fba5f5b13$var$S(this.instance.config.capture_heatmaps) ? $fad8677fba5f5b13$var$S(this.instance.config.enable_heatmaps) ? this._enabledServerSide : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this._initialized) return;
            $fad8677fba5f5b13$var$$.info("[heatmaps] starting..."), this._setupListeners(), this._flushInterval = setInterval(this.flush.bind(this), this.flushIntervalMilliseconds);
        } else {
            var e;
            clearInterval(null !== (e = this._flushInterval) && void 0 !== e ? e : void 0), this.getAndClearBuffer();
        }
    }
    afterDecideResponse(e) {
        const t = !!e.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [$fad8677fba5f5b13$var$te]: t
        }), this._enabledServerSide = t, this.startIfEnabled();
    }
    getAndClearBuffer() {
        const e = this.buffer;
        return this.buffer = void 0, e;
    }
    _setupListeners() {
        $fad8677fba5f5b13$var$e && $fad8677fba5f5b13$var$o && ($fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$o, "click", (t)=>this._onClick(t || (null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.event)), !1, !0), $fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$o, "mousemove", (t)=>this._onMouseMove(t || (null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.event)), !1, !0), this._initialized = !0);
    }
    _getProperties(t, i) {
        const n = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), r = this.instance.scrollManager.scrollElement(), o = function(t, i, n) {
            let s = t;
            for(; s && $fad8677fba5f5b13$var$bi(s) && !$fad8677fba5f5b13$var$wi(s, "body");){
                if (s === n) return !1;
                if ($fad8677fba5f5b13$var$N(i, null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.getComputedStyle(s).position)) return !0;
                s = $fad8677fba5f5b13$var$xi(s);
            }
            return !1;
        }($fad8677fba5f5b13$var$yi(t), [
            "fixed",
            "sticky"
        ], r);
        return {
            x: t.clientX + (o ? 0 : s),
            y: t.clientY + (o ? 0 : n),
            target_fixed: o,
            type: i
        };
    }
    _onClick(e) {
        var t;
        if ($fad8677fba5f5b13$var$hr(e.target)) return;
        const i = this._getProperties(e, "click");
        null !== (t = this.rageclicks) && void 0 !== t && t.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._capture({
            ...i,
            type: "rageclick"
        }), this._capture(i);
    }
    _onMouseMove(e) {
        $fad8677fba5f5b13$var$hr(e.target) || (clearTimeout(this._mouseMoveTimeout), this._mouseMoveTimeout = setTimeout(()=>{
            this._capture(this._getProperties(e, "mousemove"));
        }, 500));
    }
    _capture(t) {
        if (!$fad8677fba5f5b13$var$e) return;
        const i = $fad8677fba5f5b13$var$e.location.href;
        this.buffer = this.buffer || {}, this.buffer[i] || (this.buffer[i] = []), this.buffer[i].push(t);
    }
    flush() {
        this.buffer && !$fad8677fba5f5b13$var$w(this.buffer) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class $fad8677fba5f5b13$var$pr {
    constructor(e){
        this.instance = e;
    }
    getContext() {
        return this.context;
    }
    resetContext() {
        const e = this.context;
        return setTimeout(this._updateScrollData, 0), e;
    }
    _updateScrollData = ()=>{
        var e, t, i, n;
        this.context || (this.context = {});
        const s = this.scrollElement(), r = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = r + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
        this.context.lastScrollY = Math.ceil(r), this.context.maxScrollY = Math.max(r, null !== (e = this.context.maxScrollY) && void 0 !== e ? e : 0), this.context.maxScrollHeight = Math.max(o, null !== (t = this.context.maxScrollHeight) && void 0 !== t ? t : 0), this.context.lastContentY = a, this.context.maxContentY = Math.max(a, null !== (i = this.context.maxContentY) && void 0 !== i ? i : 0), this.context.maxContentHeight = Math.max(l, null !== (n = this.context.maxContentHeight) && void 0 !== n ? n : 0);
    };
    startMeasuringScrollPosition() {
        null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("scroll", this._updateScrollData, !0), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("scrollend", this._updateScrollData, !0), null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.addEventListener("resize", this._updateScrollData);
    }
    scrollElement() {
        if (!this.instance.config.scroll_root_selector) return null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.document.documentElement;
        {
            const t = $fad8677fba5f5b13$var$m(this.instance.config.scroll_root_selector) ? this.instance.config.scroll_root_selector : [
                this.instance.config.scroll_root_selector
            ];
            for (const i of t){
                const t = null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.document.querySelector(i);
                if (t) return t;
            }
        }
    }
    scrollY() {
        if (this.instance.config.scroll_root_selector) {
            const e = this.scrollElement();
            return e && e.scrollTop || 0;
        }
        return $fad8677fba5f5b13$var$e && ($fad8677fba5f5b13$var$e.scrollY || $fad8677fba5f5b13$var$e.pageYOffset || $fad8677fba5f5b13$var$e.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this.instance.config.scroll_root_selector) {
            const e = this.scrollElement();
            return e && e.scrollLeft || 0;
        }
        return $fad8677fba5f5b13$var$e && ($fad8677fba5f5b13$var$e.scrollX || $fad8677fba5f5b13$var$e.pageXOffset || $fad8677fba5f5b13$var$e.document.documentElement.scrollLeft) || 0;
    }
}
const $fad8677fba5f5b13$var$gr = "$copy_autocapture";
function $fad8677fba5f5b13$var$fr(e, t) {
    return t.length > e ? t.slice(0, e) + "..." : t;
}
class $fad8677fba5f5b13$var$vr {
    _initialized = !1;
    _isDisabledServerSide = null;
    rageclicks = new $fad8677fba5f5b13$var$dr;
    _elementsChainAsString = !1;
    constructor(e){
        this.instance = e, this._elementSelectors = null;
    }
    get config() {
        var e, t;
        const i = $fad8677fba5f5b13$var$b(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return i.url_allowlist = null === (e = i.url_allowlist) || void 0 === e ? void 0 : e.map((e)=>new RegExp(e)), i.url_ignorelist = null === (t = i.url_ignorelist) || void 0 === t ? void 0 : t.map((e)=>new RegExp(e)), i;
    }
    _addDomEventHandlers() {
        if (!this.isBrowserSupported()) return void $fad8677fba5f5b13$var$$.info("Disabling Automatic Event Collection because this browser is not supported");
        if (!$fad8677fba5f5b13$var$e || !$fad8677fba5f5b13$var$o) return;
        const t = (t)=>{
            t = t || (null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.event);
            try {
                this._captureEvent(t);
            } catch (e) {
                $fad8677fba5f5b13$var$$.error("Failed to capture event", e);
            }
        }, i = (t)=>{
            t = t || (null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.event), this._captureEvent(t, $fad8677fba5f5b13$var$gr);
        };
        $fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$o, "submit", t, !1, !0), $fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$o, "change", t, !1, !0), $fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$o, "click", t, !1, !0), this.config.capture_copied_text && ($fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$o, "copy", i, !1, !0), $fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$o, "cut", i, !1, !0));
    }
    startIfEnabled() {
        this.isEnabled && !this._initialized && (this._addDomEventHandlers(), this._initialized = !0);
    }
    afterDecideResponse(e) {
        e.elementsChainAsString && (this._elementsChainAsString = e.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [$fad8677fba5f5b13$var$ee]: !!e.autocapture_opt_out
        }), this._isDisabledServerSide = !!e.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(e) {
        this._elementSelectors = e;
    }
    getElementSelectors(e) {
        var t;
        const i = [];
        return null === (t = this._elementSelectors) || void 0 === t || t.forEach((t)=>{
            const n = null == $fad8677fba5f5b13$var$o ? void 0 : $fad8677fba5f5b13$var$o.querySelectorAll(t);
            null == n || n.forEach((n)=>{
                e === n && i.push(t);
            });
        }), i;
    }
    get isEnabled() {
        var e, t;
        const i = null === (e = this.instance.persistence) || void 0 === e ? void 0 : e.props[$fad8677fba5f5b13$var$ee], n = this._isDisabledServerSide;
        if ($fad8677fba5f5b13$var$x(n) && !$fad8677fba5f5b13$var$F(i) && !this.instance.config.advanced_disable_decide) return !1;
        const s = null !== (t = this._isDisabledServerSide) && void 0 !== t ? t : !!i;
        return !!this.instance.config.autocapture && !s;
    }
    _previousElementSibling(e) {
        if (e.previousElementSibling) return e.previousElementSibling;
        let t = e;
        do t = t.previousSibling;
        while (t && !$fad8677fba5f5b13$var$bi(t));
        return t;
    }
    _getAugmentPropertiesFromElement(e) {
        if (!$fad8677fba5f5b13$var$Pi(e)) return {};
        const t = {};
        return $fad8677fba5f5b13$var$O(e.attributes, function(e) {
            if (e.name && 0 === e.name.indexOf("data-ph-capture-attribute")) {
                const i = e.name.replace("data-ph-capture-attribute-", ""), n = e.value;
                i && n && $fad8677fba5f5b13$var$Li(n) && (t[i] = n);
            }
        }), t;
    }
    _getPropertiesFromElement(e, t, i) {
        var n;
        const s = e.tagName.toLowerCase(), r = {
            tag_name: s
        };
        $fad8677fba5f5b13$var$ki.indexOf(s) > -1 && !i && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? r.$el_text = $fad8677fba5f5b13$var$fr(1024, $fad8677fba5f5b13$var$Oi(e)) : r.$el_text = $fad8677fba5f5b13$var$fr(1024, $fad8677fba5f5b13$var$mi(e)));
        const o = $fad8677fba5f5b13$var$fi(e);
        o.length > 0 && (r.classes = o.filter(function(e) {
            return "" !== e;
        }));
        const a = null === (n = this.config) || void 0 === n ? void 0 : n.element_attribute_ignorelist;
        $fad8677fba5f5b13$var$O(e.attributes, function(i) {
            var n;
            if ((!$fad8677fba5f5b13$var$Fi(e) || -1 !== [
                "name",
                "id",
                "class",
                "aria-label"
            ].indexOf(i.name)) && (null == a || !a.includes(i.name)) && !t && $fad8677fba5f5b13$var$Li(i.value) && (n = i.name, !$fad8677fba5f5b13$var$E(n) || "_ngcontent" !== n.substring(0, 10) && "_nghost" !== n.substring(0, 7))) {
                let e = i.value;
                "class" === i.name && (e = $fad8677fba5f5b13$var$pi(e).join(" ")), r["attr__" + i.name] = $fad8677fba5f5b13$var$fr(1024, e);
            }
        });
        let l = 1, c = 1, u = e;
        for(; u = this._previousElementSibling(u);)l++, u.tagName === e.tagName && c++;
        return r.nth_child = l, r.nth_of_type = c, r;
    }
    _getDefaultProperties(e) {
        return {
            $event_type: e,
            $ce_version: 1
        };
    }
    _captureEvent(t) {
        let i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "$autocapture";
        if (!this.isEnabled) return;
        let n = $fad8677fba5f5b13$var$yi(t);
        var s;
        ($fad8677fba5f5b13$var$Si(n) && (n = n.parentNode || null), "$autocapture" === i && "click" === t.type && t instanceof MouseEvent) && this.instance.config.rageclick && null !== (s = this.rageclicks) && void 0 !== s && s.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this._captureEvent(t, "$rageclick");
        const r = i === $fad8677fba5f5b13$var$gr;
        if (n && $fad8677fba5f5b13$var$Ii(n, t, this.config, r, r ? [
            "copy",
            "cut"
        ] : void 0)) {
            var o, a;
            const s = [
                n
            ];
            let r = n;
            for(; r.parentNode && !$fad8677fba5f5b13$var$wi(r, "body");)$fad8677fba5f5b13$var$Ei(r.parentNode) ? (s.push(r.parentNode.host), r = r.parentNode.host) : (s.push(r.parentNode), r = r.parentNode);
            const d = [], h = {};
            let _, p, g = !1;
            if ($fad8677fba5f5b13$var$O(s, (e)=>{
                const t = $fad8677fba5f5b13$var$Pi(e);
                "a" === e.tagName.toLowerCase() && (_ = e.getAttribute("href"), _ = t && $fad8677fba5f5b13$var$Li(_) && _);
                $fad8677fba5f5b13$var$N($fad8677fba5f5b13$var$fi(e), "ph-no-capture") && (g = !0), d.push(this._getPropertiesFromElement(e, this.instance.config.mask_all_element_attributes, this.instance.config.mask_all_text));
                const i = this._getAugmentPropertiesFromElement(e);
                $fad8677fba5f5b13$var$D(h, i);
            }), this.instance.config.mask_all_text || ("a" === n.tagName.toLowerCase() || "button" === n.tagName.toLowerCase() ? d[0].$el_text = $fad8677fba5f5b13$var$Oi(n) : d[0].$el_text = $fad8677fba5f5b13$var$mi(n)), _) {
                var l, c;
                d[0].attr__href = _;
                const t = null === (l = $fad8677fba5f5b13$var$rt(_)) || void 0 === l ? void 0 : l.host, i = null == $fad8677fba5f5b13$var$e || null === (c = $fad8677fba5f5b13$var$e.location) || void 0 === c ? void 0 : c.host;
                t && i && t !== i && (p = _);
            }
            if (g) return !1;
            const f = $fad8677fba5f5b13$var$D(this._getDefaultProperties(t.type), this._elementsChainAsString ? {
                $elements_chain: $fad8677fba5f5b13$var$Ni(d)
            } : {
                $elements: d
            }, null !== (o = d[0]) && void 0 !== o && o.$el_text ? {
                $el_text: null === (a = d[0]) || void 0 === a ? void 0 : a.$el_text
            } : {}, p && "click" === t.type ? {
                $external_click_url: p
            } : {}, h), v = this.getElementSelectors(n);
            if (v && v.length > 0 && (f.$element_selectors = v), i === $fad8677fba5f5b13$var$gr) {
                var u;
                const i = $fad8677fba5f5b13$var$vi(null == $fad8677fba5f5b13$var$e || null === (u = $fad8677fba5f5b13$var$e.getSelection()) || void 0 === u ? void 0 : u.toString()), n = t.type || "clipboard";
                if (!i) return !1;
                f.$selected_content = i, f.$copy_type = n;
            }
            return this.instance.capture(i, f), !0;
        }
    }
    isBrowserSupported() {
        return $fad8677fba5f5b13$var$y(null == $fad8677fba5f5b13$var$o ? void 0 : $fad8677fba5f5b13$var$o.querySelectorAll);
    }
}
class $fad8677fba5f5b13$var$mr {
    _restoreXHRPatch = void 0;
    _restoreFetchPatch = void 0;
    constructor(e){
        this.instance = e;
    }
    _loadScript(e) {
        var t, i, n;
        null !== (t = $fad8677fba5f5b13$var$h.__PosthogExtensions__) && void 0 !== t && t.tracingHeadersPatchFns && e(), null === (i = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === i || null === (n = i.loadExternalDependency) || void 0 === n || n.call(i, this.instance, "tracing-headers", (t)=>{
            if (t) return $fad8677fba5f5b13$var$$.error("[TRACING-HEADERS] failed to load script", t);
            e();
        });
    }
    startIfEnabledOrStop() {
        var e, t;
        this.instance.config.__add_tracing_headers ? this._loadScript(this._startCapturing) : (null === (e = this._restoreXHRPatch) || void 0 === e || e.call(this), null === (t = this._restoreFetchPatch) || void 0 === t || t.call(this), this._restoreXHRPatch = void 0, this._restoreFetchPatch = void 0);
    }
    _startCapturing = ()=>{
        var e, t, i, n;
        $fad8677fba5f5b13$var$S(this._restoreXHRPatch) && (null === (e = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === e || null === (t = e.tracingHeadersPatchFns) || void 0 === t || t._patchXHR(this.instance.sessionManager));
        $fad8677fba5f5b13$var$S(this._restoreFetchPatch) && (null === (i = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === i || null === (n = i.tracingHeadersPatchFns) || void 0 === n || n._patchFetch(this.instance.sessionManager));
    };
}
let $fad8677fba5f5b13$var$yr;
!function(e) {
    e[e.PENDING = -1] = "PENDING", e[e.DENIED = 0] = "DENIED", e[e.GRANTED = 1] = "GRANTED";
}($fad8677fba5f5b13$var$yr || ($fad8677fba5f5b13$var$yr = {}));
class $fad8677fba5f5b13$var$br {
    constructor(e){
        this.instance = e;
    }
    get config() {
        return this.instance.config;
    }
    get consent() {
        return this.getDnt() ? $fad8677fba5f5b13$var$yr.DENIED : this.storedConsent;
    }
    isOptedOut() {
        return this.consent === $fad8677fba5f5b13$var$yr.DENIED || this.consent === $fad8677fba5f5b13$var$yr.PENDING && this.config.opt_out_capturing_by_default;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    optInOut(e) {
        this.storage.set(this.storageKey, e ? 1 : 0, this.config.cookie_expiration, this.config.cross_subdomain_cookie, this.config.secure_cookie);
    }
    reset() {
        this.storage.remove(this.storageKey, this.config.cross_subdomain_cookie);
    }
    get storageKey() {
        const { token: e, opt_out_capturing_cookie_prefix: t } = this.instance.config;
        return (t || "__ph_opt_in_out_") + e;
    }
    get storedConsent() {
        const e = this.storage.get(this.storageKey);
        return "1" === e ? $fad8677fba5f5b13$var$yr.GRANTED : "0" === e ? $fad8677fba5f5b13$var$yr.DENIED : $fad8677fba5f5b13$var$yr.PENDING;
    }
    get storage() {
        if (!this._storage) {
            const e = this.config.opt_out_capturing_persistence_type;
            this._storage = "localStorage" === e ? $fad8677fba5f5b13$var$Xe : $fad8677fba5f5b13$var$Je;
            const t = "localStorage" === e ? $fad8677fba5f5b13$var$Je : $fad8677fba5f5b13$var$Xe;
            t.get(this.storageKey) && (this._storage.get(this.storageKey) || this.optInOut("1" === t.get(this.storageKey)), t.remove(this.storageKey, this.config.cross_subdomain_cookie));
        }
        return this._storage;
    }
    getDnt() {
        return !!this.config.respect_dnt && !!$fad8677fba5f5b13$var$Q([
            null == $fad8677fba5f5b13$var$r ? void 0 : $fad8677fba5f5b13$var$r.doNotTrack,
            null == $fad8677fba5f5b13$var$r ? void 0 : $fad8677fba5f5b13$var$r.msDoNotTrack,
            $fad8677fba5f5b13$var$h.doNotTrack
        ], (e)=>$fad8677fba5f5b13$var$N([
                !0,
                1,
                "1",
                "yes"
            ], e));
    }
}
const $fad8677fba5f5b13$var$wr = "[Exception Autocapture]";
class $fad8677fba5f5b13$var$Sr {
    originalOnUnhandledRejectionHandler = void 0;
    constructor(e){
        var t;
        this.instance = e, this.remoteEnabled = !(null === (t = this.instance.persistence) || void 0 === t || !t.props[$fad8677fba5f5b13$var$ie]), this.startIfEnabled();
    }
    get isEnabled() {
        var e;
        return null !== (e = this.remoteEnabled) && void 0 !== e && e;
    }
    get isCapturing() {
        var t;
        return !(null == $fad8677fba5f5b13$var$e || null === (t = $fad8677fba5f5b13$var$e.onerror) || void 0 === t || !t.__POSTHOG_INSTRUMENTED__);
    }
    get hasHandlers() {
        return this.originalOnUnhandledRejectionHandler || this.unwrapOnError;
    }
    startIfEnabled() {
        this.isEnabled && !this.isCapturing && ($fad8677fba5f5b13$var$$.info($fad8677fba5f5b13$var$wr + " enabled, starting..."), this.loadScript(this.startCapturing));
    }
    loadScript(e) {
        var t, i;
        this.hasHandlers && e(), null === (t = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === t || null === (i = t.loadExternalDependency) || void 0 === i || i.call(t, this.instance, "exception-autocapture", (t)=>{
            if (t) return $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$wr + " failed to load script", t);
            e();
        });
    }
    startCapturing = ()=>{
        var t, i, n, s;
        if (!$fad8677fba5f5b13$var$e || !this.isEnabled || this.hasHandlers || this.isCapturing) return;
        const r = null === (t = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === t || null === (i = t.errorWrappingFunctions) || void 0 === i ? void 0 : i.wrapOnError, o = null === (n = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === n || null === (s = n.errorWrappingFunctions) || void 0 === s ? void 0 : s.wrapUnhandledRejection;
        if (r && o) try {
            this.unwrapOnError = r(this.captureException.bind(this)), this.unwrapUnhandledRejection = o(this.captureException.bind(this));
        } catch (e) {
            $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$wr + " failed to start", e), this.stopCapturing();
        }
        else $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$wr + " failed to load error wrapping functions - cannot start");
    };
    stopCapturing() {
        var e, t;
        null === (e = this.unwrapOnError) || void 0 === e || e.call(this), null === (t = this.unwrapUnhandledRejection) || void 0 === t || t.call(this);
    }
    afterDecideResponse(e) {
        const t = e.autocaptureExceptions;
        this.remoteEnabled = !!t || !1, this.instance.persistence && this.instance.persistence.register({
            [$fad8677fba5f5b13$var$ie]: this.remoteEnabled
        }), this.startIfEnabled();
    }
    captureException(e) {
        const t = this.instance.requestRouter.endpointFor("ui");
        e.$exception_personURL = `${t}/project/${this.instance.config.token}/person/${this.instance.get_distinct_id()}`, this.instance.exceptions.sendExceptionEvent(e);
    }
}
const $fad8677fba5f5b13$var$Er = 9e5, $fad8677fba5f5b13$var$kr = "[Web Vitals]";
class $fad8677fba5f5b13$var$xr {
    _enabledServerSide = !1;
    _initialized = !1;
    buffer = {
        url: void 0,
        metrics: [],
        firstMetricTimestamp: void 0
    };
    constructor(e){
        var t;
        this.instance = e, this._enabledServerSide = !(null === (t = this.instance.persistence) || void 0 === t || !t.props[$fad8677fba5f5b13$var$se]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var e, t;
        const i = $fad8677fba5f5b13$var$b(this.instance.config.capture_performance) ? null === (e = this.instance.config.capture_performance) || void 0 === e ? void 0 : e.web_vitals_allowed_metrics : void 0;
        return $fad8677fba5f5b13$var$S(i) ? (null === (t = this.instance.persistence) || void 0 === t ? void 0 : t.props[$fad8677fba5f5b13$var$re]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : i;
    }
    get flushToCaptureTimeoutMs() {
        return ($fad8677fba5f5b13$var$b(this.instance.config.capture_performance) ? this.instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get _maxAllowedValue() {
        const e = $fad8677fba5f5b13$var$b(this.instance.config.capture_performance) && $fad8677fba5f5b13$var$P(this.instance.config.capture_performance.__web_vitals_max_value) ? this.instance.config.capture_performance.__web_vitals_max_value : $fad8677fba5f5b13$var$Er;
        return 0 < e && e <= 6e4 ? $fad8677fba5f5b13$var$Er : e;
    }
    get isEnabled() {
        const e = $fad8677fba5f5b13$var$b(this.instance.config.capture_performance) ? this.instance.config.capture_performance.web_vitals : void 0;
        return $fad8677fba5f5b13$var$F(e) ? e : this._enabledServerSide;
    }
    startIfEnabled() {
        this.isEnabled && !this._initialized && ($fad8677fba5f5b13$var$$.info($fad8677fba5f5b13$var$kr + " enabled, starting..."), this.loadScript(this._startCapturing));
    }
    afterDecideResponse(e) {
        const t = $fad8677fba5f5b13$var$b(e.capturePerformance) && !!e.capturePerformance.web_vitals, i = $fad8677fba5f5b13$var$b(e.capturePerformance) ? e.capturePerformance.web_vitals_allowed_metrics : void 0;
        this.instance.persistence && (this.instance.persistence.register({
            [$fad8677fba5f5b13$var$se]: t
        }), this.instance.persistence.register({
            [$fad8677fba5f5b13$var$re]: i
        })), this._enabledServerSide = t, this.startIfEnabled();
    }
    loadScript(e) {
        var t, i, n;
        null !== (t = $fad8677fba5f5b13$var$h.__PosthogExtensions__) && void 0 !== t && t.postHogWebVitalsCallbacks && e(), null === (i = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === i || null === (n = i.loadExternalDependency) || void 0 === n || n.call(i, this.instance, "web-vitals", (t)=>{
            t ? $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$kr + " failed to load script", t) : e();
        });
    }
    _currentURL() {
        const t = $fad8677fba5f5b13$var$e ? $fad8677fba5f5b13$var$e.location.href : void 0;
        return t || $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$kr + "Could not determine current URL"), t;
    }
    _flushToCapture = ()=>{
        clearTimeout(this._delayedFlushTimer), 0 !== this.buffer.metrics.length && (this.instance.capture("$web_vitals", this.buffer.metrics.reduce((e, t)=>({
                ...e,
                [`$web_vitals_${t.name}_event`]: {
                    ...t
                },
                [`$web_vitals_${t.name}_value`]: t.value
            }), {})), this.buffer = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        });
    };
    _addToBuffer = (e)=>{
        var t;
        const i = null === (t = this.instance.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0);
        if ($fad8677fba5f5b13$var$S(i)) return void $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$kr + "Could not read session ID. Dropping metrics!");
        this.buffer = this.buffer || {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        };
        const n = this._currentURL();
        if ($fad8677fba5f5b13$var$S(n)) return;
        if ($fad8677fba5f5b13$var$I(null == e ? void 0 : e.name) || $fad8677fba5f5b13$var$I(null == e ? void 0 : e.value)) return void $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$kr + "Invalid metric received", e);
        if (this._maxAllowedValue && e.value >= this._maxAllowedValue) return void $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$kr + "Ignoring metric with value >= " + this._maxAllowedValue, e);
        this.buffer.url !== n && (this._flushToCapture(), this._delayedFlushTimer = setTimeout(this._flushToCapture, this.flushToCaptureTimeoutMs)), $fad8677fba5f5b13$var$S(this.buffer.url) && (this.buffer.url = n), this.buffer.firstMetricTimestamp = $fad8677fba5f5b13$var$S(this.buffer.firstMetricTimestamp) ? Date.now() : this.buffer.firstMetricTimestamp, e.attribution && e.attribution.interactionTargetElement && (e.attribution.interactionTargetElement = void 0), this.buffer.metrics.push({
            ...e,
            $current_url: n,
            $session_id: i.sessionId,
            $window_id: i.windowId,
            timestamp: Date.now()
        }), this.buffer.metrics.length === this.allowedMetrics.length && this._flushToCapture();
    };
    _startCapturing = ()=>{
        let e, t, i, n;
        const s = $fad8677fba5f5b13$var$h.__PosthogExtensions__;
        $fad8677fba5f5b13$var$S(s) || $fad8677fba5f5b13$var$S(s.postHogWebVitalsCallbacks) || ({ onLCP: e, onCLS: t, onFCP: i, onINP: n } = s.postHogWebVitalsCallbacks), e && t && i && n ? (this.allowedMetrics.indexOf("LCP") > -1 && e(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && t(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && i(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && n(this._addToBuffer.bind(this)), this._initialized = !0) : $fad8677fba5f5b13$var$$.error($fad8677fba5f5b13$var$kr + "web vitals callbacks not loaded - not starting");
    };
}
const $fad8677fba5f5b13$var$Ir = {
    icontains: (t, i)=>!!$fad8677fba5f5b13$var$e && i.href.toLowerCase().indexOf(t.toLowerCase()) > -1,
    not_icontains: (t, i)=>!!$fad8677fba5f5b13$var$e && -1 === i.href.toLowerCase().indexOf(t.toLowerCase()),
    regex: (t, i)=>!!$fad8677fba5f5b13$var$e && $fad8677fba5f5b13$var$ot(i.href, t),
    not_regex: (t, i)=>!!$fad8677fba5f5b13$var$e && !$fad8677fba5f5b13$var$ot(i.href, t),
    exact: (e, t)=>t.href === e,
    is_not: (e, t)=>t.href !== e
};
class $fad8677fba5f5b13$var$Pr {
    constructor(e){
        this.instance = e;
        const t = (e)=>{
            this.applyFeatureFlagChanges(e);
        };
        this.instance.onFeatureFlags && this.instance.onFeatureFlags(t), this._flagToExperiments = new Map;
    }
    applyFeatureFlagChanges(e) {
        $fad8677fba5f5b13$var$I(this._flagToExperiments) || this.instance.config.disable_web_experiments || ($fad8677fba5f5b13$var$Pr.logInfo("applying feature flags", e), e.forEach((e)=>{
            var t;
            if (this._flagToExperiments && null !== (t = this._flagToExperiments) && void 0 !== t && t.has(e)) {
                var i;
                const t = this.instance.getFeatureFlag(e), n = null === (i = this._flagToExperiments) || void 0 === i ? void 0 : i.get(e);
                t && null != n && n.variants[t] && this.applyTransforms(n.name, t, n.variants[t].transforms);
            }
        }));
    }
    afterDecideResponse(e) {
        this._is_bot() ? $fad8677fba5f5b13$var$Pr.logInfo("Refusing to render web experiment since the viewer is a likely bot") : (this._featureFlags = e.featureFlags, this.loadIfEnabled(), this.previewWebExperiment());
    }
    previewWebExperiment() {
        const e = $fad8677fba5f5b13$var$Pr.getWindowLocation();
        if (null != e && e.search) {
            const t = $fad8677fba5f5b13$var$lt(null == e ? void 0 : e.search, "__experiment_id"), i = $fad8677fba5f5b13$var$lt(null == e ? void 0 : e.search, "__experiment_variant");
            t && i && ($fad8677fba5f5b13$var$Pr.logInfo(`previewing web experiments ${t} && ${i}`), this.getWebExperiments((e)=>{
                this.showPreviewWebExperiment(parseInt(t), i, e);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this.instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperimentsAndEvaluateDisplayLogic = (()=>{
        var e = this;
        return function() {
            let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            e.getWebExperiments((t)=>{
                $fad8677fba5f5b13$var$Pr.logInfo("retrieved web experiments from the server"), e._flagToExperiments = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key && e._featureFlags && e._featureFlags[t.feature_flag_key]) {
                        var i;
                        if (e._flagToExperiments) $fad8677fba5f5b13$var$Pr.logInfo("setting flag key ", t.feature_flag_key, " to web experiment ", t), null === (i = e._flagToExperiments) || void 0 === i || i.set(t.feature_flag_key, t);
                        const n = e._featureFlags[t.feature_flag_key];
                        n && t.variants[n] && e.applyTransforms(t.name, n, t.variants[n].transforms);
                    } else if (t.variants) for(const i in t.variants){
                        const n = t.variants[i];
                        $fad8677fba5f5b13$var$Pr.matchesTestVariant(n) && e.applyTransforms(t.name, i, n.transforms);
                    }
                });
            }, t);
        };
    })();
    getWebExperiments(e, t, i) {
        if (this.instance.config.disable_web_experiments && !i) return e([]);
        const n = this.instance.get_property("$web_experiments");
        if (n && !t) return e(n);
        this.instance._send_request({
            url: this.instance.requestRouter.endpointFor("api", `/api/web_experiments/?token=${this.instance.config.token}`),
            method: "GET",
            transport: "XHR",
            callback: (t)=>{
                if (200 !== t.statusCode || !t.json) return e([]);
                const i = t.json.experiments || [];
                return e(i);
            }
        });
    }
    showPreviewWebExperiment(e, t, i) {
        const n = i.filter((t)=>t.id === e);
        n && n.length > 0 && ($fad8677fba5f5b13$var$Pr.logInfo(`Previewing web experiment [${n[0].name}] with variant [${t}]`), this.applyTransforms(n[0].name, t, n[0].variants[t].transforms, !0));
    }
    static matchesTestVariant(e) {
        return !$fad8677fba5f5b13$var$I(e.conditions) && $fad8677fba5f5b13$var$Pr.matchUrlConditions(e) && $fad8677fba5f5b13$var$Pr.matchUTMConditions(e);
    }
    static matchUrlConditions(e) {
        var t;
        if ($fad8677fba5f5b13$var$I(e.conditions) || $fad8677fba5f5b13$var$I(null === (t = e.conditions) || void 0 === t ? void 0 : t.url)) return !0;
        const i = $fad8677fba5f5b13$var$Pr.getWindowLocation();
        if (i) {
            var n, s, r;
            return null === (n = e.conditions) || void 0 === n || !n.url || $fad8677fba5f5b13$var$Ir[null !== (s = null === (r = e.conditions) || void 0 === r ? void 0 : r.urlMatchType) && void 0 !== s ? s : "icontains"](e.conditions.url, i);
        }
        return !1;
    }
    static getWindowLocation() {
        return null == $fad8677fba5f5b13$var$e ? void 0 : $fad8677fba5f5b13$var$e.location;
    }
    static matchUTMConditions(e) {
        var t;
        if ($fad8677fba5f5b13$var$I(e.conditions) || $fad8677fba5f5b13$var$I(null === (t = e.conditions) || void 0 === t ? void 0 : t.utm)) return !0;
        const i = $fad8677fba5f5b13$var$ai.campaignParams();
        if (i.utm_source) {
            var n, s, r, o, a, l, c, u, d, h, _, p, g, f, v, m;
            const t = null === (n = e.conditions) || void 0 === n || null === (s = n.utm) || void 0 === s || !s.utm_campaign || (null === (r = e.conditions) || void 0 === r || null === (o = r.utm) || void 0 === o ? void 0 : o.utm_campaign) == i.utm_campaign, y = null === (a = e.conditions) || void 0 === a || null === (l = a.utm) || void 0 === l || !l.utm_source || (null === (c = e.conditions) || void 0 === c || null === (u = c.utm) || void 0 === u ? void 0 : u.utm_source) == i.utm_source, b = null === (d = e.conditions) || void 0 === d || null === (h = d.utm) || void 0 === h || !h.utm_medium || (null === (_ = e.conditions) || void 0 === _ || null === (p = _.utm) || void 0 === p ? void 0 : p.utm_medium) == i.utm_medium, w = null === (g = e.conditions) || void 0 === g || null === (f = g.utm) || void 0 === f || !f.utm_term || (null === (v = e.conditions) || void 0 === v || null === (m = v.utm) || void 0 === m ? void 0 : m.utm_term) == i.utm_term;
            return t && b && w && y;
        }
        return !1;
    }
    static logInfo(e) {
        for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)i[n - 1] = arguments[n];
        $fad8677fba5f5b13$var$$.info(`[WebExperiments] ${e}`, i);
    }
    applyTransforms(e, t, i, n) {
        var s;
        this._is_bot() ? $fad8677fba5f5b13$var$Pr.logInfo("Refusing to render web experiment since the viewer is a likely bot") : "control" !== t ? i.forEach((i)=>{
            if (i.selector) {
                var s;
                $fad8677fba5f5b13$var$Pr.logInfo(`applying transform of variant ${t} for experiment ${e} `, i);
                let o = 0;
                const a = null === (s = document) || void 0 === s ? void 0 : s.querySelectorAll(i.selector);
                var r;
                if (null == a || a.forEach((e)=>{
                    const t = e;
                    o += 1, i.attributes && i.attributes.forEach((e)=>{
                        switch(e.name){
                            case "text":
                                t.innerText = e.value;
                                break;
                            case "html":
                                t.innerHTML = e.value;
                                break;
                            case "cssClass":
                                t.className = e.value;
                                break;
                            default:
                                t.setAttribute(e.name, e.value);
                        }
                    }), i.text && (t.innerText = i.text), i.html && (t.parentElement ? t.parentElement.innerHTML = i.html : t.innerHTML = i.html), i.css && t.setAttribute("style", i.css);
                }), this.instance && this.instance.capture) this.instance.capture("$web_experiment_applied", {
                    $web_experiment_name: e,
                    $web_experiment_variant: t,
                    $web_experiment_preview: n,
                    $web_experiment_document_url: null === (r = $fad8677fba5f5b13$var$Pr.getWindowLocation()) || void 0 === r ? void 0 : r.href,
                    $web_experiment_elements_modified: o
                });
            }
        }) : ($fad8677fba5f5b13$var$Pr.logInfo("Control variants leave the page unmodified."), this.instance && this.instance.capture && this.instance.capture("$web_experiment_applied", {
            $web_experiment_name: e,
            $web_experiment_preview: n,
            $web_experiment_variant: t,
            $web_experiment_document_url: null === (s = $fad8677fba5f5b13$var$Pr.getWindowLocation()) || void 0 === s ? void 0 : s.href,
            $web_experiment_elements_modified: 0
        }));
    }
    _is_bot() {
        return $fad8677fba5f5b13$var$r && this.instance ? $fad8677fba5f5b13$var$ur($fad8677fba5f5b13$var$r, this.instance.config.custom_blocked_useragents) : void 0;
    }
}
const $fad8677fba5f5b13$var$Fr = "/e/";
class $fad8677fba5f5b13$var$Rr {
    constructor(e){
        var t;
        this.instance = e, this._endpointSuffix = (null === (t = this.instance.persistence) || void 0 === t ? void 0 : t.props[$fad8677fba5f5b13$var$ne]) || $fad8677fba5f5b13$var$Fr;
    }
    get endpoint() {
        return this.instance.requestRouter.endpointFor("api", this._endpointSuffix);
    }
    afterDecideResponse(e) {
        const t = e.autocaptureExceptions;
        this._endpointSuffix = $fad8677fba5f5b13$var$b(t) && t.endpoint || $fad8677fba5f5b13$var$Fr, this.instance.persistence && this.instance.persistence.register({
            [$fad8677fba5f5b13$var$ne]: this._endpointSuffix
        });
    }
    sendExceptionEvent(e) {
        this.instance.capture("$exception", e, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent",
            _url: this.endpoint
        });
    }
}
const $fad8677fba5f5b13$var$Tr = {}, $fad8677fba5f5b13$var$$r = ()=>{}, $fad8677fba5f5b13$var$Cr = "posthog";
let $fad8677fba5f5b13$var$Mr = !$fad8677fba5f5b13$var$Xn && -1 === (null == $fad8677fba5f5b13$var$d ? void 0 : $fad8677fba5f5b13$var$d.indexOf("MSIE")) && -1 === (null == $fad8677fba5f5b13$var$d ? void 0 : $fad8677fba5f5b13$var$d.indexOf("Mozilla"));
const $fad8677fba5f5b13$var$Ar = ()=>{
    var t;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: $fad8677fba5f5b13$var$j(null == $fad8677fba5f5b13$var$o ? void 0 : $fad8677fba5f5b13$var$o.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: $fad8677fba5f5b13$var$$r,
        store_google: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: "if_capture_pageview",
        debug: $fad8677fba5f5b13$var$a && $fad8677fba5f5b13$var$E(null == $fad8677fba5f5b13$var$a ? void 0 : $fad8677fba5f5b13$var$a.search) && -1 !== $fad8677fba5f5b13$var$a.search.indexOf("__posthog_debug=true") || !1,
        verbose: !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $fad8677fba5f5b13$var$e || null === (t = $fad8677fba5f5b13$var$e.location) || void 0 === t ? void 0 : t.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        inapp_protocol: "//",
        inapp_link_new_window: !1,
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        on_request_error: (e)=>{
            const t = "Bad HTTP status: " + e.statusCode + " " + e.text;
            $fad8677fba5f5b13$var$$.error(t);
        },
        get_device_id: (e)=>e,
        _onCapture: $fad8677fba5f5b13$var$$r,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        __add_tracing_headers: !1
    };
}, $fad8677fba5f5b13$var$Lr = (e)=>{
    const t = {};
    $fad8677fba5f5b13$var$S(e.process_person) || (t.person_profiles = e.process_person), $fad8677fba5f5b13$var$S(e.xhr_headers) || (t.request_headers = e.xhr_headers), $fad8677fba5f5b13$var$S(e.cookie_name) || (t.persistence_name = e.cookie_name), $fad8677fba5f5b13$var$S(e.disable_cookie) || (t.disable_persistence = e.disable_cookie);
    const i = $fad8677fba5f5b13$var$D({}, t, e);
    return $fad8677fba5f5b13$var$m(e.property_blacklist) && ($fad8677fba5f5b13$var$S(e.property_denylist) ? i.property_denylist = e.property_blacklist : $fad8677fba5f5b13$var$m(e.property_denylist) ? i.property_denylist = [
        ...e.property_blacklist,
        ...e.property_denylist
    ] : $fad8677fba5f5b13$var$$.error("Invalid value for property_denylist config: " + e.property_denylist)), i;
};
class $fad8677fba5f5b13$var$Or {
    get _forceAllowLocalhost() {
        return this.__forceAllowLocalhost;
    }
    set _forceAllowLocalhost(e) {
        $fad8677fba5f5b13$var$$.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
    }
    __forceAllowLocalhost = !1;
}
class $fad8677fba5f5b13$export$a9d6b9cbf49b8241 {
    webPerformance = new $fad8677fba5f5b13$var$Or;
    version = $fad8677fba5f5b13$var$_.LIB_VERSION;
    _internalEventEmitter = new $fad8677fba5f5b13$var$ms;
    constructor(){
        this.config = $fad8677fba5f5b13$var$Ar(), this.decideEndpointWasHit = !1, this.SentryIntegration = $fad8677fba5f5b13$var$hs, this.sentryIntegration = (e)=>(function(e, t) {
                const i = $fad8677fba5f5b13$var$ds(e, t);
                return {
                    name: $fad8677fba5f5b13$var$us,
                    processEvent: (e)=>i(e)
                };
            })(this, e), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this._initialPageviewCaptured = !1, this._initialPersonProfilesConfig = null, this.featureFlags = new $fad8677fba5f5b13$var$Oe(this), this.toolbar = new $fad8677fba5f5b13$var$Jn(this), this.scrollManager = new $fad8677fba5f5b13$var$pr(this), this.pageViewManager = new $fad8677fba5f5b13$var$ps(this), this.surveys = new $fad8677fba5f5b13$var$sr(this), this.experiments = new $fad8677fba5f5b13$var$Pr(this), this.exceptions = new $fad8677fba5f5b13$var$Rr(this), this.rateLimiter = new $fad8677fba5f5b13$var$rr(this), this.requestRouter = new $fad8677fba5f5b13$var$cs(this), this.consent = new $fad8677fba5f5b13$var$br(this), this.people = {
            set: (e, t, i)=>{
                const n = $fad8677fba5f5b13$var$E(e) ? {
                    [e]: t
                } : e;
                this.setPersonProperties(n), null == i || i({});
            },
            set_once: (e, t, i)=>{
                const n = $fad8677fba5f5b13$var$E(e) ? {
                    [e]: t
                } : e;
                this.setPersonProperties(void 0, n), null == i || i({});
            }
        }, this.on("eventCaptured", (e)=>$fad8677fba5f5b13$var$$.info(`send "${null == e ? void 0 : e.event}"`, e));
    }
    init(e, t, i) {
        if (i && i !== $fad8677fba5f5b13$var$Cr) {
            var n;
            const s = null !== (n = $fad8677fba5f5b13$var$Tr[i]) && void 0 !== n ? n : new $fad8677fba5f5b13$export$a9d6b9cbf49b8241;
            return s._init(e, t, i), $fad8677fba5f5b13$var$Tr[i] = s, $fad8677fba5f5b13$var$Tr[$fad8677fba5f5b13$var$Cr][i] = s, s;
        }
        return this._init(e, t, i);
    }
    _init(t) {
        var i, n;
        let s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
        if ($fad8677fba5f5b13$var$S(t) || $fad8677fba5f5b13$var$k(t)) return $fad8677fba5f5b13$var$$.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return $fad8677fba5f5b13$var$$.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, this._triggered_notifs = [], s.person_profiles && (this._initialPersonProfilesConfig = s.person_profiles), this.set_config($fad8677fba5f5b13$var$D({}, $fad8677fba5f5b13$var$Ar(), $fad8677fba5f5b13$var$Lr(s), {
            name: r,
            token: t
        })), this.config.on_xhr_error && $fad8677fba5f5b13$var$$.error("[posthog] on_xhr_error is deprecated. Use on_request_error instead"), this.compression = s.disable_compression ? void 0 : $fad8677fba5f5b13$export$6a00d17b5aff0af.GZipJS, this.persistence = new $fad8677fba5f5b13$var$ci(this.config), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $fad8677fba5f5b13$var$ci({
            ...this.config,
            persistence: "sessionStorage"
        });
        const o = {
            ...this.persistence.props
        }, a = {
            ...this.sessionPersistence.props
        };
        if (this._requestQueue = new $fad8677fba5f5b13$var$Yn((e)=>this._send_retriable_request(e)), this._retryQueue = new $fad8677fba5f5b13$var$rs(this), this.__request_queue = [], this.sessionManager = new $fad8677fba5f5b13$var$os(this.config, this.persistence), this.sessionPropsManager = new $fad8677fba5f5b13$var$ar(this.sessionManager, this.persistence), new $fad8677fba5f5b13$var$mr(this).startIfEnabledOrStop(), this.sessionRecording = new $fad8677fba5f5b13$var$zn(this), this.sessionRecording.startIfEnabledOrStop(), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new $fad8677fba5f5b13$var$vr(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new $fad8677fba5f5b13$var$_r(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new $fad8677fba5f5b13$var$xr(this), this.exceptionObserver = new $fad8677fba5f5b13$var$Sr(this), this.exceptionObserver.startIfEnabled(), $fad8677fba5f5b13$var$_.DEBUG = $fad8677fba5f5b13$var$_.DEBUG || this.config.debug, $fad8677fba5f5b13$var$_.DEBUG && $fad8677fba5f5b13$var$$.info("Starting in debug mode", {
            this: this,
            config: s,
            thisC: {
                ...this.config
            },
            p: o,
            s: a
        }), this._sync_opt_out_with_persistence(), void 0 !== (null === (i = s.bootstrap) || void 0 === i ? void 0 : i.distinctID)) {
            var l, c;
            const e = this.config.get_device_id($fad8677fba5f5b13$var$We()), t = null !== (l = s.bootstrap) && void 0 !== l && l.isIdentifiedID ? e : s.bootstrap.distinctID;
            this.persistence.set_property($fad8677fba5f5b13$var$Ee, null !== (c = s.bootstrap) && void 0 !== c && c.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: s.bootstrap.distinctID,
                $device_id: t
            });
        }
        if (this._hasBootstrappedFeatureFlags()) {
            var u, d;
            const e = Object.keys((null === (u = s.bootstrap) || void 0 === u ? void 0 : u.featureFlags) || {}).filter((e)=>{
                var t, i;
                return !(null === (t = s.bootstrap) || void 0 === t || null === (i = t.featureFlags) || void 0 === i || !i[e]);
            }).reduce((e, t)=>{
                var i, n;
                return e[t] = (null === (i = s.bootstrap) || void 0 === i || null === (n = i.featureFlags) || void 0 === n ? void 0 : n[t]) || !1, e;
            }, {}), t = Object.keys((null === (d = s.bootstrap) || void 0 === d ? void 0 : d.featureFlagPayloads) || {}).filter((t)=>e[t]).reduce((e, t)=>{
                var i, n, r, o;
                null !== (i = s.bootstrap) && void 0 !== i && null !== (n = i.featureFlagPayloads) && void 0 !== n && n[t] && (e[t] = null === (r = s.bootstrap) || void 0 === r || null === (o = r.featureFlagPayloads) || void 0 === o ? void 0 : o[t]);
                return e;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: e,
                featureFlagPayloads: t
            });
        }
        if (!this.get_distinct_id()) {
            const e = this.config.get_device_id($fad8677fba5f5b13$var$We());
            this.register_once({
                distinct_id: e,
                $device_id: e
            }, ""), this.persistence.set_property($fad8677fba5f5b13$var$Ee, "anonymous");
        }
        return null == $fad8677fba5f5b13$var$e || null === (n = $fad8677fba5f5b13$var$e.addEventListener) || void 0 === n || n.call($fad8677fba5f5b13$var$e, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this)), this.toolbar.maybeLoadToolbar(), s.segment ? $fad8677fba5f5b13$var$_s(this, ()=>this._loaded()) : this._loaded(), $fad8677fba5f5b13$var$y(this.config._onCapture) && this.on("eventCaptured", (e)=>this.config._onCapture(e.event, e)), this;
    }
    _afterDecideResponse(e) {
        var t, i, n, s, r, o, a, l, c;
        this.compression = void 0, e.supportedCompression && !this.config.disable_compression && (this.compression = $fad8677fba5f5b13$var$N(e.supportedCompression, $fad8677fba5f5b13$export$6a00d17b5aff0af.GZipJS) ? $fad8677fba5f5b13$export$6a00d17b5aff0af.GZipJS : $fad8677fba5f5b13$var$N(e.supportedCompression, $fad8677fba5f5b13$export$6a00d17b5aff0af.Base64) ? $fad8677fba5f5b13$export$6a00d17b5aff0af.Base64 : void 0), null !== (t = e.analytics) && void 0 !== t && t.endpoint && (this.analyticsDefaultEndpoint = e.analytics.endpoint), this.set_config({
            person_profiles: this._initialPersonProfilesConfig ? this._initialPersonProfilesConfig : e.defaultIdentifiedOnly ? "identified_only" : "always"
        }), null === (i = this.sessionRecording) || void 0 === i || i.afterDecideResponse(e), null === (n = this.autocapture) || void 0 === n || n.afterDecideResponse(e), null === (s = this.heatmaps) || void 0 === s || s.afterDecideResponse(e), null === (r = this.experiments) || void 0 === r || r.afterDecideResponse(e), null === (o = this.surveys) || void 0 === o || o.afterDecideResponse(e), null === (a = this.webVitalsAutocapture) || void 0 === a || a.afterDecideResponse(e), null === (l = this.exceptions) || void 0 === l || l.afterDecideResponse(e), null === (c = this.exceptionObserver) || void 0 === c || c.afterDecideResponse(e);
    }
    _loaded() {
        const e = this.config.advanced_disable_decide;
        e || this.featureFlags.setReloadingPaused(!0);
        try {
            this.config.loaded(this);
        } catch (e) {
            $fad8677fba5f5b13$var$$.critical("`loaded` function failed", e);
        }
        this._start_queue_if_opted_in(), this.config.capture_pageview && setTimeout(()=>{
            this.consent.isOptedIn() && this._captureInitialPageview();
        }, 1), e || (new $fad8677fba5f5b13$var$Vn(this).call(), this.featureFlags.resetRequestQueue());
    }
    _start_queue_if_opted_in() {
        var e;
        this.has_opted_out_capturing() || this.config.request_batching && (null === (e = this._requestQueue) || void 0 === e || e.enable());
    }
    _dom_loaded() {
        this.has_opted_out_capturing() || $fad8677fba5f5b13$var$L(this.__request_queue, (e)=>this._send_retriable_request(e)), this.__request_queue = [], this._start_queue_if_opted_in();
    }
    _handle_unload() {
        var e, t;
        this.config.request_batching ? (this._shouldCapturePageleave() && this.capture("$pageleave"), null === (e = this._requestQueue) || void 0 === e || e.unload(), null === (t = this._retryQueue) || void 0 === t || t.unload()) : this._shouldCapturePageleave() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    _send_request(e) {
        this.__loaded && ($fad8677fba5f5b13$var$Mr ? this.__request_queue.push(e) : this.rateLimiter.isServerRateLimited(e.batchKey) || (e.transport = e.transport || this.config.api_transport, e.url = $fad8677fba5f5b13$var$Zn(e.url, {
            ip: this.config.ip ? 1 : 0
        }), e.headers = {
            ...this.config.request_headers
        }, e.compression = "best-available" === e.compression ? this.compression : e.compression, ((e)=>{
            var t, i, n;
            const s = {
                ...e
            };
            s.timeout = s.timeout || 6e4, s.url = $fad8677fba5f5b13$var$Zn(s.url, {
                _: (new Date).getTime().toString(),
                ver: $fad8677fba5f5b13$var$_.LIB_VERSION,
                compression: s.compression
            });
            const r = null !== (t = s.transport) && void 0 !== t ? t : "XHR", o = null !== (i = null === (n = $fad8677fba5f5b13$var$Q($fad8677fba5f5b13$var$ss, (e)=>e.transport === r)) || void 0 === n ? void 0 : n.method) && void 0 !== i ? i : $fad8677fba5f5b13$var$ss[0].method;
            if (!o) throw new Error("No available transport method");
            o(s);
        })({
            ...e,
            callback: (t)=>{
                var i, n, s;
                (this.rateLimiter.checkForLimiting(t), t.statusCode >= 400) && (null === (n = (s = this.config).on_request_error) || void 0 === n || n.call(s, t));
                null === (i = e.callback) || void 0 === i || i.call(e, t);
            }
        })));
    }
    _send_retriable_request(e) {
        this._retryQueue ? this._retryQueue.retriableRequest(e) : this._send_request(e);
    }
    _execute_array(e) {
        let t;
        const i = [], n = [], s = [];
        $fad8677fba5f5b13$var$L(e, (e)=>{
            e && (t = e[0], $fad8677fba5f5b13$var$m(t) ? s.push(e) : $fad8677fba5f5b13$var$y(e) ? e.call(this) : $fad8677fba5f5b13$var$m(e) && "alias" === t ? i.push(e) : $fad8677fba5f5b13$var$m(e) && -1 !== t.indexOf("capture") && $fad8677fba5f5b13$var$y(this[t]) ? s.push(e) : n.push(e));
        });
        const r = function(e, t) {
            $fad8677fba5f5b13$var$L(e, function(e) {
                if ($fad8677fba5f5b13$var$m(e[0])) {
                    let i = t;
                    $fad8677fba5f5b13$var$O(e, function(e) {
                        i = i[e[0]].apply(i, e.slice(1));
                    });
                } else this[e[0]].apply(this, e.slice(1));
            }, t);
        };
        r(i, this), r(n, this), r(s, this);
    }
    _hasBootstrappedFeatureFlags() {
        var e, t;
        return (null === (e = this.config.bootstrap) || void 0 === e ? void 0 : e.featureFlags) && Object.keys(null === (t = this.config.bootstrap) || void 0 === t ? void 0 : t.featureFlags).length > 0 || !1;
    }
    push(e) {
        this._execute_array([
            e
        ]);
    }
    capture(e, t, i) {
        var n;
        if (!(this.__loaded && this.persistence && this.sessionPersistence && this._requestQueue)) return void $fad8677fba5f5b13$var$$.uninitializedWarning("posthog.capture");
        if (this.consent.isOptedOut()) return;
        if ($fad8677fba5f5b13$var$S(e) || !$fad8677fba5f5b13$var$E(e)) return void $fad8677fba5f5b13$var$$.error("No event name provided to posthog.capture");
        if (!this.config.opt_out_useragent_filter && this._is_bot()) return;
        const s = null != i && i.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
        if (null != s && s.isRateLimited) return void $fad8677fba5f5b13$var$$.critical("This capture call is ignored due to client rate limiting.");
        this.sessionPersistence.update_search_keyword(), this.config.store_google && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.store_google || this.config.save_referrer) && this.persistence.set_initial_person_info();
        const r = new Date, o = (null == i ? void 0 : i.timestamp) || r;
        let a = {
            uuid: $fad8677fba5f5b13$var$We(),
            event: e,
            properties: this._calculate_event_properties(e, t || {}, o)
        };
        s && (a.properties.$lib_rate_limit_remaining_tokens = s.remainingTokens);
        (null == i ? void 0 : i.$set) && (a.$set = null == i ? void 0 : i.$set);
        const l = this._calculate_set_once_properties(null == i ? void 0 : i.$set_once);
        l && (a.$set_once = l), a = $fad8677fba5f5b13$var$z(a, null != i && i._noTruncate ? null : this.config.properties_string_max_length), a.timestamp = o, $fad8677fba5f5b13$var$S(null == i ? void 0 : i.timestamp) || (a.properties.$event_time_override_provided = !0, a.properties.$event_time_override_system_time = r);
        const c = {
            ...a.properties.$set,
            ...a.$set
        };
        $fad8677fba5f5b13$var$w(c) || this.setPersonPropertiesForFlags(c), this._internalEventEmitter.emit("eventCaptured", a);
        const u = {
            method: "POST",
            url: null !== (n = null == i ? void 0 : i._url) && void 0 !== n ? n : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
            data: a,
            compression: "best-available",
            batchKey: null == i ? void 0 : i._batchKey
        };
        return !this.config.request_batching || i && (null == i || !i._batchKey) || null != i && i.send_instantly ? this._send_retriable_request(u) : this._requestQueue.enqueue(u), a;
    }
    _addCaptureHook(e) {
        return this.on("eventCaptured", (t)=>e(t.event, t));
    }
    _calculate_event_properties(e, t, i) {
        if (i = i || new Date, !this.persistence || !this.sessionPersistence) return t;
        const n = this.persistence.remove_event_timer(e);
        let s = {
            ...t
        };
        if (s.token = this.config.token, "$snapshot" === e) {
            const e = {
                ...this.persistence.properties(),
                ...this.sessionPersistence.properties()
            };
            return s.distinct_id = e.distinct_id, (!$fad8677fba5f5b13$var$E(s.distinct_id) && !$fad8677fba5f5b13$var$P(s.distinct_id) || $fad8677fba5f5b13$var$k(s.distinct_id)) && $fad8677fba5f5b13$var$$.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), s;
        }
        const r = $fad8677fba5f5b13$var$ai.properties();
        if (this.sessionManager) {
            const { sessionId: e, windowId: t } = this.sessionManager.checkAndGetSessionAndWindowId();
            s.$session_id = e, s.$window_id = t;
        }
        if (this.requestRouter.region === $fad8677fba5f5b13$var$as.CUSTOM && (s.$lib_custom_api_host = this.config.api_host), this.sessionPropsManager && this.config.__preview_send_client_session_params && ("$pageview" === e || "$pageleave" === e || "$autocapture" === e)) {
            const e = this.sessionPropsManager.getSessionProps();
            s = $fad8677fba5f5b13$var$D(s, e);
        }
        if (!this.config.disable_scroll_properties) {
            let t = {};
            "$pageview" === e ? t = this.pageViewManager.doPageView(i) : "$pageleave" === e && (t = this.pageViewManager.doPageLeave(i)), s = $fad8677fba5f5b13$var$D(s, t);
        }
        if ("$pageview" === e && $fad8677fba5f5b13$var$o && (s.title = $fad8677fba5f5b13$var$o.title), !$fad8677fba5f5b13$var$S(n)) {
            const e = i.getTime() - n;
            s.$duration = parseFloat((e / 1e3).toFixed(3));
        }
        $fad8677fba5f5b13$var$d && this.config.opt_out_useragent_filter && (s.$browser_type = this._is_bot() ? "bot" : "browser"), s = $fad8677fba5f5b13$var$D({}, r, this.persistence.properties(), this.sessionPersistence.properties(), s), s.$is_identified = this._isIdentified(), $fad8677fba5f5b13$var$m(this.config.property_denylist) ? $fad8677fba5f5b13$var$O(this.config.property_denylist, function(e) {
            delete s[e];
        }) : $fad8677fba5f5b13$var$$.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        const a = this.config.sanitize_properties;
        a && (s = a(s, e));
        const l = this._hasPersonProcessing();
        return s.$process_person_profile = l, l && this._requirePersonProcessing("_calculate_event_properties"), s;
    }
    _calculate_set_once_properties(e) {
        if (!this.persistence || !this._hasPersonProcessing()) return e;
        let t = $fad8677fba5f5b13$var$D({}, this.persistence.get_initial_props(), e || {});
        const i = this.config.sanitize_properties;
        return i && (t = i(t, "$set_once")), $fad8677fba5f5b13$var$w(t) ? void 0 : t;
    }
    register(e, t) {
        var i;
        null === (i = this.persistence) || void 0 === i || i.register(e, t);
    }
    register_once(e, t, i) {
        var n;
        null === (n = this.persistence) || void 0 === n || n.register_once(e, t, i);
    }
    register_for_session(e) {
        var t;
        null === (t = this.sessionPersistence) || void 0 === t || t.register(e);
    }
    unregister(e) {
        var t;
        null === (t = this.persistence) || void 0 === t || t.unregister(e);
    }
    unregister_for_session(e) {
        var t;
        null === (t = this.sessionPersistence) || void 0 === t || t.unregister(e);
    }
    _register_single(e, t) {
        this.register({
            [e]: t
        });
    }
    getFeatureFlag(e, t) {
        return this.featureFlags.getFeatureFlag(e, t);
    }
    getFeatureFlagPayload(e) {
        const t = this.featureFlags.getFeatureFlagPayload(e);
        try {
            return JSON.parse(t);
        } catch  {
            return t;
        }
    }
    isFeatureEnabled(e, t) {
        return this.featureFlags.isFeatureEnabled(e, t);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateEarlyAccessFeatureEnrollment(e, t) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(e, t);
    }
    getEarlyAccessFeatures(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return this.featureFlags.getEarlyAccessFeatures(e, t);
    }
    on(e, t) {
        return this._internalEventEmitter.on(e, t);
    }
    onFeatureFlags(e) {
        return this.featureFlags.onFeatureFlags(e);
    }
    onSessionId(e) {
        var t, i;
        return null !== (t = null === (i = this.sessionManager) || void 0 === i ? void 0 : i.onSessionId(e)) && void 0 !== t ? t : ()=>{};
    }
    getSurveys(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        this.surveys.getSurveys(e, t);
    }
    getActiveMatchingSurveys(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        this.surveys.getActiveMatchingSurveys(e, t);
    }
    renderSurvey(e, t) {
        this.surveys.renderSurvey(e, t);
    }
    canRenderSurvey(e) {
        this.surveys.canRenderSurvey(e);
    }
    getNextSurveyStep(e, t, i) {
        return this.surveys.getNextSurveyStep(e, t, i);
    }
    identify(e, t, i) {
        if (!this.__loaded || !this.persistence) return $fad8677fba5f5b13$var$$.uninitializedWarning("posthog.identify");
        if ($fad8677fba5f5b13$var$P(e) && (e = e.toString(), $fad8677fba5f5b13$var$$.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), !e) return void $fad8677fba5f5b13$var$$.error("Unique user id has not been set in posthog.identify");
        if ([
            "distinct_id",
            "distinctid"
        ].includes(e.toLowerCase())) return void $fad8677fba5f5b13$var$$.critical(`The string "${e}" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.`);
        if (!this._requirePersonProcessing("posthog.identify")) return;
        const n = this.get_distinct_id();
        if (this.register({
            $user_id: e
        }), !this.get_property("$device_id")) {
            const e = n;
            this.register_once({
                $had_persisted_distinct_id: !0,
                $device_id: e
            }, "");
        }
        e !== n && e !== this.get_property($fad8677fba5f5b13$var$K) && (this.unregister($fad8677fba5f5b13$var$K), this.register({
            distinct_id: e
        }));
        const s = "anonymous" === (this.persistence.get_property($fad8677fba5f5b13$var$Ee) || "anonymous");
        e !== n && s ? (this.persistence.set_property($fad8677fba5f5b13$var$Ee, "identified"), this.setPersonPropertiesForFlags(t || {}, !1), this.capture("$identify", {
            distinct_id: e,
            $anon_distinct_id: n
        }, {
            $set: t || {},
            $set_once: i || {}
        }), this.featureFlags.setAnonymousDistinctId(n)) : (t || i) && this.setPersonProperties(t, i), e !== n && (this.reloadFeatureFlags(), this.unregister($fad8677fba5f5b13$var$Se));
    }
    setPersonProperties(e, t) {
        (e || t) && this._requirePersonProcessing("posthog.setPersonProperties") && (this.setPersonPropertiesForFlags(e || {}), this.capture("$set", {
            $set: e || {},
            $set_once: t || {}
        }));
    }
    group(e, t, i) {
        if (!e || !t) return void $fad8677fba5f5b13$var$$.error("posthog.group requires a group type and group key");
        if (!this._requirePersonProcessing("posthog.group")) return;
        const n = this.getGroups();
        n[e] !== t && this.resetGroupPropertiesForFlags(e), this.register({
            $groups: {
                ...n,
                [e]: t
            }
        }), i && (this.capture("$groupidentify", {
            $group_type: e,
            $group_key: t,
            $group_set: i
        }), this.setGroupPropertiesForFlags({
            [e]: i
        })), n[e] === t || i || this.reloadFeatureFlags();
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(e) {
        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        this._requirePersonProcessing("posthog.setPersonPropertiesForFlags") && this.featureFlags.setPersonPropertiesForFlags(e, t);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(e) {
        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        this._requirePersonProcessing("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(e, t);
    }
    resetGroupPropertiesForFlags(e) {
        this.featureFlags.resetGroupPropertiesForFlags(e);
    }
    reset(e) {
        var t, i, n, s, r;
        if ($fad8677fba5f5b13$var$$.info("reset"), !this.__loaded) return $fad8677fba5f5b13$var$$.uninitializedWarning("posthog.reset");
        const o = this.get_property("$device_id");
        this.consent.reset(), null === (t = this.persistence) || void 0 === t || t.clear(), null === (i = this.sessionPersistence) || void 0 === i || i.clear(), null === (n = this.surveys) || void 0 === n || n.reset(), null === (s = this.persistence) || void 0 === s || s.set_property($fad8677fba5f5b13$var$Ee, "anonymous"), null === (r = this.sessionManager) || void 0 === r || r.resetSessionId();
        const a = this.config.get_device_id($fad8677fba5f5b13$var$We());
        this.register_once({
            distinct_id: a,
            $device_id: e ? a : o
        }, "");
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var e, t;
        return null !== (e = null === (t = this.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== e ? e : "";
    }
    get_session_replay_url(e) {
        if (!this.sessionManager) return "";
        const { sessionId: t, sessionStartTimestamp: i } = this.sessionManager.checkAndGetSessionAndWindowId(!0);
        let n = this.requestRouter.endpointFor("ui", `/project/${this.config.token}/replay/${t}`);
        if (null != e && e.withTimestamp && i) {
            var s;
            const t = null !== (s = e.timestampLookBack) && void 0 !== s ? s : 10;
            if (!i) return n;
            n += `?t=${Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - t, 0)}`;
        }
        return n;
    }
    alias(e, t) {
        return e === this.get_property($fad8677fba5f5b13$var$X) ? ($fad8677fba5f5b13$var$$.critical("Attempting to create alias for existing People user - aborting."), -2) : this._requirePersonProcessing("posthog.alias") ? ($fad8677fba5f5b13$var$S(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single($fad8677fba5f5b13$var$K, e), this.capture("$create_alias", {
            alias: e,
            distinct_id: t
        })) : ($fad8677fba5f5b13$var$$.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1)) : void 0;
    }
    set_config(e) {
        const t = {
            ...this.config
        };
        var i, n, s, r;
        $fad8677fba5f5b13$var$b(e) && ($fad8677fba5f5b13$var$D(this.config, $fad8677fba5f5b13$var$Lr(e)), null === (i = this.persistence) || void 0 === i || i.update_config(this.config, t), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $fad8677fba5f5b13$var$ci({
            ...this.config,
            persistence: "sessionStorage"
        }), $fad8677fba5f5b13$var$Xe.is_supported() && "true" === $fad8677fba5f5b13$var$Xe.get("ph_debug") && (this.config.debug = !0), this.config.debug && ($fad8677fba5f5b13$var$_.DEBUG = !0, $fad8677fba5f5b13$var$$.info("set_config", {
            config: e,
            oldConfig: t,
            newConfig: {
                ...this.config
            }
        })), null === (n = this.sessionRecording) || void 0 === n || n.startIfEnabledOrStop(), null === (s = this.autocapture) || void 0 === s || s.startIfEnabled(), null === (r = this.heatmaps) || void 0 === r || r.startIfEnabled(), this.surveys.loadIfEnabled(), this._sync_opt_out_with_persistence());
    }
    startSessionRecording(e) {
        const t = $fad8677fba5f5b13$var$F(e) && e;
        if (t || null != e && e.sampling || null != e && e.linked_flag) {
            var i;
            const r = null === (i = this.sessionManager) || void 0 === i ? void 0 : i.checkAndGetSessionAndWindowId();
            var n, s;
            if (t || null != e && e.sampling) null === (n = this.sessionRecording) || void 0 === n || n.overrideSampling(), $fad8677fba5f5b13$var$$.info("Session recording started with sampling override for session: ", null == r ? void 0 : r.sessionId);
            if (t || null != e && e.linked_flag) null === (s = this.sessionRecording) || void 0 === s || s.overrideLinkedFlag(), $fad8677fba5f5b13$var$$.info("Session recording started with linked_flags override");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var e;
        return !(null === (e = this.sessionRecording) || void 0 === e || !e.started);
    }
    captureException(e, t) {
        var i;
        const n = new Error("PostHog syntheticException"), s = $fad8677fba5f5b13$var$y(null === (i = $fad8677fba5f5b13$var$h.__PosthogExtensions__) || void 0 === i ? void 0 : i.parseErrorAsProperties) ? $fad8677fba5f5b13$var$h.__PosthogExtensions__.parseErrorAsProperties([
            e.message,
            void 0,
            void 0,
            void 0,
            e
        ], {
            syntheticException: n
        }) : {
            $exception_level: "error",
            $exception_list: [
                {
                    type: e.name,
                    value: e.message,
                    mechanism: {
                        handled: !0,
                        synthetic: !1
                    }
                }
            ],
            ...t
        };
        this.exceptions.sendExceptionEvent(s);
    }
    loadToolbar(e) {
        return this.toolbar.loadToolbar(e);
    }
    get_property(e) {
        var t;
        return null === (t = this.persistence) || void 0 === t ? void 0 : t.props[e];
    }
    getSessionProperty(e) {
        var t;
        return null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.props[e];
    }
    toString() {
        var e;
        let t = null !== (e = this.config.name) && void 0 !== e ? e : $fad8677fba5f5b13$var$Cr;
        return t !== $fad8677fba5f5b13$var$Cr && (t = $fad8677fba5f5b13$var$Cr + "." + t), t;
    }
    _isIdentified() {
        var e, t;
        return "identified" === (null === (e = this.persistence) || void 0 === e ? void 0 : e.get_property($fad8677fba5f5b13$var$Ee)) || "identified" === (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.get_property($fad8677fba5f5b13$var$Ee));
    }
    _hasPersonProcessing() {
        var e, t, i, n;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $fad8677fba5f5b13$var$w(this.getGroups()) && (null === (e = this.persistence) || void 0 === e || null === (t = e.props) || void 0 === t || !t[$fad8677fba5f5b13$var$K]) && (null === (i = this.persistence) || void 0 === i || null === (n = i.props) || void 0 === n || !n[$fad8677fba5f5b13$var$Re]));
    }
    _shouldCapturePageleave() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && this.config.capture_pageview;
    }
    createPersonProfile() {
        this._hasPersonProcessing() || this._requirePersonProcessing("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    _requirePersonProcessing(e) {
        return "never" === this.config.person_profiles ? ($fad8677fba5f5b13$var$$.error(e + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this._register_single($fad8677fba5f5b13$var$Re, !0), !0);
    }
    _sync_opt_out_with_persistence() {
        var e, t;
        const i = this.consent.isOptedOut(), n = this.config.opt_out_persistence_by_default, s = this.config.disable_persistence || i && !!n;
        var r, o;
        (null === (e = this.persistence) || void 0 === e ? void 0 : e.disabled) !== s && (null === (r = this.persistence) || void 0 === r || r.set_disabled(s));
        (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.disabled) !== s && (null === (o = this.sessionPersistence) || void 0 === o || o.set_disabled(s));
    }
    opt_in_capturing(e) {
        var t;
        (this.consent.optInOut(!0), this._sync_opt_out_with_persistence(), $fad8677fba5f5b13$var$S(null == e ? void 0 : e.captureEventName) || null != e && e.captureEventName) && this.capture(null !== (t = null == e ? void 0 : e.captureEventName) && void 0 !== t ? t : "$opt_in", null == e ? void 0 : e.captureProperties, {
            send_instantly: !0
        });
        this.config.capture_pageview && this._captureInitialPageview();
    }
    opt_out_capturing() {
        this.consent.optInOut(!1), this._sync_opt_out_with_persistence();
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this._sync_opt_out_with_persistence();
    }
    _is_bot() {
        return $fad8677fba5f5b13$var$r ? $fad8677fba5f5b13$var$ur($fad8677fba5f5b13$var$r, this.config.custom_blocked_useragents) : void 0;
    }
    _captureInitialPageview() {
        $fad8677fba5f5b13$var$o && !this._initialPageviewCaptured && (this._initialPageviewCaptured = !0, this.capture("$pageview", {
            title: $fad8677fba5f5b13$var$o.title
        }, {
            send_instantly: !0
        }));
    }
    debug(t) {
        !1 === t ? (null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
            debug: !1
        })) : (null == $fad8677fba5f5b13$var$e || $fad8677fba5f5b13$var$e.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
            debug: !0
        }));
    }
}
!function(e, t) {
    for(let i = 0; i < t.length; i++)e.prototype[t[i]] = $fad8677fba5f5b13$var$H(e.prototype[t[i]]);
}($fad8677fba5f5b13$export$a9d6b9cbf49b8241, [
    "identify"
]);
const $fad8677fba5f5b13$export$2e2bcd8739ae039 = function() {
    const t = $fad8677fba5f5b13$var$Tr[$fad8677fba5f5b13$var$Cr] = new $fad8677fba5f5b13$export$a9d6b9cbf49b8241;
    return function() {
        function t() {
            t.done || (t.done = !0, $fad8677fba5f5b13$var$Mr = !1, $fad8677fba5f5b13$var$O($fad8677fba5f5b13$var$Tr, function(e) {
                e._dom_loaded();
            }));
        }
        null != $fad8677fba5f5b13$var$o && $fad8677fba5f5b13$var$o.addEventListener && ("complete" === $fad8677fba5f5b13$var$o.readyState ? t() : $fad8677fba5f5b13$var$o.addEventListener("DOMContentLoaded", t, !1)), $fad8677fba5f5b13$var$e && $fad8677fba5f5b13$var$G($fad8677fba5f5b13$var$e, "load", t, !0);
    }(), t;
}();


const $a18db346086c295a$export$12ba4a87a63f35f7 = {
    APP_OPENED: "app_opened",
    GAME_OPENED: "game_opened",
    GAME_STARTED: "game_started",
    CELL_FILLED: "cell_filled",
    PING_SENT: "ping_sent",
    SHARE_INITIATED: "share_initiated",
    SHARE_COMPLETED: "share_completed",
    PUZZLE_COMPLETED: "puzzle_completed",
    UPLOAD_STARTED: "upload_started",
    SETTINGS_UPDATED: "settings_updated",
    NOTIFICATION_OPT_IN_CHANGED: "notification_opt_in_changed",
    NOTIFICATION_OPENED: "notification_opened",
    FUN_MORGO_EGG: "fun_morgo_egg"
};


const $a73b638dd7d927c0$var$POSTHOG_API_KEY = "phc_Jt7bHCQmUWThQD4d1K9CZ4AYgLm69dPpy5zEpXyrLRg";
const $a73b638dd7d927c0$var$POSTHOG_HOST = "https://us.i.posthog.com";
const $a73b638dd7d927c0$var$VALID_EVENTS = new Set(Object.values((0, $a18db346086c295a$export$12ba4a87a63f35f7)));
let $a73b638dd7d927c0$var$initialized = false;
let $a73b638dd7d927c0$var$commonContext = {
    platform: "web"
};
const $a73b638dd7d927c0$export$f2a39aaa42ea357a = ({ userToken: userToken, appVersion: appVersion = null, nickname: nickname = null })=>{
    if ($a73b638dd7d927c0$var$initialized) return;
    if (window.location.protocol !== "https:") return;
    (0, $fad8677fba5f5b13$export$2e2bcd8739ae039).init($a73b638dd7d927c0$var$POSTHOG_API_KEY, {
        api_host: $a73b638dd7d927c0$var$POSTHOG_HOST,
        person_profiles: "identified_only"
    });
    if (userToken) (0, $fad8677fba5f5b13$export$2e2bcd8739ae039).identify(userToken);
    $a73b638dd7d927c0$var$commonContext = {
        ...$a73b638dd7d927c0$var$commonContext,
        userToken: userToken || null,
        appVersion: appVersion || null,
        nickname: typeof nickname === "string" && nickname.trim() ? nickname.trim() : null
    };
    $a73b638dd7d927c0$var$initialized = true;
};
const $a73b638dd7d927c0$export$ce116fc00f514d86 = (userToken)=>{
    if (!$a73b638dd7d927c0$var$initialized || !userToken) return;
    (0, $fad8677fba5f5b13$export$2e2bcd8739ae039).identify(userToken);
    $a73b638dd7d927c0$var$commonContext = {
        ...$a73b638dd7d927c0$var$commonContext,
        userToken: userToken
    };
};
const $a73b638dd7d927c0$export$a612d3804dec9d26 = (nickname)=>{
    if (!$a73b638dd7d927c0$var$initialized) return;
    $a73b638dd7d927c0$var$commonContext = {
        ...$a73b638dd7d927c0$var$commonContext,
        nickname: typeof nickname === "string" && nickname.trim() ? nickname.trim() : null
    };
};
const $a73b638dd7d927c0$export$73d0a139caca1fee = (eventName, properties = {})=>{
    if (!$a73b638dd7d927c0$var$initialized || !eventName) return;
    if (!$a73b638dd7d927c0$var$VALID_EVENTS.has(eventName)) console.warn(`[analytics] Unknown event "${eventName}"`);
    (0, $fad8677fba5f5b13$export$2e2bcd8739ae039).capture(eventName, {
        ...$a73b638dd7d927c0$var$commonContext,
        ...properties
    });
};



const $7afb2f16600ea55a$var$Image = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).img`
    width: 32px;
`;
/**
 * Copies the given text to clipboard.
 * @param {String} text text to copy
 */ const $7afb2f16600ea55a$var$copyText = (text)=>{
    const textarea = document.createElement("textarea");
    textarea.setAttribute("type", "hidden");
    textarea.textContent = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
};
const $7afb2f16600ea55a$var$ShareButton = ({ onClick: onClick, ...props })=>{
    const onClickShare = async ()=>{
        (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).SHARE_INITIATED, {
            source: "share_button"
        });
        if (onClick) {
            onClick();
            return;
        }
        if (navigator.share) try {
            await navigator.share({
                title: "Join this Crossword with me!",
                text: "Join this Crossword with me!",
                url: window.location.href
            });
            (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).SHARE_COMPLETED, {
                source: "share_button"
            });
        } catch (err) {
            console.error(err);
        }
        else {
            $7afb2f16600ea55a$var$copyText(window.location.href);
            window.alert("The URL has been copied to your clipboard!");
            (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).SHARE_COMPLETED, {
                source: "share_button",
                method: "clipboard"
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($7afb2f16600ea55a$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($51f8827d164123c4$exports))),
        onClick: onClickShare,
        ...props
    });
};
var $7afb2f16600ea55a$export$2e2bcd8739ae039 = $7afb2f16600ea55a$var$ShareButton;



var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");
var $94231c21d6d56d2e$var$__defProp = Object.defineProperty;
var $94231c21d6d56d2e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $94231c21d6d56d2e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $94231c21d6d56d2e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $94231c21d6d56d2e$var$__defNormalProp = (obj, key, value)=>key in obj ? $94231c21d6d56d2e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $94231c21d6d56d2e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($94231c21d6d56d2e$var$__hasOwnProp.call(b, prop)) $94231c21d6d56d2e$var$__defNormalProp(a, prop, b[prop]);
    if ($94231c21d6d56d2e$var$__getOwnPropSymbols) {
        for (var prop of $94231c21d6d56d2e$var$__getOwnPropSymbols(b))if ($94231c21d6d56d2e$var$__propIsEnum.call(b, prop)) $94231c21d6d56d2e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $94231c21d6d56d2e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($94231c21d6d56d2e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $94231c21d6d56d2e$var$__getOwnPropSymbols) {
        for (var prop of $94231c21d6d56d2e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $94231c21d6d56d2e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $94231c21d6d56d2e$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class _QrCode {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code with the given version number,
        // error correction level, data codeword bytes, and mask number.
        // This is a low-level API that most users should not use directly.
        // A mid-level API is the encodeSegments() function.
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            // The modules of this QR Code (false = light, true = dark).
            // Immutable after constructor finishes. Accessed through getModule().
            this.modules = [];
            // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
        /*-- Static factory functions (high level) --*/ // Returns a QR Code representing the given Unicode text string at the given error correction level.
        // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
        // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
        // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
        // ecl argument if it can be done without increasing the version.
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        // Returns a QR Code representing the given binary data at the given error correction level.
        // This function always encodes using the binary segment mode, not any text mode. The maximum number of
        // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
        // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        /*-- Static factory functions (mid level) --*/ // Returns a QR Code representing the given segments with the given encoding parameters.
        // The smallest possible QR Code version within the given range is automatically
        // chosen for the output. Iff boostEcl is true, then the ECC level of the result
        // may be higher than the ecl argument if it can be done without increasing the
        // version. The mask number is either between 0 to 7 (inclusive) to force that
        // mask, or -1 to automatically choose an appropriate mask (which may be slow).
        // This function allows the user to create a custom sequence of segments that switches
        // between modes (such as alphanumeric and byte) to encode text in less space.
        // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        /*-- Accessor methods --*/ // Returns the color of the module (pixel) at the given coordinates, which is false
        // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
        // If the given coordinates are out of bounds, then false (light) is returned.
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        // Modified to expose modules for easy access
        getModules() {
            return this.modules;
        }
        /*-- Private helper methods for constructor: Drawing function modules --*/ // Reads this object's version field, and draws and marks all function modules.
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        // Draws two copies of the format bits (with its own error correction code)
        // based on the given mask and this object's error correction level field.
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        // Draws two copies of the version bits (with its own error correction code),
        // based on this object's version field, iff 7 <= version <= 40.
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        // Draws a 9*9 finder pattern including the border separator,
        // with the center module at (x, y). Modules can be out of bounds.
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        // Draws a 5*5 alignment pattern, with the center module
        // at (x, y). All modules must be in bounds.
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        // Sets the color of a module and marks it as a function module.
        // Only used by the constructor. Coordinates must be in bounds.
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        /*-- Private helper methods for constructor: Codewords and masking --*/ // Returns a new byte string representing the given data with the appropriate error correction
        // codewords appended to it, based on this object's version and error correction level.
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
        // data area of this QR Code. Function modules need to be marked off before this is called.
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        // XORs the codeword modules in this QR Code with the given mask pattern.
        // The function modules must be marked and the codeword bits must be drawn
        // before masking. Due to the arithmetic of XOR, calling applyMask() with
        // the same mask value a second time will undo the mask. A final well-formed
        // QR Code needs exactly one (not zero, two, etc.) mask applied.
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        // Calculates and returns the penalty score based on state of this QR Code's current modules.
        // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        /*-- Private helper functions --*/ // Returns an ascending list of positions of alignment patterns for this version number.
        // Each position is in the range [0,177), and are used on both the x and y axes.
        // This could be implemented as lookup table of 40 variable-length lists of integers.
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        // Returns the number of data bits that can be stored in a QR Code of the given version number, after
        // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
        // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
        // QR Code of the given version number and error correction level, with remainder bits discarded.
        // This stateless pure function could be implemented as a (40*4)-cell lookup table.
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
        // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
        // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        // Can only be called immediately after a light run is added, and
        // returns either 0, 1, or 2. A helper function for getPenaltyScore().
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
    };
    /*-- Constants and tables --*/ // The minimum version number supported in the QR Code Model 2 standard.
    _QrCode.MIN_VERSION = 1;
    // The maximum version number supported in the QR Code Model 2 standard.
    _QrCode.MAX_VERSION = 40;
    // For use in getPenaltyScore(), when evaluating which mask is best.
    _QrCode.PENALTY_N1 = 3;
    _QrCode.PENALTY_N2 = 3;
    _QrCode.PENALTY_N3 = 40;
    _QrCode.PENALTY_N4 = 10;
    _QrCode.ECC_CODEWORDS_PER_BLOCK = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Low
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        // Medium
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Quartile
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    _QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        // Low
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        // Medium
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        // Quartile
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    let QrCode = _QrCode;
    qrcodegen2.QrCode = _QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class _QrSegment {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code segment with the given attributes and data.
        // The character count (numChars) must agree with the mode and the bit buffer length,
        // but the constraint isn't checked. The given bit buffer is cloned and stored.
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
        /*-- Static factory functions (mid level) --*/ // Returns a segment representing the given binary data encoded in
        // byte mode. All input byte arrays are acceptable. Any text string
        // can be converted to UTF-8 bytes and encoded as a byte mode segment.
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        // Returns a segment representing the given string of decimal digits encoded in numeric mode.
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        // Returns a segment representing the given text string encoded in alphanumeric mode.
        // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
        // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
        // The result may use various segment modes and switch modes to optimize the length of the bit stream.
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        // Returns a segment representing an Extended Channel Interpretation
        // (ECI) designator with the given assignment value.
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        // Tests whether the given string can be encoded as a segment in numeric mode.
        // A string is encodable iff each character is in the range 0 to 9.
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        // Tests whether the given string can be encoded as a segment in alphanumeric mode.
        // A string is encodable iff each character is in the following set: 0 to 9, A to Z
        // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        /*-- Methods --*/ // Returns a new copy of the data bits of this segment.
        getData() {
            return this.bitData.slice();
        }
        // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
        // the given version. The result is infinity if a segment has too many characters to fit its length field.
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        // Returns a new array of bytes representing the given string encoded in UTF-8.
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substring(i + 1, i + 3), 16));
                i += 2;
            }
            return result;
        }
    };
    /*-- Constants --*/ // Describes precisely all strings that are encodable in numeric mode.
    _QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    // Describes precisely all strings that are encodable in alphanumeric mode.
    _QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    // The set of all legal characters in alphanumeric mode,
    // where each character value maps to the index in the string.
    _QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    let QrSegment = _QrSegment;
    qrcodegen2.QrSegment = _QrSegment;
})($94231c21d6d56d2e$var$qrcodegen || ($94231c21d6d56d2e$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class _Ecc {
            // The QR Code can tolerate about 30% erroneous codewords
            /*-- Constructor and fields --*/ constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        /*-- Constants --*/ _Ecc.LOW = new _Ecc(0, 1);
        // The QR Code can tolerate about  7% erroneous codewords
        _Ecc.MEDIUM = new _Ecc(1, 0);
        // The QR Code can tolerate about 15% erroneous codewords
        _Ecc.QUARTILE = new _Ecc(2, 3);
        // The QR Code can tolerate about 25% erroneous codewords
        _Ecc.HIGH = new _Ecc(3, 2);
        let Ecc = _Ecc;
        QrCode2.Ecc = _Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($94231c21d6d56d2e$var$qrcodegen || ($94231c21d6d56d2e$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class _Mode {
            /*-- Constructor and fields --*/ constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            /*-- Method --*/ // (Package-private) Returns the bit width of the character count field for a segment in
            // this mode in a QR Code at the given version number. The result is in the range [0, 16].
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        };
        /*-- Constants --*/ _Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        _Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        _Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        _Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        _Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        let Mode = _Mode;
        QrSegment2.Mode = _Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($94231c21d6d56d2e$var$qrcodegen || ($94231c21d6d56d2e$var$qrcodegen = {}));
var $94231c21d6d56d2e$var$qrcodegen_default = $94231c21d6d56d2e$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $94231c21d6d56d2e$var$ERROR_LEVEL_MAP = {
    L: $94231c21d6d56d2e$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $94231c21d6d56d2e$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $94231c21d6d56d2e$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $94231c21d6d56d2e$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $94231c21d6d56d2e$var$DEFAULT_SIZE = 128;
var $94231c21d6d56d2e$var$DEFAULT_LEVEL = "L";
var $94231c21d6d56d2e$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $94231c21d6d56d2e$var$DEFAULT_FGCOLOR = "#000000";
var $94231c21d6d56d2e$var$DEFAULT_INCLUDEMARGIN = false;
var $94231c21d6d56d2e$var$DEFAULT_MINVERSION = 1;
var $94231c21d6d56d2e$var$SPEC_MARGIN_SIZE = 4;
var $94231c21d6d56d2e$var$DEFAULT_MARGIN_SIZE = 0;
var $94231c21d6d56d2e$var$DEFAULT_IMG_SCALE = 0.1;
function $94231c21d6d56d2e$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $94231c21d6d56d2e$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $94231c21d6d56d2e$var$getImageSettings(cells, size, margin, imageSettings) {
    if (imageSettings == null) return null;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $94231c21d6d56d2e$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    const opacity = imageSettings.opacity == null ? 1 : imageSettings.opacity;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    const crossOrigin = imageSettings.crossOrigin;
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation,
        opacity: opacity,
        crossOrigin: crossOrigin
    };
}
function $94231c21d6d56d2e$var$getMarginSize(includeMargin, marginSize) {
    if (marginSize != null) return Math.max(Math.floor(marginSize), 0);
    return includeMargin ? $94231c21d6d56d2e$var$SPEC_MARGIN_SIZE : $94231c21d6d56d2e$var$DEFAULT_MARGIN_SIZE;
}
function $94231c21d6d56d2e$var$useQRCode({ value: value, level: level, minVersion: minVersion, includeMargin: includeMargin, marginSize: marginSize, imageSettings: imageSettings, size: size, boostLevel: boostLevel }) {
    let qrcode = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useMemo(()=>{
        const values = Array.isArray(value) ? value : [
            value
        ];
        const segments = values.reduce((accum, v)=>{
            accum.push(...$94231c21d6d56d2e$var$qrcodegen_default.QrSegment.makeSegments(v));
            return accum;
        }, []);
        return $94231c21d6d56d2e$var$qrcodegen_default.QrCode.encodeSegments(segments, $94231c21d6d56d2e$var$ERROR_LEVEL_MAP[level], minVersion, void 0, void 0, boostLevel);
    }, [
        value,
        level,
        minVersion,
        boostLevel
    ]);
    const { cells: cells, margin: margin, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useMemo(()=>{
        let cells2 = qrcode.getModules();
        const margin2 = $94231c21d6d56d2e$var$getMarginSize(includeMargin, marginSize);
        const numCells2 = cells2.length + margin2 * 2;
        const calculatedImageSettings2 = $94231c21d6d56d2e$var$getImageSettings(cells2, size, margin2, imageSettings);
        return {
            cells: cells2,
            margin: margin2,
            numCells: numCells2,
            calculatedImageSettings: calculatedImageSettings2
        };
    }, [
        qrcode,
        size,
        imageSettings,
        includeMargin,
        marginSize
    ]);
    return {
        qrcode: qrcode,
        margin: margin,
        cells: cells,
        numCells: numCells,
        calculatedImageSettings: calculatedImageSettings
    };
}
var $94231c21d6d56d2e$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
var $94231c21d6d56d2e$export$7e3713cf0c0fe9d0 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(function QRCodeCanvas2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $94231c21d6d56d2e$var$DEFAULT_SIZE, level: level = $94231c21d6d56d2e$var$DEFAULT_LEVEL, bgColor: bgColor = $94231c21d6d56d2e$var$DEFAULT_BGCOLOR, fgColor: fgColor = $94231c21d6d56d2e$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $94231c21d6d56d2e$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $94231c21d6d56d2e$var$DEFAULT_MINVERSION, boostLevel: boostLevel, marginSize: marginSize, imageSettings: imageSettings } = _a, extraProps = $94231c21d6d56d2e$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "marginSize",
        "imageSettings"
    ]);
    const _b = extraProps, { style: style } = _b, otherProps = $94231c21d6d56d2e$var$__objRest(_b, [
        "style"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useRef(null);
    const _image = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useRef(null);
    const setCanvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useCallback((node)=>{
        _canvas.current = node;
        if (typeof forwardedRef === "function") forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
    }, [
        forwardedRef
    ]);
    const [isImgLoaded, setIsImageLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useState(false);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $94231c21d6d56d2e$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useEffect(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cellsToDraw = cells;
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cellsToDraw = $94231c21d6d56d2e$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($94231c21d6d56d2e$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($94231c21d6d56d2e$var$generatePath(cellsToDraw, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (calculatedImageSettings) ctx.globalAlpha = calculatedImageSettings.opacity;
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).useEffect(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $94231c21d6d56d2e$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image,
        crossOrigin: calculatedImageSettings == null ? void 0 : calculatedImageSettings.crossOrigin
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("canvas", $94231c21d6d56d2e$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: setCanvasRef,
        role: "img"
    }, otherProps)), img);
});
$94231c21d6d56d2e$export$7e3713cf0c0fe9d0.displayName = "QRCodeCanvas";
var $94231c21d6d56d2e$export$10307208e61210e9 = (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).forwardRef(function QRCodeSVG2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $94231c21d6d56d2e$var$DEFAULT_SIZE, level: level = $94231c21d6d56d2e$var$DEFAULT_LEVEL, bgColor: bgColor = $94231c21d6d56d2e$var$DEFAULT_BGCOLOR, fgColor: fgColor = $94231c21d6d56d2e$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $94231c21d6d56d2e$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $94231c21d6d56d2e$var$DEFAULT_MINVERSION, boostLevel: boostLevel, title: title, marginSize: marginSize, imageSettings: imageSettings } = _a, otherProps = $94231c21d6d56d2e$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "title",
        "marginSize",
        "imageSettings"
    ]);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $94231c21d6d56d2e$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    let cellsToDraw = cells;
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cellsToDraw = $94231c21d6d56d2e$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("image", {
            href: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none",
            opacity: calculatedImageSettings.opacity,
            crossOrigin: calculatedImageSettings.crossOrigin
        });
    }
    const fgPath = $94231c21d6d56d2e$var$generatePath(cellsToDraw, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("svg", $94231c21d6d56d2e$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`,
        ref: forwardedRef,
        role: "img"
    }, otherProps), !!title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("title", null, title), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
});
$94231c21d6d56d2e$export$10307208e61210e9.displayName = "QRCodeSVG";




const $4b217727919d843e$var$Overlay = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;
const $4b217727919d843e$var$Panel = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  background: #90d1a8;
  border-radius: 16px;
  padding: 32px 28px;
  text-align: center;
  max-width: 360px;
  width: 90%;
`;
const $4b217727919d843e$var$Title = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).h2`
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin: 0 0 24px;
`;
const $4b217727919d843e$var$QRWrap = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  display: inline-block;
  margin-bottom: 12px;
`;
const $4b217727919d843e$var$UrlText = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).p`
  font-size: 14px;
  color: #2f4b3d;
  margin: 0 0 20px;
  word-break: break-all;
`;
const $4b217727919d843e$var$Button = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).button`
  display: block;
  width: 100%;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const $4b217727919d843e$var$PrimaryButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)($4b217727919d843e$var$Button)`
  background: #4f765f;
`;
const $4b217727919d843e$var$SecondaryButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)($4b217727919d843e$var$Button)`
  background: #6f9880;
`;
const $4b217727919d843e$var$copyText = (text)=>{
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text).catch(()=>{});
        return;
    }
    const textarea = document.createElement("textarea");
    textarea.setAttribute("type", "hidden");
    textarea.textContent = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
};
const $4b217727919d843e$var$ShareModal = ({ gameId: gameId, onClose: onClose })=>{
    const url = `${window.location.origin}/game/${gameId}`;
    const onShare = ()=>{
        (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).SHARE_INITIATED, {
            source: "share_modal",
            gameId: gameId
        });
        if (navigator.share) navigator.share({
            title: "Join this Crossword with me!",
            text: "Join this Crossword with me!",
            url: url
        }).then(()=>{
            (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).SHARE_COMPLETED, {
                source: "share_modal",
                gameId: gameId
            });
        }).catch(()=>{});
        else {
            $4b217727919d843e$var$copyText(url);
            window.alert("The URL has been copied to your clipboard!");
            (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).SHARE_COMPLETED, {
                source: "share_modal",
                method: "clipboard",
                gameId: gameId
            });
        }
    };
    const onOverlayClick = (e)=>{
        if (e.target === e.currentTarget) onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4b217727919d843e$var$Overlay, {
        onClick: onOverlayClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4b217727919d843e$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4b217727919d843e$var$Title, null, "Share"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4b217727919d843e$var$QRWrap, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $94231c21d6d56d2e$export$10307208e61210e9), {
        value: url,
        size: 200,
        bgColor: "#fff",
        fgColor: "#333"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4b217727919d843e$var$UrlText, null, url), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4b217727919d843e$var$PrimaryButton, {
        onClick: onShare
    }, "Share Game Link"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4b217727919d843e$var$SecondaryButton, {
        onClick: onClose
    }, "Close")));
};
var $4b217727919d843e$export$2e2bcd8739ae039 = $4b217727919d843e$var$ShareModal;



var $gIfym = parcelRequire("gIfym");


var $6cecf15d24652ff0$exports = {};
$6cecf15d24652ff0$exports = new URL("house.4786c191.svg", import.meta.url).toString();


const $b5f4758e147af6da$var$Image = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).img`
  width: 32px;
`;
const $b5f4758e147af6da$var$StyledLink = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)((0, $9cbc292f226e199b$export$2e2bcd8739ae039))`
  width: 32px;
  height: 32px;
`;
const $b5f4758e147af6da$var$HomeButton = ({ ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b5f4758e147af6da$var$StyledLink, {
        to: "/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($b5f4758e147af6da$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6cecf15d24652ff0$exports))),
        ...props
    }));
};
var $b5f4758e147af6da$export$2e2bcd8739ae039 = $b5f4758e147af6da$var$HomeButton;



var $gIfym = parcelRequire("gIfym");
const $9fd6d2d569d44a4c$var$TIMER_UPDATE_MS = 500;
const $9fd6d2d569d44a4c$var$useDuration = (localStartTime, gameDurationSeconds, gameSecondsOffset, isRunning = true)=>{
    const [duration, setDuration] = (0, $gIfym.useState)(null);
    (0, $gIfym.useEffect)(()=>{
        if (isNaN(gameDurationSeconds) || isNaN(gameSecondsOffset)) return;
        const canTick = isRunning && !isNaN(localStartTime);
        const baseDuration = (gameDurationSeconds || 0) + gameSecondsOffset;
        const update = ()=>{
            const localOffset = canTick ? Date.now() - localStartTime : 0;
            setDuration(baseDuration + localOffset);
        };
        if (!canTick) {
            setDuration((prevDuration)=>prevDuration === null ? baseDuration : prevDuration);
            return;
        }
        update();
        const intervalId = window.setInterval(update, $9fd6d2d569d44a4c$var$TIMER_UPDATE_MS);
        return ()=>{
            window.clearInterval(intervalId);
        };
    }, [
        localStartTime,
        gameDurationSeconds,
        gameSecondsOffset,
        isRunning
    ]);
    if (duration === null) return "...";
    const totalSeconds = Math.floor(duration / 1000);
    const seconds = totalSeconds % 60;
    const totalMinutes = Math.floor(totalSeconds / 60);
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);
    if (hours > 0) return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};
var $9fd6d2d569d44a4c$export$2e2bcd8739ae039 = $9fd6d2d569d44a4c$var$useDuration;





const $7764b776fbd01fc1$var$SOCKET_URL = (0, window.location.origin);
const $7764b776fbd01fc1$var$OFFLINE_ID = -1;
const $7764b776fbd01fc1$var$RECONNECT_INTERVAL_MS = 3000;
const $7764b776fbd01fc1$var$PRESENCE_COLOR_MAP = {
    red: "rgba(219, 94, 72, 0.92)",
    green: "rgba(138, 219, 72, 0.92)",
    blue: "rgba(72, 155, 219, 0.92)",
    purple: "rgba(153, 72, 219, 0.92)",
    orange: "rgba(219, 170, 72, 0.92)"
};
const $7764b776fbd01fc1$var$resolveReportedColor = (color)=>{
    if (!color || typeof color !== "string") return undefined;
    const normalized = color.trim().toLowerCase();
    return $7764b776fbd01fc1$var$PRESENCE_COLOR_MAP[normalized] || color.trim();
};
const $7764b776fbd01fc1$var$normalizeCompletionStats = (stats)=>{
    if (!Array.isArray(stats)) return [];
    return stats.map((stat)=>{
        const userToken = typeof stat?.userToken === "string" ? stat.userToken : "";
        const nickname = (typeof stat?.nickname === "string" ? stat.nickname : "").trim() || userToken;
        return {
            userToken: userToken,
            nickname: nickname,
            letters: Number.isFinite(stat?.letters) ? stat.letters : 0,
            percent: Number.isFinite(stat?.percent) ? stat.percent : 0,
            color: typeof stat?.color === "string" ? stat.color : undefined
        };
    }).filter((stat)=>stat.userToken);
};
const $7764b776fbd01fc1$var$isValidGamePayload = (game)=>Boolean(game && typeof game.short_id === "string" && typeof game.board === "string" && Number.isInteger(game.width) && Number.isInteger(game.height));
const $7764b776fbd01fc1$var$StyledShareButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)((0, $7afb2f16600ea55a$export$2e2bcd8739ae039))`
    position: absolute;
    right: 8%;
    cursor: pointer;

    @media screen and (min-width: 1000px) {
        right: 25%;
    }
`;
const $7764b776fbd01fc1$var$StyledHomeButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)((0, $b5f4758e147af6da$export$2e2bcd8739ae039))`
    position: absolute;
    left: 8%;
    cursor: pointer;

    @media screen and (min-width: 1000px) {
        left: 25%;
    }
`;
const $7764b776fbd01fc1$var$Game = ({ match: match, history: history })=>{
    const [game, setGame] = (0, $gIfym.useState)({});
    const [users, setUsers] = (0, $gIfym.useState)({});
    const [me, setMe] = (0, $gIfym.useState)(undefined);
    const [won, setWon] = (0, $gIfym.useState)(false);
    const [gameSecondsOffset, setGameSecondsOffset] = (0, $gIfym.useState)(0);
    const [localStartTime, setLocalStartTime] = (0, $gIfym.useState)(undefined);
    const _userToken = localStorage.getItem("userToken");
    const duration = (0, $9fd6d2d569d44a4c$export$2e2bcd8739ae039)(localStartTime, game.duration_seconds, gameSecondsOffset, !won);
    const _crossword = (0, $gIfym.useRef)(null);
    const _socket = (0, $gIfym.useRef)(null);
    const [offline, setOffline] = (0, $gIfym.useState)(false);
    const [offlineUpdates, setOfflineUpdates] = (0, $99fbd476f3947bc1$export$2e2bcd8739ae039)(`offline-${match.params.gameId}`, []);
    const [settings, setSettings] = (0, $99fbd476f3947bc1$export$2e2bcd8739ae039)("settings", {}, 0);
    const [ready, setReady] = (0, $gIfym.useState)(false);
    const [showShareModal, setShowShareModal] = (0, $gIfym.useState)(false);
    const [gameOverStats, setGameOverStats] = (0, $gIfym.useState)([]);
    const [showGameOverModal, setShowGameOverModal] = (0, $gIfym.useState)(false);
    const gameOverAutoOpenedRef = (0, $gIfym.useRef)(false);
    const receivedCompletionEventRef = (0, $gIfym.useRef)(false);
    const hasTrackedGameStartRef = (0, $gIfym.useRef)(false);
    const isLoadingGameRef = (0, $gIfym.useRef)(false);
    const trackedGameOpenedRef = (0, $gIfym.useRef)(new Set());
    const downClues = (0, $gIfym.useMemo)(()=>{
        if (!game.down) return {};
        const clues = {};
        Object.keys(game.down).forEach((key)=>{
            const { row: row, col: col } = game.down[key];
            if (!clues[row]) clues[row] = {};
            clues[row][col] = key;
        });
        return clues;
    }, [
        game.down
    ]);
    const acrossClues = (0, $gIfym.useMemo)(()=>{
        if (!game.across) return {};
        const clues = {};
        Object.keys(game.across).forEach((key)=>{
            const { row: row, col: col } = game.across[key];
            if (!clues[row]) clues[row] = {};
            clues[row][col] = key;
        });
        return clues;
    }, [
        game.across
    ]);
    const onClickTimer = ()=>{
        const nextTimerValue = !settings.timer;
        setSettings((settings)=>({
                ...settings,
                timer: nextTimerValue
            }));
        (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).SETTINGS_UPDATED, {
            setting: "timer",
            value: nextTimerValue,
            gameId: match.params.gameId
        });
    };
    (0, $gIfym.useEffect)(()=>{
        if (!match.params.gameId) return;
        gameOverAutoOpenedRef.current = false;
        receivedCompletionEventRef.current = false;
        hasTrackedGameStartRef.current = false;
        trackedGameOpenedRef.current = new Set();
        setShowGameOverModal(false);
        setGameOverStats([]);
        loadGame();
        return ()=>{
            if (_socket.current) _socket.current.disconnect();
        };
    }, [
        match.params.gameId
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (!won || gameOverAutoOpenedRef.current) return;
        if (!receivedCompletionEventRef.current && gameOverStats.length === 0) return;
        gameOverAutoOpenedRef.current = true;
        setShowGameOverModal(true);
    }, [
        won,
        gameOverStats.length
    ]);
    (0, $gIfym.useEffect)(()=>{
        setGameOverStats($7764b776fbd01fc1$var$normalizeCompletionStats(game?.completion_stats));
    }, [
        game?.completion_stats
    ]);
    const decoratedGameOverStats = (0, $gIfym.useMemo)(()=>{
        const myResolvedColor = $7764b776fbd01fc1$var$resolveReportedColor(me?.color);
        const reportedColors = Array.from(new Set(Object.values(users || {}).map((user)=>$7764b776fbd01fc1$var$resolveReportedColor(user?.color)).filter(Boolean)));
        const remainingColors = reportedColors.filter((color)=>color !== myResolvedColor);
        let nextColorIndex = 0;
        const sortedStats = [
            ...gameOverStats
        ].sort((a, b)=>{
            if (b.letters !== a.letters) return b.letters - a.letters;
            return a.nickname.localeCompare(b.nickname);
        });
        return sortedStats.map((stat)=>{
            const isCurrentUser = Boolean(_userToken && stat.userToken === _userToken);
            let playerColor = $7764b776fbd01fc1$var$resolveReportedColor(stat.color);
            if (!playerColor && isCurrentUser) playerColor = myResolvedColor;
            if (!playerColor && remainingColors.length > 0) {
                playerColor = remainingColors[nextColorIndex % remainingColors.length];
                nextColorIndex += 1;
            }
            return {
                ...stat,
                isCurrentUser: isCurrentUser,
                playerColor: playerColor
            };
        });
    }, [
        gameOverStats,
        me?.color,
        users,
        _userToken
    ]);
    const myGameOverStat = (0, $gIfym.useMemo)(()=>decoratedGameOverStats.find((stat)=>stat.isCurrentUser), [
        decoratedGameOverStats
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (game.completed_at || game.board && game.board === game.solution) setWon(true);
    }, [
        game.board,
        game.solution,
        game.completed_at
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (!won) return;
        if (game.short_id) (0, $3be2d95b79eebae2$export$95a1a7db56f99e1b)(game.short_id);
        (0, $8edb5194a04d38bf$export$ffbd567786ca98ee)();
    }, [
        won,
        game.short_id
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (!offlineUpdates.length) return;
        if (!_socket.current) return;
        // if connected, send up the wire
        processOfflineUpdates();
    }, [
        offlineUpdates.length,
        _socket.current
    ]);
    // effect to reconnect socket after disconnected
    (0, $gIfym.useEffect)(()=>{
        if (!offline) return;
        const intervalId = window.setInterval(loadGame, $7764b776fbd01fc1$var$RECONNECT_INTERVAL_MS);
        return ()=>{
            if (intervalId) window.clearInterval(intervalId);
        };
    }, [
        offline
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (!_crossword.current) return;
        if (!offlineUpdates.length) return;
        if (!ready) return;
        // draw locally
        const { board: board } = _crossword.current.state;
        const newBoard = {
            ...board
        };
        offlineUpdates.forEach(({ row: row, col: col, value: value })=>{
            const val = value === "-" ? "" : value;
            if (!newBoard[row]) newBoard[row] = {};
            newBoard[row][col] = val;
        });
        _crossword.current.setState({
            board: newBoard
        });
    }, [
        offlineUpdates.length,
        _crossword.current,
        ready
    ]);
    const getColor = (usedColors)=>{
        const _baseRandomColor = ()=>{
            const idx = Math.floor(Math.random() * (0, $5cbcba0f1da6c5df$export$56d196d2844d1ca1).length);
            return (0, $5cbcba0f1da6c5df$export$56d196d2844d1ca1)[idx];
        };
        const { color: preferredColor } = settings;
        // if (window.localStorage && typeof window.localStorage.getItem === 'function' &&
        //     window.localStorage.getItem('myColor')) {
        //   return window.localStorage.getItem('myColor')
        // }
        // if theres no remaining colors, return preferred or random
        const remainingColors = (0, $5cbcba0f1da6c5df$export$56d196d2844d1ca1).filter((c)=>!usedColors.has(c));
        if (!remainingColors.length) return preferredColor || _baseRandomColor();
        // if there is a preferred color, return it if it's available
        if (preferredColor && remainingColors.includes(preferredColor)) return preferredColor;
        // otherwise, return a random remaining color
        const idx = Math.floor(Math.random() * remainingColors.length);
        return remainingColors[idx];
    };
    const setColor = (color)=>{
        if (!window.localStorage || typeof window.localStorage.setItem !== "function") return;
        window.localStorage.setItem("myColor", color);
        setMe({
            color: color
        });
        if (!_socket.current) return;
        _socket.current.emit("setcolor", color);
    };
    const connectSocket = (game)=>{
        const { short_id: shortId } = game;
        if (_socket.current) {
            _socket.current.removeAllListeners();
            _socket.current.disconnect();
        }
        _socket.current = io($7764b776fbd01fc1$var$SOCKET_URL);
        _socket.current.on("connect", ()=>{
            _socket.current.emit("loadgame", {
                gameId: shortId,
                userToken: _userToken,
                platform: "web"
            });
            if (!localStartTime) setLocalStartTime(Date.now());
            setOffline(false);
        });
        _socket.current.on("reconnect", ()=>{
            _socket.current.emit("loadgame", {
                gameId: shortId,
                userToken: _userToken,
                platform: "web"
            });
            if (!localStartTime) setLocalStartTime(Date.now());
            setOffline(false);
        });
        _socket.current.on("disconnect", ()=>{
            setOffline(true);
        });
        _socket.current.on("users", (users)=>{
            setUsers(users);
        });
        _socket.current.on("doneloading", (users)=>{
            const color = getColor(new Set(Object.values(users).map((u)=>u.color)));
            setColor(color);
            _crossword.current.setInitialPosition();
            setReady(true);
        });
        _socket.current.on("boardupdate", ({ row: row, col: col, value: value, socketId: socketId })=>{
            if (_socket.id === socketId) // we sent this update, no need to process again
            return;
            const { board: board } = _crossword.current.state;
            const newBoard = {
                ...board
            };
            let val = value;
            if (value === "-") val = "";
            newBoard[row][col] = val;
            _crossword.current.setState({
                board: newBoard
            });
            const boardStr = Object.values(newBoard).flatMap((arr)=>arr.map((item)=>item === "" ? "." : item)).join("");
            if (boardStr === game.solution) setWon(true);
            // drop from offline update
            setOfflineUpdates((offlineUpdates)=>offlineUpdates.filter(({ row: offlineRow, col: offlineCol })=>row !== parseInt(offlineRow) && col !== parseInt(offlineCol)));
        });
        _socket.current.on("boardupdates", (updates)=>{
            const { board: board } = _crossword.current.state;
            const newBoard = {
                ...board
            };
            updates.forEach(({ row: row, col: col, value: value })=>{
                let val = value;
                if (value === "-") val = "";
                newBoard[row][col] = val;
            });
            _crossword.current.setState({
                board: newBoard
            });
            const boardStr = Object.values(newBoard).flatMap((arr)=>arr.map((item)=>item === "" ? "." : item)).join("");
            if (boardStr === game.solution) setWon(true);
        });
        _socket.current.on("gamecompleted", ({ board: completedBoard, completedAt: completedAt, stats: stats })=>{
            const normalizedStats = $7764b776fbd01fc1$var$normalizeCompletionStats(stats);
            receivedCompletionEventRef.current = true;
            if (_crossword.current && completedBoard && game.width && game.height) {
                const newBoard = [];
                for(let i = 0; i < game.height; i += 1){
                    const row = [];
                    for(let j = 0; j < game.width; j += 1){
                        const item = completedBoard[i * game.width + j];
                        row.push(item === "." || item === "-" ? "" : item);
                    }
                    newBoard.push(row);
                }
                _crossword.current.setState({
                    board: newBoard
                });
            }
            setGameOverStats(normalizedStats);
            setGame((prev)=>({
                    ...prev,
                    board: completedBoard || prev.board,
                    completed_at: completedAt || prev.completed_at || new Date().toISOString(),
                    completion_stats: normalizedStats
                }));
            setWon(true);
            (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).PUZZLE_COMPLETED, {
                gameId: shortId
            });
        });
        _socket.current.on("sendpings", ({ row: row, col: col })=>{
            const { pingKeys: pingKeys } = _crossword.current.state;
            const newPingKeys = [
                ...pingKeys
            ];
            newPingKeys[row][col] = (0, (/*@__PURE__*/$parcel$interopDefault($ab009d3ca5ea0c28$exports))).generate();
            _crossword.current.setState({
                pingKeys: newPingKeys
            });
        });
        _socket.current.on("game_seconds_offset", (offset)=>{
            setGameSecondsOffset(offset);
        });
    };
    const loadGame = async ()=>{
        const { gameId: gameId } = match.params;
        if (!gameId) return;
        if (isLoadingGameRef.current) return;
        isLoadingGameRef.current = true;
        const trackGameOpenedOnce = ({ gameId: gameId, isOffline: isOffline })=>{
            const key = `${gameId}:${isOffline ? "offline" : "online"}`;
            if (trackedGameOpenedRef.current.has(key)) return;
            trackedGameOpenedRef.current.add(key);
            (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).GAME_OPENED, {
                gameId: gameId,
                offline: isOffline
            });
        };
        try {
            // TODO: add timeout?
            const game = await (0, $1fb8695a0c221e27$export$2e2bcd8739ae039).getGameInfo(gameId);
            if ($7764b776fbd01fc1$var$isValidGamePayload(game)) {
                setOffline(false);
                localStorage.setItem("lastGameId", gameId);
                (0, $3be2d95b79eebae2$export$b164046a52434f6a)(game);
                setGame(game);
                connectSocket(game);
                trackGameOpenedOnce({
                    gameId: gameId,
                    isOffline: false
                });
            } else throw new Error("not found");
        } catch (err) {
            if (offline) // already offline, dont reset state
            return;
            if (err.message === "Failed to fetch") {
                const cachedGame = (0, $3be2d95b79eebae2$export$1adf613f7458986)(gameId);
                if (cachedGame) {
                    setOffline(true);
                    setGame(cachedGame);
                    setGameOverStats([]);
                    setUsers({
                        [$7764b776fbd01fc1$var$OFFLINE_ID]: {
                            color: settings.color,
                            row: 0,
                            col: 0
                        }
                    });
                    setColor(settings.color);
                    _crossword.current.setInitialPosition();
                    setReady(true);
                    trackGameOpenedOnce({
                        gameId: gameId,
                        isOffline: true
                    });
                }
            } else {
                console.error(`Error loading game: ${err.message}`);
                alert("Invalid game ID!");
                history.push("/game/continue");
            }
        } finally{
            isLoadingGameRef.current = false;
        }
    };
    const processOfflineUpdates = ()=>{
        if (won || game.completed_at) return;
        // step 1. consolidate
        const boardMap = {};
        offlineUpdates.forEach(({ row: row, col: col, value: value })=>{
            if (!boardMap[row]) boardMap[row] = {};
            boardMap[row][col] = value;
        });
        // step 2. deliver
        // TODO: batch delivery
        const gameId = game.short_id;
        Object.keys(boardMap).forEach((row)=>{
            Object.keys(boardMap[row]).forEach((col)=>{
                const value = boardMap[row][col];
                _socket.current.emit("updateboard", {
                    gameId: gameId,
                    row: parseInt(row),
                    col: parseInt(col),
                    value: value
                });
            });
        });
    };
    const updateLetter = (row, col, val)=>{
        if (won || game.completed_at) return;
        const { gameId: gameId } = match.params;
        let value = val;
        if (!val || !val.trim()) value = "-";
        const { board: board } = _crossword.current.state;
        // window.game = game
        // window.board = board
        const update = {
            gameId: gameId,
            row: row,
            col: col,
            value: value
        };
        if (!hasTrackedGameStartRef.current) {
            hasTrackedGameStartRef.current = true;
            (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).GAME_STARTED, {
                gameId: gameId
            });
        }
        if (!_socket.current) {
            setOfflineUpdates((offlineUpdates)=>[
                    ...offlineUpdates,
                    update
                ]);
            return;
        }
        // TODO: optimize this, still slow
        // TODO: dont need to reset state on boardUpdate when its the same user
        // backend can stop sending this to the updating client
        // TODO: removed, bc its already happening in crossword.js
        // const newBoard = { ...board }
        // newBoard[row][col] = value === '-' ? '' : value
        // _crossword.current.setState({ board: newBoard })
        _socket.current.emit("updateboard", {
            gameId: gameId,
            row: row,
            col: col,
            value: value
        });
        const boardStr = Object.values(board).flatMap((arr)=>arr.map((item)=>item === "" ? "." : item)).join("");
        if (boardStr === game.solution) setWon(true);
    };
    const updatePos = (row, col)=>{
        const socketId = _socket.current?.id || $7764b776fbd01fc1$var$OFFLINE_ID;
        setUsers((users)=>({
                ...users,
                [socketId]: {
                    ...users[socketId],
                    row: row,
                    col: col
                }
            }));
        if (!_socket.current) return;
        _socket.current.emit("updatepos", {
            row: row,
            col: col
        });
    };
    const emitPing = (row, col)=>{
        if (!_socket.current) return;
        _socket.current.emit("emitping", {
            row: row,
            col: col
        });
        (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).PING_SENT, {
            gameId: game.short_id,
            row: row,
            col: col
        });
    };
    const { gameId: gameId } = match.params;
    const statusString = game.short_id ? game.title.trim() || "Untitled" : "Loading...";
    if (!gameId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $19737ff6f49f85c7$export$2e2bcd8739ae039), {
        to: "/"
    });
    // console.log('users: ', users)
    // console.log('socket id: ', _socket.current?.id)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "GameWindow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h1", null, statusString), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "Row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($7764b776fbd01fc1$var$StyledHomeButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "Col"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", null, "Game ID: ", gameId), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        className: "Duration",
        onClick: onClickTimer,
        style: {
            cursor: "pointer"
        }
    }, "\xa0\xa0\xa0Timer:\xa0", settings.timer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        style: {
            fontSize: "1em"
        }
    }, duration) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        style: {
            fontSize: "1em",
            fontStyle: "italic"
        }
    }, "hidden")), !offline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        className: "UserString"
    }, "Players: ", Object.keys(users).length, "\xa0\xa0\xa0\xa0"), offline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        className: "UserString"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("strong", null, "\u26A0\uFE0F OFFLINE \u26A0\uFE0F"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($7764b776fbd01fc1$var$StyledShareButton, {
        onClick: ()=>setShowShareModal(true)
    })), showShareModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4b217727919d843e$export$2e2bcd8739ae039), {
        gameId: gameId,
        onClose: ()=>setShowShareModal(false)
    }), showGameOverModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "GameOverOverlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "GameOverModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "Puzzle Completed!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", {
        className: "GameOverDuration"
    }, "Duration: ", duration), gameOverStats.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "GameOverStatsCard"
    }, myGameOverStat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "GameOverMeSummary"
    }, "You placed ", myGameOverStat.letters, " letters (", myGameOverStat.percent, "%)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("table", {
        className: "GameOverStatsTable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("colgroup", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("col", {
        style: {
            width: "40%"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("col", {
        style: {
            width: "18%"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("col", {
        style: {
            width: "42%"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", null, "Player"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", null, "Letters"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", null, "Share"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tbody", null, decoratedGameOverStats.map((stat)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tr", {
            key: stat.userToken,
            className: stat.isCurrentUser ? "GameOverRowMe" : ""
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
            className: "GameOverPlayerNameCell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
            className: "GameOverPlayerDot",
            style: stat.playerColor ? {
                backgroundColor: stat.playerColor
            } : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
            className: "GameOverPlayerName"
        }, stat.isCurrentUser ? "Me" : stat.nickname), stat.isCurrentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
            className: "GameOverMeBadge"
        }, "YOU"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", null, stat.letters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "GameOverShareCell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", null, stat.percent, "%"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "GameOverShareTrack"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "GameOverShareFill",
            style: {
                width: `${Math.max(0, Math.min(100, stat.percent))}%`,
                ...stat.playerColor ? {
                    backgroundColor: stat.playerColor
                } : {}
            }
        }))))))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "Finalizing score..."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "GameOverActions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("button", {
        className: "GameOverCloseButton",
        type: "button",
        onClick: ()=>setShowGameOverModal(false)
    }, "Close"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("button", {
        className: "GameOverNextButton",
        type: "button",
        onClick: ()=>history.push("/game/new")
    }, "Next Puzzle")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ab94c19ccb4acf4d$export$2e2bcd8739ae039), {
        ref: _crossword,
        ...game,
        isComplete: won || Boolean(game.completed_at),
        showCheck: !(won || game.completed_at),
        onViewStats: gameOverStats.length > 0 ? ()=>setShowGameOverModal(true) : undefined,
        clues: {
            down: downClues,
            across: acrossClues
        },
        users: users,
        me: me,
        updateLetter: updateLetter,
        updatePos: updatePos,
        emitPing: emitPing,
        settings: settings
    }));
};
var $7764b776fbd01fc1$export$2e2bcd8739ae039 = $7764b776fbd01fc1$var$Game;



var $gIfym = parcelRequire("gIfym");

class $70e2c0163f8d3e05$export$271f9f08425019c7 extends (0, $gIfym.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $19737ff6f49f85c7$export$2e2bcd8739ae039), {
            to: "/"
        });
    }
}
var $70e2c0163f8d3e05$export$2e2bcd8739ae039 = $70e2c0163f8d3e05$export$271f9f08425019c7;



var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");

const $71c881f00ccd32d4$var$SOURCE_MAP = {
    atl: "Atlantic",
    club: "Crossword Club",
    db: "The Daily Beast",
    pop: "Daily Pop",
    std: "Der Standard",
    tgam: "The Globe And Mail cryptic",
    grdc: "Guardian Cryptic",
    grde: "Guardian Everyman",
    grdp: "Guardian Prize",
    grdq: "Guardian Quick",
    grdu: "Guardian Quiptic",
    grds: "Guardian Speedy",
    grdw: "Guardian Weekend",
    lat: "Los Angeles Times",
    mck: "The McKinsey Crossword",
    nyt: "New York Times",
    nytm: "New York Times Mini",
    nytv: "New York Times Variety",
    tny: "The New Yorker",
    nd: "Newsday",
    pzm: "Puzzmo",
    sdp: "Simply Daily Puzzles",
    sdpc: "Simply Daily Puzzles Cryptic",
    sdpq: "Simply Daily Puzzles Quick",
    uni: "Universal",
    usa: "USA Today",
    vox: "Vox",
    wp: "Washington Post"
};
const $71c881f00ccd32d4$var$Tr = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).tr`
  height: 32px;
  text-align: left;
  cursor: pointer;

  &:nth-child(even) {
    background-color: #5abd7f;
  }

  &:hover {
    background-color: #abffca;
  }
`;
const $71c881f00ccd32d4$var$Th = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).th`
  text-align: left;
`;
const $71c881f00ccd32d4$var$Td = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).td`
  padding: 0 8px;
`;
const $71c881f00ccd32d4$var$PuzzleTable = ({ files: files, onPreview: onPreview, actionsDisabled: actionsDisabled, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("table", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Th, null, "Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Th, {
        style: {
            textAlign: "center"
        }
    }, "Size"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Th, {
        style: {
            textAlign: "center"
        }
    }, "Source"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Th, {
        style: {
            textAlign: "center"
        }
    }, "Date Uploaded")), files.map((f)=>{
        let size = "-";
        if (f.width && f.height) size = `${f.width}x${f.height}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Tr, {
            key: f.filename,
            onClick: ()=>{
                if (!actionsDisabled) onPreview(f);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Td, null, f.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Td, {
            style: {
                textAlign: "center"
            }
        }, size), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Td, {
            style: {
                textAlign: "center"
            }
        }, $71c881f00ccd32d4$var$SOURCE_MAP[f.source] || f.source), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($71c881f00ccd32d4$var$Td, {
            style: {
                textAlign: "center"
            }
        }, new Date(f.created_at).toISOString().split("T")[0]));
    })));
};
var $71c881f00ccd32d4$export$2e2bcd8739ae039 = $71c881f00ccd32d4$var$PuzzleTable;



var $gIfym = parcelRequire("gIfym");





const $db31371ddb62172a$var$StyledButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)((0, $ee6e5d464bbae375$export$2e2bcd8739ae039))`
  font-size: 1em;
`;
const $db31371ddb62172a$var$API_URL = "";
const $db31371ddb62172a$var$FORM_ACTION = `${$db31371ddb62172a$var$API_URL}/upload`;
const $db31371ddb62172a$var$Upload = ()=>{
    const formRef = (0, $gIfym.useRef)();
    const [loading, setLoading] = (0, $gIfym.useState)(false);
    const onSubmit = (event)=>{
        if (!formRef.current[0].files.length) {
            event.preventDefault();
            alert("Please select a file to upload.");
        }
        (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).UPLOAD_STARTED);
        setLoading(true);
    };
    let uploadText = "Upload (.PUZ)";
    if (loading) uploadText = "Uploading...";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "UploadBox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h1", null, "Upload"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("form", {
        action: $db31371ddb62172a$var$FORM_ACTION,
        method: "POST",
        encType: "multipart/form-data",
        ref: formRef,
        onSubmit: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("input", {
        type: "file",
        name: "puzzle",
        accept: ".puz"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("input", {
        type: "hidden",
        name: "userToken",
        value: localStorage.getItem("userToken")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($db31371ddb62172a$var$StyledButton, {
        className: "button",
        type: "submit",
        disabled: loading,
        text: uploadText
    })));
};
var $db31371ddb62172a$export$2e2bcd8739ae039 = $db31371ddb62172a$var$Upload;



const $b0d472a6b7eb4940$var$spin = (0, $cc85e8b8e7405a89$export$d25ddfdf17c3ad3e)`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;
const $b0d472a6b7eb4940$var$Spinner = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: inline-block;
  width: 80px;
  height: 80px;
  &:after {
    content: ' ';
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #333;
    border-color: #333 transparent #333 transparent;
    animation: ${$b0d472a6b7eb4940$var$spin} 1.2s linear infinite;
  }
`;
var $b0d472a6b7eb4940$export$2e2bcd8739ae039 = $b0d472a6b7eb4940$var$Spinner;



var $gIfym = parcelRequire("gIfym");


const $d258a7e32d1bf58a$var$Box = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  width: 90%;
  max-width: 1000px;
  position: relative;
  padding: 0 15px;
  margin: 20px auto;
  // background-color: #78b08f;
  border-radius: 10px;
  padding-bottom: 40px;
  color: #333;
  text-align: center;
  display: flex;
  flex-direction: column;
  font-size: 1.2em;
  box-sizing: border-box;

  @media only screen and (max-width: 600px) {
    width: 100%;
    margin: 0 auto;
    border-radius: 0;
  }
`;
const $d258a7e32d1bf58a$var$CloseBtn = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 5px;
  right: 15px;
  font-size: 42px;
  cursor: pointer;

  a {
    text-decoration: none;
    color: inherit;
  }
`;
const $d258a7e32d1bf58a$var$ContentBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  width: 80%;
  margin: 0 auto;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;
const $d258a7e32d1bf58a$var$Modal = ({ title: title, onCloseLink: onCloseLink = "/", className: className, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($d258a7e32d1bf58a$var$Box, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h1", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($d258a7e32d1bf58a$var$CloseBtn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $9cbc292f226e199b$export$2e2bcd8739ae039), {
        to: onCloseLink
    }, "\xd7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($d258a7e32d1bf58a$var$ContentBox, {
        className: className
    }, children));
};
var $d258a7e32d1bf58a$export$2e2bcd8739ae039 = $d258a7e32d1bf58a$var$Modal;



const $6e75660a5e42b669$var$StyledModal = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)((0, $d258a7e32d1bf58a$export$2e2bcd8739ae039))`
  width: 100%;
`;
const $6e75660a5e42b669$var$StyledTable = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)((0, $71c881f00ccd32d4$export$2e2bcd8739ae039))`
  width: 90%;
  margin: 0 auto;
`;
const $6e75660a5e42b669$var$TableBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  height: 420px;
  overflow: auto;
`;
const $6e75660a5e42b669$var$PageButtons = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  width: 50%;
  margin: 20px auto 0;
  text-align: center;
  align-items: center;
  
  > div {
    flex: 1;
    font-size: 1.4em;
    color: #333;
  }

  > div.page-btn {
    font-size: 2em;
    cursor: pointer;

    &[disabled] {
      visibility: hidden;
      cursor: initial;
    }
  }
`;
const $6e75660a5e42b669$var$MissingText = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).p`
  display: flex;
  margin: 0;
  height: 100%;
  align-items: center;
  justify-self: center;
`;
const $6e75660a5e42b669$var$PreviewBackdrop = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  position: fixed;
  inset: 0;
  z-index: 20;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
`;
const $6e75660a5e42b669$var$PreviewCard = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  width: 100%;
  max-width: 900px;
  max-height: 82vh;
  overflow: auto;
  border-radius: 12px;
  background-color: #d6f0df;
  padding: 14px;
  box-sizing: border-box;
`;
const $6e75660a5e42b669$var$PreviewTitle = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).h2`
  margin: 0;
  color: #2f4538;
`;
const $6e75660a5e42b669$var$PreviewMeta = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).p`
  margin: 4px 0 10px;
  color: #2f4538;
  font-size: 0.8em;
`;
const $6e75660a5e42b669$var$PreviewHeader = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
`;
const $6e75660a5e42b669$var$PreviewHeaderText = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  grid-column: 2;
  min-width: 0;
  text-align: center;
`;
const $6e75660a5e42b669$var$HeaderButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).button`
  border-radius: 8px;
  border: 1px solid #2f4538;
  padding: 8px 12px;
  background-color: rgba(255, 255, 255, 0.6);
  color: #2f4538;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  justify-self: start;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
const $6e75660a5e42b669$var$TopStartButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)($6e75660a5e42b669$var$HeaderButton)`
  justify-self: end;
  border-radius: 8px;
  border: none;
  background-color: #78b08f;
  color: #333;
`;
const $6e75660a5e42b669$var$PreviewLoadingBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $6e75660a5e42b669$var$PreviewContent = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $6e75660a5e42b669$var$GridScroller = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  overflow-x: auto;
`;
const $6e75660a5e42b669$var$GridWrap = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: inline-block;
  background-color: #fff;
`;
const $6e75660a5e42b669$var$GridRow = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $6e75660a5e42b669$var$GridCell = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  width: 20px;
  height: 20px;
  border-top: 1px solid #2f4538;
  border-left: 1px solid #2f4538;
  background-color: ${({ $blocked: $blocked })=>$blocked ? "#2f4538" : "#fff"};
  border-right: ${({ $lastCol: $lastCol })=>$lastCol ? "1px solid #2f4538" : "none"};
  border-bottom: ${({ $lastRow: $lastRow })=>$lastRow ? "1px solid #2f4538" : "none"};
  color: #2f4538;
  font-size: 0.45em;
  font-weight: 700;
  padding-left: 1px;
  padding-top: 1px;
  box-sizing: border-box;
`;
const $6e75660a5e42b669$var$ClueSection = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  background-color: rgba(255, 255, 255, 0.45);
  border-radius: 8px;
  padding: 10px;
  text-align: left;
`;
const $6e75660a5e42b669$var$ClueHeader = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).h3`
  margin: 0 0 6px;
  color: #2f4538;
  font-size: 1.1em;
`;
const $6e75660a5e42b669$var$ClueText = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).p`
  margin: 0 0 3px;
  color: #333;
  font-size: 0.82em;
  line-height: 1.3;
`;
const $6e75660a5e42b669$var$PreviewButtons = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  margin-top: 10px;
  display: flex;
  gap: 10px;
`;
const $6e75660a5e42b669$var$SecondaryButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).button`
  flex: 1;
  border-radius: 8px;
  border: 1px solid #2f4538;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.6);
  color: #2f4538;
  font-weight: 700;
  cursor: pointer;
`;
const $6e75660a5e42b669$var$StartButton = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).button`
  flex: 1;
  border-radius: 8px;
  border: none;
  padding: 10px;
  background-color: #78b08f;
  color: #333;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
const $6e75660a5e42b669$var$SOURCE_MAP = {
    atl: "Atlantic",
    club: "Crossword Club",
    db: "The Daily Beast",
    pop: "Daily Pop",
    std: "Der Standard",
    tgam: "The Globe And Mail cryptic",
    grdc: "Guardian Cryptic",
    grde: "Guardian Everyman",
    grdp: "Guardian Prize",
    grdq: "Guardian Quick",
    grdu: "Guardian Quiptic",
    grds: "Guardian Speedy",
    grdw: "Guardian Weekend",
    lat: "Los Angeles Times",
    mck: "The McKinsey Crossword",
    nyt: "New York Times",
    nytm: "New York Times Mini",
    nytv: "New York Times Variety",
    tny: "The New Yorker",
    nd: "Newsday",
    pzm: "Puzzmo",
    sdp: "Simply Daily Puzzles",
    sdpc: "Simply Daily Puzzles Cryptic",
    sdpq: "Simply Daily Puzzles Quick",
    uni: "Universal",
    usa: "USA Today",
    vox: "Vox",
    wp: "Washington Post"
};
const $6e75660a5e42b669$var$getDisplayTitle = (title = "")=>title ? title.replace(/\s*\([^)]*\)\s*$/, "") : "Untitled";
const $6e75660a5e42b669$var$getSizeLabel = (puzzle)=>puzzle?.width && puzzle?.height ? `${puzzle.width}x${puzzle.height}` : "-";
const $6e75660a5e42b669$var$sortClueEntries = (clues = {})=>Object.entries(clues).sort(([a], [b])=>Number(a) - Number(b));
const $6e75660a5e42b669$var$buildClueLookup = (across = {}, down = {})=>{
    const lookup = {};
    const assign = (entries)=>{
        Object.entries(entries).forEach(([number, clue])=>{
            const key = `${clue.row}-${clue.col}`;
            if (!lookup[key] || Number(number) < Number(lookup[key])) lookup[key] = number;
        });
    };
    assign(across);
    assign(down);
    return lookup;
};
class $6e75660a5e42b669$export$e7e20814fadcf6e extends (0, $gIfym.Component) {
    constructor(props){
        super(props);
        this.state = {
            files: [],
            page: 1,
            loading: true,
            startingFilename: null,
            previewVisible: false,
            previewFile: null,
            previewLoading: false,
            previewData: null,
            previewCache: {}
        };
        this.loadFiles();
    }
    loadFiles = ()=>{
        const { page: page } = this.state;
        const userToken = localStorage.getItem("userToken");
        (0, $1fb8695a0c221e27$export$2e2bcd8739ae039).getPuzzles(page, userToken).then((files)=>{
            this.setState({
                files: files
            });
        }).finally(()=>{
            this.setState({
                loading: false
            });
        });
    };
    handleNextPage = ()=>{
        this.setState((prevState)=>({
                page: prevState.page + 1,
                loading: true
            }), this.loadFiles);
    };
    handlePreviousPage = ()=>{
        this.setState((prevState)=>({
                page: Math.max(prevState.page - 1, 1),
                loading: true
            }), this.loadFiles);
    };
    onStart = (filename)=>{
        const { history: history } = this.props;
        this.setState({
            startingFilename: filename
        });
        (0, $1fb8695a0c221e27$export$2e2bcd8739ae039).createGame(filename).then((game)=>{
            history.push(`/game/${game.short_id}`);
        }).catch(console.error).finally(()=>{
            this.setState({
                startingFilename: null
            });
        });
    };
    onPreview = (file)=>{
        this.setState({
            previewFile: file,
            previewVisible: true
        });
        const { previewCache: previewCache } = this.state;
        const cached = previewCache[file.filename];
        if (cached) {
            this.setState({
                previewLoading: false,
                previewData: cached
            });
            return;
        }
        this.setState({
            previewLoading: true,
            previewData: null
        });
        (0, $1fb8695a0c221e27$export$2e2bcd8739ae039).getPuzzlePreview(file.filename).then((payload)=>{
            this.setState((prevState)=>({
                    previewData: payload,
                    previewCache: {
                        ...prevState.previewCache,
                        [file.filename]: payload
                    }
                }));
        }).catch((error)=>{
            console.error("Failed to load puzzle preview", error);
            this.setState({
                previewData: null
            });
        }).finally(()=>{
            this.setState({
                previewLoading: false
            });
        });
    };
    closePreview = ()=>{
        const { previewLoading: previewLoading, startingFilename: startingFilename } = this.state;
        if (previewLoading || startingFilename) return;
        this.setState({
            previewVisible: false
        });
    };
    renderPreviewModal = ()=>{
        const { previewVisible: previewVisible, previewFile: previewFile, previewLoading: previewLoading, previewData: previewData, startingFilename: startingFilename } = this.state;
        if (!previewVisible) return null;
        const clueNumberLookup = previewData ? $6e75660a5e42b669$var$buildClueLookup(previewData.across || {}, previewData.down || {}) : {};
        const acrossEntries = previewData ? $6e75660a5e42b669$var$sortClueEntries(previewData.across || {}) : [];
        const downEntries = previewData ? $6e75660a5e42b669$var$sortClueEntries(previewData.down || {}) : [];
        const startDisabled = !previewFile || Boolean(startingFilename) || previewLoading;
        const startLabel = startingFilename === previewFile?.filename ? "Starting..." : "Start Puzzle";
        const startCurrentPuzzle = ()=>{
            if (!previewFile) return;
            this.setState({
                previewVisible: false
            }, ()=>this.onStart(previewFile.filename));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewBackdrop, {
            onClick: this.closePreview
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewCard, {
            onClick: (e)=>e.stopPropagation()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$HeaderButton, {
            onClick: this.closePreview
        }, "Keep Looking"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewHeaderText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewTitle, null, $6e75660a5e42b669$var$getDisplayTitle(previewFile?.title || previewData?.title || "")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewMeta, null, previewFile ? `${$6e75660a5e42b669$var$getSizeLabel(previewFile)} \u{2022} ${$6e75660a5e42b669$var$SOURCE_MAP[previewFile.source || ""] || previewFile.source || "-"}` : "")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$TopStartButton, {
            disabled: startDisabled,
            onClick: startCurrentPuzzle
        }, startLabel)), previewLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewLoadingBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b0d472a6b7eb4940$export$2e2bcd8739ae039), null)) : previewData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$GridScroller, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$GridWrap, null, Array.from({
            length: previewData.height
        }).map((_, row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$GridRow, {
                key: `row-${row}`
            }, Array.from({
                length: previewData.width
            }).map((__, col)=>{
                const idx = row * previewData.width + col;
                const blocked = previewData.board[idx] === ".";
                const clueNumber = clueNumberLookup[`${row}-${col}`] || "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$GridCell, {
                    key: `${row}-${col}`,
                    $blocked: blocked,
                    $lastCol: col === previewData.width - 1,
                    $lastRow: row === previewData.height - 1
                }, !blocked ? clueNumber : "");
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$ClueSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$ClueHeader, null, "Across"), acrossEntries.map(([number, clue])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$ClueText, {
                key: `a-${number}`
            }, number, ". ", clue.clue))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$ClueSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$ClueHeader, null, "Down"), downEntries.map(([number, clue])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$ClueText, {
                key: `d-${number}`
            }, number, ". ", clue.clue)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewLoadingBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$MissingText, null, "Could not load preview")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PreviewButtons, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$SecondaryButton, {
            onClick: this.closePreview
        }, "Keep Looking"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$StartButton, {
            disabled: startDisabled,
            onClick: startCurrentPuzzle
        }, startLabel))));
    };
    render() {
        const { files: files, page: page, loading: loading, startingFilename: startingFilename } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$StyledModal, {
            title: "Start new game"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "NewGame"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$TableBox, null, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $b0d472a6b7eb4940$export$2e2bcd8739ae039), null), !loading && files && files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$StyledTable, {
            files: files,
            onPreview: this.onPreview,
            actionsDisabled: Boolean(startingFilename)
        }), !loading && !files?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$MissingText, null, "Unable to load puzzles :(")), files?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($6e75660a5e42b669$var$PageButtons, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "page-btn",
            onClick: this.handlePreviousPage,
            disabled: page === 1
        }, "<"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", null, page), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "page-btn",
            onClick: this.handleNextPage,
            disabled: files.length < 10
        }, ">")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $db31371ddb62172a$export$2e2bcd8739ae039), null)), this.renderPreviewModal());
    }
}
var $6e75660a5e42b669$export$2e2bcd8739ae039 = $6e75660a5e42b669$export$e7e20814fadcf6e;



var $gIfym = parcelRequire("gIfym");



const $a26da0cf4f317091$var$StyledInput = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).input`
  border: none;
  border-bottom: 2px solid #333;
  outline: none;
  padding: 5px;
  font-size: 1rem;
  background-color: transparent;
  transition: border-color 0.3s;
  color: #333;

  &::placeholder {
    color: #333;
  }

  &:focus {
    // border-bottom-color: #90d1a8;
  }
`;
var $a26da0cf4f317091$export$2e2bcd8739ae039 = $a26da0cf4f317091$var$StyledInput;





const $56acd30ccb2489dc$var$StyledModal = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039)((0, $d258a7e32d1bf58a$export$2e2bcd8739ae039))`
    width: 100%;
`;
class $56acd30ccb2489dc$export$4c53cc530bd5b699 extends (0, $gIfym.Component) {
    constructor(props){
        super(props);
        this.state = {
            gameId: ""
        };
        this.recentGames = (0, $3be2d95b79eebae2$export$d2e1544dc8131c8a)();
    }
    onKeyDown(e) {
        const { history: history } = this.props;
        const { gameId: gameId } = this.state;
        if (!gameId) return;
        if (e.key !== "Enter") return;
        if (gameId === "error") throw new Error("Testing Error");
        history.push(`/game/${gameId}`);
    }
    render() {
        const { gameId: gameId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($56acd30ccb2489dc$var$StyledModal, {
            title: "Continue Game"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "ContinueGame"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $a26da0cf4f317091$export$2e2bcd8739ae039), {
            placeholder: "Enter Game ID",
            type: "text",
            onKeyDown: (e)=>this.onKeyDown(e),
            onChange: (e)=>this.setState({
                    gameId: e.target.value
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ee6e5d464bbae375$export$2e2bcd8739ae039), {
            text: "Continue game",
            to: `/game/${gameId}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), this.recentGames.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "Recent Games"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", null, "Short ID"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", null, "Title"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", null, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", null, "Last Played"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tbody", null, this.recentGames.map((game)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tr", {
                key: `recent-${game.short_id}`,
                className: game.completed_at ? "is-completed" : ""
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("a", {
                href: `/game/${game.short_id}`
            }, game.short_id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("a", {
                href: `/game/${game.short_id}`
            }, game.title || "Untitled")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", null, game.completed_at && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
                className: "completed-badge"
            }, "Completed")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", null, new Date(game.last_played_at).toLocaleString()))))))));
    }
}
var $56acd30ccb2489dc$export$2e2bcd8739ae039 = $56acd30ccb2489dc$export$4c53cc530bd5b699;




var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");

const $d75795f8972625be$var$Label = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  input {
    margin-left: 12px;
  }
`;
const $d75795f8972625be$var$Toggle = ({ label: label, value: value, onChange: onChange, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($d75795f8972625be$var$Label, {
        className: "switch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("label", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("input", {
        type: "checkbox",
        checked: value,
        onChange: onChange,
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        className: "slider round"
    }));
};
var $d75795f8972625be$export$2e2bcd8739ae039 = $d75795f8972625be$var$Toggle;










const $12e7be8c0b2fea41$var$ContentBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  text-align: left;

  label {
    text-align: right;
    width: 50%;
    display: inline-block;
  }

  @media only screen and (max-width: 600px) {
    input {
      max-width: 100px;
    }
  }
`;
const $12e7be8c0b2fea41$var$UserBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  margin-bottom: 15px;
  label {
    margin-right: 15px;
  }
`;
const $12e7be8c0b2fea41$var$ColorBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  margin-top: 22px;
  display: flex;
`;
const $12e7be8c0b2fea41$var$Colors = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: flex;
  margin-left: 15px;
  align-items: center;
  justify-content: space-between;
`;
const $12e7be8c0b2fea41$var$Color = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  border-radius: 100%;
  width: 17px;
  height: 17px;
  background-color: ${(props)=>props.color};
  margin-right: 8px;
  cursor: pointer;
  transition: all 0.2s;
  ${(props)=>props.selected && `
    border: 2px solid white;
  `}

  &:hover {
    transform: scale(1.2);
  }

  &:last-child {
    margin-right: 0;
  }
`;
const $12e7be8c0b2fea41$var$ButtonBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;
const $12e7be8c0b2fea41$var$Settings = ({ history: history })=>{
    const [settings, setSettings] = (0, $99fbd476f3947bc1$export$2e2bcd8739ae039)("settings", {}, 0);
    const [nickname, setNickname] = (0, $gIfym.useState)(settings.nickname || "");
    const [check, setCheck] = (0, $gIfym.useState)(settings.check || false);
    const [color, setColor] = (0, $gIfym.useState)(settings.color || "blue");
    const [timer, setTimer] = (0, $gIfym.useState)(settings.timer || false);
    const [saving, setSaving] = (0, $gIfym.useState)(false);
    (0, $gIfym.useEffect)(()=>{
        const userToken = localStorage.getItem("userToken");
        if (!userToken) return;
        (0, $ddadb956d940b4b7$export$2e2bcd8739ae039).getProfile(userToken).then((profile)=>{
            const serverNickname = typeof profile?.nickname === "string" ? profile.nickname : "";
            if (!serverNickname) return;
            setNickname(serverNickname);
            setSettings((prev)=>({
                    ...prev,
                    nickname: serverNickname
                }));
            (0, $a73b638dd7d927c0$export$a612d3804dec9d26)(serverNickname);
        }).catch((err)=>{
            console.warn("Failed to load user profile", err);
        });
    }, []);
    const onClickSave = async ()=>{
        const userToken = localStorage.getItem("userToken");
        const normalizedNickname = nickname.trim().replace(/\s+/g, " ");
        if (!normalizedNickname) {
            alert("Nickname is required.");
            return;
        }
        if (!userToken) {
            alert("Could not find user token.");
            return;
        }
        setSaving(true);
        try {
            await (0, $ddadb956d940b4b7$export$2e2bcd8739ae039).updateProfile(userToken, normalizedNickname);
            setSettings({
                check: check,
                nickname: normalizedNickname,
                color: color,
                timer: timer
            });
            (0, $a73b638dd7d927c0$export$a612d3804dec9d26)(normalizedNickname);
            (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).SETTINGS_UPDATED, {
                check: check,
                timer: timer,
                color: color,
                hasNickname: Boolean(normalizedNickname)
            });
            history.push("/");
        } catch (err) {
            console.error("Failed to update nickname", err);
            alert("Unable to save nickname right now.");
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $d258a7e32d1bf58a$export$2e2bcd8739ae039), {
        title: "Settings",
        onCloseLink: "/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($12e7be8c0b2fea41$var$ContentBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($12e7be8c0b2fea41$var$UserBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("label", {
        htmlFor: "nickname"
    }, "Set nickname"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $a26da0cf4f317091$export$2e2bcd8739ae039), {
        placeholder: "eg. puzzler",
        value: nickname,
        onChange: (e)=>setNickname(e.target.value),
        title: "Nickname displayed in game",
        name: "nickname"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $d75795f8972625be$export$2e2bcd8739ae039), {
        label: "Default check mode",
        title: "Should check mode by enabled by default or not",
        value: check,
        onChange: (e)=>setCheck(e.target.checked)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        style: {
            marginTop: 16
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $d75795f8972625be$export$2e2bcd8739ae039), {
        label: "Show timer",
        title: "Should the timer be visible by default or not",
        value: timer,
        onChange: (e)=>setTimer(e.target.checked)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($12e7be8c0b2fea41$var$ColorBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("label", {
        htmlFor: "color"
    }, "Preferred color"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($12e7be8c0b2fea41$var$Colors, null, (0, $5cbcba0f1da6c5df$export$56d196d2844d1ca1).map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($12e7be8c0b2fea41$var$Color, {
            key: `color-${c}`,
            color: c,
            onClick: ()=>setColor(c),
            selected: c === color
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($12e7be8c0b2fea41$var$ButtonBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $ee6e5d464bbae375$export$2e2bcd8739ae039), {
        text: saving ? "Saving..." : "Save",
        onClick: onClickSave
    }))));
};
var $12e7be8c0b2fea41$export$2e2bcd8739ae039 = $12e7be8c0b2fea41$var$Settings;



var $gIfym = parcelRequire("gIfym");







var $4152eb8c38d8a014$exports = {};
$4152eb8c38d8a014$exports = new URL("discord.0f995d10.png", import.meta.url).toString();


const $3a047136a5414232$var$ContentBox = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  text-align: center;
  p {
    margin: 0;
    font-size: 1.1em;
  }
`;
const $3a047136a5414232$var$DiscordImg = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).img`
  width: 200px;
  margin-top: 32px;
  display: inline-block;
`;
const $3a047136a5414232$var$Feedback = ({ history: history })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $d258a7e32d1bf58a$export$2e2bcd8739ae039), {
        title: "Feedback",
        onCloseLink: "/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($3a047136a5414232$var$ContentBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "We invite you to join our Discord community for faster support, the latest game updates, announcements, feedback opportunities, and friends to play with!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("a", {
        href: "https://discord.gg/9KMMksmsY7",
        target: "_blank",
        title: "Join our Discord community"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($3a047136a5414232$var$DiscordImg, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4152eb8c38d8a014$exports))),
        width: 200
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", {
        style: {
            marginTop: 24
        }
    }, "You may also reach us via email at: ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("a", {
        href: "mailto:feedback@wordgrid.io?subject=Feedback%20on%20WordGrid"
    }, "feedback@wordgrid.io"))));
};
var $3a047136a5414232$export$2e2bcd8739ae039 = $3a047136a5414232$var$Feedback;



var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");

function $34bde8fd4594a025$var$ImageSlider({ images: images }) {
    const [currentImageIndex, setCurrentImageIndex] = (0, $gIfym.useState)(0);
    const [fadeProp, setFadeProp] = (0, $gIfym.useState)("fade-in");
    const TIMEOUT = 3000; // Time between image changes (in milliseconds)
    const FADE_DURATION = 1000; // Duration of fade transition (in milliseconds)
    (0, $gIfym.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setFadeProp("fade-out");
            setTimeout(()=>{
                setCurrentImageIndex((currentImageIndex + 1) % images.length);
                setFadeProp("fade-in");
            }, FADE_DURATION); // Wait for fade-out to complete before changing image
        }, TIMEOUT);
        return ()=>clearTimeout(timeout);
    }, [
        currentImageIndex,
        images.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "image-slider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("img", {
        src: images[currentImageIndex],
        alt: "slideshow",
        className: fadeProp
    }));
}
var $34bde8fd4594a025$export$2e2bcd8739ae039 = $34bde8fd4594a025$var$ImageSlider;




const $924f9703d02a910a$var$Box = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  text-align: center;
  color: #333;

  h1.egg {
    cursor: pointer;
  }
  
  h1.title {
    margin-bottom: 32px;
  }
  
  img {
    border-radius: 10px;
  }
`;
const $924f9703d02a910a$var$imageBase = "https://dhcabdjaij1gf.cloudfront.net/";
const $924f9703d02a910a$var$imageUrls = [
    "hickey.jpg",
    "nville.png",
    "rv.jpg",
    "broadway.JPG",
    "fdate.JPG",
    "ring.jpg",
    "cotton.jpg",
    "office.JPEG",
    "eclipse.jpg",
    "bed.jpg",
    "airport.jpg",
    "lake.jpg",
    "mila.jpg",
    "jetski2.jpg",
    "infuse.jpg",
    "rat.jpg",
    "photo.jpg",
    "phone.jpg",
    "nye.jpg",
    "sunset.jpg",
    "sad.PNG"
];
const $924f9703d02a910a$var$SOCKET_URL = (0, window.location.origin);
const $924f9703d02a910a$var$MorgoEgg = ()=>{
    const socket = (0, $gIfym.useRef)(null);
    const audio = (0, $gIfym.useRef)(null);
    (0, $gIfym.useEffect)(()=>{
        (0, $8edb5194a04d38bf$export$ffbd567786ca98ee)(2900, true);
    }, []);
    (0, $gIfym.useEffect)(()=>{
        if (socket.current) return;
        const userToken = localStorage.getItem("userToken");
        socket.current = io($924f9703d02a910a$var$SOCKET_URL);
        socket.current.on("connect", ()=>{
            socket.current.emit("morgo", {
                userToken: userToken
            });
        });
        (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).FUN_MORGO_EGG);
    }, []);
    const onRestartAudio = ()=>{
        if (!audio.current) return;
        if (audio.current.paused) {
            audio.current.currentTime = 0;
            audio.current.play();
        } else audio.current.pause();
    };
    const fullImageUrls = $924f9703d02a910a$var$imageUrls.map((url)=>`${$924f9703d02a910a$var$imageBase}${url}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($924f9703d02a910a$var$Box, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h1", {
        className: "egg",
        onClick: onRestartAudio
    }, "\uD83E\uDD9A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h1", {
        className: "title"
    }, "Morgo Baby"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "Cuddle ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("strong", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("em", null, "puzzle")), " touch love!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "Miss kiss AND kiss miss!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "Falling (", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("em", null, "for you"), ")."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "No matter? ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("em", null, "Literally what.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "Just you. Always just you."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "My favorite ever."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "I love endlessly."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("em", null, "Come sleep with me?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "Never let go."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "Never let go."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("audio", {
        autoPlay: true,
        ref: audio
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("source", {
        src: "https://dhcabdjaij1gf.cloudfront.net/running.mp3",
        type: "audio/mpeg"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $34bde8fd4594a025$export$2e2bcd8739ae039), {
        images: fullImageUrls
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), "Yours forever and always, Nick.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("br", null));
};
var $924f9703d02a910a$export$2e2bcd8739ae039 = $924f9703d02a910a$var$MorgoEgg;



var $gIfym = parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");

var $gIfym = parcelRequire("gIfym");
const $cec77e0393fc9523$var$UserNamesContext = /*#__PURE__*/ (0, $gIfym.createContext)();
const $cec77e0393fc9523$export$bf8018b7ef784ee5 = ()=>{
    return (0, $gIfym.useContext)($cec77e0393fc9523$var$UserNamesContext);
};
const $cec77e0393fc9523$export$6b4d911a3cc619be = ({ children: children })=>{
    const [userNames, setUserNames] = (0, $gIfym.useState)({});
    const setNickname = (userToken, nickname)=>{
        setUserNames((userNames)=>({
                ...userNames,
                [userToken]: nickname
            }));
    };
    const getNickname = (userToken)=>{
        return userNames[userToken] || userToken;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($cec77e0393fc9523$var$UserNamesContext.Provider, {
        value: {
            setNickname: setNickname,
            getNickname: getNickname
        }
    }, children);
};


const $38eddd5d8e1b664c$var$NameTag = ({ userToken: userToken, onUpdate: onUpdate, nickname: nickname = "", ...props })=>{
    const { setNickname: setNickname, getNickname: getNickname } = (0, $cec77e0393fc9523$export$bf8018b7ef784ee5)();
    const cachedNickname = getNickname(userToken);
    const onClick = ()=>{
        const newNickname = prompt("Enter new nickname", nickname || "");
        if (!newNickname) return;
        setNickname(userToken, newNickname);
        onUpdate(userToken, newNickname);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", {
        onClick: onClick,
        ...props
    }, nickname || cachedNickname);
};
var $38eddd5d8e1b664c$export$2e2bcd8739ae039 = $38eddd5d8e1b664c$var$NameTag;


const $f90fb9adfa79a1b4$var$SOCKET_URL = (0, window.location.origin);
const $f90fb9adfa79a1b4$var$Admin = ()=>{
    const socket = (0, $gIfym.useRef)();
    const [users, setUsers] = (0, $gIfym.useState)({});
    const [games, setGames] = (0, $gIfym.useState)({});
    const [events, setEvents] = (0, $gIfym.useState)([]);
    const [gamePlays, setGamePlays] = (0, $gIfym.useState)({});
    const onUpdateName = async (userToken, nickname)=>{
        if (!socket.current) {
            alert("no socket");
            return;
        }
        setUsers((users)=>({
                ...users,
                [userToken]: {
                    ...users[userToken],
                    nickname: nickname
                }
            }));
        await socket.current.emit("update_nickname", {
            userToken: userToken,
            nickname: nickname
        });
    };
    (0, $gIfym.useEffect)(()=>{
        if (!window.io) return;
        socket.current = window.io($f90fb9adfa79a1b4$var$SOCKET_URL);
        const adminKey = localStorage.getItem("adminKey");
        socket.current.emit("admin_login", {
            adminKey: adminKey
        });
        setUsers({});
        setGames({});
        setEvents([]);
        setGamePlays({});
        socket.current.on("init", ({ events: events, activity: activity, gamePlays: gamePlays, users: dbUsers, games: dbGames })=>{
            console.log({
                events: events,
                activity: activity,
                gamePlays: gamePlays,
                users: dbUsers,
                games: dbGames
            });
            setEvents(events);
            dbUsers.forEach((dbUser)=>{
                setUsers((users)=>({
                        ...users,
                        [dbUser.user_token]: {
                            ...users[dbUser.user_token] || {},
                            ts: new Date(dbUser.last_active_at).getTime(),
                            nickname: dbUser.nickname
                        }
                    }));
            });
            dbGames.forEach((dbGame)=>{
                setGames((games)=>({
                        ...games,
                        [dbGame.short_id]: {
                            users: [],
                            ...games[dbGame.short_id] || {},
                            ts: new Date(dbGame.updated_at).getTime()
                        }
                    }));
                (dbGame.users || []).forEach(({ userToken: userToken, plays: plays })=>{
                    setGames((games)=>({
                            ...games,
                            [dbGame.short_id]: {
                                ...games[dbGame.short_id],
                                users: Array.from(new Set([
                                    ...games[dbGame.short_id].users || [],
                                    userToken
                                ]))
                            }
                        }));
                    setGamePlays((gamePlays)=>({
                            ...gamePlays,
                            [dbGame.short_id]: {
                                ...gamePlays[dbGame.short_id],
                                [userToken]: plays
                            }
                        }));
                });
            });
            gamePlays.forEach(({ userId: userId, gameId: gameId, plays: plays })=>{
                setGamePlays((gamePlays)=>({
                        ...gamePlays,
                        [gameId]: {
                            ...gamePlays[gameId],
                            [userId]: (gamePlays[gameId]?.[userId] || 0) + plays
                        }
                    }));
            });
            const gameLives = {};
            activity.forEach(({ gameId: gameId, left: left })=>{
                gameLives[gameId] = gameLives[gameId] || !left;
            });
            activity.forEach(({ userId: userId, gameId: gameId, ts: ts, left: left })=>{
                setUsers((users)=>({
                        ...users,
                        [userId]: {
                            ...users[userId] || {},
                            gameId: gameId,
                            ts: ts,
                            left: left
                        }
                    }));
                setGames((games)=>({
                        ...games,
                        [gameId]: {
                            users: Array.from(new Set([
                                ...games[gameId]?.users || [],
                                userId
                            ])),
                            live: gameLives[gameId],
                            ts: ts
                        }
                    }));
            });
        });
        socket.current.on("update", (message)=>{
            if (message.type === "user_activity") {
                const { userId: userId, gameId: gameId, ts: ts } = message;
                setUsers((users)=>({
                        ...users,
                        [userId]: {
                            ...users[userId] || {},
                            gameId: gameId,
                            ts: ts,
                            left: null
                        }
                    }));
                setGames((games)=>({
                        ...games,
                        [gameId]: {
                            users: Array.from(new Set([
                                ...games[gameId]?.users || [],
                                userId
                            ])),
                            live: true,
                            ts: ts
                        }
                    }));
            } else if (message.type === "gameplay") {
                const { userId: userId, gameId: gameId } = message;
                setGamePlays((gamePlays)=>({
                        ...gamePlays,
                        [gameId]: {
                            ...gamePlays[gameId],
                            [userId]: (gamePlays[gameId]?.[userId] || 0) + 1
                        }
                    }));
            } else if (message.type === "user_removed") {
                const { userId: userId } = message;
                setUsers((users)=>({
                        ...users,
                        [userId]: {
                            ...users[userId],
                            left: Date.now()
                        }
                    }));
            } else if (message.type === "event") {
                const { idType: idType, id: id, event: event, ts: ts } = message;
                setEvents((events)=>{
                    const newEvents = [
                        ...events
                    ];
                    newEvents.unshift({
                        idType: idType,
                        id: id,
                        event: event,
                        ts: ts
                    });
                    return newEvents;
                });
                // hack for end game
                if (idType === "game" && event === "ended") setGames((games)=>({
                        ...games,
                        [id]: {
                            ...games[id],
                            live: false
                        }
                    }));
            }
        });
        return ()=>{
            socket.current.disconnect();
        };
    }, [
        window.io
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "flex w-full min-h-screen p-4",
        style: {
            boxSizing: "border-box"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h1", {
        className: "text-3xl font-bold text-center mb-4"
    }, "Admin"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "flex gap-4 pb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "w-1/4 px-4 rounded-lg",
        style: {
            border: "1px solid black"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", {
        className: "text-xl font-semibold mb-4 border-b pb-2"
    }, "Recent Users"), Object.entries(users).sort((a, b)=>b[1].ts - a[1].ts).map(([userId, { gameId: gameId, ts: ts, left: left, nickname: nickname }])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            key: userId,
            className: "mb-4 p-2 bg-gray-100 rounded-lg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "font-medium text-gray-800"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $38eddd5d8e1b664c$export$2e2bcd8739ae039), {
            nickname: nickname,
            userToken: userId,
            onUpdate: onUpdateName
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "text-sm text-gray-500"
        }, "Status: ", left || !gameId ? "Offline" : "Online"), gameId && !left && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "text-sm text-gray-500"
        }, "Game ID: ", gameId), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "text-sm text-gray-500"
        }, "Last Active: ", new Date(ts).toLocaleString())))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "w-1/2 px-4 rounded-lg",
        style: {
            border: "1px solid black"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", {
        className: "text-xl font-semibold mb-4 border-b pb-2"
    }, "Recent Games"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("table", {
        className: "w-full text-left border-collapse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tr", {
        className: "border-b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", {
        className: "py-2 px-3 font-medium "
    }, "Online"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", {
        className: "py-2 px-3 font-medium "
    }, "Game ID"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("th", {
        className: "py-2 px-3 font-medium"
    }, "Last Activity"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tbody", null, Object.entries(games).sort((a, b)=>b[1].ts - a[1].ts).map(([gameId, { users: gameUsers, ts: ts, live: live }])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, {
            key: gameId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tr", {
            className: "hover:bg-gray-50"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", {
            className: "py-2 px-3"
        }, live ? "Yes" : "No"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", {
            className: "py-2 px-3"
        }, gameId), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", {
            className: "py-2 px-3"
        }, new Date(ts).toLocaleString())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("td", {
            colSpan: "3",
            className: "py-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "ml-6"
        }, gameUsers.map((userId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
                key: `game-users-${userId}`,
                className: "text-sm text-gray-600"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $38eddd5d8e1b664c$export$2e2bcd8739ae039), {
                nickname: users[userId]?.nickname,
                userToken: userId,
                className: "text-sm",
                onUpdate: onUpdateName
            }), ":\xa0", gamePlays[gameId]?.[userId] || 0, " plays")))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
        className: "w-1/4 px-4 rounded-lg",
        style: {
            border: "1px solid black"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", {
        className: "text-xl font-semibold mb-4 border-b pb-2"
    }, "Event Log"), events.map(({ idType: idType, id: id, event: event, ts: ts }, index)=>{
        let title;
        if (idType === "user" && event == "joined game") title = "User joined game";
        else if (idType === "game" && event == "started") title = "Game started";
        else if (idType === "game" && event == "ended") title = "Game ended";
        else if (idType === "user" && event == "left game") title = "User left game";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            key: index,
            className: "mb-4 p-2 bg-gray-100 rounded-lg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "font-medium text-gray-800 mb-2"
        }, title || event), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "text-sm text-gray-500 mb-1"
        }, idType === "user" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $38eddd5d8e1b664c$export$2e2bcd8739ae039), {
            userToken: id,
            nickname: users[id]?.nickname,
            onUpdate: onUpdateName,
            className: "text-sm"
        }) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("span", null, id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("div", {
            className: "text-sm text-gray-500"
        }, new Date(ts).toLocaleString()));
    })))));
};
var $f90fb9adfa79a1b4$export$2e2bcd8739ae039 = $f90fb9adfa79a1b4$var$Admin;



var $gIfym = parcelRequire("gIfym");

const $4fbda79babf2c9eb$var$Page = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  min-height: 100%;
  box-sizing: border-box;
  padding: 48px 24px;
  display: flex;
  justify-content: center;
`;
const $4fbda79babf2c9eb$var$Card = (0, $cc85e8b8e7405a89$export$2e2bcd8739ae039).div`
  width: 100%;
  max-width: 900px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 32px;
  line-height: 1.55;
  overflow: scroll;

  h1 {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 2rem;
  }

  h2 {
    margin-top: 28px;
    margin-bottom: 12px;
    font-size: 1.2rem;
  }

  h3 {
    margin-top: 18px;
    margin-bottom: 8px;
    font-size: 1rem;
  }

  p {
    margin: 0 0 14px;
  }

  ul {
    margin-top: 0;
    margin-bottom: 14px;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
  }

  @media only screen and (max-width: 700px) {
    padding: 24px;
  }
`;
const $4fbda79babf2c9eb$var$Privacy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4fbda79babf2c9eb$var$Page, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement($4fbda79babf2c9eb$var$Card, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h1", null, "Privacy Policy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("strong", null, "Last updated:"), " February 2026"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "This Privacy Policy describes how WordGrid (\u201CWordGrid,\u201D \u201Cwe,\u201D \u201Cus,\u201D or \u201Cour\u201D) collects, uses, and discloses information when you use the WordGrid mobile application (the \u201CApp\u201D)."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "By using the App, you agree to the collection and use of information in accordance with this Privacy Policy."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "1. Information We Collect"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h3", null, "Personal Information"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "WordGrid does not require user accounts and does not intentionally collect personal information such as names, email addresses, phone numbers, or payment details."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h3", null, "Usage Data"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "We collect limited, non-personal usage data through PostHog, a third-party analytics provider. This may include:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("li", null, "Device type, operating system, and app version"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("li", null, "Anonymous identifiers"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("li", null, "App interactions (e.g., puzzle activity, button taps)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("li", null, "General usage metrics and performance data")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "This information is used solely to monitor performance, improve functionality, and enhance user experience."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "We do not sell personal information."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "2. Multiplayer & Game Data"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "To enable real-time multiplayer features and puzzle persistence, gameplay data (such as board state and puzzle progress) may be temporarily stored on our servers."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "This data is not associated with personal identity."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "3. Third-Party Services"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "We use PostHog for analytics. PostHog may process data in accordance with its own privacy policy. We encourage you to review PostHog\u2019s privacy practices for additional information."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "4. Data Retention"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "We retain usage and gameplay data only for as long as reasonably necessary to operate and improve the App."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "5. Children\u2019s Privacy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "The App is not directed to children under the age of 13. We do not knowingly collect personal information from children under 13."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "If we become aware that personal information from a child under 13 has been collected, we will take steps to delete such information."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "6. Data Security"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "We implement reasonable administrative and technical safeguards to protect information collected through the App. However, no method of transmission over the internet or electronic storage is completely secure."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "7. Changes to This Privacy Policy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "We may update this Privacy Policy from time to time. Any changes will be reflected by updating the \u201CLast updated\u201D date above. Continued use of the App after changes constitutes acceptance of the updated policy."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("h2", null, "8. Contact"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, "If you have any questions about this Privacy Policy, you may contact us at:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement("a", {
        href: "mailto:feedback@wordgrid.io"
    }, "feedback@wordgrid.io"))));
};
var $4fbda79babf2c9eb$export$2e2bcd8739ae039 = $4fbda79babf2c9eb$var$Privacy;



class $1e660b916d30a31c$export$86fbec116b87613f extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $cec77e0393fc9523$export$6b4d911a3cc619be), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $5a45d2e41d002d73$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $2cd531af13324c98$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            exact: true,
            path: "/",
            component: (0, $e8b70f167a9a3bef$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/game/new",
            component: (0, $6e75660a5e42b669$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/game/continue",
            component: (0, $56acd30ccb2489dc$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/game/\uD83E\uDD9A",
            component: (0, $924f9703d02a910a$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/game/morgobaby",
            component: (0, $924f9703d02a910a$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/game/:gameId",
            component: (0, $7764b776fbd01fc1$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/upload",
            component: (0, $db31371ddb62172a$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/settings",
            component: (0, $12e7be8c0b2fea41$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/feedback",
            component: (0, $3a047136a5414232$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/privacy",
            component: (0, $4fbda79babf2c9eb$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            path: "/admin",
            component: (0, $f90fb9adfa79a1b4$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $4d8a4f59b4c9f185$export$2e2bcd8739ae039), {
            component: (0, $70e2c0163f8d3e05$export$2e2bcd8739ae039)
        }))));
    }
}
var $1e660b916d30a31c$export$2e2bcd8739ae039 = $1e660b916d30a31c$export$86fbec116b87613f;




var $db0120b4dfd1ac63$exports = {};
$db0120b4dfd1ac63$exports = new URL("service-worker.js", import.meta.url).toString();


// if ('serviceWorker' in navigator) {
//     const s = navigator.serviceWorker
//     const url = new URL('../service-worker.js', import.meta.url)
//     s.register(url)
// }
if ("serviceWorker" in navigator) navigator.serviceWorker.register($db0120b4dfd1ac63$exports, {
    scope: "/"
});
if (window.location.protocol === "https:") $ca8c28182539f605$export$2cd8252107eb640b({
    dsn: "https://9334b3962c7e3140050a943c6ab52c93@o4508247366107136.ingest.us.sentry.io/4508247367221248",
    integrations: [
        $02a23b0f4e66f6c2$export$b4109253475213e9(),
        $d2e2031c7edc550c$export$d7706faf7ab354bf()
    ],
    // Tracing
    tracesSampleRate: 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/wordgrid\.io/
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
});
let $b7ac0cf7b7632c81$var$userToken = localStorage.getItem("userToken");
if (!$b7ac0cf7b7632c81$var$userToken) {
    $b7ac0cf7b7632c81$var$userToken = (0, $1813fa57023b067c$export$2e2bcd8739ae039)();
    localStorage.setItem("userToken", $b7ac0cf7b7632c81$var$userToken);
}
let $b7ac0cf7b7632c81$var$nickname = null;
try {
    const rawSettings = localStorage.getItem("settings");
    if (rawSettings) {
        const parsed = JSON.parse(rawSettings);
        if (typeof parsed?.nickname === "string" && parsed.nickname.trim()) $b7ac0cf7b7632c81$var$nickname = parsed.nickname.trim();
    }
} catch  {
// Ignore malformed settings payloads.
}
(0, $a73b638dd7d927c0$export$f2a39aaa42ea357a)({
    userToken: $b7ac0cf7b7632c81$var$userToken,
    appVersion: null,
    nickname: $b7ac0cf7b7632c81$var$nickname
});
const $b7ac0cf7b7632c81$var$API_BASE = (0, window.location.origin);
const $b7ac0cf7b7632c81$var$APP_OPEN_TIMEOUT_MS = 1200;
const $b7ac0cf7b7632c81$var$waitForProfileNickname = async ()=>{
    const profileRequest = fetch(`${$b7ac0cf7b7632c81$var$API_BASE}/users/profile?userToken=${encodeURIComponent($b7ac0cf7b7632c81$var$userToken)}`).then(async (response)=>response.ok ? response.json() : null).then((profile)=>{
        const serverNickname = typeof profile?.nickname === "string" ? profile.nickname.trim() : "";
        if (!serverNickname) return;
        (0, $a73b638dd7d927c0$export$a612d3804dec9d26)(serverNickname);
    }).catch(()=>{});
    const timeout = new Promise((resolve)=>{
        window.setTimeout(resolve, $b7ac0cf7b7632c81$var$APP_OPEN_TIMEOUT_MS);
    });
    await Promise.race([
        profileRequest,
        timeout
    ]);
};
$b7ac0cf7b7632c81$var$waitForProfileNickname().finally(()=>{
    (0, $a73b638dd7d927c0$export$73d0a139caca1fee)((0, $a18db346086c295a$export$12ba4a87a63f35f7).APP_OPENED);
});
const $b7ac0cf7b7632c81$var$container = document.getElementById("app");
(0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createElement((0, $1e660b916d30a31c$export$2e2bcd8739ae039), null), $b7ac0cf7b7632c81$var$container);


//# sourceMappingURL=index.83638fc8.js.map
